(function() {
    'use strict';

    angular
        .module('triangular.layouts', [

        ]);
})();
'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @module triAngular
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .controller('TriangularStateController', TriangularStateController);

    /* @ngInject */
    function TriangularStateController($scope, $state, $log, $rootScope, $firebaseArray, $timeout, pageDimensionsService, $templateRequest, $compile, $element, $window, triLayout, triLoaderService) {
        var loadingQueue = [];
        var vm = this;

        vm.activateHover = activateHover;
        vm.removeHover  = removeHover;
        vm.showLoader = triLoaderService.isActive();

        // we need to use the scope here because otherwise the expression in md-is-locked-open doesnt work
        $scope.layout = triLayout.layout; //eslint-disable-line


        ////////////////

        function activateHover() {
            if(triLayout.layout.sideMenuSize === 'icon') {

                // Added for Adminja - delay in triggering left side
                $timeout(function(){
                    $element.find('.triangular-sidenav-left').addClass('hover');
                }, 100);

                $timeout(function(){
                    $window.dispatchEvent(new Event('resize'));
                }, 300);
            }
        }

        function injectFooterUpdateContent(viewName) {
            var contentView = $element.find('.triangular-content');
            if (viewName === '@triangular' && angular.isDefined(triLayout.layout.footerTemplateUrl)) {
                // add footer to the content view
                $templateRequest(triLayout.layout.footerTemplateUrl)
                .then(function(template) {
                    // compile template with current scope and add to the content
                    var linkFn = $compile(template);
                    var content = linkFn($scope);
                    $timeout(function() {
                        contentView.append(content);
                    });
                });
            }
        }

        function loaderEvent(event, isActive) {
            // $log.info('loaderEvent!');
            vm.showLoader = isActive;
        }

        function stateChangeStart() {
            // state has changed so start the loader

            // We don't want a loader message every time.
            //So we double the range and only show a message if our random generator picks a number in the bottom half.
            var randomNumber = Math.floor(Math.random()* ($rootScope.loaderMessages.length));
            if(randomNumber > $rootScope.loaderMessages.length){
                $rootScope.loaderMessage = ""
            } else {
                var selectedMessage =  $rootScope.loaderMessages[randomNumber];
                $rootScope.loaderMessage = selectedMessage;
            }

            triLoaderService.setLoaderActive(true);
        }

        function removeHover () {
            if(triLayout.layout.sideMenuSize === 'icon') {
                // Added for Adminja - delay in triggering left side
                $timeout(function(){
                    $element.find('.triangular-sidenav-left').removeClass('hover');
                },500);


                $timeout(function(){
                    $window.dispatchEvent(new Event('resize'));
                }, 0);
            }
        }

        function viewContentLoading($event, viewName) {
            // a view is loading so add it to the queue
            // so we know when to turn off the loader
            loadingQueue.push(viewName);
        }

        function viewContentLoaded($event, viewName) {
            if(angular.isDefined(triLayout.layout.footer) && triLayout.layout.footer === true) {
                // inject footer into content
                injectFooterUpdateContent(viewName);
            }

            // Customized for Adminja
            var originalQueueLength = loadingQueue.length;
            // $log.info(originalQueueLength);
            // view content has loaded so remove it from queue
            var index = loadingQueue.indexOf(viewName);
            if(-1 !== index) {
                loadingQueue.splice(index, 1);
            }
            // is the loadingQueue empty?
            if(loadingQueue.length === 0) {
                // nothing left to load so turn off the loader
                // triLoaderService.setLoaderActive(false);

                // If the loader had a message. Make sure it stays up a bit
                if($rootScope.loadingMessage != ""){
                    if ($state.is('triangular.dashboard') ||
                        $state.is('triangular.tasks-page') ||
                        $state.is('triangular.today')
                        ) {
                        $timeout(function(){
                            triLoaderService.setLoaderActive(false);
                        }, 1500);
                    // else, Normal deactivation of loader is A-OK
                    } else {
                        $timeout(function(){
                            triLoaderService.setLoaderActive(false);
                        }, 500);
                    }
                // If we are on a page KNOWN to take a bit longer to paint
                } else  {
                    triLoaderService.setLoaderActive(false);
                }




            }// if loadingQueue == 0
        }



        // watches

        // register listeners for loader
        $scope.$on('loader', loaderEvent);

        // watch for ui router state change
        $scope.$on('$stateChangeStart', stateChangeStart);

        // watch for view content loading
        $scope.$on('$viewContentLoading', viewContentLoading);

        // watch for view content loaded
        $scope.$on('$viewContentLoaded', viewContentLoaded);



    }
})();

'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @module triAngular
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .controller('DefaultLayoutController', DefaultLayoutController);

    /* @ngInject */
    function DefaultLayoutController($scope, $element, $timeout, $window, triLayout) {
        // we need to use the scope here because otherwise the expression in md-is-locked-open doesnt work
        $scope.layout = triLayout.layout; //eslint-disable-line
        var vm = this;

        vm.activateHover = activateHover;
        vm.removeHover  = removeHover;

        ////////////////

        function activateHover() {
            if(triLayout.layout.sideMenuSize === 'icon') {
                $element.find('.admin-sidebar-left').addClass('hover');
                // $timeout(function(){
                //     $window.dispatchEvent(new Event('resize'));
                // },300);
            }
        }

        function removeHover () {
            if(triLayout.layout.sideMenuSize === 'icon') {
                $element.find('.admin-sidebar-left').removeClass('hover');
                // $timeout(function(){
                //     $window.dispatchEvent(new Event('resize'));
                // },300);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .directive('triDefaultContent', triDefaultContent);

    /* @ngInject */
    function triDefaultContent ($rootScope, $compile, $templateRequest, triLayout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            replace: true,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element) {
            // scroll page to the top when content is loaded (stops pages keeping scroll position even when they have changed url)
            $scope.$on('$stateChangeStart', scrollToTop);

            // when content view has loaded add footer if needed and send mdContentLoaded event
            $scope.$on('$viewContentLoaded', injectFooterUpdateContent);

            ////////////////////////

            function scrollToTop() {
                $element.scrollTop(0);
            }

            function injectFooterUpdateContent() {
                var contentView = $element.find('#admin-panel-content-view');
                var footerElem = contentView.find('#footer');
                if (footerElem.length === 0) {
                    // add footer to the content view
                    $templateRequest(triLayout.layout.footerTemplateUrl)
                    .then(function(template) {
                        // compile template with current scope and add to the content
                        var linkFn = $compile(template);
                        var content = linkFn($scope);
                        contentView.append(content);
                    });

                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components', [
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWizard', TriWizard);

    /* @ngInject */
    function TriWizard() {
        // Usage: <div tri-wizard> (put some forms in here) </div>
        //
        // Creates: Nothing
        //
        var directive = {
            bindToController: true,
            controller: WizardController,
            controllerAs: 'triWizard',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function WizardController($scope, $timeout, $log, $mdToast) {
        var vm = this;

        var forms = [];
        var totalErrors = 0;
        var fixedErrors = 0;

        vm.currentStep = 0;
        vm.getForm = getForm;
        vm.isFormValid = isFormValid;
        vm.nextStep = nextStep;
        vm.nextStepDisabled = nextStepDisabled;
        vm.prevStep = prevStep;
        vm.prevStepDisabled = prevStepDisabled;
        vm.progress = 0;
        vm.registerForm = registerForm;
        vm.updateProgress = updateProgress;
        vm.registerUser = registerUser;
        vm.saveUserProfile = saveUserProfile;
        vm.registrationError = undefined;
        vm.showError = false;

        //////////////// Customized for Adminja ////////////////

        function getForm(index) {
            return forms[index];
        }

        function nextStep() {
            // $log.info('nextStep');
            vm.currentStep = vm.currentStep + 1;
        }

        function registerUser(user){
            // $log.info('register clicked');

            // do registration


            firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(_userData, error) {
                // console.log("User " + _userData.uid + " created successfully", _userData);

                // get set to store our own userData
                var usersRef = firebase.database().ref('users');

                user.uid = _userData.uid;

                var newUserRecord = {
                    email: user.email,
                    uid: _userData.uid
                }

                newUserRecord.profile = {};
                newUserRecord.profile.avatar = "";
                newUserRecord.profile.firstName = "";
                newUserRecord.profile.lastName = "";

                // save our basic users record
                usersRef.child(_userData.uid).set(newUserRecord);


            }).then(function(authData) {
                $mdToast.showSimple('New Account Created.');

                // proceed to next pane of wizard
                nextStep();

                // return firebase.auth().signInWithEmailAndPassword(vm.user.email, vm.user.password);
                // console.log("Logged in as: ", authData.uid);
                // $state.go('triangular.account-page.profile');

            }).catch(function(error) {
                // console.log("Error: ", error);
                // vm.errorMessage = error.message;
                // vm.showError = true;
                $mdToast.show(
                      $mdToast.simple()
                        .textContent(error.message)
                        .position('top center')
                        .hideDelay(3000)
                    );
                user.email = "";
                user.password = "";
                user.passwordConfirm = "";
            });


    }

        function saveUserProfile(user){
            // $log.info('saveUserProfile');
            var newUser = angular.copy(user);

            if (newUser.profile.dob){
                newUser.profile.dob = newUser.profile.dob.toISOString();
            }

            var usersRef = firebase.database().ref('users');

            // save our user profile
            usersRef.child(newUser.uid + '/profile').set(newUser.profile);
            $mdToast.showSimple('User Profile Updated');

            // proceed to next pane of wizard
            nextStep();


        }

        function nextStepDisabled() {
            // get current active form
            var form = $scope.triWizard.getForm(vm.currentStep);
            var formInvalid = true;
            if(angular.isDefined(form) && angular.isDefined(form.$invalid)) {
                formInvalid = form.$invalid;
            }
            return formInvalid;
        }

        function isFormValid(step) {
            if(angular.isDefined(forms[step])) {
                return forms[step].$valid;
            }
        }

        function prevStep() {
            vm.currentStep = vm.currentStep - 1;
        }

        function prevStepDisabled() {
            return vm.currentStep === 0;
        }

        function registerForm(form) {
            forms.push(form);
        }

        function updateProgress() {
            var errors = calculateErrors();
            fixedErrors = totalErrors - errors;

            // calculate percentage process for completing the wizard
            vm.progress = Math.floor((fixedErrors / totalErrors) * 100);
        }

        function calculateErrors() {
            var errorCount = 0;
            for (var form = forms.length - 1; form >= 0; form--) {
                if(angular.isDefined(forms[form].$error)) {
                    for(var error in forms[form].$error) {
                        errorCount += forms[form].$error[error].length;
                    }
                }
            }
            return errorCount;
        }


        // init

        // wait until this tri wizard is ready (all forms registered)
        // then calculate the total errors
        $timeout(function() {
            totalErrors = calculateErrors();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWizardForm', WizardFormProgress);

    /* @ngInject */
    function WizardFormProgress() {
        // Usage:
        //  <div tri-wizard>
        //      <form tri-wizard-form>
        //      </form>
        //  </div>
        //
        var directive = {
            require: ['form', '^triWizard'],
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, require) {
            var ngFormCtrl = require[0];
            var triWizardCtrl = require[1];

            // register this form with the parent triWizard directive
            triWizardCtrl.registerForm(ngFormCtrl);

            // watch for form input changes and update the wizard progress
            element.on('input', function() {
                triWizardCtrl.updateProgress();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triTable', triTable);

    /* @ngInject */
    function triTable($filter) {
        var directive = {
            restrict: 'E',
            scope: {
                columns: '=',
                contents: '=',
                filters: '='
            },
            link: link,
            templateUrl: 'app/triangular/components/table/table-directive.tmpl.html'
        };
        return directive;

        function link($scope, $element, attrs) {
            var sortableColumns = [];
            var activeSortColumn = null;
            var activeSortOrder = false;

            // init page size if not set to default
            $scope.pageSize = angular.isUndefined(attrs.pageSize) ? 0 : attrs.pageSize;

            // init page if not set to default
            $scope.page = angular.isUndefined(attrs.page) ? 0 : attrs.page;

            // make an array of all sortable columns
            angular.forEach($scope.columns, function(column) {
                if(column.sortable) {
                    sortableColumns.push(column.field);
                }
            });

            $scope.refresh = function(resetPage) {
                if(resetPage === true) {
                    $scope.page = 0;
                }
                $scope.contents = $filter('orderBy')($scope.contents, activeSortColumn, activeSortOrder);
            };

            // if we have sortable columns sort by first by default
            if(sortableColumns.length > 0) {
                // sort first column by default
                activeSortOrder = false;
                activeSortColumn = sortableColumns[0];
                $scope.refresh();
            }

            $scope.sortClick = function(field) {
                if(sortableColumns.indexOf(field) !== -1) {
                    if(field === activeSortColumn) {
                        activeSortOrder = !activeSortOrder;
                    }
                    activeSortColumn = field;
                    $scope.refresh();
                }
            };

            $scope.showSortOrder = function(field, orderDown) {
                return field === activeSortColumn && activeSortOrder === orderDown;
            };

            $scope.headerClass = function(field) {
                var classes = [];
                if(sortableColumns.indexOf(field) !== -1) {
                    classes.push('sortable');
                }
                if(field === activeSortColumn) {
                    classes.push('sorted');
                }
                return classes;
            };

            $scope.cellContents = function(column, content) {
                if(angular.isDefined(column.filter)) {
                    return $filter(column.filter)(content[column.field]);
                }
                else {
                    return content[column.field];
                }
            };

            $scope.totalItems = function() {
                return $scope.contents.length;
            };

            $scope.numberOfPages = function() {
                return Math.ceil($scope.contents.length / $scope.pageSize);
            };

            $scope.pageStart = function() {
                return ($scope.page * $scope.pageSize) + 1;
            };

            $scope.pageEnd = function() {
                var end = (($scope.page + 1) * $scope.pageSize);
                if(end > $scope.contents.length) {
                    end = $scope.contents.length;
                }
                return end;
            };

            $scope.goToPage = function (page) {
                $scope.page = page;
            };
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .filter('startFrom', startFrom);

    function startFrom() {
        return filterFilter;

        ////////////////

        function filterFilter(input, start) {
            start = +start;
            return input.slice(start);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .filter('tableImage', tableImage);

    function tableImage($sce) {
        return filterFilter;

        ////////////////

        function filterFilter(value) {
            return $sce.trustAsHtml('<div style=\"background-image: url(\'' + value + '\')\"/>');
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWidget', widget);

    /* @ngInject */
    function widget ($mdTheming) {
        // Usage:
        //
        // ```html
        // <widget title="'Nice Title'" subtitle="'Subtitle'" avatar="http://myavatar.jpg" title-position="top|bottom|left|right" content-padding overlay-title>content here</widget>
        // ```

        // Creates:
        //
        // Widget for use in dashboards
        var directive = {
            restrict: 'E',
            templateUrl: 'app/triangular/components/widget/widget.tmpl.html',
            transclude: true,
            replace: true,
            scope: {
                title: '@',
                subtitle: '@',
                avatar: '@'
            },
            bindToController: true,
            controller: Controller,
            controllerAs: 'vm',
            link: link
        };
        return directive;

        function link($scope, $element, attrs) {
            // set the value of the widget layout attribute
            $scope.vm.widgetLayout = attrs.titlePosition === 'left' || attrs.titlePosition === 'right' ? 'row' : 'column';
            // set the layout attribute for the widget content
            $scope.vm.contentLayout = angular.isUndefined(attrs.contentLayout) ? 'column' : attrs.contentLayout;
            // set if the layout-padding attribute will be added
            $scope.vm.contentPadding = angular.isDefined(attrs.contentPadding);
            // set the content align
            $scope.vm.contentLayoutAlign = angular.isUndefined(attrs.contentLayoutAlign) ? '' : attrs.contentLayoutAlign;
            // set the order of the title and content based on title position
            $scope.vm.titleOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 2 : 1;
            $scope.vm.contentOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 1 : 2;
            // set if we overlay the title on top of the widget content
            $scope.vm.overlayTitle = angular.isUndefined(attrs.overlayTitle) ? undefined : true;

            $mdTheming($element);

            if(angular.isDefined(attrs.class)) {
                $element.addClass(attrs.class);
            }

            if(angular.isDefined(attrs.backgroundImage)) {
                $element.css('background-image', 'url(' + attrs.backgroundImage + ')');
            }

            $scope.menuClick = function($event) {
                if(angular.isUndefined($scope.menu.menuClick)) {
                    $scope.menu.menuClick($event);
                }
            };

            // remove title attribute to stop popup on hover
            $element.attr('title', '');
        }
    }

    /* @ngInject */
    function Controller () {
        var vm = this;
        vm.menu = null;
        vm.loading = false;

        this.setMenu = function(menu) {
            vm.menu = menu;
        };

        this.setLoading = function(loading) {
            vm.loading = loading;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('DefaultToolbarController', DefaultToolbarController);

    /* @ngInject */
    function DefaultToolbarController($scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout) {
        var vm = this;
        vm.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        vm.emailNew = false;
        vm.languages = triSettings.languages;
        vm.openSideNav = openSideNav;
        vm.hideMenuButton = hideMenuButton;
        vm.switchLanguage = switchLanguage;
        vm.toggleNotificationsTab = toggleNotificationsTab;
        vm.isFullScreen = false;
        vm.fullScreenIcon = 'zmdi zmdi-fullscreen';
        vm.toggleFullScreen = toggleFullScreen;

        // initToolbar();

        ////////////////

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            return triLayout.layout.sideMenuSize !== 'hidden' && $mdMedia('gt-sm');
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            vm.openSideNav('notifications');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }

        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .provider('triMenu', menuProvider);


    /* @ngInject */
    function menuProvider() {
        // Provider
        var menuArray = [];

        this.addMenu = addMenu;
        this.removeMenu = removeMenu;
        this.removeAllMenu = removeAllMenu;

        function addMenu(item) {
            menuArray.push(item);
        }

        function getMenu(id) {
            return findMenu(menuArray, id);
        }

        function removeMenu(state, params) {
            findAndDestroyMenu(menuArray, state, params);
        }

        function removeAllMenu() {
            for (var i = menuArray.length - 1; i >= 0 ; i--) {
                menuArray.splice(i, 1);
            }
        }

        function findMenu(menu, id) {
            var found;
            if (menu instanceof Array) {
                for (var i = 0; i < menu.length; i++) {
                    if(menu[i].id === id) {
                        found = menu[i];
                        break;
                    }
                    else if(angular.isDefined(menu[i].children)) {
                        found = findMenu(menu[i].children, id);
                        if(angular.isDefined(found)) {
                            break;
                        }
                    }
                }
            }
            return found;
        }

        function findAndDestroyMenu(menu, state, params, isChildren) {
            if (menu instanceof Array) {
                for (var i = menu.length - 1; i >= 0 ; i--) {
                    if(menu[i].state === state && angular.equals(menu[i].params, params)) {
                        menu.splice(i, 1);
                        if (!isNaN(isChildren) && !menuArray[isChildren].children.length) {
                            menuArray.splice(isChildren, 1);
                        }
                        break;
                    }
                    else if(angular.isDefined(menu[i].children)) {
                        findAndDestroyMenu(menu[i].children, state, params, i);
                    }
                }
            }
        }

        // Service
        this.$get = function() {
            return {
                menu: menuArray,
                addMenu: addMenu,
                getMenu: getMenu,
                removeMenu: removeMenu,
                removeAllMenu: removeAllMenu
            };
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triMenu', triMenuDirective);

    /* @ngInject */
    function triMenuDirective($location, $mdTheming, triTheming) {
        var directive = {
            restrict: 'E',
            template: '<md-content><tri-menu-item permission permission-only="item.permission" ng-repeat="item in triMenuController.menu | orderBy:\'priority\'" item="::item"></tri-menu-item></md-content>',
            scope: {},
            controller: triMenuController,
            controllerAs: 'triMenuController',
            link: link
        };
        return directive;

        function link($scope, $element) {
            $mdTheming($element);
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line

            var menuColor = triTheming.getThemeHue($mdTheme.$mdTheme, 'primary', 'default');
            var menuColorRGBA = triTheming.rgba(menuColor.value);
            $element.css({ 'background-color': menuColorRGBA });
            $element.children('md-content').css({ 'background-color': menuColorRGBA });
        }
    }

    /* @ngInject */
    function triMenuController(triMenu, $scope) {
        var triMenuController = this;
        // get the menu and order it
        triMenuController.menu = triMenu.menu;


    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triMenuItem', triMenuItemDirective);

    /* @ngInject */
    function triMenuItemDirective() {
        var directive = {
            restrict: 'E',
            require: '^triMenu',
            scope: {
                item: '='
            },
            // replace: true,
            template: '<div ng-include="::triMenuItem.item.template"></div>',
            controller: triMenuItemController,
            controllerAs: 'triMenuItem',
            bindToController: true
        };
        return directive;
    }

    /* @ngInject */
    function triMenuItemController($log, $scope, $injector, $mdSidenav, $state, $filter, $window, $location, triBreadcrumbsService, localStorageService, userDataService, clientDataService, timerDataService) {
        var triMenuItem = this;
        // load a template for this directive based on the type ( link | dropdown )
        triMenuItem.item.template = 'app/triangular/components/menu/menu-item-' + triMenuItem.item.type + '.tmpl.html';

        switch(triMenuItem.item.type) {
            case 'dropdown':
                // if we have kids reorder them by priority
                triMenuItem.item.children = $filter('orderBy')(triMenuItem.item.children, 'priority');
                triMenuItem.toggleDropdownMenu = toggleDropdownMenu;
                // add a check for open event
                $scope.$on('toggleDropdownMenu', function(event, item, open) {
                    // if this is the item we are looking for
                    if(triMenuItem.item === item) {
                        triMenuItem.item.open = open;
                    }
                    else {
                        triMenuItem.item.open = false;
                    }
                });
                // this event is emitted up the tree to open parent menus
                $scope.$on('openParents', function() {
                    // openParents event so open the parent item
                    triMenuItem.item.open = true;
                    // also add this to the breadcrumbs
                    triBreadcrumbsService.addCrumb(triMenuItem.item);
                });
                break;
            case 'link':
                triMenuItem.openLink = openLink;

                // on init check if this is current menu
                checkItemActive($state.current.name, $state.params);

                $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                    checkItemActive(toState.name, toParams);
                });
                break;

             // Added for Adminja!!!!
             case 'link-w-no-params':
                 triMenuItem.openLink = openLink;

                 // on init check if this is current menu
                 checkItemActive($state.current.name, $state.params);

                 $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                     checkItemActive(toState.name, toParams);
                 });
                 break;
             // Added for Adminja!!!!
            case 'client':
                 triMenuItem.openLink = openLink;

                 // on init check if this is current menu
                 triMenuItem.item.active = ($state.params.clientID == triMenuItem.item.clientid)

                 if (triMenuItem.item.active){
                     triBreadcrumbsService.reset();
                     triBreadcrumbsService.addCrumb(triMenuItem.item);
                 }

                 $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {

                     checkItemActive(triMenuItem.item);
                 });
                 break;

        }

        function checkItemActive() {
            // Customized for Adminja!!!!!
            // If we are checking against a client item, we need to look for the clientID
                if (triMenuItem.item.type == 'client'){
                    if ($state.params.clientID == triMenuItem.item.clientid){
                        triMenuItem.item.active = true;
                    } else {
                        triMenuItem.item.active = false;
                    }

                } else {
                    // first check if the state is the same
                    triMenuItem.item.active = $state.includes(triMenuItem.item.state, triMenuItem.item.params);
                }

            // if we are now the active item reset the breadcrumbs and open all parent dropdown items
            if(triMenuItem.item.active) {
                triBreadcrumbsService.reset();
                triBreadcrumbsService.addCrumb(triMenuItem.item);
                $scope.$emit('openParents');
            }
        }

        function toggleDropdownMenu() {
            $scope.$parent.$parent.$broadcast('toggleDropdownMenu', triMenuItem.item, !triMenuItem.item.open);
        }

        function openLink() {
            if (triMenuItem.item.type == 'client'){
                 var view = "clients/" + triMenuItem.item.clientid;
                 $location.path(view);

            } else if (triMenuItem.item.type == 'link-w-no-params'){
                 // this state should transition WITHOUT parent's clientID
                 // so we are removing it
                $state.go(triMenuItem.item.state, {clientID: undefined});
                triMenuItem.item.active = true;
            }

            else if(angular.isDefined(triMenuItem.item.click)) {
                $injector.invoke(triMenuItem.item.click);
            }

            else {
                var params = angular.isUndefined(triMenuItem.item.params) ? {} : triMenuItem.item.params;
                if(angular.isDefined(triMenuItem.item.openInNewTab) && triMenuItem.item.openInNewTab === true) {
                    var url = $state.href(triMenuItem.item.state, params);
                    $window.open(url, '_blank');
                }
                else {
                    $state.go(triMenuItem.item.state, params);
                }
            }
            triMenuItem.item.active = true;
            $mdSidenav('left').close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('NotificationsPanelController', NotificationsPanelController);

    /* @ngInject */
    function NotificationsPanelController($scope, $http, $mdSidenav, $state, API_CONFIG) {
        var vm = this;
        // sets the current active tab
        vm.close = close;
        vm.currentTab = 0;
        vm.notificationGroups = [{
            name: 'Twitter',
            notifications: [{
                title: 'Mention from oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Followed by Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Server',
            notifications: [{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            },{
                title: 'Slow Response Time',
                icon: 'zmdi zmdi-alert-triangle',
                iconColor: 'rgb(255, 152, 0)',
                date: moment().startOf('hour')
            },{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Sales',
            notifications: [{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Lambda WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Lambda WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            }]
        }];
        vm.openMail = openMail;
        vm.settingsGroups = [{
            name: 'Account Settings',
            settings: [{
                title: 'Show my location',
                icon: 'zmdi zmdi-pin',
                enabled: true
            },{
                title: 'Show my avatar',
                icon: 'zmdi zmdi-face',
                enabled: false
            },{
                title: 'Send me notifications',
                icon: 'zmdi zmdi-notifications-active',
                enabled: true
            }]
        },{
            name: 'Chat Settings',
            settings: [{
                title: 'Show my username',
                icon: 'zmdi zmdi-account',
                enabled: true
            },{
                title: 'Make my profile public',
                icon: 'zmdi zmdi-account-box',
                enabled: false
            },{
                title: 'Allow cloud backups',
                icon: 'zmdi zmdi-cloud-upload',
                enabled: true
            }]
        }];

        vm.statisticsGroups = [{
            name: 'User Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        },{
            name: 'Server Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        }];

        ////////////////

        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('triSwitchNotificationTab', function($event, tab) {
            vm.currentTab = tab;
        });

        // fetch some dummy emails from the API
        $http({
            method: 'GET',
            url: API_CONFIG.url + 'email/inbox'
        }).success(function(data) {
            vm.emails = data.slice(1,20);
        });

        function openMail() {
            $state.go('triangular-no-scroll.email.inbox');
            vm.close();
        }

        function close() {
            $mdSidenav('notifications').close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triLoader', TriLoader);

    /* @ngInject */
    function TriLoader () {
        var directive = {
            bindToController: true,
            controller: TriLoaderController,
            controllerAs: 'vm',
            templateUrl: 'app/layouts/loader/loader.tmpl.html',
            // adminja customized
            // template: '<div style="background-color: rgba(255,255,255,.8);" flex class="loader padding-100" ng-show="vm.isActive()" layout="column" layout-fill layout-align="center center"><h3 class="md-headline"></h3><md-progress-linear md-mode="indeterminate"></md-progress-linear></div>',
            restrict: 'E',
            replace: true
        };
        return directive;

        function link($scope) {
            var loadingListener = $rootScope.$on('$viewContentLoading', function() {
                $scope.vm.setLoaderActive(true);
            });

            var loadedListener = $rootScope.$on('$viewContentLoaded', function() {
                $scope.vm.setLoaderActive(false);
            });

            $scope.$on('$destroy', removeListeners);

            function removeListeners() {
                loadingListener();
                loadedListener();
            }
        }

    }

    /* @ngInject */
    function TriLoaderController ($rootScope, $log, triLoaderService, triSettings) {
        console.log('loaderDirective');
        var vm = this;
        vm.status = triLoaderService.status;
        vm.setLoaderActive = triLoaderService.setLoaderActive;
        vm.triSettings = triSettings;
        vm.isActive = triLoaderService.isActive;

        // console.log(loadingMessages);
    }

})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .factory('triLoaderService', LoaderService);

    /* @ngInject */
    function LoaderService($rootScope) {
        var active = false;

        return {
            isActive: isActive,
            setLoaderActive: setLoaderActive
        };

        ////////////////

        function isActive() {
            return active;
        }

        function setLoaderActive(setActive) {
            active = setActive;
            // active = true;
            $rootScope.$broadcast('loader', active);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('FooterController', FooterController);

    /* @ngInject */
    function FooterController(triSettings, triLayout) {
        var vm = this;
        vm.name = triSettings.name;
        vm.copyright = triSettings.copyright;
        vm.layout = triLayout.layout;
        vm.version = triSettings.version;
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .factory('triBreadcrumbsService', BreadcrumbsService);

    /* @ngInject */
    function BreadcrumbsService($rootScope) {
        var crumbs = [];

        return {
            breadcrumbs: {
                crumbs: crumbs
            },
            addCrumb: addCrumb,
            reset: reset
        };

        ////////////////

        function addCrumb(item) {
            this.breadcrumbs.crumbs.unshift(item);
            $rootScope.$emit('changeTitle');
        }

        function reset() {
            this.breadcrumbs.crumbs = [];
        }
    }
})();

"use strict";function ngClassOnMobileConfig(){}function ngClassOnMobile(a){function b(b,c,d){a.isAMobileDevice()&&setTimeout(function(){b.classToAdd&&(b.classesToAdd=b.classToAdd.split(", ").map(function(a){return a.trim()}),b.classesToAdd.forEach(function(a){c.addClass(a)})),b.classToRemove&&(b.classesToRemove=b.classToRemove.split(", ").map(function(a){return a.trim()}),b.classesToRemove.forEach(function(a){c.removeClass(a)})),b.removeCssInline&&c.removeAttr("style")},b.delayToApply||0)}var c={restrict:"A",link:b,scope:{classToAdd:"@",classToRemove:"@",delayToApply:"=",removeCssInline:"="}};return c}function deviceCheckService(a){var b=a.navigator.userAgent,c=a.navigator.vendor,d=a.opera,e=function(){var a=!1;return function(b){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(b)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(b.substr(0,4)))&&(a=!0)}(b||c||d),a};return{isAMobileDevice:e}}var ngClassOnMobileModule=angular.module("ngClassOnMobile",["ngAnimate"]);ngClassOnMobileModule.config(ngClassOnMobileConfig),angular.module("ngClassOnMobile",[]),angular.module("ngClassOnMobile").directive("ngClassOnMobile",ngClassOnMobile),ngClassOnMobile.$inject=["ngClassOnMobile.deviceCheckService"],angular.module("ngClassOnMobile").service("ngClassOnMobile.deviceCheckService",deviceCheckService),deviceCheckService.$inject=["$window"];
"use strict";!function(){angular.module("lk-color-chooser",[]).provider("lkColorSettings",function(){this.colors=[],this.$get=function(){return{colors:this.colors}},this.configure=function(o){var l;for(l in o)this[l]=o[l]}}).directive("lkColorChooser",["lkColorSettings","$timeout",function(o){return{restrict:"EA",template:'<ul class="lk-color-chooser"><lk-color ng-repeat="color in colors track by $index" color="color" ng-class="{\'selected\': selectedColor == color}"></lk-color></ul>',replace:!0,scope:{colors:"=?",selectedColor:"="},controller:["$scope","$timeout",function(o,l){this.setSelectedColor=function(r){l(function(){o.selectedColor=r})}}],link:function(l){l.colors||(l.colors=o.colors)}}}]).directive("lkColor",function(){return{restrict:"EA",require:"^lkColorChooser",template:'<li class="lk-color-chooser__color" ng-style="{\'background-color\': color }">&nbsp;</li>',replace:!0,scope:{color:"="},link:function(o,l,r,c){l.on("click",function(){c.setSelectedColor(o.color)})}}})}();
(function() {
    'use strict';

    angular
        .module('triangular.themes', [

        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.themes')
        .provider('triTheming', themingProvider);

    /* @ngInject */
    function themingProvider($mdThemingProvider) {
        var themes = {};

        return {
            theme: function(name) {
                if(angular.isDefined(themes[name])) {
                    return themes[name];
                }

                var theme = new Theme(name);

                themes[name] = theme;

                return themes[name];

            },
            $get: function() {
                return {
                    getTheme: function(themeName) {
                        return themes[themeName];
                    },
                    getThemeHue: function(themeName, intentName, hue) {
                        if(angular.isDefined($mdThemingProvider._THEMES[themeName]) && angular.isDefined($mdThemingProvider._THEMES[themeName].colors[intentName])) {
                            var palette = $mdThemingProvider._THEMES[themeName].colors[intentName];
                            if(angular.isDefined($mdThemingProvider._PALETTES[palette.name]) && angular.isDefined($mdThemingProvider._PALETTES[palette.name][palette.hues[hue]])) {
                                return $mdThemingProvider._PALETTES[palette.name][palette.hues[hue]];
                            }
                        }
                    },
                    getPalette: function(name) {
                        return $mdThemingProvider._PALETTES[name];
                    },
                    getPaletteColor: function(paletteName, hue) {
                        if(angular.isDefined($mdThemingProvider._PALETTES[paletteName]) && angular.isDefined($mdThemingProvider._PALETTES[paletteName][hue])) {
                            return $mdThemingProvider._PALETTES[paletteName][hue];
                        }
                    },
                    rgba: $mdThemingProvider._rgba,
                    palettes: $mdThemingProvider._PALETTES,
                    themes: $mdThemingProvider._THEMES,
                    parseRules: $mdThemingProvider._parseRules
                };
            }
        };
    }

    function Theme(name) {
        var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
        var self = this;
        self.name = name;
        self.colors = {};
        self.isDark = false;

        THEME_COLOR_TYPES.forEach(function(colorType) {
            self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
                self.colors[colorType] = {
                    name: paletteName,
                    hues: {}
                };
                if(angular.isDefined(hues)) {
                    self.colors[colorType].hues = hues;
                }
                return self;
            };
        });

        self.dark = function(isDark) {
            // default setting when dark() is called is true
            self.isDark = angular.isUndefined(isDark) ? true : isDark;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.themes')
        .provider('triSkins', skinsProvider)
        .run(addSkinToScope);

    /* @ngInject */
    function skinsProvider($mdThemingProvider, triThemingProvider) {
        var skins = {};
        var currentSkin = null;
        var useSkinCookie = false;

        return {
            skin: function(id, name) {
                if(angular.isDefined(skins[id])) {
                    return skins[id];
                }

                var skin = new Skin(id, name, $mdThemingProvider, triThemingProvider);

                skins[id] = skin;

                return skins[id];
            },
            setSkin: function(id) {
                if(angular.isUndefined(skins[id])) {
                    return;
                }

                // set skin to selected skin
                currentSkin = skins[id];

                // override the skin if cookie is enabled and has been set
                if(useSkinCookie) {
                    // we need to check cookies to see if skin has been saved so inject it
                    var $cookies;
                    angular.injector(['ngCookies']).invoke(['$cookies', function(cookies) {
                        $cookies = cookies;
                    }]);
                    // if we have a cookie set then override the currentSkin
                    var triangularSkin = $cookies.get('triangular-skin');
                    if(angular.isDefined(triangularSkin)) {
                        var cookieTheme = angular.fromJson(triangularSkin);
                        currentSkin = angular.isDefined(skins[cookieTheme.skin]) ? skins[cookieTheme.skin] : skins[0];
                    }
                }

                // make material load the themes needed for the skin
                currentSkin.loadThemes();

                return currentSkin;
            },
            useSkinCookie: function(skinCookie) {
                useSkinCookie = skinCookie;
            },
            $get: function() {
                return {
                    getCurrent: function() {
                        return currentSkin;
                    },
                    getSkins: function() {
                        return skins;
                    }
                };
            }
        };
    }

    /* @ngInject */
    function Skin(id, name, $mdThemingProvider, triThemingProvider) {
        // Added for Adminja: 'status' theme
        var THEMABLE_ELEMENTS = ['sidebar', 'logo', 'toolbar', 'content', 'status'];
        var self = this;
        self.id = id;
        self.name = name;
        self.elements = {};

        THEMABLE_ELEMENTS.forEach(function(element) {
            self[element + 'Theme'] = function setElementTheme(themeName) {
                self.elements[element] = themeName;
                return self;
            };
        });

        self.loadThemes = function() {
            // go through each element
            for (var element in self.elements) {
                // register theme with mdThemingProvider (will load css in the header)
                var theme = triThemingProvider.theme(self.elements[element]);

                $mdThemingProvider.theme(theme.name)
                .primaryPalette(theme.colors.primary.name, theme.colors.primary.hues)
                .accentPalette(theme.colors.accent.name, theme.colors.accent.hues)
                .warnPalette(theme.colors.warn.name, theme.colors.warn.hues)
                .dark(theme.isDark);

                if(angular.isDefined(theme.colors.background)) {
                    $mdThemingProvider
                    .theme(theme.name)
                    .backgroundPalette(theme.colors.background.name, theme.colors.background.hues);
                }
            }

            $mdThemingProvider.setDefaultTheme(self.elements.content);
        };
    }

    /* @ngInject */
    function addSkinToScope($rootScope, triSkins) {
        $rootScope.triSkin = triSkins.getCurrent();
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular', [
            'ngMaterial',
            'triangular.layouts', 'triangular.components', 'triangular.themes', 'triangular.directives', 'triangular.router',
            // 'triangular.profiler',
            // uncomment above to activate the speed profiler
            'ui.router'
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $window, $state, $filter, $timeout, $injector, triRoute, triBreadcrumbsService) {
        var breadcrumbs = triBreadcrumbsService.breadcrumbs;

        // change title when language changes - when a menu item is clicked - on app init
        var menuTitleHandler = $rootScope.$on('changeTitle', function(){
            setFullTitle();
        });

        $rootScope.$on('$destroy', function(){
            menuTitleHandler();
        });

        function setFullTitle() {
            $timeout(function(){
                var title = triRoute.title;
                angular.forEach(breadcrumbs.crumbs, function(crumb){
                    var name = crumb.name;
                    if($injector.has('translateFilter')) {
                        name = $filter('translate')(crumb.name);
                    }
                    title +=' ' + triRoute.separator + ' ' + name;
                });
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular')

        .provider('triRoute', routeProvider);

    /* @ngInject */
    function routeProvider($locationProvider) {
        // Provider
        var settings = {
            docTitle: '',
            separator: ''
        };

        this.setTitle = setTitle;
        this.setSeparator = setSeparator;
        this.$get = routeHelper;

        function setTitle(title) {
            settings.docTitle = title;
        }

        function setSeparator(separator) {
            settings.separator = separator;
        }

        // Service
        function routeHelper() {
            return {
                title: settings.docTitle,
                separator: settings.separator
            };
        }
        // if we want to jump through hoops and do away with # in our urls
        // $locationProvider.html5Mode(true);
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular.router', [

        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.profiler', [
            'digestHud'
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.profiler')
        .config(profilerConfig);

    /* @ngInject */
    function profilerConfig(digestHudProvider) {
        digestHudProvider.enable();

        // Optional configuration settings:
        digestHudProvider.setHudPosition('top right'); // setup hud position on the page: top right, bottom left, etc. corner
        digestHudProvider.numTopWatches = 20;  // number of items to display in detailed table
        digestHudProvider.numDigestStats = 25;  // number of most recent digests to use f
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .run(layoutRunner)
        .provider('triLayout', layoutProvider);

    /* @ngInject */
    function layoutProvider() {
        var layoutDefaults = {
            toolbarSize: 'default',
            toolbarShrink: true,
            toolbarClass: '',
            contentClass: '',
            innerContentClass: '',
            sideMenuSize: 'icon',
            showToolbar: true,
            footer: true,
            contentTemplateUrl: 'app/triangular/layouts/default/default-content.tmpl.html',
            sidebarLeftTemplateUrl: 'app/layouts/leftsidenav/leftsidenav.tmpl.html',
            sidebarLeftController: 'MenuController',
            sidebarRightTemplateUrl: 'app/triangular/components/notifications-panel/notifications-panel.tmpl.html',
            sidebarRightController: 'NotificationsPanelController',
            toolbarTemplateUrl: 'app/triangular/components/toolbars/toolbar.tmpl.html',
            toolbarController: 'DefaultToolbarController',
            footerTemplateUrl: 'app/triangular/components/footer/footer.tmpl.html'
        };
        var resetableOptions = ['toolbarSize', 'toolbarShrink', 'toolbarClass', 'contentClass', 'innerContentClass',  'showToolbar', 'footer', 'contentTemplateUrl', 'sidebarLeftTemplateUrl', 'sidebarLeftController', 'sidebarRightTemplateUrl', 'sidebarRightController', 'toolbarTemplateUrl', 'toolbarController', 'footerTemplateUrl', 'loaderTemplateUrl', 'loaderController'];
        var layout = {};

        this.getDefaultOption = getDefaultOption;
        this.setDefaultOption = setDefaultOption;

        function getDefaultOption(name) {
            return layoutDefaults[name];
        }

        function setDefaultOption(name, value) {
            layoutDefaults[name] = value;
        }

        // init

        angular.extend(layout, layoutDefaults);

        // Service
        this.$get = function() {
            function setOption(name, value) {
                layout[name] = value;
            }

            function updateLayoutFromState(event, toState) {
                // reset classes
                angular.forEach(resetableOptions, function(option){
                    layout[option] = layoutDefaults[option];
                });
                var layoutOverrides = angular.isDefined(toState.data) && angular.isDefined(toState.data.layout) ? toState.data.layout : {};
                angular.extend(layout, layout, layoutOverrides);
            }

            return {
                layout: layout,
                setOption: setOption,
                updateLayoutFromState: updateLayoutFromState
            };
        };
    }

    /* @ngInject */
    function layoutRunner($rootScope, triLayout) {
        // check for $stateChangeStart and update the layouts if we have data.layout set
        // if nothing set reset to defaults for every state
        var destroyOn = $rootScope.$on('$stateChangeStart', triLayout.updateLayoutFromState);
        $rootScope.$on('$destroy', removeWatch);

        /////////////

        function removeWatch() {
            destroyOn();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.directives', [
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('themeBackground', themeBackground);

    /* @ngInject */
    function themeBackground($mdTheming, triTheming) {
        // Usage:
        // ```html
        // <div md-theme="cyan" theme-background="primary|accent|warn|background:default|hue-1|hue-2|hue-3">Coloured content</div>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            $mdTheming($element);

            // make sure we have access to the theme - causes an eslint but nothing we can do about AM naming
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line
            if(angular.isDefined($mdTheme)) {
                var intent = attrs.themeBackground;
                var hue = 'default';

                // check if we have a hue provided
                if(intent.indexOf(':') !== -1) {
                    var splitIntent = attrs.themeBackground.split(':');
                    intent = splitIntent[0];
                    hue = splitIntent[1];
                }
                // get the color and apply it to the element
                var color = triTheming.getThemeHue($mdTheme.$mdTheme, intent, hue);
                if(angular.isDefined(color)) {
                    $element.css({
                        'background-color': triTheming.rgba(color.value),
                        'border-color': triTheming.rgba(color.value),
                        'color': triTheming.rgba(color.contrast)
                    });
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('triSamePassword', samePassword);

    /* @ngInject */
    function samePassword() {
        // Usage:
        //
        // ```html
        // <form name="signup">
        //     <input name="password" type="password" ng-model="user.password" same-password="signup.confirm" />
        //     <input name="confirm" type="password" ng-model="user.confirm" same-password="signup.confirm" />
        // </form>
        // ```
        // Creates:
        //
        // `samePassword` is a directive with the purpose to validate a password input based on the value of another input.
        // When both input values are the same the inputs will be set to valid

        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: link,
            scope: {
                triSamePassword: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$viewChangeListeners.push(function() {
                ngModel.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
                scope.triSamePassword.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('paletteBackground', paletteBackground);

    /* @ngInject */
    function paletteBackground(triTheming) {
        // Usage:
        // ```html
        // <div palette-background="green:500">Coloured content</div>
        // ```
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            var splitColor = attrs.paletteBackground.split(':');
            var color = triTheming.getPaletteColor(splitColor[0], splitColor[1]);

            if(angular.isDefined(color)) {
                $element.css({
                    'background-color': triTheming.rgba(color.value),
                    'border-color': triTheming.rgba(color.value),
                    'color': triTheming.rgba(color.contrast)
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('countupto', countupto);

    /* @ngInject */
    function countupto($timeout) {
        // Usage:
        //
        // ```html
        // <h1 countupto="100"></h1>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                'countupto': '=',
                'options': '='
            }
        };
        return directive;

        function link($scope, $element, attrs) {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            };

            var numAnim;

            // override default options?
            if ($scope.options) {
                for(var option in options) {
                    if(angular.isDefined($scope.options[option])) {
                        options[option] = $scope.options[option];
                    }
                }
            }

            attrs.from = angular.isUndefined(attrs.from) ? 0 : parseInt(attrs.from);
            attrs.decimals = angular.isUndefined(attrs.decimals) ? 2 : parseFloat(attrs.decimals);
            attrs.duration = angular.isUndefined(attrs.duration) ? 5 : parseFloat(attrs.duration);

            $timeout(function() {
                numAnim = new CountUp($element[0], attrs.from, $scope.countupto, attrs.decimals, attrs.duration, options);
                numAnim.start();

                $scope.$watch('countupto', function(value, oldValue) {
                    if (angular.isDefined(value) && value != oldValue) {
                        numAnim.update(value);
                    }
                });

            }, 500);            
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.permission', [
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .controller('PermissionController', PermissionController);

    /* @ngInject */
    function PermissionController($state, $window, $cookies, RoleStore, PermissionStore, UserService, users) {
        var vm = this;
        vm.userList = users.data;
        vm.roleList = [];
        vm.permissionList = [];
        vm.allRoles = RoleStore.getStore();
        vm.allPermissions = PermissionStore.getStore();

        vm.loginClick = loginClick;
        vm.selectUser = selectUser;

        ////////////////

        function init() {
            var currentUser = UserService.getCurrentUser();
            angular.forEach(users.data, function(user) {
                if(user.username === currentUser.username) {
                    selectUser(user);
                }
            });
        }

        function loginClick() {
            // store username in a cookie so we can load after reload
            $cookies.put('tri-user', vm.selectedUser.username);
            $window.location.reload();
        }

        function selectUser(user) {
            vm.selectedUser = user;
            vm.roleList = [];
            vm.permissionList = [];
            // find first role and select that
            angular.forEach(vm.allRoles, function(role) {
                if(-1 !== vm.selectedUser.roles.indexOf(role.roleName)) {
                    // add this users roles to the list
                    vm.roleList.push(role);
                    angular.forEach(role.permissionNames, function(permission) {
                        vm.permissionList.push(permission);
                    });
                }
            });
        }

        // init

        init();
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('ToolbarController', DefaultToolbarController);

    /* @ngInject */
    function DefaultToolbarController($log, $scope, teamDataService, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;
        // teamDataService.getOwnersTeamList();

        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $scope.logout =logout;


        // if we are on dashboard, substitute a different crumb
        if($state.includes('triangular.dashboard')){
            $scope.overRideBreadcrumb = "Adminja"
        }

        $scope.filterUser = function(user){
         if(user != 'all'){
             // alert('Will trigger filtering to user ' + userID);
             // alert the parent controller of the new filter
             teamDataService.filteredMember = user.uid;
             teamDataService.filteredMemberName = user.profile.firstName;
         } else {
             delete teamDataService.filteredMember;
             delete teamDataService.filteredMemberName;
         }
        }// filterUser

        $timeout(function(){
            $scope.teamList = teamDataService.teamList;
        }, 500);

        // Added for Adminja
        function logout(){
            firebase.auth().signOut().then(function() {
              // Sign-out successful.
              $state.go('authentication.login')
            }, function(error) {
              // An error happened.
            });
        }
        ////////////////

        function changeState(newState){
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('LeftSidenavController', LeftSidenavController);

    /* @ngInject */
    function LeftSidenavController(triSettings, triLayout, userDataService, $log, $timeout, $mdUtil, $mdSidenav) {
        var vm = this;
        vm.layout = triLayout.layout;
        vm.sidebarInfo = {
            appName: triSettings.name,
            appLogo: triSettings.logo
        };
        vm.toggleIconMenu = toggleIconMenu;
        vm.closeSideNav = closeSideNav;


        ////////////
        function toggleIconMenu() {
            if (vm.layout.sideMenuSize ==='icon'){
                // changing to full
                triLayout.setOption('sideMenuSize', 'full');
                userDataService.changeUserSetting('pinMenu', true);
            } else {
                // changing to icon
                triLayout.setOption('sideMenuSize', 'icon');
                userDataService.changeUserSetting('pinMenu', false);
            }

        }// toggleIconMenu

        function closeSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-md');
            }
        }

    }
})();

(function() {
        'use strict';
        angular
            .module('app', [
                // Triangular Modules
                'ui.router', 'permission',
                'triangular',
                'ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngMaterial',
                'googlechart', 'chart.js', 'linkify', 'ui.calendar', 'angularMoment', 'textAngular', 'hljs', 'md.data.table', angularDragula(angular), 'ngFileUpload',
                // 'seed-module',
                'app.translate',
                'app.permission',
                // dont need permissions?  if you want to turn off permissions
                // comment out or remove the 'app.permission', line above
                // also remove 'permission' from the first line of dependencies
                // https://github.com/Narzerus/angular-permission see here for why

                // Other Third Party,
                'lk-color-chooser',
                'lk-google-picker',
                'dropbox-picker',
                'angular-embedly',
                'AngularPrint',
                'cfp.hotkeys',
                'lk-color-chooser',
                'firebase',
                'LocalStorageModule',
                'ngLodash',
                'ngSanitize',
                'angularLoad', // for loading and wrapping 3rd party JS (used for Chargebee API)
                'ngCsv', // for converting JSON into Bas64 CSV downloads
                'rt.debounce', // mainly for debouncing horizontal nav bounds checking but might come in handy on
                // 'xeditable',
                'angularInlineEdit',
                'angular-toArrayFilter',
                // 'angular-timezone-selector',

                // VATool modules
                // 'time',
                'app.authentication',
                'appDirectives',
                'appServices',
                'adminDashboard',
                // 'adminSetup',
                // 'tasks',
                'clientManager',
                // 'adminTeam',
                // 'diagnostics',
                'appFilters',
                // 'adminToday',
                'manage',
                'ngClassOnMobile'
            ])

              // configure google file picker
              .config(['lkGoogleSettingsProvider', function (lkGoogleSettingsProvider) {
                  // https://github.com/softmonkeyjapan/angular-google-picker
                lkGoogleSettingsProvider.configure({
                  apiKey   : 'AIzaSyC3Fo2AjN-zJcTmkAQ4xvIHT2Wsp5Y_F8k',
                  clientId : '1012957704097-6gljved40d8lfp6tjmcm1194dtll5735.apps.googleusercontent.com',
                  scopes   : ['https://www.googleapis.com/auth/drive'],
                  locale   : 'en',
                  features : ['MULTISELECT_ENABLED']
                })
            }])

              .config(['$mdToastProvider', function($mdToastProvider){
                $mdToastProvider
                  .addPreset('adminjaAlert', {
                    options: ['$mdToast', '$mdTheming', function($mdToast, $mdTheming) {
                      return {
                        template:
                          '<md-toast class="adminja-toast">' +
                          '  <div  class="md-toast-content " style="background-color: #fff; color: #666; padding: 1em; border-top: 4px solid {{color}};">' +
                              '<div layout="row" layout-align="start start">'+
                                '<div layout="column" layout-align="center center">'+
                                  '<img src="/assets/images/brand/adminja-bug-small.png" width="30" height="30" style="margin: 0 1em 0 0;"> ' +
                                  '</div>'+
                                '<div flex layout="column" layout-align="start start">'+
                                  '<h4 style="margin:0;"><strong>{{title}}</strong></h4>' +
                                  '<p style="margin:0;">{{message}}</p>'+
                                '</div>' +
                              '</div>' +
                              '</div>'+
                          '</md-toast>',
                        controllerAs: 'vm',
                        hideDelay   : 3000,
                        bindToController: true,
                        position: 'top right',
                        controller: messageToastController
                      };
                    }]
                  });
                  /* @ngInject */
                  function messageToastController($scope, $mdToast, locals){
                    $scope.message = locals.message;
                    $scope.title = locals.title;
                    $scope.color = locals.color;
                  }
              }])

              // configure dropbox file picker
              // https://github.com/geojacobm6/angular-dropbox-box-picker
              .config(['DropBoxSettingsProvider', function(DropBoxSettingsProvider) {
                    // Configure the options
                      DropBoxSettingsProvider.configure({
                          linkType: 'preview',//dropbox link type
                          multiselect: false,
                          extensions: ['images', 'audio', 'video', 'documents','text']
                        });
                  }])

            //Configure Hotkeys
            .config(function(hotkeysProvider) {
                hotkeysProvider.includeCheatSheet = true;
            })

            // Configure embedly
            .config(['embedlyServiceProvider', function(embedlyServiceProvider) {
                embedlyServiceProvider.setKey('25aeb3a109ff4ddfa40153bbeff5b244');
            }])

            // create a constant for languages so they can be added to both triangular & translate
            .constant('APP_LANGUAGES', [{
                name: 'LANGUAGES.CHINESE',
                key: 'zh'
            }, {
                name: 'LANGUAGES.ENGLISH',
                key: 'en'
            }, {
                name: 'LANGUAGES.FRENCH',
                key: 'fr'
            }, {
                name: 'LANGUAGES.PORTUGUESE',
                key: 'pt'
            }])

            // set a constant for the API we are connecting to
            .constant('API_CONFIG', {
                // 'url': 'http://triangular-api.oxygenna.com/'
            })
            // firebase url
            .constant('firebaseUrl', 'https://project-6414439425425792624.firebaseio.com')


            /* @ngInject */
            .run(function($window, teamDataService, $q, $log, triLoaderService, $timeout, gateService, authFactory, timerDataService,$mdDateLocale, $rootScope, $state, $firebaseAuth, $stateParams, clientDataService, userDataService, messagingService, localStorageService, triMenu, $mdDialog, $mdToast){
                $rootScope.adminjaEnv = adminjaEnv;



                triLoaderService.setLoaderActive(true);

                // Every ime the client Menu is built, we
                // want to refresh our clientTeams array AFTER it's done
                // Since we are trying to get service to talk to each other
                // Using events got us around lots of gnarly stuff
                // The initial event that triggers this is at the end of clientDataService.setupClientMenu


                authFactory.$onAuthStateChanged(function(authData){
                  // $log.info('authStateChanged', authData);
                  // if we are really logged in - set everything up
                  if(authData){
                    $log.info('logged in');


                    // set this so it always shows
                    $rootScope.showNinjaMenu = true;


                    // if we are logged in and we aren't on registration page
                    var pass = true
                    if(_.has($rootScope, 'toState.current')){
                        if ($rootScope.toState.current.name == 'authentication.registration' || $rootScope.toState.current.name == 'authentication.login'){
                          pass = false
                        }
                    }



                  }// if authdata
                  if(!authData){
                      // $log.info('Adminja: no user logged in');
                      // $log.info('Attempting to go to: ');
                      // $log.info($rootScope.toState);
                      if($rootScope.toState.name != 'authentication.login' && $rootScope.toState.name != 'authentication.registration' && $rootScope.toState.current.name != 'authentication.confirmation'){
                        // $log.info('Not trying to access authentication. Should Go to login.');
                        $state.go('authentication.login'); // go to login
                      }
                  }// if !authdata
                }); // onAuthStateChanged


                $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                    // $log.info('$stateChangeStart');
                    // Putting our state on rootscope so we can access all of it's values when checking for login redirects in our .run loop
                    // SEE: https://stackoverflow.com/questions/24895908/how-do-return-the-state-current-name-from-ui-router-statechange/27073618
                    $rootScope.toState = toState;
                    // $log.debug(toState);
                    // $log.debug(fromState);
                    // $log.debug('$stateChangeStart $stateParams');
                    // $log.debug($stateParams);

                    // Kill dialogs if we navigate to a different route
                    $rootScope.$on('$routeChangeStart', function() {
                      $mdDialog.cancel();
                    })

                    // if asking for login, just go there.
                    var isLogin = toState.name === "authentication.login";
                    if(isLogin){
                       return; // no need to redirect
                    }
                    // $log.info('app.module.js');
                    // if asking for registration, just go there.
                    var isRegistration = toState.name === "authentication.registration";
                    if(isRegistration){
                      // $log.info('asking for Registration. Passing through.');
                       return; // no need to redirect
                    }

                    // Otherwise, if logged in, go to route, if logged out, go to login
                   if($rootScope.userID){
                    // $log.info('we has a user. they can pass through');
                        return
                   } else {
                      $log.info('no user. need to login.');
                      $state.go('authentication.login'); // go to login
                   }

                });

                $rootScope.$on('$locationChangeSuccess', function() {

                   });

                $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){

                });

                // If any states yield an error - send it to console so we can see it
                $rootScope.$on('$stateChangeError',
                function(event, toState, toParams, fromState, fromParams, error){
                    $log.info('$stateChangeError');
                    console.log('Event:');
                    console.log('event', event);
                    console.log('fromState:');
                    console.log(fromState);
                    console.log('toState:');
                    console.log(toState);
                    // console.log('fromParams:');
                    // console.log(fromParams);
                    // console.log('toParams:');
                    // console.log(toParams);
                    console.log('Error:');
                    console.log('Error:', error);
                });



            // If any of our resolves trigger an error, send to login
                $rootScope.$on('$routeChangeError', function(event, next, previous, error){
                    console.log('$routeChangeError');
                    console.log(error);
                    if (error = "AUTH_REQUIRED"){
                        console.log('Error in Auth');
                        // $state.go('authentication.login');
                    }
                });


                    $rootScope.loaderMessages = [
                      'Thank you for using Adminja, we appreciate it!',
                      'Are you ready to Adminja today?',
                      'Time to kick it up a level!',
                      'Get ready to drop kick this day!',
                      'Tasks happen, be an Adminja!',
                      'Please Adminja responsibly.',
                      'With great power...comes a great electricity bill.',
                      'After Tuesday even the calendar goes W T F',
                      'An apple day keeps anyone away if you throw it hard enough.',
                      'Life is short, eat the cake.',
                      'Cupakes are muffins that believed in miracles.',
                      'We\'ll be back in just a minute, but if we\'re not.. Read this message again.',
                      'Deja Poo: The feeling that you\'ve heard this crap before.',
                      'Awesomeness: Just one of the services I offer.',
                      'We\'re not lazy. We\'re just on our energy saving mode.',
                      'Coffee kicking in 3...2...1...',
                      'We\'re all in this together!',
                      'You can do this!',
                      'You got this!',
                      'Let\'s Rock and Roll!',
                      'In case no one has told you lately, You are amazing!',
                      'We like you!',
                      'Remember to get up and stretch once in a while.',
                      'Take a minute and breathe...',
                      'Take a second and close your eyes. They need rest too...',
                      'Positive Mind. Positive Vibes. Positive Life.',
                      'Mistakes just mean you are trying.',
                      'Mistakes happen, eat a cupcake. ',
                      // 'Work Hard. Play Harder.',
                      // 'Work Hard. Dream Big.',
                      'May your day be as wonderful as you are!',
                      'Keep your head up and eye on the prize.',
                      'Life is beautiful. Enjoy the ride!',
                      'Today is a great day to have a great day!',
                      '"Live and Let Live" \n-Scottish Proverb',
                      '"Life is short. Live Passionately." -Unknown',
                      '"The trouble is you think you have time." -Buddha',
                      '"Whatever you are, be a good one." -Abraham Lincoln',
                      '"Be the change you wish to see in the world- Gandhi',
                      '"Life is ten percent what happens to you and ninety percent how you respond to it." -Lou Holtz',
                      '"Love the life you live, and live the life you love." -Bob Marley',
                      '"Try and fail, but never fail to try." - Jared Leto',
                      '"To succeed in life, you need two things: ignorance and confidence." - Mark Twain',
                      '"Too much of a good thing can be wonderful." - Mae West',
                      'A diamond is a lump of coal that did well under pressure.',
                      'One day...I\'m gonna make the onions cry.',
                      '"I failed my way to success" - Thomas Edison',
                      'Don\'t raise your voice, improve your argument.',
                      'You can\'t live a positive life with a negative mind.',
                      'Be who you want to be, not what others see.',
                      'Take risks and conquer your fears.',
                      'What would you attempt to do if you knew you could not fail?',
                      'You are enough.',
                      'You are beautiful.',
                      'Take a deep breath and enjoy your life',
                      'Every day is a new beginning.',
                      'If plan \'A\' didn\'t work, the alphabet has 25 more letters.',
                      'You have the power to make every day a bright day.',
                      'You can\'t make a rainbow without a little rain.',
                      'If opportunity doesn\'t knock, build a door.',
                      'The secret of getting ahead is getting started.',
                      'A goal without a plan is just a wish',
                      'You are stronger than you think',
                      'Don\'t regret the past, just learn from it',
                      'Don\'t count the days. Make the days count.',
                      'If there is no struggle, there is no progress.',
                      'Lose an hour in the morning and spend all day looking for it.',
                      'To improve is to change. To be perfect is to change often.',
                      'If you are too busy to laugh, you are too busy.'

                    ];

                    var randomNumber = Math.floor(Math.random()* $rootScope.loaderMessages.length);
                      var selectedMessage =  $rootScope.loaderMessages[randomNumber];
                      $rootScope.loaderMessage = selectedMessage;



                switch ($rootScope.adminjaEnv){
                  case 'production':
                    // $log.info('using chargeBee live');
                    // Chargebee Live Settings
                    $rootScope.chargebeeSettings={
                        checkoutURL: 'https://adminja.chargebee.com/hosted_pages/plans/',
                        site: 'adminja',
                        api_key: 'live_Ftcucu8ysV7C05ctwUIcdRj8WjTUl9fdSfcd',
                        customerPortalURL : "https://adminja.chargebeeportal.com"
                    }// Chargebee Live Settings

                    $rootScope.functionsURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net";
                    $rootScope.functionsKey = "hZPEbfkrPqyTimY4dbgE";
                    $rootScope.adminjaURL = "https://www.adminja.co";
                    $rootScope.dataURL = "https://console.firebase.google.com/u/0/project/project-6414439425425792624/database/project-6414439425425792624/data/";
                  break;
                  case 'staging':
                    // Chargebee Test Settings
                    // $log.info('using chargeBee test');
                    $rootScope.chargebeeSettings={
                        checkoutURL: 'https://adminja-test.chargebee.com/hosted_pages/plans/',
                        site: 'adminja-test',
                        api_key: 'test_KGUZ0ycdqpizfSxWJylBcdcdsYXlKj5LHt',
                        customerPortalURL : "https://adminja-test.chargebeeportal.com"

                    }// Chargebee Test Settings
                    $rootScope.functionsURL = "https://us-central1-adminja-staging.cloudfunctions.net";
                    $rootScope.functionsKey = "hZPEbfkrPqyTimY4dbgE";
                    $rootScope.adminjaURL = "https://adminja-staging.firebaseapp.com";
                    $rootScope.dataURL = "https://console.firebase.google.com/u/0/project/adminja-staging/database/adminja-staging/data/"
                  break;
                }



                    $rootScope.tutorials  = {
                        manageClients: '-KX2nOYyrfzCGLwoHLNe',
                        appPrimer: '-KhboHuMbrk1lmvfz3E6',
                        singleClientNudge: '-KY0SmWv9cg8PK0AGZBe',
                        manageClientProfile: '-KhbrX26R5JHLKtTsvu7',
                        manageClientTaskPanels: '-KYFgFMFvWvlr5t7iGos',
                        manageClientTasks: '-KY0bYzKQpr3AUktyJ4W',
                        timeTracking: '-KY0bYzKQpr3AUktyJ4W',
                        timer: '-KY0bYzKQpr3AUktyJ4W',
                        timerList: '-KY0bYzKQpr3AUktyJ4W',
                        // onboarding 2018
                        gotoWorkspace: '-L3o8VuHsqbSHuKVnaoY',
                        workspaceTabs: '-L41aoiNGJ583BxdBcFs'
                    }


                }); // end run block




    }
)();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('LoaderController', LoaderController);

    /* @ngInject */
    function LoaderController(triSettings, $scope, $log) {
        // $log.info('loaderController');
        var vm = this;
        vm.triSettings = triSettings;

    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('RightSidenavController', RightSidenavController);

    /* @ngInject */
    function RightSidenavController($mdToast, $rootScope, teamDataService, $sce, inboxService, gateService, messagingService, profileDataService, $document, $stateParams, timeDataService, taskDataService, $timeout, userDataService, $log, $firebaseArray, $q, localStorageService, $scope, $http, $mdDialog, $mdSidenav, $state, API_CONFIG) {
        // $log.info('RightSidenavController');
        var vm = this;
        vm.user = userDataService.getUser();
        // In a timeout to make sure the view gets the info



        $scope.sanitizeMe = function(text) {
            return $sce.trustAsHtml(text)
        };

        // $scope.sanitizeNotification = function(text){
        //     var sanitized = $scope.sanitizeMe(text);
        //     return sanitized.substring(0,140)+"...";
        // }
        $scope.requestNotificationPermission = function(){
            messagingService.requestPermission();
        }
        var emailKey = undefined;

        // when the notificatins tab is opened, mark them all read




        $scope.updateSettings = function(setting, value){
            // $log.info('updateSettings');
            userDataService.changeUserSetting(setting, value);
            userDataService.getLoggedInUser();
        } // $scope.updateSettings

        $scope.resetOnboarding = function(){
            return userDataService.resetOnboarding();
        }

        $scope.changeOnboardingFlag = function(flag, value){
            // $log.info('changeOnboardingFlag: ' + flag + ' ' + value);
            return userDataService.changeOnboardingFlag(flag, value);
        }

        // For some reason, this functino won't work under 'vm'
        $scope.logManualTime = function(){
           // $log.info('newTime');
           var clientID = null;
           // if we are on a client page and passed a Client ID, prepopulate our client info
           if ($stateParams.clientID){
            // $log.info('new time for client' + $stateParams.clientID);
            clientID = $stateParams.clientID;
           }

           $scope.timeEntry = timeDataService.newLogEntry(clientID);
           // $log.info($scope.timeEntry);
           timeDataService.timeDialog($scope.timeEntry, "New");
        }




        $scope.discardAllNotifications = function(){
           var entryRef = firebase.database().ref('users/' + $scope.user.uid + '/notifications/');
          entryRef.set(null);
          // _.each(user.notifications, function(notification){

          // })
        }



        // sets the current active tab
        $scope.close = close;
        $scope.currentTab = 0;



        $scope.noGhostUser = function(){
            if(!localStorageService.get('ghostUser')){
                return true
            } else {
                return false
            }
        }
        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('triSwitchNotificationTab', function($event, tab) {
            $scope.currentTab = tab;
        });

        function close() {
            $mdSidenav('right').close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('AppFooterController', FooterController);

    /* @ngInject */
    function FooterController(triLayout, triSettings) {
        var vm = this;

        vm.layout = triLayout;
        vm.settings = triSettings;
    }
})();

(function(){
	'use strict';
	angular.module('appServices',['lk-color-chooser', 'firebase'])
})();

(function () {
    'use strict';
    angular.module('appServices')
            .service('userDataService', userDataService);

    /* @ngInject */
    function userDataService($mdToast, $mdDialog, triMenu, triLayout, $state, gateService, localStorageService, $q, presenceService, $mdDateLocale, $timeout, $log, $http, $rootScope, $firebaseArray, $firebaseAuth, $firebaseObject, authFactory) {
        var usersRef = firebase.database().ref('users');
        var user = undefined;
        var service = {
            getLoggedInUser: getLoggedInUser,
            getUserByID: getUserByID,
            userAvatar: userAvatar,
            updateUser: updateUser,
            clearUserData: clearUserData,
            userDialog: userDialog,
            saveNewUser: saveNewUser,
            getUser: getUser,
            logout: logout,
            changeUserSetting: changeUserSetting,
            changeOnboardingFlag: changeOnboardingFlag,
            resetOnboarding: resetOnboarding,
            getGate: getGate

        };

        return service;

        /////////
        // getUser
        function getUser(){
            return service.user;
        }

        /////////
        // getUser
        function getGate(gate){
              return gateService.gateData[gate]
        }

        ///////////////////////////////////////////////////////////
        /// logout
        function logout() {
            // record the event in drip
            // _dcq.push(["track", "Logged Out"]);
            // clear out our data
            clearUserData();
            // remove Raven user context
            // Raven.setUserContext();
            firebase.auth().signOut().then(function () {
                // Sign-out successful.
                $state.go('authentication.login')
            }, function (error) {
                // An error happened.
            });
        }
        // logout

        ///////////////////////////////////////////////////////////
        /// changeUserSetting
        function changeUserSetting(setting, value) {
            // $log.info('ChangeUserSetting: ' + setting, value);
                  var updates = {};
                  // store our canonical object - just update the PROFILE
                  updates['/users/' + service.user.uid + '/profile/settings/' + setting] = value;
                  return firebase.database().ref().update(updates)

        }
        // changeUserSetting

        ///////////////////////////////////////////////////////////
        /// resetOnboarding
        function resetOnboarding() {
            // $log.info('resetOnboarding: ' + setting, value);
                  var updates = {};
                  // store our canonical object - just update the PROFILE
                  updates['/users/' + service.user.uid + '/profile/onboardingFlags/'] = null;
                  return firebase.database().ref().update(updates)

        }
        // resetOnboarding


        ///////////////////////////////////////////////////////////
        /// changeOnboardingFlag
        function changeOnboardingFlag(flag, value) {
            // $log.info('changeOnboardingFlag: ' + flag, value);
            var updates = {};
            // store our canonical object - just update the PROFILE
            updates['/users/' + service.user.uid + '/profile/onboardingFlags/' + flag] = value;
            return firebase.database().ref().update(updates)
        }
        // changeOnboardingFlag

        ///////////////////////////////////////////////////////////
        /// userDialog
        function userDialog(title) {

                        // we couldn't do an angular.copy here. Not sure why this variable is considered part of the window object
                        // but we are doing a to and from JSON conversion to get the data into our dialog
                        var userCopy = angular.toJson(service.user);
                        userCopy = angular.fromJson(userCopy);

                        // if we are an old user with no profile, add one to avoid errors.
                        if (!userCopy.profile) {
                            userCopy.profile = [];
                        }

                        // if we already have an avatar, assign it to our profile avatar

                        if (userCopy.profile.dob) {
                            userCopy.profile.dob = new Date(userCopy.profile.dob)
                        }
                        ;

                        $mdDialog.show({
                            controller: userDialogController, // see below
                            controllerAs: 'vm',
                            templateUrl: 'app/app-services/userDataService/dialog-user-profile.tmpl.html',
                            locals: {user: userCopy, title: title},
                            bindToController: true,
                            fullScreen: true,
                            focusOnOpen: false,
                            clickOutsideToClose: true
                        });




        }; // userDialog


        function userDialogController() {
            var vm = this;

            vm.countries = [
                {name: 'US'},
                {name: 'CA'},
                {name: 'UK'},
                {name: 'EU'},
                {name: 'AU'},
                {name: 'SA'},
                {name: 'AF'},
            ]
            vm.cancelDialog = function cancelDialog(dialog) {
                // I don't think I'm doing this properly (see fn above)
                // unbindDetail();
                $mdDialog.cancel();
            }

            vm.updateUser = function (user) {
                updateUser(user);
            }

            vm.uploadAvatar = function ($files, user) {
                // $log.info('upload file');
                // $log.info($files);

                if ($files !== null && $files.length > 0) {
                    var storage = firebase.storage(),
                            storageRef = storage.ref();

                    _.each($files, function (file) {
                        var filename = user.uid + '_userAvatar.' + file.name;

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function (snapshot) {
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');

                        }, function (error) {

                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function (success) {
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                            // Set the file url value in our model

                            // $timeout to force a $digest/$apply
                            $timeout(function () {
                                user.profile.avatar = uploadTask.snapshot.downloadURL;
                                vm.scope.userDialogForm.$pristine = false;
                            }, 0);

                            // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
                } // if files
            };// vm.uploadAvatar

        }// userDialogController

        ////////////////////
        // clear user

        function clearUserData() {
            // $log.info('clearUserData');
            delete service.user;
            delete $rootScope.userID;
            delete $rootScope.userName;
            localStorageService.remove('userID');
            localStorageService.remove('userName');
            gateService.clearGates();

        }


        //////////////////////////////////
        // Save User
        function saveNewUser(user) {
            // make a copy so we don't modify what's being shown and throw a DOB error
            var userCopy = angular.copy(user);

            user.dob = user.dob.toISOString();

            user.$save()
                    .then(function () {
                        $mdToast.showSimple('Profile Updated. Thanks!');
                        user.dob = new Date(user.dob);
                    });

            // Redirect to Client Manager for next onramping step
        }

        //////////////////////////////////
        // Update User (TO KEEP LOG DATA SAFE, THIS ONLY UPDATES THE USER PROFILE NODE!!!)


        function updateUser(user){
          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var userCopy = angular.fromJson(angular.toJson(user));
          // $log.info('updateUser');
          // $log.info(userCopy);

            // Make sure we reset fullName in case our name has changed
            userCopy.profile.fullName = userCopy.profile.firstName + ' ' + userCopy.profile.lastName;
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/users/' + userCopy.uid + '/profile'] = userCopy.profile;

            return firebase.database().ref().update(updates)


        }// updateUser
        ///////////////////////////////////////////////////////////
        /// getUser by ID

        function getUserByID(userID) {
            // $log.info('getUserByID: ' + userID);
            var d = $q.defer();
            var userRef = firebase.database().ref('users/' + userID);
            user = $firebaseObject(userRef)
                    .$loaded(function (user) {
                        d.resolve(user);
                        // $log.info(user);
                        return d.promise;
                    });
        }
        ;// getUserByID

        ///////////////////////////////////////////////////////////
        /// userAvatar

        function userAvatar(userID) {
            // $log.info('userAvatar: ' + userID);
            // var d = $q.defer();
            var userRef = firebase.database().ref('users/' + userID);
            user = $firebaseObject(userRef)
                    .$loaded(function (user) {
                      // $log.info(user.profile.avatar);
                      return user.profile.avatar
                      // if(_.has(user, 'profile.avatar') && user.profile.avatar != ""){
                      //   return user.profile.avatar
                      // } else {
                      //   return '/assets/images/avatars/generic-avatar.png'
                      // }
                  });
        };// userAvatar

        //////////////////
        // getLoggedInUser
        // Needs no parameter, returns full user object and sets up gates and user.profile.settings);

        function getLoggedInUser() {
              return $timeout(function (force) {
                  if (service.user && !force) {
                      return service.user
                  } else {
                      // $log.info('Initial user setup...');
                       var userRef = firebase.database().ref('users/' + localStorageService.get('userID'));
                       // If we have logged in as another user, switch to that user
                       if(localStorageService.get('ghostUser')){
                         var ghostUser = localStorageService.get('ghostUser');
                        userRef = firebase.database().ref('users/' + ghostUser.uid);
                       }

                        return $firebaseObject(userRef)
                        .$loaded(function(data){
                          user = data;

                          // we are only allowing Admins into this portal
                          if(user.type != 'admin'){
                            firebase.auth().signOut().then(function() {
                                // delete $rootScope.authData;
                                // delete $rootScope._userData;
                              // Sign-out successful.
                              alert('Sorry, this site is for admins only.')
                              // heap.track('Unauthorized manage adminja login attempt');
                              // console.log('login.controller logoutClick successful.');
                              $state.go('authentication.login')
                            });
                          } else {

                            // Store the user on the service
                            service.user = user;

                            $rootScope.admin = user.type;

                            // return our user
                            return service.user
                          }
                        })
                      };// if service.user && !force
              }, 0);

        }// getLoggedInUser

        function notifyThirdParties(user){

        }// notifyThirdParties

        function defineUserSettings(user){
          // Set sidemenu size based on user setting
          if(_.has(user,'profile.settings.pinMenu')){
              if(user.profile.settings.pinMenu){
                  triLayout.setOption('sideMenuSize', 'full');
              } else {
                  triLayout.setOption('sideMenuSize', 'icon');
              }
          } else {
              triLayout.setOption('sideMenuSize', 'full');
          }

          // if user is new and doesn't have settings, let's define the defaults we need
          if(!_.has(user, 'profile.settings')){

              // make sure they at least have a profile node
              if(!_.has(user, 'profile')){
                user.profile = {};
              }

              user.profile.settings = {};
              user.profile.settings.verticalProfilePanels = false;
              user.profile.settings.verticalTaskPanels = false;
              user.profile.settings.requireWorkDescription = false;
              user.profile.settings.roundUpTo = 1;
              user.profile.settings.hideCompletedPanel = false;
          } else {
              // we have a settings node.
              // but still, make sure critical properties get set on our user
              if(!_.has(user, 'profile.settings.verticalProfilePanels')){
                  user.profile.settings.verticalProfilePanels = false;
              }

              if(!_.has(user, 'profile.settings.verticalTaskPanels')){
                  user.profile.settings.verticalTaskPanels = false;
              }

              if(!_.has(user, 'profile.settings.requireWorkDescription')){
                  user.profile.settings.requireWorkDescription = false;
              }

              if(!_.has(user, 'profile.settings.roundUpTo')){
                  user.profile.settings.roundUpTo = 1;
              }

              if(!_.has(user, 'profile.settings.hideCompletedPanel')){
                  user.profile.settings.hideCompletedPanel = false;
              }
          }

          var dateFormat = 'us';

          // Check user setting and change default datepicker format if set
          if (_.has(user, 'profile.settings.dateFormat')){
              dateFormat = user.profile.settings.dateFormat;
          }

          if (dateFormat == 'eu'){
            // $log.info('Changing dateFormat to eu');
            // Setup our datePicker format
            $mdDateLocale.formatDate = function(date) {
              return date ? moment(date).format('DD/MM/YYYY') : null;
            };

            $mdDateLocale.parseDate = function(dateString) {
              var m = moment(dateString, 'DD/MM/YYYY', true);
              return m.isValid() ? m.toDate() : new Date(NaN);
            };
          }
          if(_.has(user, 'profile.settings.startOfWeek')){
              $mdDateLocale.firstDayOfWeek = parseInt(user.profile.settings.startOfWeek);
          }
        }


    }


})
        ();

(function () {
    'use strict';


    angular.module('appServices')
            .service('timerDataService', timerDataService);

    /* @ngInject */
    function timerDataService($log, moment, localStorageService, taskDataService,
                userDataService, gateService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $interval,hotkeys, $firebaseArray, $firebaseObject, $q, $window) {
        var service = {
            timerData: timerData,
            newTimer: newTimer,
            newTaskTimer: newTaskTimer,
            updateTimer: updateTimer,
            getTimer: getTimer,
            getTimers: getTimers,
            startTimer: startTimer,
            pauseTimer: pauseTimer,
            pauseTaskTimer: pauseTaskTimer,
            deactivateActiveTimer: deactivateActiveTimer,
            resumeTimer: resumeTimer,
            resumeSavedTimer: resumeSavedTimer,
            resumeSavedTaskTimer: resumeSavedTaskTimer,
            stopTimer: stopTimer,
            discardTimer: discardTimer,
            resetTimer: resetTimer,
            calcLogged: calcLogged,
            runTimer: runTimer,
            clearTimerData: clearTimerData,
            init: init,
            toggleTimerGui: toggleTimerGui
        };



        return service;

        // Initialize service.timerData object
        function init(){
            var user = firebase.auth().currentUser;
            if (user){
                service.timerData = {};
               $timeout(function(){
                    getTimers();
                    service.showTimerGui = true;
                }, 0);
            }
        }

        // global placeholder for our approxAccrued $interval so it can be cancelled anywhere in the service
        var timerCounter = undefined;

        /////////////
        // Toggle timer gui
        function toggleTimerGui(){
            if(service.showTimerGui){
                service.showTimerGui = false
            } else {
                service.showTimerGui = true
            }
        }


        ////////////////////////////////////
        // newTaskTimer
        //
        // Uses existing methods to create, activate and start a new timer from a task card
        function newTaskTimer(task){
            // $log.info('newTaskTimer. Task:');
            // $log.info();
            deactivateActiveTimer();

            var targetClient = _.find(clientDataService.getQuickClients(), function(o){return o.uid == task.client});
            var timer = newTimer(targetClient, task);

            // set our active client
            // only if there's no activeClient or if the activeClient is different from new timer's

            if (!_.has(service.timerData, 'activeClient')){
            // If we don't already have one, assign it
                service.timerData.activeClient = targetClient;
            } else if (service.timerData.activeClient.uid != targetClient.uid){
                // if we have activeClient and it's different from current client, assign it
                service.timerData.activeClient = targetClient;
            }

            // heap.track('New Task Timer Started');
            startTimer(timer);
        }// newTaskTimer

        //////////////////////////////////////////////////////
        // Calculates logged time off of timer events.
        // Recalculates entire timer on each pause or stop.
        function calcLogged(timer){
            // $log.info('calcLogged. Timer:');
            // $log.info(timer);
            var logged = 0;
            var start = undefined;

            // go through each timer.event and find start/stop times
            _.each(timer.events, function(timerEvent){
                // If it's a start event, store it's start time
                if(timerEvent.event == 'start'){
                    // store a start
                    start = timerEvent.when;
                }

                // If it's a stop event, compare to start time and add difference to logged
                // reset start time in prep for next event pair
                if (timerEvent.event == 'stop'){
                    // if it's a stop event, calculate against start
                    var end = timerEvent.when;
                    var difference = (end-start);
                    logged = Math.round(logged + (difference/1000));
                    start = undefined;
                }
            });
            // $log.info(logged + ' seconds logged.');
            // Update Accrued
            timer.accrued = logged;
            // Clear timer.lastStart so local elapsed will start fresh next time
            timer.lastStart =  undefined;
            // Save our changes
            updateTimer(timer);
        }

        ///////////////////////////////////////////////
        ///////////////getTimers////////////////////
        // Get all timer data of user
        function getTimers() {
            // $log.info('getTimers');
            if(_.size(service.timerData.timers > 0)){
                // we already have timers. returning
                return service.timerData.timers
            } else {
                // we can't use the simpler user = userDataService.user here for some reason.
                return userDataService.getLoggedInUser()
                .then(function(user){
                    // we dont have timers. getting and building our timerData object
                    var timerRef = firebase.database().ref('users/' + user.uid + '/timers');
                    return $firebaseArray(timerRef)
                    .$loaded(function (data) {
                        // Store our timers array on the service
                        service.timerData.timers = data;

                        //If there's an active timer, add it to timerData so directive picks it up on load/refresh
                        var activeTimer  = _.find(service.timerData.timers, function (timer) {
                            return timer.active == true;
                        });

                        // if we had a valid activeTimer - assign it
                        // otherwise, make an empty one.
                        if (_.size(activeTimer)){
                            // make this our active timer immediately
                            service.timerData.activeTimer = activeTimer;
                            // set our active client so our md-select functions correctly
                            service.timerData.activeClient = activeTimer.client;

                            // if this timer was in an "on" state,
                            // trigger our runTimer
                            if (service.timerData.activeTimer.on){
                            // grab localWhen from the last event and set it to lastStart so we can display it
                                var lastEvent = _.last(service.timerData.activeTimer.events);
                                service.timerData.activeTimer.lastStart = lastEvent.localWhen;
                                // start runTimer
                                 runTimer();

                            }// if activeTimer.on
                        } else {
                            service.timerData.activeTimer = {};
                        }

                        // return our timers
                        return service.timerData.timers
                })
            });
            }
        } // getTimers

        ///////////////////////////////////////////////
        /////////////// newwTimer ////////////////////
        // Creates a fresh timer object with client and taskID
        function newTimer(quickClient, task){
            // $log.info('newTimer. quickClient, task:');
            // $log.info(quickClient);
            // $log.info(task);

            var timer = {};
            // $log.info('newTimer');
            // Task Data Prep (if present)
            if (task){
                var taskShadow={};
                taskShadow.logged = task.logged;
                taskShadow.title = task.description;
                taskShadow.uid = task.refID;
                if(_.has(task, 'budget')){
                    taskShadow.budget = task.budget;
                }
                // put it on our new timer
                timer.task = taskShadow;
            } // task data prep

            // add user info
            timer.userID = userDataService.getUser().uid;

            // Add client Info
            timer.client = quickClient;

            // Setup empty array to push events to
            timer.events = [];

            // Timer State Prep
            //-----------------
            // Set this timer to be active
            timer.active = true;
            // Set timer's state to on
            timer.on = false;
            // Give it zero time accrued
            timer.accrued = 0;

            // our ephemeral approxAccrued for displaying live count to our users
            // it will always be 0 as far as firebase is concerned.
            // we use it and throw it away in between firebase updates
            timer.approxAccrued = 0;

            // set it to our active timer
            service.timerData.activeTimer = timer;

            // set our active client for our md-select
            // but only if we need to
            // service.timerData.activeClient = timer.client;

            if (!_.has(service.timerData, 'activeClient')){
            // If we don't already have one, assign it
                service.timerData.activeClient = timer.client;
            } else if (!_.has(service.timerData, 'activeClient.uid') && service.timerData.activeClient.uid != timer.client.uid){
                // if we have activeClient and it's different from current client, assign it
                service.timerData.activeClient = timer.client;
            }


            return service.timerData.activeTimer
        }


        ///////////////////////////////////////////////
        ///////////////Start Timer////////////////////
        // Store and Start timer
        function startTimer(timer) {
            // $log.info('startTimer. timer:');
            // $log.info(timer);



            // Store lastStart for accurate time elapsed display
            timer.lastStart =  moment().format('x');

            // add start event to this timer's events array
            timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': timer.lastStart});

            // Set timer to on
            timer.on = true;

            // get unique ID for the new timer
            var newEntryKey = firebase.database().ref().child('users/' + timer.userID + '/timers').push().key;
            timer.uid = newEntryKey;

            // make sure we have a clean, simple object
            var Timer = angular.fromJson(angular.toJson(timer));

            // declare our array of updates to make
            var updates = {};

            // store data in the Users -> timers
            updates['/users/' + Timer.userID + '/timers/' + newEntryKey] = Timer;

            // Commit our updates
            return firebase.database().ref().update(updates)
            .then(function(response){
                // IMPORTANT - go through timer array and BIND activeTimer to the one that we just added
                _.each(service.timerData.timers, function(timer){
                    // if we found our active timer...
                    if(timer.uid == newEntryKey){
                        // assign it to activeTimer
                        service.timerData.activeTimer = timer;
                    }
                })
            })
            .then(function(){
                // Start our runTimer to show elapsed in GUI
                    // $window.Appcues.identify($rootScope.user.uid {});
                    // heap.track('Timer Started');
                    runTimer();
                     _dcq.push(["identify", {
                      email: userDataService.user.email,
                      tags: ["Used Timer"]
                    }]);

            });

        }// startTimer



        function pauseTimer(timer) {
            timer.displayColor = 'rgba(0,0,0,.5)'
            // $log.info('pauseTimer. timer:');
            // $log.info(timer);
            // As a safety check, we call pause alot
            // only pause if it's running. we don't need unnecessary events logged
            if(timer.on){
                // Cancel our runTimer
                $interval.cancel(timerCounter);
                // add start event to this timer's events array
                timer.events.push({'event': 'stop', 'when': firebase.database.ServerValue.TIMESTAMP});
                // Turn off the timer
                timer.on = false;
                // Save our updated timer
                // // heap.track('Timer Paused');
                return updateTimer(timer)
                .then(function(){
                    // calculate our new "accrued" total and save it
                    calcLogged(timer);
                    // Adding this because we need to refresh our user
                    // he's losing .gates when timer is updated on timer start
                    // vm.user is already bound to the service, we are just refreshing that variable
                    return userDataService.getLoggedInUser(true);
                });
            }
        }

        // Safely pause and/or deactivate timer and update only if necessary.
        // Result is a cleaned up timer, if there was one active
        // Pattern is probably inefficient, but easy to read
        function deactivateActiveTimer() {
            // $log.info('deactivateActiveTimer');
            var timer = service.timerData.activeTimer;
            var needsUpdate = false;

            if (timer.on){
                needsUpdate = true;
                timer.on = false;
                // Cancel our runTimer
                $interval.cancel(timerCounter);
                // add start event to this timer's events array
                timer.events.push({'event': 'stop', 'when': firebase.database.ServerValue.TIMESTAMP});
            }

            if (timer.active){
                needsUpdate = true;
                timer.active = false;
            }

            if (needsUpdate){
                return updateTimer(timer)
                .then(function(){
                    calcLogged(timer);
                });
            }
        }// deactivateTimer

        function resumeTimer(timer) {
            // $log.info('resumeTimer. timer:');
            // $log.info(timer);
          // add start event to this timer's events array
            timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': moment().format('x')});
            timer.on = true;
            timer.active = true;
            timer.lastStart =  moment().format('x');

            // Save our updated timer
           return updateTimer(timer)
           .then(function(){
                // heap.track('Timer Resumed');
                 runTimer();
           });

        }

        function pauseTaskTimer(task){
            // $log.info('pauseTaskTimer', task);
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.refID){
                              // heap.track('Timer Paused');
                              service.pauseTimer(timer);
                          }
                      }
                  });// each timer
        }


        function resumeSavedTaskTimer(task){
            // $log.info('resumeSavedTaskTimer', task);
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.refID){

                              service.resumeSavedTimer(timer);
                          }
                      }
                  });// each timer
        }

        function resumeSavedTimer(timer){
            // $log.info('resumeSavedTimer. timer:');
            // $log.info(timer);
            // If we have an activeTimer - pause and deactivate it
            if(_.has(service.timerData, 'activeTimer.active')){
                // make sure it's active and we are NOT resuming an active/paused timer (don't want to wipe it out before resuming)
                if (service.timerData.activeTimer.active && service.timerData.activeTimer.uid != timer.uid){
                    deactivateActiveTimer(service.timerData.activeTimer);
                }
            }
            // $log.info(service.timerData.activeClient);
             // Add Event
              timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': moment().format('x')});

              // Set properties
              timer.on = true;
              timer.active = true;
              timer.lastStart =  moment().format('x');

              // reset accrued to actual
              timer.approxAccrued = timer.accrued;

              // make it our active timer
              service.timerData.activeTimer = timer;

              // Only set the activeClient if it's not set
              // or if it needs to be set to a DIFFERENT client
              // otherwise, the md-select will fail as it triggers a new timer.)
              if (!_.has(service.timerData, 'activeClient')){
                // $log.info('no activeClient. setting.');
                // no activeClient. Setting.
                service.timerData.activeClient = timer.client;
              } else if (_.has(service.timerData, 'activeClient.uid') && _.has(timer, 'client.uid')){
                if (service.timerData.activeClient.uid != timer.client.uid){
                    // $log.info('activeClient needs changing. setting.');
                    // activeClient nees to change. Setting.
                    service.timerData.activeClient = timer.client;
                }

              } else {
                // $log.info('*activeClient untouched.');
                // activeClient should stay the same. Doing nothing.
              }

              // Update in FB
              return updateTimer(service.timerData.activeTimer)
              .then(function(){
                    // heap.track('Resume Timer');
                    runTimer();
              });
        }

        function stopTimer (timer){
            // $log.info('stopTimer. timer:');
            // $log.info(timer);
            var roundUpTo = userDataService.user.profile.settings.roundUpTo;
            // just for safety's sake
            if(!roundUpTo){
                roundUpTo = 1
            }
            $q.when(pauseTimer(timer))
            .then(function(){
                // $log.info(timer);
                // get a fresh logEntry to work with
                var timeEntry = timeDataService.newLogEntry(timer.client.uid);
                // if our timer has an associated task, pass it on
                if(_.has(timer, 'task')){
                    timeEntry.task = timer.task.uid;
                    timeEntry.taskName = timer.task.title;
                }
                // convert accrued into hours and minutes for our form
                var totalMinutes = timer.accrued/60;
                // round up total minutes to nearest roundUpTo
                totalMinutes = Math.ceil(totalMinutes/roundUpTo)*roundUpTo;

                var hours = Math.floor(totalMinutes / 60),
                minutes = (totalMinutes % 60);

                // Make sure we return 0 for no results
                timeEntry.hours = Math.round(hours) || 0;
                timeEntry.minutes = Math.round(minutes) || 0;
                timeEntry.timerID = timer.uid;

                // if we already provided a description for this. Prepopulate it
                if (_.has(timer, 'description')){
                    timeEntry.description = timer.description;
                }

                // $log.info(timeEntry);

                // Notify HEAP
                // heap.track('Timer Closed');
                // Pass it to our time dialog form for user to complete
                timeDataService.timeDialog(timeEntry, "Log");
                 _dcq.push(["identify", {
                  email: userDataService.user.email,
                  tags: ["Closed Timer"]
                }]);
            });
        }

        function timerData () {
            return service.timerServiceData;
        }



        ///////////////////////////////////////////////
        ///////////////Update Timer////////////////////
        function updateTimer(timer) {
            // $log.info('updateTimer. timer:');
            var Timer = angular.fromJson(angular.toJson(timer));
            ajUTILITIES.removePropertiesWith(Timer);
            var updates = {};
            // // store data in the Users -> timers
            updates['/users/' + Timer.userID + '/timers/' + timer.uid] = Timer;
            // Commit our updates
           return firebase.database().ref().update(updates);
        } // pauseTimer

        /////////////////////////////////////////////////////////
        //// Get Timer Data according to userID and TimerID ////

        function getTimer(userID, timerID) {
            // $log.info('getTimer. userID, timerID:');
            // $log.info(userID);
            // $log.info(timerID);
            var timerRef = firebase.database().ref('users/' + userID + '/timers/' + timerID);
            return $firebaseObject(timerRef)
                    .$loaded(function (timer) {
                        return timer;
                    });
        }// getTimer


        function resetTimer(){
            // $log.info('resetTimer');
            delete service.timerData.activeClient;
            service.timerData.activeTimer = { accrued: 0, approxAccrued: 0};
        }

        ///////////////////////////////////////////////
        ///////////////delete Timer////////////////////
        // Delete timer record from list
        // need to do this by ID so it's accessible to our timeDialog after time is officially submitted
        function discardTimer(timerID) {
            // $log.info('discardTimer. timerID:');
            // $log.info(timerID);
            _.each(service.timerData.timers, function(timer){
                // Find the timer by ID
                if(timer.uid == timerID){
                    // if timer is the Active one, remove it from active and reset our timer first
                    if (timer.active){
                        resetTimer();
                    }
                    // heap.track('Timer Discarded');
                    var updates = {}
                    updates['/users/' + timer.userID + '/timers/' + timer.uid ] = null;
                    // Execute Updates
                    // heap.track('Timer Discarded');
                    return firebase.database().ref().update(updates);
                }
            })

        }

        // runTimer
        //
        // runTimer's ONLY reason for existing is to provide a visual indicator of time elapsed.
        // it is not used to "count" time.
        //
        // runTimer relies on the local timeStamp (lastStart) for a timer's start/resume time to calculate and display total time elapsed (timer.approxAccrued).
        // When a timer is paused, the ACTUAL time elapsed (may be different by <1sec) is calculated based on server timestamps (for ensured accuracy.)
        // and is committed as the official timer.accrued.
        //
        // FYI: lastStart is logged with timer start events as "localWhen" and is also used to rebuild a running timer on page refresh or login from another browser


        function runTimer(){
             // $log.info('runTimer');
            // $log.info('runTimer');


            if(_.has(service, 'timerData.activeClient.clientColor')){
                var color = _.trim(service.timerData.activeClient.clientColor, '#');
                color = ajUTILITIES.lightenDarkenColor(color, +30);
                service.timerData.activeTimer.displayColor = '#' + color;
            }

            timerCounter = $interval(function() {
                // get local lastStart for timer
                if(_.has(service,'timerData.activeTimer.lastStart')){
                    // determine now
                    var rightNow = moment().format('x'),
                    lastStart = service.timerData.activeTimer.lastStart,
                    // calculate elapsed time
                    elapsed = Math.round((rightNow - lastStart)/1000),
                    // calculate approxAccrued
                    approxAccrued = service.timerData.activeTimer.accrued + elapsed;
                    // LOCALLY Update our bound display variable
                    service.timerData.activeTimer.approxAccrued = approxAccrued;
                    // $log.info('activeTimer accrued='+ service.timerData.activeTimer.approxAccrued)
                }
             }, 200, undefined, true);

            // Adding this because we need to refresh our user
            // he's losing .gates when timer is updated on timer start
            // vm.user is already bound to the service, we are just refreshing that variable
            return userDataService.getLoggedInUser(true);
        }

        function clearTimerData(){
            delete service.timerData.timerList;
            delete service.timerData.activeTimer;
        }

    } // end timerDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('timeReportService', timeReportService);

    /* @ngInject */
    function timeReportService($log, moment, taskDataService,
                userDataService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $interval, $firebaseArray, $firebaseObject) {
        var service = {
            report: [],
            getUsersTime: getUsersTime,
            getClientsTime: getClientsTime,
            getEveryClientsTime: getEveryClientsTime,
            setMonthList: setMonthList,
            setRetainerList: setRetainerList,
            setWeekList: setWeekList,
            returnClientsTime: returnClientsTime,
            init: init
        };

        init();
        return service;


        // Initialize service.timerData object
        function init(){
            var user = firebase.auth().currentUser;
            if (user){
                // define our state variable
                service.report.source = 'all'
                service.report.view = 'month';
                service.report.filter = "";
                service.report.start = moment().startOf('month').subtract(1, 'month').toDate();
                service.report.end = moment().endOf('month').toDate();
                // $log.info('Offset: ' + moment().format('Z ZZ'));
                // $log.info('start: ' + moment(service.report.start).toISOString());
                // $log.info('end:' + moment(service.report.end).toISOString());
                // service.setMonthList(service.report.end, service.report.start);
                // service.getUsersTime(userDataService.getUser().uid, service.report.end, service.report.start);
               // $timeout(function(){getTimers();}, 0);

              service.report.data = {};
              service.report.loading = false;
              service.report.selectedClient = 'all';
              service.report.selectedMember = 'all';
            }
        }


        // Returns all time logged by user (uid) between start and end.
        function getUsersTime(uid, end, start){
            // $log.info('getUsersTime');
            service.report.loading = true;
            var thisStart = moment(start).startOf('day').toISOString(),
                thisEnd = moment(end).endOf('day').toISOString(),
                timeRef = firebase.database().ref('time');
                // clear our data. it's causing problems
                service.report.data = [];
                $firebaseArray(timeRef.orderByChild("creator").equalTo(uid))
                  .$loaded(
                      function (data) {
                        var time = [];

                        _.each(data, function(entry){
                          var entryLogDate = moment(entry.logDate).startOf('day').toISOString();
                            if(entryLogDate >= thisStart && entryLogDate < thisEnd && !entry.flag){
                                time.push(entry);
                            }
                        });
                        $timeout(function(){
                             service.report.data = time;
                             service.report.loading = false;
                        }, 200);

            });

        }// getUsersTime


        function getEveryClientsTime(clients, end, start){
           var time = [];
           service.report.data = [];
           _.each(clients, function(client){
            // $log.info('processing client:' + client.uid);
              service.report.loading = true;
              var thisStart = moment.utc(start).startOf('day'),
                  // extending end by 1 month so we are sure to include current retainer period if this is a retainer report
                  thisEnd = moment.utc(end).endOf('day'),
                  // thisEnd = moment(end).add(1, 'month').toISOString(),
                  timeRef = firebase.database().ref('time');
              $firebaseArray(timeRef.orderByChild('client').equalTo(client.uid))
                .$loaded(
                    function (data) {
                      _.each(data, function(entry){
                          var entryLogDate = moment.utc(entry.logDate);
                          if(entryLogDate >= thisStart && entryLogDate < thisEnd && !entry.flag){
                              // $log.info(entryLogDate + ' is in between ' + thisStart + ' and ' + thisEnd);// $log.info(entry);
                              time.push(entry);
                          }
                      });

                });
           });// each client


            $timeout(function(){
                // $log.info(time);
                 service.report.data = time;
                 service.report.loading = false;
            }, 200);

        }// getEveryClientsTime

        // Assigns all time logged for a client (uid) between start and end to service
        function getClientsTime(uid, end, start){
            // $log.info('getClientsTime: ' + uid);
            // $log.info('Updating time...');
            // $log.info(moment(start).toISOString());
            // $log.info(moment(end).toISOString());
            service.report.loading = true;
            var thisStart = moment.utc(start).startOf('day'),
                // extending end by 1 month so we are sure to include current retainer period if this is a retainer report
                thisEnd = moment.utc(end).endOf('day'),
                // thisEnd = moment(end).add(1, 'month').toISOString(),
                timeRef = firebase.database().ref('time');
            service.report.data = [];
            $firebaseArray(timeRef.orderByChild('client').equalTo(uid))
              .$loaded(
                  function (data) {
                    var time = [];
                    _.each(data, function(entry){
                        var entryLogDate = moment.utc(entry.logDate);
                        if(entryLogDate >= thisStart && entryLogDate < thisEnd && !entry.flag){
                            // $log.info(entryLogDate + ' is in between ' + thisStart + ' and ' + thisEnd);// $log.info(entry);
                            time.push(entry);
                        }
                    });
                  $timeout(function(){
                      // $log.info(time);
                       service.report.data = time;
                       service.report.loading = false;
                  }, 200);

              });

        }// getClientsTime

        // Returns all time logged for a client (uid) between start and end to service
        // DOES NOT persist with service
        function returnClientsTime(uid, end, start){
            // $log.info('returnClientsTime');
            var thisStart = moment(start).startOf('day').toISOString(),
                // extending end by 1 month so we are sure to include current retainer period if this is a retainer report
                thisEnd = moment(end).endOf('day').add(1, 'month').toISOString(),
                timeRef = firebase.database().ref('time');
            service.report.data = [];
            $firebaseArray(timeRef.orderByChild("client").equalTo(uid))
              .$loaded(
                  function (data) {
                    var time = [];
                    _.each(data, function(entry){
                      var entryLogDate = moment(entry.logDate).startOf('day').toISOString();
                        if(entryLogDate >= thisStart && entryLogDate < thisEnd){
                            time.push(entry);
                        }
                    });
                    return time;
              });

        }// returnClientsTime

        // Returns an array of months (default 6 from end month unless start specified)
        function setMonthList(end, start){
            // $log.info('setMonthList');
            service.report.loading = true;
            var dateStart = moment(start);
            var dateEnd = moment(end);
            var months = [];

            //NOTE: Due to moment behavior, need to subtract 1 day from month end to get proper range.
            while (dateEnd > dateStart) {
                var month = {
                    name: moment(dateStart).format('MMMM YYYY'),
                    number: moment(dateStart).format('M'),
                    start: moment(dateStart).startOf('month').toISOString(),
                    end: moment(dateStart).endOf('month').toISOString(),
                    startLabel: moment(dateStart).format('MMMM D'),
                    endLabel: moment(dateStart).endOf('month').format('MMMM D, YYYY')
                }
                // $log.info('Month group:' + month.start + month.end);
               months.push(month);
               // dateStart.add(1,'month');
               dateStart = dateStart.add(1,'month').startOf('month');
            }
            // $log.info(months);
            $timeout(function(){
                 service.report.groups = months;
                service.report.loading = false;
            }, 200);
        }// setMonthList

        // Returns an array of months (default 6 from end month unless start specified and respecting Retainer monthly timeframes)
        function setRetainerList(uid, end, start){
            // var retainerStart = get retainerStart from client
            var retainerStart = undefined;
            var clientRef = firebase.database().ref('clients').child(uid);
            clientRef.once('value', function(snapshot){
              var client = snapshot.val();
              // if this is a retainer client and their retainerStart is set, use it
              if(_.has(client, 'profile.plan.retainerStart') && client.profile.plan.type == 'retainer'){
                retainerStart = client.profile.plan.retainerStart;
              } else {
                // otherwise, use the 1st of the month.
                retainerStart = 1;
              }


              start = moment(start).date(retainerStart).startOf('day');
              // make sure we extend the end date a month to include the current retainer period
              end = moment(end).add(1,'month').date(retainerStart-1).endOf('day');

              var months = [],
                  dateStart = moment(start),
                  dateEnd = moment(end);

              while (dateEnd > dateStart){
                var month = {
                    name: moment(dateStart).format('MMMM'),
                    number: moment(dateStart).format('M'),
                    start: moment(dateStart).date(retainerStart).toISOString(),
                    end: moment(dateStart).add(1,'month').date(retainerStart-1).endOf('day').toISOString(),
                    startLabel : moment(dateStart).date(retainerStart).format('MMMM D'),
                    endLabel: moment(dateStart).add(1,'month').date(retainerStart-1).format('MMMM D, YYYY')
                }
                // $log.info('adding month to retainerList:', month);
                months.push(month);
                dateStart = dateStart.add(1, 'month').date(retainerStart);
                $timeout(function(){
                    service.report.groups = months;
                    service.report.loadig = false;
                }, 200);
              }
            });// clientRef.once

        }// setRetainerList

        // Returns an array of weeks (default just end month unless start specified)
        function setWeekList(end, start){
            // $log.info('setWeekList');
            service.report.loading = true;
           var dateStart = moment(start);
           var dateEnd = moment(end);
           var weeks = [];

           while (dateEnd > dateStart) {
               var week = {
                   name: 'Week ' + moment(dateStart).week(),
                   number: moment(dateStart).week(),
                   start: moment(dateStart).startOf('week').toISOString(),
                   end: moment(dateStart).endOf('week').toISOString(),
                   startLabel: moment(dateStart).startOf('week').format('MMMM D'),
                   endLabel: moment(dateStart).endOf('week').format('MMMM D, YYYY')
               }
              weeks.push(week);
              dateStart = dateStart.add(1,'week').startOf('week');
           }
           $timeout(function(){
                service.report.groups = weeks;
               service.report.loading = false;
           }, 200);


        }// setWeekList

    } // end timeReportService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('timeDataService', timeDataService);

    /* @ngInject */
    function timeDataService($rootScope,gateService, $mdToast, $q, $log, moment, aggregateDataService, $mdDateLocale, localStorageService, $http, pageDimensionsService, taskDataService, userDataService, clientDataService, $mdMedia, $mdDialog, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            saveEntry: saveEntry,
            updateEntry: updateEntry,
            newLogEntry: newLogEntry,
            timeDialog: timeDialog,
            updateTotals: updateTotals,
            reCreateTotals: reCreateTotals,
            triggerReCalc: triggerReCalc,
            requestPDF: requestPDF,
            // startTimer: startTimer,
            getClientTime: getClientTime,
            getEntry: getEntry,
            deleteEntry: deleteEntry
        };

        return service;

        var timers = [];

        ///////////////////////////////////////////////////////////
        /// updateTotals
        // updates all log totals that a time entry might affect
        function updateTotals(timeEntry) {

            // $log.info('updateTotals');
            // $log.info(timeEntry);


            // if assigned to a task, update that task's total
            if (_.has(timeEntry, 'task')) {
                // $log.info('updating task totals');
                return taskDataService.getTask(timeEntry.task)
                        .then(function (task) {
                            // $log.debug('have task, calculating...');
                            // $log.debug(task);
                            var total = 0;
                            _.each(task.time, function (entry) {
                                total += entry.logged;
                            });

                            // $log.debug('total time:' + total);
                            // update single task property on /tasks and /clients/#/tasks/
                            var updates = {};

                            // store our canonical object
                            updates['/tasks/' + timeEntry.task + '/info/logged'] = total;

                            // store our reference in the client
                            updates['/clients/' + timeEntry.client + "/tasks/" + timeEntry.task + '/logged'] = total;

                            // Commit our updates
                            return firebase.database().ref().update(updates)
                        })
                        .then(function () {
                            // $log.info('updateTotals completed');
                        });

            }// if timeEntry.task

        }// updateTotals



        // Saves an empty 'deleteme' time log to a period to trigger that period's totals to be recalculated
        function triggerReCalc(period){
            // Create dummy time entry to trigger a calculation for this billingPeriod
            var newTimeKey = firebase.database().ref('/time').push().key,
                triggerEntry = {
                uid: newTimeKey,
                client: period.info.client,
                logDate: moment(period.info.start).add(1, 'day').toISOString(),
                flag: 'deleteMe',
                logged: 0
            };
            // Update the database with this period using the new key
            var updates = {};
            // Store our new time record
            updates['/time/' + newTimeKey] = triggerEntry;
            // Execute changes
            return firebase.database().ref().update(updates)
            .then(function(){
                // console.log('created period:' + results.billingPeriod.uid);
            });
        }

        //////////////////////////////////////////////////////////
        /// Re-Create Totals
        ///////////////////////////////////////////////////////////

        function reCreateTotals(clientData) {

//           var clientDataa = clientDataService.getClient(clientData.uid);
//            console.log('clientDataa');
//             console.log(clientDataa);

            var today = new Date();
            var year = today.getFullYear();

            var intervals = [];

            var retainer_total = [];

            // default retainerStart
            var RetainerStart = 1;

            /* Create Months Interval */
            // overwrite retainerStart if they have it set
            if(_.has(clientData.profile, 'plan.retainerStart')){
                RetainerStart = clientData.profile.plan.retainerStart;
            }


            for (var month = 1; month < 12; month++) {

                var retainerStartDate = year + "-" + month + "-" + RetainerStart;

                retainerStartDate = new Date(retainerStartDate);
                retainerStartDate = moment(retainerStartDate).format("YYYY-MM-DD");

                var retainerEndDate;

                var NextMonth = 1;

                if (month != 12) {
                    NextMonth = month + 1;
                }

                if (RetainerStart == 1) {
                    retainerEndDate = moment(retainerStartDate).endOf('month').format('YYYY-MM-DD');
                } else {
                    retainerEndDate = year + "-" + NextMonth + "-" + (parseInt(RetainerStart) - 1);
                    retainerEndDate = moment(retainerEndDate).format("YYYY-MM-DD");
                }

                intervals.push(retainerStartDate + "_" + retainerEndDate);
            }


            /* Recreate retainer Totols */
            getClientTime(clientData.uid, year)
                    .then(function (data) {

                        _.each(data, function (timeLog) {
                            var timeLogDay = timeLog.day,
                                    timeLogMonth = timeLog.month,
                                    timeLogYear = timeLog.year;

                            var TimeLogDate = moment(timeLogYear + "-" + timeLogMonth + "-" + timeLogDay).format("YYYY-MM-DD");

                            var monthCount = 1;

                            _.each(intervals, function (interval) {

                                var retainerDates = interval.split("_");

                                var intervalStart = retainerDates[0];
                                var intervalEnd = retainerDates[1];


                                if (TimeLogDate >= intervalStart && TimeLogDate < intervalEnd) {


                                    var timeLogslogged;

                                    if (timeLog.logged) {
                                        timeLogslogged = timeLog.logged;
                                    } else {
                                        timeLogslogged = 0;
                                    }

                                    /* Change the retainer time */

                                    if (retainer_total.hasOwnProperty(monthCount)) {

                                        /* Not Found */
                                        var tmpSum = retainer_total[monthCount]['minutes'];

                                        tmpSum = tmpSum + (parseInt(timeLogslogged));
                                        retainer_total[monthCount]['minutes'] = tmpSum;

                                    } else {
                                        retainer_total[monthCount] = {};
                                        retainer_total[monthCount]['minutes'] = (parseInt(timeLogslogged));
                                    }

                                }

                                monthCount++;
                            });
                        });
                    }).then(function () {

                var updates = {};

                if (retainer_total) {
                    updates['/clients/' + clientData.uid + '/retainer_totals/' + year + '/monthly'] = retainer_total;

                    // Commit clients retainer_totals updates
                    return firebase.database().ref().update(updates)
                            .then(function () {

                            });
                }
            });
        }

        ///////////////////////////////////////////////////////////
        /// startTimer
        // updates all log totals that a time entry might affect
        /// ** deprecated. timerDataService and our various directives handle this
        // function startTimer(task) {
        //     // $log.info('startTimer');
        //     // Future TODO - Check for current running timers and pause
        //     // Prepare a new timer
        //     var newTimer = newLogEntry(task.client, task.refID);
        //     // attach taskName and creatorName for easier viewing
        //     newTimer.taskName = firstLine(task.description);
        //     newTimer.creatorName = localStorageService.get('userName');
        //     // $log.debug('newTimer ready!', newTimer);
        //     // Future TODO - should actual create and start timer instead of open manual entry
        //     timeDialog(newTimer, newTimer.taskName);

        // }//startTimer

        ///////////////////////////////////////////////////////////
        /// getEntry
        // updates all log totals that a time entry might affect
        function getEntry(entryID) {
            // $log.info('getEntry');
            var entry = {},
                    d = $q.defer(),
                    entryRef = firebase.database().ref('time/' + entryID);
            return $firebaseObject(entryRef)
                    .$loaded(function (data) {
                        entry = data;
                        d.resolve(entry);
                        return d.promise;
                    })

        }//getEntry

        ///////////////////////////////////////////////////////////
        /// getClientTime
        // Get's all client time for the year specified
        function getClientTime(clientID, year) {
            // $log.info('getClientTime');
            var timeRef = firebase.database().ref('time/');
            return $firebaseArray(timeRef.orderByChild('loadGroup').equalTo(year + '_' + clientID))
                    .$loaded(function (time) {
                        return time
                    });

        }//getClientTime


        ///////////////////////////////////////////////////////////
        /// newLog
        // prepares a new empty log item
        function newLogEntry(clientID, taskID) {
            var userID = localStorageService.get('userID'),
                    logEntry = {
                        creator: userID,
                        creatorName: localStorageService.get('userName'),
                        client: clientID,
                        description: "",
                        timestamp: new Date(),
                        logDate: new Date()
                    }

            if (clientID) {
                logEntry.clientName = clientDataService.clientName(clientID);
                logEntry.clientColor = clientDataService.clientColor(clientID);
            }

            // $log.debug(logEntry);

            // if this is tied to a task
            if (taskID) {
                // store the task reference
                logEntry.task = taskID;
            }

            // heap.track('New logEntry Started');

            // $log.debug('prepared entry', logEntry);
            return logEntry
        }// newLog


        ///////////////////////////////////////////////////////////
        // firstline utility for creating our task reference
        function firstLine(taskDescription) {
            var firstLineText = taskDescription.split('\n')[0];
            // $log.debug(firstLineText);
            return firstLineText
        }

        ///////////////////////////////////////////////////////////
        /// saveEntry
        function saveEntry(timeEntry) {
            // $log.info('saveEntry');
            // IMPORTANT - we are validating requirement on the description field in the GUI via settings
            // BUT, for automatic CSV generation, we need a value here
            // SO, we are going to make sure it has one
            if(!timeEntry.description){
                timeEntry.description = "Time entry";
            }

            var logDate = {};
            logDate.longMonth = moment(timeEntry.logDate).format('MMMM');
            logDate.day = moment(timeEntry.logDate).format('DD');
            logDate.month = moment(timeEntry.logDate).format('M');
            logDate.year = moment(timeEntry.logDate).format('YYYY');
            logDate.week = moment(timeEntry.logDate).week();
            // $log.debug(logDate); // 1)

            timeEntry.longMonth = logDate.longMonth;
            timeEntry.week = logDate.week;
            timeEntry.year = logDate.year;
            timeEntry.month = logDate.month;
            timeEntry.day = logDate.day;
            if(_.has(userDataService.user, 'profile.avatar')){
                timeEntry.creatorAvatar = userDataService.user.profile.avatar;
            }


            // set single field for quicker firebaseArray querying by client/year
            timeEntry.loadGroup = logDate.year + "_" + timeEntry.client;

            // Fix our Log Amount
            var totalTime = 0;
            if (timeEntry.hours) {
                totalTime = totalTime + (timeEntry.hours * 60);
            }
            if (timeEntry.minutes) {
                totalTime = totalTime + (timeEntry.minutes * 1);
            }
            timeEntry.logged = totalTime;

            // get client color for the entry
            timeEntry.clientColor = clientDataService.clientColor(timeEntry.client);


            // get unique ID for the new entry
            var newEntryKey = firebase.database().ref().child('time').push().key;

            timeEntry.uid = newEntryKey;

            var updates = {};

            // store our canonical object
            updates['/time/' + newEntryKey] = timeEntry;

            // store our reference in the client
            // updates['/clients/' + timeEntry.client + "/time/" + logDate.year + '/' + logDate.month + '/' + newEntryKey] = timeEntry;

            // if we have a task reference, also store a copy there
            if (_.has(timeEntry, 'task')) {
                updates['/tasks/' + timeEntry.task + '/time/' + newEntryKey] = timeEntry;
            }

            // $log.info('Processing updates:');
            // $log.info(updates);
            // Commit our updates
            return firebase.database().ref().update(updates)
                    .then(function () {
                        // $log.info('saveEntry: updateTotals', timeEntry);
                        updateTotals(timeEntry);
                        aggregateDataService.timeCounter(timeEntry);

                         _dcq.push(["identify", {
                          email: userDataService.user.email,
                          tags: ["Logged Manual Time"]
                        }]);

                         if (_.has(timeEntry, 'task')) {
                         taskDataService.logTask(timeEntry.task, 'Time logged against task: ' + timeEntry.logged + ' minutes');
                        }

                    });

        }// saveEntry

        ///////////////////////////////////////////////////////////
        /// updateEntry
        // prepares a new empty log item
        function updateEntry(timeEntry) {
            // $log.debug('updateEntry');
            // IMPORTANT - we are validating requirement on the description field in the GUI via settings
            // BUT, for automatic CSV generation, we need a value here
            // SO, we are going to make sure it has one
            if(!timeEntry.description){
                timeEntry.description = "Time entry";
            }


            var saveEntry = angular.copy(timeEntry);
            // $log.debug(saveEntry);

            // Split our logDate for easy reports
            saveEntry.longMonth = moment(timeEntry.logDate).format('MMMM');
            saveEntry.day = moment(timeEntry.logDate).format('DD');
            saveEntry.month = moment(timeEntry.logDate).format('M');
            saveEntry.year = moment(timeEntry.logDate).format('YYYY');
            saveEntry.week = moment(timeEntry.logDate).week();

            // convert our logDate back to a string for Firebase
            saveEntry.logDate = moment(saveEntry.logDate).toISOString();

            // set single field for quicker firebaseArray querying by client/year
            saveEntry.loadGroup = saveEntry.year + "_" + saveEntry.client;


            // Fix our Logged Amount based on vm.hours and vm.minutes fields
            var totalTime = 0;
            if (saveEntry.hours) {
                totalTime = totalTime + (saveEntry.hours * 60);
            }
            if (saveEntry.minutes) {
                totalTime = totalTime + (saveEntry.minutes * 1);
            }
            saveEntry.logged = totalTime;

            // get client color for the entry
            timeEntry.clientColor = clientDataService.clientColor(saveEntry.client);


            // remove our temp variables used for collecting logtotal
            delete saveEntry.hours;
            delete saveEntry.minutes;

            // Remove the stuff that firebase hates
            delete saveEntry.$id;
            delete saveEntry.$priority;

            // this is where we will do our updating
            var updates = {};


            // store our canonical object
            updates['/time' + '/' + saveEntry.uid] = saveEntry;

            // store our client copy
            updates['clients/' + saveEntry.client + "/time/" + saveEntry.year + '/' + saveEntry.month + '/' + saveEntry.uid] = saveEntry;

            // if there's an associated task, update that as well
            if (saveEntry.task) {
                updates['tasks/' + saveEntry.task + '/time/' + saveEntry.uid] = saveEntry;
            }

            // Update our aggregate Totals
            aggregateDataService.timeCounter(saveEntry);

            // Execute our time entry updates
            // $log.debug('executing tie update');
            return firebase.database().ref().update(updates)
                    .then(function (response) {
                        // Call updateTotals to propagate our change to task and client
                        updateTotals(saveEntry);
                        if(_.has(saveEntry, 'task')){
                            taskDataService.logTask(saveEntry.task, 'Time entry modified');
                        }
                    });
        }// updateEntry

        ///////////////////////////////////////////////////////////
        /// deleteEntry
        function deleteEntry(entry) {
            // $log.info(entry);
            var entryID = entry.uid;
            var retainerMonth = entry.retainer_month;
            // $log.debug('deleteEntry');

            // Get our entry from the database (to make sure we are getting the correct dates and references)
            return getEntry(entryID)
                    .then(function (entry) {

                        // save our key properties so we can update our aggregates post-deletion
                        var oldEntry = {};
                        oldEntry.client = entry.client;
                        oldEntry.creator = entry.creator;
                        oldEntry.logged = entry.logged;
                        oldEntry.year = entry.year;
                        oldEntry.week = entry.week;
                        oldEntry.month = entry.month;
                        oldEntry.retainer_month = retainerMonth;

                        // Prepare updates to remove from /time, /tasks/#id/time, and client/time
                        var updates = {}

                        // remove our log from client
                        updates['/clients/' + entry.client + "/time/" + entry.year + '/' + entry.month + '/' + entry.uid] = null;

                        // Remove our log from task
                        if (entry.task) {
                            updates['/tasks/' + entry.task + '/time/' + entry.uid] = null;
                            // store our taskID so we can retotal it later.
                            var taskID = entry.task;
                        }

                        // remove our canonical object
                        updates['/time/' + entry.uid] = null;

                        // Execute Updates
                        // heap.track('Time Entry Deleted');
                        return firebase.database().ref().update(updates)
                                .then(function () {
                                    // Recalc task totals
                                    if (taskID) {
                                        // $log.debug('attached to a task...let\'s recalc the task');
                                        taskDataService.reCalcTask(taskID);
                                        taskDataService.logTask(taskID, 'Time deleted from task');

                                    }

                                    // Remove from clienttotals
                                    aggregateDataService.timeCounter(oldEntry, 'delete');

                                //     clientDataService.getClient(oldEntry.client)
                                //             .then(function (clientData) {

                                //                 if (clientData.profile.plan.type == 'retainer') {

                                //                     /* Update Retainer view */
                                //                     var RetainerMonths = clientDataService.thisRetainerYear(clientData);
                                //                     $rootScope.$emit('ratingUpdated', RetainerMonths);

                                //                     var RetainerWeeks = clientDataService.thisRetainerMonth(clientData, oldEntry.retainer_month);
                                //                     $rootScope.$emit('retainerWeeks', RetainerWeeks);
                                //                 }
                                //             });

                                });
                    });
        }// deleteEntry


        ///////////////////////////////////////////////////////////
        /// requestPDF
        // Takes report data and requests a PDF for it from the cloud

        function requestPDF(report){
          // $log.info('requestPDF - client time report');
          // $log.info(report);
          // remove $id and $priority from our time entries so we can process
          _.each(report.time, function(entry){
            ajUTILITIES.removePropertiesWith(entry);
          })
          var pdfRef = firebase.database().ref('pdfRequests'),
              pdfKey = pdfRef.push().key;

          report.uid = pdfKey
          var updates = {};
          updates['pdfRequests/'+ pdfKey] = report;
          return firebase.database().ref().update(updates)
                  .then(function () {
                      // $log.info('Time report pdfRequest sent');
                  });
        }// requestPDF



        ///////////////////////////////////////////////////////////
        /// timeDialog
        // opens dialog with the prepared log entry

        function timeDialog(timeEntry, title) {
            // $log.debug('timeDialog');
            // $log.debug(timeEntry, title);

            // $log.debug($rootScope.user.gates);
            return userDataService.getLoggedInUser()
            .then(function (user) {
                // $log.debug(user);
                var canLogTime = true;

                if (!title) {
                    var title = "Edit"
                }


                $mdDialog.show({
                    controller: timeDialogController,
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/timeDataService/dialog-edit-time-entry.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        timeEntry: timeEntry,
                        assignedClients: $rootScope.quickClients,
                        title: title,
                        canLogTime: canLogTime
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    fullscreen: true
                });

                // Set focus
                $timeout(function () {
                    // if this is a new task, put the focus on the description field
                    if (!timeEntry.uid) {
                        angular.element("textarea[name='hours']").focus();
                    }
                }, 100);
            })
        }; //end timeDialog



        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// timeDialogController

        /* @ngInject */
        function timeDialogController($scope, $mdDialog, timerDataService, $rootScope, hotkeys, $state, $stateParams, localStorageService, clientDataService, userDataService) {
            $log.debug('timeDialogController');

            var vm = this;
            vm.maxDate = new Date();
            vm.assignedClients = $rootScope.quickClients;
            vm.taskCandidates = undefined;
            // $log.debug('timeDialogController');
            vm.requireWorkDescription = false;
            vm.requireWorkDescription = userDataService.getUser().profile.settings.requireWorkDescription;
            vm.inputOptions = { updateOn: 'default blur',
                                     debounce: {
                                       default: 300,
                                       blur: 0
                                     }
                                };

            // store the original log total so we can compare and update totals correctly
            if(_.has(vm.timeEntry, 'logged')){
                vm.timeEntry.oldLogged = angular.copy(vm.timeEntry.logged);
            }


            // if we are editing an existing entry, take total logged minutes and split into hours and minutes for our form
            if(_.has(vm.timeEntry, 'uid')){
            vm.timeEntry.hours = Math.floor(vm.timeEntry.logged / 60);
            vm.timeEntry.minutes = vm.timeEntry.logged % 60;
            }
            // Set focus
            $timeout(function () {
                // if this is based on a timer and we already have time info, focus on the description field
                if(vm.timeEntry.hours > 0 || vm.timeEntry.minutes >0){
                    angular.element("textarea[name='description']").focus();
                    // otherwise, if there is a client already, focus on the minutes field
                } else if (vm.timeEntry.client) {
                    angular.element("input[name='minutes']").focus();
                }

                // if there's a task assigned, fill the description field
                if(_.has(vm.timeEntry, 'task')){
                    $scope.setTask(vm.timeEntry);
                }

            }, 100);

            $scope.setTask = function (timeEntry) {
                // $log.debug('setTask');
                // we just need to get the name for the ID that was just selected and assign it as well
                _.each(vm.taskCandidates, function (task) {
                    if (task.refID == timeEntry.task) {
                        timeEntry.taskName = task.description;
                        if(!timeEntry.description){
                            // trim it
                            timeEntry.description = _.truncate(task.description, {
                                          'length': 50,
                                          'separator': ' '
                                        });
                        }
                    }
                });
                //
            }// setClient

            $scope.setClient = function (clientID) {
                // $log.debug('setClient');
                return clientDataService.thisUsersClients(userDataService.user.uid)
                        .then(function (clients) {
                            _.each(clients, function (client) {
                                if (client.uid == clientID) {
                                    // update the model populating our task drop down.
                                    vm.taskCandidates = _.sortBy(client.tasks, [function(o) { return o.description; }]);
                                    vm.timeEntry.clientName = client.profile.fullName;
                                    // $log.debug(vm.taskCandidates);
                                }
                            })
                        })
                //
            }// setClient

            // setup our initial task drop down if we are starting new task from a client space page
            if (typeof $stateParams.clientID !== 'undefined') {
                $scope.setClient($stateParams.clientID);
            }

            // setup our initial task drop down if we are starting from a timer
            // setup our initial task drop down.
            if (_.has(vm.timeEntry, 'client')) {
                $scope.setClient(vm.timeEntry.client);
            }

            $scope.cancelDialog = function (timeEntry) {
                // $log.debug('$scope.cancelDialog');
                $mdDialog.cancel(timeEntry);
            };

            $scope.saveEntry = function (timeEntry) {
                // $log.info('timeDialogController: saveEntry');
                if (timeEntry.minutes > 0 || timeEntry.hours > 0){
                    saveEntry(timeEntry);
                    var message = "New Time Entry Saved.";
                   $mdToast.show($mdToast.adminjaAlert(
                       {
                           locals:{
                               title: 'New time log saved!',
                               message: '' ,
                               color: 'green'
                           }
                     }));// mdToast
                    // if a timer was attached to this entry, discard it. we are done now
                    if(_.has(timeEntry, 'timerID')){
                            timerDataService.discardTimer(timeEntry.timerID);

                    }
                    $rootScope.$emit('updateTimeReport');
                    $mdDialog.cancel(timeEntry);
                }

            }


            $scope.updateEntry = function (timeEntry) {
                return service.updateEntry(timeEntry)
                        .then(function () {

                            /* Get client data by client ID */
                            clientDataService.getClient(timeEntry.client)
                                    .then(function (clientData) {
                                        if (clientData.profile.plan.type == 'retainer') {
                                            /* update client's totals */
                                            service.reCreateTotals(clientData);
                                            // /* Update Retainer view */
                                            // vm.RetainerMonths = clientDataService.thisRetainerYear(clientData);
                                            // $scope.$emit('ratingUpdated', vm.RetainerMonths);

                                            // vm.RetainerWeeks = clientDataService.thisRetainerMonth(clientData, timeEntry.retainer_month);
                                            // $scope.$emit('retainerWeeks', vm.RetainerWeeks);

                                        }
                                    });

                            $scope.cancelDialog();
                            $rootScope.$emit('updateTimeReport');
                            $mdToast.show($mdToast.adminjaAlert(
                                {
                                    locals:{
                                        title: 'Time log updated!',
                                        message: '' ,
                                        color: 'green'
                                    }
                              }));// mdToast
                        });


            }// updateEntry

            vm.confirmDelete = false;
            $scope.startDelete = function(){
                // $log.info('startDelete');
                vm.confirmDelete = true;
            }

            $scope.cancelDelete = function(){
                vm.confirmDelete = false;
            }

            $scope.deleteTime = function (entry) {
                // $log.info('deleteTime');
                // $log.info(entry);
                $timeout(function(){
                    return service.deleteEntry(entry)
                            .then(function (response) {
                               $mdToast.show($mdToast.adminjaAlert(
                                   {
                                       locals:{
                                           title: 'Time Log deleted',
                                           message: '' ,
                                           color: 'orange'
                                       }
                                 }));// mdToast
                                $mdDialog.cancel(entry);
                                $rootScope.$emit('updateTimeReport');
                            });
                },0);
            }
            // We put the form on $scope.forms. so it's forced to attach to original instead of child scope
            // See name="forms.clientDialogForm" in dialog-client.html
            // https://stackoverflow.com/questions/22436501/simple-angularjs-form-is-undefined-in-scope
            $scope.forms = {};

            // Setup Hotkeys for this dialog
            hotkeys.bindTo($scope)
                    // inhibit enter from submitting
                    .add({
                        combo: 'enter',
                        callback: function (event) {
                            event.preventDefault();
                            // $log.debug('enter blocked');
                        }
                    })
                    .add({
                        combo: 'ctrl+enter',
                        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                        description: 'Save/Update Entry',
                        callback: function (event) {
                            // $log.debug('ctrl+enter');
                            event.preventDefault();
                            // $log.debug($scope.clientDialogForm);
                            var pristine = $scope.forms.timeDialogForm.$pristine,
                                    invalid = $scope.forms.timeDialogForm.$invalid;

                            if (!pristine && !invalid) {
                                $scope.updateEntry($scope.vm.timeEntry);
                            }

                            if (!pristine && !invalid) {
                                $scope.saveEntry($scope.vm.timeEntry);
                            }
                        }
                    })
                    // .add({
                    //     combo: 'shift+ctrl+enter',
                    //     allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    //     description: 'Save and add New',
                    //     callback: function (event) {
                    //         // $log.debug('shift+ctrl+enter');
                    //         event.preventDefault();
                    //         // $log.debug($scope.clientDialogForm);
                    //         var pristine = $scope.forms.timeDialogForm.$pristine,
                    //                 invalid = $scope.forms.timeDialogForm.$invalid

                    //         if (!pristine && !invalid) {
                    //             // $scope.saveUpdatedTask($scope.vm.editedItem);
                    //         }

                    //         if (!pristine && !invalid) {
                    //             var andNew = true;
                    //             // $scope.saveNewTask($scope.vm.editedItem, andNew);
                    //         }
                    //     }
                    // })
                    ;

        }
        ; // end timeDialogController

    } // end timeDataService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('teamInviteDialogController', teamInviteDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// teamInviteDialogController

        /* @ngInject */
        function teamInviteDialogController($scope, $q, $mdDialog, $log, $timeout, $mdToast, teamDataService, gateService) {
            // $log.info('teamInviteDialogController');
            var vm = this;
            // owner already defined when opening dialog
            vm.owner = vm.locals.owner;
            vm.numMembers = vm.locals.numMembers;
            // Get our client limit
            vm.gateService = gateService;
            vm.teamLimit = vm.gateService.gateData.teamLimit;

            function init(){
                // Get all of the info we'll need to send invites
                // get our team limit


            } // init

            init();


            vm.saveInvite = function(email){
                // make sure member isn't already on our team
                var sendInvite = true;
                _.each(teamDataService.team, function(member){
                    $log.info(member.email);
                    if(member.email == email){
                        sendInvite = false;
                    }
                });

            if(sendInvite){
                return teamDataService.inviteMember(email)
                .then(function(){
                  vm.inviteEmail = undefined;
                  vm.cancelDialog();
                  $mdToast.show($mdToast.adminjaAlert(
                      {
                          locals:{
                              title: 'Invitation Sent',
                              message: 'Your invitation to ' + email + ' is on it\'s way!',
                              color: 'green'
                          }
                      }));
                })
            } else {
                vm.inviteEmail = null;
                alert('Sorry, a person with that email is already on your team!');
            }

    }// vm.saveInvite



            vm.cancelDialog = function(){
                $mdDialog.cancel();
            };
        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('teamDataService', teamDataService);

    /* @ngInject */
    function teamDataService($log, moment, localStorageService,
                userDataService, gateService, clientDataService, notificationService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $interval,hotkeys, triLoaderService, triMenu, $firebaseArray, $firebaseObject, $q, $window) {

        var service = {
            getUsersTeam: getUsersTeam,
            getUsersTeams: getUsersTeams,
            getOwnersTeamList: getOwnersTeamList,
            getClientTeams: getClientTeams,
            getClientTeamList: getClientTeamList,
            selectTeamMember: selectTeamMember,
            getMemberName: getMemberName,
            selectUser: selectUser,
            inviteDialog: inviteDialog,
            inviteMember: inviteMember,
            revokeInvite: revokeInvite,
            resendInvite: resendInvite,
            acceptInvite: acceptInvite,
            declineInvite: declineInvite,
            initializeTeam: initializeTeam,
            hasAccess: hasAccess,
            canViewClient: canViewClient,
            isAdmin: isAdmin,
            getOwner: getOwner,
            setMemberAccess: setMemberAccess,
            changeMemberStatus: changeMemberStatus,
            removeMember: removeMember,
            saveMemberNote: saveMemberNote,
            updateMember: updateMember,
            deselectMember: deselectMember,
            init: init

        };

        return service;


        // Setup service.team and service.teams objects
        function init(){
            $log.info('setup Teams');
            var user = firebase.auth().currentUser;
            if (user){
                // Remove any previous data
                // delete service.team
                // delete service.teams
                // delete service.teamList
                // delete service.clientTeams

                // the quietRebuild flag tells the function to replace the array
                // with new data. This is smoother than deleting it and then simply
                // running the functions with empty arrays.
                var quietRebuild = true;

                // Load in a timeout so we render properly
               $timeout(function(){
                // get all members belonging to this user's team
                getUsersTeam(quietRebuild);
                // get all other teams this member belongs to
                getUsersTeams(quietRebuild);
                // compile our quick teamList for menus and stuff
                getOwnersTeamList(quietRebuild)
                // build array of a client teams for this user's clients
                getClientTeams(quietRebuild)

            }, 0);

            }
        }

        function deselectMember(){
            delete service.selectedMember;
            delete service.selectedUser;
        };

        // build an array of teams from assigned clients keyed by clientID for quick and easy access
        // in our drop downs and comments
        function getClientTeams(quietRebuild){
            // $log.info('getClientTeams');
            // Run our chain of operations
            // var clientsRef = firebase.database().ref().child('/clients');


            var clientTeams = [];
            _.each($rootScope.quickClients, function(client){
                    var thisTeam = {};
                    var ownersTeamRef = firebase.database().ref('teams/' + client.owner);
                    var teamRef = firebase.database().ref('clients/' + client.uid  +'/access/users');
                    var ownersTeam = undefined;
                    ownersTeamRef.once('value', function(snapshot){
                        // store the owners team so we can combine info there with our user info
                        ownersTeam = snapshot.val();
                    })
                    .then(function(){
                        // Get the team data
                        teamRef.once('value', function(snapshot){
                             var team = snapshot.val();
                             _.each(team, function(value, key){

                                var thisMember = {};

                                // get the user info and put it on our member
                                var userRef = firebase.database().ref('users/' + key);
                                userRef.once('value').then(function (snapshot) {
                                    // The first promise succeeded. Save snapshot for later.
                                   var user = snapshot.val();
                                   if(_.has(user, 'profile')){
                                        // Go through this user's teams and pull out colors
                                       // / attach properties to member
                                       thisMember.profile = user.profile;
                                       thisMember.email = user.email;
                                       thisMember.uid = key;
                                   }// if user found
                                   if(_.has(ownersTeam, 'members')){
                                     // Get the teamOwners info and start our new member
                                     // go through our ownersTeam and pop in that info
                                    _.each(ownersTeam.members, function(member){
                                     if (member.uid == thisMember.uid){
                                         if(_.has(member, 'clients')){
                                             thisMember.clients = member.clients;
                                         }
                                         if(_.has(member,'color')){
                                             thisMember.color = member.color;
                                         }
                                         thisMember.role = member.role;
                                         thisMember.status = member.status;
                                     }// if member.uid matches
                                    });// each ownersTeam
                                    // put it on thisTeam
                                    thisTeam[key]=thisMember;
                                   }// if owner has a team
                                });// userRef.once
                             });// each teammember
                        });// teamRef.once
                    })
                    // put the array of clientTeams on the service
                    clientTeams[client.uid] = thisTeam;
            });// each client

            service.clientTeams = clientTeams;
            // $log.info('clientTeams Completed:');
            // $log.info(service.clientTeams);
        }// getClientTeams

        function canViewClient(userID, clientID){
          var thisClientsTeam = service.clientTeams[clientID],
              thisUserAsMember = thisClientsTeam[userID];
            // Only check if we are dealing with a team member (i.e. solo accounts don't apply herer)
            if(_.has(thisUserAsMember, 'status')){
              // Only allow "active" members through
              if(thisUserAsMember.status == 'active'){
              return true
              } else {
                return false
              }
            } // if we are actually dealing with a team member
            else {
              // must be a solo account. allow it
              return true
            }
        }// canViewClient

        function getUsersTeam(quietRebuild) {
            // $log.info('getUsersTeam');
            if(_.size(service.team > 0) && !quietRebuild ){
                // we already have timers. returning
                return service.team
            } else {
                // we can't use the simpler user = userDataService.user here for some reason.
                // and hey, why not make sure we are 100% accurate?
                return userDataService.getLoggedInUser()
                .then(function(user){
                    // $log.info('user:');
                    // $log.info(user);
                    var teamRef = firebase.database().ref('teams').child(user.uid).child('members');
                    // Get the team data
                    $firebaseArray(teamRef)
                    .$loaded(
                        // we need to do this manually it seems. Not sure why. No biggie. It's still bound
                        function(members) {
                            service.team = members;

                            return service.team
                        });

                });
            }
        } // getUsersTeam

        // getUsersTeams - all of the TEAMS THIS USER IS ON//
        // quietRebuild flag forces a rebuild without deleting first (which causes a UI reset);
        function getUsersTeams(quietRebuild) {
            // $log.info('getUsersTeams');
            if(_.size(service.teams > 0) && !quietRebuild){
                // we already have timers. returning
                return service.teams
            } else {
                // we can't use the simpler user = userDataService.user here for some reason.
                // and hey, why not make sure we are 100% accurate?
                return userDataService.getLoggedInUser()
                .then(function(user){
                    var teamsRef = firebase.database().ref('teams');
                    var tempTeams = [];
                    // Get the team data
                    $firebaseArray(teamsRef.orderByChild('members/' + user.uid + '/uid').equalTo(user.uid))
                    .$loaded(
                        function(teams) {

                            _.each(teams, function(team){
                                tempTeams.push(team);
                            }); // each team

                            // if we've been assigned to a team, we should have a timer
                            if(tempTeams > 0 ){
                               $timeout(function(){
                                gateService.setGate('canUseTimer', true);
                            },0);
                            }
                        });
                    service.teams = tempTeams
                    return service.teams
                });
            }
        } // getUsersTeam


        // Get's an owners full teamlist (rather than for individual clients as above)
        function getOwnersTeamList(force){
            if (_.size(service.teamList > 0) && !force){
                return service.teamList
            } else {
                // if we want to force a rebuild. we need to remove existing one by one,
                // not delete the whole node and rebuild
                // if(force){
                //     // we just want to refresh the array, not remove it and lose our bindings
                //     // $log.info('removing items from teamList for a refresh');
                //     service.teamList.length = 0;
                //     // $log.info(service.teamList);
                // } else {
                //     // starting fresh
                //     service.teamList = [];
                // }

                 var teamRef = firebase.database().ref('teams').child($rootScope.userID).child('members');
                // Get the team data
                //  var teamList = [];
                // teamRef.once('value', function(snapshot){
                //  var team = snapshot.val();
                //  _.each(team, function(member){
                //    // make sure they are active
                //   if(member.status != 'something'){
                //    // get the user info and put it on our member
                //    var userRef = firebase.database().ref('users/' + member.uid);
                //    userRef.once('value').then(function (snapshot) {
                //        // The first promise succeeded. Save snapshot for later.
                //       var user = snapshot.val();
                //       if(_.has(user, 'profile')){
                //           // / attach properties to member
                //           member.profile = user.profile;
                //           member.email = user.email;
                //       }// if user found

                //       teamList.push(member);

                //    });// userRef.once
                //  }// if active
                //  });// each team member
                //  // $log.info(vm.teamList);
                // });// teamsRef
                // service.teamList = teamList;
                // return service.teamList;
            }
        }// getOwnersTeamList

        // couldn't get this to work for populating drop downs.
        // had to move the code into each controller (duplicating it)
        // TODO - ask MO what I'm doing wrong (it's promises I'm sure.)
        function getClientTeamList(clientID){
            // we are having trouble returning this complicated object to our controllers.
            // using $rootScope as a workaround for now. Sorry best practices. :(
            $rootScope.currentTeamList = [];
           var clientRef = firebase.database().ref('clients/' + clientID + '/owner');
           return clientRef.once('value', function(snapshot){
               var ownerID = snapshot.val();
               var teamRef = firebase.database().ref('teams/' + ownerID  +'/members');
               // Get the team data
                var teamList = [];
               teamRef.once('value', function(snapshot){
                var team = snapshot.val();
                _.each(team, function(member){
                  // make sure they are active
                 if(member.status == 'active' && service.hasAccess(member, clientID)){
                  // get the user info and put it on our member
                  var userRef = firebase.database().ref('users/' + member.uid);
                  userRef.once('value').then(function (snapshot) {
                      // The first promise succeeded. Save snapshot for later.
                     var user = snapshot.val();
                      // attach properties to member
                         member.profile = user.profile;
                         member.email = user.email;

                         $rootScope.currentTeamList.push(member);
                  });// userRef.once
                }// if active
                });// each team member
                // $log.info(vm.teamList);
               });// teamsRef
           });// clientsRef

        }// getClientTeamList

        function hasAccess(member, clientID){
            var found = false;
            // If status == 'active' && this client is in member.client[clientID]
            if(member.status == 'active'){
              if(_.has(member, 'clients')){
                  if(member.clients[clientID]){
                      found = true;
                  }
              }// if has clients
            }

            if(member.role == 'owner'){
                found = true;
            }
            return found
        }// hasAccess

        function isAdmin(member, clientID){
            var found = false;
            // go through member/clients and see if this ID found
            if(_.has(member, 'clients')){
                if(member.clients[clientID] == 'admin'){
                    found = true;
                }
            }// if has clients
            return found
        } // isAdmin



        function getOwner(clientID){
            var clientRef = firebase.database().ref('clients/' + clientID + '/owner');
            return clientRef.once('value', function(snapshot){
                var ownerID = snapshot.val();
                return ownerID
            });
        } // isAdmin

        function getMemberName(memberID){

        }// getMemberName
        ////////////////////////////////////////////////
        // Functions mainly to facilitate state in member detail panel

        function selectTeamMember(member){
            delete service.selectedMember;
            $timeout(function(){
                service.selectedMember = member;
            },0);
        }

        // when displaying full team member detail, we need all of the
        // data at their user node.
        // this allows us to handle it via the service
        function selectUser(user){
            delete service.selectedUser;
            service.selectedUser = user;
        }

        function selectTeam(team){
            service.selectedTeam = team;
        }

        function changeMemberStatus(member, teamID){
          var memberCopy = angular.fromJson(angular.toJson(member)),
              updates = {};

          updates['teams/' + teamID + '/members/' + memberCopy.uid + '/status/'] = memberCopy.status;

          // if we are disabling, also remove all client references
          if(memberCopy.status == 'disabled'){

            // Archiving this member - remove asisgnment from all clients as well
            if(_.has(memberCopy, 'clients')){
              _.each(memberCopy.clients, function(value, key){
                updates['teams/' + teamID + '/members/' + memberCopy.uid + '/clients/' + key] = null;
                updates['clients/' + key + '/access/users/' + memberCopy.uid] = null;
                updates['clients/' + key + '/access/admins/' + memberCopy.uid] = null;
              });
            }// if hasClients
          }// if disabling

          // make our changes
          return firebase.database().ref().update(updates)
                  .then(function () {
                    $timeout(function(){
                    clientDataService.setupClientMenu(true);
                  }, 1000)

                  });

        }// changeMemberStatus


        function removeMember(member, teamID){
          // first we disabled the member (removing all references from clients)
          var memberCopy = angular.fromJson(angular.toJson(member));
          memberCopy.status = 'disabled';
          return service.changeMemberStatus(memberCopy, teamID)
          .then(function(){
            // next we remove the member from our team
            var memberRef = firebase.database().ref('/teams/' + teamID + '/members/' + memberCopy.uid);
            memberRef.set(null);
          });
        }// removeMember

        function saveMemberNote(member, teamID){
            var memberRef = firebase.database().ref('/teams/' + teamID + '/members/' + member.uid);
            memberRef.child('notes').set(member.notes);
        }

        function updateMember(member){
            var memberCopy = _.clone(member);
            ajUTILITIES.removePropertiesWith(memberCopy);
            var updates = {};
            updates['teams/'+ member.owner + '/members/' + member.uid] = memberCopy;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        service.init();
                    });
        }

        function setMemberAccess(member, clientID, teamID, access){
            // triLoaderService.setLoaderActive(true);
            // Update the reference on the team
            var memberRef = firebase.database().ref('teams/' + teamID + '/members/' + member.uid + '/clients');

            var updates = {};
            if (access != 'none'){
                // add them to team list and add them to users list
                updates['teams/' + teamID + '/members/' + member.uid + '/clients/' + clientID] = access;
                updates['clients/' + clientID + '/access/users/' + member.uid] = true;

                // if admin, add to admin list
                if(access=='admin'){
                    updates['clients/' + clientID + '/access/admins/' + member.uid] = true;
                } else {
                    // otherwise, make sure removed from admin list
                    updates['clients/' + clientID + '/access/admins/' + member.uid] = null;
                }
            } else {
                // if 'none', remove from user's client list and remove user and admin access to this client
                updates['teams/' + teamID + '/members/' + member.uid + '/clients/' + clientID] = null;
                updates['clients/' + clientID + '/access/users/' + member.uid] = null;
                updates['clients/' + clientID + '/access/admins/' + member.uid] = null;
            }

            // make our changes
            return firebase.database().ref().update(updates)
                    .then(function () {

                        // I hate that I'm doing something with the GUI here but it's necessary
                        // Re-initialize our team

                        $timeout(function(){
                            // clientDataService.setupClientMenu(true);
                            // triLoaderService.setLoaderActive(false);
                        },1000);


                        // $log.info('sorted');
                        return clientDataService.getClient(clientID)
                        .then(function(thisClient){

                            // $log.info(thisClient);
                            var customTitle = undefined, customMessage = undefined, sendMessage = false;

                            if(access == 'none'){
                                sendMessage = true;
                                customTitle = "Goodbye!";
                                customMessage= "You've been removed from " + thisClient.profile.fullName + "'s team";
                            }
                            if(access == 'member'){
                                sendMessage = true;
                                customTitle = "Welcome!";
                                customMessage= "You've been added to <a href='/#/clients/" + thisClient.uid + "'>" + thisClient.profile.fullName + "</a>'s team";
                            }
                            if(access == 'admin'){
                                sendMessage = true;
                                customTitle = "Congrats!";
                                customMessage= "You've been made an admin for <a href='/#/clients/" + thisClient.uid + "'>" + thisClient.profile.fullName + "</a>'s team";
                            }
                            // Bryan - fix this notificaiton with the right message/info
                            if (sendMessage){
                                var notification = {
                                    title: customTitle,
                                    message: customMessage,
                                    meta: 'Assignement Change',
                                    type: 'clientAssignment',
                                    assignee: member.uid,
                                    related: thisClient.uid
                                  }
                                notificationService.notify(notification);
                            }// if sendMessage
                        })


                    });

        }

        ///////////////////////////////////////////////////////////
        /// inviteDialog
        // opens team invitation dialog

        function inviteDialog(user, numMembers) {

                $mdDialog.show({
                    controller: 'teamInviteDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/teamDataService/dialog-invite-team-member.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        owner: user,
                        numMembers : numMembers
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });

        }
        ; //end inviteDialog


        ///////////////////////////////////////////////////////////
        /// inviteMember
        // opens team invitation dialog

        function inviteMember(email) {
            var user = userDataService.getUser();
            // Create our invitation
            var newInviteKey = firebase.database().ref('teamInvites').push().key,
                invitation = {
                  'invitee': email,
                  'owner' : user.uid,
                  'ownerName' : user.profile.fullName,
                  'ownerEmail': user.email,
                  'status': 'new',
                  'timeStamp' : moment().toISOString(),
                  'expire': moment().add(10, 'days').toISOString(),
                  'uid': newInviteKey
              }
            var updates = {};
            updates['teamInvites/' + newInviteKey ] = invitation;
            // Execute our update
            return firebase.database().ref().update(updates)
            .then(function(){
                return
            });

        }
        ; //end inviteMember

        function revokeInvite(member){
            // change status to revoked
            var inviteRef = firebase.database().ref('teamInvites/' + member.invitationID);
            inviteRef.child('status').set('revoked');
        }// revokeInvite

        function resendInvite(member){
            // change status to resend - adjust cloud function to reset date and re-notify
            var inviteRef = firebase.database().ref('teamInvites/' + invitation.uid);
            inviteRef.child('status').set('resend');
        }// resendInvite

        function acceptInvite(invitation, newUserID){
            // $log.info('teamDataService.acceptInvite');
            // $log.info(invitation);
            // if we are accepting from a notification, we should use the related chld for our inviteID
            // if we are accepting from an email or other, we should use the UID
            var inviteID = undefined;
            if(!_.has(invitation, 'related')){
              inviteID = invitation.uid
            } else {
              inviteID = invitation.related
            }
            var inviteRef = firebase.database().ref('teamInvites/' + inviteID);

            // if this is a new user, update the invite with the userID
            // and a flag to tell CFN to process it differently
            if(newUserID){
              inviteRef.child('isNewUser').set(true);
              inviteRef.child('inviteeUID').set(newUserID)
            }
            // Set our status to active and trigger cloud function to complete acceptance
            inviteRef.child('status').set('active');


        }// acceptInvite

        function declineInvite(invitation){
            // $log.info('teamDataService.declineInvite');
            // if we are declining from a notification, we should use the related chld for our inviteID
            // if we are declining from an email or other, we should use the UID
            var inviteID = undefined;
            if(!_.has(invitation, 'related')){
              inviteID = invitation.uid
            } else {
              inviteID = invitation.related
            }
            var inviteRef = firebase.database().ref('teamInvites/' + inviteID);
            inviteRef.child('status').set('declined');
        }// acceptInvite

        function initializeTeam(owner, name){
            $log.info('teamDataService', owner, name);
            var ownerID = owner.uid;
            // Create our fresh team object
            var newTeam = {
                'ownerEmail': owner.email,
                'ownerID': owner.uid,
                'ownerName': owner.profile.fullName,
                'name': name
            }
            newTeam.members = {};

            newTeam.members[ownerID] = {
                'becameMember': moment().toISOString(),
                'color': "#0000e0",
                'email': owner.email,
                'owner': owner.uid,
                'role': 'owner',
                'status': 'active',
                'uid': owner.uid
            }

            var updates = {};
            updates['/teams/' + owner.uid] = newTeam;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        return
                    });
        }

    } // end teamDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('taskTemplateDataService', taskTemplateDataService);

    /* @ngInject */
    function taskTemplateDataService($mdToast, $q, $log, gateService, userDataService, localStorageService, $http, pageDimensionsService, $mdMedia, $mdDialog, $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            newTaskTemplate: newTaskTemplate,
            getClientTaskTemplates: getClientTaskTemplates,
            getTaskTemplate: getTaskTemplate,
            taskTemplateDialog: taskTemplateDialog,
            saveNewTaskTemplate: saveNewTaskTemplate,
            deleteTaskTemplate: deleteTaskTemplate,
            updateTaskTemplate: updateTaskTemplate
        };

        return service;



        //////////////////////////
        // New task
        function newTaskTemplate(clientID) {
            // $log.info('taskTemplateDataService.newTaskTemplate');
            // $log.info('newTaskTemplate for client:' + clientID);
            // $log.info(clientID);
            var userID = userDataService.user.uid,
                task = {
                    type: 'template',
                    creator: userID,
                    isRecurring: false,
                    info: {
                        client: clientID,
                        assignee: userID,
                        logged: 0,
                        status: 'open',
                        budget: 0,
                        description: '',
                        numnotes: 0,
                        created: Date.now()
                    },
                    schedule: {
                        dueDays: 0
                    }
                }

            // heap.track('New Task Template Started');

            // $log.info(task);
            return task
        }

        ///////////////////////////
        // getClientTaskTemplates
        function getClientTaskTemplates(clientID) {
            var tasksRef = firebase.database().ref('taskTemplates/');
            return $firebaseArray(tasksRef.orderByChild('info/client').equalTo(clientID))
                    .$loaded(function (tasks) {
                        return tasks
                    });
        }; // end getClientTaskTemplates


        ///////////////////////////////////////////////////////////
        /// taskTemplateDialog
        // opens dialog with the prepared editedItem

        function taskTemplateDialog(editedItem, selectedTab) {
            return userDataService.getLoggedInUser()
            .then(function(user){
                var canLogTime = gateService.gateData.canLogTime;
                // $log.info('taskTemplateDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: taskTemplateDialog');
                var clientColor;
                var newNote; // just need to declare it so our in-dialog note form has a model to work from

                // if we already have a client assigned, pass along the color.
                // otherwise, pass an empty string.
                if (editedItem.info.client) {
                    // editing an existing task
                    // editing an existing task
                    var selectedClient = _.find($rootScope.quickClients, function (client) {
                        return client.uid == editedItem.info.client;
                    });
                    if (_.has(selectedClient, 'clientColor')) {
                        clientColor =  selectedClient.clientColor;
                    }
                } else {
                    // creating a new task
                    clientColor = '#aaa'; // Not used. just to avoid an undefined error.
                }

                $mdDialog.show({
                    controller: 'taskDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-task.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        editedItem: editedItem,
                        assignedClients: $rootScope.quickClients,
                        clientColor: clientColor,
                        newNote: newNote,
                        tags: $rootScope.tags,
                        selectedTab: selectedTab,
                        canLogTime: canLogTime
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });

                // Set focus
                $timeout(function () {
                    // if this is a new task, put the focus on the description field
                    if (!editedItem.uid) {
                        var taskDescription = angular.element("textarea[name='description']");
                        // if this is an empty field, just put the cursor there
                        if (!taskDescription[0].value) {
                            taskDescription.focus();
                            // taskDescription.setSelectionRange(0, 0);
                            // if we've been passed a value put the cursor at the top of the field ready to edit
                        } else if (taskDescription[0].value) {
                            // todo: this doesn't work in chrome anymore for some reason and needs rewritten
                            // http://stackoverflow.com/questions/21572682/createtextrange-is-not-working-in-chrome
                            var range = taskDescription.createTextRange();
                            range.moveStart('character', 0);
                            range.select();
                        }


                    }
                }, 100);
            });



        }
        ; //end taskTemplateDialog

        ///////////////////////////////////////////////////////////
        /// getTaskTemplate
        function getTaskTemplate(taskID) {
            // $log.info('getTaskTemplate:' + taskID);
            var task = {},
                    taskRef = firebase.database().ref('taskTemplates/' + taskID);
            return $firebaseObject(taskRef)
                    .$loaded(function (data) {
                        task = data
                        // $log.info(task);
                        return task
                    })
        }
        ; // end getTaskTemplate

        ///////////////////////////////////////////////////////////
        /// saveNewTaskTemplate
        function saveNewTaskTemplate(task) {
            // $log.info('saveNewTaskTemplate');
            // $log.info(task);
            var taskCopy = angular.copy(task),
                    firstNote = undefined;
            if (taskCopy.duedate) {
                taskCopy.duedate = taskCopy.duedate.toISOString();
            }

            if(_.has(taskCopy, 'schedule.startOn')){
                // $log.info(taskCopy.schedule.startOn); // in unix
                // $log.info('Saving...has starton:' + moment.unix(taskCopy.schedule.startOn).toISOString()); // show us in ISO
                // taskCopy.schedule.startOn = moment(task.schedule.startOn).unix(); //
                // $log.info('starton converted to:' + moment.unix(taskCopy.schedule.startOn).toISOString());
            }

            // console.log('savetask');
            // $log.info(task);
            var newTaskTemplateKey = firebase.database().ref().child('taskTemplates/').push().key;
            // put our $id as a property for easier retrieval
            taskCopy.uid = newTaskTemplateKey;
            taskCopy.info.refID = newTaskTemplateKey;

            // add our task to the new key
            var updates = {};
            updates['/taskTemplates/' + newTaskTemplateKey] = taskCopy;
            updates['/clients/' + taskCopy.info.client + '/taskTemplates/' + newTaskTemplateKey] = taskCopy;

            // make the update
            return firebase.database().ref().update(updates)
                    .then(function () {

                        $mdToast.show($mdToast.adminjaAlert(
                            {
                                locals:{
                                    title: "New Task Template Added",
                                    message: 'You\'ll find it in your Recurring tab',
                                    color: 'green'
                                }
                            }));
                        // heap.track('New Task Template Saved');
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                        }, 500);
                        Appcues.identify(task.creator, {
                            hasTaskTemplates: true
                        });

                        $rootScope.$broadcast('taskTemplateChanged');
                    });

        }
        ; // end saveNewTaskTemplate

        ///////////////////////////////////////////////////////////
        /// deleteTaskTemplate
        function deleteTaskTemplate(item) {
            // $log.info('deleteTaskTemplate');
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                    .title('PERMANENTLY delete this task template?')
                    .textContent(item.description)
                    .ariaLabel('Delete Task? Y//N')
                    .targetEvent(item)
                    .ok('Yes, Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm)
                    .then(function () {
                        // remove our client's reference
                        return firebase.database().ref().child('/clients/' + item.info.client + '/taskTemplates/' + item.uid).remove()
                        .then(function () {
                            // Locate the task record in our tasks array
                            return firebase.database().ref().child('/taskTemplates/' + item.uid).remove();
                        })
                        .then(function () {
                            $mdDialog.hide();
                            $mdToast.show($mdToast.adminjaAlert(
                                {
                                    locals:{
                                        title: "Task Template deleted.",
                                        message: '',
                                        color: 'red'
                                    }
                                }));

                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                            }, 500);
                        });
                    });

            // heap.track('Task Template Deleted');
        }
        ; // end deleteTaskTemplate

        ///////////////////////////////////////////////////////////
        /// updateTaskTemplate
        function updateTaskTemplate(task) {
            var taskCopy = angular.fromJson(angular.toJson(task));

            // convert our date into a string for storing

            if (taskCopy.info.duedate) {
                taskCopy.info.duedate = moment(taskCopy.info.duedate).toISOString();
            }

            var updates = {};

            // // // remove things that firebase provides
            ajUTILITIES.removePropertiesWith(taskCopy);

            // // store our modified object
            updates['/taskTemplates/' + taskCopy.uid] = taskCopy;
            updates['/clients/' + taskCopy.info.client + '/taskTemplates/' + taskCopy.uid] = taskCopy;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        // Make sure our columns adjust to new/removed items
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                        }, 500);
                    });

            // heap.track('Task Template Updated');
        }
        ; //end updateTaskTemplate


    } // end taskTemplateDataService
})();

(function() {
    'use strict';


    angular.module('appServices')
        .service('taskPanelDataService', taskPanelDataService);

    /* @ngInject */
    function taskPanelDataService($log, $http, $injector, pageDimensionsService, $mdToast, $firebaseArray, $firebaseObject, $mdMedia, $mdDialog, $rootScope, $timeout, $window) {
        var service = {
            newPanel: newPanel,
            editPanel: editPanel,
            createPanel: createPanel,
            deletePanel: deletePanel,
            saveUpdatedPanel: saveUpdatedPanel,
            importPanel: importPanel

        };

        return service;


        ///////////////////////////////////////////////////////////
        /// editPanel
        function editPanel(panel) {
        var editPanel = angular.copy(panel),
            clientID = panel.client;


            var hasCards = false;

            if ($( ".app-item-container-items[panelid='" +panel.uid + "']").find('md-card').length){
               hasCards = true;
            };

            // $log.info(hasCards);

            $mdDialog.show({
              controller: taskPanelDialogController,// see below
              controllerAs: 'vm',
              templateUrl: 'app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html',
              locals: {panel: editPanel, clientID: clientID, hasCards: hasCards},
              // targetEvent: $event,
              focusOnOpen: false,
              clickOutsideToClose: true,
              fullscreen: true
          });

        };



        ///////////////////////////////////////////////////////////
        /// deletePanel
        function deletePanel(panel) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('PERMANENTLY delete this bucket?')
                .textContent(panel.label)
                .ariaLabel('Delete bucket? Y//N')
                .targetEvent(panel)
                .ok('Yes, Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                // Locate the detail record in our client array
                return firebase.database().ref().child('clients/' + panel.client + '/taskpanels/' + panel.uid).remove().then(function(){
                $mdToast.showSimple('Bucket Removed');
                // heap.track('Bucket Deleted');
                });
            }, function() {
                // $log.inf('delete panel cancelled');

            }); // end deletePanel
        }


        ///////////////////////////////////////////////////////////
        /// createPanel
        function createPanel(panel) {
            // $log.info('taskPanelDataService.createPanel');
            // $log.info(panel);
            // Get new key
            var newPanelKey = firebase.database().ref().child('clients/' + panel.client + '/taskpanels').push().key;
            // make sure you store it's key location as a uid
            panel.uid = newPanelKey;


            var updates ={};
            // store our canonical object
            updates['/clients/' + panel.client + '/taskpanels/' + newPanelKey] = panel;

            return firebase.database().ref().update(updates);
            // heap.track('New Task Bucket Saved');

        }; // end createPanel

        ///////////////////////////////////////////////////////////
        /// saveUpdatedPanel
        function saveUpdatedPanel(panel) {
            var updates ={};

            // store our canonical object
            updates['/clients/' + panel.client + '/taskpanels/' + panel.uid] = panel;
            // heap.track('Task Bucket Updated');
            return firebase.database().ref().update(updates);

        }

        ///////////////////////////////////////////////////////////
        /// newPanel
        function newPanel(clientID) {
            // $log.info('taskPanelDataService.newPanel(' + clientID + ')');
            var sort = angular.element('task-panel').length;
            var panel = {
                client: clientID,
                tasks: [],
                order: sort+1
            };
            var hasCards = false;

            $mdDialog.show({
                controller: taskPanelDialogController,// see below
                controllerAs: 'vm',
                templateUrl: 'app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html',
                locals: {panel: panel, clientID: clientID, hasCards: hasCards},
                // targetEvent: $event,
                focusOnOpen: false,
                clickOutsideToClose: true
            });

            // heap.track('New Bucket Started');

        };

        ////////////////////////////////////////////////////////
        // Create Panel and Populate with tasks
        function setupPanelAndTasks(panel){
            $log.info(panel);

            // service.createPanel(panel).then(function(){
            // _.each(panel.tasks, function(task){
                // var newTask == taskDataService.newTask(panel.client, panel.uid);
                // return taskDataService.saveNewTask(newTask)
            // });
            // })
        }


        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// Panel Dialog Controller

        /* @ngInject */
        function taskPanelDialogController(panel, hasCards, $scope, $rootScope, hotkeys) {
            var vm = this;
            vm.panel = panel;
            vm.hasCards = hasCards;
            vm.colors = $rootScope.clientColors;

            $timeout(function(){
                $('input[name="detaillabel"]').focus();
            },300)

            vm.showColors = false;

            vm.toggleColors = function(){
                // $log.info('toggleColors');
                if(!vm.showColors){
                    vm.showColors = true;
                } else {
                    vm.showColors = false;
                }
            }

            // Hide color panel after selection made
            $scope.$watch('vm.panel.color', function (newValue, oldValue, scope) {
                if(vm.showColors){
                    vm.toggleColors();
                }
            });

            // Setup Hotkeys for this dialog
            hotkeys.bindTo($scope)
                // inhibit enter from submitting
                .add({
                  combo: 'enter',
                  callback: function(event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                  }
                })
                .add({
                  combo: 'ctrl+enter',
                  allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  description: 'Save/Update Bucket',
                  callback: function(event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info($scope.clientDialogForm);
                    var pristine = $scope.vm.panelDialogForm.$pristine,
                        invalid = $scope.vm.panelDialogForm.$invalid;

                        if (!pristine && !invalid && vm.panel.uid){
                            $scope.updatePanel($scope.vm.panel);
                        }

                        if (!pristine && !invalid && !vm.panel.uid){
                            $scope.saveNewPanel($scope.vm.panel);
                        }
                    }
                });


            $scope.saveNewPanel = function saveNewPanel(panel) {
                // $log.info(panel);
                createPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('Bucket ' + panel.label + ' created.');
                // $scope.editedPanel = null;
                pageDimensionsService.resizeColumns();
            }

            $scope.updatePanel = function updatePanel(panel) {
                // $log.info('DialogControl: updatePanel');
                // $log.info(panel);
                saveUpdatedPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('Bucket ' + panel.label + ' updated.');
                pageDimensionsService.resizeColumns();
            }

            $scope.cancelDialog = function cancelDialog(dialog) {
                $mdDialog.cancel();
            }

            $scope.removePanel = function removePanel(panel) {
                deletePanel(panel);
                $timeout(function(){
                    pageDimensionsService.resizeColumns();
                },500);
            }


        }

        function importPanel(panel){
            $log.info('taskPanelDataService');
            $log.info(panel);

            var taskDataService = $injector.get('taskDataService'),
                panelTasks = angular.copy(panel.tasks),
                newPanelKey = firebase.database().ref().child('clients/' + panel.client + '/taskpanels').push().key;

            // remove tasks from the panel
            delete panel.tasks;

            // Save our new UID
            panel.uid = newPanelKey;
            var updates = {};
            // store our panel
            updates['/clients/' + panel.client + '/taskpanels/' + newPanelKey] = panel;
            return firebase.database().ref().update(updates)
            .then(function(){
                _.each(panelTasks, function(task){
                    var newTask = taskDataService.newTask(panel.client, panel.uid);
                    // put in our imported description
                    newTask.info.description = task.description;
                    // Make it show up in Today views
                    newTask.info.focus = 'today';
                    return taskDataService.saveNew(newTask);
                });
            });

           }

    }; // end taskPanelDataService


})
();

(function () {
    'use strict';


    angular.module('appServices')
            .service('subscriptionService', subscriptionService)


    /* @ngInject */
    function subscriptionService($log, moment,
                userDataService, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject) {


        var service = {
            init: init
        };

        return service;


        // Initialize service.timerData object
        function init(){

        }



    }

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('taskDialogController', taskDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// taskDialogController

        /* @ngInject */
        function taskDialogController($q, $scope, gateService, dragulaService, $mdDialog, $timeout, $log, $mdToast, rrule, $rootScope, hotkeys, localStorageService, userDataService, teamDataService, clientDataService, taskDataService) {
            // $log.info('taskDialogController');
            var vm = this;
            vm.taskControls = true;
            vm.today = new Date();
            vm.canLogTime = true;
            vm.canEmailClient = true;
            vm.canUseChecklists = true;
            vm.showAssignmentField = true;

            // vm.teamLimit = gateService.gateData.teamLimit;


            vm.filePath = 'tasks'
            vm.canLogTime = gateService.gateData.canLogTime;
            vm.canEmailClient = gateService.gateData.canEmailClient;
            vm.canUseChecklists = gateService.gateData.canUseChecklists;
            // set minDate so we can't select due dates prior to today
            vm.minDate = vm.today;
            // Prep for files
            vm.numFiles = 0;
            if (_.has(vm.editedItem, 'info.files')) {
                vm.numFiles = vm.editedItem.info.files.length;
            } else {
                vm.editedItem.info.files = [];
            }

            // If we are here from a copied task, set the form to dirty immediately
            if(_.has(vm.editedItem, 'clone'))
            $timeout(function(){
                $scope.taskDialogForm.$setDirty();

            }, 200);

        // Initialize
        init();

        function init(){
            getTeamList();
        }

        // Load our teamList for our assignee drop down from teamDataService.clientTeams
        // Then go through and determine:
        // A: If the assignment field should show
        // B: If the current user has the rights to change the assignment
        function getTeamList(){
            vm.teamListLoading = true;
            $timeout(function(){
                vm.teamList = teamDataService.clientTeams[vm.editedItem.info.client];
                vm.teamListSize = _.size(vm.teamList);
                vm.teamListLoading = false;


                vm.isAdmin = false;
                // if it's the owner of the task, they can assign
                if(vm.editedItem.creator == $rootScope.userID){
                    vm.isAdmin = true;
                };

                // find this logged in member in the list
                _.each(vm.teamList, function(member){
                    if(member.uid == $rootScope.userID){
                        // if it's the owner of the team, they can assign
                        if (member.role == 'owner'){
                            vm.isAdmin = true;
                        }
                        // if they've been made admin on a client, they can assign for that client
                        if (_.has(member.clients, vm.editedItem.info.client)){
                            if(member.clients[vm.editedItem.info.client] == 'admin'){
                                vm.isAdmin = true;
                            }
                        }
                    }// if member matches current user
                });// each member
            },0);
        }

        vm.panelCandidates = [];

        // Load up panel candidates
        vm.clientChange = function(clientID){
            return clientDataService.getClient(clientID)
            .then(function(thisClient){
                $timeout(function(){
                    vm.panelCandidates = thisClient.taskpanels;
                    // reset our teamList for this client
                    getTeamList();
                },0);
            });
        } // clientChange


        // execute clientChange to pre-select our option
        if(_.has(vm.editedItem, 'info.client')){
            vm.clientChange(vm.editedItem.info.client);
        }

        vm.duedates = {
            today: moment().toDate(),
            tomorrow: moment().add(1, 'day').toDate(),
            days3: moment().add(3, 'day').toDate(),
            days7: moment().add(7, 'day').toDate()
        }

        vm.setDueWith = function(day){
            // $log.info(moment(day).toISOString());
            vm.editedItem.info.duedate = day;
            $scope.taskDialogForm.$setDirty();
        }

        // Needed variables for tag autocomplete field
        vm.selectedItem = undefined;
        vm.searchText = "";


        // Recurring Task Handling
        vm.rulePreview = [];
        vm.startOnPrep = moment().startOf('day');
        vm.startOn = moment.utc(vm.startOnPrep).toDate();
        // $log.info('vm.startOn=' + moment.utc(vm.startOn).format());

        if(_.has(vm.editedItem, 'schedule.startOn')){
            // setting our startOn time to start of day in local time zone
            var temp = moment.utc(vm.editedItem.schedule.startOn);
            vm.startOn = moment(temp).toDate();
        }

        vm.resetValidity = function(){
            vm.validRule = false;
            vm.rulePreview = [];
        }

        vm.setDirty = function(){
            $scope.taskDialogForm.$setDirty();
        }

        vm.showChecklists = function(item){
            // only show checklists A) if allowed. B) if there's a UID or there's already a checklist
            if(vm.canUseChecklists){
                if(_.has(item, 'uid')){
                    return true
                } else if (_.has(item,'checklist')){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }// if vm.canUseChecklists
        }

        vm.calcRule = function(ruleText){
            // $log.info('vm.calcRule');
            // Clear our preview array
            vm.rulePreview = [];

            // This rrule library is weird. Saving the rule to repopulate the field
            // after calcing
            var ruleCopy = angular.copy(ruleText);


    ///////////// Setup our Rule /////////////
    //
            // Setup our ruleOptions with our ruleText
            var ruleOptions = RRule.parseText(ruleText);

            // Careful construction of our dtstart object
            // to make sure our recurring rule starts at the right time
            var startYear = moment(vm.startOn).format('YYYY'),
                startMonth = moment(vm.startOn).format('MM'),
                startDay = moment(vm.startOn).format('DD'),
                startTime = moment(vm.startOn).format('HH');

            // Add our dtstart object to our ruleoptions
            ruleOptions.dtstart = new Date(startYear, startMonth - 1, startDay, startTime, 0, 0);

            // Create our rule with the options we've put together
            var rule = new RRule(ruleOptions);
    //
    ///////////// End Setup Rule /////////////

    ////////// Build preview array

            // set our preview limit
            var previewLimit = 6;

            // Reduce the limit to the actual count
            // If count is less than 6, let's not confuse our users.
            if(rule.options.count < 6){
                previewLimit = rule.options.count;
            }

            // pull only the next previewLimit occurences
            vm.ruleTemp = rule.all(function (date, i){return i < 6});

            vm.rulePreview = [];
            // Convert Dates to human readable
            _.each(vm.ruleTemp, function(scheduledDate){
                scheduledDate = moment(scheduledDate).startOf('day').format('dddd MMM DD, YYYY');
                vm.rulePreview.push(scheduledDate);
            });
    //
    //////// end preview array building ////

            // If we have successful preview...setup our schedule
            // Our "aha" moment on dealing with dates that take local timezones into account
            // (All tasks are due midnight in the user's locale)
            // came from this article:
            // http://blog.skylight.io/bringing-sanity-to-javascript-utc-dates-with-moment-js-and-ember-data/

            if(vm.rulePreview.length){
                // We've changed the form. Alter $Pristine
                $scope.taskDialogForm.$pristine = false;
                vm.validRule = true;

                // Setup our schedule
                var today = moment().startOf('day'), // make sure we are starting from our local midnight
                    // convert to global utc
                    today = moment.utc(today).toDate(),
                    // we are going to start our occurence building YESTERDAY to be sure to
                    // include today (if start date is on today)
                    yesterday = moment.utc(today).subtract(1,'day').toDate();
                    // next occurence is on rule match, at midnight, in this time zone

                    var nextDue = rule.after(yesterday),
                        nextRepeat = moment(nextDue).subtract(vm.editedItem.schedule.dueDays, 'days');

                // setup props for our repeating schedule
                // vm.editedItem.schedule = {};
                // Store our rule
                vm.editedItem.schedule.repeatRule = rule.toString();
                // Store the nextcreate date
                vm.editedItem.schedule.nextCreateDate = moment.utc(nextRepeat).toISOString();
                // Store the nextdue date
                vm.editedItem.schedule.nextDueDate = moment.utc(nextDue).toISOString(); // this will change later
                // Store run limit
                vm.editedItem.schedule.limit = rule.options.count;
                // Set run count to 0
                vm.editedItem.schedule.count = 0;
                // Set complete to false
                vm.editedItem.schedule.complete = false;
                // Store our offset (just in case we need it later)
                vm.editedItem.schedule.offset = (new Date()).getTimezoneOffset();
                // // convert our startOn to utc for storage
                vm.editedItem.schedule.startOn = moment.utc(ruleOptions.dtstart).toISOString();

                // we have good results. Put our rule back in the form.
                // we don't know why it's going empty on us but this gets around it
                vm.editedItem.schedule.ruleText = ruleCopy;
                $scope.taskDialogForm.$setDirty();
            } else {
                $mdToast.showSimple('Sorry, I couldn\'t Understand that rule.');
            }

        }// vm.calcRule;



        $scope.toggleToday = function (task) {
            // $log.info('dialogController: toggleToday');
            if (task.info.focus == 'today') {
                task.info.focus = 'someday';
            } else {
                task.info.focus = 'today';
            }
            $scope.taskDialogForm.$setDirty();
        }

        $scope.toggleComplete = function (task) {
            // $log.info('dialogController: toggleComplete');
            if (task.info.status === 'closed') {
                task.info.status = 'open';
                delete task.info.closedDate;
            } else {
                task.info.status = 'closed';
                var now = new Date();
                task.info.closedDate = now.toISOString();
            }
            $scope.taskDialogForm.$setDirty();
        }

        $scope.setupTask = function () {
            vm.taskControls = true;
        }

        $scope.hideTaskControls = function () {
            vm.taskControls = false;
        }

        $scope.showTaskControls = function () {
            vm.taskControls = true;
        }

        $scope.setupNotes = function () {
            taskDataService.setupNotes();
        }

        $scope.cancelDialog = function (task) {
            $scope.editedItem = null;
            // unwatch();

            $mdDialog.cancel();
        } //cancelDialog


        $scope.saveUpdatedTask = function (task) {
            // $log.info('updateTask called for:');
            // Update the task

            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            } else {
                // task.info.assignee is set.
                // let's get the rest of the info we need to display on our cards
                _.each(vm.teamList, function(member){
                    if(member.uid == task.info.assignee){
                        task.info.assigneeName = member.profile.fullName;
                        task.info.assigneeAvatar = member.profile.avatar;
                    }
                });
            }



            taskDataService.updateTask(task)
            // remove editedItem
            $scope.editedItem = null;
            ////
            // unwatch();
            // Remove our Dialog
            $mdDialog.hide();
            // remove highlight if it was added in previous step
            delete task.highlight;

        } // saveUpdatedTask

        $scope.saveNewTask = function (task, andNew) {
            // $log.info('save new task clicked');
            // Why is our panel UID NOT in our client.taskpanels?
            // $log.info(task);

            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            }
            else {
                _.each(vm.teamList, function(member){

                    if(member.uid == task.info.assignee){

                        task.info.assigneeName = member.profile.fullName;
                        task.info.assigneeAvatar = member.profile.avatar;
                    }
                });
            }

            // Save our task
            taskDataService.saveNew(task);

            // remove editedItem
            delete $scope.editedItem;

            // Remove our Dialog
            $mdDialog.hide();

            if (andNew) {
                //make empty editedDetail object
                $scope.editedItem = newTask(task.info.client, task.info.panel);
                $scope.editedItem.info.status = task.info.status;
                $scope.editedItem.creator = task.creator;
                $scope.editedItem.info.focus = task.info.focus;

                // Set our dialogTitle
                $scope.dialogTitle = "New Task";

                // Trigger our next task
                // $log.info($scope.editedItem);
                taskDataService.taskDialog($scope.editedItem);
            }
            ;

        }; // saveNewTask


        $scope.isClose = function (item) {
            var progress = item.logged/item.budget;
            if (item.budget > 0 && progress <=1 && progress > .75 ) {
                return true
            }
        }


        $scope.isOver = function (item) {
            var progress = item.logged/item.budget
            if (item.budget > 0 && progress > 1) {
                return true
            }
        }

        ////////////
        // Tag autocomplete query
        $scope.queryTags = function (query) {
            var d = $q.defer();
            var results = query ? $rootScope.tags.filter(createFilterFor(query)) : [];
            d.resolve(results)
            return d.promise;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(tag) {
                return (tag.name.indexOf(lowercaseQuery) != -1);
                ;
            };
        }


        $scope.tagSelected = function (tag) {
            // $log.info('tagSelected', tag)
        }

        $scope.transformChip = function (chip) {
            // $log.info('transformChip', chip)
            return chip
        }


        // Checklist functions
        vm.shouldShowForm = false;

        vm.showChecklistForm = function(){
           vm.shouldShowForm = true;
             $timeout(function () {
               document.getElementById("focusfield").focus();
           }, 250, false);


        }

        vm.closeChecklistForm = function(){
            delete vm.newChecklistItem

            // delete vm.newChecklistItem.uid;
            // delete vm.newChecklistItem.order;
           vm.shouldShowForm = false;
        }

        vm.manualSubmit = function(task){
            // Enter has been pressed while in the task description field
            if(_.has(task, 'uid') && $scope.vm.editedItem.info.description && $scope.vm.editedItem.info.client){
                // update task
                $scope.saveUpdatedTask($scope.vm.editedItem);
            } else if ($scope.vm.editedItem.info.description && $scope.vm.editedItem.info.client) {
                // add new task
                $scope.saveNewTask($scope.vm.editedItem);
            } else {
                return false
            }
        }


        // Called to add or UPDATE an existing checklistItem
        vm.addChecklistItem = function(item, task){
            if(_.has(item, 'uid')){
                // We are editing this item's body only. Just update it directly
                var taskRef = firebase.database().ref('tasks/' + task.uid);
                taskRef.child('checklist').child(item.uid).child('body').set(item.body);
                vm.closeChecklistForm();
                // $timeout(function(){vm.newChecklistItem.body = "";},0);
                // vm.closeChecklistForm();
            } else {
                return taskDataService.addChecklistItem(item, task).then(function(result){
                    $timeout(function(){delete vm.newChecklistItem;},0);
                      $timeout(function () {
                        document.getElementById("focusfield").focus();
                    }, 250, false);
                });
            }
        }



        vm.deleteChecklistItem = function(item, task){
            // $log.info('vm.deleteChecklistItem');
            return taskDataService.deleteChecklistItem(item, task);
        }

        vm.updateChecklistItem = function(item,task){
            $timeout(function(){
                return taskDataService.updateChecklistItem(item, task);
            },200);
        }

        vm.editChecklistItem = function(item,task){
            var itemCopy = angular.fromJson(angular.toJson(item));
            // $log.info(itemCopy);
            vm.showChecklistForm();
            vm.newChecklistItem = itemCopy;
        }

        vm.makeChecklistItemCard = function(item, task){
            return taskDataService.deleteChecklistItem(item, task);
        }

            // if we already have a Dragula bag by this name (we shouldn't but sometimes we do), destroy it
            if (dragulaService.find($scope, 'drag-checklist')){
                dragulaService.destroy($scope, 'drag-checklist');
            }

              // Dragula Setup
               dragulaService.options($scope, 'drag-checklist', {
                         moves: function (el, container, handle) {
                            return true
                           // return handle.classList.contains('handle');
                         },
                         accepts: function(el, target, source, sibling) {
                          return true
                          // if (target === source){
                          //   return true
                          // }
                        },
                         direction: 'vertical'
                       });

               ///////////
               // Task Drop Listener
               $scope.$on('drag-checklist.drop', function(event, item, target, source, sibling){
                   // $log.info('drag-checklist.drop');

                   // Get our items to sort
                    var sortingContainer = $('.task-checklist');
                    var sortedItems = $(sortingContainer).find('.checklist-item');

                   // Prepare our atomic updates
                   var updates = {};
                   _.each(sortedItems, function(item, index){
                    var newOrder = parseInt(index) + 1,
                        itemID = item.getAttribute('uid');
                        var taskRef = firebase.database().ref('tasks/' + $scope.vm.editedItem.uid);
                        taskRef.child('checklist').child(itemID).child('order').set(newOrder);
                   });
               });// $on.drag-task.drop


               hotkeys.bindTo($scope)
                  // inhibit enter from submitting
                  .add({
                      combo: 'enter',
                      callback: function (event) {
                          event.preventDefault();
                          // $log.info('enter blocked');
                      }
                  })
                  .add({
                      combo: 'ctrl+enter',
                      allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                      description: 'Save/Update Client',
                      callback: function (event) {
                          // $log.info('ctrl+enter');
                          event.preventDefault();
                          // $log.info($scope.clientDialogForm);
                          var pristine = $scope.taskDialogForm.$pristine,
                                  invalid = $scope.taskDialogForm.$invalid,
                                  clientID = $scope.vm.editedItem.uid;

                          if (!pristine && !invalid && clientID) {
                              $scope.saveUpdatedTask($scope.vm.editedItem);
                          }

                          if (!pristine && !invalid && !clientID) {
                              $scope.saveNewTask($scope.vm.editedItem);
                          }
                      }
                  })
                  // .add({
                  //     combo: 'shift+ctrl+enter',
                  //     allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  //     description: 'Save and add New',
                  //     callback: function (event) {
                  //         // $log.info('shift+ctrl+enter');
                  //         event.preventDefault();
                  //         // $log.info($scope.clientDialogForm);
                  //         var pristine = $scope.taskDialogForm.$pristine,
                  //                 invalid = $scope.taskDialogForm.$invalid,
                  //                 clientID = $scope.vm.editedItem.uid;

                  //         if (!pristine && !invalid && clientID) {
                  //             $scope.saveUpdatedTask($scope.vm.editedItem);
                  //         }

                  //         if (!pristine && !invalid && !clientID) {
                  //             var andNew = true;
                  //             $scope.saveNewTask($scope.vm.editedItem, andNew);
                  //         }
                  //     }
                  // });
                  ;


        }
        ; // end taskDialogController

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('taskDataService', taskDataService);

    /* @ngInject */
    function taskDataService($mdToast, $q, $log, gateService, taskTemplateDataService, userDataService,
        aggregateDataService, localStorageService, $http, pageDimensionsService, $mdMedia, $mdDialog,
        $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            newTask: newTask,
            getClientTasks: getClientTasks,
            getTask: getTask,
            taskDialog: taskDialog,
            batchDialog: batchDialog,
            toggleToday: toggleToday,
            toggleComplete: toggleComplete,
            saveNew: saveNew,
            removeTask: removeTask,
            updateTask: updateTask,
            logTask: logTask,
            setupNotes: setupNotes,
            moveTask: moveTask,
            makeTemplate: makeTemplate,
            reCalcTask: reCalcTask,
            quickUpdate: quickUpdate,
            addChecklistItem: addChecklistItem,
            updateChecklistItem: updateChecklistItem,
            deleteChecklistItem: deleteChecklistItem,
            makeChecklistItemCard: makeChecklistItemCard
        };

        var allClientsTasks = [];

        return service;

        function reCalcTask(taskID) {
            // $log.info('reCalcTask Totals');
            return getTask(taskID)
                    .then(function (task) {
                        // $log.info('recalcing task', task.info);
                        // $log.info(task.info.client);
                        var total = 0;
                        _.each(task.time, function (entry) {
                            total += entry.logged;
                        });

                        var updates = {};
                        updates['/tasks/' + taskID + '/info/logged'] = total;
                        updates['/clients/' + task.info.client + '/tasks/' + taskID + '/logged'] = total;
                        // Commit our updates
                        return firebase.database().ref().update(updates)
                                .then(function () {
                                    // $log.info('reCalcTask completed');
                                });
                    });

        }


        function quickUpdate(task, message) {
            // Save our changes down to FB
            // $log.info('quickUpdate', task);
            delete task.$id;
            delete task.$priority;
            delete task.showComplete;
            var updates = {};
            updates['/tasks/' + task.refID + '/info'] = task;
            updates['/clients/' + task.client + '/tasks/' + task.refID] = task;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                        }, 500);

                        // logTask(task.refID, message);

                        if (message) {
                            logTask(task.refID, message);
                            // $mdToast.show(
                            //         $mdToast.simple()
                            //         .textContent(message)
                            //         .position('top right')
                            //         .hideDelay(2000)
                            //         );
                        }

                    });
        }
        ///////////////////////
        // Move Task
        function moveTask(item, toPanel) {
            // $log.info('moveTask');
            var itemCopy = angular.fromJson(angular.toJson(item));
            item.panel = toPanel;
            quickUpdate(item, 'Task moved to ' + toPanel);
            // heap.track('Task Moved');
        }


        //////////////////////////
        // New task
        function newTask(clientID, panel) {
            // $log.info('clientDataService.newTask');
            // $log.info('newTask for panel:' + panel);
            // $log.info('newTask for client:' + clientID);

            var userID = localStorageService.get('userID'),
                    task = {
                        creator: userID,
                        info: {
                            assignee: userID,
                            logged: 0,
                            status: 'open',
                            budget: 0,
                            description: '',
                            numnotes: 0,
                            created: Date.now()
                        }
                    }

            if (clientID) {
                task.info.client = clientID;
            }

            switch (panel) {
                case undefined:
                    // no panel specified, it goes in Later with "someday" focus
                    task.focus = 'someday';
                    task.info.panel = 'Later';
                    break
                case 'today':
                    // today specified, set focus and default panel
                    task.info.panel = 'Later';
                    task.info.focus = 'today';
                    break
                case 'Later':
                    // Later specified, set focus and default panel
                    task.info.panel = 'Later';
                    task.info.focus = 'someday';
                    break
                default:
                    // Otherwise, assign the panel to match and set focus to "someday"
                    task.info.panel = panel;
                    task.info.focus = 'someday';
                    break
            }

            // heap.track('New Task Started');

            // $log.info(task);
            return task
        }

        ///////////////////////////
        // getClientTasks
        function getClientTasks(clientID) {
            var tasksRef = firebase.database().ref('tasks/');

            return $firebaseArray(tasksRef.orderByChild('client').equalTo(clientID))
                    .$loaded(function (tasks) {
                        return tasks
                    });
        }
        ; // end getClientTasks

        function makeTemplate(task){
            var newTaskTemplate = taskTemplateDataService.newTaskTemplate(task.info.client);
            newTaskTemplate.info = task.info;
            newTaskTemplate.creator = $rootScope.userID;
            newTaskTemplate.assignee = $rootScope.userID;

            if(_.has(task, 'checklist')){
                newTaskTemplate.checklist = task.checklist;
            };
            logTask(task.uid, 'Used as starter for new Task Template');
            return taskTemplateDataService.saveNewTaskTemplate(newTaskTemplate);
        }


        ////////////////////////////////
        // logTasks
        function logTask(taskID, event) {
            // log the event
            var log = {
                actor: localStorageService.get('userName'),
                actorID: localStorageService.get('userID'),
                event: event,
                timestamp: moment().toISOString()
            }

            var newLogKey = firebase.database().ref().child('tasks/' + taskID + '/activity/').push().key;
            var updates = {};
            // store our canonical object
            updates['/tasks/' + taskID + '/activity/' + newLogKey] = log;
            return firebase.database().ref().update(updates);

        } // logTask

        ///////////////////////////////////////////////////////////
        /// toggleToday
        function toggleToday(item) {
            // $log.info('toggleToday - taskDataService');
            var itemCopy = angular.fromJson(angular.toJson(item)),
                    message;

            // clean up our object for sending back to original FB reference
            // delete itemCopy.$id;
            // delete itemCopy.$priority;

            if (itemCopy.focus == 'today') {
                itemCopy.focus = 'someday';
                message = '"Today" flag removed';
                quickUpdate(itemCopy, message);
            } else {
                itemCopy.focus = 'today';
                message = '"Today" flag set';
                quickUpdate(itemCopy, message);
            }

            // heap.track('Task Focus Toggled');
        }
        ; // end toggleToday

        ///////////////////////////////////////////////////////////
        /// toggleComplete


        function toggleComplete(item) {
            $log.info('taskDataService: toggleComplete', item);
            // debugger
            // $log.info(item.uid);

            var itemCopy = angular.fromJson(angular.toJson(item));
            var today = new Date();

            // clean up our object for sending back to original FB reference
            delete itemCopy.$id;
            delete itemCopy.$priority;
            itemCopy.panel = 'Later';

            var event, message;

            // Change our status and setup our log and toast message
            if (itemCopy.status === 'open') {
                itemCopy.status = 'closed';
                itemCopy.focus = 'someday';
                // also set our item to closed so the user gets an
                // immediate indication
                item.status = 'closed';
                item.focus = 'someday';
                itemCopy.closedDate = today.toISOString();
                event = "Task Closed";
                message = "completed";
            } else {
                itemCopy.status = 'open';
                // also set our item to open so the user gets an
                // immediate indication
                // item.status = 'open';
                itemCopy.closedDate = null;
                event = "Task reopened";
                message = "reopened";
            }

            quickUpdate(itemCopy, event);
            aggregateDataService.toggleTask(itemCopy);
            // heap.track('Complete Task Toggled');
            //  _dcq.push(["identify", {
            //   email: userDataService.user.email,
            //   tags: ["Completed First Task"]
            // }]);
        }
        ; // end toggleComplete

        ///////////////////////////////////////////////////////////
        /// taskDialog
        // opens dialog with the prepared editedItem

        function taskDialog(editedItem, selectedTab) {
            // $log.info(editedItem);
            return userDataService.getLoggedInUser()
            .then(function(user){
                var canLogTime = gateService.gateData.canLogTime;
                // $log.info('taskDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: taskDialog');
                var clientColor;
                var newNote; // just need to declare it so our in-dialog note form has a model to work from

                // if we already have a client assigned, pass along the color.
                // otherwise, pass an empty string.
                if (editedItem.info.client) {
                    // editing an existing task
                    var selectedClient = _.find($rootScope.quickClients, function (client) {
                        return client.uid == editedItem.info.client;
                    });
                    if (_.has(selectedClient, 'clientColor')) {
                        clientColor =  selectedClient.clientColor;
                    }
                } else {
                    // creating a new task
                    clientColor = '#aaa'; // Not used. just to avoid an undefined error.
                }

                $mdDialog.show({
                    controller: 'taskDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-task.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        editedItem: editedItem,
                        assignedClients: $rootScope.quickClients,
                        clientColor: clientColor,
                        newNote: newNote,
                        tags: $rootScope.tags,
                        selectedTab: selectedTab,
                        canLogTime: canLogTime
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    fullscreen: true
                });

                // Set focus
                $timeout(function () {
                    // if this is a new task, put the focus on the description field
                    if (!editedItem.uid) {
                        var taskDescription = angular.element("textarea[name='description']");
                        // if this is an empty field, just put the cursor there

                                if (taskDescription.createTextRange) {
                                    var part = taskDescription.createTextRange();
                                    part.move("character", 0);
                                    part.select();
                                } else if (taskDescription.setSelectionRange) {
                                    taskDescription.setSelectionRange(0, 0);
                                }
                                taskDescription.focus();
                        // if (!taskDescription[0].value) {
                        //     taskDescription.focus();
                        //     // taskDescription.setSelectionRange(0, 0);
                        //     // if we've been passed a value select the description for easy editing
                        // } else if (taskDescription[0].value) {
                        //     taskDescription.select();
                        // }


                    }
                }, 100);
            });



        }
        ; //end taskDialog

        ///////////////////////////////////////////////////////////
        /// getTask
        function getTask(taskID) {
            // $log.info('getTask:' + taskID);
            var task = {},
                    taskRef = firebase.database().ref('tasks/' + taskID);
            return $firebaseObject(taskRef)
                    .$loaded(function (data) {
                        task = data
                        // $log.info(task);
                        return task
                    })
        }
        ; // end getTask

        ///////////////////////////////////////////////////////////
        /// saveNew
        function saveNew(task) {
            // $log.info(task);
            // This service is called for saving tasks and task templates (because they share a GUI)
            // Hence we have to check for/against type and either save it here, or use taskTemplateServices to save
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    // in $timeout so our view updates

                    taskTemplateDataService.saveNewTaskTemplate(task);


                } else {

                    saveTaskFunction(task);
                }
            } else {

                saveTaskFunction(task);
            }

            function saveTaskFunction(task){
                // $log.info('Saving a task');
                // $log.info(task);

                var taskCopy = angular.copy(task),
                        firstNote = undefined;
                if (taskCopy.duedate) {
                    taskCopy.duedate = taskCopy.duedate.toISOString();
                }

                // if we passed an initial 'note' for the task, pull it off so we can properly add it later
                if (taskCopy.note) {
                    firstNote = taskCopy.note;
                    delete taskCopy.note;
                }
                // console.log('savetask');
                // $log.info(task);
                var newTaskKey = firebase.database().ref().child('tasks/').push().key;
                // put our $id as a property for easier retrieval
                taskCopy.uid = newTaskKey;
                taskCopy.info.refID = newTaskKey;

                // $log.info(taskCopy);
                // add our task to the new key
                var updates = {};
                updates['/tasks/' + newTaskKey] = taskCopy;
                updates['/clients/' + taskCopy.info.client + '/tasks/' + newTaskKey] = taskCopy.info;


                // return
                // make the update
                return firebase.database().ref().update(updates)
                        .then(function () {
                            $rootScope.$emit('taskUpdated');
                            // if we have a first note, add it to our new task
                            if (firstNote) {
                                // $log.info('we have a first note passed');
                                var newNoteKey = firebase.database().ref().child('tasks/' + newTaskKey + '/notes').push().key,
                                        noteObj = {};
                                noteObj.uid = newNoteKey;
                                noteObj.date = Date.now();
                                noteObj.author = localStorageService.get('userID');
                                noteObj.authorName = localStorageService.get('userName');
                                noteObj.body = firstNote;
                                // declare our updates
                                var updates = {};

                                // store our canonical object
                                updates['/tasks/' + newTaskKey + '/notes/' + newNoteKey] = noteObj;

                                // Save the note
                                return firebase.database().ref().update(updates)
                                        .then(function () {

                                            // $log.info('note added');
                                        })
                            } // firstNote

                        })
                        .then(function () {
                            // setup our first log entry
                            aggregateDataService.taskCounter(taskCopy.info, 'new', 1);
                            logTask(newTaskKey, 'Task Created');
                            // $mdToast.show(
                            //         $mdToast.simple()
                            //         .textContent('New Task Created')
                            //         .position('top right')
                            //         .hideDelay(2000)
                            //         );
                            // heap.track('New Task Saved');
                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                            }, 500);
                            Appcues.identify(task.creator, {
                                hasTasks: true
                            });
                            //  _dcq.push(["identify", {
                            //   email: userDataService.user.email,
                            //   tags: ["Added first Task"]
                            // }]);
                        });

            }

        }
        ; // end saveNew

        ///////////////////////////////////////////////////////////
        /// removeTask
        function removeTask(item) {
            // $log.info('removeTask');
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                    .title('PERMANENTLY delete this task?')
                    .textContent(item.description)
                    .ariaLabel('Delete Task? Y//N')
                    .targetEvent(item)
                    .ok('Yes, Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm)
                    .then(function () {
                        // store the task's created date so you can update that period's aggregate total
                        var taskShadow = {};
                        taskShadow.created = item.created;
                        taskShadow.client = item.client;
                        // $log.info(taskShadow);

                        // remove our client's reference
                        return firebase.database().ref().child('/clients/' + item.client + '/tasks/' + item.refID).remove()

                                .then(function () {
                                    // Locate the task record in our tasks array
                                    return firebase.database().ref().child('/tasks/' + item.refID).remove();


                                })
                                .then(function () {
                                    // $log.info(taskShadow);
                                    // use the taskShadow to update the correct aggregate
                                    // disabled - this is actually unintuitive. Deleting an old task could be considered "handling" it, thus
                                    // we shouldn't ding productivity 1 task if that happens
                                    // aggregateDataService.taskCounter(taskShadow, -1);
                                    $mdDialog.hide();
                                    // $mdToast.show(
                                    //         $mdToast.simple()
                                    //         .textContent('Task deleted.')
                                    //         .position('top right')
                                    //         .hideDelay(2000)
                                    //         );
                                    $timeout(function () {
                                        pageDimensionsService.resizeColumns();
                                        $rootScope.$emit('taskUpdated');

                                    }, 500);
                                });
                    });
            // heap.track('Task Deleted');
        }
        ; // end removeTask

        ///////////////////////////////////////////////////////////
        /// updateTask
        function updateTask(task) {

            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    taskTemplateDataService.updateTaskTemplate(task);
                } else {

                    updateTaskFunction(task);
                }
            } else {

                updateTaskFunction(task);
            }

            function updateTaskFunction(task){
                var taskCopy = angular.copy(task.info);

                // convert our date into a string for storing

                if (taskCopy.duedate) {
                    taskCopy.duedate = moment(taskCopy.duedate).toISOString();
                }

                var updates = {};

                // // // remove things that firebase provides
                // delete taskCopy.$id;
                // delete taskCopy.$priority;
                // delete taskCopy.$$state;
                // delete taskCopy.$$conf;
                // delete taskCopy.$$hashkey;

                // // store our modified object
                updates['/tasks/' + taskCopy.refID + '/info'] = taskCopy;
                updates['/clients/' + taskCopy.client + '/tasks/' + taskCopy.refID] = taskCopy;
                return firebase.database().ref().update(updates)
                        .then(function () {
                            logTask(taskCopy.refID, 'Task updated');
                            // Make sure our columns adjust to new/removed items
                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                                $rootScope.$emit('taskUpdated');
                            }, 500);

                            //  $mdToast.show(
                            //   $mdToast.simple()
                            //     .textContent('Task Updated')
                            //     .position('top right')
                            //     .hideDelay(2000)
                            // );
                        });

                // heap.track('Task Updated');

            }

        }
        ; //end updateTask


        function setupNotes() {
            // $log.info('setupNotes');
            $timeout(function () {
                var scroller = document.getElementById("noteList");
                scroller.scrollTop = scroller.scrollHeight;
                document.getElementById("newNoteBody").focus();
            }, 500, false);
        }



        ///////////////////////////////////////////////////////////
        /// batchDialog
        // opens dialog with the prepared editedItem

        function batchDialog(clientID, panel) {

            return userDataService.getLoggedInUser()
            .then(function(user){
                // $log.info('batchDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: batchDialog');
                var thisClient, thisPanel;

                if(clientID){
                    thisClient = clientID;

                    if(panel){
                        thisPanel = panel;
                    } else {
                        thisPanel = 'Later'
                    }
                } else {
                    // no client. just assign thisPanel
                    thisClient = undefined;
                    thisPanel = 'Later';
                }


                $mdDialog.show({
                    controller: 'batchDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-batch.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        client: thisClient,
                        panel: thisPanel,
                        assignedClients: $rootScope.quickClients
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });


            });// getLoggedInUser

        }
        ; //end batchDialog

        function addChecklistItem(item, task){

            // $log.info('addChecklistItem');
            // $log.info(task);
            // $log.info(task.uid);

            // add our completed property
            item.complete = false;
            var updates = {};

            // Items are at a different path depending on whether we are editing task templates or tasks
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    addItemToTaskTemplate();
                } else {

                    addItemToTask();

                }
            } else {

                addItemToTask();
            }

            function addItemToTask(){
                var newItemKey = firebase.database().ref().child('tasks/' + task.uid + '/checklist/').push().key;
                item.uid = newItemKey;
                // store our canonical object
                updates['/tasks/' + task.uid + '/checklist/' + newItemKey] = item;
                updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist)+1;
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)+1;
                logTask(task.uid, 'Checklist item added. ');
            }

            function addItemToTaskTemplate(){
                var newItemKey = firebase.database().ref().child('taskTemplates/' + task.uid + '/checklist/').push().key;
                item.uid = newItemKey;
                // store our canonical object
                updates['/taskTemplates/' + task.uid + '/checklist/' + newItemKey] = item;
                updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist)+1;
                updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numChecklistItems'] = _.size(task.checklist)+1;
            }

            return firebase.database().ref().update(updates);
        }// addChecklistItem

        function deleteChecklistItem(item, task){
            // $log.info('service.deleteChecklistItem');


            var updates = {};
            // Items are at a different path depending on whether we are editing task templates or tasks
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    updates['/taskTemplates/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                    updates['/taskTemplates/' + task.uid + '/checklist/' + item.uid] = null;
                    updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numChecklistItems'] = _.size(task.checklist)-1;

                } else {
                    updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                    updates['/tasks/' + task.uid + '/checklist/' + item.uid] = null;
                    updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
                }
            } else {
                updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                updates['/tasks/' + task.uid + '/checklist/' + item.uid] = null;
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
            }
            logTask(task.uid, 'Checklist item deleted. ');
            return firebase.database().ref().update(updates);

        }// deleteChecklistItem

        function updateChecklistItem(item, task){
            // $log.info(countCompletedItems(task));
            // $log.info(item);
            var updates = {};
            // Items are at a different path depending on whether we are editing task templates or tasks
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    updates['/taskTemplates/' + task.uid + '/checklist/' + item.uid] = item;
                    // don't forget we are storing a copy of the template in the client
                    updates['/clients/' + task.info.client +'/taskTemplates/'+ task.uid + '/info/checklist/' + item.uid ] = item;
                    updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                } else {
                    updates['/tasks/' + task.uid + '/checklist/' + item.uid] = item;
                    updates['/tasks/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                    updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
                }
            } else {
                updates['/tasks/' + task.uid + '/checklist/' + item.uid] = item;
                updates['/tasks/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
            }
            logTask(task.uid, 'Checklist item updated. ');
            return firebase.database().ref().update(updates);

        }// updateChecklistItem


        function makeChecklistItemCard(item, task){

                    // remove item from task
                    logTask(task.uid, 'Checklist item converted to task card. ');
                    service.deleteChecklistItem(item, task.uid);
                }// makeChecklistItemCard

        function countCompletedItems(task){
            var count = 0;
            _.each(task.checklist, function(item){
                if (item.complete){
                    count = count + 1;
                }
            });
            return count
        }



    } // end taskDataService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('batchDialogController', batchDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// batchDialogController

        /* @ngInject */
        function batchDialogController($scope, $mdDialog, $log, $timeout, $mdToast, rrule, $rootScope, hotkeys, localStorageService, userDataService, taskDataService) {
            // $log.info('batchDialogController');
            var vm = this;
            vm.thisClient = vm.locals.client;
            vm.thisPanel = vm.locals.panel;

              $timeout(function () {
                document.getElementById("focusfield").focus();
            }, 250, false);

            vm.saveTasks = function(text){
                var taskList = text.split("\n");
                _.each(taskList, function(task){
                    var newTask = taskDataService.newTask(vm.thisClient, vm.thisPanel);
                    newTask.info.description = task;
                    return taskDataService.saveNew(newTask);
                });
                $mdDialog.cancel();
            }
        }
        ; // end batchDialogController

})();

(function(){
	'use strict';


	angular.module('appServices')
	.service('profileDataService', profileDataService);


	/* @ngInject */
	function profileDataService($log, $http, pageDimensionsService, clientDataService, $mdMedia, $mdDialog, $rootScope, $timeout, hotkeys) {
		var service = {
			newProfileDetail: newProfileDetail,
			editProfileDetail: editProfileDetail,
			profileDetailDialog: profileDetailDialog,
			saveProfileDetail: saveProfileDetail,
			deleteProfileDetail: deleteProfileDetail,
			updateProfileDetail: updateProfileDetail,
		};

		return service;




	///////////////////////////////////////////////////////////
	/// profileDetailDialog
	function profileDetailDialog(detail, title){

		$mdDialog.show({
		  controller: detailDialogController, // see below
		  controllerAs: 'vm',
		  templateUrl: 'app/app-services/profileDataService/dialog-profile-detail-'+ detail.type + '.tmpl.html',
		  locals: {detail: detail, title: title},
		  bindToController: true,
		  focusOnOpen: false,
		  clickOutsideToClose:true,
		  fullscreen: true
		});


		 // Set focus
		$timeout(function () {
		    angular.element("input[name='detaillabel']").focus();
		}, 300);

	};


	///////////////////////////////////////////////////////////
	/// editProfileDetail
	function editProfileDetail(detail){
		var title = "Edit " + detail.type;
		var editedDetail = angular.copy(detail);
		if (editedDetail.dob) {
		    editedDetail.dob = new Date(editedDetail.dob);
		}
		profileDetailDialog(editedDetail, title);
		// heap.track('Edit Profile Card Started');
	}

	///////////////////////////////////////////////////////////
	/// newProfileDetail
	function newProfileDetail(type, panel, title, body){
		var detail = {};
		    detail.type = type;
		    detail.order = 100;

		  if(panel){
			var order = _.size(panel.details) + 1;
		  	detail.panel = panel.uid;
		  	detail.order = order;
		  	detail.client = panel.client;
		  }

		  if(body){
		  	detail.note = body;
		  }


		// If we are making a new URL, set the default richembed mode
		if (detail.type == 'url'){
			detail.simpleEmbed = true;
		}

		// If we are making a new URL, set the default richembed mode
		if (detail.type == 'note'){
			detail.notecolor = '#fffde7';

		} else {
			detail.notecolor = '#fff';
		}


		profileDetailDialog(detail, title);
		// heap.track('New Profile Card Started');


	};


	///////////////////////////////////////////////////////////
	/// deleteProfileDetail
	function deleteProfileDetail(detail){
		       // Appending dialog to document.body to cover sidenav in docs app
		       var confirm = $mdDialog.confirm()
		             .title('PERMANENTLY delete this ' + detail.type + '?')
		             .textContent(detail.label)
		             .ariaLabel('Delete card? Y//N')
		             .targetEvent(detail)
		             .ok('Yes, Delete')
		             .cancel('Cancel');
		       $mdDialog.show(confirm).then(function() {

		       	return firebase.database().ref().child('clients/' + detail.client + '/panels/' + detail.panel + '/details/' + detail.uid).remove().then(function(){
		       		$mdDialog.hide();
		       		pageDimensionsService.resizeColumns();
		       		// heap.track('Profile Card Deleted');
		       	});
			       }, function() {
		            $mdDialog.cancel();

			}); // end deleteProfileDetail

	}

	///////////////////////////////////////////////////////////
	/// saveProfileDetail
	function saveProfileDetail(detail) {
		var detailCopy = angular.copy(detail);
		if (detailCopy.dob) {
		    detailCopy.dob = detailCopy.dob.toISOString();
		}
		var newDetailKey = firebase.database().ref().child('clients/' + detailCopy.client + '/panels/' + detailCopy.panel + '/details/').push().key;
		detailCopy.uid = newDetailKey;
		var updates = {};

		// store our canonical object
		updates['/clients/'+detailCopy.client+'/panels/'+ detailCopy.panel +'/details/' + newDetailKey] = detailCopy;

		// heap.track('New Profile Card Saved');
		return firebase.database().ref().update(updates)

	};// end addProfileDetail


	///////////////////////////////////////////////////////////
	/// updateProfileDetail
	function updateProfileDetail(detail) {
		var detailCopy = angular.copy(detail);
		if (detailCopy.dob) {
		    detailCopy.dob = detailCopy.dob.toISOString();
		}
		var updates = {};

		// store our canonical object
		updates['/clients/'+detailCopy.client+'/panels/'+ detailCopy.panel +'/' + '/details/' + detailCopy.uid] = detailCopy;

		// heap.track('Profile Card Updated');
		return firebase.database().ref().update(updates);
		pageDimensionsService.resizeColumns();


		}


		////////////////////////////////////////////////////////////
		///////////////////////////////////////////////////////////
		/// detailDialogController

		/* @ngInject */
		function detailDialogController($scope,$state, $rootScope, $mdToast){
			var vm = this;
			vm.showPicker = false;
			vm.countries = $rootScope.countries;
			vm.assignedClients = $rootScope.quickClients;
			vm.panels = [];
			vm.filePath = 'profile';
			// Prep our files array
			vm.numFiles = 0;
			if (_.has(vm.detail, 'files')) {
			    vm.numFiles = vm.detail.files.length;
			} else {
			    vm.detail.files = [];
			}
			if (vm.detail.type == 'url' && !vm.detail.url){
				vm.detail.url = 'http://';
			}

			if(!_.has(vm.detail, 'panel')){
				// $log.info(vm.detail.panel);
				vm.showPicker = true;
			}

			vm.loadPanels = function(clientID){
				vm.panels = [];
				// $log.info('setClient ' + clientID);
				clientDataService.getClient(clientID)
				        .then(function (clientData) {
				        	_.each(clientData.panels, function(panel){
				        		vm.panels.push(panel);
				        	});
				        });// then
			}

			// If we are in a client space, we should make that the active client
			// and load up their panels
			if($state.params.clientID){
				vm.detail.client = $state.params.clientID;
				vm.loadPanels($state.params.clientID);
			}


			// $log.info(vm.numFiles);

			// Setup & Bind Hotkeys
			// when you bind it to the controller's scope, it will automatically unbind
			// the hotkey when the scope is destroyed
			hotkeys.bindTo($scope)
			.add({
			  combo: 'enter',
			  callback: function(event) {
			    event.preventDefault();
			    // $log.info('enter blocked');
			  }
			})
			  .add({
			    combo: 'ctrl+enter',
			    description: 'Save Detail',
			    allowIn: ['INPUT', 'SELECT', 'TEXTAREA', 'DIV'],
			    callback: function(event, hotkey) {
			      // This doesn't appear to be working
			      // event.preventDefault();
			      // $log.info('ctrl + enter');
				if ($scope.vm.detail.uid){
			        $scope.updateDetail($scope.vm.detail);
			      } else {
			        $scope.saveNewDetail($scope.vm.detail);
			      }
			    }
			  });

			  // configure color chooser

			  if(vm.detail.type == 'note'){
			  	// $log.info('have note autofocussing');
			  	$timeout(function() {

			  	    angular.element('text-angular').find('*[id*=taText]').focus();
			  	});
			  }


		  	$scope.colors = ['#fff', '#fffde7', '#e8f5e9', '#e1f5fe', '#fce4ec', '#ede7f6'];


			$scope.saveNewDetail = function saveNewDetail(detail){

			    saveProfileDetail(detail);
			    $scope.cancelDialog();
			    $scope.editedItem = null;
			    pageDimensionsService.resizeColumns();
			}

			$scope.colorChange = function(){
			  // $log.info('colorChange');
			  $scope.detailDialogForm.$setDirty();
			};

			$scope.uploadAvatar = function($files, detail) {
			    // $log.info('upload file');
			    // $log.info($files);
			    if ($files !== null && $files.length > 0) {
			        var storage = firebase.storage(),
			            storageRef = storage.ref();
			        _.each($files, function(file) {
			            var filename = ref.currentUser.uid + '_' + file.name;
			            // $log.info('Saving '+filename);
			            // create imageRef and put the file
			            var imageRef = storageRef.child('avatars/' + filename),
			                uploadTask = imageRef.put(file);

			            uploadTask.on('state_changed', function(snapshot) {
			                // $log.info('upload state changed');
			            }, function(error) {
			                // $log.warn('upload failed');
			            }, function(success) {
			                // $log.info('upload success');

			                detail.avatar = uploadTask.snapshot.downloadURL;
			                $scope.detailDialogForm.$setDirty();
			                $mdToast.show(
			                      $mdToast.simple()
			                        .textContent('Profile photo uploaded. Thanks!')
			                        .position('top right')
			                        .hideDelay(2000)
			                    );
			                // heap.track('Contact Avatar Uploaded');
			            }); // uploadTask.on
			        }); // ._each files
			    } // if files
			}; // $scope.uploadAvatar

			$scope.updateDetail = function updateDetail(detail){
				// $log.info(detail);
			    updateProfileDetail(detail);
			    $scope.cancelDialog();
			    pageDimensionsService.resizeColumns();
			}

			$scope.cancelDialog = function cancelDialog(dialog){
			  // I don't think I'm doing this properly (see fn above)
			  // unbindDetail();
			  $mdDialog.cancel();
			}

			$scope.removeFile = function(chip){
				// $log.info('removeFile');
				// $log.info(chip);

				// Create a reference to the file to delete
				var storage = firebase.storage(),
					storageRef = storage.ref();
				var fileRef = storageRef.child('clients/' + vm.detail.client + '/' + chip.fileName);

				// Delete the file
				fileRef.delete().then(function() {
				  // File deleted successfully
				  // $log.info('File ' + chip.fileName + ' deleted.');
				  // $mdToast.showSimple(chip.filenName + ' deleted.');
				  // heap.track('Profile Card File Deleted');
				}).catch(function(error) {
				  // Uh-oh, an error occurred!
				  $log.info('Oops! File ' + chip.fileName + ' NOT! deleted.');
				});
			}

			$scope.uploadFile = function($files) {
			    // $log.info('upload file');
			    // $log.info($files);

			    if ($files !== null && $files.length > 0) {
			        var storage = firebase.storage(),
			            storageRef = storage.ref();
			        _.each($files, function(file) {
			            var filename = file.name;
		            	  vm.isUploading = true;

			            // $log.info('Saving '+filename);
			            // create imageRef and put the file
			            var fileRef = storageRef.child('clients/' + vm.detail.client + '/' + filename),
			                uploadTask = fileRef.put(file);

			            uploadTask.on('state_changed', function(snapshot) {
			                // $log.info('upload state changed');
			            }, function(error) {
			                // $log.warn('upload failed');
			            }, function(success) {
			                // $log.info('upload success');
			                var fileObject = {
			                	fileName: filename,
			                	url: uploadTask.snapshot.downloadURL
			                }
			                // $log.info(fileObject.url);
			                // Put file references on our detail object
			                if (vm.detail.files){
			                	// $log.info(vm.detail);
			                	// $log.info(fileObject);
			                	vm.detail.files.push(fileObject);
			                } else {
			                	// $log.info(fileObject);
			                	vm.detail.files = [];
			                	// $log.info(vm.detail);
			                	vm.detail.files.push(fileObject);
			                }

			                $scope.detailDialogForm.$setDirty();
			                vm.isUploading = false;
			                vm.numFiles = vm.numFiles + 1;

			                $mdToast.show(
	                               $mdToast.simple()
	                                 .textContent('File uploaded. Thanks!')
	                                 .position('top right')
	                                 .hideDelay(2000)
	                             );
			                // heap.track('Profile Card File Uploaded');


			            }); // uploadTask.on
			        }); // ._each files
			    } // if files
			}; // vm.uploadAvatar

		}


	};// end profileDataService







	})
();



(function() {
    'use strict';
    angular.module('appServices')
        .service('presenceService', presenceService);

    /* @ngInject */
    function presenceService($log, $http, $firebaseArray, $mdDialog, $firebaseAuth, triLoaderService, $firebaseObject, authFactory, $mdToast) {
       var service = {
       	monitor: monitor
              };

       return service;



       function monitor(uid){
           var waitingForReconnect = false, showingReconnected = false;
           // Setup presence monitoring
           ////////////////////////////////////////////////////////
           // Manage Presence
           // since I can connect from multiple devices or browser tabs, we store each connection instance separately
           // any time that connectionsRef's value is null (i.e. has no children) I am offline
               var myConnectionsRef = firebase.database().ref('connections');

               // stores the timestamp of my last disconnect (the last time I was seen online)
               var lastOnlineRef = firebase.database().ref('users/' + uid + '/lastOnline');

               var connectedRef = firebase.database().ref('.info/connected');

               // We are getting" offline" status when we shouldn't.
               // attempting to start with an off call per: http://stackoverflow.com/questions/38151265/firebase-ondisconnect-firing-multiple-times
               // to see if it fixes.
               connectedRef.off();
               connectedRef.on('value', function(snap) {
                 if (snap.val() === true) {
                   // We're connected!
                   // add this device to my connections list
                   var con = myConnectionsRef.push(true);

                   // if this was a reconnection, let the user know
                   if(waitingForReconnect){
                       waitingForReconnect = false;
                       $mdDialog.cancel();
                   }// if waitingForReconnect

                   // when I disconnect, remove this device
                   con.onDisconnect().remove();

                   // when I disconnect, update the last time I was seen online (this actually happens on the server via firebase magic)
                   lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
                 } else {
                   // we've been disconnected!
                   waitingForReconnect = true;
                   $mdDialog.show({
                             controller: presenceDialogController, // see below
                             controllerAs: 'vm',
                             // bindToController: true,
                             templateUrl: 'app/app-services/presenceService/dialog-presence.tmpl.html',
                             locals: {
                                 title: 'Network Alert',
                                 message: 'There is no network connection. Operations have been paused.\nPlease make sure you are connected to the internet.',
                                 button: false
                             },
                             focusOnOpen: false,
                             clickOutsideToClose: false,
                             escapeToClose: false
                         });


               };
       });

        function presenceDialogController(title, message, button){
          var vm = this;
          vm.title = title;
          vm.message = message;
          vm.showButton = button;

          vm.cancelDialog = function(){
            $mdDialog.cancel();
          }
        };


       }

       }// fbService





})
();

(function() {
    'use strict';


    angular.module('appServices')
        .service('panelDataService', panelDataService);

    /* @ngInject */
    function panelDataService($log, $http, pageDimensionsService, $mdToast, clientDataService, $firebaseArray, $firebaseObject, $mdMedia, $mdDialog, $rootScope, $timeout, $window) {
        var service = {
            newPanel: newPanel,
            editPanel: editPanel,
            createPanel: createPanel,
            deletePanel: deletePanel,
            saveUpdatedPanel: saveUpdatedPanel

        };

        return service;



        ///////////////////////////////////////////////////////////
        /// editPanel
        function editPanel(panel) {
        var editPanel = angular.copy(panel),
            clientID = panel.client;

            $mdDialog.show({
              controller: panelDialogController,// see below
              controllerAs: 'vm',
              templateUrl: 'app/app-services/panelDataService/dialog-profile-panel.tmpl.html',
              locals: {panel: editPanel, clientID: clientID},
              // targetEvent: $event,
              focusOnOpen: false,
              clickOutsideToClose: true,
              fullscreen: true
          });

        };



        ///////////////////////////////////////////////////////////
        /// deletePanel
        function deletePanel(panel) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('PERMANENTLY delete this bucket?')
                .textContent(panel.label)
                .ariaLabel('Delete detail? Y//N')
                .targetEvent(panel)
                .ok('Yes, Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                // Locate the detail record in our client array
                return firebase.database().ref().child('clients/' + panel.client + '/panels/' + panel.uid).remove().then(function(){
                $mdToast.showSimple('Bucket Removed');
                // heap.track('Bucket Deleted');
                });
            }, function() {
                // $log.inf('delete panel cancelled');

            });
        }// end deletePanel

        ///////////////////////////////////////////////////////////
        /// createPanel
        function createPanel(panel) {
            // $log.info('panelDataService.createPanel');
            // $log.info(panel);
            // Get new key
            var newPanelKey = firebase.database().ref().child('clients/' + panel.client + '/panels').push().key;
            // make sure you store it's key location as a uid
            panel.uid = newPanelKey;


            var updates ={};
            // store our canonical object
            updates['/clients/' + panel.client + '/panels/' + newPanelKey] = panel;

            // heap.track('New Bucket Saved');
            return firebase.database().ref().update(updates);

        }; // end createPanel

        ///////////////////////////////////////////////////////////
        /// saveUpdatedPanel
        function saveUpdatedPanel(panel) {
            var updates ={};

            // store our canonical object
            updates['/clients/' + panel.client + '/panels/' + panel.uid] = panel;
            // heap.track('Bucket Updated');
            return firebase.database().ref().update(updates);

        }

        ///////////////////////////////////////////////////////////
        /// newPanel
        function newPanel(clientID) {
            // $log.info('panelDataService.newPanel(' + clientID + ')');
            var sort = angular.element('profile-panel').length;
            var panel = {
                client: clientID,
                details: [],
                order: sort+1
            };


            $mdDialog.show({
                controller: panelDialogController,// see below
                controllerAs: 'vm',
                templateUrl: 'app/app-services/panelDataService/dialog-profile-panel.tmpl.html',
                locals: {panel: panel, clientID: clientID},
                // targetEvent: $event,
                focusOnOpen: false,
                clickOutsideToClose: true
            });

            // heap.track('New Bucket Started');

        };

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// Panel Dialog Controller

        /* @ngInject */
        function panelDialogController(panel, $scope, hotkeys, $timeout) {
            var vm = this;
            vm.panel = panel;
            vm.colors = $rootScope.clientColors;
            $timeout(function(){
                $('input[name="detaillabel"]').focus();
            },300)

            vm.showColors = false;
            vm.toggleColors = function(){
                if(!vm.showColors){
                    vm.showColors = true;
                } else {
                    vm.showColors = false;
                }
            }

            // Hide color panel after selection made
            $scope.$watch('vm.panel.color', function (newValue, oldValue, scope) {
                if(vm.showColors){
                    vm.toggleColors();
                }
            });

            // Setup Hotkeys for this dialog
            hotkeys.bindTo($scope)
                // inhibit enter from submitting
                .add({
                  combo: 'enter',
                  callback: function(event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                  }
                })
                .add({
                  combo: 'ctrl+enter',
                  allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  description: 'Save/Update Bucket',
                  callback: function(event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info($scope.clientDialogForm);
                    var pristine = $scope.vm.panelDialogForm.$pristine,
                        invalid = $scope.vm.panelDialogForm.$invalid;

                        if (!pristine && !invalid && vm.panel.uid){
                            $scope.updatePanel($scope.vm.panel);
                        }

                        if (!pristine && !invalid && !vm.panel.uid){
                            $scope.saveNewPanel($scope.vm.panel);
                        }
                    }
                });


            $scope.saveNewPanel = function saveNewPanel(panel) {
                createPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('Bucket ' + panel.label + ' created.');
                // $scope.editedPanel = null;
                pageDimensionsService.resizeColumns();
            }

            $scope.updatePanel = function updatePanel(panel) {
                // $log.info('DialogControl: updatePanel');
                // $log.info(panel);
                saveUpdatedPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('Bucket ' + panel.label + ' updated.');
                pageDimensionsService.resizeColumns();
            }

            $scope.cancelDialog = function cancelDialog(dialog) {
                $mdDialog.cancel();
            }


        }


    }; // end panelDataService


})
();

(function() {
    'use strict';


    angular.module('appServices')
        .service('noteDataService', noteDataService);

    /* @ngInject */
    function noteDataService($mdToast, $q, $log, notificationService, teamDataService, taskDataService, userDataService, localStorageService, $http, pageDimensionsService, clientDataService, $mdMedia, $mdDialog, $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            saveNote: saveNote,
            deleteNote: deleteNote,
            updateNote: updateNote
        };


        return service;

        function saveNote(newNote, taskID, clientID, numnotes, teamList){
            var note = angular.copy(newNote),
                client = _.find(clientDataService.getQuickClients(), function(client) { return client.uid == clientID; }),
                newNoteKey = firebase.database().ref().child('tasks/' + taskID + '/notes').push().key;

            note.uid = newNoteKey;
            note.date = Date.now();
            note.author = userDataService.user.uid;
            note.authorName = userDataService.user.profile.fullName;
            note.clientName = client.name;

            // declare our updates
            var updates = {};

            // store our canonical object
            updates['/tasks/' + taskID + '/notes/' + newNoteKey] = note;

            // update numnotes on /tasks and /clients/task reference
            updates['/tasks/' + taskID + '/info/numnotes' ] = numnotes;
            updates['/clients/' + clientID + '/tasks/' + taskID + '/numnotes'] = numnotes;

            // Save the note
            return firebase.database().ref().update(updates)
            .then(function(){
                // prep notification
                var notification = {
                  title: 'Comment from ' + note.authorName,
                  message: note.body,
                  meta: 'Task Update: ' + note.clientName,
                  type: 'comment',
                  related: taskID
                }

                // notify all team members except one leaving the comment
                _.each(teamList, function(member){
                  // $log.info('Sending notification to: ' + member.uid);
                    if(member.uid != userDataService.user.uid){
                        notification.assignee = member.uid;
                        notificationService.notify(notification);
                    }
                });// each team member

                // log the event on the task
                taskDataService.logTask(taskID, 'Comment added.');

                // if we are to notify the client, send off that email
                if (note.notifyClient){
                    return taskDataService.getTask(taskID)
                    .then(function(task){
                        var serialize = function(obj) {
                          var str = [];
                          for(var p in obj)
                            if (obj.hasOwnProperty(p)) {
                              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            }
                          return str.join("&");
                        }


                        var budget = task.info.budget/60;
                        var newImage = new Image();
                        var message = {};
                        message.recipientEmail = client.email;
                        message.message = task.info.description + '<br><br>' + note.body;
                        message.subject = task.info.description.substring(0, 100);
                        message.budget = budget.toFixed(2);
                        message.due = moment(task.info.duedate).format('MM/DD/YYYY')
                        message.logged = $filter('HandM')(task.info.logged);
                        message.status = task.info.status;
                        message.sender = note.authorname;
                        message.senderEmail = userDataService.user.email;
                        var payload = serialize(message);
                        ;
                        newImage.src = "https://hooks.zapier.com/hooks/catch/44307/tkzfyb/?"+payload;

                    })
                }
            })// return Updates
        } // saveNote


        function deleteNote(note, taskID, clientID){
            // $log.info("deleteNote");

               // Update our canonical task
              var updates  = {}
              updates['/tasks/' + taskID + "/notes/" + note.uid ] = null;

               // Execute Updates
               // heap.track('Task Note Deleted');
               return firebase.database().ref().update(updates)
               .then(function(){
                    // Update Task's numnotes
                    return taskDataService.getTask(taskID)
                    .then(function(task){
                         // client's tasks are just our task.info
                         var workingTask = task.info;
                         // with a refID
                         workingTask.refID = task.uid;
                         // update numnotes total
                         workingTask.numnotes = workingTask.numnotes -1;
                         // Execute a quickupdate
                         taskDataService.quickUpdate(workingTask);
                    })
                    .then(function(response){
                        taskDataService.logTask(taskID, 'Comment deleted.');
                        $mdToast.show(
                             $mdToast.simple()
                               .textContent('Note removed')
                               .position('top right')
                               .hideDelay(2000)
                           );
                    })

               });
        }// deleteNote

        function updateNote(note, taskID, clientID){
            // $log.info("updateNote");
            delete note.$id;
            delete note.$priority;
            var updates = {};
             // store our canonical object
             updates['/tasks/' + taskID + '/notes/' + note.uid] = note;

             // Execute our updates
             return firebase.database().ref().update(updates)
                 // Add the default "Client Details" panel to this client
                 .then(function(response) {
                    taskDataService.logTask(taskID, 'Comment edited.');
                    taskDataService.setupNotes();
                 });
        }// updateNote


    } // end noteDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('notificationService', notificationService);

    /* @ngInject */
    function notificationService($log, $sce, moment, userDataService, taskDataService, $rootScope, $firebaseArray, $firebaseObject) {
        var service = {
            notify: notify,
            init: init
        };


        return service;


        function init(){

        }// init

        function sanitizeMe(text) {
            return $sce.trustAsHtml(text)
        };

       function notify(notification){
        // $log.info('notify');
        // $log.info(notification.assignee);

        // notification should include:
        //    - a title
        //    - a message
        //    - a meta
        //    - an assignee (as an array with one property userID)
        //    - optional - a type (general(default), task, email, tip, fix, thanks, recurring, retainer, date, alert, new)
        //    - optional - a 'team' ID (for sending notifications to an entire team)
        //    - optional - a related item ID (task/recurring task)


        // if a type wasn't set, set it to general
        if(!_.has(notification, 'type')){
          notification.type = 'general';
        }

        // Create our targets array
        var targets = [];

        if(_.has(notification, 'team')){
          // create a targetArray from the team and remove the property
          delete notification.team
        } else {
          var thisUser = {
            userID: notification.assignee
          };
          targets.push(thisUser);
        }
        notification.targets = targets;


        var notificationRef = firebase.database().ref('notifications');
        var notificationKey = notificationRef.push().key,
            updates = {};
        updates['/notifications/' + notificationKey] = notification;
        return firebase.database().ref().update(updates)
                .then(function () {
                    // $log.info('sorted');
                });

       }// notify


    } // end notificationService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('messagingService', messagingService);

    /* @ngInject */
    function messagingService($log, $mdMedia, $mdDialog, $mdToast, userDataService, $rootScope,$timeout, $firebaseArray, $firebaseObject, $window) {
        var messaging = firebase.messaging(); // Retrieve Firebase Messaging object.

        var userRef = undefined;
        var service = {
            init: init,
            storeToken: storeToken,
            refreshToken: refreshToken,
            requestPermission: requestPermission
        };

        return service;

        //

        // Initialize service.timerData object
        function init(){
            // $log.info('messagingService Initializing');
            userRef = firebase.database().ref('users/');
             // Get Instance ID token. Initially this makes a network call, once retrieved
              // subsequent calls to getToken will return from cache.
              return messaging.getToken()
              .then(function(currentToken) {
                // $log.info('We have a token:' + currentToken);
                if (currentToken) {
                  // $log.info('token success');
                  // $log.info('storing for user:' + $rootScope.userID);
                  // store the token on the user so any notifications we send will go to the right place
                    service.storeToken(currentToken, $rootScope.userID);
                    return
                } else {
                  // Show permission request.
                  console.log('No Instance ID token available. Request permission to generate one.');
                  // Show permission UI.
                  // updateUIForPushPermissionRequired();
                  // setTokenSentToServer(false);
                  // if(userDataService.getUser().limits.hasNotifications){
                  //   requestPermission();
                  // }
                  requestPermission();
                  return
                }
              })
              .catch(function(err) {
                console.log('An error occurred while retrieving token. ', err);
                // showToken('Error retrieving Instance ID token. ', err);
                // setTokenSentToServer(false);
              });

        }// messagingService.init

        function storeToken(token, userID){
          // $log.info('storeToken');
          // $log.info(token, userID);
          return userRef.child(userID).child('deviceID').set(token)
          .then(function(res){
            // $log.info('Response:', res);
          });
        }

        function requestPermission(){
          // $log.info('requesting permission to notify');
            messaging.requestPermission()
               .then(function(result) {
                 // $log.info('Notification permission granted.')
                 $mdToast.show($mdToast.adminjaAlert(
                     {
                         locals:{
                             title: 'Notifications Enabled!',
                             message: '',
                             color: '#fff'
                         }
                     }));
                 // re-init service to get and store the devices new token
                 // heap.track('Enabled Notifications');
                 service.init();
               })
               .catch(function(err) {
                 $log.error('Unable to get permission to notify. ', err)
               });
        }// requestPermission

        function refreshToken(){
          messaging.getToken()
          .then(function(refreshedToken) {
            console.log('Token refreshed.');
            service.storeToken(refreshedToken);
          })
          .catch(function(err) {
            $log.error('Unable to retrieve refreshed token ', err);
            // showToken('Unable to retrieve refreshed token ', err);
          });
        }




    } // end messagingService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('invoiceService', invoiceService)
            .controller('emailInvoiceDialogController', emailInvoiceDialogController);

    /* @ngInject */
    function invoiceService($log, moment, taskDataService,
                userDataService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject) {


        var service = {
            init: init,
            newInvoice: newInvoice,
            saveInvoice: saveInvoice,
            updateInvoice: updateInvoice,
            deleteInvoice: deleteInvoice,
            lockTimeEntries: lockTimeEntries,
            lockLineItems: lockLineItems,
            selectInvoice: selectInvoice,
            unlockTimeEntries: unlockTimeEntries,
            unlockLineItems: unlockLineItems,
            calcInvoice: calcInvoice,
            preparePDF: preparePDF,
            createPDF: createPDF,
            getLastInvoice: getLastInvoice,
            mailInvoiceDialog: mailInvoiceDialog
        };

        return service;

        var userID = undefined;

        // Initialize service.timerData object
        function init(client){
            var user = firebase.auth().currentUser;
            if (user){
              userID = user.uid;
              // clear our selected Period
              delete service.selectedInvoice;
              delete service.lastInvoiceNumber;
              getLastInvoice(client);
            }
        }

      service.lastInvoiceNumber = {};

      function getLastInvoice(client){
        // clear out from previous use
        delete service.lastInvoiceNumber;
        service.lastInvoiceNumber = 0;
        var invoiceListRef = firebase.database().ref('invoiceNumbers').child(client.owner);
        $firebaseArray(invoiceListRef.orderByChild('date').limitToLast(1))
        .$loaded(function (invoices) {
          if(_.has(invoices[0], 'number')){
            service.lastInvoiceNumber = invoices[0].number
          }
         });
      }// get invoices



      // Creates a new invoice object to be edited
      function newInvoice(user, billingPeriod, lineItems, time){
        // $log.info('newInvoice');

        // We'll need the full client object to build our invoice
        return clientDataService.getClient(billingPeriod.info.client)
        .then(function(client){
          var invoiceRef = firebase.database().ref('invoices'),
              // newInvoiceKey = invoiceRef.push().key,
              invoice = {
                // 'uid': newInvoiceKey,
                'lineItems': lineItems,
                'time': time
              };

              var remitCompany = "";
              if(_.has(user, 'profile.company')){
                remitCompany = user.profile.company;
              } else {
                remitCompany = user.profile.firstname + ' ' + user.profile.lastname;
              }

              if(_.has(user.profile, 'address')){
                invoice.remit={
                  company: remitCompany,
                  street: (typeof user.profile.address.street === 'undefined') ? "Missing street" : user.profile.address.street,
                  city: user.profile.address.city || "Missing city",
                  state: user.profile.address.state || "Missing state",
                  zip: user.profile.address.zip || "Missing postal code"
                }
              } else {
                invoice.remit={
                  company: remitCompany,
                  street: 'Missing Street',
                  city: 'Missing City',
                  state: 'Missing State',
                  zip: 'Missing Postal Code'
                }
              }


              // only add street2 if it's there
              if(_.has(user, 'profile.address.street2')){
                invoice.remit.street2 = user.profile.address.street2;
              }

              // only add country if it's there
              if(_.has(user, 'profile.address.country')){
                invoice.remit.country = user.profile.address.country;
              }


              // get some possibly empty values from client
              var address = {};
              if(_.has(client, 'profile.address.street')){
                address.street = client.profile.address.street;
              } else {address.street = "Street Address"};

              if(_.has(client, 'profile.address.city')){
                address.city = client.profile.address.city;
              } else {address.city = "City/Town"};

              if(_.has(client, 'profile.address.state')){
                address.state = client.profile.address.state;
              } else {address.state = "State"};

              if(_.has(client, 'profile.address.zip')){
                address.zip = client.profile.address.zip;
              } else {address.zip = "Postal Code"};

              if(_.has(client, 'profile.address.country')){
                address.country = client.profile.address.country;
              } else {address.country = "Country"};

          var newInvoiceNumber = _.toNumber(service.lastInvoiceNumber) + 1;
          newInvoiceNumber = _.padStart(newInvoiceNumber, 5, '0');
          invoice.info = {
              number: newInvoiceNumber,
              owner: billingPeriod.owner,
              billingPeriod: billingPeriod.uid,
              date: moment().toDate(),
              due: moment().add(1, 'month').toDate(),
              terms: user.profile.invoiceTerms,
              status: 'open',
              client: client.uid,

              recipient:{
                name: client.profile.fullName,
                email: client.profile.email,
                address: address.street,
                city: address.city || "City",
                state: address.state || "State",
                postal: address.zip || "Zip",
                country: address.country || "Country",
              }

          } // invoice.info declaration

        return invoice
        });
      } // newInvoice

      // Saves a new invoice
      function saveInvoice(invoice){
        // $log.info('saveInvoice');
        var invoiceRef = firebase.database().ref('invoices'),
            newInvoiceKey = invoiceRef.push().key;

        invoice.uid = newInvoiceKey;
        invoice.info.uid = newInvoiceKey;

        var shortInvoice = {
          uid: newInvoiceKey,
          number: invoice.info.number,
          date: invoice.info.date,
          due: invoice.info.due,
          owner: invoice.info.owner
        }
        // Send copies to lock (in case invoice gets removed before locking finished)
        var timeCopy = angular.copy(invoice.time),
            lineItemCopy = angular.copy(invoice.lineItems);
        service.lockTimeEntries(timeCopy);
        service.lockLineItems(lineItemCopy);

        ajUTILITIES.removePropertiesWith(invoice);

        // Check to make sure terms and notes aren't blank
        if(!invoice.info.terms){
            invoice.info.terms = "";
        }
        if(!invoice.info.notes){
            invoice.info.notes = "";
        }

        // Update the database
        var updates = {};
        // store our canonical object
        updates['invoices/' + newInvoiceKey] = invoice;
        // store a shortinvoice on our owner-based list of invoice numbers
        updates['invoiceNumbers/' + invoice.info.owner + '/' + newInvoiceKey] = shortInvoice;
        // store our reference in the client's store
        updates['clients/' + invoice.info.client + '/invoices/' + newInvoiceKey ] = true;
        // store our reference in the billingPeriod's store
        updates['billingPeriods/' + invoice.info.billingPeriod + '/invoices/' + newInvoiceKey ] = invoice.info;
        // Execute our update
        return firebase.database().ref().update(updates)
                .then(function () {
                  // re-select the new invoice
                    service.selectInvoice(newInvoiceKey);
                  // update our lastInvoiceNumber
                  service.lastInvoiceNumber = invoice.info.number;
          });
      } // saveInvoice

      // Update existing invoice
      function updateInvoice(invoice){
        // $log.info('updateInvoice');
        var invoiceCopy = angular.fromJson(angular.toJson(invoice));
        // Remove our PDF since we've changed the invoice. Needs to be generated again.
        delete invoiceCopy.pdf

        var timeCopy = undefined, lineItemCopy = undefined;
        // Send copies to lock (in case we added new items)
        var timeCopy = angular.copy(invoice.time),
            lineItemCopy = angular.copy(invoice.lineItems);

        // clean out our firebase $ cruft
        ajUTILITIES.removePropertiesWith(invoiceCopy);
        if(timeCopy){
          ajUTILITIES.removePropertiesWith(timeCopy);
        }
        if(lineItemCopy){
          ajUTILITIES.removePropertiesWith(lineItemCopy);
        }
        // Update the database
        var updates = {};
        // update our canonical object
        updates['invoices/' + invoiceCopy.uid] = invoiceCopy;
        // update our billingPeriod's copy
        updates['billingPeriods/' + invoiceCopy.info.billingPeriod + '/invoices/' + invoiceCopy.uid] = invoiceCopy.info;
        // Update this item in our invoiceLIst
        updates['invoiceNumbers/' + invoiceCopy.info.owner + '/' + invoiceCopy.info.uid + '/number'] = invoiceCopy.info.number;
        // Execute our update
        // TODO - this always yields a TypeError from firebase when we are updating after removing a line item. No idea why

        return firebase.database().ref().update(updates)
                .then(function () {
                  service.lockTimeEntries(timeCopy);
                  service.lockLineItems(lineItemCopy);
                  // re-select the new invoice
                  // service.selectInvoice(invoiceCopy.uid);
          });
      } // updateInvoice

      // Deletes existing invoice
      function deleteInvoice(invoice){
        // $log.info('deleteInvoice');
        // Unlock time and lineItems so they can be freed for a different invoice
        if (_.has(invoice, 'time')){
          service.unlockTimeEntries(invoice.time);
        }
        if(_.has(invoice, 'lineItems')){
          service.unlockLineItems(invoice.lineItems);
        }

        var updates = {};
        updates['invoices/' + invoice.uid] = null;
        updates['billingPeriods/' + invoice.info.billingPeriod + '/invoices/' + invoice.uid] = null;
        return firebase.database().ref().update(updates)
        .then(function(){
          $timeout(function(){
            delete service.selectedInvoice
          }, 0);

        })
      } // deleteInvoice

      // Sets "invoiced" status of time entries in this invoice to true.
      function lockTimeEntries(entries){
        // $log.info('lockTimeEntries');
        var updates = {};

        _.each(entries, function(thisEntry){
          updates['time/' + thisEntry.uid + '/invoiced'] = true;
        });
        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // lockTimeEntries

      // Sets "invoiced" status of line items in this invoice to true.
      function lockLineItems(items){
        // $log.info('lockLineItems');
        var updates = {};

        _.each(items, function(item){
          updates['billingPeriods/' + service.selectedInvoice.info.billingPeriod + '/lineItems/' + item.uid + '/invoiced'] = true;
        });

        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // lockLineItems

      function putInView() {
               $('#scroll-h').animate({
                   scrollLeft: 3000
               }, 20, 'linear');
           }

      // Sets the service.selectedInvoice to the invoice matching the passed ID
      function selectInvoice(invoiceID){
        // $log.info('selectInvoice');
        // $log.info('selectPeriod:', period);
        var newInvoice = {},
            invoiceRef = firebase.database().ref('invoices/' + invoiceID);
        return $firebaseObject(invoiceRef)
        .$loaded(function (data) {
            service.selectedInvoice = data;
            putInView();
            // $log.info(service.selectedInvoice);
        });
      } // selectInvoice

      // Sets "invoiced" status of time entries in this invoice to false.
      function unlockTimeEntries(entries){
        // $log.info('unlockTimeEntries');
       var updates = {};
               _.each(entries, function(thisEntry){
                 updates['time/' + thisEntry.uid + '/invoiced'] = false;
               });
               // Execute our atomic update
               return firebase.database().ref().update(updates)
               .then(function () {
                   // $log.info('sorted');
               });
      } // unlockTimeEntries

      // Sets "invoiced" status of line items in this invoice to false.
      function unlockLineItems(items){
        // $log.info('unlockLineItems');
        var updates = {};

        _.each(items, function(item){
          updates['billingPeriods/' + service.selectedInvoice.info.billingPeriod + '/lineItems/' + item.uid + '/invoiced'] = false;
        });

        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // unlockLineItems

      // Calculates the total for the selectedInvoice
      function calcInvoice(){
        // $log.info('calcInvoice');
      } // calcInvoice



      // Saves invoice to /pdfRequests so a pdf can be created and attached for download/sending
      function createPDF(invoice , next){
        // $log.info('createPDF');
        // save a copy of our invoice in pdfRequests
        var invoiceCopy = angular.fromJson(angular.toJson(invoice));
        ajUTILITIES.removePropertiesWith(invoiceCopy);
        var updates = {};
        updates['pdfRequests/'+ invoiceCopy.uid] = invoiceCopy;
        // Execute our update
        return firebase.database().ref().update(updates)
                .then(function () {
                    // $log.info('pdfRequest sent');
                  // if there's a next step, let's handle it
                });

      } // printInvoice

      function preparePDF(invoice, user, client, next){
        // $log.info(invoice);
        // Add our client info to our invoice so cloud function has all the info it needs to build invoice
        invoice.client = client.profile;

        invoice.time = _.sortBy(invoice.time, ['logDate']);
        invoice.lineItems = _.sortBy(invoice.lineItems, ['date']);

        // prepare a new Filename
        if(_.has(client.profile, 'firstName')){
            var newFilename = client.profile.firstName + '_' + client.profile.lastName+'_invoice-'+ invoice.info.number + '.pdf';
        } else {
            var newFilename = client.profile.firstname + '_' + client.profile.lastname+'_invoice-'+ invoice.info.number  + '.pdf';
        }

        // Prepare our the pdf node of our pdfRequest
        var pdf = {
            template: 'invoice',
            filename: newFilename,
            parentPath: "invoices/"+ invoice.uid
        }

        // if we are not emailing the PDF (i.e. we are waiting for it)
        // set our indicator on the invoice
        if(!next){
          pdf.link = 'pending'
        }

        // if we have a "next" step, add it to our pdf request
        if(next){
            if (next == 'emailClient'){
                pdf.next = 'emailClient';
                pdf.senderEmail = user.email;
                pdf.senderName = user.profile.fullName;
                pdf.emailSubject = 'New Invoice from ' + pdf.senderName;
                pdf.emailBody = 'Attached you\'ll find your recent invoice from ' + pdf.senderName + '\n';
                pdf.recipientEmail = invoice.recipientEmail;
            }
        }

        // add our company logo to invoice
        if (_.has(user, 'profile.logo')){
            invoice.logo = user.profile.logo
        }

        invoice.currency = user.profile.settings.currency;

        // Add our PDF meta info to invoice so cloud function knows what to do with it
        invoice.pdf = pdf;


      }// preparePDF



      function mailInvoiceDialog(invoice, user, client){
        $mdDialog.show({
            controller: 'emailInvoiceDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/invoiceService/emailInvoice.html',
            parent: angular.element(document.body),
            locals: {
                invoice: invoice,
                user: user,
                client: client

            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });
      }

    } // end invoiceService

    /* @ngInject */
    function emailInvoiceDialogController($mdDialog, $mdToast, $log, $scope, $rootScope, invoiceService){
      // $log.info('emailInvoiceDialogController');
      var vm = $scope.vm;
      // $log.info(vm);
      vm.recipientEmail = vm.client.profile.email;
      vm.cancel = function(){
        $mdDialog.cancel();
      }
      vm.sendPDF = function(recipientEmail){
        $mdDialog.cancel();
        // $log.info('Send invoice to:' + recipientEmail);
        vm.invoice.recipientEmail = recipientEmail;
        invoiceService.preparePDF(vm.invoice, vm.user, vm.client, 'emailClient')
        $mdToast.show($mdToast.adminjaAlert(
            {
                locals:{
                    title: 'Woot!',
                    message: 'Your invoice is being prepared and will be emailed to ' + recipientEmail+'.' ,
                    color: 'orange'
                }
            }));// mdToast
        return invoiceService.createPDF(vm.invoice)


      }

    }

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('inboxService', inboxService);

    /* @ngInject */
    function inboxService($log, $sce, moment, userDataService, taskDataService, profileDataService, $rootScope, $timeout, $firebaseArray, $firebaseObject) {
        var service = {
            importTask: importTask,
            importNote: importNote,
            // discardMessage: discardMessage,
            // clearInbox: clearInbox,
            init: init
        };


        return service;


        function init(){

        }// init

        function sanitizeMe(text) {
            return $sce.trustAsHtml(text)
        };

        // Deprecated 10/19/17. These items now appear in user/notifications
        // function loadInbox(email){
        //   var emailKey = email.replace(/\./g, "-");
        //   var inboxRef = firebase.database().ref().child('/inbox/' + emailKey);
        //       $firebaseArray(inboxRef)
        //       .$loaded(
        //           function(messages) {
        //               service.inbox = messages;
        //               // $log.info(service.inbox);
        //           });
        // }

        function importTask(message) {
          // $log.info('importTask');
          // heap.track('Start Task Import');

          var userID = userDataService.user.uid,
              task = taskDataService.newTask();

          var cleanMessage = sanitizeMe(message.message);
          task.info.panel = 'Later';
          task.info.description = message.title + '\n' + cleanMessage;
          // task.note = message.body;

          taskDataService.taskDialog(task);
           _dcq.push(["identify", {
            email: userDataService.user.email,
            tags: ["Imported Task"]
          }]);
        };// importTask

      function importNote(message){
        // $log.info('importTask');
        // heap.track('Start Note Import');

        var userID = userDataService.user.uid,
            cleanMessage = sanitizeMe(message.message),
            messageBody = message.title + '\n' + cleanMessage,
            newNote = profileDataService.newProfileDetail('note', null, null, messageBody);
        // $log.info(newNote);
        profileDataService.profileDetailDialog(newNote);
         _dcq.push(["identify", {
          email: userDataService.user.email,
          tags: ["Imported Note"]
        }]);

      } // importNote

      // Deprecated 10/19/17. These items now appear in user/notifications and discarded there.
      // function discardMessage(message){
      //   var emailKey = userDataService.user.email.replace(/\./g, "-");
      //   // $log.info('discardMessage', message);
      //   // heap.track('Discard Inbox Item');
      //   return firebase.database().ref().child('/inbox/' + emailKey +'/' + message.$id).remove();
      // }

      // function clearInbox(){
      //   delete service.inbox
      // }// clearInbox


    } // end inboxService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('gateService', gateService);

    /* @ngInject */
    function gateService($log, moment, $rootScope, $timeout, $firebaseArray, $firebaseObject, triMenu) {
        var service = {
            // gateData: gateData,
            setupGates: setupGates,
            clearGates: clearGates,
            setGate : setGate,
            init: init
        };


        return service;


        function init(){

        }// init


        function setGate(gate, value){
            service.gateData[gate] = value;
            // $log.info('setGate');
            // $log.info(service.gateData[gate]);
        }

      function setupGates(user){
        // $log.info('gateService.init');
        service.gateData = {};
        // $log.info('setupGates');
        if(user){
          $log.info(user);
          // Set our default (so we don't have a fail on accounts without plans)
          var planID = 'starter-2018a', subStatus = 'in_trial';
          // set our default client limit for free/cancelled accounts
          var clientLimit = 2,
              teamLimit = 1,
              recurringLimit = 2;

              // if we do have a plan node (and they should), then use that info
              if (_.has(user, 'plan')){
                  planID = user.plan.content__subscription__plan_id;
                  subStatus = user.plan.content__subscription__status;
              } else {
                // alert('Oops! Please refresh your browser');
              }

              // if we have a client limit set (via chargebee/zapier event), use it instead
              if (_.has(user.limits, 'clients')){
                clientLimit = user.limits.clients;
              }

              // if we have a client limit set (via chargebee/zapier event), use it instead
              if (_.has(user.limits, 'team')){
                teamLimit = user.limits.team;
              }

              // if we have a recurring limit set (via chargebee/zapier event), use it instead
              if (_.has(user.limits, 'team')){
                recurringLimit = user.limits.recurring;
              }

              // Grandfather in our old plans...they don't have recurring limits. Set it to zero.
              var options = ['starter-2017a',
                              'assistant-2017a',
                              'ninja-2017a',
                              'ninja-2017b',
                              'warrior-2017a',
                              'early-ninja',
                              'beta-ninja',
                              'starter-2017b',
                              'pro-2017b',
                              'lite-2017b',
                              'assistant-2017b'
                              ];

              if(options.indexOf(planID) > -1){
                 recurringLimit = 0;
              }

              // If plan is cancelled, let's limit them to the free account
              if (subStatus == 'cancelled'){
                planID = 'starter-2018a';
                clientLimit = 2;
                $rootScope.trial = {
                  daysLeft: 0,
                  type: 'paid',
                  status: 'expired',
                  color: 'red'
                }
                // Should we trigger a once-only modal here?
              }

              var grantAccess = 'premium';

              // grandfather in PRO accounts to have team access (they don't have the teamLimit node)
              if(planID == 'pro-2017b' && teamLimit < 3){
                teamLimit = 3;
              }


              // if they are in trial, and on a paid account they should have all features
              if (subStatus == 'in_trial' && planID != 'starter-2017b' && planID != 'starter-2017a'){
                    grantAccess = 'premium-trial';
                 var trialStart = moment(user.plan.content__subscription__trial_start),
                     trialEnd = moment(user.plan.content__subscription__trial_end),
                     today = moment(),
                     numDaysLeft = trialEnd.diff(today, 'days'),
                     statusColor = undefined;

                     if (numDaysLeft > 15){
                      statusColor = 'green'
                     }

                     if (numDaysLeft <= 15){
                      statusColor = 'orange'
                     }

                     if (numDaysLeft > 0){
                        // setup our trial object for upgrade pushing
                        $rootScope.trial = {
                          daysLeft: numDaysLeft,
                          type: 'paid',
                          status: 'in_trial',
                          color: statusColor
                        }
                     }
              }

              if(planID == 'lite-2017b'){
                grantAccess = 'basic';
              }

              // Exceptions for starter plan:
              if(planID == 'starter-2017b' || planID == 'starter-2017a'){
                grantAccess = 'basic'
                // $log.info(planID);
                //some of our users don't have start dates so we have to check
                if(_.has(user.profile, 'startDate')){

                  // If free plan but within first 30 days, it should be treated as a starterTrial
                  // We aren't using chargebee to manage this for us. Hence the following block:

                  // Are they on starter trial?
                  // if now is less than 30 days since they signed up
                  if(planID == 'starter-2017b'){
                      if(moment() < moment(user.profile.startDate).add(30, 'days')){
                          // trial is true
                          // $log.info('User in starter trial period.');
                          var starterTrial = true,
                              today = moment(),
                              trialEnd = moment(user.profile.startDate).add(30, 'days'),
                              numDaysLeft = trialEnd.diff(today, 'days');
                          // Define our trial properties for sidebarcontrols to use elsewhere
                          $rootScope.trial = {
                            daysLeft: numDaysLeft,
                            type: 'starter',
                            status: 'in_trial',
                            color: 'orange'
                          }

                          // $log.info($rootScope.trial);

                      }
                    } else {
                        // trial is false
                        // $log.info('not in trial');
                        var starterTrial = false,
                            trialEnd = moment();
                    }

                  }// if starter-2017b

                  // If they should have a starterTrial
                  if (starterTrial){
                      // allow premium access by putting it "in_trial"
                      subStatus = 'in_trial';
                      grantAccess = 'starter-trial';
                      // starterTrial limits (default is 2 clients)
                      clientLimit = 2;
                      user.limits.clients = clientLimit;
                      user.plan.content__subscription__status = 'in_trial';
                      user.plan.content__subscription__trial_end = trialEnd;
                  }
              }// premium trial period for starter accounts

          // Define our gates based on plan
          switch(grantAccess) {
              case 'basic':
                  service.gateData = {
                    'canLogTime' : true,
                    'canUseTimer': true,
                    'canViewTime' : true,
                    'canEmailClient' : true,
                    'canImportEmail' : true,
                    'clientLimit' :clientLimit,
                    'teamLimit': teamLimit,
                    'hasRecurring': true,
                    'hasBilling': false,
                    'canUseChecklists' : true,
                    'subStatus': subStatus,
                    'recurringLimit': recurringLimit
                  }
                    break;
              case 'starter-trial':
                  service.gateData = {
                    'canLogTime' : true,
                    'canUseTimer': true,
                    'canViewTime' : true,
                    'canEmailClient' : true,
                    'canImportEmail' : true,
                    'clientLimit' :clientLimit,
                    'teamLimit': teamLimit,
                    'hasRecurring': true,
                    'hasBilling': true,
                    'canUseChecklists' : true,
                    'subStatus': subStatus,
                    'recurringLimit': recurringLimit

                  }
                    break;
              case 'premium-trial':
                  service.gateData = {
                    'canLogTime' : true,
                    'canUseTimer': true,
                    'canViewTime' : true,
                    'canEmailClient' : true,
                    'canImportEmail' : true,
                    'teamLimit': teamLimit,
                    'clientLimit' :clientLimit,
                    'hasRecurring': true,
                    'hasBilling': true,
                    'canUseChecklists' : true,
                    'subStatus': subStatus,
                    'recurringLimit': recurringLimit

                  }
                    break;

              case 'premium':
                service.gateData = {
                  'canLogTime' : true,
                  'canUseTimer': true,
                  'canViewTime' : true,
                  'canEmailClient' : true,
                  'canImportEmail' : true,
                  'clientLimit' : clientLimit,
                  'teamLimit': teamLimit,
                  'hasRecurring': true,
                  'hasBilling': true,
                  'canUseChecklists' : true,
                  'subStatus': subStatus,
                    'recurringLimit': recurringLimit
                }
                  break;

              default:
                 service.gateData = {
                    'canLogTime' : true,
                    'canUseTimer': true,
                    'canViewTime' : true,
                    'canEmailClient' : true,
                    'canImportEmail' : true,
                    'clientLimit' :2,
                    'teamLimit': 1,
                    'hasRecurring': true,
                    'hasBilling': false,
                    'canUseChecklists' : true,
                    'subStatus': subStatus,
                    'recurringLimit': recurringLimit
                  }
          }// switch
        } else {
          alert('User not passed to gates');
        }

        // $log.info('Granting priveleges for: '+ grantAccess);
        // $log.info(service.gateData);
        // Is this user allowed additional team members?
        if(service.gateData.teamLimit > 1){
            service.gateData.hasTeams = true;
        }

        // $log.info(service.gateData);
        // if account cancelled, disable features
        if(subStatus == 'cancelled'){
          // $log.info('cancelled account. disabling features.');
          service.gateData.hasBilling = false;
          service.gateData.hasTeams = false;
          service.gateData.clientLimit = 2;
        }
        // $log.info(grantAccess);
        // $log.info(service.gateData);

      }// setupGates

      function clearGates(){
        delete service.gateData
      }// clearGates


    } // end gateService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('clientDialogController', clientDialogController);


///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// clientDialogController

/* @ngInject */
function clientDialogController($log, gateService, teamDataService, userDataService, $mdDialog, $mdToast, client, triMenu, clientDataService, $timeout, clientColors, $rootScope, title, $scope, hotkeys, timeDataService, $state) {
    var vm = this;
    // client is already assumed
    vm.client = client;
    vm.teamDataService = teamDataService;
    vm.clientColors = clientColors;
    vm.countries = $rootScope.countries;
    vm.title = title;
    vm.thisForm = $scope.clientDialogForm;
    vm.canCreateClient = false;
    vm.selectedTabIndex = 0;
    vm.inputOptions = { updateOn: 'default blur',
                             debounce: {
                               default: 300,
                               blur: 0
                             }
                        };
    vm.currency = "$";
    vm.teamLimit = gateService.gateData.teamLimit;
    if(vm.teamLimit > 1 && vm.client.access.admins[$rootScope.userID]){
        vm.showTeam = true;
    }

    // if this is a new client, assign a temporary avatar
    if(!vm.client.uid){
        vm.client.profile.avatar = "/assets/images/avatars/generic-avatar.png";
        // We do want to pre-populate today's date.
        // but we don't want personal spaces to trigger billing period renewals
        if(vm.client.status != 'personal'){
            // vm.client.profile.plan.nextCycle = moment().toDate();
        }
    }
    // if(vm.client.access.admins[$rootScope.userID]){
    //     vm.canEdit = true
    // } else {
    //     vm.canEdit = false
    // }

    if(_.has(userDataService.user.profile, 'settings.currency')){
        vm.currency = userDataService.user.profile.settings.currency;
    }

    // isolate the teamList for this client
     vm.teamList = teamDataService.clientTeams[vm.client.uid];
     vm.thisMember = undefined;

    // Set defaults
    vm.canEdit = false;
    vm.isOwner = false;
    vm.isAdmin = false;

    // if we have a team, check for permissions to edit otherwise, allow it
    if(_.size(vm.teamList) > 1){
        // Go through team and find our member
        _.each(vm.teamList, function(member){
            if(member.uid == $rootScope.userID){
                // check if this is the owner of the client
                if(member.role == 'owner'){
                    vm.isOwner = true;
                    vm.isAdmin = true;
                    // if not owner, check to see if admin or member
                } else if (member.clients[vm.client.uid] == 'admin'){
                    vm.isAdmin = true;
                }
            }// if we found matching member info
        });
    } else {
        // no team. This is a solo account. Set all to true.
        vm.canEdit = true;
        vm.isOwner = true;
        vm.isAdmin = true;
    }


    // calculate number of OWNED clients so we can limit based on plan
    vm.numClients = 0;
    _.each($rootScope.quickClients, function(client){
        if(client.clientType == 'own'){
            vm.numClients = vm.numClients + 1;
        }
    });

    // if this is our first client , show tooltips
    // if(vm.numClients < 1 && vm.isOwner){
    //     Appcues.show('-KnQzUkJ59lmSPOEoKqa');
    // }

   vm.clientLimit = gateService.gateData.clientLimit;
    // if it's an existing client, or if we are under our limit, it's ok to open the dialog
   if (vm.client.uid || vm.clientLimit > vm.numClients) {
       vm.canEditClient = true;
   }


   // We put the form on $scope.forms. so it's forced to attach to original instead of child scope
   // See name="forms.clientDialogForm" in dialog-client.html
   // https://stackoverflow.com/questions/22436501/simple-angularjs-form-is-undefined-in-scope
   $scope.forms = {};

    // Setup Hotkeys for this dialog
    hotkeys.bindTo($scope)
            // inhibit enter from submitting
            .add({
                combo: 'enter',
                callback: function (event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                }
            })
            .add({
                combo: 'ctrl+enter',
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                description: 'Save/Update Client',
                callback: function (event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info($scope.forms.clientDialogForm);
                    var pristine = $scope.forms.clientDialogForm.$pristine,
                            invalid = $scope.forms.clientDialogForm.$invalid,
                            clientID = $scope.vm.client.uid;

                    if (!pristine && !invalid && clientID) {
                        vm.saveUpdatedClient($scope.vm.client);
                    }

                    if (!pristine && !invalid && !clientID) {
                        vm.saveNewClient($scope.vm.client);
                    }
                }
            });

    // Set focus
    $timeout(function () {
        // if this is a new client, put the focus on the description field
        if (!vm.client.uid) {
            var firstname = angular.element("input[name='clientfirstname']");
            firstname.focus();
        }
    }, 100);

    // monitor color changes and change pristine to false
    vm.colorChange = function (form) {
        form.$setDirty();
        $timeout(function(){
            vm.togglePicker();
        }, 250);

    };

    // autosuggest nextRenew based on deprecated retainerStart
    vm.suggestedRenew = function(retainerStart){
        // $log.info('retainerStart:' + retainerStart);
        var nextCycle = moment();

        // if we've already more than 2 weeks past the day in this month, move forward a month
        // if(Number(nextCycle.format('D')) > (retainerStart + 21)){
        //     nextCycle = moment(nextCycle).add(1, 'month').date(retainerStart).startOf('day');
        // } else {
        //     nextCycle = moment(nextCycle).date(retainerStart).startOf('day');
        // }

        // if cycle day is upcoming, start date should be in previous month
        if (Number(nextCycle.format('D')) <= retainerStart){
            nextCycle = moment(nextCycle).subtract(1, 'month').date(retainerStart).startOf('day');
        } else {
            nextCycle = moment(nextCycle).date(retainerStart).startOf('day');
        }


        return moment(nextCycle).format('MMM, D  YYYY')
    }


    vm.gotoTab = function(index){
        vm.selectedTabIndex = index;
    }
    vm.colorPicker = false;

    vm.togglePicker = function(){
        if (vm.colorPicker){
            vm.colorPicker = false;
        } else{
            vm.colorPicker = true;
        }
    }


    vm.showCycleWarning = function(){

            vm.showRetainerWarning = true;

    }

    vm.changeBilling = function(){
        vm.showRetainerChangeWarning = true;
    }

    // Ensures our nextCycle datePicker constrains
    // the date candidates
    vm.cycleDateLimit = function(date){
        // return date
        var now = moment(),
            min = moment(now).subtract(15, 'days'),
            max = moment(now).add(1, 'month'),
            day = moment(date),
            dayNumber = Number(moment(date).format('D')),
            pass = false;

        if(_.has(vm.client, 'profile.plan.nextCycle')){
            min = moment(vm.client.profile.plan.nextCycle).subtract(15, 'day');
            max = moment(vm.client.profile.plan.nextCycle).add(1, 'month').add(1, 'day');
        } else {
            min = moment().subtract(15, 'day');
            max = moment().add(1, 'month').subtract(1, 'day');
        }

        // is within min/max dates?
        if(moment(day).isSameOrAfter(min) && moment(day).isSameOrBefore(max)){
            pass = true;
        }

        // is less than 29?
        if(dayNumber > 28){
            pass = false;
        }

        if(pass){
            return dayNumber
        }
    }// cycleDateLimit

    vm.uploadAvatar = function ($files) {
        // $log.info('upload file');
        // $log.info($files);
        if ($files !== null && $files.length > 0) {
            var storage = firebase.storage(),
                    storageRef = storage.ref();
            _.each($files, function (file) {
                var filename = ref.currentUser.uid + '_' + file.name;
                // $log.info('Saving '+filename);
                // create imageRef and put the file
                var imageRef = storageRef.child('avatars/' + filename),
                        uploadTask = imageRef.put(file);

                uploadTask.on('state_changed', function (snapshot) {
                    // $log.info('upload state changed');
                }, function (error) {
                    // $log.warn('upload failed');
                }, function (success) {
                    // $log.info('upload success');

                    vm.client.profile.avatar = uploadTask.snapshot.downloadURL;
                    $scope.clientDialogForm.$setDirty();
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent('Profile photo uploaded. Thanks!')
                            .position('top right')
                            .hideDelay(2000)
                            );
                    // heap.track('Client Avatar Uploaded');
                }); // uploadTask.on
            }); // ._each files
        } // if files
    }; // vm.uploadAvatar

    vm.cancelDialog = function (task) {
        $mdDialog.cancel();
    };

    vm.saveUpdatedClient = function (client, prevRetainerDate) {
        // $log.info('vm.saveUpdatedClient');

        // // remove the $$conf property...it causes errors
        // delete client.$$conf;
        return clientDataService.updateClient(client, prevRetainerDate).then(function () {
            // $log.info('update client - re-generate client menu');
            triMenu.removeMenu('triangular.client-manager-page');
            // Refresh Client Data
            clientDataService.setupClientMenu();
            vm.cancelDialog();
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Updated Client:' + client.profile.firstname + ' ' + client.profile.lastname)
                    .position('top right')
                    .hideDelay(2000)
                    );
            // heap.track('Client Updated');

        }).then(function () {
            timeDataService.reCreateTotals(client);
        });
    }

    vm.saveNewClient = function (client) {
        // $log.info('saveNewClient clicked');
        return clientDataService.saveNewClient(client).then(function () {
            vm.cancelDialog();
            // Let Appcues know who this is

            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Added new Space')
                    .position('top right')
                    .hideDelay(2000)
                    );
            // heap.track('New Client Saved');

            // Update Client Menu
            // $log.info('new client - re-generate client menu');
            triMenu.removeMenu('triangular.client-manager-page');
            // Refresh Client Data
            $timeout(function () {
                clientDataService.setupClientMenu();

            }, 1000);

        });
    }


    vm.onTabChanges = function(tabIndex){
        // display the button we need depending on what tab we are on.
        $log.info('Current tab ' + tabIndex);
    }

    vm.changeTab = function(targetTab){
        // display the button we need depending on what tab we are on.
        vm.selectedTabIndex = targetTab
    }

    vm.setupAsPersonalSpace = function(){
        vm.client.status = 'personal';
        vm.client.profile.isCompany = true;
        vm.client.profile.plan.type == 'hourly';
        vm.client.order = 1;
        vm.client.plan = {rate:0}
        vm.title = "New Personal Space";

    }


}
;

})();

(function () {
    'use strict';
    angular.module('appServices')
            .service('clientDataService', clientDataService);


    /* @ngInject */
    function clientDataService(rrule, $timeout, $log, $q, $state, triLoaderService, localStorageService, $injector,
                            $mdDialog, $mdToast, $rootScope, $firebaseArray, $firebaseObject,
                            $stateParams, userDataService, gateService, fbService, triMenu) {
        var clientMenu = [],
            clientsArray = [];

        var service = {
            newClient: newClient,
            clientColor: clientColor,
            clientName: clientName,
            clientOwner: clientOwner,
            clientDialog: clientDialog,
            workspaceAddressDialog: workspaceAddressDialog,
            editClient: editClient,
            saveNewClient: saveNewClient,
            updateClient: updateClient,
            deleteClient: deleteClient,
            getClient: getClient,
            clientBrief: clientBrief,
            getWorkspace: getWorkspace,
            getUsersClients: getUsersClients,
            thisUsersWorkspaces: thisUsersWorkspaces,
            setupUserAndClientMenu: setupUserAndClientMenu,
            setupWorkspaceMenu: setupWorkspaceMenu,
            clearClientData: clearClientData,
            updateTime: updateTime,
            easyClient: easyClient,
            getQuickClients: getQuickClients,
            restoreClient: restoreClient,
            archiveClient: archiveClient,
            copyClient: copyClient,
            isOwner : isOwner
        };


        return service;


        // $log.info(demoPanels);
        //////////////
        // updateTime
        function updateTime(timeEntry) {
            // $log.info('updateTime');
            // $log.info(timeEntry);
            // get current

        }


        function isOwner(clientID, userID){
            _.each(service.clients, function(client){
                if(client.uid == clientID){
                    var thisClient = client;
                    if(thisClient.owner == userID){
                        return true
                    } else {
                        return false
                    }

                }
            })
        }//isOwner

        function getQuickClients () {

            return service.clients;

        }






        function clientBrief(clientID){
            // this is duplicaterd in timerDataService.newTimer
            // because we couldnt' get newTimer to use this function efficiently
            _.each(service.clients, function(client){
                if(client.uid == clientID){
                    var newClientBrief = {
                        access: client.access,
                        clientColor: client.profile.clientColor,
                        email: client.profile.email,
                        name: client.profile.fullName,
                        order: client.order,
                        owner: client.owner,
                        status: client.status,
                        uid: client.uid
                    }

                    if(_.has(client, 'profile.avatar')){
                        newClientBrief.avatar = client.profile.avatar;
                    }

                    return newClientBrief
                }
            })
        }

        //////////////
        // easyClient
        function easyClient(clientID) {
            var found = {};
            _.each(service.clients, function (client) {
                if (client.uid === clientID) {
                    found = client
                }
            });
            return found
        }// easyClient


        //////////////
        // clearClientData
        function clearClientData() {
            delete service.clients;
            delete $rootScope.VAWorkspacesMenu;
            delete $rootScope.vaWorkspacesMenuBuilt;
            clientsArray = [];
            // Kill our quick list of client info
            // kill our client menu
            triMenu.removeMenu('triangular.workspaces');
        }




        ///////////////////////////////////////////////////////////
        // newClient
        function newClient(ownerID, lead) {
            var user = userDataService.user;
            if (!ownerID) {
                var ownerID = user.uid;
            }

            // Define our client scaffold to pass to dialog for population
            var client = {
                owner: ownerID,
                created: moment().toISOString(),
                order: 1,
                profile:{
                    plan: {
                        retainerStart: 1,
                        type: undefined,
                        cost: 0,
                        allocated: 0,
                        rate: 0,
                        recurrenceType: 'month',
                        weekDay: 'MO',
                        displayWeekDay: 'Monday',
                        interval: 1
                    }
                },
                access: {
                    users: {},
                    admins: {}
                },
                panels: {}
            }

            // // Save the client owner in users/admins lists
            client.access.users[ownerID] = true;
            client.access.admins[ownerID] = true;
            // if being setup by someone other than owner, make sure they are added too
            if(ownerID != user.uid){
                client.access.users[user.uid] = true;
                client.access.admins[user.uid] = true;
            }

            // if a lead was passed, use it's info to prepopulate
            if(lead){
                client.profile.firstname = lead.firstName;
                client.profile.lastname = lead.lastName;
                client.profile.fullname = lead.firstName + ' ' + lead.lastName;

                // Add our lead object with metadata on this promotion to workspace
                client.lead = lead;
                client.lead.convertedOn = moment().toISOString;
                client.lead.convertedBy = $rootScope.userID;

                if(_.has(lead, 'email')){
                    client.profile.email = lead.email;
                }
                if(_.has(lead, 'company')){
                    client.profile.company = lead.company;
                }
                if(_.has(lead, 'position')){
                    client.profile.position = lead.position;
                }
                if(_.has(lead, 'avatar')){
                    client.profile.avatar = lead.avatar;
                }
                if(_.has(lead, 'avatarThumb')){
                    client.profile.avatarThumb = lead.avatarThumb;
                }
                if(_.has(lead, 'phone')){
                    client.profile.phone = lead.phone;
                }
                if(_.has(lead, 'companyfax')){
                    client.profile.companyfax = lead.companyfax;
                }
                if(_.has(lead, 'linkedin')){
                    client.profile.linkedin = lead.linkedin;
                }
                if(_.has(lead, 'facebook')){
                    client.profile.facebook = lead.facebook;
                }
                if(_.has(lead, 'twitter')){
                    client.profile.twitter = lead.twitter;
                }
                if(_.has(lead, 'pinterest')){
                    client.profile.pinterest = lead.pinterest;
                }
                if(_.has(lead, 'instagram')){
                    client.profile.instagram = lead.instagram;
                }
                if(_.has(lead, 'website')){
                    client.profile.companyurl = lead.website;
                }
                if(_.has(lead, 'address')){
                    client.profile.address = lead.address;
                }

            }// if lead
            // $log.info('new client scaffold:');
            // $log.info(client);
            dataLayer.push({'event': 'new-workspace'});
            return client
        }// newClient

        ///////////////////////////////////////////////////////////
        /// clientColor
        function clientColor(clientID) {

                var selectedClient = _.find(clientsArray, function (client) {
                    return client.uid == clientID;
                });

                if (_.has(selectedClient, 'profile.clientColor')) {
                    return selectedClient.profile.clientColor;
                } else {
                    return '#888888'
                }

        }

        ///////////////////////////////////////////////////////////
        /// clientName
        function clientName(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            var name = "";
            if(selectedClient){
                if (_.has(selectedClient.profile,'fullName')){
                    name = selectedClient.profile.fullName;
                } else {
                    name = selectedClient.profile.name
                }
                return name
            }
        }

        /////////////////
        // getWorkspace
        //// returns full client based on id
        function getWorkspace(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            return selectedClient;
        }

        ///////////////////////////////////////////////////////////
        /// clientOwner
        function clientOwner(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            return selectedClient.owner;
        }

        function workspaceAddressDialog(client){
            $mdDialog.show({
                controller: 'workspaceAddressDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/clientDataService/dialog-workspaceAddress.tmpl.html',
                locals: {
                    client: client
                },
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });
        }

        ///////////////////////////////////////////////////////////
        /// clientDialog
        function clientDialog(client, dialogTitle, tab) {

            // Make sure they are allowed to add clients
            // Not counting: Demo clients, Delegated Clients (their owner has unlimited anyways), archived clients
            var clientLimit = gateService.gateData.clientLimit;
            // $log.info('limit:' + clientLimit);


            //////////// Make sure we can open the dialog ////////////
            var numClients = 0, canOpenDialog = true;

            // Only check client count if adding for OWN account
            // team accounts have no limits anyways

            // if user owns the client and the client is new
            if(client.owner == $rootScope.userID && !client.uid){
                // count up our active, non-demo , owned clients
                _.each(service.clients, function(client){
                    if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                        numClients = numClients + 1;
                    }
                });
                // $log.info('numClients: '+numClients);

                if(numClients == clientLimit || numClients > clientLimit){
                    canOpenDialog = false;
                }
            }

            // $log.info('Original check: '+ canOpenDialog);

            var workingClient = angular.fromJson(angular.toJson(client));
            if(_.has(workingClient, 'profile.startDate')){
                workingClient.profile.startDate = new Date(workingClient.profile.startDate);
            }

            $mdDialog.show({
                controller: 'clientDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/clientDataService/dialog-client.tmpl.html',
                locals: {
                    title: dialogTitle,
                    client: workingClient,
                    clientColors: $rootScope.clientColors,
                    canOpenDialog: canOpenDialog,
                    tab: tab
                },
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });

        }
        ; // end clientDialog


        ///////////////////////////////////////////////////////////
        /// editClient
        function editClient(clientID, tab) {
            _.each(service.clients, function(client){
                if (client.uid == clientID ){
                    var editedClient = client;
                    // $log.info(editedClient.avatar);
                    clientDialog(editedClient, 'Edit ' + editedClient.firstname + ' ' + editedClient.lastname, tab);
                    //heap.track('Edit Client Started');
                    userpilot.track('Edit Client Started');
                }
            });
        }
        ; // end editClient

        function getRuleString(client){
            switch(client.profile.plan.recurrenceType) {
                case 'week':
                    // $log.info('prepare weekly rule');
                    // always show button if menu is hidden
                    var ruleString = 'RRULE:FREQ=WEEKLY;BYDAY='+client.profile.plan.weekDay + ';INTERVAL=' + client.profile.plan.interval;
                    break;
                case 'month':
                    // $log.info('prepare monthly rule');
                    // never show button if menu is turned off
                    var ruleString = 'RRULE:FREQ=MONTHLY;BYMONTHDAY='+ moment(client.profile.plan.nextCycle).format('D') +';INTERVAL=' + client.profile.plan.interval;
                    break;
                case 'zero':
                    // $log.info('prepare daily rule');
                    var ruleString = 'RRULE:FREQ=DAILY;INTERVAL=1';
                    break;
                default:
                    // $log.info('prepare default rule');
                   var ruleString = 'RRULE:FREQ=MONTHLY;BYMONTHDAY='+ moment(client.profile.plan.nextCycle).format('D') +';INTERVAL=' + client.profile.plan.interval;
            }
            return ruleString
        }

        ///////////////////////////////////
        // saveNewClient

        function saveNewClient(client, visit) {
            var user = userDataService.user;
            // if we are on dashboard, we need to turn the loader on while we rebuild it.
            if($state.includes('triangular.dashboard')){
                $timeout(function(){
                    triLoaderService.setLoaderActive(true)
                });
            }

            // if this is a client space, make sure to include the default "Client Details" panel.
            var saveClient = angular.copy(client);

            saveClient.createdOn = moment().toISOString();


            // $log.info(client.profile.plan.nextCycle);
            if(client.profile.plan.type != 'none'){
                var ruleString = getRuleString(client);
                saveClient.profile.plan.ruleString = ruleString;
                // make sure nextCycle is converted from function to isoString for storage
                saveClient.profile.plan.nextCycle = moment(saveClient.profile.plan.nextCycle).toISOString();
            }

            if(client.profile.plan.type == 'none'){
                delete saveClient.profile.plan.nextCycle
            }
            // $log.info(ruleString);

            if (_.has(saveClient, 'profile.startDate')) {
                saveClient.profile.startDate = moment(saveClient.profile.startDate).toISOString();
            }

            // Convert retainerStart to a number
            // this is probably safely completely deprecated
            if(_.has(saveClient, 'profile.plan.retainerStart')){
                saveClient.profile.plan.retainerStart = Number(saveClient.profile.plan.retainerStart);
            }

            // Also, store it as the client's "Start Date"
            if(_.has(saveClient, 'profile.startDate')){
                saveClient.profile.startDate = moment(saveClient.profile.startDate).startOf('day').toISOString();
            }

            // Set our client's default name
            if (saveClient.profile.isCompany && saveClient.profile.company) {
                // using company name for this client label
                saveClient.profile.fullName = saveClient.profile.company;
            } else {
                // using first/last for this client label
                saveClient.profile.fullName = saveClient.profile.firstname + ' ' + saveClient.profile.lastname;
            }

            // get unique ID for the new client
            var newClientKey = firebase.database().ref().child('clients').push().key;
            // put the key on the original client so our calling function has it
            client.uid = newClientKey;

            saveClient.uid = newClientKey;

            // $log.info('saveNewClient client:');
            // $log.info(saveClient);
            // declare our updates
            var updates = {};

            // If a lead was attached, update the lead with the workspace info
            if(_.has(saveClient, 'lead')){
                // $log.info(saveClient.lead);
                updates['/leadBoards/' + saveClient.owner + '/leads/' + saveClient.lead.uid + '/promotedWorkspace'] = newClientKey;
            }

            // store our canonical object
            updates['/clients/' + newClientKey] = saveClient;
            // store our reference in the owner's assigned client list
            updates['users/' + saveClient.owner + "/clients/" + newClientKey] = true;

            // if creator isn't owner, add to creator's client list as well
            if(saveClient.owner != user.uid){
                updates['users/' + user.uid + "/clients/" + newClientKey] = true;
                // make sure added to their team
                updates['teams/' + saveClient.owner + "/members/" + user.uid + "/clients/" + newClientKey] = 'admin';
            }
            var thisMoment = moment().toISOString();
            saveClient.accountCreated = saveClient.owner + thisMoment
            saveClient.created = saveClient.owner + thisMoment

            // Save the client
            // $log.info('saveClient:');
            return firebase.database().ref().update(updates)
                    // Add the default "Client Details" panel to this client
                    .then(function (response) {

                        dataLayer.push({'event': 'new-workspace-saved'});
                        // $log.info('Client saved. Adding panels.');
                        // $log.info(response);
                        // get a new key
                        var updates = {};
                        // $log.info(profilePanels);

                           setupClientPanels(saveClient);

                    //heap.track('New Client Saved');
                    userpilot.track('New Client Saved');


                    // if this is our FIRST client, trigger the appcues flow that shows us where workspaces are
                    if(service.clients.length == 1 && !userDataService.user.profile.onboardingFlags.hasCreatedClient){
                        // Let Drip Knkow
                        _dcq.push(["identify", {
                                email: userDataService.user.email,
                                tags: ["Added First Client"]
                            }]);
                        // show the appcue tooltip
                        // Appcues.show($rootScope.tutorials.gotoWorkspace);
                        // Change the onboarding flag
                        return userDataService.changeOnboardingFlag('hasCreatedClient', true);
                    } else if(visit) {
                        $timeout(function(){
                            $state.go("triangular.workspaces.tasks", {"clientID": saveClient.uid});

                        },1000);
                    }
                    // // Execute our updates
                    // return firebase.database().ref().update(updates)
                    // .then(function(response){
                    //     // Visit our new client space
                    //     // $state.go('triangular.workspaces.information', {clientID: newClientKey});

                    // });
                    return service.setupUserAndClientMenu(true);
                }); //database update client

        } // end saveNewClient


        function checkEmailAddresses(emailAddresses){
            var addressList = emailAddresses.split('\n');
            // $log.info(addressList);
            var valid = true;
            for (var n = 0; n < addressList.length; n++) {
              var addressInfo = addressList[n].trim();
              var validRegExp = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

              if (addressInfo.search(validRegExp) === -1) {
                  valid = false;
                  break
              }
            }

            return valid
        }// checkEmailAddresses

        ///////////////////////////////////
        // updateClient
        function updateClient(client, original) {

            var updates = {},
                adjustBillingPeriod = false,
                now = moment().toISOString();

                var ruleString= getRuleString(client);
                client.profile.plan.ruleString = ruleString;

            // remove deprecated dob property if they have it
            if(_.has(client, 'profile.dob')){
                delete client.profile.dob
            }

            var thisProfile = angular.copy(client.profile);

            if (_.has(thisProfile, 'startDate')) {
                thisProfile.startDate = thisProfile.startDate.toISOString();
            }


            // Set our client's default name
            if (thisProfile.isCompany && thisProfile.company) {
                // using company name for this client label
                thisProfile.fullName = thisProfile.company;
            } else {
                // using first/last for this client label
                thisProfile.fullName = thisProfile.firstname + ' ' + thisProfile.lastname;
            }

            thisProfile.updatedOn = now;

            // check to make sure email addresses in report are valid

            if(_.has(thisProfile, 'weeklyStatusReportEnabled')){
                if(thisProfile.weeklyStatusReportEnabled){
                    var isValid = checkEmailAddresses(thisProfile.weeklyStatusReport.recipients);

                    // Determine if the report is new
                        if(!original.profile.weeklyStatusReportEnabled){
                            //heap.track('Setup Weekly Client Report');
                            userpilot.track('Setup Weekly Client Report');
                            _dcq.push(["track", "Setup Weekly Client Report"]);
                            dataLayer.push({'event': 'enabled-workspace-status-reports'});
                        }


                    if(!isValid){
                        alert('At least one of the email addresses you provided are invalid. Please correct and try again.')
                        return
                    }
                } else {
                    // it's disabled. Delete it.
                    if(original.profile.weeklyStatusReportEnabled){
                        dataLayer.push({'event': 'disabled-workspace-status-reports'});
                    }
                    delete thisProfile.weeklyStatusReport
                }// if report enabled

            }// if has report

            // if billing plan set to none, remove everything else on the node
            if(thisProfile.plan.type == 'none'){
                thisProfile.plan = {
                    type: 'none'
                }
            }

            var updates = {};

            // store our canonical object
            updates['/clients/' + client.uid + '/profile'] = thisProfile;
            updates['/clients/' + client.uid + '/status'] = client.status;
            updates['/clients/' + client.uid + '/accountUpdated'] = client.owner + now;
            updates['/clients/' + client.uid + '/updated'] = now;


            // if recurrenceType has changed, also update the current billingPeriod
            var updateBillingPeriod = false;

            if(client.profile.plan.recurrenceType == 'zero' && (original.profile.plan.recurrenceType != client.profile.plan.recurrenceType)){
                // $log.info('switched from date-based to balance-based')
                updateBillingPeriod = true;
            };

            if(original.profile.plan.recurrenceType == 'zero' && (original.profile.plan.recurrenceType != client.profile.plan.recurrenceType)){
                // $log.info('switched from balance-based to date-based')
                updateBillingPeriod = true;
            };


            // If we've changed our nextCycle - adjust the last billing period to match
            var updateBillingPeriodRange = false;
            if(original.profile.plan.nextCycle != client.profile.plan.nextCycle){
                // the cycle date has changed. We are going to find the LAST billing period and adjust it's end-date to 1ms prior to the nextCycle
                if(_.has(client.profile.plan, 'currentPeriod')){
                    var newEnd = moment(client.profile.plan.nextCycle).subtract(1, 'ms');
                    updates['billingPeriods/' + client.profile.plan.currentPeriod + '/info/end'] = moment(newEnd).toISOString();
                    updates['clients/' + client.uid + '/billing/' + client.profile.plan.currentPeriod + '/end'] = moment(newEnd).toISOString();
                }
            }

            if(client.profile.plan.type == 'none' && client.status == 'active'){
                delete client.profile.plan.nextCycle
                updateBillingPeriod = false;
            }


            if(updateBillingPeriod){
                // Find the current billing period that needs updating
                var now = moment().toISOString();
                // Find the current billingPeriod for adjusting
                _.each(client.billing, function(billingPeriod){
                   if(billingPeriod.start <= now && billingPeriod.end >= now){
                        // Update it's recurrenceType
                        updates['/billingPeriods/' + billingPeriod.uid + '/type'] = client.profile.plan.type;
                        updates['/billingPeriods/' + billingPeriod.uid + '/recurrenceType'] = client.profile.plan.recurrenceType;
                        updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/recurrenceType'] = client.profile.plan.recurrenceType;
                        updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/type'] = client.profile.plan.type;

                        //if we are now on balance-based - change the end date to match nextCycle for our daily checks.
                        if(client.profile.plan.recurrenceType == 'zero'){
                            var end = moment().add('2', 'days').toISOString();
                            updates['/billingPeriods/' + billingPeriod.uid + '/end'] = end;
                            updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/end'] = end;
                        }

                        //if we are now on date-based - change the end date to day after "nextCycle"
                        if(client.profile.plan.recurrenceType != 'zero'){
                            var nextCheck = moment(client.profile.plan.nextCycle).subtract(1, 'ms').toISOString();
                            updates['/billingPeriods/' + billingPeriod.uid + '/end'] = nextCheck;
                            updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/end'] = nextCheck;
                        }
                   };
                })
            }


            // if we are on a client-manager page (i.e. focused on a client)
            // update the rootscope instance of our key client details
            // so our color coding can pick up on it
            if ($state.is('triangular.workspaces.information')) {
                $rootScope.thisClient.clientColor = thisProfile.clientColor;
            }

            //heap.track('Client Updated');
            userpilot.track('Client Updated');
            return firebase.database().ref().update(updates).
            then(function(){
                dataLayer.push({'event': 'workspace-updated'});
                $rootScope.$emit('clientUpdated');
            })
        } // end updateClient


        ///////////////////////////////////
        // deleteClient
        function deleteClient(client) {
            // $log.info('deleting');
            var updates = {};

            // all we need to do is change the status to "deleted".
            // Our cloud function will take over from there.
            updates['/clients/' + client.uid + '/status' ] = 'deleting';

            // delete the records
            //heap.track('Client Deleted');
            userpilot.track('Client Deleted');
            _dcq.push(["identify", {
                    email: userDataService.user.email
                }]);
            return firebase.database().ref().update(updates)
            .then(function(){
                dataLayer.push({'event': 'workspace-deleted'});
            })


        }
        ; // end deleteClient




        ///////////////////////////////////////////////////////////
        /// getClient
        /// Returns entire client object by ID
        function getClient(clientID) {
            // $log.info('clientObjectyByID called;')
            var client = {},
                    d = $q.defer(),
                    clientRef = firebase.database().ref('clients/' + clientID);
            return $firebaseObject(clientRef)
                    .$loaded(function (data) {
                        client = data;
                        // $log.info('client returned');
                        // $log.info(client);
                        d.resolve(client);
                        return d.promise;
                    });

        }
        ; // end getClient




        ///////////////////////////////////////////////////////////
        /// getUsersClients
        //  Gets complete array of client objects assigned to this user
        function getUsersClients(userID) {
            // $log.info(userID);
            var d = $q.defer();
            var clientsRef = firebase.database().ref().child('/clients');
            $firebaseArray(clientsRef.orderByChild("access/users/" + userID).equalTo(true))
                    .$loaded(
                            function (clients) {
                                // $log.info(clients);
                                d.resolve(clients);
                                return d.promise;
                            });
        }
        ; // End getClients



        ///////////////////////////////////////////////////////////
        /// Stores result in clientsArray
        // We have already double-checked and this is working properly (only running on initial load, otherwise returning the service.clientsArray)
        // our delays are not here
        function thisUsersWorkspaces(user, force) {
            // $log.info('thisUsersWorkspaces');
            // if(service.clients){
            //     $log.info('already has '+ service.clients.length +' clients');
            // }
            // $log.info(user);
            return $timeout(function(){
                if(!service.clients || force){
                    // $log.info('XXX - Loading workspaces');

                    // $log.info('Puilling Clients from scratch...');

                    // Clear our array and previous service values
                    clientsArray = [];
                    if(_.has(service, 'clients')){
                        delete service.clients;
                    }
                    if(_.has(user, 'limits.clients')){
                        var clientLimit = user.limits.clients, own = 0;
                    } else {
                        var clientLimit = 1, own = 0;
                    }



                    // Using Array of Promises
                    var clients=[],
                        reads = [],
                        ref= firebase.database().ref();

                    // prepare our array of promises
                    if(_.has(user, 'clients')){
                           _.each(user.clients, function(value, key){
                               var ref = firebase.database().ref('/clients/'+key),
                                   obj = $firebaseObject(ref),
                                   promise = obj.$loaded().then(function(){
                                       if(obj.owner == user.uid){
                                           // Check if we are within limits
                                           if(own <= clientLimit){
                                               // if Owned space
                                               if(obj.demo && obj.status != 'archived'){
                                                   own = own + 1;
                                                   clientsArray.push(obj);
                                               } else if(obj.status == 'active' || obj.status == 'personal'){
                                                   own = own + 1;
                                                   clientsArray.push(obj);
                                               }
                                           }// if under limit

                                       } else {
                                           // If delegated space
                                           if(obj.status == 'active' || obj.status == 'personal'){
                                               // $log.info('pushing delegated: ' + obj.profile.fullName);
                                               clientsArray.push(obj);
                                           }
                                       }
                                   });
                               reads.push(promise);
                           });

                            return Promise.all(reads)
                            .then(function(){
                               service.clients = clientsArray;
                               // service.setupWorkspaceMenu();
                               $rootScope.$emit('workspacesRefreshed');
                               return service.clients;
                            }, function(error){
                               $log.warn('error loading workspaces');
                               $log.warn(error);
                               //heap.track('error loading workspaces');
                               userpilot.track('error loading workspaces');
                               $mdDialog.show(
                                    $mdDialog.alert()
                                      .parent(angular.element(document.querySelector('#popupContainer')))
                                      .clickOutsideToClose(true)
                                      .title('Sorry, I\'m having a problem loading your workspace data.')
                                      .textContent('Please refresh or login again. Contact help@getadminja.com if this message persists.')
                                      .ariaLabel('Adminja Error Dismissed')
                                      .ok('Continue')
                                  );
                            });
                        } else {
                            service.clients = [];
                            return service.clients
                        }




                } else {
                    // $log.info('already have service.clients. Returning.');
                    return service.clients
                    // deferred.resolve(service.clients);
                    // // $log.info(service.clients);
                    // return $q.when(service.clients);
                }
            });
        }// thisUsersWorkspaces

        //this function used in the service function below
        function prepUserData(user){
            // var userType = 'unknown',
            // clientLimit = 1;

            // if(!_.has(user, 'profile')){
            //     var user = {};
            //     // alert('no user!');
            // }

            // if (_.has(user, 'limits.clients')) {
            //     clientLimit = user.limits.clients;
            // }

            // var startDate;
            // if (_.has(user, 'profile.startDate')) {
            //     startDate = user.profile.startDate;
            // } else {
            //     startDate = '2016-10-01';
            // }

            // // set our defaults so we don't throw errors
            // var plan = 'starter-2018c', status = 'unknown';
            // // and overwrite from .plan if it exists
            // if(_.has(user,'plan')){
            //     plan = user.plan.content__subscription__plan_id;
            //     status = user.plan.content__subscription__status;
            // }
            // var firstName = "",
            //     lastName = "";

            // if(_.has(user.profile, 'firstName')){
            //     firstName = user.profile.firstName;
            // }
            // if(_.has(user.profile, 'lastName')){
            //     lastName = user.profile.lastName;
            // }

            // If this is an old pre-launch beta user, we need to refer to non-camelCased names. Uggh.
            if (!localStorageService.get('userName')) {
                if (_.has(user, 'profile.firstName')) {
                    // we have a handful of users on a misnamed schema. FUN TIMES!
                    localStorageService.set('userName', user.profile.firstName + ' ' + user.profile.lastName);
                } else if (_.has(user, 'profile.firstname')){
                    localStorageService.set('userName', user.profile.firstname + ' ' + user.profile.lastname);
                }
            }

            if (!_.has(user, 'profile.avatar')) {
                localStorageService.set('userAvatar', "/assets/images/avatars/generic-person-avatar.png");
            } else {
                localStorageService.set('userAvatar', user.profile.avatar);
            }

        }

        //////////////////////////////////
        // setupUserAndClientMenu
        //////////////////////////////////
        function setupUserAndClientMenu(force) {
            // $log.info('setupUserAndClient Menu ' + force);
            return $timeout(function(){
                    return userDataService.getLoggedInUser(force)
                            .then(function (user) {
                                // extract our assigned client IDs
                                // $log.info('Asking for thisUsersWorkspaces');
                                return thisUsersWorkspaces(user, force)
                                .then(function (clients) {
                                    // triggered by an emit from "thisUsersWorkspaces"

                                    // $log.info('after thisUsersWorkspaces');
                                    // if(clients.length){
                                    //     $log.info('setting up menu');
                                    //     // service.setupWorkspaceMenu();
                                    // }
                                });
                            });
                       },0);
        } // setupUserAndClientMenu

        function setupWorkspaceMenu(){
            // $log.info('setupWorkspaceMenu');

            // $log.info(service.clients);
            var menus = triMenu.menu,
                    clientLimit = 1,
                    user = userDataService.user;

            // If this is an old pre-launch beta user, we need to refer to non-camelCased names. Uggh.
            if (!localStorageService.get('userName')) {
                if (_.has(user, 'profile.firstName')) {
                    // we have a handful of users on a misnamed schema. FUN TIMES!
                    localStorageService.set('userName', user.profile.firstName + ' ' + user.profile.lastName);
                } else if (_.has(user, 'profile.firstname')){
                    localStorageService.set('userName', user.profile.firstname + ' ' + user.profile.lastname);
                }
            }

            if (!_.has(user, 'profile.avatar')) {
                localStorageService.set('userAvatar', "/assets/images/avatars/generic-person-avatar.png");
            } else {
                localStorageService.set('userAvatar', user.profile.avatar);
            }

            // If we are forcing a client menu rebuild, remove the current one
                triMenu.removeMenu('triangular.workspaces');
                triMenu.removeMenu('triangular.vaworkspaces');
                triMenu.removeMenu('triangular.clients');
                triMenu.removeMenu('triangular.internal');
                triMenu.removeMenu('triangular.admin-menu');

            if (_.has(user, 'limits.clients')) {
                clientLimit = user.limits.clients;
            }

            var clientCount = 0, internalOwnCount = 0, internalDelegatedCount = 0, delegatedClientCount = 0;

            var workspaceMenuName = 'Client Workspaces';

            // if(user.type == 'client'){
            //     workspaceMenuName = 'Client Workspaces'
            // }

            var clientMenu = {
                name: workspaceMenuName,
                icon: 'zmdi zmdi-folder-person',
                type: 'dropdown',
                state: 'triangular.clients',
                priority: 3.0,
                open: false,
                children: []
            }

            // var delegatedMenu = {
            //     name: 'Delegated',
            //     icon: 'zmdi zmdi-account-box',
            //     type: 'dropdown',
            //     state: 'triangular.workspaces',
            //     priority: 4.0,
            //     open: false,
            //     children: []
            // }

            var internalMenu = {
                name: 'Internal Workspaces',
                icon: 'zmdi zmdi-folder',
                type: 'dropdown',
                state: 'triangular.internal',
                priority: 5.0,
                open: false,
                children: []
            }

            // if user is also a client, prep their menu as well

                var vaWorkspacesMenu = {
                    name: 'VA Workspaces',
                    icon: 'zmdi zmdi-folder',
                    type: 'dropdown',
                    state: 'triangular.internal',
                    priority: 4.0,
                    open: false,
                    children: []
                }



            if (service.clients.length > 0) {
                var ownClientCount = 0, clientUserClientCount = 0;;
                // Setup our menu object
                // $log.info('setting up menu');
                _.each(service.clients, function (client, index) {
                    var disabled = true;
                    // Override - allow anything flagged as a demo workspace to show
                    if(client.demo == true){
                        disabled = false;
                        client.type = 'own';

                    } else if(client.owner === user.uid){
                        if (ownClientCount < clientLimit) {
                            disabled = false;
                        }
                        ownClientCount = ownClientCount + 1;
                        // set flag so we can know which clients are owned and which are delegated
                        client.type = 'own';
                        // if workspace has user listed as clientUser
                    } else if(_.has(client, 'clientUsers['+user.uid+']')){
                        client.type = 'clientUser';
                        clientUserClientCount ++;
                        disabled = false;
                    }
                    else {
                        // this client is owned by someone else's account. we MUST allow it.
                        disabled = false;
                        client.type = 'delegated';
                    }


                    if(client.type != 'clientUser'){
                        addClientMenuItem(client, index, disabled, status);
                    } else {
                        addVAMenuItem(client, index, disabled, status);
                    }


                });// each client

                      var searchMenuItem = {
                          name:'Workspace Search',
                          // state: 'triangular.workspaces-manager',
                          icon: 'fa fa-gears',
                          type: 'search',
                          searchScope: 'triangular.workspaces',
                          priority: 1
                      };

                      var delegatedLabel = {
                        name: 'Delegated Workspaces',
                        // state: 'triangular.workspaces-manager',
                        // icon: 'fa fa-gears',
                        type: 'label',
                        align: 'center',
                        // badgeIcon: 'fa fa-gears',
                        priority: 500
                    }



                      if((clientCount + delegatedClientCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          clientMenu.children.push(searchMenuItem)
                      }

                      if((internalOwnCount + internalDelegatedCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          internalMenu.children.push(searchMenuItem)
                      }

                      if((clientUserClientCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          vaWorkspacesMenu.children.push(searchMenuItem)
                      }

                      // $log.info('clientCount: ' + clientCount);
                      // $log.info('delegatedClientCount: ' + delegatedClientCount);
                      // $log.info('internalOwnCount: ' + internalOwnCount);
                      // $log.info('internalDelegatedCount: ' + internalDelegatedCount);

                       if(delegatedClientCount > 0 && clientCount > 0){
                          clientMenu.children.push(delegatedLabel);
                       }

                       if(internalOwnCount > 0 && internalDelegatedCount > 0){
                          internalMenu.children.push(delegatedLabel);
                       }

                      if(user.type != 'client'){
                        triMenu.addMenu(clientMenu);
                        }

                      if(clientUserClientCount > 0 && !$rootScope.vaWorkspacesMenuBuilt){
                        triMenu.addMenu(vaWorkspacesMenu);
                        $rootScope.vaWorkspacesMenuBuilt = true;

                      }

                      if((internalOwnCount + internalDelegatedCount) > 0 && user.type != 'client'){
                          // $log.info('adding internal menu');
                          triMenu.addMenu(internalMenu);
                      }

                      // if(delegatedCount > 0){
                      //     triMenu.addMenu(delegatedMenu);
                      // }
                      // $log.info('clientMenu complete with clients');
                      // $log.info(clientMenu);



                $rootScope.$emit('clientMenuBuilt');
                return
            } else {

                    // spit out our empty menu so
                    triMenu.addMenu(clientMenu);

                    // alert teamDataService to init
                    $rootScope.$emit('clientMenuBuilt');
                    return

            }

            // utility function - setup and add each client to menu array
            function addClientMenuItem(client, index, disabled, userStatus) {

                    if (_.has(client.profile, 'fullName')) {
                        // TODO -we need to stop using .name and use .fullName instead throughout system
                        client.profile.name = client.profile.fullName;
                    } else {
                        client.profile.name = client.profile.firstname + ' ' + client.profile.lastname;
                    }


                    var thumbnail = undefined;

                    // Set most common default
                    thumbnail = "/assets/images/avatars/generic-person-avatar.png";

                    // Various cascade of checks to determine thumnbail for this workspace
                    if (!_.has(client.profile,'avatar') && client.status == 'personal') {
                        thumbnail = "/assets/images/avatars/generic-default-avatar.png";
                    }

                     if (_.has(client.profile,'avatar')) {
                         thumbnail = client.profile.avatar;
                     }

                     if (_.has(client.profile,'thumbnail')) {
                         thumbnail = client.profile.thumbnail;
                     }


                     // $log.info('nav thumb: ' + thumbnail);
                    if (!client.profile.clientColor) {
                        client.profile.clientColor = "#999"
                    }

                    // if we don't own this client. Put it at the bottom of our menu
                    if(client.owner != $rootScope.userID){
                        client.order = client.order + 100
                    }
                    var newPriority = client.order + 6;

                    if(client.type == 'delegated'){
                        newPriority = client.order + 500;
                    }

                    var clientMenuItem = {
                            name: client.profile.name,
                            email: client.profile.email,
                            icon: thumbnail,
                            avatar: thumbnail,
                            avatarThumb: thumbnail,
                            clientType: client.type,
                            priority: newPriority,
                            type: 'client',
                            state: 'triangular.workspaces.tasks',
                            color: client.profile.clientColor,
                            clientid: client.uid,
                            clientactive: false,
                            disabled: disabled,
                            subStatus: userStatus,
                            status: client.status
                        }

                    // push to the correct menu

                    if(client.status == 'personal'){
                        if(client.type == 'own'){
                            internalOwnCount ++
                        } else if (client.type == 'delegated'){
                            internalDelegatedCount ++
                        }
                        internalMenu.children.push(clientMenuItem);
                    } else {
                        if(client.type == 'own'){
                            clientCount ++
                        }
                        if(client.type == 'delegated'){
                            delegatedClientCount ++
                        }
                        clientMenu.children.push(clientMenuItem);
                    }

            }
                function addVAMenuItem(client, index, disabled, userStatus) {
                    if(!_.has($rootScope, 'VAWorkspacesMenu')){
                        $rootScope.VAWorkspacesMenu = [];
                    }

                    firebase.database().ref('/userList/' + client.owner).once('value').then(function(snapshot){
                        var virtualAssistant = snapshot.val();
                        var thumbnail = undefined;
                        // Set most common default
                        thumbnail = "/assets/images/avatars/generic-person-avatar.png";
                        if(_.has(virtualAssistant, 'avatar')){
                            thumbnail = virtualAssistant.avatar
                        }

                         // $log.info('nav thumb: ' + thumbnail);
                        if (!client.profile.clientColor) {
                            client.profile.clientColor = "#999"
                        }

                        // adjust the client's fullName to indicate which VA it's with
                        if(!client.profile.adjustedName){
                            client.profile.fullName = client.profile.fullName + ' and ' + virtualAssistant.fullName;
                            client.profile.adjustedName = true;
                        }

                        var clientMenuItem = {
                                name: client.profile.fullName,
                                email: client.profile.email,
                                icon: thumbnail,
                                avatar: thumbnail,
                                avatarThumb: thumbnail,
                                clientType: client.type,
                                priority: 3 + index,
                                type: 'va',
                                state: 'triangular.workspaces.tasks',
                                color: client.profile.clientColor,
                                clientid: client.uid,
                                clientactive: false,
                                disabled: disabled,
                                subStatus: userStatus,
                                status: client.status
                            }

                            vaWorkspacesMenu.children.push(clientMenuItem);
                            $rootScope.VAWorkspacesMenu.push(clientMenuItem);
                    });
            }// addVaMenuItem
        }




        function restoreClient(client){
            // $log.info('clientDataService.restoreClient');
            var canRestore = true,
                today = moment();

            // if previously Restored, check to see if they should be allowed to do it again
            // if(_.has(client, 'lastRestored')){
            //     var previous = moment(client.lastRestored),
            //         difference = today.diff(previous, 'days');
            //     if (difference > 15){
            //         canRestore = true;
            //     }  else {
            //         canRestore = false;
            //     }
            // }

            if (canRestore || userDataService.user.type == 'admin'){
                var updates = {};
                updates['clients/' + client.uid + '/status'] = client.oldStatus;
                updates['clients/' + client.uid + '/lastRestored'] = moment().toISOString();
                updates['clients/' + client.uid + '/access/users/' + client.owner] = true;
                updates['clients/' + client.uid + '/access/admins/' + client.owner] = true;
                updates['users/' + client.owner + '/clients/'+ client.uid] = true;
                // remove from the team archive list
                updates['teams/' + client.owner + '/archivedWorkspaces/' + client.uid] = null;

                // if being restored by a team administrator, add them as well
                if(client.owner != $rootScope.userID){
                    updates['clients/' + client.uid + '/access/users/' + $rootScope.userID] = true;
                    updates['clients/' + client.uid + '/access/admins/' + $rootScope.userID] = true;
                    updates['users/' + $rootScope.userID + '/clients/'+ client.uid] = true;
                    updates['teams/' + client.owner + '/members/' + $rootScope.userID + '/clients/' + client.uid] = 'admin';
                }

                updates['clients/' + client.uid + '/access/archiveOwner/' + client.owner] = null;
                return firebase.database().ref().update(updates)
                // Add the default "Client Details" panel to this client
                .then(function (response) {
                    service.setupUserAndClientMenu(true);
                    // service.thisUsersWorkspaces(userDataService.user, true);
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: client.profile.fullName + ' has being restored.',
                                message: '' ,
                                color: 'green'
                            }
                        }));// mdToast
                });
            } else {
                // This Space has already been restored once in the past 30 days.
                // Prohibit doing it now
                $mdDialog.show(
                     $mdDialog.alert()
                       .parent(angular.element(document.querySelector('#popupContainer')))
                       .clickOutsideToClose(true)
                       .title('Restore Prohibited')
                       .textContent('To prevent abuse, a Space can only be archived/restored once per month.')
                       .ariaLabel('Restore Prohibited')
                       .ok('Got it!')
                       .targetEvent()
                   );
            }


            // if lastRestored IS within past 30 days - block restore

        } // restoreClient

        function archiveClient(client){
            // $log.info('clientDataService.archiveClient');
            var oldStatus = client.status;
            var updates = {};
            updates['clients/' + client.uid + '/oldStatus'] = oldStatus;
            updates['clients/' + client.uid + '/status'] = 'archived';
            updates['clients/' + client.uid + '/lastArchived'] = moment().toISOString();
            // add owner to /access/archiveOwner
            updates['clients/' + client.uid + '/access/archiveOwner/' + client.owner] = true;
            // remove owner from /users list
            updates['clients/' + client.uid + '/access/users/' + client.owner] = null;

            // add to team node list of archived clients (we will pull archived clients from this)
            // TODO - create utility function and create this node for all archived clients that currently exist.

            updates['/teams/' + client.owner + '/archivedWorkspaces/' + client.uid] = true;


            return firebase.database().ref().update(updates)
            // Add the default "Client Details" panel to this client
            .then(function (response) {
                dataLayer.push({'event': 'workspace-archived'});
                service.setupUserAndClientMenu(true);
                //heap.track('Client Archived');
                userpilot.track('Client Archived');
                // service.thisUsersWorkspaces(userDataService.user, true);
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: client.profile.fullName + ' is being archived.',
                            message: ' ',
                            color: 'red'
                        }
                    }));// mdToast
            });

        }// archiveClient


        function copyClient(clientID, targetUserID, isDemo){
            return service.getClient(clientID)
            .then(function(client){
                //heap.track('Client Copied');
                userpilot.track('Client Copied');
                return doCopy(client, targetUserID, isDemo);
            });

            // the actual work
            function doCopy(client, targetUserID, isDemo){
                // prepare a backup client and our newClient object
                var clientCopy = angular.fromJson(angular.toJson(client)),
                    newClient = angular.fromJson(angular.toJson(client)),
                    updates = {},
                    now = moment().toISOString();

                clientCopy = ajUTILITIES.removePropertiesWith(clientCopy);
                newClient = ajUTILITIES.removePropertiesWith(newClient);

                //Get new UID for this client
                var newKey = firebase.database().ref('/clients').push().key;

                newClient.uid = newKey;
                newClient.owner = targetUserID;

                //Add demo flag if set
                if(isDemo){
                    newClient.demo = true;
                    updates['/users/' + targetUserID + '/firstLogin'] = true;
                }


                // Remove accumulated dirt
                delete newClient.lastRestored
                delete newClient.lastArchived
                delete newClient.oldStatus
                delete newClient.retainer_totals
                delete newClient.time
                delete newClient.totals
                delete newClient.billing
                delete newClient.invoices
                delete newClient.profile.workspaceAddress
                delete newClient.schedules
                delete newClient.clientUsers
                delete newClient.clientUserTabs
                delete newClient.profile.weeklyStatusReport
                delete newClient.profile.weeklyStatusReportEnabled
                delete newClient.accountUpdated


                // set our created nodes
                newClient.created = now;
                newClient.accountCreated = newClient.owner + now;

                /// this isn't stored on the DB but is added after load.
                // let's make sure we don't store it on the copy
                delete newClient.type

                // Remove and replace access
                delete newClient.access
                newClient.access = {};
                newClient.access.users = {};
                newClient.access.users[targetUserID] = true;
                newClient.access.admins = {};
                newClient.access.admins[targetUserID] = true;

                // Prepare plan to start on today
                if(_.has(newClient.profile, 'plan.currentPeriod')){
                    delete newClient.profile.plan.currentPeriod;
                }
                if(!_.has(newClient, 'profile')){
                    newClient.profile = {};
                }
                if(!_.has(newClient, 'profile.plan')){
                    newClient.profile.plan = {};
                }

                if(!isDemo){
                    if(newClient.profile.isCompany){
                        newClient.profile.company = "Copy of " + newClient.profile.company;
                    } else {
                        newClient.profile.fullName = "Copy of " + newClient.profile.fullName;
                    }

                    newClient.profile.name = "Copy of " + newClient.profile.name;
                }


                // Give them an empty plan
                newClient.profile.plan = { rate: 0};

                // newClient.profile.plan.nextCycle = moment().startOf('month').startOf('day').toISOString();
                // newClient.profile.plan.monthDay = moment().format('D');
                // newClient.profile.plan.ruleString = "RRULE:FREQ=MONTHLY;BYMONTHDAY=1;INTERVAL=1"
                // newClient.profile.plan.startDate = moment().startOf('day').toISOString();

                // Remove the items we are going to rebuild properly from backup
                delete newClient.tasks
                delete newClient.taskpanels
                delete newClient.taskTemplates
                delete newClient.panels

                // make sure the workspace is active
                newClient.status = 'active';


                updates['/clients/' + newKey] = newClient;
                updates['/users/' + targetUserID +'/clients/' + newKey] = true;

                return firebase.database().ref().update(updates)
                .then(function(){
                    return copyTaskBoard(clientCopy, newClient)
                })
                .then(function(){
                        return copyNotes(clientCopy, newClient)
                    })
                .then(function(){
                        return copyTaskTemplates(clientCopy, newClient);
                })
                .then(function(){
                    return newClient
                });
            }// doCopy

        }// copyClient

            function copyTaskBoard(clientCopy, newClient){
                // $log.info('copy Task Board');
                return copyTaskLists(clientCopy, newClient)
                .then(function(listMap){
                    return copyTasks(clientCopy, newClient, listMap)
                });
            }// copyTaskBoard

            function copyTaskLists(clientCopy, newClient){
                // $log.info('copy Task Lists');
                var updates = {};
                var listMap = {};
                _.each(clientCopy.taskpanels, function(list){
                    var newKey = firebase.database().ref('/clients/'+ clientCopy.uid + '/taskpanels').push().key;

                    // store our ID mapping so we can look it up later when we do tasks
                    listMap[list.uid] = newKey;

                    // Create our newList
                    var newList = angular.fromJson(angular.toJson(list));
                    newList.uid = newKey;
                    newList.client = newClient.uid;

                    // Add the list to our updates
                    updates['/clients/' + newClient.uid + '/taskpanels/' + newKey] = newList;
                });// each list

                return firebase.database().ref().update(updates)
                .then(function(){
                    return listMap
                })
            }// copyTaskLists


            function copyTaskTemplates(clientCopy, newClient, listMap){
                // $log.info('copy Tasks');
                _.each(clientCopy.taskTemplates, function(task){
                    // $log.info('copying taskTemplates');
                    var updates = {};
                    // only if it's good data
                    if(_.has(task, 'uid')){
                        var newKey = firebase.database().ref('/taskTemplates/').push().key;
                        // get the full task from DB
                        var taskRef = firebase.database().ref('taskTemplates/' + task.uid);
                        return $firebaseObject(taskRef)
                                .$loaded(function (fullTask) {

                            var newTask = angular.fromJson(angular.toJson(fullTask));
                            newTask = ajUTILITIES.removePropertiesWith(newTask);

                            delete newTask.notes;
                            delete newTask.activity;
                            delete newTask.checklist;
                            delete newTask.info.duedate;
                            delete newTask.info.startdate;
                            delete newTask.info.assigneeName;
                            delete newTask.info.assigneeAvatar;
                            delete newTask.info.parentTemplate;
                            newTask.schedule.count = 0;
                            newTask.uid = newKey;
                            newTask.info.refID = newKey;
                            newTask.info.client = newClient.uid;
                            newTask.info.clientName = newClient.profile.fullName;
                            newTask.creator = newClient.owner;
                            newTask.info.assignee = newClient.owner;
                            newTask.info.created = moment().unix();
                            newTask.info.logged = 0;
                            newTask.info.numnotes = 0;
                            // newTask.info.private = false;
                            newTask.info.status = 'open';

                            newTask.info.panel = "Later"

                            // Flag all files as pending copy
                            // our taskFileChange cloud function will make file copies and adjust the paths.
                            if(_.has(newTask.info, 'files')){
                                _.each(newTask.info.files, function(file, index){
                                    // if the file is stored in firebase, we need to copy it to the new workspace
                                    if(file.source == "firebaseStorage"){
                                        file.source = "pendingFirebaseStorage";
                                        file.newFullPath = '/clients/' + newTask.info.client + '/taskTemplates/' + file.fileName;
                                        file.newResponsePath = '/taskTemplates/' + newTask.uid + '/info/files/' + index;
                                        file.newResponsePath2 = '/clients/' + newTask.info.client + '/taskTemplates/' + newTask.uid + '/info/files/' + index;
                                    }
                                    // if(file.source == "googleDrive"){
                                    //     file.source = "pendingGoogleDrive";
                                    //     file.newWorkspace = newTask.info.client;
                                    //     file.newOwner = newClient.owner;
                                    //     file.newTask = newTask.uid;
                                    // }
                                    // if(file.source == "dropbox"){
                                    //     file.source = "pendingDropbox";
                                    //     file.newWorkspace = newTask.info.client;
                                    //     file.newOwner = newClient.owner;
                                    //     file.newTask = newTask.uid;
                                    // }
                                })
                            }// if task has files

                            updates['/taskTemplates/' + newTask.uid] = newTask;
                            updates['/clients/' + newTask.info.client + '/taskTemplates/' + newTask.uid] = newTask;
                            // updates['/users/' + newClient.owner + '/tasks/' + newTask.uid] = newTask.info;
                            // save our new task and it's fanned data
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                // if checklist, add
                                if(_.has(fullTask, 'checklist')){
                                    var updates = {};
                                    _.each(fullTask.checklist, function(item){
                                       var newChecklistItem = angular.fromJson(angular.toJson(item));
                                       newChecklistItem = ajUTILITIES.removePropertiesWith(newChecklistItem);

                                       var newItemID = firebase.database().ref('/tasks').push().key;
                                       newChecklistItem.uid = newItemID
                                       updates['/taskTemplates/' + newTask.uid + '/checklist/'+newItemID] = newChecklistItem;
                                    });
                                    return firebase.database().ref().update(updates)
                                };
                            });
                        });// return Task
                    }// if valid task
                });// each
            }//copyTaskTemplates

            function copyTasks(clientCopy, newClient, listMap){
                // $log.info('copy Tasks');
                _.each(clientCopy.tasks, function(task){
                    // $log.info('copying task');
                    var updates = {};
                    // only if it's good data
                    if(_.has(task, 'refID')){
                        var newKey = firebase.database().ref('/tasks/').push().key;
                        // get the full task from DB
                        var taskRef = firebase.database().ref('tasks/' + task.refID);
                        return $firebaseObject(taskRef)
                                .$loaded(function (fullTask) {

                            var newTask = angular.fromJson(angular.toJson(fullTask));
                            newTask = ajUTILITIES.removePropertiesWith(newTask);

                            delete newTask.notes
                            delete newTask.activity
                            delete newTask.checklist
                            // delete newTask.info.duedate
                            // delete newTask.info.startdate
                            delete newTask.info.assigneeName;
                            delete newTask.info.assigneeAvatar;
                            delete newTask.info.parentTemplate;
                            newTask.uid = newKey;
                            newTask.info.refID = newKey;
                            newTask.info.client = newClient.uid;
                            newTask.info.clientName = newClient.profile.fullName;
                            newTask.creator = newClient.owner;
                            newTask.info.assignee = newClient.owner;
                            newTask.info.created = moment().unix();
                            newTask.info.logged = 0;
                            newTask.info.numnotes = 0;
                            newTask.info.private = false;
                            // newTask.info.status = 'open';


                            if(newTask.info.panel == null || !_.has(newTask.info, 'panel')){
                                newTask.info.panel = "Later"
                            }

                            if(newTask.info.panel != "Later"){
                                // assign the newList ID
                                newTask.info.panel = listMap[newTask.info.panel]
                            }

                            // Duplicated to clean up if previious if statement yields a null value
                            if(newTask.info.panel == null || !_.has(newTask.info, 'panel')){
                                newTask.info.panel = "Later"
                            }

                            // Flag all files as pending copy
                            // our taskFileChange cloud function will make file copies and adjust the paths.
                            if(_.has(newTask.info, 'files')){
                                var uniqueID = guid();
                                _.each(newTask.info.files, function(file, index){
                                    if(file.source == "firebaseStorage"){
                                        file.source = "pendingFirebaseStorage";
                                        file.newFullPath = 'clients/' + newTask.info.client + '/tasks/' + uniqueID + file.fileName;
                                        file.newResponsePath = 'tasks/' + newTask.uid + '/info/files/' + index;
                                        file.newResponsePath2 = 'clients/' + newTask.info.client + '/tasks/' + newTask.uid + '/info/files/' + index;
                                    }
                                    // if(file.source == "googleDrive"){
                                    //     file.source = "pendingGoogleDrive";
                                    //     file.newWorkspace = newTask.info.client;
                                    //     file.newOwner = newClient.owner;
                                    //     file.newTask = newTask.uid;
                                    // }
                                    // if(file.source == "dropbox"){
                                    //     file.source = "pendingDropbox";
                                    //     file.newWorkspace = newTask.info.client;
                                    //     file.newOwner = newClient.owner;
                                    //     file.newTask = newTask.uid;
                                    // }
                                })
                            }// if task has files

                            updates['/tasks/' + newTask.uid] = newTask;
                            updates['/clients/' + newTask.info.client + '/tasks/' + newTask.uid] = newTask.info;
                            updates['/users/' + newClient.owner + '/tasks/' + newTask.uid] = newTask.info;

                            // save our new task and it's fanned data
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                // if checklist, add
                                if(_.has(fullTask, 'checklist')){
                                    var updates = {};
                                    _.each(fullTask.checklist, function(item){
                                       var newChecklistItem = angular.fromJson(angular.toJson(item));
                                       newChecklistItem = ajUTILITIES.removePropertiesWith(newChecklistItem);

                                       var newItemID = firebase.database().ref('/tasks').push().key;
                                       newChecklistItem.uid = newItemID
                                       updates['/tasks/' + newTask.uid + '/checklist/'+newItemID] = newChecklistItem;
                                    });
                                    return firebase.database().ref().update(updates)
                                };
                            });
                        });// return Task
                    }// if valid task
                });// each
            }//copyTasks


            function copyNotes(clientCopy, newClient){
                // $log.info('copy Note Board');
                _.each(clientCopy.panels, function(panel){
                    if(_.has(panel, 'uid')){
                        var updates = {};
                        // Setup our new Panel
                        var newPanel = angular.fromJson(angular.toJson(panel));
                        newPanel = ajUTILITIES.removePropertiesWith(newPanel);
                        var newPanelKey = firebase.database().ref('/clients/'+newClient.uid+'/panels').push().key;

                        delete newPanel.details;
                        newPanel.uid = newPanelKey;
                        newPanel.client = newClient.uid;
                        newPanel.createdOn = moment().toISOString();
                        updates['/clients/' + newClient.uid + '/panels/'+ newPanel.uid] = newPanel;
                        // create our panel
                        return firebase.database().ref().update(updates)
                        .then(function(){
                            var detailUpdates = {}
                            // setup our deails array
                            _.each(panel.details, function(detail){
                                var newDetail = angular.fromJson(angular.toJson(detail));
                                newDetail = ajUTILITIES.removePropertiesWith(newDetail);
                                var newDetailKey = firebase.database().ref('/clients').push().key;
                                newDetail.client = newClient.uid;
                                newDetail.panel = newPanelKey;
                                newDetail.uid = newDetailKey;

                                // Flag all files as pending copy
                                // our taskFileChange cloud function will make file copies and adjust the paths.
                                if(_.has(newDetail, 'files')){
                                    var uniqueID = guid();

                                    _.each(newDetail.files, function(file, index){
                                        if(file.source == "firebaseStorage"){
                                            file.source = "pendingFirebaseStorage";
                                            file.newFullPath = '/clients/' + newDetail.client + '/profile/' + uniqueID + file.fileName;
                                            file.newResponsePath = '/clients/' + newDetail.client + '/panels/' + newPanelKey + '/details/' + newDetailKey + '/files/' + index;
                                        }
                                        // if(file.source == "googleDrive"){
                                        //     file.source = "pendingGoogleDrive";
                                        //     file.newWorkspace = newDetail.client;
                                        //     file.newDetail = newDetailKey;
                                        //     file.newPanel = newPanelKey;

                                        // }
                                        // if(file.source == "dropbox"){
                                        //     file.source = "pendingDropbox";
                                        //     file.newWorkspace = newDetail.client;
                                        //     file.newDetail = newDetailKey;
                                        //     file.newPanel = newPanelKey;
                                        // }
                                    })
                                }// if task has files
                                detailUpdates['/clients/' + newClient.uid + '/panels/'+ newPanel.uid + '/details/' + newDetailKey] = newDetail;
                            });// each detail
                            // save our details on our panel
                            return firebase.database().ref().update(detailUpdates)
                        });
                    }//if valid panel

                }); // each panel
            }// copyNotes


            function setupClientPanels(client){

               var profilePanels = [];

                //if it's a client workspace, include the client details panel by default.
                if(client.status != 'personal'){
                    var defaultPanel = { 'label': 'Client Details',
                      'color': '#787575',
                      'order': 1
                    }
                    profilePanels.push(defaultPanel)
                }


                // Add our profile panels
                _.each(profilePanels, function(panel, index){
                    var updates = {};
                    var newPanelKey = firebase.database().ref().child('clients/' + client.uid + '/panels').push().key,
                        newPanel = {
                            client: client.uid,
                            details: {},
                            order: index+1,
                            label: panel.label,
                            color: panel.color,
                            uid: newPanelKey
                        };

                    // $log.info(newPanel);
                    updates['clients/' + client.uid + '/panels/' + newPanelKey] = newPanel;
                    return firebase.database().ref().update(updates)

                });

            }// setupClientPanels


            // Utility function used to generate unique IDs for each image uploaded to storage
            function guid() {
              function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
              }
              return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
            }

    };// service



})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('clientBillingService', clientBillingService);

    /* @ngInject */
    function clientBillingService($log, moment, taskDataService,
                userDataService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject, timeReportService, invoiceService) {


        var service = {
            init: init,
            selectPeriod: selectPeriod,
            updateBillingPeriod: updateBillingPeriod,
            findPeriod: findPeriod

        };

        return service;

        var userID = undefined;

        // Initialize service.timerData object
        function init(clientID){
            var user = firebase.auth().currentUser;
            if (user){
              userID = user.uid;
              // clear our selected Period
              delete service.selectedPeriod
            }
        }


        function findPeriod(client, date){
          if(_.has(client, 'billing')){
              var queryDate = moment(date).startOf('day').toISOString();
              _.each(client.billing, function(billingPeriod){
                  if(moment(billingPeriod.start).startOf('day').toISOString() <= queryDate && moment(billingPeriod.end).endOf('day').toISOString() > queryDate){
                     return billingPeriod
                  }
              });
          }
        }

        function selectPeriod(period){
          // $log.info('selectPeriod:', period);
          var newPeriod = {},
              periodRef = firebase.database().ref('billingPeriods/' + period.uid);
          return $firebaseObject(periodRef)
                  .$loaded(function (data) {
                      delete invoiceService.selectedInvoice;
                      delete invoiceService.selectedTime;
                      service.selectedPeriod = data;
                      // Update timeReportService so we have access to the time for this period.
                      timeReportService.getClientsTime(service.selectedPeriod.info.client, moment(service.selectedPeriod.info.end).toDate(), moment(service.selectedPeriod.info.start).toDate());
                  });
        } // selectPeriod

        function updateBillingPeriod(info){
          // We pass period.info here because we only update the .info node.
          // The other nodes (invoices, line items) are updated separately
          // $log.info('updateBillingPeriod', info.uid);
          var updates = {};
          // update our canonical object
          updates['billingPeriods/' + info.uid + '/info'] = info;
          // update our reference in the client's
          updates['clients/' + info.client + '/billing/' + info.uid] = info;
          // Execute our update
          return firebase.database().ref().update(updates)
                  .then(function () {
                      // $log.info('Billing Period Updated');
                      // heap.track('Billing Period Updated');
                  });

        } // updateBillingPeriod


    } // end clientBillingService
})();

(function () {
    'use strict';
    angular.module('appServices')
            .service('aggregateDataService', aggregateDataService);

    /* @ngInject */
    function aggregateDataService($mdToast, $mdDialog, localStorageService, $q, $timeout, $log, $http, $rootScope, $firebaseArray, $firebaseAuth, $firebaseObject,clientDataService) {

        var service = {
            timeCounter: timeCounter,
            taskCounter: taskCounter,
            toggleTask: toggleTask,
            calcTotals: calcTotals
        };

        return service;


        ///////////////////////////////////////////////////////////
        /// timeCounter
        function timeCounter(timeEntry, mode) {
            // $log.info('timeCounter');

            var thisMonth = timeEntry.month,
                    thisYear = timeEntry.year,
                    thisWeek = timeEntry.week,
                    counter = 'minutes',
                    clientID = timeEntry.client,
                    userID = timeEntry.creator,
                    updateAmount = 0;

            // Set updateAmount: Determine the value we are going to increment with
            if (mode == "delete") {
                // $log.info('Deleting Time from aggregate');
                // if we are in "delete" mode, we will update with a negative of the whole
                updateAmount = -Math.abs(timeEntry.logged);
            } else if (_.has(timeEntry, 'oldLogged')) {
                // if we have oldLogged time, subtract it from this update
                updateAmount = timeEntry.logged - timeEntry.oldLogged;
            } else {
                // this is new time, just add the amount passed to us
                updateAmount = timeEntry.logged;
            }

            var clientTotals,
                    userTotals;

            var clientInfo = {};

            /* Check client's Retainer period */

            clientDataService.getClient(timeEntry.client)
                    .then(function (client) {
                        clientInfo = client.profile;
                        return client.profile;
                    }).then(function () {

                var thisMonth = timeEntry.month,
                        thisYear = timeEntry.year,
                        thisWeek = timeEntry.week,
                        clientID = timeEntry.client,
                        userID = timeEntry.creator;

                if (_.has(clientInfo, 'plan')) {
                    if (clientInfo.plan.type == 'retainer') {
                        if (clientInfo.plan.retainerStart) {

                            var CurrentDate = moment(timeEntry.logDate).format("YYYY-MM-DD");

                            var tmpDate = thisYear + "/" + thisMonth + "/" + clientInfo.plan.retainerStart;

                            var RetainerDate = new Date(tmpDate);
                            RetainerDate = moment(RetainerDate).format("YYYY-MM-DD");

                            if (moment(CurrentDate).unix() >= moment(RetainerDate).unix()) {
                                /* Current Period*/

                            } else {
                                /* Previous Period */
                                thisMonth = parseInt(thisMonth) - 1;

                                if (thisMonth == 0) {
                                    thisMonth = 12;
                                    thisYear = parseInt(thisYear) - 1;
                                }
                            }
                        }

                        var clientTotalsRef = firebase.database().ref('clients').child(clientID).child('retainer_totals').child(thisYear),
                                userTotalsRef = firebase.database().ref('users').child(userID).child('totals').child(thisYear);

                    } else {
                        var clientTotalsRef = firebase.database().ref('clients').child(clientID).child('calendar_totals').child(thisYear),
                                userTotalsRef = firebase.database().ref('users').child(userID).child('totals').child(thisYear);
                    }
                } else {
                    var clientTotalsRef = firebase.database().ref('clients').child(clientID).child('calendar_totals').child(thisYear),
                            userTotalsRef = firebase.database().ref('users').child(userID).child('totals').child(thisYear);
                }

                // Update our client's totals
                clientTotalsRef.once('value').then(function (snapshot) {
                    // The first promise succeeded. Save snapshot for later.
                    clientTotals = snapshot.val();
                    // By returning a Promise, we know the function passed to "then" below
                    // will execute after the transaction finishes.
                    return clientTotalsRef.child('monthly').child(thisMonth).child(counter).transaction(function (current) {
                        // Increment readCount by 1, or set to 1 if it was undefined before.
                        return (current || 0) + updateAmount;
                    });
                }).then(function (result) {
                    return clientTotalsRef.child('weekly').child(thisWeek).child(counter).transaction(function (current) {
                        // Increment readCount by 1, or set to 1 if it was undefined before.
                        return (current || 0) + updateAmount;
                    });

                }, function (error) {
                    // Something went wrong.

                    $log.error('aggregateDataService timeCounter error:', error);
                });

                // Update our users's totals
                userTotalsRef.once('value').then(function (snapshot) {
                    // The first promise succeeded. Save snapshot for later.
                    userTotals = snapshot.val();
                    // By returning a Promise, we know the function passed to "then" below
                    // will execute after the transaction finishes.
                    return userTotalsRef.child('monthly').child(thisMonth).child(counter).transaction(function (current) {
                        // Increment readCount by 1, or set to 1 if it was undefined before.
                        return (current || 0) + updateAmount;
                    });
                }).then(function (result) {
                    return userTotalsRef.child('weekly').child(thisWeek).child(counter).transaction(function (current) {
                        // Increment readCount by 1, or set to 1 if it was undefined before.
                        return (current || 0) + updateAmount;
                    });

                }, function (error) {
                    // Something went wrong.
                    $log.error('aggregateDataService timeCounter error:', error);
                });

            });
        }
        ; // timeCounter

        ///////////////////////////////////////////////////////////
        /// taskCounter
        function taskCounter(task, counter, increment) {
            // $log.info('taskCounter');

            // Determine the targetDate to put this action on
            var targetDate = moment();
            if (task.status == 'closed') {
                targetDate = moment(task.closedDate);
            } else {
                targetDate = moment(task.created);
            }


            var thisMonth = parseInt(moment(targetDate).format('M')),
                    thisYear = parseInt(moment(targetDate).format('YYYY')),
                    thisWeek = parseInt(moment(targetDate).week()),
                    clientID = task.client,
                    userID = task.assignee;

            var clientTotals,
                    userTotals,
                    clientTotalsRef = firebase.database().ref('clients').child(clientID).child('totals').child(thisYear),
                    userTotalsRef = firebase.database().ref('users').child(userID).child('totals').child(thisYear);

            // Update our client's totals
            clientTotalsRef.once('value').then(function (snapshot) {
                // The first promise succeeded. Save snapshot for later.
                clientTotals = snapshot.val();
                // $log.info('clientTotals:', clientTotals);
                // By returning a Promise, we know the function passed to "then" below
                // will execute after the transaction finishes.
                return clientTotalsRef.child('monthly').child(thisMonth).child(counter).transaction(function (current) {
                    // Increment readCount by 1, or set to 1 if it was undefined before.
                    return (current || 0) + increment;
                });
            }).then(function (result) {
                return clientTotalsRef.child('weekly').child(thisWeek).child(counter).transaction(function (current) {
                    // Increment readCount by 1, or set to 1 if it was undefined before.
                    return (current || 0) + increment;
                });

            }, function (error) {
                // Something went wrong.

                $log.error('aggregateDataService taskCounter error:', error);
            });

            // Update our users's totals
            userTotalsRef.once('value').then(function (snapshot) {
                // The first promise succeeded. Save snapshot for later.
                userTotals = snapshot.val();
                // $log.info('userTotals:', userTotals);
                // By returning a Promise, we know the function passed to "then" below
                // will execute after the transaction finishes.
                return userTotalsRef.child('monthly').child(thisMonth).child(counter).transaction(function (current) {
                    // Increment readCount by 1, or set to 1 if it was undefined before.
                    return (current || 0) + increment;
                });
            }).then(function (result) {
                return userTotalsRef.child('weekly').child(thisWeek).child(counter).transaction(function (current) {
                    // Increment readCount by 1, or set to 1 if it was undefined before.
                    return (current || 0) + increment;
                });

            }, function (error) {
                // Something went wrong.
                console.error(error);
            });

        }
        ; // taskCounter

        ///////////////////////////////////////////////////////////
        /// toggleTask
        function toggleTask(task) {
            if (task.status == 'closed') {
                taskCounter(task, 'completed', 1);
            } else {
                taskCounter(task, 'completed', -1);
            }
        }
        ; // toggleTask

        ///////////////////////////////////////////////////////////
        /// removeTask
        function removeTask(task) {
            // no longer used. see comment in taskDataService.js
        }
        ; // removeTask

        ///////////////////////////////////////////////////////////
        /// calcTotals
        //  This function assumes there are no totals
        //  and regenerates all new.
        // Created for migrating beta tester's old data so their dashboard's work
        function calcTotals(userData, clientData) {
            // $log.info('calcTotals');
            // $log.info(userData, clientData);

            // Go through all clients
            _.each(clientData, function (client) {

                // Do our Task Counts
                _.each(client.tasks, function (task) {
                    taskCounter(task, 'new', 1);
                    if (task.status == 'closed') {
                        taskCounter(task, 'completed', 1);
                    }
                });// each client.tasks

                // Do our time counts
                var today = new Date();
                var year = today.getFullYear()

                return getClientTime(client.uid, year)
                        .then(function (time) {
                            _.each(time, function (timeEntry) {
                                timeCounter(timeEntry);
                            });// each time
                        });// return.then
            });// each clientData;

        }// calcTotals

        function getClientTime(clientID, year) {
            // $log.info('getClientTime');
            var timeRef = firebase.database().ref('time/');
            return $firebaseArray(timeRef.orderByChild('loadGroup').equalTo(year + '_' + clientID))
                    .$loaded(function (time) {
                        return time
                    });

        }//getClientTime


    }// aggregateDataService


})
        ();

(function() {
	'use strict';

	angular
		.module('appDirectives',['appServices', 'lk-color-chooser']);


	angular
		.module('appDirectives')
		.directive('ngEnter', function () {
		    return function (scope, element, attrs) {
		        element.bind("keydown keypress", function (event) {
		            if(event.which === 13 && event.ctrlKey) {
		                scope.$apply(function (){
		                    scope.$eval(attrs.ngEnter);
		                });
		                event.preventDefault();
		            }
		        });
		    };
		});
})();

(function() {
	'use strict';

	angular
		.module('appDirectives')
		.directive('todayPanel', todayPanel)
		.directive('allTodayPanel', allTodayPanel);

	function todayPanel() {
		var directive = {
			restrict: 'E',
			scope: {
				client: '=',
				tasks: '=',
				days: '='
				},
			// client: '=',
			controller: todayPanelController,
			controllerAs: 'vm',
			replace: true,
			preserveScope: true,
			bindToController: true,
			templateUrl: 'app/app-directives/today-panel/today-panel.tmpl.html'

		};
		return directive;
	};

	function allTodayPanel() {
		var directive = {
			restrict: 'E',
			scope: {
				tasks: '=',
				days: '='
				},
			// client: '=',
			controller: todayPanelController,
			controllerAs: 'vm',
			replace: true,
			preserveScope: true,
			bindToController: true,
			templateUrl: 'app/app-directives/today-panel/all-today-panel.tmpl.html'

		};
		return directive;
	};

	///////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////
	/// todayPanelController


/* @ngInject*/
	function todayPanelController(dragulaService, $log, userDataService, taskDataService, pageDimensionsService, $rootScope, $stateParams, $state, $scope, $timeout, $mdToast, clientDataService) {
		// $log.info($scope);
		// Once agaain, vm. can't be used. we have to use $scope.
		// $log.info('todayPanelController');
		var vm = this;
			$scope.showClientName = true;
			// Set our client ID, exposed to our directives
			if ($stateParams.clientID){
				vm.clientID = $stateParams.clientID;
				$scope.showClientName = false;
			}
			vm.state = $state;
			vm.now = moment().add(vm.days, 'days');
			vm.now = vm.now.toISOString();
			vm.verticalTaskPanels = userDataService.getUser().profile.settings.verticalTaskPanels;
			// set our drag/drop direction accordingly
			if(userDataService.getUser().profile.settings.verticalTaskPanels){
			        vm.taskDragDirection = "vertical"
			    } else {
			        vm.taskDragDirection = "horizontal"
			    }

			// if we are on the dashboard, we need to FORCE vertical panels
			if ($state.is('triangular.dashboard')) {
			    vm.verticalTaskPanels = true;
			}

			vm.suppressResize = false;
			// For some reason we are needing to be VERY specific about this truthy checking
			if (vm.verticalTaskPanels === true){
			    vm.suppressResize = true;
			}

		// we need this filter to be able to show appropriate items in today and waiting panels.
		$scope.todayFilter = function (task) {
		    return task.panel === 'due' || task.panel === 'today' || task.duedate <= vm.now | task.focus === 'today';
		};

		$scope.laterFilter = function (task) {
		    // $log.info(task.duedate + ' - ' + $scope.today);
		    // return !task.duedate || task.duedate > vm.now;
		    return true
		};

		// if we already have a Dragula bag by this name (we shouldn't but sometimes we do), destroy it
		if (dragulaService.find($scope, 'drag-today-task')){
			dragulaService.destroy($scope, 'drag-today-task');
		}

	      // Dragula Setup
	       dragulaService.options($scope, 'drag-today-task', {
	                 moves: function (el, container, handle) {
	                   return handle.classList.contains('task-handle');
	                 },
	                 accepts: function(el, target, source, sibling) {
	                  if (target === source){
	                    return true
	                  }
	                },
	                 direction: 'vertical'
	               });

	       ///////////
	       // Task Drop Listener
	       $scope.$on('drag-today-task.drop', function(event, item, target, source, sibling){
	           // $log.info('drag-today-task.drop');
	           // $log.info(item);
	           var itemID = item[0].attributes.taskid.nodeValue,
	               parentPanelID = item[0].attributes.taskpanel.nodeValue,
	               clientID = item[0].attributes.client.nodeValue,
	               targetPanelID = target[0].attributes.panelid.nodeValue,
	               newOrder = undefined;

	               // $log.info(targetPanelID);

	               // $log.info(target);
	               // $log(itemID, parentPanelID, clientID, targetPanelID);

	                // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
	                if (sibling != undefined){
	                   // this check is to make sure other tasks that don't have an order set don't throw an error
	                   if (!sibling[0].attributes.order.nodeValue){
	                       newOrder = undefined;
	                   } else {
	                       // sibling has an order, figure our ours from there
	                       newOrder = sibling[0].attributes.order.nodeValue;
	                   }
	                }

	                 // just moving within the same panel
	                 sortTasks(target[0], clientID);
	                 // resize our columns
	                 if (!vm.suppressResize){
	                 $timeout(function(){
	                   pageDimensionsService.resizeColumns();
	                   // heap.track('Tasks Reordered');
	                 }, 500);
	            }

	       });// $on.drag-task.drop


		$scope.newTask = function(clientID, panel){
		    // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
		    $scope.editedItem = taskDataService.newTask(clientID, panel);
		    // Set our dialogTitle
		    $scope.dialogTitle = "New";
		  // console.log($scope.editedItem);
		    taskDataService.taskDialog($scope.editedItem);
		}

		function sortTasks(panel){
		    var panelID = panel.attributes.panelid.nodeValue;
		    // debugger
		    // $log.info('sortTasks');

		    // // Isolate this panel thanks to it's panelid attribute
		    var sortingPanel = panel;
		    // $(sortingPanel).css('background-color', 'yellow');
		    // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
		    var sortedTasks = $(sortingPanel).find('app-item');


		    // // Update each item in firebase by ID
		    _.each(sortedTasks, function(task, index){
		        var newOrder = parseInt(index) + 1,
		            taskID = task.getAttribute('taskid'),
		            clientID = task.getAttribute('client');

		            // // set our DB references
		            var tasksRef = firebase.database().ref('tasks/');
		            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

		            // Update the database
		             var updates = {};
		             // store our canonical object
		             updates['tasks/' + taskID + '/info/todayorder'] = newOrder;
		             // store our reference in the client's store
		             updates['clients/' + clientID + '/tasks/' + taskID + '/todayorder'] = newOrder;
		             // Execute our update
		             return firebase.database().ref().update(updates)
		             .then(function(){
		                // $log.info('sorted');
		             });
		    })
		}// sortTasks







	}
})();

///////////////////////////////////////////
// Setup all directives related to the client object
// timer
// newClient Button
// future: clientSummary

(function (aj) {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timer', [timer])
            .controller('timerController', [timerController])
            .filter('hhmmss', function () {
                return function (time) {
                    var thisTime = time || 0;
                    var sec_num = parseInt(thisTime, 10); // don't forget the second param
                    var hours = Math.floor(sec_num / 3600);
                    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                    var seconds = sec_num - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }

                    var thisTime = hours + ':' + minutes + ':' + seconds;
                    return thisTime;
                }
            })
            ;


    // Our Timer Directive
    /* @ngInject */
    function timer(timeDataService, $interval, timerDataService, userDataService, taskDataService,clientDataService, $log, $mdDialog, _clientData) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/app-directives/timer-directives/timer.tmpl.html',
            controller: timerController,
            controllerAs: 'vm',
            bindToController: false

        };
        return directive;
    };// End Directive



    /* @ngInject */
    function timerController($rootScope, timeDataService, userDataService,
                            clientDataService, $log, $scope, taskDataService,
                            $timeout, localStorageService, timerDataService, $mdDialog, $mdToast, $q) {

       var vm = this;

       vm.timerDataService = timerDataService;  //ensure service bound to controller

       ///////////////////////////////////
        // Setup our timers from service. $timeout required to ensure view gets it after next $digest
        $timeout(function(){
            //obtain current clients from service
            vm.clients = clientDataService.getQuickClients();
            vm.userTimers = timerDataService.timerData.timers;
        },0); // $timeout

        var selectReady = false
        $timeout(function(){
            selectReady = true;
            // to address pre-"onchange" triggers to our client select dropdown
        }, 0)

        //

        vm.toggleTimerGui = function(){
           return timerDataService.toggleTimerGui()
        }
        // vm.clients = clientDataService.getQuickClients();
        // vm.userTimers = timerDataService.timerData.timers;

        vm.newTimer = function(client, taskID){
            // $log.info('newTimer triggered');
            // $log.info(vm.timerDataService.timerData.activeClient.uid);
            // newTimer is triggered whenever we reset our client drop-down
            // so we need to only execute if there's a valid client passed
            if (client.uid)  {
                // $log.info('newTimer executing');
                 // get a fresh timer object for this client/task
                 // * vm.newTimer is called when client md-select auto selects it's client. Thus we need
                 // to check her and avoid getting a new timer unnecessarily
                 //
                 // if there's no activeTimer OR if the client is different from activeTimer's client
                 if (!timerDataService.timerData.activeTimer.client || client.uid != timerDataService.timerData.activeTimer.client.uid){
                     // if we have an activeTimer - deactivate it
                     if (_.has(timerDataService.timerData, 'activeTimer.active')){
                         timerDataService.deactivateActiveTimer(timerDataService.timerData.activeTimer);
                     }
                     vm.selectedClient = client;
                     // Set our new active timer
                    timerDataService.timerData.activeTimer = timerDataService.newTimer(client, taskID);
                }
            } // if client.length
        } // newtimer

        vm.startTimer = function(timer){
            timerDataService.startTimer(timerDataService.timerData.activeTimer);
        }

        vm.pauseTimer = function(timer){
            timerDataService.pauseTimer(timerDataService.timerData.activeTimer);
        }

        vm.resumeTimer = function(timer){
            timerDataService.resumeTimer(timerDataService.timerData.activeTimer);
        }

        vm.stopTimer = function(timer){
            timerDataService.stopTimer(timerDataService.timerData.activeTimer);
            vm.selectedClient = "";
        }

        vm.discardTimer = function(timer){

            var needsReset = false;

            if(timer.active){
                needsReset = true;
            }

            var confirm = $mdDialog.confirm()
                    .title('Discard '+ timer.client.name +'\'s timer?')
                    .textContent('')
                    .ariaLabel('Discard this timer? Y//N')
                    .ok('Discard')
                    .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                $timeout(function(){
                    timerDataService.discardTimer(timer.uid);
                    if(needsReset){
                        timerDataService.resetTimer();
                    }

                }, 0);
            });


        }


        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

        vm.viewTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (thisTask) {
                        taskDataService.taskDialog(thisTask);
                    });
        }

        // determines if timer should display alert tht we are reaching end of task budget
        vm.budgetStatus = function (timer) {
            // only calc if we have a budget
            if(_.has(timer, 'task.budget')){
                if (timer.task.budget > 0){
                    // budget is in minute
                    // logged is in minutes
                    // approxAccrued is in seconds
                    var accrued = Math.round(timer.approxAccrued), // in seconds
                        logged = timer.task.logged * 60, // in seconds,
                        budget = (timer.task.budget) * 60, // convert budget to seconds
                        elapsed = logged + accrued,
                        percentOfBudget = elapsed/budget;

                    if (percentOfBudget < .9){
                        // percent of budget used is less than 90
                        return 'under-budget'

                    } else if (percentOfBudget > .9 && percentOfBudget < 1){
                        // percent of budget used is greater than 90%
                        return 'close-to-budget'

                    } else {
                        // we are OVER, so 'close' isn't what we want to set
                        return 'over-budget'

                    }
                }
            } else {
                // we don't have a budget for this task. no color coding.
                return ''
            }
        }



        vm.shortTaskName = function(text){
            var truncated = _.truncate(text, {
            'omission': '...',
            'length': 25
            });
            return truncated
        }

    }
    ; //end timerController

})();

///////////////////////////////////////////
// Setup all directives related to the client object
// timer
// newClient Button
// future: clientSummary

(function (aj) {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timerList', [timerList])
            .controller('timerListController', [timerListController]);


    /* @ngInject */
    function timerList(timeDataService, timerDataService, userDataService, clientDataService, $log, $mdDialog) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/app-directives/timer-directives/timer-list.tmpl.html',
            controller: timerListController,
            controllerAs: 'vm',
            bindToController: true,
        };
        return directive;
    }
    ;


    /* @ngInject */
    function timerListController($rootScope, timeDataService, userDataService,
                            clientDataService, $log, $scope, taskDataService,
                            $timeout, localStorageService, timerDataService, $mdDialog, $mdToast, $q) {

       var vm = this;
       vm.refreshing= false;
       vm.timerDataService = timerDataService;  //ensure service bound to controller
       vm.inputOptions = { updateOn: 'default blur',
                                debounce: {
                                  default: 300,
                                  blur: 0
                                }
                           };
       ///////////////////////////////////
        // Setup our timers from service. $timeout required to ensure view gets it after next $digest
        vm.refreshTimers = function(){
            vm.refreshing = true;
            vm.userTimers = {};
            $timeout(function(){
                vm.clients = clientDataService.getQuickClients();
                vm.userTimers = timerDataService.timerData.timers;
            }, 2000);
            vm.refreshing = false;
        }

        // wrapping in timeout to ensure view on sidebar load
        $timeout(function(){vm.refreshTimers();},0);

        vm.viewTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (thisTask) {
                        taskDataService.taskDialog(thisTask);
                    });
        }

        vm.firstLine = function (taskDescription) {
            var firstLineText = taskDescription.split('\n')[0];
            return firstLineText
        }

        vm.pauseTimer = function(timer){
            timerDataService.pauseTimer(timer);
        }

        vm.resumeTimer = function(timer){
            timerDataService.resumeTimer(timerDataService.timerData.activeTimer);
        }

        vm.resumeSavedTimer = function(timer){
            //resume time and set vars on promise callback/then only if needed.
            timerDataService.resumeSavedTimer(timer);
        }

        vm.stopTimer = function(timer){
            timerDataService.stopTimer(timer);
        }

        vm.discardTimer = function(timer){

            // will we need to reset the active timer as well?
            var needsReset = false;

            if(timer.active){
                needsReset = true;
            }

            var confirm = $mdDialog.confirm()
                    .title('Discard '+ timer.client.name +'\'s timer?')
                    .textContent('')
                    .ariaLabel('Discard this timer? Y//N')
                    .ok('Discard')
                    .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                $timeout(function(){
                    timerDataService.discardTimer(timer.uid);
                    if(needsReset){
                        timerDataService.resetTimer();
                    }
                }, 0);
            });

        }

        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

        vm.viewTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (thisTask) {
                        taskDataService.taskDialog(thisTask);
                    });
        }

        vm.updateDescription = function(timer){
            // $log.info('updateDescription');
            $timeout(function(){
                timer.saving = true;
            },0);
            // just update the node we want without the service
              var updates = {};
              // // store data in the Users -> timers
              updates['/users/' + timer.userID + '/timers/' + timer.uid + '/description'] = timer.description;
              // Commit our updates
             return firebase.database().ref().update(updates)
             .then(function(){
                $timeout(function(){
                    timer.saving = false;
                    timer.saved = true;
                    // $('.timer-description').blur();
                },0);

                $timeout(function(){
                    timer.saved = false;
                },1500);



             })
        }
    }
    ; //end timerListController

})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timeEntry', timeEntry);


    function timeEntry() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: timeEntryController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            link: linkFunc,
            // Populate the template via ng-include
            templateUrl: 'app/app-directives/time-entry/time-entry.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {



    }// linkFunc


    /* @ngInject */
    function timeEntryController($log, hotkeys, $timeout, $mdToast, userDataService, timeDataService, $rootScope, taskDataService, $scope, $firebaseArray, localStorageService, $mdDialog, clientDataService) {
        // $log.info('timeEntryController');
        var vm = this;
        vm.requireWorkDescription = false;
        vm.requireWorkDescription = userDataService.getUser().profile.settings.requireWorkDescription;
        vm.entry = $scope.entry;
        vm.editMode = false;

        $scope.openTime = function(entry){
            timeDataService.timeDialog(entry, 'Modify');
        }

        $scope.editTime = function (entry) {

            // check to make sure no other edits are open
            // alert if that's the case and ignore edit request
            if ($('.time-edit-inline').length) {
                // $log.info('Already editing');
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Already editing a time entry. Please complete your operation first.')
                        .position('top right')
                        .hideDelay(2000)
                        );
                return
            }

            vm.editEntry = angular.copy(entry);
            vm.editEntry.logDate = new Date(vm.editEntry.logDate);

            // store the original log total so we can compare and update totals correctly
            vm.editEntry.oldLogged = angular.copy(vm.editEntry.logged);
            // take total logged minutes and split into hours and minutes for our form

            vm.editEntry.hours = Math.floor(vm.editEntry.logged / 60);
            vm.editEntry.minutes = vm.editEntry.logged % 60;

            vm.editMode = true;
            vm.editStatus = 'editing';

            // Set focus
            $timeout(function () {
                angular.element("input[name='hours']").focus();
            }, 300);


        }
        $scope.cancelEdit = function (entry) {
            vm.editMode = false;
        }
        $scope.startDelete = function (entry) {
            vm.editStatus = 'startdelete';
        }
        $scope.cancelDelete = function (entry) {
            vm.editStatus = 'editing';
        }
        $scope.openTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (task) {
                        var taskInfo = angular.copy(task.info),
                                // fake a "task" shell so our dual purpose dialog
                                // works without worse hacks
                                editedItem = {uid: taskID};
                        editedItem.info = taskInfo;

                        // convert our due date into a date object for md-date-picker
                        if (editedItem.info.duedate) {
                            editedItem.info.duedate = new Date(editedItem.info.duedate);
                        }

                        // send it to our dialog
                        taskDataService.taskDialog(editedItem, 0);
                    })

        }
        $scope.deleteEntry = function (entry) {

            vm.editStatus = 'deleting';
            $timeout(function(){
                return timeDataService.deleteEntry(entry)
                        .then(function (response) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Time Log Deleted')
                                    .position('top right')
                                    .hideDelay(2000)
                                    );
                            vm.editStatus = 'deleted';
                            vm.editMode = false;
                            $scope.$emit('updateReport');
                        });
            },0);
        }

        $scope.updateTime = function (entry) {
            vm.editStatus = 'saving';
            return timeDataService.updateEntry(entry)
                    .then(function () {

                        /* Get client data by client ID */

                        clientDataService.getClient(entry.client)
                                .then(function (clientData) {

                                    if (clientData.profile.plan.type == 'retainer') {
//
                                        /* update client's Retainer_totals */
                                        timeDataService.reCreateTotals(clientData);

                                        /* Update Retainer view */
                                        vm.RetainerMonths = clientDataService.thisRetainerYear(clientData);
                                        $scope.$emit('ratingUpdated', vm.RetainerMonths);

                                        vm.RetainerWeeks = clientDataService.thisRetainerMonth(clientData, entry.retainer_month);
                                        $scope.$emit('retainerWeeks', vm.RetainerWeeks);

                                    }
                                });

                        vm.editStatus = 'saved';
                        vm.editMode = false;
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Time Log Updatedd.')
                                .position('top right')
                                .hideDelay(2000)
                                );
                    });

        }// updateTime
    } // timeEntryController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('teamMemberCard', teamMemberCard);


     function teamMemberCard() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: teamMemberCardController,
         scope: {
           member: '=',
           displaytype: '@',
           team: '@',
           clientid: '@',
           editallowed: '@'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
            if(scope.vm.displaytype == 'card'){
                return 'app/app-directives/team-member/team-member-card.tmpl.html';
            } else if(scope.vm.displaytype == 'client-list'){
                return 'app/app-directives/team-member/team-member-client-list-item.tmpl.html';
            } else {
                // default to card view
                return 'app/app-directives/team-member/team-member-card.tmpl.html';
            }

       };

     }// linkFunc

    /* @ngInject */
    function teamMemberCardController($rootScope, $timeout, $scope, $log, clientDataService, userDataService, teamDataService) {
        var vm = this;


        vm.teamDataService = teamDataService;
        vm.userID = $rootScope.userID;
        // get the user info for the card (if there is any)
            // get the full userRecord for this team member. We need both
            var userRef = firebase.database().ref('users').child(vm.member.uid);
            userRef.once('value', function(snapshot){
                vm.user = snapshot.val();
            });


            vm.clientAccess = 'none';
            // if we are displaying with access radio buttons...we also need to have
            // our access values exposed
            if(vm.displaytype == 'client-list'){

                if(_.has(vm.member, 'clients')){

                    vm.clientAccess = vm.member.clients[vm.clientid];
                    // if that failed, set it to 'none'
                    if(!vm.clientAccess){
                        vm.clientAccess = 'none'
                    }

                }
                if(vm.member.role == 'owner'){
                    vm.clientAccess = 'admin'
                }
            }

            // Determine if this member's access can be edited by this user
            if (vm.editallowed == 'true'){
               vm.disableEdit = false;
           } else if (vm.editallowed == 'false'){
               vm.disableEdit = true;
           }
           if(vm.member.status != 'active'){
               vm.disableEdit = true;
           }
           if(vm.member.role == 'owner'){
               vm.disableEdit = true;
           }


            // this is a pending member and there's no user for them
            // just prep the basics for display
            // vm.invited = moment(vm.member.invited).format('MMM DD, YYYY');
            vm.expires = moment(vm.member.expires).format('MMM DD, YYYY');




        vm.selectTeamMember = function(member){
            vm.teamDataService.selectUser(vm.user);
            vm.teamDataService.selectTeamMember(member);
        }

        vm.isMemberSelected = function(){
            if(vm.teamDataService.selectedMember){
                if(vm.teamDataService.selectedMember.uid == vm.member.uid){
                    return true
                }
            }
        }

        vm.setMemberAccess = function(member, access){
            return teamDataService.setMemberAccess(member, vm.clientid, vm.team, access)
            .then(function(){
                $timeout(function(){
                    clientDataService.setupClientMenu(true);
                },0);
            })
        }



    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('teamMemberDetail', teamMemberDetail);


     function teamMemberDetail() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: teamMemberDetailController,
         scope: {
           member: '=member',
           user: '=user'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/team-member-detail/team-member-detail.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function teamMemberDetailController($rootScope, $state, hotkeys, $scope, $log, $mdDialog, $timeout, userDataService, teamDataService, clientDataService) {
        var vm = this;

        // vm.member is implicit in the directive
        vm.userID = $rootScope.userID;
        // var tempClients = clientDataService.getQuickClients();

        // filter out clients NOT Owned by this user and expose to view
        vm.membersClients = $rootScope.quickClients;
        // _.each(clientDataService.getQuickClients(), function(client){
        //   if(client.owner == vm.userID){
        //     vm.membersClients.push(client);
        //   }
        // });


        vm.memberColors = $rootScope.clientColors;
        vm.colorPicker = false;

        vm.togglePicker = function(){
            if (vm.colorPicker){
                vm.colorPicker = false;
            } else{
                vm.colorPicker = true;
            }
        }
        // monitor color changes and change pristine to false
        vm.colorChange = function (form) {
            form.$setDirty();
            $timeout(function(){
                vm.togglePicker();
            }, 250);

        };
        // vm.becameMember = moment(vm.member.becameMember).format('MMM d, YYYY');
        // vm.invited = moment(vm.member.invited).format('MMM d, YYYY');

        vm.cancelMemberSelect = function(){
          delete teamDataService.selectedMember
        }


        vm.cancelNote = function(){
          delete vm.member.notes;
          vm.memberForm.$pristine = true;
        };

        vm.isSelected = function(){
            // if(vm.clientBillingService.selectedPeriod){
            //     if(vm.clientBillingService.selectedPeriod.uid == vm.period.uid){
            //         return true
            //     }
            // }
        };

        vm.changeMemberStatus = function(member){
          //using our fallback because for some reason we aren't getting a user with getLoggedInUser here. Pffft.
          teamDataService.changeMemberStatus(member, $rootScope.userID);

        };

        vm.removeMember = function(member,event){
          // confirm they want to delete
          var confirm = $mdDialog.confirm()
                    .title('Are you sure you want to remove ' + member.email + '?')
                    .textContent('This member will be completely removed from your team.')
                    .ariaLabel('Remove Member')
                    .targetEvent(event)
                    .ok('Remove')
                    .cancel('cancel');

              $mdDialog.show(confirm).then(function() {
                teamDataService.removeMember(member, $rootScope.userID);
                // deselect our member detail
                $timeout(function(){teamDataService.deselectMember();}, 500);
              }, function() {
              });

        }

        vm.openClient = function(clientUID){
            // $log.info('vm.openClient: ' + client);
            $state.go("triangular.client-manager-page.information(clientID: clientUID)")
            // return clientDataService.getClient(clientID)
            // .then(function(thisClient){
            //     // $log.info(thisClient);
            //     return clientDataService.clientDialog(thisClient);
            // })
        }

        vm.saveMemberNote = function(member){
          teamDataService.saveMemberNote(member, $rootScope.userID);
          vm.memberForm.$pristine = true;
          vm.memberForm.$dirty = false;
        }

        vm.updateMember = function(member){
          teamDataService.updateMember(member);
          vm.memberForm.$pristine = true;
          vm.memberForm.$dirty = false;
        }

        vm.editMemberNote = function(){
          vm.memberForm.$pristine = false;
          vm.memberForm.$dirty = true;
        }

        vm.revokeInvite = function(member){
            teamDataService.revokeInvite(member);
            teamDataService.deselectMember();
        };

        vm.resendInvite = function(member){
            var memberCopy = _.clone(member);
            teamDataService.revokeInvite(memberCopy);
            teamDataService.inviteMember(memberCopy.email);
            teamDataService.selectedMember = null;
        };

    }// controller



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskTime', taskTime);


  function taskTime() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskTimeController,
      scope: {
        task: '@task',
        client: '@client',
        local: '@local'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-time/task-time.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskTimeController($log, hotkeys, timeDataService, $rootScope, taskDataService, $scope, $firebaseArray,  localStorageService, $mdDialog) {
    // $log.info('taskTimeController');

    var vm = this,
        taskID = vm.task,
        clientID = vm.client;
        vm.newNote = undefined;
        vm.notes = [];
        vm.totalLogged = 0;



        // // Setup our hotkeys
        // hotkeys.bindTo($scope)
        //     // inhibit enter from submitting
        //     .add({
        //       combo: 'enter',
        //       callback: function(event) {
        //         event.preventDefault();
        //         // $log.info('enter blocked');
        //       }
        //     })
        //     .add({
        //       combo: 'ctrl+enter',
        //       allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        //       description: 'Save/Update Note',
        //       callback: function(event) {
        //         // $log.info('ctrl+enter');
        //         event.preventDefault();
        //         // $log.info($scope.clientDialogForm);
        //         var pristine = $scope.vm.taskNoteForm.$pristine,
        //             invalid = $scope.vm.taskNoteForm.$invalid;

        //             if (!pristine && !invalid){
        //                 $scope.addTaskNote($scope.vm.newNote);
        //             }
        //         }
        //     });



          var timeRef = firebase.database().ref().child('/tasks/' + taskID + '/time');
          $firebaseArray(timeRef)
          .$loaded(function(data){
            // $log.info(data);
            // only overwrite notes if there's something there.
            if (data){
              vm.timeLogs = data;

                // calculate our totalLogged
                _.each(vm.timeLogs, function(entry){
                  vm.totalLogged += entry.logged;
                });
              }

            });


            $scope.cancelDialog = function(){
                $mdDialog.hide();
            }



    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('appItem', appItem);


    function appItem() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: appItemController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            link: linkFunc,
            // Populate the template via ng-include
            template: '<div ng-include="getTemplateUrl()"></div>'
        };
        return directive;
    }
    ;

    // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        scope.getTemplateUrl = function () {
            return 'app/app-directives/task-item/app-item-task.tmpl.html';
        };
    }


    ///////////////////////////////////////////////////////////
    /// appItemController

    /* @ngInject */
    function appItemController($q, gateService, teamDataService, clientDataService, $log,  $mdToast, userDataService, $rootScope, $scope, taskDataService, $timeout, timeDataService, $filter, timerDataService, localStorageService, $window) {
        var vm = this;
        vm.userDataService = userDataService;
        // setup minDate for any calendar controls
        var d = new Date();
         vm.minDate = d;

         vm.canUseTimer = true;

         // Isolate the team for this client
         vm.teamList = {};

        vm.isTimerRunning = function (task) {
            // Doing double-checking here to avoid all possible conflicts in how we are using task cards
            if(_.has(timerDataService, 'timerData.activeTimer.on') && _.has(timerDataService, 'timerData.activeTimer.task')){
                if (timerDataService.timerData.activeTimer.on && timerDataService.timerData.activeTimer.task.uid == task.refID){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }

        vm.hasOpenTimers = function(task){
            if(_.find(timerDataService.timerData.timers, function(o) {
                // make certain this timer has a task before we check and throw an error
                if(_.has(o, 'task')){
                    return o.task.uid == task.refID;
                }
            })){
                return true
            }
        }

        vm.assigneeName = function(assignee){
            // $log.info('looking up:' + assignee);
            _.each(vm.teamList, function(member){
                if(member.uid == assignee){
                    return member.profile.fullName
                }
            })
        }

        vm.assigneeAvatar = function(assignee){
            // $log.info('looking up:' + assignee);
            _.each(vm.teamList, function(member){
                if(member.uid == assignee){
                    return member.profile.avatar
                }
            })
        }

        vm.assigneeAvatar = function(assignee){
            // $log.info('looking up:' + assignee);
            _.each(teamDataService.teamList, function(member){
                if(member.uid == assignee){
                    return member.profile.fullName
                }
            })
        }
        // the following value is used to show time logged in individual task cards
        // while the timer is running.
        // if it's not running, we are just showing total logged time.

        $scope.getColor = function (clientID) {
            return clientDataService.clientColor(clientID)
        }

        $scope.clientName = function (clientID) {
            return clientDataService.clientName(clientID)
        }

        $scope.startTimer = function (task) {
            // $log.info('startTimer Clicked on Task');
            timerDataService.newTaskTimer(task);

        }

        $scope.logTime = function (task) {
           var newTimeEntry = timeDataService.newLogEntry(task.client, task.refID);
           timeDataService.timeDialog(newTimeEntry, 'Log');
        }

        $scope.pauseTimer = function (task) {
            // $log.info('$scope.pauseTimer', task);
            timerDataService.pauseTaskTimer(task);
        }

        $scope.resumeTimer = function (task) {
            // $log.info('$scope.resumeTimer', task);
            timerDataService.resumeSavedTaskTimer(task);
        }

        // // startTimer
        $scope.toggleToday = function (item) {
            // $log.info('toggleToday - directive');
            taskDataService.toggleToday(item);

        };

        $scope.isImage = function(file){
          var validExtensions = [
              'jpg',
              'gif',
              'png',
              'bmp'
              ],
            extension = file.fileName.split('.').pop();

          // if this file's extension is valid, return true
          if (_.includes(validExtensions,extension)){
            return true
          } else {
            return false
          }
        }// isImage

        // general moveTask
        $scope.moveTask = function (item, panel) {
            // $log.info('toggleToday - directive');
            taskDataService.moveTask(item, panel);

        };

        // change completed status
        $scope.toggleCompleted = function (item) {
            // if we have open timers, alert to close them first
            if (!vm.hasOpenTimers(item)){
                if (item.status != 'closed') {
                    item.showComplete = true;
                } else {
                    item.showComplete = false;
                }
                // console.log('apptItemDirective: toggleCompleted for: ' + item);
                $timeout(function () {
                    taskDataService.toggleComplete(item);
                }, 250); // 1/2 second delay so user received visual indicator of closed task before it disappears

            } else {
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: 'Task has open timers!',
                            message: 'You have open timers for this task. Complete or discard them before completing the task.' ,
                            color: 'orange'
                        }
                    }));// mdToast
            }

        };

        // Edit a task
        $scope.editTask = function (item, targetTab, $event) {
            // $log.info('editTask');
            // item.highlight=true;
            // Show task was clicked
            item.clicked = true;
            // Remove visual after timer delay
            $timeout(function(){
                item.clicked = false;
            },1000);

            return taskDataService.getTask(item.refID)
            .then(function(editedItem){

                // convert our due date into a date object for md-date-picker
                if (editedItem.info.duedate) {
                    editedItem.info.duedate = new Date(editedItem.info.duedate);
                }
                // send it to our dialog
                taskDataService.taskDialog(editedItem, targetTab);
            })
            // var taskInfo = angular.copy(item),
            //         // fake a "task" shell so our dual purpose dialog
            //         // works without worse hacks
            //         editedItem = {uid: item.refID};
            // editedItem.info = taskInfo;
        }; // End editTask

        // Copy a task
        $scope.copyTask = function (item, $event) {
            // setup our editedItem
            var editedItem = {};

            // Get full task from server (not the .info version in item)
            return taskDataService.getTask(item.refID)
            .then(function(originalTask){
                // make a copy
                var taskCopy = angular.fromJson(angular.toJson(originalTask));

                // Take out the firebase-assigned properties
                ajUTILITIES.removePropertiesWith(taskCopy);

                // set flag so we know we are dealing with a clone
                taskCopy.clone = true;

                // Remove this task's unique history
                delete taskCopy.uid;
                delete taskCopy.info.refID;
                delete taskCopy.activity;
                taskCopy.info.order = 1000;
                delete taskCopy.info.allOrder;
                delete taskCopy.info.todayOrder;
                taskCopy.info.numnotes = 0;
                delete taskCopy.notes;
                delete taskCopy.time;
                taskCopy.info.logged = 0;

                // if no budget, make sure it's set to zero
                if(!_.has(taskCopy, 'info.budget')){
                    taskCopy.info.budget = 0;
                }

                // If there's a duedate, convert it into a date object
                if(_.has(taskCopy.info, 'duedate')){
                    // $log.info(taskCopy.info.duedate);
                    taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                }

                // send it to dialog for modification and saving
                taskDataService.taskDialog(taskCopy);
            });


        }; // End copyTask

        // Turn a task into a template
        $scope.makeTemplate = function (item, $event) {
            // setup our editedItem
            var editedItem = {};

            // Get full task from server (not the .info version in item)
            return taskDataService.getTask(item.refID)
            .then(function(originalTask){
                // make a copy
                var taskCopy = angular.fromJson(angular.toJson(originalTask));

                // Take out the firebase-assigned properties
                ajUTILITIES.removePropertiesWith(taskCopy);

                // set flag so we know we are dealing with a clone
                taskCopy.clone = true;

                // Remove this task's unique history
                delete taskCopy.uid;
                delete taskCopy.info.refID;
                delete taskCopy.activity;
                taskCopy.info.order = 1000;
                delete taskCopy.info.allOrder;
                delete taskCopy.info.todayOrder;
                taskCopy.info.numnotes = 0;
                delete taskCopy.notes;
                delete taskCopy.time;

                // if no budget, make sure it's set to zero
                if(!_.has(taskCopy, 'info.budget')){
                    taskCopy.info.budget = 0;
                }

                // If there's a duedate, convert it into a date object
                if(_.has(taskCopy.info, 'duedate')){
                    // $log.info(taskCopy.info.duedate);
                    taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                }

                // send to taskData who will get a new template, merge, and create the template.
                return taskDataService.makeTemplate(taskCopy)
                .then(function(){
                    // alert('template created');

                })

                // // send it to dialog for modification and saving
                // taskDataService.taskDialog(taskCopy);
            });


        }; // End copyTask

        // change completed status
        $scope.deleteTask = function (item) {
            var taskname = item.description;
            // console.log('toggleCompleted for: ' + item.taskname);
            taskDataService.removeTask(item);
        };

        $scope.canFocus = function (task) {
            return true
            // if (!task.duedate) {
            //     // if there's not a duedate on a task, then the focus control should always appear
            //     return true
            // } else {

            //     var today = moment(),
            //             dueDate = moment(task.duedate),
            //             difference = dueDate.diff(today, 'hours');
            //     if (difference >= 23) {
            //         return true
            //     }
            // }

        }// canFocus



        $scope.isClose = function (logged, budget) {
            var progress = logged/budget;
            if (budget > 0 && progress > .75 && progress <= 1) {
                return true
            }
        }


        $scope.isOver = function (logged, budget) {
            var progress = logged/budget;
            if (budget > 0 && progress > 1) {
                return true
            }
        }

        $scope.isNear = function (due, status) {
            var today = moment(),
                    dueDate = moment(due),
                    difference = dueDate.diff(today, 'hours');
            if (difference < 48 && difference > 0 && status == 'open') {
                return true
            }
        }

        $scope.difference = function(due, status){
            var today = moment(),
            dueDate = moment(due),
            difference = dueDate.diff(today, 'hours');
            return difference
        }

        $scope.isDue = function (due, status) {
            var today = moment(),
                    dueDate = moment(due),
                    difference = dueDate.diff(today, 'hours');
            if (difference < 1 && status == 'open') {
                return true
            }
        }

        // The following functions handle splitting our task description into
        // first line, and the rest
        // so we can bold the first line on display (up to first linebreak)
        // but still keep it stored as a plain string with no formatting.

        $scope.firstLine = function (taskDescription) {
            if(taskDescription){
                var firstLineText = taskDescription.split('\n')[0];
            } else {
                var firstLineText = null;
            }
            return firstLineText

        }

        $scope.restLines = function (taskDescription) {

            if(taskDescription){
                // break the textblock into an array of lines
                var restLinesText = taskDescription.split('\n');
                // remove one line, starting at the first position
                restLinesText.splice(0, 1);
                // join the array back into a single string
                var newText = restLinesText.join('\n');
                return newText
            } else {
                return null
            }

        }




    }
    ; //end appItemController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskTemplateCard', taskTemplateCard);


  function taskTemplateCard() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskTemplateCardController,
      scope: {
        template: '=template'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-template-card/task-template-card.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskTemplateCardController($log, $rootScope, rrule, taskTemplateDataService, taskDataService, clientDataService, $scope, $firebaseArray, $mdDialog) {
    // $log.info('taskTemplateCardController');
    // $log.info(this);
    var vm = this,
        // vm.template is already here for us
        taskID = vm.task,
        clientID = vm.client;

        // Only figure out our rules if we have them.
        if (vm.template.isRecurring && _.has(vm.template, 'schedule.repeatRule')){
          vm.rule = RRule.fromString(vm.template.schedule.repeatRule);
          vm.ruleInEnglish = vm.rule.toText();

          // Make sure we are displaying next date correctly
          // vm.displayNextCreateDate = vm.template.schedule.nextCreateDate;
          // var nextCreateDate = moment().unix(vm.template.schedule.nextCreateDate);
          vm.displayNextDueDate = moment(vm.template.schedule.nextDueDate).format('dddd, MMM DD, YYYY');
        } else {
          vm.rule = "";
          vm.ruleInEnglish = "No recurring pattern defined.";
        }

        // $log.info(vm);

        vm.editTemplate = function(template){
          // $log.info('editing');
          // $log.info(template);
          return taskTemplateDataService.getTaskTemplate(template.uid)
          .then(function(thisTemplate){
            taskTemplateDataService.taskTemplateDialog(thisTemplate);
          });
        }

        $scope.deleteTemplate = function(template){
          // var taskname = item.taskname;
          // console.log('toggleCompleted for: ' + item.taskname);
          return taskTemplateDataService.deleteTaskTemplate(template);

        }// $scope.delete
        $scope.clone = function(template){
          var clone = angular.copy(template);

          // remove any template-only values
          delete clone.type;
          delete clone.schedule;
          delete clone.isRecurring;
          delete clone.uid;
          delete clone.info.refID;
          delete clone.$id;
          delete clone.$priority;
          delete clone.$key;
          clone.focus = 'someday';
          clone.info.panel = 'Later';
          clone.info.order = 1;
          clone.created = moment().unix();

          taskDataService.taskDialog(clone);
        }

      $scope.getColor = function (clientID) {
          return clientDataService.clientColor(clientID)
      }

      $scope.clientName = function (clientID) {
          return clientDataService.clientName(clientID)
      }
      $scope.firstLine = function (taskDescription) {
          var firstLineText = taskDescription.split('\n')[0];
          return firstLineText
      }

      $scope.restLines = function (taskDescription) {
          // break the textblock into an array of lines
          var restLinesText = taskDescription.split('\n');
          // remove one line, starting at the first position
          restLinesText.splice(0, 1);
          // join the array back into a single string
          var newText = restLinesText.join('\n');
          return newText
      }
          // var timeRef = firebase.database().ref().child('/tasks/' + taskID + '/time');
          // $firebaseArray(timeRef)
          // .$loaded(function(data){
          //   // only overwrite notes if there's something there.
          //   if (data){
          //     vm.timeLogs = data;

          //       // calculate our totalLogged
          //       _.each(vm.timeLogs, function(entry){
          //         vm.totalLogged += entry.logged;
          //       });
          //     }

          //   });



    }// taskTemplateCardController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskNotes', taskNotes);

    /* @ngInject */
  function taskNotes($rootScope) {

    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskNotesController,
      scope: {
        task: '@task',
        client: '@client'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-notes/task-notes.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskNotesController($log, hotkeys, $timeout, $rootScope, teamDataService, taskDataService, noteDataService, userDataService, $scope, $firebaseArray,  localStorageService, $mdDialog) {
    // $log.info('taskNotesController');

    var vm = this,
        taskID = vm.task,
        clientID = vm.client;
        vm.newNote = undefined;
        vm.notes = [];
        // We are now giving this to free accounts as well. Too minor to be a premium feature.
        vm.canEmailClient = true;
        init();

        function init(){
          getTeamList();
        }

        function getTeamList(){

            $timeout(function(){
                // repopulate $rootScope.currentTeamList
                vm.teamList = teamDataService.clientTeams[clientID];
                // assign $rootScope.currentTeamList
                vm.teamListLoading = false;
            },0);
        }

        // // Setup our hotkeys
        // hotkeys.bindTo($scope)
        //     // inhibit enter from submitting
        //     .add({
        //       combo: 'enter',
        //       callback: function(event) {
        //         event.preventDefault();
        //         // $log.info('enter blocked');
        //       }
        //     })
        //     .add({
        //       combo: 'ctrl+enter',
        //       allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        //       description: 'Save/Update Note',
        //       callback: function(event) {
        //         $log.info(event);
        //         // $log.info('ctrl+enter');
        //         event.preventDefault();
        //         // $log.info($scope.taskNoteForm);
        //         var pristine = $scope.vm.taskNoteForm.$pristine,
        //             invalid = $scope.vm.taskNoteForm.$invalid;

        //             if (!$pristine && !invalid){
        //                 $scope.addTaskNote($scope.vm.newNote);
        //             }
        //         }
        //     });

          var notesRef = firebase.database().ref().child('/tasks/' + taskID + '/notes');
          $firebaseArray(notesRef)
          .$loaded(function(data){
            // only overwrite notes if there's something there.
            if (data){
              vm.notes = data;
              vm.numnotes = vm.notes.length;
            }
          })


          $scope.clearNote = function(){
            vm.newNote = undefined;
          }
            $scope.cancelDialog = function(){
                $mdDialog.hide();
            }

           $scope.addTaskNote = function(newNote) {
               vm.numnotes = vm.numnotes + 1;
               noteDataService.saveNote(newNote, taskID, clientID, vm.numnotes, vm.teamList)
               .then(function(response){
                newNote.body = "";
                newNote.notifyClient = false;
                  // heap.track('New Task Note Saved');
                   taskDataService.setupNotes();
               });

           }; // addTaskNote



    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('subscriptionManager', subscriptionManager);


     function subscriptionManager() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: subscriptionManagerController,
         scope: {
           user: '=user'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/subscription-manager/subscription-manager.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function subscriptionManagerController($rootScope, $window, triLoaderService, $state, $scope, $log, $http, $mdDialog, $timeout, $firebaseArray, $firebaseObject, userDataService, subscriptionService) {
        var vm = this;
        // we have vm.user inherently

        vm.functionsURL = $rootScope.functionsURL;
        vm.functionsKey = $rootScope.functionsKey;
        // prepare for loading our plans
        vm.plans = [];
        var plansRef = firebase.database().ref().child('/plans');


        function init(user){
          // Load up our list of plans
          $timeout(function(){
            $firebaseArray(plansRef)
            .$loaded(
                function(plans) {
                    vm.plans = plans;
                    _.each(vm.plans, function(plan){
                      if (plan.planID == vm.user.plan.content__subscription__plan_id){
                        vm.currentPlan = plan;
                        vm.currentStatus = vm.user.plan.content__subscription__status;
                        vm.cardStatus = vm.user.plan.content__customer__card_status;
                        vm.trialEnd = vm.user.plan.content__subscription__trial_end;
                        if(_.has(vm.user.plan, 'content__subscription__activated_at')){
                          vm.activeStart = vm.user.plan.content__subscription__activated_at;
                        }

                        if(vm.currentStatus == 'in_trial'){
                          var today = moment();
                          vm.remainingTrial = moment(vm.trialEnd).diff(today, 'days');
                        }

                      }// if planID matches
                    })//each
                });

          },200);

        }// init

        init(vm.user);

        vm.confirmChange = function(planID){
          var confirm = $mdDialog.confirm()
                   .title('Are you sure you want to change your subscription?')
                   .htmlContent('Your Workspace, Team and Task limits will be adjusted to the new plan. <br>If you are already over any of the new limits, you may lose access to some data.')
                   .ariaLabel('Change subscription?')
                   .ok('Continue')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
               vm.changePlan(planID);
             }, function() {
              // plan change cancelled
             });
        }//vm.changePlan

        vm.reactivatePlan = function(planID){
          var confirm = $mdDialog.confirm()
                   .title('You are about to reactivate your subscription')
                   .textContent('You will be asked to re-enter your payment information.')
                   .ariaLabel('Confirm Reactivation')
                   .ok('I\'m ready to reactivate')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
              var reactivateURL = vm.functionsURL + "/checkout?key=" + vm.functionsKey + "&user=" + vm.user.uid + "&plan=" + planID + "&method=checkout&reactivate=true";
               $window.location.href= reactivateURL;
             }, function() {
              // plan change cancelled
             });
        }//vm.changePlan

        vm.changePlan = function(planID){
          var chargebeeAPIUrl = $rootScope.functionsURL + '/checkout?key='+ $rootScope.functionsKey + '&user=' + vm.user.uid + '&plan=' + planID + '&method=update';
          $http.get(chargebeeAPIUrl)
              .then(function(res) {
                vm.loading = false;
                var response = res.data;
                if (response == 'success'){
                  triLoaderService.setLoaderActive(false);
                  $mdDialog.show(
                       $mdDialog.alert()
                         .parent(angular.element(document.querySelector('#popupContainer')))
                         .clickOutsideToClose(true)
                         .title('Subscription change succeeded')
                         .textContent('Please click "continue" to reload your data.')
                         .ariaLabel('Subscription change succeeded')
                         .ok('Continue')
                     ).then(function(){
                      triLoaderService.setLoaderActive(true);
                      $state.go('triangular.dashboard');
                     });

                } else {
                  $mdDialog.show(
                       $mdDialog.alert()
                         .parent(angular.element(document.querySelector('#popupContainer')))
                         .clickOutsideToClose(true)
                         .title('There was a problem updating your subscription')
                         .textContent('Please refresh and try again. If you continue to have trouble, please let us know at help@getadminja.com.')
                         .ariaLabel('Subscription change failed')
                         .ok('Got it!')
                     );
                }
              });
        }


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('sidebarControls', sidebarControls);


    function sidebarControls() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: sidebarControlsController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            // link: linkFunc,
            // Populate the template via ng-include
            templateUrl: 'app/app-directives/sidebar-controls/sidebar-controls.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
// function linkFunc(scope, element, attr) {


//   }


    /* @ngInject */
    function sidebarControlsController($document, gateService, $rootScope, $log, $state, $timeout, angularLoad, timerDataService, localStorageService, userDataService, $scope, $stateParams, timeDataService, $window) {
        var vm = this;


        // vm.assignedClients = $rootScope.quickClients;
        vm.user = userDataService.getUser();

        // In a timeout to make sure the view gets the info
        // otherwise all sorts of things are unavailable
        // $timeout(function(){
        //     vm.gates = gateService.gateData;
        //     $scope.canLogTime = vm.gates.canLogTime;
        //     $scope.canUseTimer = vm.gates.canUseTimer;
        // },200);

        // $scope.showTimerInSidebar = false;
        // if(_.has(vm.user, 'profile.settings.showTimerInSidebar')){
        //       $scope.showTimerInSidebar = vm.user.profile.settings.showTimerInSidebar;
        //     }


        // $rootScope.$watch('clientID', function () {
        //     $scope.clientID = $rootScope.clientID;
        // }, true);

//        setTimeout(function () {
//            $scope.$apply(function () {
//                vm.clients = $rootScope.clientID;
//            });
//        }, 2000);


        // vm.user.avatar = localStorageService.get('userAvatar');
        // vm.user.name = localStorageService.get('userName');

        vm.numTimers = function () {
            var length = _.size(vm.user.timers);
            return length
        };

        vm.inboxCount = function () {
            var b = _.filter(vm.user.notifications, function(o) { if (!o.read) return o }).length;
            return b
        };


        vm.markAllRead = function(){
          // $log.info('markAllRead');
          var updates = {};
          _.each(vm.user.notifications, function(notification){
            updates['/users/'+ $rootScope.userID + '/notifications/' + notification.uid + '/read'] = true;
          });
          // $log.info('Marking notifications read:');
          // $log.info(updates);
          $timeout(function(){
            return firebase.database().ref().update(updates)
            }, 300);

        }// markAllRead

        vm.showTrialMessage = function(){
            if ($rootScope.trial && $rootScope.trial.type == 'starter'){
                // If it's a starter account, send them to upgrading instructions
                $state.go('authentication.profile');
            } else if ($rootScope.trial.status == 'expired' && $rootScope.trial.type == 'paid'){
                // if our trial is over and the PAID account has been cancelled due to no card (or other reason)
                // send them to the upgrade page to reactivate their account
                $state.go('authentication.profile');
            } else {
                // do nothing
            }
        }
        vm.logout = function () {
            $log.info('logout');
            userDataService.logout();
        }


        vm.getHelp = function () {
            // $log.info('Open Groove Widget');
            // groove.widget('open');
        }

        vm.userProfile = function () {
            $state.go('authentication.profile');
        }

        vm.userDialog = function () {
            userDataService.userDialog('Complete your registration');
        }

        vm.newTime = function () {
            // $log.info('newTime');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID) {
                // $log.info('new time for client' + $stateParams.clientID);
                clientID = $stateParams.clientID;
            }

            vm.timeEntry = timeDataService.newLogEntry(clientID);
            // $log.info(vm.timeEntry);
            timeDataService.timeDialog(vm.timeEntry, "New");

        }

        vm.toggleFullScreen = function() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }

        // vm.user = userDataService.getLoggedInUser();
        // vm.assignedClients = vm.user.clients;
        // $log.info(vm.assignedClients);

        /////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////
      // We need Headway, a 3rd party library loaded .
        // $timeout(function(){
        //     angularLoad.loadScript('//cdn.headwayapp.co/widget.js').then(function() {
        //         // $log.info('headway loaded. initializing...');
        //       var config = {
        //           selector: ".changelog",
        //           account: "JVv4AJ"
        //         };
        //         Headway.init(config);
        //     });
        // }, 0);

    }


})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('registrationWizard', registrationWizard);

    /* @ngInject */
    function registrationWizard() {
        // Usage: <div tri-wizard> (put some forms in here) </div>
        //
        // Creates: Nothing
        //
        var directive = {
            bindToController: true,
            controller: registrationWizardController,
            controllerAs: 'registrationWizard',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function registrationWizardController($scope, $timeout, $log, $mdToast) {
        var vm = this;

        var forms = [];
        var totalErrors = 0;
        var fixedErrors = 0;

        vm.currentStep = 0;
        vm.getForm = getForm;
        vm.isFormValid = isFormValid;
        vm.nextStep = nextStep;
        vm.nextStepDisabled = nextStepDisabled;
        vm.prevStep = prevStep;
        vm.prevStepDisabled = prevStepDisabled;
        vm.progress = 0;
        vm.registerForm = registerForm;
        vm.updateProgress = updateProgress;
        vm.registerUser = registerUser;
        vm.saveUserProfile = saveUserProfile;
        vm.registrationError = undefined;
        vm.showError = false;

        //////////////// Customized for Adminja ////////////////

        function getForm(index) {
            return forms[index];
        }

        function nextStep() {
            // $log.info('nextStep');
            vm.currentStep = vm.currentStep + 1;
        }

        function registerUser(user){
            // $log.info('register clicked');

            // do registration


            firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(_userData, error) {
                // console.log("User " + _userData.uid + " created successfully", _userData);

                // get set to store our own userData
                var usersRef = firebase.database().ref('users');

                user.uid = _userData.uid;

                var newUserRecord = {
                    email: user.email,
                    uid: _userData.uid
                }

                newUserRecord.profile = {};
                newUserRecord.profile.avatar = "";
                newUserRecord.profile.firstName = "";
                newUserRecord.profile.lastName = "";

                // save our basic users record
                usersRef.child(_userData.uid).set(newUserRecord);


            }).then(function(authData) {
                $mdToast.showSimple('New Account Created.');

                // proceed to next pane of wizard
                nextStep();

                // return firebase.auth().signInWithEmailAndPassword(vm.user.email, vm.user.password);
                // console.log("Logged in as: ", authData.uid);
                // $state.go('triangular.account-page.profile');

            }).catch(function(error) {
                // console.log("Error: ", error);
                // vm.errorMessage = error.message;
                // vm.showError = true;
                $mdToast.show(
                      $mdToast.simple()
                        .textContent(error.message)
                        .position('top center')
                        .hideDelay(3000)
                    );
                user.email = "";
                user.password = "";
                user.passwordConfirm = "";
            });


    }

        function saveUserProfile(user){
            // $log.info('saveUserProfile');
            var newUser = angular.copy(user);

            if (newUser.profile.dob){
                newUser.profile.dob = newUser.profile.dob.toISOString();
            }

            var usersRef = firebase.database().ref('users');

            // save our user profile
            usersRef.child(newUser.uid + '/profile').set(newUser.profile);
            $mdToast.showSimple('User Profile Updated');

            // proceed to next pane of wizard
            nextStep();


        }

        function nextStepDisabled() {
            // get current active form
            var form = $scope.registrationWizard.getForm(vm.currentStep);
            var formInvalid = true;
            if(angular.isDefined(form) && angular.isDefined(form.$invalid)) {
                formInvalid = form.$invalid;
            }
            return formInvalid;
        }

        function isFormValid(step) {
            if(angular.isDefined(forms[step])) {
                return forms[step].$valid;
            }
        }

        function prevStep() {
            vm.currentStep = vm.currentStep - 1;
        }

        function prevStepDisabled() {
            return vm.currentStep === 0;
        }

        function registerForm(form) {
            forms.push(form);
        }

        function updateProgress() {
            var errors = calculateErrors();
            fixedErrors = totalErrors - errors;

            // calculate percentage process for completing the wizard
            vm.progress = Math.floor((fixedErrors / totalErrors) * 100);
        }

        function calculateErrors() {
            var errorCount = 0;
            for (var form = forms.length - 1; form >= 0; form--) {
                if(angular.isDefined(forms[form].$error)) {
                    for(var error in forms[form].$error) {
                        errorCount += forms[form].$error[error].length;
                    }
                }
            }
            return errorCount;
        }


        // init

        // wait until this tri wizard is ready (all forms registered)
        // then calculate the total errors
        $timeout(function() {
            totalErrors = calculateErrors();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('registrationWizardForm', registrationWizardFormProgress);

    /* @ngInject */
    function registrationWizardFormProgress() {
        // Usage:
        //  <div tri-wizard>
        //      <form tri-wizard-form>
        //      </form>
        //  </div>
        //
        var directive = {
            require: ['form', '^registrationWizard'],
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, require) {
            var ngFormCtrl = require[0];
            var registrationWizardCtrl = require[1];

            // register this form with the parent triWizard directive
            registrationWizardCtrl.registerForm(ngFormCtrl);

            // watch for form input changes and update the wizard progress
            element.on('input', function() {
                registrationWizardCtrl.updateProgress();
            });
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('appDirectives')
		.directive('profilePanel', profilePanel)
		.directive('newProfilePanel', newProfilePanel);


	function newProfilePanel(){
			var directive = {
				restrict: 'E',
				replace: false,
				controller: profilePanelController,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: 'app/app-directives/profile-panel/new-profile-panel.tmpl.html'
			};
			return directive;
	}

	function profilePanel() {
		var directive = {
			restrict: 'E',
			panel: '=',
			replace: false,
			controller: profilePanelController,
			controllerAs: 'vm',
			bindToController: true,
			templateUrl: 'app/app-directives/profile-panel/profile-panel.tmpl.html'


		};
		return directive;
	};

	///////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////
	/// profilePanelController


/* @ngInject*/
	function profilePanelController(dragulaService, $log, pageDimensionsService, userDataService, $rootScope, $stateParams, $state, $scope, $timeout, $mdToast, profileDataService, panelDataService, clientDataService) {

		// Once agaain, vm. can't be used. we have to use $scope.
		// $log.info('profilePanelController');
		var vm = this;

			// Set our client ID, exposed to our directives
			vm.clientID = $stateParams.clientID;
			vm.state = $state;


		$scope.verticalProfilePanels = userDataService.user.profile.settings.verticalProfilePanels;

		$scope.scrollFocus = function scrollFocus(event){
			// $log.info('scrollFocus - disabled');
			// var panel = $(event.target).closest('.app-item-container');
			// var scrollContainer = $(panel).closest('#scroll-h');
			// var scrollContainerWidth = $(scrollContainer).width();
			// // var offset = $(panel).offset().left - $(scrollContainer).offset().left
			// // $log.info(panel);
			// // // $(scrollContainer).css('background-color', 'pink');
			// // // $(panel).css('background-color', 'blue');
			// // scrollContainer.scrollLeft(offset);

			// var scrollTo = $(panel).offset().left; // retrieve its position relative to its parent
			// $log.info(scrollTo);
			//    //$('.scroller').scrollLeft(scrollTo); // simply update the scroll of the scroller
			//    $(scrollContainer).animate({'scrollLeft': scrollTo + 100}, 800); // use an animation to scroll to the destination
		}



		$scope.showClientCard = function(label){
		  if(label == 'Client Details'){
		    return true
		  };
		}

		$scope.newPanel = function newPanel(){
			// $log.info('profilePanelController: newPanel');
			var panelCount = $('profile-panel').length;
			return panelDataService.newPanel(vm.clientID, panelCount);
		}

		$scope.addDetail = function addDetail(type, panel){
			// $log.info('profilePanelController: new detail', panel);
				profileDataService.newProfileDetail(type, panel, 'New');
		};

		$scope.editPanel = function editPanel(panel){
			// $log.info('profilePanelController: editPanel');

			 return panelDataService.editPanel(panel);

		};

		$scope.deletePanel = function deletePanel(panel){
			if(panel.label != "Client Details"){
				panelDataService.deletePanel(panel);
			}
		}

		/////////////////////////////////////////////
		// Sort profile detail panels
		function sortDetails(panelID, clientID){
			// $log.error('Sorting Details');
			// Isolate this panel thanks to it's panelid attribute
			var sortingPanel = $('.app-item-container-items[panelid="' + panelID +'"]');
			// $(sortingPanel).css('background-color', 'yellow');
			// grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
			var sortedDetails = $(sortingPanel).find('.info-card');

			// set our DB reference
			var detailsRef = firebase.database().ref('clients/' + clientID + '/panels/' + panelID + '/details');

			// Update each item in firebase by ID
			_.each(sortedDetails, function(detail, index){
				var newOrder = parseInt(index) + 1,
				    detailID = detail.getAttribute('uid');
				// update JUST the order value on the panel
				detailsRef.child(detailID).child('order').set(newOrder);
			})
		}

		////////////////////////////////////////
		// move detail to a different panel
		var moveToPanel = function(detailID, parentPanelID, targetPanelID, clientID, newOrder){
			// get a canonical copy of our detail
			var detailRef = firebase.database().ref('clients/' + clientID + '/panels/' + parentPanelID + '/details/' + detailID);

			detailRef.once('value', function(snap)  {
				var detail = snap.val(),
				    newPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid);

				// change our panel and set our order to just before the dropped sibling
				detail.panel = targetPanelID;

				if (newOrder){detail.order = parseInt(newOrder) - .5;}

				// Set the record at the new location
			     newPath.set(detail, function(error) {
			          if( !error ) {
			          	// remove the original one if no error
			          	detailRef.remove();
			          	// heap.track('Profile Card Moved');
			          	$timeout(function(){
			          	  pageDimensionsService.resizeColumns();
			          	  sortDetails(targetPanelID, clientID);
			          	}, 250);
			          }
			          else if( typeof(console) !== 'undefined' && console.error ) {  console.error(error); }
			     });
		    });
		}



		/////////////////////////////////////////////
		// drag-profile-detail over function
		$scope.$on('drag-profile-detail.over', function (event, el, target, source) {
			// $log.info(target,source);
			if(target[0].$$hashKey != source[0].$$hashKey){
				pageDimensionsService.resizeColumns();
			}
		});

		/////////////////////////////////////////////
		// drag-profile-detail over function
		$scope.$on('drag-profile-detail.out', function (event, el, target, source) {
			// $log.info(target,source);
			if(target[0].$$hashKey != source[0].$$hashKey){
				pageDimensionsService.resizeColumns();
			}
		});

		$scope.$on('drag-profile-detail.cancel', function (event, el, target, source) {
			// $log.info(target,source);
			$timeout(function(){
			  $rootScope.draggingDetail = false;

			}, 100);
		});

		/////////////////////////////////////////////
		// drag-profile-detail drop function
		$scope.$on('drag-profile-detail.drop', function (event, el, target, source, sibling) {
			$rootScope.draggingDetail = false;
			// $log.info('sibling:', sibling);

			// Gather all of the properties we will need to execute the move
			 var  detailID = el[0].id,
				 parentPanelID =  el[0].attributes.panel.nodeValue,
				 clientID = el[0].attributes.client.nodeValue,
				 targetPanelID = target[0].attributes.panelid.nodeValue,
				 newOrder = undefined;

			 // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
			 if (sibling != undefined){
			 	newOrder = sibling[0].attributes.order.nodeValue;
			 }

			 if (parentPanelID == targetPanelID){
				// just moving within the same panel
				sortDetails(parentPanelID, clientID);
				// resize our columns
				$timeout(function(){
				  pageDimensionsService.resizeColumns();
				  // heap.track('Profile Card Reordered');
				}, 250);

			 } else {
			 	// moving betwixt panels
			 	moveToPanel(detailID, parentPanelID, targetPanelID, clientID, newOrder);
			 	// heap.track('Profile Card Reordered');
			 }
		});// $on.drag-profile-detail.drop
	}
})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('profileDetailItem', profileDetailItem);


  function profileDetailItem() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: profileDetailItemController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/profile-detail-item/profile-detail-item.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {}

  ///////////////////////////////////////////////////////////
  /// profileDetailItemController

  /* @ngInject */
  function profileDetailItemController($timeout, $log, $mdToast, $scope, $filter, profileDataService, pageDimensionsService) {

    var vm=this;


  //Make sure our note links open in new window
  $timeout(function(){
    $('md-card.info-card a').click(function(e){
      e.preventDefault();
      window.open(this.href);
    });
  },20);



  $scope.applyBackground = function(detail){
        if (detail.notecolor){
          return { 'background-color': detail.notecolor }
        } else { return null}
    };

    $scope.shortenFilename = function(text){
     return _.truncate(text, {
        'length': 36,
        'omission': '...'
      });


    }

    $scope.isImage = function(file){
      var validExtensions = [
          'jpg',
          'gif',
          'png',
          'bmp'
          ],
        extension = file.fileName.split('.').pop();

      // if this file's extension is valid, return true
      if (_.includes(validExtensions,extension)){
        return true
      } else {
        return false
      }
    }// isImage


    $scope.editDetail = function(detail){
      var newDetail = angular.copy(detail);
      if (newDetail.dob){
        newDetail.dob = new Date(newDetail.dob);
      }
      profileDataService.editProfileDetail(newDetail, 'Update');


    };

    $scope.copyDetail = function(detail){
      // heap.track('Profile Card Copy Started');
      var newDetail = angular.copy(detail);
      $log.info(newDetail);
      // Remove ID, Client, and Bucket so we will then be saving a new copy and be able to assign it elsewhere

      delete newDetail.uid;
      delete newDetail.client;
      delete newDetail.panel;
      profileDataService.editProfileDetail(newDetail, 'Clone');
    };

    $scope.removeDetail = function(item){
      profileDataService.deleteProfileDetail(item);

    };

    $scope.moveToPanel = function(detail, targetPanelID){
      // heap.track('Profile Card Moved');
      var originalPanelID = detail.panel,
          clientID = detail.client;

      // $log.info('moveToPanel');
      // $log.info(detail);
      // $log.info(targetPanelID);

      var originalPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + originalPanelID + '/details/' + detail.uid);
      var newPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid);

      moveFbRecord(originalPath, newPath);

      // update panel property
      detail.panel = targetPanelID;
      detail.order = 1000;
      newPath.set(detail);

      $timeout(function(){
        pageDimensionsService.resizeColumns();
      }, 0);

       function moveFbRecord(oldRef, newRef) {
        // $log.info('moveFbRecord');
        // $log.info(oldRef, newRef);
            oldRef.once('value', function(snap)  {
                 newRef.set( snap.val(), function(error) {
                      if( !error ) {  oldRef.remove(); }
                      else if( typeof(console) !== 'undefined' && console.error ) {  console.error(error); }
                 });
            });
       }

    };

  }

})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('printTimeReport', printTimeReport);


     function printTimeReport() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: printTimeReportController,
         scope: {
           report: '=report'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

     // Directive expects report to have the following properties
     // vm.report.clientName
     // vm.report.start
     // vm.report.end
     // vm.report.type
     // vm.report.allocated
     // vm.report.time

   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/print-time-report/print-time-report.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function printTimeReportController($rootScope, $mdToast, $scope, $log, timeDataService, clientBillingService, userDataService) {
        var vm = this;
        vm.user = userDataService.user;
         // set our currency
         vm.currency = "$";
        if (_.has(vm.user.profile, 'settings.currency')){
             vm.currency = vm.user.profile.settings.currency;
         }


        // NOTE we have vm.report by default because it was passed in to "this" already
        // $log.info(vm.report);

        // Calculate and display total for period
        vm.total = function(){
            if (vm.report.type == 'retainer'){
                return Number(vm.report.cost).toFixed(2)
            } else {
                var cost = vm.period.rate * vm.used();
                return number(cost).toFixed(2)
            }
        }// vm.total

        vm.used = function(){

            var used = 0;
            _.each(vm.report.time, function(entry){
                used = used + entry.logged;
            });

            return used
        }

        vm.remain = function(){
            return (vm.report.allocated * 60) - vm.used()
        }

        vm.lineItemTotal = function(entry){
            return (entry.logged/60) * vm.report.rate
            // return (vm.report.allocated * 60) - vm.used()
        }

        vm.reportTotal = function(){
            var logged = 0;
            _.each(vm.report.time, function(entry){
                logged = logged + entry.logged;
            });
            return (logged/60) * vm.report.rate
        }

        vm.cancelReport = function(){
            delete vm.report
        }


        vm.printReport = function(report){
            // $log.info('Report directive: printReport');
            report.user = vm.user.profile;

            // Pre-sort our time before sending it to the cloud
            report.time = _.sortBy(report.time, ['logDate']);


            if(report.type == 'hourly'){
                report.isHourly = true
            } else {report.isHourly = false}

             var request = {
               link: 'pending',
               template: 'time-report',
               filename: report.filename
             };


             // attach our pdf request node to our data
             report.pdf = request;
             // $log.info(report);
             // Let the user know it's on it's way
             $mdToast.show($mdToast.adminjaAlert(
                 {
                     locals:{
                         title: 'Your report is on it\'s way!',
                         message: 'We\'ll notify you when it\'s ready.' ,
                         color: 'orange'
                     }
                 }));// mdToast

             return timeDataService.requestPDF(report);

        }// vm.printReport


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('notificationCard', notificationCard);


     function notificationCard() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: notificationCardController,
         scope: {
           item: '=item'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/notification-card/notification-card.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function notificationCardController($rootScope, $scope, $injector, $sce, $state, $log, teamDataService, inboxService, taskDataService) {
        var vm = this;

        vm.sanitizeMe = function(text) {
            return $sce.trustAsHtml(text)
        };

        vm.isOld = function(notification){
            var now = moment(),
                then = moment(notification.date);
                if (now.diff(then, 'days') > 15 && notification.read){
                    return true
                }

        }

        vm.importTask = function(message){
           inboxService.importTask(message);
        }


        vm.openTask = function(item, tab){
           return taskDataService.getTask(item.related)
           .then(function(editedItem){
                // $log.info(editedItem);
               // convert our due date into a date object for md-date-picker
               if (_.has(editedItem, 'info.duedate')) {
                   editedItem.info.duedate = new Date(editedItem.info.duedate);
               }
               // send it to our dialog
               taskDataService.taskDialog(editedItem, tab);
           })
        }

        vm.showCue = function(cue){
          Appcues.show(cue);
        }

        vm.importNote = function(message){
           inboxService.importNote(message);
        }

        vm.discardNotification = function(item){
           var updates = {};
           // $log.info(item);
           // we are using $index as a reference as not all notifications will have a .uid property
           updates['/users/' + item.user + '/notifications/' + item.$key] = null;
           firebase.database().ref().update(updates)

        }

        vm.acceptInvite = function(item){
          teamDataService.acceptInvite(item);
          vm.discardNotification(item);
        }

        vm.declineInvite = function(item){
          teamDataService.declineInvite(item);
          vm.discardNotification(item);
        }

        vm.refreshClients = function(){
          var clientDataService = $injector.get('clientDataService');
          return clientDataService.setupClientMenu(true);
        }

        vm.gotoClient = function(item){
          $state.go("triangular.client-manager-page.tasks", {"clientID": item.related});
        }

    }// notificationCardcontroller



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('noteEntry', noteEntry);


  function noteEntry() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: noteEntryController,
      controllerAs: 'vm',
      bindToController: true,
      // preserveScope: true,
      scope: {
        task: '@task',
        client: '@client'
      },
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/note-entry/note-entry.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


  }// linkFunc


  /* @ngInject */
  function noteEntryController($log, hotkeys, teamDataService, $timeout, $mdToast, noteDataService, $rootScope, taskDataService, $scope, $firebaseArray, clientDataService, userDataService, localStorageService, $mdDialog) {
    // $log.info('noteEntryController');
    var thisClient = $scope.vm.client;
    // $log.info('thisClient:' + thisClient);
    var vm = this;
    vm.userID = $rootScope.userID;
    // Had trouble getting our note from $scope. Then we fitured out $parent
    // not sure why we can't pass client and task AND STILL have the
    // note scope passed along by default as before
    // but this seems to be an easy workaround
    vm.note = $scope.$parent.note;
    var thisTeam = teamDataService.clientTeams[thisClient];

    // Find our team member
    _.each(thisTeam, function(member){
      if(member.uid == vm.note.author){
        vm.thisMember = member;
        if(_.has(vm.thisMember, 'color')){
          vm.bubbleBackground = ajUTILITIES.lightenDarkenColor(vm.thisMember.color, 200);
        } else {
          vm.bubbleBackground = ajUTILITIES.lightenDarkenColor('#666', 200);
        }
      }
    });


    vm.editMode = false;



    $scope.editNote = function(entry){

      // check to make sure no other edits are open
      // alert if that's the case and ignore edit request
      // $log.info($('.inline-edit').length);
      if ($('.inline-edit').length > 0){
        // $log.info('Already editing');
        $mdToast.show(
             $mdToast.simple()
               .textContent('Already editing a Note. Please complete your operation first.')
               .position('top right')
               .hideDelay(2000)
           );
        return
      }

      vm.editMode = true;
      vm.editStatus = 'editing';
      vm.editNote = angular.copy(entry);

     // Set focus
    $timeout(function () {
        angular.element("textarea[name='editNotebody']").focus();
    }, 500);



    }// editNote

    $scope.cancelEdit = function(entry){
      vm.editMode = false;
    }

    $scope.startDelete = function(entry){
      vm.editStatus = 'startdelete';
    }

    $scope.cancelDelete = function(entry){
      vm.editStatus = 'editing';
    }


    $scope.deleteNote = function(entry, taskID, clientID){
      vm.editStatus = 'deleting';
      return noteDataService.deleteNote(entry, taskID, clientID)
      .then(function(response){
        vm.editStatus = 'deleted';
        $mdToast.show(
              $mdToast.simple()
                .textContent('Note Deleted')
                .position('top right')
                .hideDelay(2000)
            );
      });

    }

    $scope.updateNote = function(entry, taskID, clientID){
      vm.editStatus = 'saving';
      return noteDataService.updateNote(entry, taskID, clientID)
      .then(function(){
        vm.editStatus = 'saved';
        vm.editMode = false;
        $mdToast.show(
              $mdToast.simple()
                .textContent('Time Log Updated.')
                .position('top right')
                .hideDelay(2000)
            );
      });

    }// updateNote


    } // noteEntryController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('gravatarImage', function () {
      /*
       * A simple Gravatar Directive
       * @example
       *   <gravatar-image email="test@email.com" size="50"></gravatar-image>
       */
      return {
        restrict: 'AE',
        replace: true,
        required: 'email',
        template: '<img ng-src="https://www.gravatar.com/avatar/{{hash}}?s={{size}}&d=identicon" />',
        link: function (scope, element, attrs) {
          attrs.$observe('email', function (value) {
            if(!value) { return; }

            // MD5 (Message-Digest Algorithm) by WebToolkit
            var md5=function(s){function L(k,d){return(k<<d)|(k>>>(32-d));}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H);}if(I|d){if(x&1073741824){return(x^3221225472^F^H);}else{return(x^1073741824^F^H);}}else{return(x^F^H);}}function r(d,F,k){return(d&F)|((~d)&k);}function q(d,F,k){return(d&k)|(F&(~k));}function p(d,F,k){return(d^F^k);}function n(d,F,k){return(F^(d|(~k)));}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F);}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F);}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F);}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F);}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++;}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa;}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2);}return k;}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x);}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128);}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128);}}}return d;}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g);}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase();};

            scope.hash = md5(value.toLowerCase());
            scope.size = attrs.size;

            if(angular.isUndefined(scope.size)) {
              scope.size = 60; // default to 60 pixels
            }
          });
        }
      };
    });


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('globalTimer', globalTimer);


  function globalTimer() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: globalTimerController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {

    scope.getTemplateUrl = function() {
        return 'app/app-directives/global-timer/global-timer.tmpl.html';
    };

  }


  /* @ngInject */
  function globalTimerController($rootScope, $scope) {
    var vm = this;


    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('fileAttachments', fileAttachments);


    function fileAttachments() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: fileAttachmentsController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {files: '=files', // our parent object's file array
                    form: '=form', // our parent object's form (for making it dirty)
                    counter: '=counter', // our parent object's file count
                    client: '=client', // clientID so we know uploaded file paths
                    path: '=path', // path that files should be saved (tasks/profile/etc.)
                    status: '=status' // status of our parent object (i.e. if uploads are allowed)
                },
            link: linkFunc,
            templateUrl: 'app/app-directives/file-attachments/file-attachments.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }

    /* @ngInject */
    function fileAttachmentsController($rootScope, $scope, $log, $timeout) {
        var vm = this;
        vm.files = $scope.files;
        vm.form = $scope.form;
        vm.counter = $scope.counter;
        vm.client = $scope.client;
        vm.path = $scope.path;
        // $log.info($scope);

        // Check for status
        vm.status = true;
        // If status is closed, override our default
        if (_.has($scope, 'status')){
            // if it's not closed, the status is true
            if ($scope.status == 'closed'){
                vm.status = false;
            }
        }


        // Dropbox File Functions
        // NOTE: All dropbox functions handled by the directive
        // See our customized version at /vendor-components/dropbox-picker.min.js

        // Utility function used to generate unique IDs for each image uploaded to storage
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }
          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

        // Google File Functions
        vm.onLoaded = function () {
           console.log('Google Picker loaded!');
         }

         vm.onPicked = function (docs) {
           angular.forEach(docs, function (file, index) {
            var fileObject = {
                fileName: file.name,
                url: file.url,
                source: 'googleDrive'
            }

            vm.files.push(fileObject);

            $timeout(function(){
                vm.form.$setDirty();
                vm.isUploading = false;
                vm.count = vm.count + 1;
            },0);
           });
         }

         vm.onCancel = function () {
           console.log('Google picker close/cancel!');
         }

         $scope.removeFile = function (chip) {
             // $log.info('removeFile');

             // If the file is stored in firebase Storage, we need to delete it
             if(chip.source != 'googleDrive' && chip.source != 'dropbox'){
                 // Create a reference to the file to delete
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 var fileRef = storageRef.child('clients/' + vm.client + '/'+ vm.path+'/' + chip.fileName);

                 // // Delete the file
                 fileRef.delete().then(function () {
                     // File deleted successfully
                     // $log.info('File ' + chip.fileName + ' deleted.');
                     // $mdToast.showSimple(chip.fileName + ' deleted.');
                 }).catch(function (error) {
                     // Uh-oh, an error occurred!
                     // $log.info('Oops! File ' + chip.fileName + ' NOT! deleted.');
                 });
             }

             // heap.track('Task File Deleted');
         }

         // UPload file directly to firebaseStorage
         $scope.uploadFile = function ($files) {
             // $log.info('upload file');
             // $log.info($files);

             if ($files !== null && $files.length > 0) {
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 _.each($files, function (file) {
                     var filename = file.name;
                     vm.isUploading = true;
                    var uniqueID = guid();
                     // $log.info('Saving '+filename);
                     // create imageRef and put the file
                     var fileRef = storageRef.child('clients/' + vm.client + '/'+ vm.path +'/' + uniqueID+'-'+filename),
                             uploadTask = fileRef.put(file);

                     uploadTask.on('state_changed', function (snapshot) {
                         // $log.info('upload state changed');
                     }, function (error) {
                         // $log.warn('upload failed');
                     }, function (success) {
                         // $log.info('upload success');
                         var fileObject = {
                             fileName: filename,
                             url: uploadTask.snapshot.downloadURL,
                             source: 'firebaseStorage'
                         }

                            vm.files.push(fileObject);

                         $timeout(function(){
                             vm.form.$setDirty();
                             vm.isUploading = false;
                             vm.count = vm.count + 1;
                         },0);



                     }); // uploadTask.on
                 }); // ._each files
             } // if files

             // heap.track('File Uploaded');
         }; // vm.uploadAvatar


    }// fileAttachmentsController



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('fabButton', fabButton);


  function fabButton() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: fabButtonController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {

    scope.getTemplateUrl = function() {
        return 'app/app-directives/fab-button/fab-button.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function fabButtonController(hotkeys, $timeout, $mdDialog, $state, localStorageService, $log, $rootScope, $scope, taskDataService, clientDataService, userDataService, profileDataService, timeDataService, authFactory, $stateParams) {
    var vm = this;
            vm.fabDirection = "up";
            vm.fabAnimation = "md-scale";
            vm.fabStatus = false;
            vm.newTask = newTask;
            vm.newTime = newTime;
            vm.newFabDetail = newFabDetail;
            vm.newFabSpace = newFabSpace;
            vm.launchDiagnostics = launchDiagnostics;

            // Setup Hotkeys for functions below
            // Define our hotkeys
            hotkeys.add({
              combo: 'alt+ctrl+n',
              description: 'New Task',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newTask();
              }
            });
            hotkeys.add({
              combo: 'alt+ctrl+t',
              description: 'New Time Entry',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newTime();
              }
            });
            hotkeys.add({
              combo: 'alt+ctrl+b',
              description: 'Batch Enter Tasks',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                vm.batchTasks();
              }
            });

            hotkeys.add({
              combo: 'alt+ctrl+u',
              description: 'New URL Card',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabDetail('url');
              }
            });
            hotkeys.add({
              combo: 'alt+ctrl+c',
              description: 'New Space',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabClient();
              }
            });
            hotkeys.add({
              combo: 'alt+ctrl+o',
              description: 'New Note Card',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabDetail('note');
              }
            });

            hotkeys.add({
              combo: 'alt+ctrl+p',
              description: 'New Person Card',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabDetail('person');
              }
            });


           function newFabSpace(){
                // trigger newClient dialog
                // $log.info('newClient got clicked!')
                var newClient = clientDataService.newClient();



                clientDataService.clientDialog(newClient, 'New Client Workspace');

            }





            function newFabDetail(type){
              var clientID = null;
              // if we are on a client page and passed a Client ID, prepopulate our client info
              // if ($stateParams.clientID){
              //  // $log.info('new time for client' + $stateParams.clientID);
              //  clientID = $stateParams.clientID;
              //  var panel = {};
              //  panel.client = clientID;
              //  profileDataService.newProfileDetail(type, panel);
              // } else {

               profileDataService.newProfileDetail(type, undefined, "New");

              // }
            }

          function launchDiagnostics(ev){
            // $log.info('launchDiagnostics');
            $state.go('triangular.diagnostics')
          }

          function newTime(){
            // $log.info('newTime');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID){
             // $log.info('new time for client' + $stateParams.clientID);
             clientID = $stateParams.clientID;
            }

            $scope.timeEntry = timeDataService.newLogEntry(clientID);
            // $log.info($scope.timeEntry);
            timeDataService.timeDialog($scope.timeEntry, "New");

          }

          vm.batchTasks = function(){
            // $log.info('batchTasks');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID){
             // $log.info('new time for client' + $stateParams.clientID);
             clientID = $stateParams.clientID;
            }
                     return taskDataService.batchDialog(clientID);
           }// batchTasks

          function newTask() {
                // console.log('newTask from Fab');
                var userID = localStorageService.get('userID');
                // $log.info(userID);

                 var clientID = null;

                  // if we are on a client page and passed a Client ID, prepopulate our client info
                  if ($stateParams.clientID){
                   // $log.info('new task for client' + $stateParams.clientID);
                   clientID = $stateParams.clientID;
                  }

                  $scope.editedItem = taskDataService.newTask(clientID, 'Later');
                  // $log.info($scope);
                  // Set our dialogTitle
                  $scope.dialogTitle = "New";
                  // console.log($scope.editedItem);
                  taskDataService.taskDialog($scope.editedItem);
            }// newTask
    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientTeamMemberAccess', clientTeamMemberAccess);


     function clientTeamMemberAccess() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: clientTeamMemberAccessController,
         scope: {
           member: '=member',
           client: '=client'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-team-member-access/client-team-member-access.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientTeamMemberAccessController($rootScope, $timeout, $state, hotkeys, $scope, $log, userDataService, teamDataService, clientDataService) {
        var vm = this;
        vm.userID = $rootScope.userID;
        // vm.member & vm.client are implicit in the directive

        // determine the members access and set vm.access
        if(!_.has(vm.client.access.users, vm.member.uid)){
          vm.clientAccess = 'none'
        } else {
          vm.clientAccess = 'member'
        }
        // and override if we are admin
        if(_.has(vm.client.access.admins, vm.member.uid)){
          vm.clientAccess = 'admin'
        }



        vm.setMemberAccess = function(member, access){
            // $log.info('About to set member access for...');
            // $log.info('member', member);
            // $log.info('client', vm.clientid);
            // $log.info('team', vm.team);
            // $log.info('access', access);
            return teamDataService.setMemberAccess(member, vm.client.uid, vm.client.owner, access)
            .then(function(){
              $timeout(function(){
                clientDataService.setupClientMenu(true);
            },0);
            });
        }


        vm.openClient = function(clientUID){
            // $log.info('vm.openClient: ' + client);
            $state.go("triangular.client-manager-page.information(clientID: clientUID)")
            // return clientDataService.getClient(clientID)
            // .then(function(thisClient){
            //     // $log.info(thisClient);
            //     return clientDataService.clientDialog(thisClient);
            // })
        }

        vm.isClientOwner = function(owner){
          if($rootScope.userID == owner){
            return true
          } else {
            return false
          }
        }


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientSummaryStrip', clientSummaryStrip);


    function clientSummaryStrip() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: clientSummaryStripController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {thisClient: '=thisClient',
                    showProgress: '=showProgress'},
            link: linkFunc,
            templateUrl: 'app/app-directives/client-summary-strip/client-summary-strip.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }


    /* @ngInject */
    function clientSummaryStripController($rootScope, userDataService, $scope, $log, clientDataService) {
        var vm = this;
        vm.currency = "$";
        // set our currency if user has selected one
       if (_.has(userDataService.user.profile, 'settings.currency')){
            vm.currency = userDataService.user.profile.settings.currency;
        }

        function isNan(value) {
            var n = Number(value);
            return n !== n;
        };

        function init() {
            // $log.info($scope.thisClient);
            var now = moment(),
                    thisMonth = parseInt(now.month() + 1),
                    thisYear = now.year();

            vm.thisClient = $scope.thisClient;
            vm.showProgress = $scope.showProgress;
            var totalsPath = '';
            var currentRetainerPeriod = undefined;

            // $log.info(vm.type);
            vm.cost = 0;
            vm.plan = 0;
            vm.remain = 0;
            vm.rate = 0;
            vm.used = 0;
            vm.total = 0;

            // set default to avoid exceptions
            vm.type = "hourly";

            // use what's set if we have it
            if(_.has(vm.thisClient, 'profile.plan.type')){
                vm.type = vm.thisClient.profile.plan.type
            }



            vm.progress = function (logged, allocated) {
                // Find and round percentage of allocated
                var progress = ((logged / 60) / allocated) * 100;
                progress = Math.round(progress, 2);

                // if we are getting NaN (i.e. rate is zero, return 0 not an error)
                if(isNan(progress)){
                    progress = 0;
                }

                return progress

            }

        // go through billing periods and find the current one
        if(_.has(vm.thisClient, 'billing')){
            // $log.info('Finding billingperiod');
            var now = moment().startOf('day').toISOString();
            _.each(vm.thisClient.billing, function(billingPeriod){
                if(moment(billingPeriod.start).startOf('day').toISOString() <= now && moment(billingPeriod.end).endOf('day').toISOString() > now){
                    vm.rate = billingPeriod.rate;
                    vm.used = billingPeriod.logged;
                    vm.type = billingPeriod.type;
                    vm.total = (vm.used/60) * vm.rate;

                    // Countdown until next renewal
                    var a = moment(), b = moment(billingPeriod.end);
                    vm.renewsIn = b.diff(a, 'days') + 1;
                    vm.remain=0;

                    if(billingPeriod.type == 'retainer'){
                        vm.plan = billingPeriod.allocated || 0;
                        var allocated = Number(billingPeriod.allocated || 0),
                            logged= Number(billingPeriod.logged || 0);

                        vm.remain = (allocated * 60)  - logged;
                    }
                }
            });
        }

        }// init

        // Execute our calculations on run
        init();

        $scope.retainerStatus = function(logged, budget){
            var status = 'ok';
            if (budget > 0 && logged / budget > 0.70) {
                status = 'close'
            }
            if (budget > 0 && logged / budget >= 1) {
                status = 'over'
            }
            return status
        }



        // Watch vm.months and update if changed
        var unwatch = $scope.$watch('thisClient', function () {
            // console.log("logdata changed!");

            // re-execute our calculations
            init();

        }, true);

        $scope.isPersonalSpace = function(){
            if(vm.thisClient.status == 'personal'){
                return true
            } else {return false}
        }

        $scope.showSummary = function(){
            if(_.has(vm.thisClient, 'profile.plan.nextCycle')){
                return true
            } else {
                return false
            }
        }

        $scope.openClient = function(client){
            return clientDataService.clientDialog(client);
        }


    }



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientMemberListItem', clientMemberListItem);


     function clientMemberListItem() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: clientMemberListItemController,
         scope: {
           member: '=member'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-member-list-item/client-member-list-item.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientMemberListItemController($rootScope, $scope, $log, userDataService, teamDataService) {
        var vm = this;
        vm.teamDataService = teamDataService;

        // get the full userRecord for this team member. We need both
        var userRef = firebase.database().ref('users').child(vm.member.uid);
        userRef.once('value', function(snapshot){
            vm.user = snapshot.val();
        });

        vm.becameMember = moment(vm.member.becameMember).format('MMM d, YYYY');
        vm.invited = moment(vm.member.invited).format('MMM d, YYYY');

        vm.selectTeamMember = function(member){
            vm.teamDataService.selectUser(vm.user);
            vm.teamDataService.selectTeamMember(member);
        }

        vm.isMemberSelected = function(){
            if(vm.teamDataService.selectedMember){
                if(vm.teamDataService.selectedMember.uid == vm.member.uid){
                    return true
                }
            }
        }




    }// controller



})();

///////////////////////////////////////////
// Setup all directives related to the client object
// clientCard
// newClient Button
// future: clientSummary

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('clientCard', [clientCard])
        .directive('newClientButton', [newClientButton])
        .controller('clientController', [clientController]);

        /* @ngInject */
        function clientCard(clientDataService, $log, $mdDialog) {
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/app-directives/client-directives/client-card.tmpl.html',
                controller: clientController,
                controllerAs: 'vm',
                // scope:{
                //     client: '='
                // },
                bindToController: false
            };
            return directive;
        };

        /* @ngInject */
        function newClientButton(clientDataService, $log, $mdDialog) {
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/app-directives/client-directives/new-client-button.tmpl.html',
                controller: clientController,
                controllerAs: 'vm',
                bindToController: true
            };
            return directive;
        };


    /* @ngInject */
    function clientController($state, $timeout, $mdDialog, clientDataService, $log, $scope) {
        var vm = this;



        $scope.displayBirthday = function(client){
            var thisYear = moment().format('YYYY');
            var birthday = moment(client.profile.birthday.month + '/' + client.profile.birthday.day + '/' + thisYear, "MM-DD-YYYY");
            return moment(birthday).format('MMMM Do')
        }

        // Edit a task
        $scope.editClient = function(client) {
            // $log.info('editClient got clicked!')
            // $log.info(client);
            client.clicked = true;
            // Remove visual after timer delay
            $timeout(function(){
                client.clicked = false;
            },1000);
            return clientDataService.editClient(client.uid);

        }; // End editClient

        $scope.viewClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            $state.go('triangular.client-manager-page.information', {clientID: client.uid});
        }

        $scope.archiveAndDeleteClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: red; padding-bottom: 1em; margin:0;">You are about to Archive AND DELETE the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- Any Task Due Dates will be removed</li> <li>- Any team members will be unassigned.</li><li>- Recurring tasks and Billing Periods will be disabled.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Archive')
                  .targetEvent(event)
                  .ok('Archive It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             // Store the current status (active or personal) so we have it for later use

             return clientDataService.archiveAndDeleteClient(client)
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });
        }

        $scope.archiveClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: red; padding-bottom: 1em; margin:0;">You are about to Archive the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- Any Task Due Dates will be removed</li> <li>- Any team members will be unassigned.</li><li>- Recurring tasks and Billing Periods will be disabled.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Archive')
                  .targetEvent(event)
                  .ok('Archive It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             // Store the current status (active or personal) so we have it for later use

             return clientDataService.archiveClient(client)
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });
        }

        $scope.nextRenewal = function(client){
            if(_.has(client, 'profile.plan.nextCycle')){
                return client.profile.plan.nextCycle
            } else {
                // Legacy client that doesn't have nextRenewal yet.
                // we have to calculate it
                    var CurrentDate = new Date();

                    CurrentDate = moment(CurrentDate).format("YYYY-MM-DD");

                    var now = moment(),
                            thisMonth = parseInt(now.month()) + 1,
                            thisYear = now.year();

                    var tmpDate = thisYear + "/" + thisMonth + "/" + client.profile.plan.retainerStart;

                    var RetainerDate = new Date(tmpDate);
                    RetainerDate = moment(RetainerDate).format("YYYY-MM-DD");

                    // Deterimine which month we should be getting our retainer renewal date from
                    if (moment(CurrentDate).unix() >= moment(RetainerDate).unix()) {
                        /* Current Period*/
                    } else {
                        /* Previous Period */
                        var now = new Date();
                        thisMonth = (now.getMonth() - 1) + 1;

                        if (thisMonth == 0) {
                            thisMonth = 12;
                            thisYear = parseInt(thisYear) - 1;
                        }

                    }

                   tmpDate = thisYear + "/" + thisMonth + "/" + client.profile.plan.retainerStart,
                   RetainerDate = new Date(tmpDate);

                    var nextRenewal = moment(RetainerDate).add(1,'months');

                return nextRenewal
            }

        }

        $scope.newClient = function(){
            clientDataService.clientDialog(clientDataService.newClient(), 'New Client Workspace');
        }

    }; //end clientController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('billingPeriodCard', billingPeriodCard);


     function billingPeriodCard() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: billingPeriodCardController,
         scope: {
           period: '=period',
           client: '=client'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/billing-period/billing-period-card.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function billingPeriodCardController($rootScope, $scope, $log, clientBillingService, userDataService) {
        var vm = this;
         vm.currency = "$";

         // set our currency if user has selected one
        if (_.has(userDataService.user.profile, 'settings.currency')){
             vm.currency = userDataService.user.profile.settings.currency;
         }

        vm.clientBillingService = clientBillingService;

        // NOTE we have vm.period and vm.client by default because it was passed in to "this" already

        // Select and display specific period
        vm.selectPeriod = function(){
            vm.clientBillingService.selectPeriod(vm.period);
        }

        // Calculate appropriate color flag depending on status
        vm.clientColor = function(){
            return vm.client.profile.clientColor
        }// vm.clientColor



        vm.isSelected = function(){
            if(vm.clientBillingService.selectedPeriod){
                if(vm.clientBillingService.selectedPeriod.uid == vm.period.uid){
                    return true
                }
            }
        }
        // Format label for period
        vm.periodLabel = function(){
            var label = "";
            label = moment(vm.period.start).format('MMMM YYYY');
            return label
        }// vm.periodLabel



        vm.used = function(){
            return vm.period.logged/60
            // var thisYear = moment(vm.period.start).format('YYYY'),
            //     thisMonth = moment(vm.period.start).format('M');

            //     if (vm.period.type == 'retainer'){
            //         // look for reports in the retainer path
            //         var totalsPath = "retainer_totals." + thisYear + ".monthly." + thisMonth + ".minutes";
            //     } else {
            //         // look for reports in the calendar path
            //         var totalsPath = "calendar_totals." + thisYear + ".monthly." + thisMonth + ".minutes";
            //     }


            // if (_.has(vm.client, totalsPath)) {
            //     //client has totalspath
            //     //Get the minutes logged this period
            //     if(vm.period.type == 'retainer'){
            //         // retainer client
            //         var used = vm.client.retainer_totals[thisYear]['monthly'][thisMonth]['minutes'] / 60 // MINUTES converted to hours
            //         return used
            //     } else {
            //         //Hourly client.
            //         var used = vm.client.calendar_totals[thisYear]['monthly'][thisMonth]['minutes'] / 60 // MINUTES converted to hours
            //         return used
            //     }

            // } else {
            //     //No totals yet. Return 0
            //     return 0
            // }
        }

        // selects which class our "used" value should get (default, orange, red)
        vm.retainerStatusClass = function(){
            var used = vm.used();
            if(vm.period.type == 'retainer'){
                if(vm.period.allocated < used){
                    return 'over'
                }
                if(used / vm.period.allocated > .75){
                    return 'almost'
                }
                if(used / vm.period.allocated < .75){
                    return 'under'
                }
            }// if type=retainer

        }// vm.statusClass

        // $log.info(vm.period);
       //  vm.currency = "$";
       //  // set our currency if user has selected one
       // if (_.has(userDataService.user.profile, 'settings.currency')){
       //      vm.currency = userDataService.user.profile.settings.currency;
       //  }



    }// controller



})();

(function() {
    'use strict';

    angular
        .module('app.authentication', [
        	'appServices'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('subConfirmController', subConfirmController);

    /* @ngInject */
    function subConfirmController($log, $scope, $rootScope, $state, $window) {
        // $log.info('subConfirmController');
        var vm = this;
        // vm.data = {};

        vm.returnToAdminja = function(){
          var returnURL = $rootScope.adminjaURL + '/#/';
          $window.location.href= returnURL;
        }

       }//subConfirmController



})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('registrationController', registrationController);

    /* @ngInject */
    function registrationController($log, $scope, $timeout, $state, $firebaseObject, $window, firebase, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService, timerDataService, clientDataService, teamDataService) {
      // // Make sure we are logged out from any previous attempts
      // userDataService.clearUserData();
      // timerDataService.clearTimerData();
      // clientDataService.clearClientData();
      firebase.auth().signOut()

        // $log.info('registrationController');
        var vm = this;
        // vm.data = {};
        vm.user = {};
        vm.isInvitationValid = false;
        // If the visitor reached the registration page from a pricing plan page, we probably passed the plan as an ID.
        // Get it so we know which checkout page to send them to.
        vm.planID = 'starter-2017b';
        if ($stateParams.planID){
          vm.planID = $stateParams.planID
        }
        if ($stateParams.inviteID){
          vm.inviteID = $stateParams.inviteID;

          var inviteRef = firebase.database().ref('teamInvites/');
            inviteRef.child(vm.inviteID).once('value', function(snapshot) {
              var exists = (snapshot.val() !== null);

              if(exists){
                vm.invitation = snapshot.val();
                // prepopulate our email
                vm.user.email = vm.invitation.invitee;
                // Change our flag so we show invitation info
                $timeout(function(){vm.isInvitationValid = true;},0);

              } else {
                $log.info('No invitation with that UID');
              }
            });

        }// if we have an inviteID




        /////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////
        // We need Chargebee loaded first. The entire registration function is wrapped in it
        // so it has access to chargebee's methods
        angularLoad.loadScript('https://js.chargebee.com/v1/chargebee.js').then(function() {
            // Script loaded succesfully.
            // $log.info('chargeBee Loaded');
            ChargeBee.configure({site: $rootScope.chargebeeSettings.site, api_key: $rootScope.chargebeeSettings.api_key});
            vm.registerUser =  function(user){
                 // $log.info('registerUser');

                 // Did they enter a valid activation code

                  // do registration
                  firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(_userData, error) {
                      // console.log("User " + _userData.uid + " created successfully", _userData);

                      // // get set to store our own userData
                      user.uid = _userData.uid;

                      _userData.sendEmailVerification();
                      var thisSource = undefined
                      // if we are accepting an invitation, the owner should be the source
                      if(vm.isInvitationValid){
                        thisSource = "Invited by " + vm.invitation.ownerEmail
                      } else {
                        thisSource = user.source
                      }

                      var newUserRecord = {
                          email: user.email,
                          uid: _userData.uid,
                          source: thisSource,
                          profile: {
                            onboardingFlags:{
                              hasCreatedClient: false
                            },
                            settings: {
                              currency: '$',
                              dateFormat: 'us',
                              startOfWeek: 0,
                              roundUpTo: 5,
                              pinMenu: true,
                              requireWorkDescription: true,
                              verticalProfilePanels: false,
                              verticalTaskPanels: true,
                              groupToday: true,
                              showTodayPanel: false,
                              hideCompletedPanel: false,
                              showTimerInSidebar: false
                            }
                          },
                          plan: {},
                          limits: {
                            clients: 2
                          },
                          type: 'customer',
                          originalPlan: vm.planID
                      }


                      newUserRecord.profile.avatar = "/assets/images/avatars/generic-avatar.png";
                      newUserRecord.profile.firstName = user.firstname;
                      newUserRecord.profile.lastName = user.lastname;
                      newUserRecord.profile.fullName = user.firstname + ' ' + user.lastname;
                      newUserRecord.profile.startDate = new Date().toISOString();


                      // Chargebee will update these properties after the subscription has been created
                      // but this can take up to 15-20 seconds.
                      // Pre-Setting these here ensures the user can login immediately without error
                      // as these props will be updated with correct plan via zapier.
                      newUserRecord.plan.content__subscription__plan_id = 'starter-2017b';
                      newUserRecord.plan.content__subscription__status = 'in_trial';
                      newUserRecord.plan.content__subscription__future_plan_id = vm.planID;
                      newUserRecord.plan.startDate = moment().toISOString();

                      // save our user record so our profile works correctly
                       var updates = {};
                       updates['users/' + _userData.uid] = newUserRecord;

                       // if we are creating an account from a valid invitation, we
                       // need to update the invite AND the team member on the owner's node


                       // Execute our update
                       return firebase.database().ref().update(updates)
                       .then(function(){
                         /// Drip Event
                         var registrationTags = ["Adminja Signup", vm.planID];
                         // If not a free plan, add an abandoned tag
                         // which will get removed out after they checkout
                         if (vm.planID != 'starter-2017b'){
                          registrationTags = ["Adminja Signup", vm.planID, 'abandoned-at-checkout'];
                         }


                         // // safe to use the function
                         //      _dcq.push(["identify", {
                         //       email: user.email,
                         //       first_name: user.firstname,
                         //       last_name: user.lastname,
                         //       initial_plan: vm.planID,
                         //       adminja_start_date: newUserRecord.plan.startDate,
                         //       // we need unix (i.e. a number) in order to do date range comparisons
                         //       adminja_unix_start_date: moment(newUserRecord.profile.startDate).unix(),
                         //       tags: registrationTags,
                         //       uid: user.uid,
                         //       source: user.source
                         //     }]);

                         //   window._dcq.push(["track", "New Adminja User"]);

                         //  // heap.track('User registered');

                         //  // Log the goal event with google
                         //  ga('send', {
                         //    hitType: 'event',
                         //    eventCategory: 'User',
                         //    eventAction: 'user-created',
                         //    plan: vm.planID,
                         //    source: user.source
                         //  });

                       // If there's a plan and the plan isn't a free one, send them to checkout
                       // if (vm.planID && vm.planID != 'starter-2017b'){
                       //  var userUrlParameters = "?subscription[id]="+ newUserRecord.uid + "&customer[cf_adminja_user_id]=" + newUserRecord.uid + "&billing_address[first_name]=" + newUserRecord.profile.firstName + "&billing_address[last_name]=" + newUserRecord.profile.lastName + "&customer[email]=" + newUserRecord.email;
                       //  // $log.info('userUrlParameters:' + userUrlParameters);
                       //  var checkoutURL = $rootScope.chargebeeSettings.checkoutURL + vm.planID + userUrlParameters;

                       //  // Clear our _userData so our listeners aren't fired
                       //    _userData = undefined;
                       //    firebase.auth().signOut();

                       //    // Go to our Chargebee Checkout page
                       //    $window.location.href = checkoutURL;


                       // } else { // They've selected a free account or are signing up without selecting a plan
                        // Create the subParam object to send to chargebee
                        var subParam = {};
                        subParam.customer = {};
                        subParam.customer.email = user.email;
                        subParam.customer.first_name = user.firstname;
                        subParam.customer.cf_adminja_user_id = newUserRecord.uid;
                        subParam.customer.last_name = user.lastname;
                        subParam.plan_id= vm.planID;
                        ChargeBee.subscription.create(subParam).request(apiResponseHandler);
                        // Clear our _userData so our listeners aren't fired
                        _userData = undefined;
                        firebase.auth().signOut();
                        // Set a flag for confirmation page to check
                        $rootScope.registered = true;
                        // If this is a new user accepting an invitation, update the invite with the UID and
                        // change the invite's status to accepted so the cloud function takes over.
                        if(vm.invitation){
                          teamDataService.acceptInvite(vm.invitation, newUserRecord.uid);
                        }
                        // Send user to confirmation
                        $state.go('authentication.confirmation');
                        // Appcues.show($rootScope.tutorials.appPrimer);
                       // }

                       });


                  }).catch(function(error) {
                      // console.log("Error: ", error);
                      $timeout(function(){
                       vm.errorMessage = "Woops! Somethings wrong. " + error.message;
                      });

                      vm.showError = true;
                      $log.info(error);
                      $mdToast.show(
                            $mdToast.simple()
                              .textContent(error.message)
                              .position('top center')
                              .hideDelay(3000)
                          );

                      // if user is not accepting an invitation, we should clear the email property
                      if(!vm.isInvitationValid){
                        user.email = "";
                      }

                      user.password = "";
                      user.passwordConfirm = "";
                  });


          }// end vm.regiseterUser

        }).catch(function() {
            // There was some error loading the chargebee script. Meh
            $log.error('Error loading chargebee script.')
        });


        //##ajax_error_handling_start##
        function subscribeErrorHandler(response) {
            try {
                // checking for param error
                if (response.error.error_param != null) {
                    var errorMap = {};
                    var errParam = response.error.error_param;
                    var errMsg = response.error.error_msg;
                    //handling customer[id] field error
                    if (errParam == "customer[id]" && response.error.error_code == "param_not_unique") {
                        errorMap["customer[email]"] = errMsg;
                    } else {
                        errorMap[errParam] = errMsg;
                    }
                    // $("#subscribe-form").validate().showErrors(errorMap);
                } else {
                    var errMsg = response.error.error_msg;
                    alert(errMsg);
                    // $(".alert-danger").show().text(errMsg);
                }
            } catch (err) {
                alert(errMsg);
                // $(".alert-danger").show().text("Error while processing your request");
            }
        }
        //##ajax_error_handling_end##

        function apiResponseHandler(status, response) {
            if (status != 200) {
                $('.subscribe_process').hide();
                subscribeErrorHandler(response);
            } else {

                //forming query parameter from API response to post on redirect url
                // var queryParameters = "name=" + encodeURIComponent(response.customer.first_name) +
                //         "&planId=" + encodeURIComponent(response.subscription.plan_id);
                // subscribeResponseHandler({"forward": "thankyou.html?" + queryParameters});
            }
        }

        //##ajax_redirect_start##
        function subscribeResponseHandler(responseJSON) {
            window.location.replace(responseJSON.forward);
        }
        //##ajax_redirect_end##



        ////////////// END CHARGEBEE HELPER FUNCTIONS /////////////////
        ////////////////////////////////////////////////////////////////




        // vm.user.activationError = false;


        // var checkActivation = function(input){
        //   var found = false;
        //   _.each($rootScope.activationCodes,function(code){
        //       if (code == input){
        //           found = true;
        //       }
        //   });
        //   return found
        // }// checkActivation

        // watch the password field and grade it.
        vm.checkStrength = function(password){

          // var regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}/;
          // vm.passwordMessage = "Minimum of 6 characters";
          // vm.passwordStrength = 'weak';
          // var validPassword = regExp.test(password);

          //     if (vm.user.password.length > 8 & validPassword) {
          //         vm.passwordStrength = 'strong';
          //         vm.passwordMessage = "Now that's a strong password!"
          //     } else if (vm.user.password.length > 5) {
          //         vm.passwordStrength = 'medium';
          //         vm.passwordMessage = "There ya go!";
          //     } else if (vm.user.password.length >3){
          //         vm.passwordMessage = "That's not enough"
          //     }else {
          //         vm.passwordStrength = 'weak';
          //         vm.passwordMessage = "Minimum of 6 characters";
          //     }
        }


        vm.passwordLength = function(password){
          return password.length
        };





       }

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('confirmationController', confirmationController);

    /* @ngInject */
    function confirmationController($log, $scope, $timeout, $state, $window, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService) {
        // $log.info('confirmationController');
        var vm = this;
        // vm.data = {};

        // Look for flag that we got here from a successful registration
        // if not, redirect to registration
        vm.registered = $rootScope.registered;
        if(!vm.registered){
            $state.go('authentication.registration');
        }
       }

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('profileController', profileController);

    /* @ngInject */
    function profileController($log, $rootScope, $timeout, $state, $stateParams, $scope, userDataService, gateService, _userData) {
        var vm = this;
        // we stored this minor variable globally onAuthStateChagne
        vm.emailVerified = $rootScope.emailVerified;
        vm.user = _userData;
        vm.gates = gateService.gateData;

        if(_.has($stateParams, 'selectedTab')){
            vm.selectedTab = $stateParams.selectedTab;

        }
        // $log.info('profileController');
        vm.countries = [
        {name: 'US'},
        {name: 'CA'},
        {name: 'UK'},
        {name: 'EU'},
        {name: 'AU'},
        {name: 'SA'},
        {name: 'AF'}

        ]



        vm.cancelProfile = function(){
            $state.go('triangular.dashboard');
        };// vm.cancelProfile

        vm.removeLogo = function(){
            vm.user.profile.logo = undefined;
        };

        vm.updateUser = function(user){
            vm.updating = true;
            // $log.info(user);
            $timeout(function(){
                userDataService.updateUser(user);
            }, 2000)
            .then(function(){
                vm.profileForm.$pristine = true;
                vm.updating = false;
            })

        }// vm.updateUser

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);

            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             vm.user.profile.avatar = uploadTask.snapshot.downloadURL;
                             vm.profileForm.$pristine = false;
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar

        vm.uploadLogo = function($files) {
            // $log.info('upload logo');
            // $log.info($files);
            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userLogo.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child(vm.user.uid + '/files/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             $timeout(function(){
                                vm.user.profile.logo = uploadTask.snapshot.downloadURL;
                            },0);

                             vm.profileForm.$pristine = false;
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadLogo
    }// profileController
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('LoginController', LoginController);


        /* @ngInject */
    function LoginController($timeout, $log, $mdToast,  $window, timerDataService, userDataService,  clientDataService, $rootScope, triLoaderService, $state, $stateParams, triSettings, $scope, authFactory, $location, localStorageService) {



        var vm = this;
        vm.showError = false;
        vm.showLogin = true;
        // on $rootScope so our onAuthStateChanged function in app.module has access to it
        $rootScope.rememberMe = false;
        userDataService.clearUserData();
        timerDataService.clearTimerData();
        clientDataService.clearClientData();
        // clear out ghost User if we are logged in as one
        localStorageService.remove('ghostUser');
        firebase.auth().signOut()
        .then(function(){
            // make sure we've wiped out any previous sessions
            vm.showLogin = true;
        });


        vm.socialLogins = [{
            icon: 'fa fa-twitter',
            color: '#5bc0de',
            url: '#'
        },{
            icon: 'fa fa-facebook',
            color: '#337ab7',
            url: '#'
        },{
            icon: 'fa fa-google-plus',
            color: '#e05d6f',
            url: '#'
        },{
            icon: 'fa fa-linkedin',
            color: '#337ab7',
            url: '#'
        }];
        vm.triSettings = triSettings;
        // create blank user variable for login form
        vm.user = {
            email: '',
            password: ''
        };

        // vm.errorMessage = "Oops! We don't have an account by that email address. Please try again.";

        vm.loginClick = function(){
            vm.loggingIn = true;
            $log.info('login Clicked');
            // Make sure all data from previous session is cleared in case someone logged in
            // without logging out of a different account previously
            timerDataService.clearTimerData();
            userDataService.clearUserData();
            clientDataService.clearClientData();

            // Logs user into firebase. Nothing more.
            // Auth listener (in app.module) will notice login change and trigger data loading/unloading.
            var ref = firebase.auth();
            ref.signInWithEmailAndPassword(vm.user.email, vm.user.password)
            .then(function(authData){
                // heap.track('Logged In');
                console.log('login.controller: logged in successfully');
                // put it in localStorage so we can persist refreshes
                localStorageService.set('userID', authData.uid);
                $rootScope.userID = authData.uid;


                // Setup lastLogin
                var lastLogin = moment().toISOString(),
                    lastLoginUnix = moment().unix();


                // // Let Groove know
                // var grooveUser = {
                //     'email': authData.email,
                //     'lastLogin': lastLogin,
                //     'lastLoginUnix' : lastLoginUnix
                // };

                // groove.widget('setCustomer', grooveUser);

                // Let Drip Knkow
                // $log.info(authData.email);
                // _dcq.push(["identify", {
                //         'email': authData.email,
                //         'user_id': authData.uid,
                //         'lastLogin' : lastLogin,
                //         'lastLoginUnix' : lastLoginUnix

                //     }]);
                // // track our event
                // _dcq.push(["track", "Logged In", {value:0}]);

                // Let heap know who this is
                // heap.identify(authData.email);
                // heap.addUserProperties({
                //         'lastLogin': lastLogin,
                //         'lastLoginUnix' : lastLoginUnix
                //     });

                // // Log the last login with appcues
                // Appcues.identify(authData.uid, {
                //     'lastLogin': lastLogin,
                //     'lastLoginUnix' : lastLoginUnix
                // });


                // update our lastLogin in firebase
                firebase.database().ref('users/' + authData.uid + '/lastLogin').set(lastLogin)
                .then(function(){
                    $state.go('triangular.dashboard');
                });

            })
            .catch(function(error){
                $log.info('error!');
                var errorCode = error.code;
                  var errorMessage = error.message;
                $log.info(errorCode, errorMessage);
                vm.loggingIn = false;
                // display firebase error message and reset email and password
                    // $mdToast.show(
                    //       $mdToast.simple()
                    //         .textContent(error.message)
                    //         .position('top center')
                    //         .hideDelay(3000)
                    //     );


                    if(error.code == 'auth/user-not-found'){

                        $timeout(function(){
                            vm.errorMessage = "Oops! We don't have an account by that email address. <br> Please try again."
                        },0)

                    } else if (error.code =='auth/wrong-password'){
                        $timeout(function(){
                            vm.errorMessage = "Oops! That's not the right password. <br>Please try again."
                        },0)
                    }
                    else {

                        $timeout(function(){
                            vm.errorMessage = error.message;
                        },0)
                    }

                    vm.showError = true;

                    // vm.user.email = '';
                    // vm.user.password = '';
            });
        }

        vm.logoutClick = function(){
            firebase.auth().signOut().then(function() {
                // delete $rootScope.authData;
                // delete $rootScope._userData;
              // Sign-out successful.
              // heap.track('Logged Out');
              console.log('login.controller logoutClick successful.');
              $state.go('authentication.login')
            }, function(error) {
              // An error happened.
                console.log('login.controller logoutClick FAILED.');
                console.error(error);
                vm.errorMessage = error.message;
            });
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('LockController', LockController);

    /* @ngInject */
    function LockController($state, triSettings) {
        var vm = this;
        vm.loginClick = loginClick;
        vm.user = {
            name: 'Morris Onions',
            email: 'info@oxygenna.com',
            password: ''
        };
        vm.triSettings = triSettings;

        ////////////////

        // controller to handle login check
        function loginClick() {
            // user logged in ok so goto the dashboard
            $state.go('triangular.admin-default.dashboard-general');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('legalController', legalController);

    /* @ngInject */
    function legalController($log, $timeout, $state, $scope) {
        var vm = this;


        vm.cancelLegal = function(){
            $state.go('triangular.dashboard');
        };// vm.cancelProfile


    }// legalController
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('ForgotController', ForgotController);

    /* @ngInject */
    function ForgotController($scope, $state, $mdToast, $filter, $http, triSettings, API_CONFIG) {
        var vm = this;
        vm.triSettings = triSettings;
        vm.user = {
            email: ''
        };
        vm.resetClick = resetClick;



        function resetClick() {
            var email = vm.user.email;

            firebase.auth().sendPasswordResetEmail(email).
            then(function() {

                $mdToast.show(
                    $mdToast.simple()
                    .content($filter('translate')('FORGOT.MESSAGES.RESET_SENT') + ' ' + email)
                    .position('bottom right')
                    .action($filter('translate')('FORGOT.MESSAGES.LOGIN_NOW'))
                    .highlightAction(true)
                    .hideDelay(0)
                ).then(function() {
                    $state.go('public.auth.login');
                });
            }).catch(function(error) {
                var errorCode       = error.code;
                var errorMessage    = error.message;

                if (errorCode == 'auth/invalid-email') {
                    alert(errorMessage);
                } else if (errorCode == 'auth/user-not-found') {
                    alert(errorMessage);
                }

                console.log(error);

                $mdToast.show(
                    $mdToast.simple()
                    .content($filter('translate')('FORGOT.MESSAGES.NO_RESET') + ' ' + email)
                    .position('bottom right')
                    .hideDelay(5000)
                );
            })
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('app.authentication')
    .controller('changeEmailController', changeEmailController);

    /* @ngInject */
    function changeEmailController($log, $timeout, $scope, $state, $mdToast, userDataService, _userData) {
        // $log.info('changeEmailController');
        var vm = this;
        vm.user = _userData;

        vm.changeEmail = function(newEmail){
            var user = firebase.auth().currentUser;
            user.updateEmail(newEmail).then(function() {
                var userRef = firebase.database().ref('users/' + user.uid);
                // save the previous email
                userRef.child('oldEmail').set(vm.user.email);
                // update actual email with new one
                userRef.child('email').set(newEmail);

              // Update successful.
              // $log.info('success!');
              // An error happened.
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Woohoo! Your login has changed!',
                          message: 'You will need to login again.',
                          color: '#128B04'
                      }
                  }));
              $timeout(function(){
                $state.go('authentication.login');
              },1000);

            }, function(error) {
              // An error happened.
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Oops! Something went wrong!',
                          message: 'Please login again and try again.',
                          color: 'red'
                      }
                  }));
              $log.info('update email fail!');
              $log.info(error);
            });
        }

     }// changeEmailController
    })();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('cancelController', cancelController);

    /* @ngInject */
    function cancelController($log, $scope, $timeout, $state, $window, firebase, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService, timerDataService, clientDataService, _userData) {
        // $log.info('cancelController');
        var vm = this;
        // vm.data = {};
        vm.user = _userData;

        // Some rare accounts don't have this property
        // so we check and use a less accurate one if that's the case
        if(_.has(vm.user.plan, 'content__subscription__started_at')){
          var subStarted = vm.user.plan.content__subscription__started_at;
        } else {
          var subStarted = vm.user.plan.startDate
        }

        function init(){
          vm.request = {
            userID: vm.user.uid,
            name: vm.user.profile.fullName,
            email: vm.user.email,
            plan: vm.user.plan.content__subscription__plan_id,
            date: moment().toISOString(),
            started: subStarted
          };
        }

        init();

        vm.selectAction = function(action){
          vm.request.action = action;
        }

        vm.isSelected = function(state){
          if (vm.request.action == state){
            return true
          } else {
            return false
          }
        }// vm.isSelected

        vm.submitRequest = function(){
          vm.processing = true;
          var newKey = firebase.database().ref().child('intervention-requests/').push().key;

          vm.request.uid = newKey;
          var updates = {};

          updates['/intervention-requests/' + newKey] = vm.request;

          return firebase.database().ref().update(updates)
                  .then(function () {
                    $timeout(function(){
                      vm.showConfirm = true;
                    },0);

                  });

        }// vm.submitRequest

        vm.resetRequest = function(){
          delete vm.processing;
          delete vm.selectedState;
          delete vm.showConfirm;
          delete vm.request;
          delete vm.continue
          init();
        }

       }//cancelController



})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('confirmationController', confirmationController);

    /* @ngInject */
    function confirmationController($log, $scope, $timeout, $state, $window, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService) {
        // $log.info('confirmationController');
        var vm = this;
        // vm.data = {};

        // Look for flag that we got here from a successful registration
        // if not, redirect to registration
        vm.registered = $rootScope.registered;
        if(!vm.registered){
            $state.go('authentication.registration');
        }
       }

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('setupProfileController', setupProfileController);

    /* @ngInject */
    function setupProfileController($log, $timeout, $state, $scope, userDataService, _userData) {
        var vm = this;
        vm.user = _userData;

        // if we don't have user.settings, create the node so our form doesnt fail
        if (!vm.user.settings){
            vm.user.settings = {};
        }
        vm.updating = false;
        if (vm.user.profile != undefined){
            // vm.user.profile.dob = new Date(vm.user.profile.dob);
        }
        vm.countries = [
        {name: 'US'},
        {name: 'CA'},
        {name: 'UK'},
        {name: 'EU'},
        {name: 'AU'},
        {name: 'SA'},
        {name: 'AF'},

        ]


        vm.cancelProfile = function(){
            $state.go('triangular.dashboard');
        };// vm.cancelProfile

        vm.updateUser = function(user){
            vm.updating = true;
            // $log.info(user);
            $timeout(function(){
                userDataService.updateUser(user);
            }, 2000)
            .then(function(){
                vm.profileForm.$pristine = true;
                vm.updating = false;
            })

        }// vm.updateUser

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);

            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             vm.user.profile.avatar = uploadTask.snapshot.downloadURL;
                             vm.profileForm.$pristine = false;
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar
    }// profileController
})();

(function() {
    'use strict';

    angular
        .module('adminSetup', [
        	'appServices'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('adminSetup')
        .controller('setupClientsController', setupClientsController);

    /* @ngInject */
    function setupClientsController($scope, $state, $mdToast, $log, clientDataService, $timeout, $filter, $rootScope, _userData, _clientData) {
        var vm = this;
        vm.user = _userData;
        vm.clients = _clientData;
        vm.clientTemplate = {
            owner: vm.user.uid,
            status: 'active',
            profile: {
                firstname: '',
                lastname: '',
                email: '',
                plan:{
                    cost: '',
                    allocated: '',
                    retainerStart:'',
                    rate:'',
                    type:'retainer'
                }

            },

            access:{
                users:{},
                admins: {}
            },
            panels: {}
        };
        vm.clientLimit=3;
        vm.showColors = false;
        vm.clientColors = $rootScope.clientColors;

        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }


        init();

        function init(){
            // add assignment properties to our model
            vm.clientTemplate.order = _.size(vm.clients)+1;
            vm.newClient = angular.copy(vm.clientTemplate);
            // $log.info(vm.newClient);
            vm.newClient.access.users[vm.user.uid] = true;
            vm.newClient.access.admins[vm.user.uid] = true;
            // Cursor in Name field to prompt new user
            focusClientName();
            vm.numClients = _.size(vm.clients);
         }


        function focusClientName(){
              $timeout(function () {
                document.getElementById("focusfield").focus();
            }, 3000, false);
        }


        function resetForm(){
            // $log.info('resetForm');
            $timeout(function() {
                // reset our form flags
                vm.clientForm.$setPristine();
                vm.clientForm.$setUntouched();
                vm.clientForm.$submitted = false;

               });
            // setup for a new client
            init();
        }

        vm.continue = function(){

            $state.go('triangular.dashboard');

        }

        vm.deleteClient = function(client){
            clientDataService.deleteClient(client);
            clientDataService.setupClientMenu(true);
        }

        vm.addClient = function(client){
            return clientDataService.saveNewClient(client).then(function() {
                clientDataService.setupClientMenu(true);
                resetForm();
            });
        }

        vm.colorChange = function(form) {
            // $log.info('color changed');
            form.$setDirty();
            vm.toggleColors();
        };

        vm.toggleColors = function(){
            if (vm.showColors){
                vm.showColors = false;
            } else {
                vm.showColors = true;
            }
        }

        vm.hasClients = function(){
            if(_.size(vm.clients)){
                return true
            } else{
                return false
            }
        }

        vm.canAddNew = function(){
            if (_.size(vm.clients) < vm.clientLimit){
                return true
            } else {
                return false
            }
        }

    }// setupClientController
})();

!function(a,b){"function"==typeof define&&define.amd?define(["moment"],function(c){return a.DateRange=b(c)}):"object"==typeof exports?module.exports=b(require("moment")):a.DateRange=b(moment)}(this,function(a){function b(b,c){var d,e=b,f=c;(1===arguments.length||void 0===c)&&("object"==typeof b&&2===b.length?(e=b[0],f=b[1]):"string"==typeof b&&(d=b.split("/"),e=d[0],f=d[1])),this.start=a(null===e?-864e13:e),this.end=a(null===f?864e13:f)}function c(b,c,d){for(var e=a(this.start);this.contains(e,d);)c.call(this,e.clone()),e.add(1,b)}function d(b,c,d){var e=this/b,f=Math.floor(e);if(f!==1/0){f===e&&d&&f--;for(var g=0;f>=g;g++)c.call(this,a(this.start.valueOf()+b.valueOf()*g))}}var e={year:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0};return b.prototype.constructor=b,b.prototype.clone=function(){return a().range(this.start,this.end)},b.prototype.contains=function(a,c){var d=this.start,e=this.end;return a instanceof b?d<=a.start&&(e>a.end||e.isSame(a.end)&&!c):a>=d&&(e>a||e.isSame(a)&&!c)},b.prototype.overlaps=function(a){return null!==this.intersect(a)},b.prototype.intersect=function(a){var c=this.start,d=this.end;return c<=a.start&&a.start<d&&d<a.end?new b(a.start,d):a.start<c&&c<a.end&&a.end<=d?new b(c,a.end):a.start<c&&d>=c&&d<a.end?this:c<=a.start&&a.start<=a.end&&a.end<=d?a:null},b.prototype.add=function(c){return this.overlaps(c)?new b(a.min(this.start,c.start),a.max(this.end,c.end)):null},b.prototype.subtract=function(a){var c=this.start,d=this.end;return null===this.intersect(a)?[this]:a.start<=c&&d>c&&d<=a.end?[]:a.start<=c&&c<a.end&&a.end<d?[new b(a.end,d)]:c<a.start&&a.start<d&&d<=a.end?[new b(c,a.start)]:c<a.start&&a.start<a.end&&a.end<d?[new b(c,a.start),new b(a.end,d)]:c<a.start&&a.start<d&&a.end<d?[new b(c,a.start),new b(a.start,d)]:void 0},b.prototype.toArray=function(a,b){var c=[];return this.by(a,function(a){c.push(a)},b),c},b.prototype.by=function(a,b,e){return"string"==typeof a?c.call(this,a,b,e):d.call(this,a,b,e),this},b.prototype.toString=function(){return this.start.format()+"/"+this.end.format()},b.prototype.valueOf=function(){return this.end-this.start},b.prototype.center=function(){var b=this.start+this.diff()/2;return a(b)},b.prototype.toDate=function(){return[this.start.toDate(),this.end.toDate()]},b.prototype.isSame=function(a){return this.start.isSame(a.start)&&this.end.isSame(a.end)},b.prototype.diff=function(a){return this.end.diff(this.start,a)},a.range=function(c,d){return c in e?new b(a(this).startOf(c),a(this).endOf(c)):new b(c,d)},a.range.constructor=b,a.fn.range=a.range,a.fn.within=function(a){return a.contains(this._d)},b});

angular.module("dropbox-picker", []).provider("DropBoxSettings", function() {
    this.box_linkType = 'shared', this.box_multiselect = 'true', this.box_clientId = null, this.linkType = 'preview', this.multiselect = false, this.extensions = ['.pdf', '.doc', '.docx'], this.$get = function() {
        return {
            linkType: this.linkType,
            multiselect: this.multiselect,
            extensions: this.extensions,
            box_linkType: this.box_linkType,
            box_multiselect: this.box_multiselect,
            box_clientId: this.box_clientId

        }
    },
    this.configure = function(e) {
        for (key in e) this[key] = e[key]
    }

})
.directive("dropBoxPicker", ["DropBoxSettings",
            function(DropBoxSettings) {
    return {
        restrict: "A",
        scope: {
            dbpickerFiles: "=",
            counter: "=",
            form: "="
        },
        link: function(scope, element, attrs) {
            function instanciate() {
                Dropbox.choose(dropboxOptions);
            }
            var dropboxOptions = {
                success: dropboxsuccess,
                cancel: function() {},
                linkType : DropBoxSettings.linkType,
                multiselect: DropBoxSettings.multiselect,
                extensions : DropBoxSettings.extensions,
            };
            function dropboxsuccess(files){
                scope.$apply(function() {
                    for (var i = 0; i < files.length; i++){
                        // For Amdinja - convert to normalized file structure
                            var fileObject = {
                                fileName: files[i].name,
                                url: files[i].link,
                                source: 'dropbox'
                            }
                            // Push onto our bound model

                                scope.dbpickerFiles.push(fileObject);
                                scope.counter = scope.counter + 1;
                                scope.form.$setDirty();


                        // End Adminja Customization

                        // Original push
                        // scope.dbpickerFiles.push(files[i]);
                    }
                });
            };
            element.bind("click", function() {
                instanciate()
            })
        }
    }
}])
.directive("boxPicker", ["DropBoxSettings",
            function(DropBoxSettings) {
    return {
        restrict: "A",
        scope: {
            boxpickerFiles: "="
        },
        link: function(scope, element, attrs) {
            function instanciate() {
                var success = false;
                var boxSelect = new BoxSelect(boxoptions);
                boxSelect.launchPopup();
                boxSelect.success(function(files) {
                    if(!success){
                        boxSelect.closePopup();
                        scope.$apply(function() {
                            for (var i = 0; i < files.length; i++){
                                scope.boxpickerFiles.push(files[i]);
                            }
                        });
                        //boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, successCallbackFunction);
                        success = true
                    }
                });
                boxSelect.cancel(function() {
                    console.log("The user clicked cancel or closed the popup");
                    boxSelect.closePopup();
                });
            }

            function successCallbackFunction(){
                boxSelect.closePopup();
            }

            var boxoptions = {
                clientId: DropBoxSettings.box_clientId,
                linkType: DropBoxSettings.box_linkType,
                multiselect: DropBoxSettings.box_multiselect
            };
            element.bind("click", function() {
                instanciate()
            })
        }
    }
}]);


(function() {
  'use strict';


})();

//These are general utilities that are NOT app specific and may used for other apps
var ajUTILITIES = (function () {
    'use strict';

    var my = {};
    // abstract localstorage calls set/get
    Storage.prototype.setObject = function(key, value) {
        this.setItem(key, JSON.stringify(value));
    }

    Storage.prototype.getObject = function(key) {
        var value = this.getItem(key);
        return value && JSON.parse(value);
    }

    my.isDefined = function (variable)	{

        if (typeof variable === 'undefined' || variable === null) {
            return false;
        }
        else {
            return true;
		}
    };

    my.removePropertiesWith = function(obj, remove) {

        // for (var p in obj) {
        //     if (p[0] === '$')
        //         delete obj[p];
        // }

        Object.keys(obj).forEach(function(p) {
            if (p[0] === '$')
                delete obj[p];
        });

        return obj;
    };

    my.mapValidProperties = function(origObj, strInvalid) {


        var newObj = Object.keys(origObj).reduce(function(previous, current) {
            if (current[0] !== strInvalid) {
                previous[current] = origObj[current];
            }
            return previous;
        }, {});

        return newObj;
    }

    my.lightenDarkenColor = function(col, amt){
        var usePound = false;
        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }
        var num = parseInt(col, 16);
        var r = (num >> 16) + amt;
        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }
        var b = ((num >> 8) & 0x00FF) + amt;
        if (b > 255) {
            b = 255;
        } else if (b < 0) {
            b = 0;
        }
        var g = (num & 0x0000FF) + amt;
        if (g > 255) {
            g = 255;
        } else if (g < 0) {
            g = 0;
        }
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }



    return my;
})();

(function() {
    'use strict';

    angular
        .module('triangular')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $timeout, $window) {
        // add a class to the body if we are on windows
        if($window.navigator.platform.indexOf('Win') !== -1) {
            $rootScope.bodyClasses = ['os-windows'];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular')
        .provider('triSettings', settingsProvider);

    /* @ngInject */
    function settingsProvider() {
        // Provider
        var settings = {
            languages: [],
            name: '',
            logo: '',
            copyright: '',
            version: ''
        };

        this.addLanguage = addLanguage;
        this.setLogo = setLogo;
        this.setName = setName;
        this.setCopyright = setCopyright;
        this.setVersion = setVersion;

        function addLanguage(newLanguage) {
            settings.languages.push(newLanguage);
        }

        function setLogo(logo) {
            settings.logo = logo;
        }

        function setName(name) {
            settings.name = name;
        }

        function setCopyright(copy) {
            settings.copyright = copy;
        }

        function setVersion(version) {
            settings.version = version;
        }

        // Service
        this.$get = function() {
            return {
                languages: settings.languages,
                name: settings.name,
                copyright: settings.copyright,
                logo: settings.logo,
                version: settings.version,
                defaultSkin: settings.defaultSkin
            };
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular')
        .config(routeConfig);

    /* @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
        .state('triangular', {
            abstract: true,
            // customized for Adminja
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            },
            views: {
                'root': {
                    templateUrl: 'app/triangular/layouts/states/triangular/triangular.tmpl.html',
                    controller: 'TriangularStateController',
                    controllerAs: 'stateController'
                },
                'sidebarLeft@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.sidebarLeftTemplateUrl)) {
                            return $templateRequest(triLayout.layout.sidebarLeftTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.sidebarLeftController;
                    },
                    controllerAs: 'vm'
                },
                'sidebarRight@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.sidebarRightTemplateUrl)) {
                            return $templateRequest(triLayout.layout.sidebarRightTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.sidebarRightController;
                    },
                    controllerAs: 'vm'
                },
                'toolbar@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.toolbarTemplateUrl)) {
                            return $templateRequest(triLayout.layout.toolbarTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.toolbarController;
                    },
                    controllerAs: 'vm'
                },
                'loader@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.loaderTemplateUrl)) {
                            return $templateRequest(triLayout.layout.loaderTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.loaderController;
                    },
                    controllerAs: 'loader'
                }
            }
        });


    }// routeConfig

})();

(function() {
    'use strict';

    angular
        .module('app.translate', [
            'pascalprecht.translate',
            'LocalStorageModule'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.translate')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, triSettingsProvider) {
        var appLanguages = [{
            name: 'Chinese',
            key: 'zh'
        },{
            name: 'English',
            key: 'en'
        },{
            name: 'French',
            key: 'fr'
        },{
            name: 'Portuguese',
            key: 'pt'
        }];

        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a i18n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        // setup available languages in angular translate & triangular
        var angularTranslateLanguageKeys = [];
        for (var language in appLanguages) {
            // add language key to array for angular translate
            angularTranslateLanguageKeys.push(appLanguages[language].key);

            // tell triangular that we support this language
            triSettingsProvider.addLanguage({
                name: appLanguages[language].name,
                key: appLanguages[language].key
            });
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
            'en_US': 'en',
            'en_UK': 'en'
        })
        .use('en');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .factory('UserService', UserService);

    /* @ngInject */
    function UserService($q, $http, RoleStore, firebaseUrl, $firebaseAuth) {
        // var currentUser = {
        //     displayName: 'Christos',
        //     username: 'christos',
        //     avatar: 'assets/images/avatars/avatar-5.png',
        //     roles: ['SUPERADMIN']
        // };

        var service = {
            getCurrentUser: getCurrentUser,
            getUsers: getUsers,
            hasPermission: hasPermission,
            login: login,
            auth: auth
        };

        return service;

        ///////////////

        function getCurrentUser() {
            // return currentUser;
        }

        function getUsers() {
            return $http.get('app/permission/data/users.json');
        }

        function hasPermission(permission) {
            var deferred = $q.defer();
            var hasPermission = false;

            // check if user has permission via its roles
            angular.forEach(currentUser.roles, function(role) {
                // check role exists
                if(RoleStore.hasRoleDefinition(role)) {
                    // get the role
                    var roleDef = RoleStore.getRoleDefinition(role);
                    // check if the permission we are validating is in this role's permissions
                    if(-1 !== roleDef.permissionNames.indexOf(permission)) {
                        hasPermission = true;
                    }
                }
            });

            // if we have permission resolve otherwise reject the promise
            if(hasPermission) {
                deferred.resolve();
            }
            else {
                deferred.reject();
            }

            // return promise
            return deferred.promise;
        }

        function auth() {
            var ref = firebase.auth();
            return $firebaseAuth(ref);
        }

        function login(username) {

            // you would replace the code below with a call you your API
            // request all users

            // return getUsers()
            // .then(function successCallback(response) {
            //     var returnUser = getCurrentUser();
            //     angular.forEach(response.data, function(user) {
            //         if(user.username === username) {
            //             returnUser = user;
            //             currentUser = user;
            //         }
            //     });
            //     return returnUser;
            // });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .run(permissionRun);


    function permissionRun($rootScope, $cookies, $state, RoleStore, UserService) {
        // normally this would be done at the login page but to show quick
        // demo we grab username from cookie and login the user
        var cookieUser = $cookies.get('tri-user');
        if(angular.isDefined(cookieUser)) {
            UserService.login(cookieUser);
        }

        // create roles for app
        RoleStore
        .defineRole('SUPERADMIN', ['viewEmail', 'viewGitHub', 'viewCalendar', 'viewLayouts', 'viewTodo', 'viewElements', 'viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('ADMIN', ['viewLayouts', 'viewTodo', 'viewElements', 'viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('USER', ['viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('ANONYMOUS', [], checkRole);


        ///////////////////////

        // default redirect if access is denied
        function accessDenied() {
            $state.go('401');
        }

        // function that calls user service to check if permission is allowed
        function checkRole(permission, transitionProperties) {
            return UserService.hasPermission(permission, transitionProperties);
        }

        // watches

        // redirect all denied permissions to 401
        var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

        // remove watch on destroy
        $rootScope.$on('$destroy', function() {
            deniedHandle();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .config(permissionConfig);

    /* @ngInject */
    function permissionConfig($stateProvider, triMenuProvider) {
        $stateProvider
        .state('triangular.permission', {
            url: '/permission',
            templateUrl: 'app/permission/pages/permission.tmpl.html',
            controller: 'PermissionController',
            controllerAs: 'vm',
            resolve: {
                users: ['UserService', function(UserService) {
                    return UserService.getUsers();
                }]
            },
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-define', {
            url: '/permission/define',
            templateUrl: 'app/permission/pages/permission-define.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-routes', {
            url: '/permission/routes',
            templateUrl: 'app/permission/pages/permission-routes.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-views', {
            url: '/permission/views',
            templateUrl: 'app/permission/pages/permission-views.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        });

        // triMenuProvider.addMenu({
        //     name: 'Permissions',
        //     icon: 'zmdi zmdi-lock',
        //     type: 'dropdown',
        //     priority: 100,
        //     children: [{
        //         name: 'Permissions',
        //         state: 'triangular.permission',
        //         type: 'link'
        //     },{
        //         name: 'Define Roles',
        //         state: 'triangular.permission-define',
        //         type: 'link'
        //     },{
        //         name: 'Routes',
        //         state: 'triangular.permission-routes',
        //         type: 'link'
        //     },{
        //         name: 'Views',
        //         state: 'triangular.permission-views',
        //         type: 'link'
        //     }]
        // });
    }
})();

(function(){
	'use strict';
	angular.module('appServices')
	.service('toastService', ['$rootScope', '$document', '$mdToast', function($rootScope,$document, $mdToast) {
		return {
			toast: function(msg){
				// console.log('toastservice: ' + msg);
				$mdToast.show($mdToast.simple().textContent(msg));
				// $mdToast.simple().content(msg);
			}
		};
	}])
})();

(function(){
	'use strict';
	angular.module('appServices')
	.service('templateDataService', templateDataService);

	templateDataService.$inject = ['$http'];

	function templateDataService($http) {
		var service = {
			getTemplates: getTemplates,
			getTemplate: getTemplate,
			addTemplate: addTemplate,
			removeTemplate: removeTemplate,
			updateTemplate: updateTemplate
		};

		return service;

		function getTemplates() {
			return $http.get('/assets/app-sample-data/templates.json')
	           .then(getTemplatesComplete)
	           .catch(getTemplatesFailed);

	       function getTemplatesComplete(response) {
	           return response.data;
	       }

	       function getTemplatesFailed(error) {
	           logger.error('XHR Failed for getTemplates.' + error.data);
	       }
		};// End getTemplates

		function getTemplate() {};// end getTemplate
		function addTemplate() {};// end addTemplate
		function removeTemplate() {};// end removeTemplate
		function updateTemplate() {};// end updateTemplate

	};



	})
();



(function(){
	'use strict';
	angular.module('appServices')
	.factory('$exceptionHandler',
	          ['$window', '$log', '$injector',
	  function ($window,  $log, $injector) {

		// Putting the injecting into a function so it can be called lazily and avoid circular references
		// http://stackoverflow.com/questions/33463300/angular-circular-dependency-injector-whie-trying-inject-modal-to-exception-ha?noredirect=1&lq=1

	    if ($window.Raven && location.hostname != "localhost") {
	      console.log('Using the RavenJS exception handler.');
	      // var Auth = $injector.get('Auth');
	      return function (exception, cause) {
	        $log.error.apply($log, arguments);
	        Raven.captureException(exception, {tags: { cause: cause }});
	      };
	    } else {
	      console.log('Using the default logging exception handler.');
	      return function (exception, cause) {
	        $log.error.apply($log, arguments);
	      };
	    }
	  }
	]);

})();

(function() {
    'use strict';

    angular.module('appServices')
		.service('rrule', rruleService)

/* @ngInject */
function rruleService($window) {
  if(!$window.rrule){
    // If lodash is not available you can now provide a
    // mock service, try to load it from somewhere else,
    // redirect the user to a dedicated error page, ...
  }
  return $window.rrule
}

})();

(function(){
	'use strict';
	angular.module('appServices')
	/* @ngInject */
	.service('pageDimensionsService', function($window,$timeout, $log, $state) {
		return {
			resizeColumns: function(mode){
				// Place it in a $timeout so we don't execute the script before the DOM is ready
				    var setWidth = function() {
				    	var containers = $('.app-item-container-items');
				    	// cycle through our containers and resize them to accommodate if they have children
				    	angular.forEach(containers, function(container) {
				        // If we have children,
				        //Calculate parent's newWidth based on the lasChild's position and width
				        if ($(container).find('md-card').length){
					        	// Get the last child in the set to determine how large the
					        	// parent container should be
					        	var lastChild = $(container).children().last();
						     var newWidth = lastChild.position().left + lastChild.outerWidth(true) - 2;
					        // Set the width
					        if(newWidth > 200){
					        	$(container).width(newWidth);
					        } else {
					        	$(container).width('auto');
					        }

				        }
				        // console.log('Width Changed');
				    	});
				    };

		    		    var setHeight = function() {
		    		    		var w = angular.element($window),
		    		    			removeHeight = 100;

		    		    	   removeHeight = removeHeight + $('md-toolbar').height();

		    		    	   // if we are managing team members, we need a different removeHeight
		    		    	   if($state.current.name == 'triangular.manage-team'){
		    		    	   	removeHeight = removeHeight - 49;
		    		    	   }

		    		    	   if($state.current.name != 'triangular.time-reports' && $state.current.name != 'triangular.client-manager-page.time'){
    	   	        		        var containers = $('.app-item-container-items');
    	   		    	    		    angular.forEach(containers, function(container){
    	   		    	    				$(container).css('height', (w.height() - removeHeight) + 'px');
    	   		    	    				// make sure our client cards aren't more than 50% of viewport
    	   		    	    				$(container).find('md-card.client-card').find('md-card-content').css('max-height',(w.height()/2.5)+'px');
    	   		    	    		    });
		    		    	   } else if ($state.current.name != 'triangular.dashboard'){
	   	        		        var containers = $('.app-item-container');
	   		    	    		    angular.forEach(containers, function(container){
	   		    	    				$(container).css('height', (w.height() - removeHeight) + 'px');
	   		    	    		    });
		    		    	   }

		    		    };
				$timeout(function() {
					// We don't want to be resizing today panel on dashboard
					if ($state.current.name != 'triangular.dashboard'){
						setHeight();
						if(mode != 'vertical'){
							setWidth();
						}
					}

				}, 200); // end our $timeout function

			}

		};
	})
})();

(function() {
    'use strict';
    angular.module('appServices')
        .service('fbService', fbService);

    /* @ngInject */
    function fbService($log, $http, $firebaseArray, $firebaseAuth, $firebaseObject, authFactory, $mdToast) {
       var service = {
              };

       return service;

       }// fbService




})
();

 (function() {
     'use strict';
     angular.module('appServices')
     .factory('authFactory', authFactory)

     /* @ngInject */
     function authFactory ($firebaseAuth){
     	// console.log('Auth factory called. authData is:');
     	// console.log($firebaseAuth().$getAuth());
         return $firebaseAuth();
       }

})();

(function() {
    'use strict';

    angular
        .module('bry', []);
})();

(function() {
    'use strict';

    angular
        .module('bry')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/bry');

        $stateProvider
            .state('triangular.bry-page', {
                url: '/bry/bry-page',
                templateUrl: 'app/bry/bry-page.tmpl.html',
                // set the controller to load for this page
                controller: 'bryPageController',
                controllerAs: 'vm'
            });

        triMenuProvider.addMenu({
            name: "Bry's Place",
            icon: 'zmdi zmdi-airline-seat-recline-extra',
            type: 'link',
            state: 'triangular.bry-page',
            priority: 100.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bry')
        .controller('bryPageController', bryPageController);

    /* @ngInject */
    bryPageController.$inject = ['$rootScope', '$scope', 'localStorageService']
    function bryPageController($rootScope, $scope, localStorageService) {
        var vm = this;
        vm.testData = ['triangular', 'is', 'great'];

        $scope.showClients = function showClients(){

        	console.log(localStorageService.get('clients'));

        }

        $scope.showTasks = function showTasks(){

        	console.log(localStorageService.get('tasks'));

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('weatherWidget', weatherWidget);

    /* @ngInject */
    function weatherWidget($http) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            require: 'triWidget',
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs, widgetCtrl) {
            widgetCtrl.setLoading(true);

            var query = 'select item.condition from weather.forecast where woeid in (select woeid from geo.places(1) where text="' + attrs.weatherWidget + '")';
            var url = 'https://query.yahooapis.com/v1/public/yql?q=' + encodeURIComponent(query) + '&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys';

            $http.get(url).
            success(function(data) {
                if(data.query.count > 0) {
                    widgetCtrl.setLoading(false);
                    $scope.weather = {
                        iconClass: 'wi-yahoo-' + data.query.results.channel.item.condition.code,
                        date: new Date(data.query.created),
                        temp: data.query.results.channel.item.condition.temp,
                        text: data.query.results.channel.item.condition.text,
                        location: attrs.weatherWidget
                    };
                }
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('resize', resize)

    /* @ngInject */
    function resize(pageDimensionsService, $state, $log, $window, $timeout) {
      return function (scope, element, attr) {
        var suppressResize = attr.resize;
        var w = angular.element($window);

        function update(mode) {
            $timeout(function(){
              pageDimensionsService.resizeColumns(mode);
            },1000);
        }

          w.bind('resize', function () {
            // trigger $digest when window is resized and call `update` function
            scope.$apply(update(attr.resize));
          });
          update(attr.resize); // initial setup

      }
    }

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('isolateScrolling', function () {
      return {
        restrict: 'A',
          link: function (scope, element, attr) {
            element.bind('DOMMouseScroll', function (e) {
              if (e.detail > 0 && this.clientHeight + this.scrollTop == this.scrollHeight) {
                this.scrollTop = this.scrollHeight - this.clientHeight;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
              else if (e.detail < 0 && this.scrollTop <= 0) {
                this.scrollTop = 0;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
            });
            element.bind('mousewheel', function (e) {
              if (e.originalEvent.deltaY > 0 && this.clientHeight + this.scrollTop >= this.scrollHeight) {
                this.scrollTop = this.scrollHeight - this.clientHeight;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
              else if (e.originalEvent.deltaY < 0 && this.scrollTop <= 0) {
                this.scrollTop = 0;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }

              return true;
            });
          }
      };
    });

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('inhibitBack', inhibitBack)

    // the inhbitBack directive detects scroll events and attempts to inhibit triggering a "back" gesture when scrolling too quickly to the left
    inhibitBack.$inject = ['$window'];
    function inhibitBack() {
      return {
        restrict: 'A',
              link: function(scope, elem, attr, ctrl) {
                // Get our element so we can monitor it
                var raw = elem[0];
                $(raw).addClass('inhibit-back');
                var thisScroll = $(elem)[0];

                $('.inhibit-back').on('scroll', function(event){
                      // We don't want to scroll below zero or above the width and height
                      var maxX = $(elem)[0].scrollWidth - $(elem)[0].offsetWidth;

                      // If this event looks like it will scroll beyond the bounds of the this event, prevent it and set the scroll to the boundary manually
                      // If scrolling too far left
                      if ($(elem)[0].scrollLeft - 10 < 0){
                        // console.log('Stopping going back');
                        event.preventDefault();
                        $(elem)[0].scrollLeft = 1;
                      }

                      // If scrolling too far right
                      if($(elem)[0].scrollLeft + 10 > maxX){
                        // console.log('Stopping going forward');
                        event.preventDefault();
                        $(elem)[0].scrollLeft = maxX;
                      }

                    });

               }
             }
      }

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('backButton', ['$window', function($window) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.bind('click', function () {
                        $window.history.back();
                    });
                }
            };
        }]);

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('adminjaEnter', function () {
      return function (scope, element, attrs) {

        element.bind('keydown keypress', function(event) {
          var keyCode = event.which || event.keyCode;

          // If enter key is pressed
          if (keyCode === 13 && !event.shiftKey) {
            scope.$apply(function() {
              scope.$eval(attrs.adminjaEnter);
            });

            event.preventDefault();
          }
        });

      }
    });

})();

(function() {
    'use strict';

    angular
        .module('appFilters', []);
})();

(function() {
    'use strict';

    angular
        .module('appFilters')
           .filter('ordinal', function() {

          // Create the return function
          // set the required parameter name to **number**
          return function(number) {

            // Ensure that the passed in data is a number
            if(isNaN(number) || number < 1) {

              // If the data is not a number or is less than one (thus not having a cardinal value) return it unmodified.
              return number;

            } else {

              // If the data we are applying the filter to is a number, perform the actions to check it's ordinal suffix and apply it.

              var lastDigit = number % 10;

              if(lastDigit === 1) {
                return number + 'st'
              } else if(lastDigit === 2) {
                return number + 'nd'
              } else if (lastDigit === 3) {
                return number + 'rd'
              } else if (lastDigit > 3) {
                return number + 'th'
              }

            }
          }
        }) // ordinal filter

        // Hours and Minutes filter
        // Give him minutes, he'll return a properly formatted (-)00:00 for it.
           .filter('HandM', function() {
          return function(number) {

              // we'll need this later
              var isNegative = false;
              if (number < 0){
                isNegative = true;
              }
              // convert to an integer so we aren't doing a floor/ceiling dance
              number = Math.abs(number);

              var hours = Math.floor( number / 60);
              hours = _.toString(hours);
              // we don't pad our hours. They may go into 3 digits for some users.

              var minutes = number % 60;
              minutes = _.toString(minutes);
              minutes = _.padStart(minutes, 2, '0');

              // set our return object
              var duration = hours;

              // if we have minutes, add them. Otherwise, 00
               if (minutes){
                duration = duration + ':' + minutes;
               } else {
                duration = duration + ':' + '00';
               }

               // if it was a negative number, prepend it
               if (isNegative){
                duration = '-' + duration;
               }

               return duration
          }
        })

        // Months to Date this year Filter
        // @ngInject //
          .filter('monthsToDate', function($log) {
         // Create the return function
         return function(months) {
          var now = new Date(),
              thisMonth = now.getMonth() + 1,
              results = [];

          _.each(months, function(month){
            if (thisMonth >= month.month)
            {
              results.push(month);
            }
          });// end each months

          return results;
         }
       }) // Months to Date Filter

         // thisMonth Filter
         // @ngInject //
           .filter('thisMonth', function($log) {
          // Create the return function
          return function(timeLogs, viewMonth) {
           var results = [];
           _.each(timeLogs, function(entry){
            // convert to integer to ensure matching works correctly
            var entryMonth = parseInt(entry.month);
             if (entryMonth == viewMonth)
             {
               results.push(entry);
             }
           });// end each months
           return results;
          }
        }) // thisMonth filter

       // isInWeek Filter
       // @ngInject //
         .filter('isInWeek', function($log) {

        // Create the return function
        return function(input, currentWeek) {

          var results = [];
          _.each(input, function(entry){

           // convert to integer to ensure matching works correctly
           var entryWeek = parseInt(entry.week);
            if (entryWeek === currentWeek)
            {
              results.push(entry);
            }
          });// end each months
          return results;
        }
      }) // isInWeek filter

         .filter('escape', function() {
           return window.encodeURIComponent;
         });

})();



(function() {
    'use strict';

    angular
        .module('app.authentication')
        .config(moduleConfig)
        .run(authenticationRun);


    /* @ngInject */
    function authenticationRun($rootScope){
        var topRange = 18,
            bottomRange = 10;

        // Pick a random number and use it to set our rotating background class on auth pages
        var random = Math.floor(Math.random() * ((topRange-bottomRange)+1) + bottomRange);
        // $rootScope.authBackground = "mb-bg-12"
        $rootScope.authBackground = "mb-bg-" + random;
        // console.log(random);
    }

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/app-authentication');

        $stateProvider
        .state('authentication', {
            abstract: true,
            views:{
                'root':{
                    templateUrl: 'app/app-authentication/layouts/authentication.tmpl.html'
                }
            }

            // url: '/authentication'
        })
        .state('authentication.login', {
            url: '/login',
            templateUrl: 'app/app-authentication/login/login.tmpl.html',
            controller: 'LoginController',
            controllerAs: 'vm'
        })
        .state('authentication.registration', {
            url: '/registration/:planID/:inviteID',
            templateUrl: 'app/app-authentication/registration/registration.tmpl.html',
            controller: 'registrationController',
            controllerAs: 'vm',
            params: {
                    planID: {squash: true, value: null},
                    inviteID: {squash: true, value: null}
                }
        })
        .state('authentication.confirmation', {
            url: '/confirmation',
            templateUrl: 'app/app-authentication/registration/registration.confirmation.tmpl.html',
            controller: 'confirmationController',
            controllerAs: 'vm'
        })
        .state('authentication.legal', {
            url: '/legal',
            templateUrl: 'app/app-authentication/legal/legal.tmpl.html',
            controller: 'legalController',
            controllerAs: 'vm'
        })
        .state('authentication.forgot', {
            url: '/forgot',
            templateUrl: 'app/app-authentication/forgot/forgot.tmpl.html',
            controller: 'ForgotController',
            controllerAs: 'vm'
        })
        .state('authentication.change-email', {
            url: '/change-email',
            templateUrl: 'app/app-authentication/change-email/change-email.tmpl.html',
            controller: 'changeEmailController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })
        // .state('authentication.signup', {
        //     url: '/signup',
        //     templateUrl: 'app/app-authentication/signup/signup.tmpl.html',
        //     controller: 'SignupController',
        //     controllerAs: 'vm'
        // })
        .state('authentication.profile', {
            url: '/profile/:selectedTab',
            templateUrl: 'app/app-authentication/profile/profile.tmpl.html',
            controller: 'profileController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })
        .state('authentication.cancel', {
            url: '/cancel',
            templateUrl: 'app/app-authentication/cancel/cancel.tmpl.html',
            controller: 'cancelController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })
        .state('authentication.subconfirmation', {
            url: '/subconfirmation',
            templateUrl: 'app/app-authentication/subscription-confirmation/subscription-confirmation.tmpl.html',
            controller: 'subConfirmController',
            controllerAs: 'vm'
        });

        // .state('authentication.lock', {
        //     url: '/lock',
        //     templateUrl: 'app/app-authentication/lock/lock.tmpl.html',
        //     controller: 'LockController',
        //     controllerAs: 'vm'
        // })


        // triMenuProvider.addMenu({
        //     name: 'MENU.AUTH.AUTH',
        //     icon: 'zmdi zmdi-key',
        //     type: 'dropdown',
        //     // open: 'false',
        //     priority: 25.1,
        //     children: [{
        //         name: 'MENU.AUTH.LOGIN',
        //         state: 'authentication.login',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.SIGN_UP',
        //         state: 'authentication.signup',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.FORGOT',
        //         state: 'authentication.forgot',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.LOCK',
        //         state: 'authentication.lock',
        //         type: 'link'
        //     }]
        // });

        // triMenuProvider.addMenu({
        //    name: 'Logout',
        //    icon: 'zmdi zmdi-lock-open',
        //    state: 'authentication.login',
        //    type: 'logout',
        //    priority: 25
        // })
    }
})();

(function() {
    'use strict';

    angular
        .module('manage', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('changeLogController', changeLogController);
        // changeLogController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function changeLogController($q, $log, $window, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
    	var vm = this;
          vm.user = _userData;
          vm.logs = [];

    	    // change the height of our container
    	    // var w = angular.element($window),
    	    // 		removeHeight = 100;
    	    // $('.admin-panel').css('height', (w.height() - removeHeight) + 'px');

          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of logs
            $timeout(function(){
              var logRef = firebase.database().ref().child('/changeLog');
              $firebaseArray(logRef)
              .$loaded(
                  function(logs) {
                      vm.logs = logs;
                  });
            },200);
          }

          vm.newLog = function(){
            vm.editedLog = null;
          }

          vm.deleteLog = function(logID){

            var updates = {};
            // store our canonical object - just update the PROFILE
            updates['/changeLog/' + logID] = null;
            firebase.database().ref().update(updates)
            vm.editedLog = null;
          }

    	   vm.selectLog = function(logID){
    	   	// $log.info('selectUser' + userID);
    	   	var logRef = firebase.database().ref('changeLog/' + logID);
    	   	return $firebaseObject(logRef)
    	   	.$loaded(
    	   	    function(log) {
                // convert date into something our form can use
                log.date = moment(log.date).toDate();
    	   	    	// $log.info(user);
    	   	        vm.editedLog = log;
    	   	    });
    	   } // vm.selectLog


        vm.updateLog = function (log){
          // $log.info('updateLog');

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var logCopy = angular.fromJson(angular.toJson(log));

          // convert date into something we can save
          logCopy.date = moment(logCopy.date).toISOString();
          // $log.info(logCopy);
          ajUTILITIES.removePropertiesWith(logCopy);
            var updates = {};
            // store our canonical object - just update the PROFILE
            updates['/changeLog/' + logCopy.uid] = logCopy;

            firebase.database().ref().update(updates)
            // vm.editedLog = null;

        }// updateLog

        vm.saveLog = function (log){
          // $log.info('updateLog');
          var newLogKey = firebase.database().ref().child('changeLog/').push().key;

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var logCopy = angular.fromJson(angular.toJson(log));

          logCopy.uid = newLogKey;
          // convert date into something we can save
          logCopy.date = moment(logCopy.date).toISOString();

          ajUTILITIES.removePropertiesWith(logCopy);
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/changeLog/' + logCopy.uid] = logCopy;

            firebase.database().ref().update(updates)
            vm.editedLog = null;

        }// updateLog



    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, $rootScopeProvider, triLayoutProvider) {


        $translatePartialLoaderProvider.addPart('app/adminja-admin');

        $stateProvider

          $stateProvider
              .state('triangular.admin', {
                  abstract: true,
                  url: '/admin',
                  templateUrl: 'app/adminja-admin/manage-page.tmpl.html',
                  // set the controller to load for this page
                  controller: 'managePageController',
                  controllerAs: 'vm',
                  resolve: {
                      'currentAuth': ['authFactory', function(authFactory) {
                          return authFactory.$requireSignIn()
                      }],
                      // resolve our _userData and pass it to the Controller for saving
                       '_userData': ['userDataService', function(userDataService) {
                         return userDataService.getLoggedInUser()
                         .then(function(data){
                              return data
                         })
                      }]
                  }

              })
              // .state('triangular.admin.clone-clients', {
              //     url: '/admin/clone',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/clone-clients.tmpl.html',
              //             controller: 'cloneClientsController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              .state('triangular.admin.manage-users', {
                  url: '/admin/users',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-users.tmpl.html',
                          controller: 'manageUsersController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.manage-tasks', {
                  url: '/admin/users/tasks/:clientID',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-tasks.tmpl.html',
                          controller: 'manageTasksController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.manage-plans', {
                  url: '/admin/plans',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-plans.tmpl.html',
                          controller: 'managePlansController',
                          controllerAs: 'vm'
                      }
                  }
              })
              // .state('triangular.admin.manage-changelog', {
              //     url: '/admin/changelog',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/update-changelog.tmpl.html',
              //             controller: 'changeLogController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              .state('triangular.admin.manage-notifications', {
                  url: '/admin/notifications',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-notifications.tmpl.html',
                          controller: 'manageNotificationsController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.manage-workspaces', {
                  url: '/admin/workspaces',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-workspaces.tmpl.html',
                          controller: 'manageWorkspacesController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.cleanup-users', {
                  url: '/admin/cleanup-users',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/cleanup-users.tmpl.html',
                          controller: 'cleanupUsersController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.manage-tutorials', {
                  url: '/admin/manage-tutorials',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-tutorials.tmpl.html',
                          controller: 'manageTutorialsController',
                          controllerAs: 'vm'
                      }
                  }
              });


              triMenuProvider.addMenu({
                  name: 'Manage users',
                  icon: 'fa fa-users',
                  type: 'link',
                  open: false,
                  priority: 2,
                  state: 'triangular.admin.manage-users'
                });

                triMenuProvider.addMenu({
                   name: 'Workspaces',
                   icon: 'fa fa-folder',
                   type: 'link',
                   open: false,
                   priority: 5,
                   state: 'triangular.admin.manage-workspaces'
                 });
                 triMenuProvider.addMenu({
                   name: 'Send Notifications',
                     icon: 'fa fa-bell-o',
                     state: 'triangular.admin.manage-notifications',
                    type: 'link',
                    open: false,
                    priority: 3
                  });

                  triMenuProvider.addMenu({
                    name: 'Manage Plans',
                    icon: 'zmdi zmdi-ticket-star',
                    state: 'triangular.admin.manage-plans',
                    type: 'link',
                    priority: 4
                  });
                  triMenuProvider.addMenu({
                     name: 'Manage Tutorials',
                     icon: 'zmdi zmdi-tv-play',
                     type: 'link',
                     open: false,
                     priority: 6,
                     state: 'triangular.admin.manage-tutorials'
                   });

                  triMenuProvider.addMenu({
                    name: 'Cleanup User Data',
                    icon: 'zmdi zmdi-hospital-alt',
                    state: 'triangular.admin.cleanup-users',
                    type: 'link',
                    priority: 7
                  });

    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageWorkspacesController', manageWorkspacesController);
        // manageWorkspacesController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageWorkspacesController($q, $log, $window, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
    	var vm = this;
          vm.user = _userData;
          vm.notifications = [];
          vm.users = [];
          vm.editedLog = {};

          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            vm.copyWorkspace = function(sourceWorkspace, targetUser){
              return clientDataService.copyClient(sourceWorkspace, targetUser)
              .then(alert('Client Copied'))
              .catch(function(error){
                alert(error);
              });
            }//

            vm.demoWorkspaces =
              ["-KVXwMsIzy9WIa8o9JO5","-KVXxgGCgRYZER4YZzhV", "-KVXygO3cGcw2gB6xeG1", "-KVc3bpcb3RHGx1LwJQr", "-KVc4704WD_86nU0Pn2h", "-LQ4_4KrWma2THUAKqqh", "-LioI1HRYMrLt5JqSRX_"]

            vm.copyDemoWorkspaces = function(targetUser){
              _.each(vm.demoWorkspaces, function(workspace){
                return clientDataService.copyClient(workspace, targetUser).
                then(function(){
                  $log.info('Client ' + workspace + ' copied.');
                });
              });
            }


          }// if admin

    }// manageWorkspacesController
})();

(function() {
    'use strict';
    angular
        .module('manage')
        .controller('manageUsersController', manageUsersController);
        // manageUsersController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageUsersController($q, $log, $window, $http, $scope, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
     var vm = this;



         vm.fbConfig = fbConfig;
         vm.user = _userData;
         vm.clients = {};
          // make a scope-based container for our userForm for validation purposes
          vm.forms = {};
         vm.selectedUser = undefined;
          vm.orderBy = 'profile.lastName';
          vm.filterStatus = 'all';
          vm.filterPlan = 'all';
          vm.plans = undefined;
          vm.leaveTeams = leaveTeams;
          vm.dissolveTeam = dissolveTeam;
          vm.forceDeleteUser = forceDeleteUser;

          // set our chargebee endpoint URL
          if(vm.fbConfig.databaseURL == "adminja-staging.firebaseio.com"){
            vm.checkoutURL = "https://us-central1-adminja-staging.cloudfunctions.net/checkout?key=hZPEbfkrPqyTimY4dbgE";
          } else {
            vm.checkoutURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net/checkout/?key=hZPEbfkrPqyTimY4dbgE";
          }

          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
              var usersRef = firebase.database().ref().child('/userList');
              $firebaseArray(usersRef)
              .$loaded(
                  function(users) {
                      vm.users = users;
                      _.each(vm.users, function(user){
                      	user.score = 0;
                      	if(_.has(user, 'profile') && _.has(user, 'counts')){
                        		user.score = vm.calculateScore(user);
                      	} else {
                      		user.score = 0;
                      	}
                      });

                        $timeout(function () {
                          document.getElementById("searchQuery").focus();
                      }, 500, false);
                  });
              var plansRef = firebase.database().ref().child('/plans');
                  $firebaseArray(plansRef)
                  .$loaded(
                      function(plans) {
                          vm.plans = plans;
                      });

            },200);

            var plansRef = firebase.database().ref().child('/plans');
            $timeout(function(){
              $firebaseArray(plansRef)
              .$loaded(
                  function(plans) {
                      vm.plans = plans;
                  });

            },200);


          }// if admin

          vm.teamSize = function(user){
            return _.size(user.teams)
          }


          vm.litmusClass = function(user){
            var litmus = user.score;
            if(litmus < 10){
              return "low";
            }
            if(litmus >=10 && litmus < 40){
              return "medium";
            }
            if(litmus >=60){
              return "high";
            }
          }

          vm.calculateScore = function(user){


            var status = 0;
            if(_.has(user, 'counts')){
              if(_.has(user, 'counts.tasks.added')){
                  status = status + Number(user.counts.tasks.added.allTime);
              }

              if(_.has(user, 'counts.timers.allTime')){
                status = status + Number(user.counts.timers.allTime);
              }

              if(_.has(user, 'counts.clients.active')){
                status = status + Number(user.counts.clients.active);
              }
              if(_.has(user, 'counts.clients.archived')){
                status = status + Number(user.counts.clients.archived);
              }

              if(_.has(user, 'counts.profileCards.alltime')){
                status = status + Number(user.counts.profileCards.allTime);
              }

              if(_.has(user, 'counts.taskTemplates.recurringTasks')){
                  status = status + (Number(user.counts.taskTemplates.recurringTasks) * 1.5);
              } // if has taskTemplates

              if(_.has(user, 'counts.taskTemplates.templateTasks')){
                  status = status + (Number(user.counts.taskTemplates.templateTasks) * 1.25);
              } // if has taskTemplates

              if(_.has(user, 'counts.timeLogs.allTime')){
                status = status + Number(user.counts.timeLogs.allTime);
              }

            }// if has counts

              return status
           }//lcalculateScore

          // Debounce our search filter
          // This is what you will bind the filter to
          vm.filterText = '';

          // Instantiate these variables outside the watch
          var tempFilterText = '',
              filterTextTimeout;
          $scope.$watch('searchQuery', function (val) {
              if (filterTextTimeout) $timeout.cancel(filterTextTimeout);

              tempFilterText = val;
              filterTextTimeout = $timeout(function() {
                  vm.filterText = tempFilterText;
              }, 250); // delay 250 ms
            });

          vm.resetFilter = function(){

            vm.filterText = '';
            document.getElementById("searchQuery").value = "";

          }// resetFilter

          vm.statusFilter = function(user){
            if(vm.filterStatus == 'all'){
              return true
            } else if (vm.filterStatus == 'exclude-cancelled'){
              if(_.has(user, 'status')){
                if(user.status != 'cancelled'){
                  return true
                }
              }
            } else if (vm.filterStatus == 'exclude-zero-score'){
                if(user.score > 5){
                  return true
                }
            }
            else {
              if(_.has(user, 'status')){
                if(user.status == vm.filterStatus){
                  return true;
                } // if has matching status
              } // if has user.plan
            } // if filterStatus == all
          }

         vm.planFilter = function(user){
           if(vm.filterPlan == 'all'){
             return true
           } else if (vm.filterPlan == 'exclude-starter') {
            if(_.has(user, 'plan')){
              if(!user.plan.includes('starter') && !user.plan.includes('client-access')){
                return true
              }// if not starter
            }// if has plan
           } else {
             if(_.has(user, 'plan')){
               if(user.plan.includes(vm.filterPlan)){
                 return true;
               } // if has matching status
             } // if has user.plan
           } // if filterStatus == all
         }




        vm.panelCount = function(panel){
         var count = _.size(panel.details);
         return count
        }

        vm.openTasks = function(client){
         // $log.info(client.tasks);
           var openTasks = _.filter(client.tasks, function(o) {
             return o.status != 'closed';
           });
       return _.size(openTasks)
        }

           vm.totalTasks = function(client){
            // $log.info(client.tasks);
            return _.size(client.tasks)
           }

        vm.updateUser = function (user){
          // $log.info('updateUser');

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var userCopy = angular.fromJson(angular.toJson(user));
          // $log.info(userCopy);
           userCopy = ajUTILITIES.removePropertiesWith(userCopy);
            // Make sure we reset fullName in case our name has changed
            // userCopy.profile.fullName = userCopy.profile.firstName + ' ' + userCopy.profile.lastName;
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/users/' + userCopy.uid] = userCopy;

            return firebase.database().ref().update(updates)
            .then(function(){
              $timeout(function(){
                $mdDialog.show(
                     $mdDialog.alert()
                       .clickOutsideToClose(true)
                       .title('Subscription Overrides Updated')
                       // .htmlContent('<p>An email notification has been sent to ' + vm.selectedUser.email + '.</p>')
                       .ariaLabel('Subscription Overrides Updated')
                       .ok('Continue')
                   ).then(function(){
                    vm.forms.userForm.$setPristine();
                   });
              }, 200);

            });


        }// updateUser

     vm.selectClients = function(userID){
       var clientsRef = firebase.database().ref().child('/clients');
       $firebaseArray(clientsRef.orderByChild("access/users/" + userID).equalTo(true))
         .$loaded(
              function (clients) {
               // $log.info(clients);
                vm.clients = clients;
              });
        }


           /////////////////////////////////////////////////////////////////////////////////////
           // Create User and Subscription functions
           //  We need Chargebee loaded first. The other functions are wrapped in it
           // so they have access to chargebee's methods
           angularLoad.loadScript('https://js.chargebee.com/v2/chargebee.js').then(function() {
               // Script loaded succesfully.
               // $log.info('chargeBee Loaded');

               // Initialize Chargebee
               var cbInstance = Chargebee.init({
                   site: $rootScope.chargebeeSettings.site,
                   publishableKey: $rootScope.chargebeeSettings.api_key
                 });

              });// chargebee script loaded

           vm.subscribeUser = function(userID, planID){
            $log.info('subscribeUser');
            $log.info(userID);
            $log.info(planID);

            var subscribeURL = vm.checkoutURL + '&method=subscribeUser&user=' + userID + '&plan='+ planID;
            $log.info(subscribeURL);
              return $http.get(subscribeURL)
                  .then(function(response){
                    vm.response = response.data;
                    if(_.has(vm.response, 'error_code')){
                      $mdDialog.show(
                           $mdDialog.alert()
                             .clickOutsideToClose(true)
                             .title('There was a problem processing your subscription request.')
                             .htmlContent('<p style="color:red;">Message returned: ' + vm.response.error_code + '<br>' + vm.response.error_msg + '</p>')
                             .ariaLabel('Subscription failed')
                             .ok('Continue')
                         )
                    } else {
                      $mdDialog.show(
                           $mdDialog.alert()
                             .clickOutsideToClose(true)
                             .title(planID + ' Subscription has been created.')
                             .htmlContent('<p>User will receive the standard welcome info.</p>')
                             .ariaLabel('Subscription change succeeded')
                             .ok('Continue')
                         )
                    }
              });
           }// subscribeUser

            vm.pauseSubscription = function(user, $event){
              $log.info('pauseSubscription: ' + user.plan.content__subscription__id);
              var confirm = $mdDialog.confirm()
                    .title('Pause Subscription. Are you sure?')
                    .htmlContent('<p>Subscription will be paused at the end of their current billing cycle.</p>')
                    .ariaLabel('Confirm Pause')
                    .targetEvent($event)
                    .ok('Do it.')
                    .cancel('Nevermind');

              $mdDialog.show(confirm).then(function() {
                var pauseURL = vm.checkoutURL + '&method=pause&subID=' + user.plan.content__subscription__id;
                 return $http.get(pauseURL)
                      .then(function(response){
                        vm.response = response.data;
                        if(_.has(vm.response, 'error_code')){
                          $mdDialog.show(
                               $mdDialog.alert()
                                 .clickOutsideToClose(true)
                                 .title('There was a problem processing your pause request.')
                                 .htmlContent('<p style="color:red;">Message returned: ' + vm.response.error_code + '<br>' + vm.response.error_msg + '</p>')
                                 .ariaLabel('Subscription change failed')
                                 .ok('Continue')
                             ).then(function(){

                             });
                        } else {
                          // add pause-scheduled to Drip
                          _dcq.push(["identify", {
                                  email: user.email,
                                  tags: ["pause-scheduled"]
                              }]);
                          $mdDialog.show(
                               $mdDialog.alert()
                                 .clickOutsideToClose(true)
                                 .title('Subscription has been scheduled to pause.')
                                 .htmlContent('<p>An email notification has been sent to ' + vm.selectedUser.email + '.</p>')
                                 .ariaLabel('Subscription change succeeded')
                                 .ok('Continue')
                             ).then(function(){

                             });
                        }
                      });
              }, function() {
                // $scope.status = 'You decided to keep your debt.';
                $mdDialog.cancel();
              });


            }// pauseSubscription

            function cancelController($scope, $mdDialog) {
                $scope.cancel = function() {
                  $mdDialog.cancel();
                };

                $scope.answer = function(answer) {
                  $mdDialog.hide(answer);
                };
              }

            vm.cancelSubscription = function(user, $event){
              $log.info('cancelSubscription: ' + user.plan.content__subscription__id);
              $mdDialog.show({
                    controller: cancelController,
                    templateUrl: 'app/adminja-admin/cancel-dialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    clickOutsideToClose:true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
                  })
                  .then(function(answer) {
                    var cancelUrl = vm.checkoutURL + '&method=cancel&subID=' + user.plan.content__subscription__id + '&endofterm=' + answer;
                    $log.info(cancelUrl);

                     return $http.get(cancelUrl)
                          .then(function(response){
                            vm.response = response.data;
                            if(_.has(vm.response, 'error_code')){
                              $mdDialog.show(
                                   $mdDialog.alert()
                                     .clickOutsideToClose(true)
                                     .title('There was a problem processing your cancellation request.')
                                     .htmlContent('<p style="color:red;">Message returned: ' + vm.response.error_code + '<br>' + vm.response.error_msg + '</p>')
                                     .ariaLabel('Subscription change failed')
                                     .ok('Continue')
                                 ).then(function(){

                                 });
                            } else {
                              // add cancel-scheduled to Drip
                              _dcq.push(["identify", {
                                      email: user.email,
                                      tags: ["cancel-scheduled"]
                                  }]);
                              $mdDialog.show(
                                   $mdDialog.alert()
                                     .clickOutsideToClose(true)
                                     .title('Subscription has been scheduled for cancellation.')
                                     .htmlContent('<p>An email notification has been sent to ' + vm.selectedUser.email + '.</p>')
                                     .ariaLabel('Subscription change succeeded')
                                     .ok('Continue')
                                 ).then(function(){

                                 });
                            }
                          });
                  }, function() {
                    console.log('You cancelled the dialog.');
                  });

            //   var confirm = $mdDialog.confirm()
            //         .title('Cancel Subscription. Are you sure?')
            //         .htmlContent('<p>Subscription will be cancelled at the end of their current billing cycle.</p>')
            //         .ariaLabel('Confirm Cancellation')
            //         .targetEvent($event)
            //         .ok('Do it.')
            //         .cancel('Nevermind');

            //   $mdDialog.show(confirm).then(function() {
            //     , function() {
            //     // $scope.status = 'You decided to keep your debt.';
            //     $mdDialog.cancel();
            // });

            }// cancelSubscription

            vm.selectUser = function(userID){
              $log.info(userID);
             // $log.info('selectUser' + userID);
             var userRef = firebase.database().ref('users/' + userID);
             userRef.once('value').then(function (snapshot) {
              vm.selectedUser = snapshot.val();
              var userCountRef = firebase.database().ref('/counts/'+ userID + '/weeks');
              var startDate = moment().subtract(12, 'weeks'), endDate = moment(), startRange = moment(startDate).format('YYYY-ww'), endRange = moment(endDate).format('YYYY-ww');
              firebase.database().ref('/counts/' + userID + '/weeks').orderByChild('range').startAt(startRange).endAt(endRange).on('value', function(snapshot){
                vm.selectedUserCounts = snapshot.val();
                _.each(vm.selectedUserCounts, function(week){
                  $log.info(week.range);
                })
              });

              // get the last 8 weeks for admin display

              // vm.selectClients(vm.selectedUser.uid);
               // set form to pristine
               $timeout(function(){
                 vm.forms.userForm.$setPristine();
               }, 3000);
              });// userRef.once

            } // vm.selectUser


            vm.exportUser = function(user){
              // save clientList so attachInvoices knows what to work from
              $log.info('exportUser: ' + user.uid);
              const do_attachClients = attachClients(user);
              const do_attachTeam = attachTeam(user);
              const do_attachTime = attachTime(user);
              const do_attachLeadBoard = attachLeadBoard(user);
              const do_attachInvoices = attachInvoices(user);
              return Promise.all([do_attachClients, , do_attachTeam, do_attachTime, do_attachLeadBoard, do_attachInvoices])
                .then(function(){
                  console.log('All Promises Executed. Let\'s download the file.');
                  downloadUser(user);
                });
            }// exportUser

            vm.deleteUser = function(user, $event){
              if(_.has(user, 'uid')){
                $log.info('deleteUser: ' + user.email);
                var confirm = $mdDialog.confirm()
                      .title('Delete User? Are you sure?')
                      .htmlContent('<p></p>')
                      .ariaLabel('Confirm Delete')
                      .targetEvent($event)
                      .ok('Do it.')
                      .cancel('Nevermind');

                $mdDialog.show(confirm).then(function() {
                  vm.exportUser(user)
                  .then(function(){
                    var updates = {};
                    updates['/users/' + user.uid + '/deleteMe'] = true;
                    firebase.database().ref().update(updates)
                    .then(function(){
                     $timeout(function(){
                       vm.selectedUser = undefined;
                     },0)
                    $mdToast.show($mdToast.adminjaAlert(

                     {
                         locals:{
                             title: 'Success',
                             message: 'Your user has been exported and tagged for deletion.' ,
                             color: 'green'
                         }
                     }));// mdToast
                  });// firebaseUpdates

                  });//export then
                });// showConfirm
              }

            }// deleteUser

            function forceDeleteUser(user){
              $log.info('forceDeleteUser');
              if(_.has(user, 'uid')){
                $log.info('forceDeleteUser: ' + user.email);
                var confirm = $mdDialog.confirm()
                      .title('Force Delete User? Are you sure?')
                      .htmlContent('<p></p>')
                      .ariaLabel('Confirm Delete')
                      .ok('Do it.')
                      .cancel('Nevermind');

                $mdDialog.show(confirm).then(function() {
                  vm.exportUser(user)
                  .then(function(){
                    var updates = {};
                    updates['/users/' + user.uid] = null;
                    updates['/userList/' + user.uid] = null;
                    firebase.database().ref().update(updates)
                    .then(function(){
                     $timeout(function(){
                       vm.selectedUser = undefined;
                     },0)

                     var alert = $mdDialog.alert()
                           .title('User record deleted')
                           .textContent('Make sure you remove the auth record for ' + user.email )
                           .targetEvent($event)
                           .ok('Ok');

                    $mdDialog.show(alert)

                  });// firebaseUpdates

                  });//export then
                });// showConfirm
              }
            }//forceDeleteUser

            function deleteClients(user){
              // We don't need to handle the whole process
              // our clientChange cloud function will pick up on status of "archiveAndDelete" and do it all for us
              var updates = {};
              if(_.has(user, 'clients')){
                var usersClients = Object.keys(user.clients);
                  _.each(usersClients, function(client){

                   var clientRef = firebase.database().ref('clients/' + client);
                    return $firebaseObject(clientRef)
                    .$loaded(function(thisClient){
                      if(thisClient.owner == user.uid){
                        $log.info('Own client - should delete');
                        clientRef.child('status').set('archiveAndDelete');
                      } else {
                        $log.info('Delegated client - should not delete');
                      }
                    })
                });// each client
              };
            } // removeClients


            function dissolveTeam(userID){
              var updates = {};
              var teamsRef = firebase.database().ref('teams/' + userID);
              $firebaseObject(teamsRef)
              .$loaded(function(thisTeam){
                  _.each(thisTeam.members, function(member){
                    // remove the team id from user's team list
                    updates['/users/' + member.uid + '/teams/' + userID] = null;
                    // remove each assigned client from this member (if they aren't the owner)
                    if(member.uid != userID){
                      _.each(member.clients, function(value, key){
                        // remove client from user's client list
                        updates['/users/' + member.uid + '/clients/' + key] = null;
                        // remove member from client's access lists
                        updates['/clients/' + key + '/access/members/' + member.uid] = null;
                        updates['/clients/' + key + '/access/admins/' + member.uid] = null;
                      });
                    }// if not owner of team
                  });
                  // Execute changes
                  return firebase.database().ref().update(updates)
                  .then(function(){
                    console.log('Team Dissolved');
                    alert(vm.selectedUser.email + '\'s Team has been dissolved.')
                  });
              })
            }// dissolveTeam

            function leaveTeams(userID){
              var updates = {};
              var teamsRef = firebase.database().ref('teams/');
              $firebaseArray(teamsRef.orderByChild('members/' + userID + '/uid').equalTo(userID))
              .$loaded(function(teams){
                if(teams){
                  _.each(teams, function(team){
                    // remove user from assigned clients
                    _.each(team.members[userID].clients, function(client, key){
                      // remove from client's access list
                      updates['/clients/' + key + '/access/members/' + userID] = null;
                      updates['/clients/' + key + '/access/admins/' + userID] = null;
                      // remove client from member's client list
                      updates['/users/' + userID + '/clients/' + key] = null;
                    })
                    // remove team from member's team list
                    updates['/users/' + userID + '/teams/' + team.ownerID]
                    // remove team member from team
                    updates['/teams/' + team.ownerID + '/members/' + userID] = null;
                  });
                  // Execute changes
                  return firebase.database().ref().update(updates)
                  .then(function(){
                    console.log('Removed from all teams');
                    alert(vm.selectedUser.email + ' has been removed from all Teams.')
                  });
                }// if teams
              })
            }// leaveTeams

            function attachInvoices(user){
              var invoicesRef = firebase.database().ref('/invoices/');
              $firebaseArray(invoicesRef.orderByChild('info/owner').equalTo(user.uid))
                .$loaded(function(invoices){
                  invoices = ajUTILITIES.removePropertiesWith(invoices);
                  user.invoices = invoices;
                })
            }//attachInvoices

            function attachLeadBoard(user){

                var leadboardRef = firebase.database().ref('leadBoards/' + user.uid);
                leadboardRef.once('value', function(snapshot){
                  if(snapshot.exists()){
                    var leadBoard = snapshot.val();
                    leadBoard = ajUTILITIES.removePropertiesWith(leadBoard);
                    user.leadBoard = leadBoard;
                  }
                })
            }//attachLeadBoard

            function attachTime(user){
                var timeRef = firebase.database().ref('time/');
                return $firebaseArray(timeRef.orderByChild('creator').equalTo(user.uid))
                        .$loaded(function (time) {
                            time = ajUTILITIES.removePropertiesWith(time);
                            user.time = time;
                        });
            }//attachTime

            function attachClients(user){
              if(_.has(user, 'clients')){
                var usersClients = Object.keys(user.clients);
                  _.each(usersClients, function(client){
                   var clientRef = firebase.database().ref('clients/' + client);
                   return $firebaseObject(clientRef)
                   .$loaded(
                       function(fullClient) {
                          if(_.has(fullClient, 'invoices')){
                              var clientInvoices = Object.keys(fullClient.invoices);
                                _.each(clientInvoices, function(invoiceNumber){
                                 var invoiceRef = firebase.database().ref('invoices/' + invoiceNumber);
                                 return $firebaseObject(invoiceRef)
                                 .$loaded(
                                     function(invoice) {
                                         invoice = ajUTILITIES.removePropertiesWith(invoice);
                                         fullClient.invoices[invoiceNumber] = invoice;
                                     });
                              });// each invoice
                            }// if has invoices
                            fullClient = ajUTILITIES.removePropertiesWith(fullClient);
                            user.clients[fullClient.uid] = fullClient;
                       });
                });// each client
              }// if has clients
            }// attachClients

            function attachTeam(user){
              var teamRef = firebase.database().ref('teams/' + user.uid);
              return $firebaseObject(teamRef)
              .$loaded(
                  function(team) {
                   // $log.info(user);
                     team = ajUTILITIES.removePropertiesWith(team);
                      user.team = team;
                  });
            }// attachTeam

            function downloadUser(user){
              var userCopy = angular.fromJson(angular.toJson(user));
              user = ajUTILITIES.removePropertiesWith(user);
              var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(user));
              var dlAnchorElem = document.getElementById('downloadAnchorElem');
              dlAnchorElem.setAttribute("href",     dataStr     );
              dlAnchorElem.setAttribute("download", "adminja-export-user-" + userCopy.email + ".json");
              dlAnchorElem.click();
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Export Received',
                          message: 'Your user has been exported.' ,
                          color: 'green'
                      }
                  }));// mdToast
            }

                  // make sure broken images get default generic avatar
            $timeout(function(){
              $('img').on("error", function() {
                $(this).attr('src', '/assets/images/avatars/generic-avatar.png');
              });
            }, 3000);
    }
})();


(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageTutorialsController', manageTutorialsController);
        // manageTutorialsController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageTutorialsController($q, $log, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, $firebaseArray, $firebaseObject, _userData) {
    	var vm = this;
          vm.tutorials = [];
    	    vm.selectedTutorial = undefined;
          vm.user = _userData;
          var tutorialsRef = firebase.database().ref('/onboarding/tutorials');
          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
                return $firebaseArray(tutorialsRef)
                .$loaded(function(data){
                 vm.tutorials = data;
              });
            },200);
          }

    	   vm.selectTutorial = function(tutorial){
    	   	$log.info('selectTutorial' + tutorial.label);
          $log.info(tutorial);
    	   	vm.selectedTutorial = tutorial;
    	   } // vm.selectPlan



        vm.updateTutorial = function (tutorial){
          // $log.info('updatetutorial');

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var tutorialCopy = angular.copy(tutorial);
          var tutorialCopy = angular.fromJson(angular.toJson(tutorial));
          // $log.info(tutorialCopy);
          ajUTILITIES.removePropertiesWith(tutorialCopy);
            // Make sure we reset fullName in case our name has changed
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/onboarding/tutorials/' + tutorialCopy.uid] = tutorialCopy;
            // reset our form

            return firebase.database().ref().update(updates)
            .then(function(){
              return vm.reset()
            })


        }// updatePlan

        vm.saveTutorial = function(tutorial){
          ajUTILITIES.removePropertiesWith(tutorial);
          var tutorialUID = undefined;

          // if we have an id, we are just updating it
          if (_.has(tutorial, 'uid')){
            tutorialUID = tutorial.uid
          } else {
            // if we don't have an id, we need to get one and add it
            tutorialUID = tutorialsRef.push().key;
            tutorial.uid = tutorialUID;
          }

          tutorial.lastUpdated = moment().toISOString();

          var updates = {};
          updates['/onboarding/tutorials/' + tutorialUID] = tutorial;

          // Add empty time entry...triggering a recalc on it's billingPeriod
          return firebase.database().ref().update(updates)

        }

        vm.reset = function(){
          vm.selectedTutorial = undefined;
        }

        vm.delete = function(tutorial){
          var updates = {};
          updates['/onboarding/tutorials/' + tutorial.uid] = null;

          // Add empty time entry...triggering a recalc on it's billingPeriod
          return firebase.database().ref().update(updates)

        }

        vm.isSelected = function(plan){
          if(vm.selectedTutorial.uid == tutorial.uid){
            return true
          }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('manageToolbarController', manageToolbarController);

    /* @ngInject */
    function manageToolbarController($log, $scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageTasksController', manageTasksController);
        // manageTasksController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageTasksController($q, $log, $window, $scope, $timeout, $stateParams, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService, taskDataService) {
     var vm = this;
         vm.clientID = $stateParams.clientID;
         vm.user = _userData;


         $log.info('manageTasksController');

          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
              var clientRef = firebase.database().ref().child('/clients/' + vm.clientID);
              $firebaseObject(clientRef)
              .$loaded(
                  function(client) {
                      vm.client = client;
                      vm.tasks = vm.client.tasks;
                      // _.each(vm.tasks, function(task){
                      // 	$log.info(task.refID);
                      // 	$log.info(task);
                      // });
                 });// $firebaseArray

               });// timeout

          }// if admin


    }// manageTasksController
})();


(function() {
    'use strict';

    angular
        .module('manage')
        .controller('managePlansController', managePlansController);
        // managePlansController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function managePlansController($q, $log, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, $firebaseArray, $firebaseObject, _userData) {
    	var vm = this;
          vm.plans = [];
    	    vm.selectedPlan = undefined;
          var plansRef = firebase.database().ref().child('/plans');
          vm.user = _userData;
          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
              $firebaseArray(plansRef)
              .$loaded(
                  function(plans) {
                      vm.plans = plans;
                  });

            },200);
          }

    	   vm.selectPlan = function(plan){
    	   	$log.info('selectPlan' + plan.planID);
    	   	vm.selectedPlan = plan;
    	   } // vm.selectPlan



        vm.updatePlan = function (plan){
          // $log.info('updatePlan');

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var planCopy = angular.copy(plan);
          var planCopy = angular.fromJson(angular.toJson(plan));
          // $log.info(planCopy);
          ajUTILITIES.removePropertiesWith(planCopy);
          planCopy.lastUpdated = moment().toISOString();
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/plans/' + planCopy.uid] = planCopy;
            // reset our form

            return firebase.database().ref().update(updates)
            .then(function(){
              return vm.reset()
            })


        }// updatePlan

        vm.savePlan = function(plan){
          ajUTILITIES.removePropertiesWith(plan);
          var planUID = undefined;

          // if we have an id, we are just updating it
          if (_.has(plan, 'uid')){
            planUID = plan.uid
          } else {
            // if we don't have an id, we need to get one and add it
            planUID = plansRef.push().key;
            plan.uid = planUID;
          }

          plan.created = moment().toISOString();

          var updates = {};
          updates['/plans/' + planUID] = plan;

          // Add empty time entry...triggering a recalc on it's billingPeriod
          return firebase.database().ref().update(updates)

        }

        vm.reset = function(){
          vm.selectedPlan = undefined;
        }

        vm.isSelected = function(plan){
          if(vm.selectedPlan.planID == plan.planID){
            return true
          }
        }

        vm.addDetail = function(detail){
          var newDetailKey = plansRef.push().key;
          detail.uid = newDetailKey;
          var updates = {};
          updates['/plans/' + vm.selectedPlan.uid + '/details/' + detail.uid]  = detail;
          return firebase.database().ref().update(updates)
          .then(function(){
            vm.deSelectDetail();
          })
        }

        vm.selectDetail = function(detail){
          vm.newDetail = angular.copy(detail);
        };


        vm.deSelectDetail = function(){
          $timeout(function(){
            vm.newDetail = {};
          },0);
        };

        vm.updateDetail = function(detail){
          var updates = {};
          updates['/plans/' + vm.selectedPlan.uid + '/details/' + detail.uid]  = detail;
          return firebase.database().ref().update(updates)
          .then(function(){
            vm.deSelectDetail();
          })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('managePageController', managePageController);
        // managePageController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function managePageController($q, $log, $timeout) {

    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageNotificationsController', manageNotificationsController);
        // manageNotificationsController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageNotificationsController($q, $log, $window, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
    	var vm = this;
          vm.user = _userData;
          vm.notifications = [];
          vm.users = [];
          vm.tempArray = [];


          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of logs
            $timeout(function(){
              var usersRef = firebase.database().ref().child('/userList');
             $firebaseArray(usersRef)
             .$loaded(
                  function(users) {
                    // we only want valid users. Not old bad data
                    _.each(users, function(user){
                      if(_.has(user, 'uid')){
                        vm.users.push(user);
                      }
                    });
                  });

              }, 0);
          }

          vm.init = function(){
            vm.editedLog = {
              title: 'Notification Title',
              meta:'Meta Label',
              message:'Lorem ipsum dolor sit amet consectetur adipiscing elit curabitur tellus, fermentum libero cursus dui fames volutpat sollicitudin auctor integer sodales, aenean diam convallis sapien primis faucibus laoreet dictumst.',
              type:'task',
              related: undefined,
              user: $rootScope.userID
            };          }

            vm.init();


            vm.triggerToast = function(){
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: vm.editedLog.title,
                          message: vm.editedLog.message,
                          color: 'orange'
                      }
                  }));// mdToast
            }
          // vm.deleteLog = function(log){

          //   var updates = {};
          //   // store our canonical object - just update the PROFILE
          //   updates['/users/'+ log.user +'/notifications/' + log.uid] = null;
          //   firebase.database().ref().update(updates)
          //   vm.editedLog = null;
          // }

    	   // vm.selectLog = function(log){
    	   // 	// $log.info('selectUser' + userID);
    	   // 	var logRef = firebase.database().ref('users/'+ log.user +'/notifications/' + log.uid);
    	   // 	return $firebaseObject(logRef)
    	   // 	.$loaded(
    	   // 	    function(log) {
        //         // convert date into something our form can use
        //         log.date = moment(log.date).toDate();
    	   // 	    	// $log.info(user);
    	   // 	        vm.editedLog = log;
    	   // 	    });
    	   // } // vm.selectLog


        // vm.updateLog = function (log){
        //   // $log.info('updateLog');

        //   // make a copy so we don't modify what's being shown and throw a DOB error
        //   // var userCopy = angular.copy(user);
        //   var logCopy = angular.fromJson(angular.toJson(log));

        //   // convert date into something we can save
        //   logCopy.date = moment(logCopy.date).toISOString();
        //   // $log.info(logCopy);
        //   ajUTILITIES.removePropertiesWith(logCopy);
        //     var updates = {};
        //     // store our canonical object - just update the PROFILE
        //     updates['/users/'+ log.user +'/notifications/' + logCopy.uid] = logCopy;

        //     firebase.database().ref().update(updates)
        //     // vm.editedLog = null;

        // }// updateLog

        vm.sendToSelf = function(){
          vm.editedLog.user = vm.user.uid;
        }

        vm.sendToAll = function(){
          vm.editedLog.user = 'all';
        }

        vm.saveLog = function (notification){

          if(notification.user == 'all'){
            notification.targets = 'all'
          } else {
            notification.targets = [];
            var thisTarget = {
              userID: notification.user
            }
            notification.targets.push(thisTarget);
          }

          // if we are leaving this blank its throwing an error. Let's make sure its not there.
          if(!notification.related){
            delete notification.related
          }

          var newLogKey = firebase.database().ref().child('notifications').push().key;
          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          // var logCopy = angular.fromJson(angular.toJson(log));
          ajUTILITIES.removePropertiesWith(notification);
          notification.uid = newLogKey;
          notification.timeStamp = moment().toISOString();
          // firebase.database().ref().child('notifications').child(newLogKey).push(log);
          var updates = {};
          updates['notifications/'+ notification.uid] = notification;
          return firebase.database().ref().update(updates)
          .then(function(){
            vm.init();
            alert('Notification Sent');
          });

        }// updateLog

    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('cloneClientsController', cloneClientsController);
        // cloneClientsController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function cloneClientsController($q, $log, $timeout, panelDataService, taskPanelDataService, profileDataService, taskDataService, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, _clientData, fbService) {
        var vm = this;
            vm.user = _userData;
            vm.users = {};
            vm.clients = {};
            vm.updateClients = updateClients;
            vm.cloneClient = cloneClient;
            var clientSnapshot = {};
            var panelList = [];
            var newClientID = undefined;

            vm.triggerToast = function(toastTitle, toastMessage, color){
                if(!color){
                    var color = '#fff';
                }
                // $log.info('triggerToast');
                // $log.info(toastMessage);
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: toastTitle,
                            message: toastMessage,
                            color: color
                        }
                    }));
            }
            // Load up our list of users
            var usersRef = firebase.database().ref().child('/users');
            $firebaseArray(usersRef)
            .$loaded(
                function(users) {
                    // $log.debug(users);
                    vm.users = users;
                });

            //Update source Client List when User selection changes
            function updateClients(userID){
                vm.clients = {};
                var clientsRef = firebase.database().ref().child('/clients');
                $firebaseArray(clientsRef.orderByChild("access/users/" + userID).equalTo(true))
                    .$loaded(
                        function(clients) {
                            vm.clients = clients;
                            // $log.debug(clients);
                        });
            }// updateClients

            function cloneClient(){
                // $log.info('cloneClient');
                // Get Client Data
                _.each(vm.clients, function(client){
                    if (client.uid == vm.sourceClient){
                        clientSnapshot = angular.copy(client);
                    }
                });
                // Clone Client Object & Profile
                var clientClone = {
                    owner: vm.targetUser,
                    status: 'active',
                    access: {
                        users: {},
                        admins: {}
                    },
                    panels: {}
                }

                clientClone.profile = clientSnapshot.profile;
                clientClone.access.users[vm.targetUser] = true;
                clientClone.access.admins[vm.targetUser] = true;

                // Save our new client and get our new clientID to work with
                return clientDataService.saveNewClient(clientClone)
                .then(function(returnedID){
                    newClientID = returnedID;
                    // Clone Client Panels & Details
                    _.each(clientSnapshot.panels, function(panel){
                            var panelCopy = angular.copy(panel),
                                panelClone = {};
                            panelClone.client = newClientID;
                            panelClone.label = panelCopy.label;
                            panelClone.order = panelCopy.order;
                            panelClone.color = panelCopy.label;

                            var newPanelKey = firebase.database().ref().child('clients/' + panelClone.client + '/panels').push().key;
                           // make sure you store it's key location as a uid
                           panelClone.uid = newPanelKey;

                           var updates ={};
                           // store our canonical object
                           updates['/clients/' + panelClone.client + '/panels/' + newPanelKey] = panelClone;
                           return firebase.database().ref().update(updates)
                           .then(function(){
                                // Go through all of the details in this panel and put in the new panel
                                _.each(panelCopy.details, function(detail){
                                    // copy the detail
                                    var detailCopy = angular.copy(detail);
                                    // change the client and panel UIDs
                                    detail.client = panelClone.client;
                                    detail.panel = panelClone.uid;
                                    // Remove existing UID
                                    delete detail.uid;
                                    // Save it
                                    profileDataService.saveProfileDetail(detail);
                                });// each detail
                           });// Save New Panel promise
                    });//each panel

                })// Finished client panels
                .then(function(){
                    // Copy Task Panels

                    // Clone Task Panels
                    if(clientSnapshot.taskpanels){
                        _.each(clientSnapshot.taskpanels, function(taskpanel){
                            // Copy the panel
                            var panelCopy = angular.copy(taskpanel);
                            // fix it's client ID
                            panelCopy.client = newClientID;
                            // Save it and get the new UID
                            var newPanelKey = firebase.database().ref().child('clients/' + panelCopy.client + '/taskpanels').push().key;
                            // make sure you store it's key location as a uid
                            panelCopy.uid = newPanelKey;
                            var updates ={};
                            // store our canonical object
                            updates['/clients/' + panelCopy.client + '/taskpanels/' + newPanelKey] = panelCopy;
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                // Add old ID and new ID to panelList for cross ref later
                                panelList.push({
                                    old: taskpanel.uid,
                                    new: newPanelKey
                                });
                            });
                        });
                    }// if taskpanels
             })
            .then(function(){
                // $log.debug('getting tasks');
                // go through client tasks and grab each for processing
                _.each(clientSnapshot.tasks, function(task){
                    $timeout(function(){
                        return taskDataService.getTask(task.refID)
                        .then(function(thisTask){
                            // store our original
                            var originalTask = angular.toJson(thisTask);
                            // make our copy to resave
                            var newTask = angular.fromJson(originalTask);
                            // reset the client
                            newTask.info.client = vm.sourceClient;
                            //reset the creator
                            newTask.creator = vm.targetUser;
                            // And the assignee
                            newTask.info.assignee = vm.targetUser;
                            // Clean up variable that we are going to overwrite
                            delete newTask.$id;
                            delete newTask.$key;
                            delete newTask.$priority;
                            delete newTask.uid;
                            delete newTask.info.refID;
                            delete newTask.time;
                            delete newTask.activity;
                            newTask.info.numnotes = 0;

                            // If there's a panel assigned, look up it's new ID and change it
                            if (newTask.panel != "Later"){
                                _.each(panelList, function(panelID){
                                    // if we found the right panel
                                    if (panelID.old == newTask.panel){
                                        // replace ID with new panel's ID
                                        newTask.panel = panelID.new;
                                    }
                                });// each panelList
                            }// if not in "Later" panel

                            // Save our Task

                                return taskDataService.saveNew(newTask)


                        })// taskDataService.getTask
                    },200);

                })// each clientSnapshot.tasks
            });// clone chain

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('cleanupUsersController', cleanupUsersController);
        // cleanupUsersController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function cleanupUsersController($log, $timeout, $rootScope, $mdToast, $mdDialog,  $firebaseArray, $firebaseObject, userDataService) {
    	var vm = this;
      vm.user = userDataService.getUser();
      vm.authUsers = [];
      vm.noAuthUser = [];
      vm.badAuthUsers = [];
      vm.badUsers = []

      processSetupPromises();


      function processSetupPromises(){
        // console.log('Starting promise chain');
        const do_getAuthUsers = getAuthUsers();
        const do_getUsers = getUsers();
        const do_buildList = buildList();
        return Promise.all([do_getAuthUsers, do_getUsers])
          .then(function(){
            console.log('All Promises Executed. Making final object change.');
            buildList(vm.users, vm.authUsers);
          })
        //
      }// samplePromiseChainFunction


      // Load our array of authUsers with their tasks (just task.info).


      function getAuthUsers(){
          $log.info("getting authUsers");
          var authUsersRef = firebase.database().ref('auth-users/users');

          return $firebaseObject(authUsersRef)
          .$loaded(
              function(users) {
                $log.info('authUsers loaded');
                vm.authUsers = users;
              });
      }

      function getUsers(){
        var users = firebase.database().ref('users');
        return $firebaseObject(users)
        .$loaded(
            function(users) {
              $log.info('users loaded');
              vm.users = users;
            });
    }


    function buildList(users, authUsers){
      vm.tempBadAuthUsers = [];
      vm.tempNoAuthUsers = [];
      $log.info('buildList');
      // go through and mark found users
        _.each(authUsers, function(authUser){
          if(_.has(authUser, 'localId')){
            $log.info('checking ' + authUser.localId);
            var found = 0;
            if(_.has(vm.users, authUser.localId)){
              $log.info('found it');
              users[authUser.localId].found = true;
            }
          } else {
            $log.info('pppppppp');
            $log.info(authUser);
            $log.info('--------');
            vm.tempBadAuthUsers.push(authUser)
          }

        });
        vm.tempBadUsers = []
       // build array of non-found uers
        _.each(users, function(user){
          if(_.has(user, 'uid')){
            $log.info('checking ' + user.uid);
             if(!user.found){
               vm.tempNoAuthUsers.push(user);
             }
          } else {
            vm.tempBadUsers.push(user);
            $log.info('xxxxx');
            $log.info(user);
            $log.info('------');
          }

        });


        $timeout(function(){
          vm.badAuthUsers = vm.tempBadAuthUsers;
          vm.badUsers = vm.tempBadUsers;
          vm.noAuthUser = vm.tempNoAuthUsers;

        },500);
    }// buildList


    vm.retireUser = function(user){
      const do_removeClients = removeClients(user);
      const do_leaveTeams = leaveTeams(user.uid);
      return Promise.all([do_removeClients, do_leaveTeams])
        .then(function(){
          console.log('Clients deleting. Teams left.');
          return deleteUser(user)
        })

    }// retireUser


    function removeClients(user){
      var updates = {};
      if(_.has(user, 'clients')){
        var usersClients = Object.keys(user.clients);
          _.each(usersClients, function(client){
           var clientRef = firebase.database().ref('clients/' + client);
           clientRef.child('status').set('archiveAndDelete');
        });// each client
      };
    } // removeClients


    function leaveTeams(userID){
      var updates = {};
      var teamsRef = firebase.database().ref('teams/');
      $firebaseArray(teamsRef.orderByChild('members/' + userID + '/uid').equalTo(userID))
      .$loaded(function(teams){
          _.each(teams, function(team){
            updates['teams/' + team.ownerID + '/team/' + userID] = null;
          });
          // Execute changes
          return firebase.database().ref().update(updates)
          .then(function(){
            console.log('Removed from all teams');
          });
      })
    }// leaveTeams


    function deleteUser(user){
      var updates = {};
      // Execute changes
      updates['users/' + user.uid] = null;
      return firebase.database().ref().update(updates)
      .then(function(){
        $mdToast.show($mdToast.adminjaAlert(
            {
                locals:{
                    title: 'Woot!',
                    message: 'User ' + user.uid + ' has been deleted.' ,
                    color: 'green'
                }
            }));// mdToast
        console.log('User Deleted');
        $timeout(function(){user.removed = true;},200);
      });
    }// deleteUser

vm.cleanupNotifications = function(){
  var notificationsRef = firebase.database().ref('notifications');

  return $firebaseObject(notificationsRef)
  .$loaded(function(notifications) {
        var count = 0;
        _.each(notifications, function(notification){
          if(_.has(notification, 'uid')){
            $log.info(notification.uid);
            count = count + 1;
            if(count < 100){
              notificationsRef.child(notification.uid).set(null);
            }
          }
        });
        $log.info(count + 'notifications');
      });
} // cleanupNotifications

    }// cleanupUsersController
})();

(function() {
    'use strict';

    angular
        .module('adminToday', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('adminToday')
        .controller('adminTodayController', adminTodayController);

    /* @ngInject */
    function adminTodayController($log, $rootScope, triLoaderService, teamDataService, taskDataService, $timeout, dragulaService, taskPanelDataService, pageDimensionsService, userDataService, $scope, $firebaseArray, clientDataService, _userData, _clientData) {
        // $log.info('adminTodayController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;
        vm.user = _userData;
        vm.clients = _clientData;


        vm.now = new Date();
        vm.now = vm.now.toISOString();
        vm.groupTodayByClients = false;
        vm.clientLimit = 3;
        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }
        // If we don't have a groupToday setting, make one
        if (_.has(vm.user, 'profile.settings.groupToday')){
         vm.groupTodayByClients = vm.user.profile.settings.groupToday;
          // vm.user.profile.settings.groupToday = false;
        };



        function setupAllTasks(){
          vm.allTasks = [];
          vm.hasClients = _.size(vm.clients);
          // we really only want to be prepping this array if we are using it.
          // we don't use it if we are grouping today by client.
          if(!vm.groupTodayByClients){
            // concate all of our open client tasks into one array
            _.each(vm.clients, function(client){
                _.each(client.tasks, function(task){
                    vm.allTasks.push(task);
                });
            });
          }
        } // setupAllTasks

        // Setup allTasks
        setupAllTasks();

        // Watch vm.clients and update allTasks if it changes
        var unwatch = vm.clients.$watch(function() {
          // console.log("data changed!");
          $timeout(function(){
            setupAllTasks();
          },100);

        });

        $scope.$on('$destroy', function() {
            // $log.info('unwatching clients');
            unwatch();
        });



       // Force a resize to address a bug we can't solve
       $timeout(function(){
         pageDimensionsService.resizeColumns();
         triLoaderService.setLoaderActive(false);
       },300);

    }
})();

(function() {
    'use strict';

    angular
        .module('adminToday')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-today');

        $stateProvider
            .state('triangular.today', {
                url: '/today',
                templateUrl: 'app/admin-today/today.tmpl.html',
                // set the controller to load for this page
                controller: 'adminTodayController',
                controllerAs: 'vm',
                resolve: {
                    'currentAuth': ['authFactory', function(authFactory) {
                        return authFactory.$requireSignIn()
                    }],
                    // resolve our _userData and pass it to the Controller for saving
                     '_userData': ['userDataService', function(userDataService) {
                       return userDataService.getLoggedInUser()
                       .then(function(data){
                            return data
                       })
                    }]
                }

            });

        // send /dashboard requests to triangular.dashboard state
        // $urlRouterProvider.when(/dashboard/, ['$state','$match', function ($state, $match) {
        //   $state.go('triangular.dashboard');
        // }]);

        triMenuProvider.addMenu({
            name: 'Today',
            icon: 'zmdi zmdi-sun',
            type: 'link',
            state: 'triangular.today',
            priority: 4.0,
            class: 'icon-today'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('time', []);
})();

(function() {
    'use strict';

    angular
        .module('time')
        .controller('timeReportsController', timeReportsController);

    /* @ngInject */
    function timeReportsController($log, $scope, CSV, timeReportService, teamDataService, userDataService, pageDimensionsService, clientDataService, $mdMedia, $mdDialog, $rootScope, $timeout, $filter, hotkeys, $firebaseArray, _userData, _clientData) {
    var vm = this;

      init();

      function init(){
        vm.user = _userData;
        vm.timeReportService = timeReportService;
        vm.timeReportService.init();
        vm.retainerMode = false;
        vm.clients = $rootScope.quickClients;
        vm.maxDate = moment().toDate();
        vm.minDate = moment().subtract(2, 'years').toDate();
        vm.today = moment();

        // if this user already has report settings, use them
        if(_.has(vm.user, 'profile.settings.reportStart')){
          // $log.info('using stored settings');
          timeReportService.report.start = vm.user.profile.settings.reportStart;
          timeReportService.report.end = vm.user.profile.settings.reportEnd;
        }
        // Load up our teamlist for our filter menu
        getTeamList();
      }


      function putInView() {
          $('#scroll-h').animate({
              scrollLeft: 0
          }, 20, 'linear');
      }


      // Build the teamlist for our filtering menu
      // would be great if this was REALLY via a service
      // but we are using the service to populate $rootScope.currentTeamList
      // because we were having too much trouble and wasting too much time
      function getTeamList(){
          // repopulate $rootScope.currentTeamList
          vm.showTeamPicker = false;
          vm.teamList = [];
          vm.teamListLoading = true;
          vm.showAssignmentField = false;
          // Go through our teamList and attach their profile and email for displaying their menu items
          _.each(teamDataService.teamList, function(member){
            // make sure they are active
           if(member.status == 'active'){
            // get the user info and put it on our member
            var userRef = firebase.database().ref('users/' + member.uid);
            userRef.once('value').then(function (snapshot) {
                // The first promise succeeded. Save snapshot for later.
               var user = snapshot.val();
                // attach properties to member
                   member.profile = user.profile;
                   member.email = user.email;
                   vm.teamList.push(member);
              });// userRef.once
            }// if active
          });// each teamList

          // Gotta put it in timeout so it digests and detects change
          $timeout(function(){
              vm.teamListLoading = false;
              // show the teampicker if we really have a team
              if(_.size(vm.teamList)> 0){
                $timeout(function(){
                  vm.showTeamPicker = true;
                },0);
              } // if we really lhave a team
          },0);
      }


      vm.reportTime = function(group, entries){
          // $log.info('printTime');
          var title = "All Clients";
          if (vm.timeReportService.report.source == 'client'){
            _.each(vm.clients, function(client){
              if(client.uid == vm.timeReportService.report.selectedClient){
                  title = client.name;
              }
            });
          }// if source is client

          vm.printReport = {};
          vm.printReport.clientName = title;
          vm.printReport.start = group.start;
          vm.printReport.end = group.end;
          vm.printReport.type = 'time';
          vm.printReport.rate = 0;
          vm.printReport.allocated = 0;
          vm.printReport.time = entries;
          vm.printReport.total = vm.logTotal(vm.printReport.time);
          vm.printReport.filename = vm.groupTimeReportFilename(group) + '.pdf';
          putInView();
      }// printTime

      vm.reportAllTime = function(){
        var title = "All Clients";
        if (vm.timeReportService.report.source == 'client'){
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){
                title = client.name;
            }
          });
        }// if source is client
        vm.printReport = {};
        vm.printReport.clientName = title;
        vm.printReport.start = vm.timeReportService.report.start;
        vm.printReport.end = vm.timeReportService.report.end;
        vm.printReport.type = 'time';
        vm.printReport.rate = 0;
        vm.printReport.allocated = 0;
        vm.printReport.time = vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end);
        vm.printReport.total = vm.logTotal(vm.printReport.time);
        vm.printReport.filename = vm.allTimeReportFilename() + '.pdf';
        putInView();

      }// Print All Time

      // create array for populating our month/year drop downs.
      function setupMonthSelect(){
          var now = moment().startOf('month'),
              nowPlus = moment(now).add(1, 'month'),
              start = moment().subtract(23, 'months'),
              months = [];

          for (var m = moment(now); m.isAfter(start); m.subtract(1, 'month')) {
              var thisMonth = {
                   label: moment(m).format('MMM YYYY'),
                   date: moment(m).toISOString()
              }
              months.push(thisMonth);
          }
          vm.monthSelect = months;
      }

      setupMonthSelect();

      vm.allTimeReportFilename = function(){
        var filename = "";
        if(vm.timeReportService.report.source == 'all'){
          filename = 'all-clients-';
          filename = filename + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
          filename = filename;
          return filename
        } else {
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){
              filename = _.snakeCase(client.name);
              filename = filename + '-' + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
              filename = filename;
            };
          });
          return filename
        } // if/else
      }// vm.allTimeReportFilename

      vm.groupTimeReportFilename = function(group){
        var filename = "";
        if(vm.timeReportService.report.source == 'all'){
          filename = 'all-clients-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
          filename = filename;
          return filename
        } else {
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){
              filename = _.snakeCase(client.name);
              filename = filename + '-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
              filename = filename;
            };
          });
          return filename
        }// if else
      }// vm.grouopTimeReportFilename

      vm.viewRetainer = function(){
          // convert our current date range to begin/end of months to match up with our new month/year select menus
          // NOTE: subtacting 1 month for start date...otherwise we aren't getting everything
          vm.timeReportService.report.start = moment(vm.timeReportService.report.start).startOf('day').subtract(1,'month').toISOString();
          vm.timeReportService.report.end = moment(vm.timeReportService.report.end).endOf('day').toISOString();
          // Enable retainerMode
          vm.retainerMode = true;
          // Set our report view
          vm.timeReportService.report.view = 'retainer';
          // Update our report
          vm.updateReport();

      }

      vm.viewWeeks = function(){
        // Make sure retainerMode is off
        vm.retainerMode = false;
        // Set our report view
          vm.timeReportService.report.view = 'week';
        // Update our report
          vm.updateReport();


      }

      vm.viewMonths = function(){
          // Make sure retainerMode is off
          vm.retainerMode = false;
          // Set our View
          vm.timeReportService.report.view = 'month';
          // Update our report
          vm.updateReport();

      }

      // Detect deletions and update report
      $rootScope.$on('updateTimeReport', function(event, data) { vm.updateReport(); });

      vm.updateReport = function(){
        // $log.info('time-reports.controller.js - vm.updateReport');
        // Update time data
        if(vm.timeReportService.report.source == 'all'){
          vm.timeReportService.getEveryClientsTime(vm.clients, vm.timeReportService.report.end, vm.timeReportService.report.start);
        } else if (vm.timeReportService.report.source == 'client') {
          // $log.info('lets pull this client\'s time');
          vm.timeReportService.getClientsTime(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);
        }

        // Update our grouping data
        switch(vm.timeReportService.report.view) {
            case 'retainer':
                vm.timeReportService.setRetainerList(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);
                break;
            case 'week':
                vm.timeReportService.setWeekList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                break;
            case 'month':
                vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                break;
            default:
                vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
        } // switch vm.timeReportService.report.view

        // Update our default view range
        userDataService.changeUserSetting('reportStart', vm.timeReportService.report.start);
        userDataService.changeUserSetting('reportEnd', vm.timeReportService.report.end);
      }// vm.updateReport

      vm.updateReport();

      vm.switchSource = function(option){
        // Executed when client drop down is changed
        if(option == 'all'){
          // Showing all data for user
          vm.timeReportService.report.source = 'all';
          // Update report
          vm.updateReport();
        } else {
          // Showing data for specific client
          vm.timeReportService.report.source = 'client';
          // Update report
          vm.updateReport();
        }
      }// vm.switchSource


      // vm.switchMember = function(option){
      //    $timeout(function(){
      //    $scope.$apply();
      //    },200); // timeReportService.filterUsersTime(option);
      // }// vm.switchMember

      // Source of pre-filtered entries for each time group.
      // TODO - this is probably pretty expensive for big reports
      vm.groupEntries = function(start, end){
        var entries = [];
        start = moment(start).startOf('day').toISOString();
        end = moment(end).endOf('day').toISOString();
        _.each(vm.timeReportService.report.data, function(entry){
          if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){
            if(entry.logDate < end && entry.logDate >= start){
              entries.push(entry);
            }
          }// if passes userFilter

        });

        return entries
      }

      //live totals calculation for each group
      vm.logTotal = function (logs) {
          var total = 0;
          _.each(logs, function (entry) {
              total += entry.logged;
          })
          return total
      };

      // Functionality for downloading CSVs
      vm.downloadCSVFile = function(data, filename) {
                 var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
                 // $log.info(preppedData);
                 // var data = "text/json;charset=utf-8," + data;

                 var downloader = document.createElement('a');

                 downloader.setAttribute('href', preppedData);
                 downloader.setAttribute('download', filename + '.csv');
                 downloader.click();
             };

      vm.downloadCSV = function(logs, filename){
          // $log.info('downloadCSV');
          var cleanLogs = [];

          // Clean Up our logData (remove unnecessary things)
          _.each(logs, function(entry){

              // Get our clientname
              var clientName = "";
              if(!_.has(entry, 'clientName')){
                  clientName = entry.client;
              } else {
                  clientName = entry.clientName;
              }

              // get our taskName
              var taskName = 'none',
                  description = '';

              if(_.has(entry, 'taskName')){

                  taskName = entry.taskName;
                  // trim it
                  taskName = _.truncate(taskName, {
                                'length': 100,
                                'separator': ' '
                              });
                  // sanitize it (replace commas and line breaks)
                  taskName = _.replace(taskName,new RegExp(",","g"),"-");
                  taskName = _.replace(taskName,new RegExp("\n","g")," ");

              }

              if(!_.has(entry, 'taskName')){
                  taskName = "none";
              }

              if(_.has(entry, 'description')){
                // trim it
                description = _.truncate(entry.description, {
                              'length': 100,
                              'separator': ' '
                            });
                // sanitize it (replace commas and line breaks)
                description = _.replace(description,new RegExp(",","g"),"-");
                description = _.replace(description,new RegExp("\n","g")," ");

              }

              // build our new object
              var newCSVLog = {
                  'clientName': clientName,
                  'creatorName': entry.creatorName,
                  'description': description,
                  'logDate' :moment(entry.logDate).format('YYYY-MM-DD'),
                  'logged' : entry.logged,
                  'taskName': taskName
              }

              cleanLogs.push(newCSVLog);

          });

          // Set the header labels for our CSV file (note, we are accepting default alpha format)
          var csvOptions = {
              'header': [
                  'Client',
                  'User',
                  'Description',
                  'Date',
                  'Minutes',
                  'Task'
              ]
          }


          // Convert our json to CSV and start the download
          CSV.stringify(cleanLogs, csvOptions).then(function(result){
                     vm.downloadCSVFile(result, filename + '.csv');
                 });
      }// downloadCSV

      // deprecated - we are filtering within our vm.groupEntries function
      // vm.userFilter = function(entry){
      //   var thisResult = false;

      //   if(vm.timeReportService.report.selectedMember == 'all'){
      //     thisResult = true;
      //   }

      //   if(entry.creator == vm.timeReportService.report.selectedMember){
      //     thisResult = true;
      //     }

      //   return thisResult
      // };// userFilter

  	}; // end timeReportsController
})();

(function() {
    'use strict';

    angular
        .module('time')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triLayoutProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-time-reports');

        $stateProvider
            .state('triangular.time-reports', {
                url: '/time/',
                templateUrl: 'app/admin-time-reports/time-reports.tmpl.html',
                // set the controller to load for this page
                controller: 'timeReportsController',
                controllerAs: 'vm'
            });

        triMenuProvider.addMenu({
            name: 'Time',
            icon: 'zmdi zmdi-time',
            state: 'triangular.time-reports',
            type: 'link',
            priority: 6.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adminTeam', ['appServices', 'ngSanitize', 'ngAnimate'])
        .run(function ($state,$rootScope) {
        	// Put state on rootscope so we ALWAYS know what it is.
            $rootScope.$state = $state;

        });
})();

(function() {
    'use strict';

    angular
        .module('adminTeam')
        .controller('teamController', teamController);
        // teamController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function teamController($log, $mdToast, hotkeys, triLoaderService, teamDataService,  $window, $scope, $timeout, gateService, $rootScope, $mdDialog, clientDataService, userDataService, currentAuth, _userData, _clientData) {
        var vm = this;
        vm.clients = _clientData;
        vm.user = _userData;
        vm.today = moment();
        vm.hasTeams = true;
        vm.teamDataService = teamDataService;

        // Keep the loader up until we've built our page. Less herky jerky
        // $timeout(function(){
        //     triLoaderService.setLoaderActive(true);
        // },0)



        // teamDataService already has .team on it, exposing it to our view
        function init(){
            // vm.team = vm.teamDataService.team;
            vm.teamLimit = gateService.gateData.teamLimit;
            vm.hasTeams = gateService.gateData.hasTeams;
            vm.teamName = vm.user.profile.fullName;
            // We need to monitor the team
            vm.thisTeam = teamDataService.team;
            vm.subStatus = gateService.gateData.subStatus;

            vm.numMembers = function(){
                var count = 0;
                _.each(vm.teamDataService.team, function(member){
                    if(member.status != 'archived'){
                        count = count + 1;
                    }
                });
                return count
            }

            vm.teamsSetup = function(){
                // if they "hasTeams", and has a team limit, and teams have been setup
                if(vm.teamLimit >0 && vm.hasTeams && vm.numMembers() > 0 ){
                    return true
                } else {
                    return false
                }
            }

            vm.canAddMembers = function(){
                var count = 0;

                _.each(vm.teamDataService.team, function(member){
                    if(member.status != 'archived'){
                        count = count + 1;
                    }
                });

                return count < vm.teamLimit
            }
        }

        $timeout(function(){
            init();
            // $log.info(vm.numMembers);
            // $log.info(vm.teamLimit)

            // Watch vm.thisTeam and re-build the team arrays if it changes
            var unwatch = $scope.$watch('vm.thisTeam',function() {
              console.log("data changed!");
              // $timeout(function(){
              //   vm.teamDataService.init();
              // },100);

            });
            $scope.$on('$destroy', function() {
                // $log.info('unwatching clients');
                unwatch();
            });
            // $timeout(function(){
            //     triLoaderService.setLoaderActive(false);
            // },500);

        },0);


        // Support for showing appcues on demand
        vm.showCue = function(cue, flag){
            // trigger our primer
            Appcues.show(cue);

            // mark step complete
            $timeout(function(){
                vm.changeOnboardingFlag(flag, true);
            }, 5000);

        }


        vm.inviteMember = function(owner, numMembers){
            teamDataService.inviteDialog(owner, numMembers);
        }

        vm.setupTeam = function(owner, name){
            // return teamDataService.initializeTeam(owner, name)
            // .then(function(){
        //     vm.teamDataService.init();
            //       $mdToast.show($mdToast.adminjaAlert(
            //           {
            //               locals:{
            //                   title: 'Team Setup Complete!',
            //                   message: 'You can now invite people to your team!',
            //                   color: 'green'
            //               }
            //           }));// mdToast
            // });// then

        }

}// teamController
})();

(function () {
    'use strict';

    angular
            .module('adminTeam')
            .config(moduleConfig);
    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {

        $stateProvider
                .state('triangular.manage-team', {
                    abstract: false,
                    url: '/team',
                    templateUrl: 'app/admin-team/admin-team.tmpl.html',
                    // set the controller to load for this page
                    controller: 'teamController',
                    controllerAs: 'vm',
                    resolve: {
                        'currentAuth': ['authFactory', function (authFactory) {
                                return authFactory.$requireSignIn()
                            }],
                        // resolve our _userData and pass it to the Controller for saving
                        '_userData': ['userDataService', function (userDataService) {
                                return userDataService.getLoggedInUser()
                                        .then(function (data) {
                                            return data
                                        })
                            }]
                    }
                });

        // add our "Manage Clients" Menu item
        triMenuProvider.addMenu({
            name: 'My Team',
            state: 'triangular.manage-team',
            icon: 'fa fa-users',
            type: 'link',
            priority: 6
        });

    } // end moduleConfig



})();

(function() {
	'use strict';

	angular
		.module('tasks', ['appServices', 'ngAnimate']);
})();

(function() {
    'use strict';

    angular
        .module('tasks')
        .controller('tasksPageController', tasksPageController);

    /* @ngInject*/
    function tasksPageController($q, $log, $scope, $timeout, triLoaderService, teamDataService, pageDimensionsService, dragulaService, $rootScope, clientDataService, taskDataService, profileDataService, localStorageService, $mdToast, _userData, _clientData) {
        var vm = this;
        // $log.info('tasksPageController');

        // reset teamDataService to make sure we have updated member lists for user drop downs
        // teamDataService.init();



        vm.user = _userData;
        vm.clients = _clientData;
        vm.clientCount = _.size(vm.clients);
        vm.now = new Date();
        vm.now = vm.now.toISOString();
        vm.verticalTaskPanels = vm.user.profile.settings.verticalTaskPanels;
        if (vm.user.profile.settings.verticalTaskPanels){
            vm.taskDragDirection = 'vertical'
        } else {
            vm.taskDragDirection = 'horizontal'
        }

        vm.loading = false;
        vm.clientLimit = 3;



        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }


        // $log.info(vm.clients);

        // clear clientID so client toolbar isn't displayed
        $rootScope.activeClientID = null;

        function setupAllTasks(){
            vm.allTasks = [];
            // if we aren't showing completed items
            // and if we aren't showing the today panel
            // we shouldn't be prepping this big array on every change
            if (vm.user.profile.settings.showTodayPanel || !vm.user.profile.settings.hideCompletedPanel){
                // concate all of our open client tasks into one array
                _.each(vm.clients, function(client){
                    _.each(client.tasks, function(task){
                        vm.allTasks.push(task);
                    });
                });
            }
        } // setupAllTasks

        // Setup allTasks
        setupAllTasks();


        // Watch vm.clients and update allTasks if it changes
        var unwatch = vm.clients.$watch(function() {
          // console.log("data changed!");
          $timeout(function(){
            setupAllTasks();
          },100);

        });

        $scope.$on('$destroy', function() {
            // $log.info('unwatching clients');
            unwatch();
        });

        $scope.removeLoader = function(){
            $timeout(function(){
                triLoaderService.setLoaderActive(false);
            },0);

        }

        // Helps with the complicated filtering necessary for the "today" columns
        $scope.todayFilter = function(task) {
            return task.panel === 'due' || task.panel === 'today' || task.duedate <= vm.now;
        };

        $scope.laterFilter = function(task) {
            // $log.info(task.duedate + ' - ' + vm.now);
            return !task.duedate || task.duedate > vm.now;
        };

        $scope.userFilter = function(task){
            if(_.has(teamDataService, 'filteredMember')){
                if(task.assignee == teamDataService.filteredMember){
                    return true
                } else { return false}
            } else {
                return true
            }
        }// userFilter



            // New Task
        $scope.newTask = function(clientID, panel) {
                // $log.info('newTask');
                //make empty editedDetail object
                $scope.editedItem = taskDataService.newTask(clientID, panel);
                // Set our dialogTitle
                $scope.dialogTitle = "New";
                // console.log($scope.editedItem);
                taskDataService.taskDialog($scope.editedItem);
            } // end newTask


        // Dragula Setup
        dragulaService.options($scope, 'drag-task', {
             moves: function (el, container, handle) {
               return handle.classList.contains('task-handle');
             },
             accepts: function(el, target, source, sibling) {
                if (target == source){
                  return true
                }
            },
             direction: vm.taskDragDirection
           });




        // Regular panel Task Drop Listener
        $scope.$on('drag-task.drop', function(event, item, target, source, sibling){
            // $log.info('drag-task.drop');
            // $log.info(target);
            var itemID = item[0].attributes.taskid.nodeValue,
                clientID = item[0].attributes.client.nodeValue,
                newOrder = undefined;

                // $log.info(targetPanelID);

                // $log.info(target);
                // $log(itemID, parentPanelID, clientID, targetPanelID);

                 // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
                 if (sibling != undefined){
                    // this check is to make sure other tasks that don't have an order set don't throw an error
                    if (!sibling[0].attributes.order.nodeValue){
                        newOrder = undefined;
                    } else {
                        // sibling has an order, figure our ours from there
                        newOrder = sibling[0].attributes.order.nodeValue;
                    }
                 }

                // just moving within the same panel
                sortTasks(target[0], clientID);

                // resize our columns
                if (!vm.verticalTaskPanels){
                    $timeout(function(){
                      pageDimensionsService.resizeColumns();
                      // heap.track('Tasks Reordered');
                    },200);
                } else {
                    $timeout(function(){
                      pageDimensionsService.resizeColumns('vertical');
                      // heap.track('Tasks Reordered');
                    },200);
                }




        });// $on.drag-task.drop



        function sortTasks(panel, clientID){

            // debugger
            // $log.info('sortTasks');

            // // Isolate this panel thanks to it's panelid attribute
            var sortingPanel = panel;
            // $(sortingPanel).css('background-color', 'yellow');
            // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedTasks = $(sortingPanel).find('app-item');

            // // set our DB references
            var tasksRef = firebase.database().ref('tasks/');
            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

            // // Update each item in firebase by ID
            _.each(sortedTasks, function(task, index){
                var newOrder = parseInt(index) + 1,
                    taskID = task.getAttribute('taskid');

                    // Update the database
                     var updates = {};
                     // store our canonical object
                     updates['tasks/' + taskID + '/info/allOrder'] = newOrder;
                     // store our reference in the client's store
                     updates['clients/' + clientID + '/tasks/' + taskID + '/allOrder'] = newOrder;
                     // Execute our update
                     return firebase.database().ref().update(updates)
                     .then(function(){
                        // $log.info('sorted');
                     });
            })
        }// sortTasks

    } // tasksPageController
})();

(function() {
    'use strict';

    angular
        .module('tasks')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-tasks');

        $stateProvider
            .state('triangular.tasks-page', {
                views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/layouts/toolbar/adminja-tasks-toolbar.tmpl.html',
                            controller: 'ToolbarController',
                            controllerAs: 'vm'
                        },
                        '@triangular': {
                            templateUrl: 'app/admin-tasks/tasks-page.tmpl.html',
                            controller: 'tasksPageController',
                            controllerAs: 'vm'
                        }
                    },
                url: '/tasks',
                // templateUrl: 'app/admin-tasks/tasks-page.tmpl.html',
                // // set the controller to load for this page
                // controller: 'tasksPageController',
                // controllerAs: 'vm',
                resolve: {
                    'currentAuth': ['authFactory', function(authFactory) {
                        return authFactory.$requireSignIn()
                    }],
                    // resolve our _userData and pass it to the Controller for saving
                     '_userData': ['userDataService', function(userDataService) {
                       return userDataService.getLoggedInUser()
                       .then(function(data){
                            return data
                       })
                    }]
                }

            });

        triMenuProvider.addMenu({
            name: 'All&nbsp;Tasks',
            icon: 'fa fa-check-square-o',
            type: 'link',
            state: 'triangular.tasks-page',
            priority: 5.0
            // badge: Math.round(Math.random() * (100 - 1) + 1)
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('adminSetup')
        .config(moduleConfig)
        .run(authenticationRun);


    /* @ngInject */
    function authenticationRun($rootScope){
        var topRange = 18,
            bottomRange = 10;

        // Pick a random number and use it to set our rotating background class on auth pages
        var random = Math.floor(Math.random() * ((topRange-bottomRange)+1) + bottomRange);
        // $rootScope.authBackground = "mb-bg-12"
        $rootScope.authBackground = "mb-bg-" + random;
        // console.log(random);
    }

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-setup');

        $stateProvider
        .state('setup', {
            abstract: true,
            views:{
                'root':{
                    templateUrl: 'app/admin-setup/layouts/setup.tmpl.html'
                }
            }

            // url: '/authentication'
        })
        .state('setup.profile', {
            url: '/setup/profile',
            templateUrl: 'app/admin-setup/profile/setup-profile.tmpl.html',
            controller: 'setupProfileController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }

            // ,
            //         resolve: {
            //           checkUser: ['$firebaseAuth', '$state',function($firebaseAuth, $state) {
            //             console.log('--login checkUser--');
            //               if (firebase.auth().currentUser.uid){
            //                 $state.transitionTo('triangular.dashboard');
            //               }
            //           }]
            //         }
        })
        .state('setup.clients', {
            url: '/setup/clients',
            templateUrl: 'app/admin-setup/clients/setup-clients.tmpl.html',
            controller: 'setupClientsController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })

    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager', ['appServices', 'ngSanitize', 'ngAnimate'])
        .run(function ($state,$rootScope) {
        	// Put state on rootscope so we ALWAYS know what it is.
            $rootScope.$state = $state;

        });
})();

(function () {
    'use strict';

    angular
            .module('clientManager')
            .controller('clientTimeController', clientTimeController);

    /* @ngInject */
    function clientTimeController($q, $log, $mdDialog, teamDataService, timeDataService, timeReportService, CSV, userDataService, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, _userData, _clientData) {
        // $log.info('clientTimeController');
        var vm = this;
        vm.user = _userData;
        vm.timeReportService = timeReportService;
        vm.timeReportService.init();
        vm.retainerMode = false;
        vm.maxDate = moment().toDate();
        vm.minDate = moment().subtract(2, 'years').toDate();
        vm.clients = _clientData;


        // Restrict our reporting to just this client
        vm.timeReportService.report.source = $stateParams.clientID;
        vm.timeReportService.report.selectedClient = $stateParams.clientID;
        // vm.timeReportService.report.uid = vm.client.uid;

        // Declare this so we don't thrown an error before we are setup
        vm.teamList = {};
        // Init function
        function init(){
          // Identify thisClient
          vm.thisClient = _.find(vm.clients, function (client) {
              return client.uid == $stateParams.clientID;
          });
          // $log.info('Client:');
          // $log.info(vm.thisClient);
            setupMonthSelect();
            vm.updateReport();
            // $log.info('Teams');
            // $log.info(teamDataService.clientTeams);
            // $log.info('thisTeam');
            // $log.info(teamDataService.clientTeams[vm.thisClient.uid]);
            vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
            vm.teamDataService = teamDataService;
            // $log.info('Team:');
            // $log.info(vm.teamList);

        } // init

        // Setup the report service and the page
        // in a $timeout becuase for some reason, refreshing on a client-time page was inhibiting rightsidenav.controller.js to get the user info.
        // suspicion is collision during init here running in concurrence
        $timeout(function(){init();}, 1500);


        vm.showTeamFilter = function(){
         if (_.size(vm.teamList) > 1){
             return true
         }
        }


        function putInView() {
            $('#scroll-h').animate({
                scrollLeft: 0
            }, 20, 'linear');
        }

        vm.reportTime = function(group, entries){
            // $log.info('printTime');
            vm.printReport = {};
            vm.printReport.clientName = vm.thisClient.profile.fullName;
            vm.printReport.start = group.start;
            vm.printReport.end = group.end;
            vm.printReport.type = vm.thisClient.profile.plan.type;
            vm.printReport.rate = vm.thisClient.profile.plan.rate;
            vm.printReport.allocated = vm.thisClient.profile.plan.allocated;
            vm.printReport.time = entries;
            vm.printReport.total = vm.logTotal(vm.printReport.time);
            vm.printReport.filename = vm.groupTimeReportFilename(group) + '.pdf';
            putInView();
        }

        vm.reportAllTime = function(){
          vm.printReport = {};
          vm.printReport.clientName = vm.thisClient.profile.fullName;
          vm.printReport.start = vm.timeReportService.report.start;
          vm.printReport.end = vm.timeReportService.report.end;
          vm.printReport.type = 'time';
          vm.printReport.rate = 0;
          vm.printReport.allocated = 0;
          vm.printReport.time = vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end);
          vm.printReport.total = vm.logTotal(vm.printReport.time);
          vm.printReport.filename = vm.allTimeReportFilename() + '.pdf';
          putInView();
        }// Print All Time

        // create array for populating our month/year drop downs.
        function setupMonthSelect(){
            var now = moment().startOf('month'),
                nowPlus = moment(now).add(1, 'month'),
                start = moment().subtract(23, 'months'),
                months = [];

            for (var m = moment(now); m.isAfter(start); m.subtract(1, 'month')) {
                var thisMonth = {
                     label: moment(m).format('MMM YYYY'),
                     date: moment(m).toISOString()
                }
                months.push(thisMonth);
            }
            vm.monthSelect = months;
        }

        vm.groupTimeReportFilename = function(group){
          var filename = "";
          if(vm.timeReportService.report.source == 'user'){
            filename = 'all-clients-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
            return filename
          } else {
            _.each(vm.clients, function(client){
              if(client.uid == vm.timeReportService.report.selectedClient){
                filename = _.snakeCase(client.profile.fullName);
                filename = filename + '-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
              };
            });
            return filename
          }// if else
        }// vm.grouopTimeReportFilename

       vm.allTimeReportFilename = function(){
         var filename = "";
         if(vm.timeReportService.report.source == 'user'){
           filename = 'all-clients-';
           filename = filename + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
           return filename
         } else {
           _.each(vm.clients, function(client){
             if(client.uid == vm.timeReportService.report.selectedClient){
               filename = _.snakeCase(client.profile.fullName);
               filename = filename + '-' + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
             };
           });
           return filename
         } // if/else
       }// vm.allTimeReportFilename




        vm.viewRetainer = function(){
            // convert our current date range to begin/end of months to match up with our new month/year select menus
            // vm.timeReportService.report.start = moment(vm.timeReportService.report.start).startOf('month').toISOString();
            // vm.timeReportService.report.end = moment(vm.timeReportService.report.end).startOf('month').toISOString();
            // NOTE: subtacting 1 month for start date...otherwise we aren't getting everything
            vm.timeReportService.report.start = moment(vm.timeReportService.report.start).subtract(1,'month').toISOString();
            vm.timeReportService.report.end = moment(vm.timeReportService.report.end).toISOString();
            // Enable retainerMode
            vm.retainerMode = true;
            // Set our report view
            vm.timeReportService.report.view = 'retainer';
            // Update our report
            vm.updateReport();

        }

        vm.viewWeeks = function(){
          // Make sure retainerMode is off
          vm.retainerMode = false;
          // Set our report view
            vm.timeReportService.report.view = 'week';
          // Update our report
            vm.updateReport();


        }

        vm.viewMonths = function(){
            // Make sure retainerMode is off
            vm.retainerMode = false;
            // Set our View
            vm.timeReportService.report.view = 'month';
            // Update our report
            vm.updateReport();

        }


        // Detect deletions and update report
        $rootScope.$on('updateTimeReport', function(event, data) { vm.updateReport(); });
        vm.updateReport = function(){
          // $log.info('client-time.controller.js - vm.updateReport');
          delete vm.printReport;

          // Update time data

            // $log.info('lets pull this client\'s time');
            vm.timeReportService.getClientsTime(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);


          // $log.info(vm.timeReportService.report.data);
          // Update our grouping data
          switch(vm.timeReportService.report.view) {
              case 'retainer':
                  vm.timeReportService.setRetainerList(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);
                  // $log.info('Setting retainerList');
                  // $log.info(moment(vm.timeReportService.report.start).toISOString());
                  // $log.info(moment(vm.timeReportService.report.end).toISOString());
                  break;
              case 'week':
                  vm.timeReportService.setWeekList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                  break;
              case 'month':
                  vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                  break;
              default:
                  vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
          } // switch vm.timeReportService.report.view

          // Update our default view range
          userDataService.changeUserSetting('reportStart', vm.timeReportService.report.start);
          userDataService.changeUserSetting('reportEnd', vm.timeReportService.report.end);
        }// vm.updateReport


        // Source of pre-filtered entries for each time group.
        // TODO - this is probably pretty expensive for big reports
        vm.groupEntries = function(start, end){
          // $log.info('groupEntries');
          // $log.info(vm.timeReportService.report.data);

          // Convert to UTC for easy math
          start = moment(start).utc();
          end = moment(end).utc();

          // $log.info(moment(start).toISOString() + '-' + moment(end).toISOString());
          var entries = [];
          _.each(vm.timeReportService.report.data, function(entry){
            // Convert to utc for accurate comparison
            if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){
              var entryLogDate = moment(entry.logDate).utc();
              if(entryLogDate < end && entryLogDate >= start){
                entries.push(entry);
              }// if in date range
            }// if passes userFilter
          });

          return entries
        }

        //live totals calculation for each group
        vm.logTotal = function (logs) {
            var total = 0;
            _.each(logs, function (entry) {
                total += entry.logged;
            })
            return total
        };

        // Functionality for downloading CSVs
        vm.downloadCSVFile = function(data, filename) {
                   var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
                   // $log.info(preppedData);
                   // var data = "text/json;charset=utf-8," + data;

                   var downloader = document.createElement('a');

                   downloader.setAttribute('href', preppedData);
                   downloader.setAttribute('download', filename + '.csv');
                   downloader.click();
               };

        vm.downloadCSV = function(logs, filename){

            var cleanLogs = [];

            // Clean Up our logData (remove unnecessary things)
            _.each(logs, function(entry){

                // Get our clientname
                var clientName = "";
                if(!_.has(entry, 'clientName')){
                    clientName = entry.client;
                } else {
                    clientName = entry.clientName;
                }

                // get our taskName
                var taskName = 'none',
                    description = '';
                if(_.has(entry, 'taskName')){
                    taskName = entry.taskName;
                    // trim it
                    taskName = _.truncate(taskName, {
                                  'length': 100,
                                  'separator': ' '
                                });
                    // sanitize it (replace commas and line breaks)
                    taskName = _.replace(taskName,new RegExp(",","g"),"-");
                    taskName = _.replace(taskName,new RegExp("\n","g")," ");

                    // $log.info(taskName);
                }


                if(_.has(entry, 'description')){
                  // trim it
                  description = _.truncate(entry.description, {
                                'length': 100,
                                'separator': ' '
                              });
                  // sanitize it (replace commas and line breaks)
                  description = _.replace(description,new RegExp(",","g"),"-");
                  description = _.replace(description,new RegExp("\n","g")," ");

                  // $log.info(description);
                }

                // build our new object
                var newCSVLog = {
                    'clientName': clientName,
                    'creatorName': entry.creatorName,
                    'description': description,
                    'logDate' :moment(entry.logDate).format('YYYY-MM-DD'),
                    'logged' : entry.logged,
                    'taskName': taskName
                }

                cleanLogs.push(newCSVLog);

            });

            // Set the header labels for our CSV file (note, we are accepting default alpha format)
            var csvOptions = {
                'header': [
                    'Client',
                    'User',
                    'Description',
                    'Date',
                    'Minutes',
                    'Task'
                ]
            }


            // Convert our json to CSV and start the download
            CSV.stringify(cleanLogs, csvOptions).then(function(result){
                    // $log.info(result);
                       vm.downloadCSVFile(result, filename + '.csv');
                   });
        }



    };// end clientTimeController


})();

 (function () {
    'use strict';

    angular
            .module('clientManager')
            .controller('clientTasksController', clientTasksController);

    /* @ngInject */
    function clientTasksController($q, $log, $window, gateService, dragulaService, taskPanelDataService, userDataService, teamDataService, $firebaseArray, localStorageService, panelDataService, $sanitize, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, pageDimensionsService, $mdDialog, _userData, _clientData) {
        // $log.info('clientTasksController');
        var vm = this;
        vm.user = _userData;
        vm.canUseTimer = false;



        if(_.has(vm.user, 'profile.settings.verticalTaskPanels')){
            if(vm.user.profile.settings.verticalTaskPanels){
                vm.taskDragDirection = "vertical"
            } else {
                vm.taskDragDirection = "horizontal"
            }
        }

        if(_.has(vm.user, 'profile.settings.verticalProfilePanels')){
            if(vm.user.profile.settings.verticalProfilePanels){
                vm.profileDragDirection = "vertical"
            } else {
                vm.profileDragDirection = "horizontal"
            }
        }

        // This is unfortunate. But when we interact with a timer via task card controls,
        // and then leave this $state and come back, our user doesn't have gates any longer.
        // Until we can guarantee the user will always be whole...we have to do this _.has check
        // if(_.has(vm.user, 'gates.canUseTimer')){
        //     vm.canUseTimer = vm.user.gates.canUseTimer;
        // }

        vm.canUseTimer = gateService.gateData.canUseTimer;
        vm.verticalTaskPanels = vm.user.profile.settings.verticalTaskPanels;

        vm.hideCompletedPanel = false;
        if(_.has(vm.user, 'profile.settings.hideCompletedPanel')){
            vm.hideCompletedPanel = vm.user.profile.settings.hideCompletedPanel;
        }



        vm.suppressResize = false;

        if (vm.verticalTaskPanels === true){
            vm.suppressResize = true;
        }

        vm.now = new Date();
        vm.now = vm.now.toISOString();
        vm.userID = localStorageService.get('userID');
        vm.clientID = $stateParams.clientID;
        // Get our client data
        vm.thisClient = _.find(_clientData, function (client) {
            return client.uid == $stateParams.clientID;
        });
        vm.clients = _clientData;
        vm.showToday = false;

        // reset teamDataService to make sure we have updated member lists for user drop downs
        vm.teamDataService = teamDataService;

        // vm.teamDataService.init();


        // If we have a showClientTodayPanel setting, use it
        if (_.has(vm.user, 'profile.settings.showClientTodayPanel')) {
            vm.showToday = vm.user.profile.settings.showClientTodayPanel;
            // vm.user.profile.settings.groupToday = false;
        }
        ;

        // store small subset of properties globally so our toolbar has easy info
        $rootScope.thisClient = vm.thisClient.profile;
        $scope.numPanels = _.size(vm.thisClient.taskpanels);

        // We need $state to be avail to client-card directive to determine what elements in client card should be shown
        $rootScope.$state = $state;

        // set "today" for our duedate comparisons
        $scope.today = new Date();
        $scope.today = $scope.today.toISOString();

        // we need this filter to be able to show appropriate items in today and waiting panels.
        $scope.todayFilter = function (task) {
            return  task.duedate <= vm.now | task.focus === 'today';
        };

        $scope.inboxFilter = function (task) {
            return task.status == 'open' && (task.panel == 'Later' || task.panel == 'backlog' || task.panel == 'waiting' || task.panel === 'due' || task.panel === 'today')
        };

        $scope.userFilter = function(task){
            if(_.has(teamDataService, 'filteredMember')){
                if(task.assignee == teamDataService.filteredMember){
                    return true
                } else { return false}
            } else {
                return true
            }
        }// userFilter


        // Our Scrolling Helpers
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        }

        function scroll(amount) {
            $('#scroll-h').animate({
                scrollLeft: amount
            }, 50, 'linear');
        }

        // Dragula Setup

        // Panel Dragging
        dragulaService.options($scope, 'drag-task-panel', {
            moves: function (el, container, handle) {
                return handle.classList.contains('panel-drag-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                if ($(target).is('.scroll-trigger')){
                    // we can't drop on scroll-triggers
                    if($(target).is('.scroll-trigger-right') && $rootScope.draggingPanel){
                        var scrollAmount = '+=20';
                      debounce(scroll(scrollAmount), 250)
                    }
                    if($(target).is('.scroll-trigger-left') && $rootScope.draggingPanel){
                       var scrollAmount = '-=20';
                        debounce(scroll(scrollAmount), 250)
                    }
                    return false
                }
                else {
                    return true
                }

            },
            allowNestedContainers: true,
            direction: 'horizontal',
            revertOnSpill: true
        });


        // Task Dragging
        dragulaService.options($scope, 'drag-task', {
            moves: function (el, container, handle) {
                return handle.classList.contains('task-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                if ($(target).is('.scroll-trigger')){
                    // we can't drop on scroll-triggers
                    if($(target).is('.scroll-trigger-right') && $rootScope.draggingTask){
                        var scrollAmount = '+=20';
                      debounce(scroll(scrollAmount), 250)
                    }
                    if($(target).is('.scroll-trigger-left') && $rootScope.draggingTask){
                       var scrollAmount = '-=20';
                        debounce(scroll(scrollAmount), 250)
                    }
                    return false
                }
                else {
                    return true
                }

            },
            direction: vm.taskDragDirection,
            revertOnSpill: true
        });




        // Setup our scrolling triggers and listeners
        $rootScope.draggingTask = false;
        $rootScope.draggingPanel = false;

        // Function checks to see if we SHOULD show overflow scrollTrigger areas
        $scope.checkOverflow = function() {
            var scrollH = $('#scroll-h'),
                target = scrollH[0];
               if (target.offsetHeight < target.scrollHeight ||
                      target.offsetWidth < target.scrollWidth) {
                      // your element have overflow
                  return true
                    } else {
                      // your element doesn't have overflow
                      return false
                    }
        };

        $scope.$on('drag-task.drag', function(){
            if($scope.checkOverflow()){
                $rootScope.draggingTask = true;
            }
        });
        $scope.$on('drag-task.cancel', function(){
            $rootScope.draggingTask = false;
        });
        $scope.$on('drag-task-panel.drag', function(){
            if($scope.checkOverflow()){
                $rootScope.draggingPanel = true;
            }
        });
        $scope.$on('drag-task-panel.cancel', function(){
            $rootScope.draggingPanel = false;
        });


        // Regular panel Task Drop Listener
        $scope.$on('drag-task.drop', function (event, item, target, source, sibling) {
            // $log.info('drag-task.drop');
                $timeout(function(){$rootScope.draggingTask = false;},100);
                var itemID = item[0].attributes.taskid.nodeValue,
                        parentPanelID = item[0].attributes.taskpanel.nodeValue,
                        clientID = item[0].attributes.client.nodeValue,
                        targetPanelID = target[0].attributes.panelid.nodeValue,
                        newOrder = undefined;

                // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
                if (sibling != undefined) {
                    // this check is to make sure other tasks that don't have an order set don't throw an error
                    if (!sibling[0].attributes.order.nodeValue) {
                        newOrder = undefined;
                    } else {
                        // sibling has an order, figure our ours from there
                        newOrder = sibling[0].attributes.order.nodeValue;
                    }
                }

                if (parentPanelID == targetPanelID) {
                    // just moving within the same panel
                    sortTasks(target[0], clientID);
                    // resize our columns
                    if (!vm.suppressResize){
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                            // heap.track('Tasks Reordered');
                        }, 500);
                    }


                } else {
                    // moving betwixt panels
                    return moveToPanel(itemID, parentPanelID, target[0], clientID, newOrder)
                            .then(function () {
                            })
                            .then(function () {
                                if(!vm.suppressResize){
                                    pageDimensionsService.resizeColumns();
                                }

                            });

                }// if moving or just reordering
        });// $on.drag-task.drop

        /////////////////////////////////////////////
        // drag-profile-detail over function


        // If over a task container
        $scope.$on('drag-task.over', function (event, el, target, source) {
            // $log.info('over');
            // $log.info(target);
            if( (target[0].$$hashKey != source[0].$$hashKey) && (!_.has(target[0].classList, 'scroll-trigger')) ){
                pageDimensionsService.resizeColumns();
            }

        });

        /////////////////////////////////////////////
        // drag-profile-detail over function
        $scope.$on('drag-task.out', function (event, el, target, source) {

            if(target[0].$$hashKey != source[0].$$hashKey && (!_.has(target[0].classList, 'scroll-trigger')) ){
                pageDimensionsService.resizeColumns();
            }
        });

        // Task Panel Drop Listener\
        $scope.$on('drag-task-panel.drop', function (event, item) {
            // $log.info(event);
            // $log.info(item);
            $rootScope.draggingPanel = false;
            // heap.track('Task Panel Moved');
            var droppedPanelID = item[0].attributes.panelid.nodeValue,
                    clientID = item[0].attributes.client.nodeValue;

            // $log.info(item);
            // $log.info(droppedPanelID + 'dropped in client ' + clientID);
            // grab all of the panels directly from the DOM to ensure we have the correct sort order
            // make sure we don't accidentally pick up dragula's .gu-mirror copy that was used
            // and hidden during the drag process
            var sortedPanels = $('.task-panel:not(".gu-mirror")');

            // set our DB reference
            var panelsRef = firebase.database().ref('clients/' + clientID + '/taskpanels');

            // Update each item in firebase by ID
            _.each(sortedPanels, function (panel, index) {
                // $log.info(panel);
                var newOrder = index + 1,
                        panelID = panel.getAttribute('panelid');
                // $log.info(panelID);
                // update JUST the order value on the detail
                panelsRef.child(panelID).child('order').set(newOrder);
            })

        });

        function moveToPanel(itemID, parentPanelID, targetPanel, clientID, newOrder) {
            // $log.info('moveToPanel');
            // $log.info(targetPanel);
            var targetPanelID = targetPanel.attributes.panelid.nodeValue;
            // $log.info(targetPanelID);
            // get a canonical copy of our detail
            return taskDataService.getTask(itemID)
                    .then(function (task) {

                        // isolate the task.info (that's all we work with)
                        var movedTask = task.info;

                        // change our panel and set our order to just before the dropped sibling
                        movedTask.panel = targetPanelID;

                        // assign new order just short of siblings (will be fixed to integer on sort)
                        if (newOrder) {
                            // $log.info('order was passed' + newOrder);
                            movedTask.order = parseInt(newOrder) - .1;
                        }

                        // Update our database
                        var updates = {};
                        // update the .info of our canonical object in /tasks
                        updates['tasks/' + movedTask.refID + '/info'] = movedTask;
                        // update our reference in the client's tasks
                        updates['clients/' + clientID + '/tasks/' + movedTask.refID] = movedTask;
                        // Execute our update
                        return firebase.database().ref().update(updates)
                                .then(function () {
                                    // $log.info('moved..sorting')
                                    $timeout(function () {
                                        sortTasks(targetPanel, clientID);
                                    }, 0);
                                    // heap.track('Task Card Moved');
                                });

                    }) // getTask.then

        }// moveToPanel

        function sortTasks(panel, clientID) {
            var panelID = panel.attributes.panelid.nodeValue;
            // debugger
            // $log.info('sortTasks');

            // // Isolate this panel thanks to it's panelid attribute
            var sortingPanel = panel;
            // $(sortingPanel).css('background-color', 'yellow');
            // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedTasks = $(sortingPanel).find('app-item');

            // // set our DB references
            var tasksRef = firebase.database().ref('tasks/');
            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

            // // Update each item in firebase by ID
            _.each(sortedTasks, function (task, index) {
                var newOrder = parseInt(index) + 1,
                        taskID = task.getAttribute('taskid');

                // Update the database
                var updates = {};

                // TODO:if we are sorting in a today column....set the todayorder, not the regular order


                // store our canonical object
                updates['tasks/' + taskID + '/info/order'] = newOrder;
                // store our reference in the client's store
                updates['clients/' + clientID + '/tasks/' + taskID + '/order'] = newOrder;
                // Execute our update
                return firebase.database().ref().update(updates)
                        .then(function () {
                            // $log.info('sorted');
                        });
            })
        }// sortTasks

        function sortTodayTasks(panel, clientID) {
            var panelID = panel.attributes.panelid.nodeValue;
            // debugger
            // $log.info('sortTodayTasks');

            // // Isolate this panel thanks to it's panelid attribute
            var sortingPanel = panel;
            // $(sortingPanel).css('background-color', 'yellow');
            // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedTasks = $(sortingPanel).find('app-item');

            // // set our DB references
            var tasksRef = firebase.database().ref('tasks/');
            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

            // // Update each item in firebase by ID
            _.each(sortedTasks, function (task, index) {
                var newOrder = parseInt(index) + 1,
                        taskID = task.getAttribute('taskid');

                // Update the database
                var updates = {};
                // store our canonical object
                updates['tasks/' + taskID + '/info/todayorder'] = newOrder;
                // store our reference in the client's store
                updates['clients/' + clientID + '/tasks/' + taskID + '/todayorder'] = newOrder;
                // Execute our update
                return firebase.database().ref().update(updates)
                        .then(function () {
                            // $log.info('sorted');
                        });
            })
        }// sortTodayTasks



        vm.newTaskPanel = function (client) {
            // $log.info('newPanel (tasks) triggered');
            taskPanelDataService.newPanel(client.uid);
        };

        vm.toggleShowToday = function () {
            // $log.info('Toggle Show Today panel clicked');
            if (vm.showToday == false) {
                vm.showToday = true;
            } else {
                vm.showToday = false;
            }
        };

        vm.editTaskPanel = function (panel) {
            // $log.info('editPanel (tasks) triggered');
            taskPanelDataService.editPanel(panel);
        };

        vm.newTask = function (clientID, panel) {
            // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
            $scope.editedItem = taskDataService.newTask(clientID, panel);
            // Set our dialogTitle
            $scope.dialogTitle = "New";
            // console.log($scope.editedItem);
            taskDataService.taskDialog($scope.editedItem);
        }

        vm.batchTasks = function(clientID, panel){
            return taskDataService.batchDialog(clientID, panel);
        }




    }
    ;// end clientTasksController


})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientTaskTemplatesController', clientTaskTemplatesController);
        // clientTaskTemplatesController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */

    function clientTaskTemplatesController($log, $state, gateService, taskDataService, $stateParams, taskTemplateDataService,  $scope, dragulaService, $timeout, $rootScope, $mdDialog,  _clientData) {
        var vm = this;
        vm.clients = _clientData;
        // $log.info('clientTaskTemplatesController');
        // not sure whay, but we can't use vm. here for our controller. Despite controllerAs.
        // $scope.user = _userData;

        // $scope.clients = _clientData;
        vm.recurringLimit = gateService.gateData.recurringLimit;
        vm.clientID = $stateParams.clientID;
        vm.thisClient = _.find(_clientData, function (client) {
            return client.uid == vm.clientID;
        });
        // store small subset of properties globally so our toolbar has easy info
        $rootScope.thisClient = vm.thisClient.profile;


        vm.newTaskTemplate = function(client){
            // $log.info('newTemplate');
            // $log.info('recurrringLimit: ' + vm.recurringLimit);
            // if no limit, or if they are under their limit, or if they were delegated this workspace start a new taskTemplate
            if(vm.recurringLimit == 0 || (_.size(vm.thisClient.taskTemplates) < vm.recurringLimit) || vm.thisClient.owner != $rootScope.userID){
                var template =  taskTemplateDataService.newTaskTemplate(client);
                taskDataService.taskDialog(template);
            } else {
                var confirm = $mdDialog.confirm()
                         .title('You\'ve reached your Recurring Task limit for this Workspace')
                         .htmlContent('Your current plan limits you to ' + vm.recurringLimit + ' recurring tasks per Workspace.')
                         .ariaLabel('Change subscription?')
                         .ok('Ok')
                         .cancel('Get more Recurring Tasks');

                   $mdDialog.show(confirm).then(function() {

                   }, function() {

                    $state.go('authentication.profile', {selectedTab: 2});
                   });
            }

            // otherwise throw a dialog pushing them to upgrade
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientProfileController', clientProfileController);



        /* @ngInject */
        function clientProfileController($scope, $q, $log, gateService, triLayout, panelDataService, $sanitize, $http, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, pageDimensionsService, templateDataService, profileDataService, $mdDialog, $mdMedia, _userData, _clientData, triLoaderService, dragulaService) {
        var vm = this;
        vm.user = _userData;
        vm.canUseTimer = gateService.gateData.canUseTimer;

        if(_.has(vm.user, 'profile.settings.verticalTaskPanels')){
            if(vm.user.profile.settings.verticalTaskPanels){
                vm.taskDragDirection = "vertical"
            } else {
                vm.taskDragDirection = "horizontal"
            }
        }

        if(_.has(vm.user, 'profile.settings.verticalProfilePanels')){
            if(vm.user.profile.settings.verticalProfilePanels){
                vm.profileDragDirection = "vertical"
            } else {
                vm.profileDragDirection = "horizontal"
            }
        }
        // turn the loader on
        // triLoaderService.setLoaderActive(true);
        // $timeout(function(){
        //   triLoaderService.setLoaderActive(false);
        // },300);

        $scope.launchPrimer = function(){
          // $log.info('launchPrimer clicked');
            Appcues.show($rootScope.tutorials.manageClientProfile);
        };

        $scope.itemsBackground = function itemsBackground(color){
          // $log.info('itemsBackground', color);
          if(color){
            var newColor = ajUTILITIES.lightenDarkenColor(color, 120);
            // $log.info(newColor);
            return newColor
          }
        }


        // $log.info('clientProfileController');
        // for some reason (maybe because we are in a child state?)
        // 'vm' isn't accessible in the template

        $scope.client = _.find(_clientData, function(client) { return client.uid == $stateParams.clientID; });


        $scope.showPrimer = function(){
          if (_.has($scope, 'client.panels')){
              if (_.size($scope.client.panels) < 2){
                return true
              } else {
                return false
              }
        } else {
          return true
        }
      };

        // store small subset of properties globally so our toolbar has easy info
        if (_.has($scope, 'client.profile')){
            $rootScope.thisClient = $scope.client.profile;
               };


        // $log.info('clientProfileController');
      // NOTE: $scope.user, and $scope.client client has already been established by our parent controller (clientManagerPageController)

        // We need $state to be avail to client-card directive to determine what elements in client card should be shown
        $rootScope.$state = $state;

        $rootScope.draggingDetail = false;
        $rootScope.draggingPanel = false;

        // Our Scrolling Helpers
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        }

        function scroll(amount) {
            $('#scroll-h').animate({
                scrollLeft: amount
            }, 20, 'linear');
        }

        // Dragula Setup
        dragulaService.options($scope, 'drag-profile-panel', {
             moves: function (el, container, handle) {
               return handle.classList.contains('panel-drag-handle');
             },
             accepts: function (el, target, source, sibling) {
                 // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                 if ($(target).is('.scroll-trigger')){
                     // we can't drop on scroll-triggers
                     if($(target).is('.scroll-trigger-right') && $rootScope.draggingPanel){
                         var scrollAmount = '+=20';
                       debounce(scroll(scrollAmount), 250)
                     }
                     if($(target).is('.scroll-trigger-left') && $rootScope.draggingPanel){
                        var scrollAmount = '-=20';
                         debounce(scroll(scrollAmount), 250)
                     }
                     return false
                 }
                 else {
                     return true
                 }

             },
             allowNestedContainers: true,
             direction: 'horizontal',
             revertOnSpill: true
           });

        dragulaService.options($scope, 'drag-profile-detail', {

            moves: function (el, container, handle) {
               return handle.classList.contains('detail-handle');
               // return true
             },

            accepts: function(el, target, source, sibling) {
               // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                  if ($(target).is('.scroll-trigger')){
                      // we can't drop on scroll-triggers
                      if($(target).is('.scroll-trigger-right') && $rootScope.draggingDetail){
                          var scrollAmount = '+=20';
                        debounce(scroll(scrollAmount), 250)
                      }
                      if($(target).is('.scroll-trigger-left') && $rootScope.draggingDetail){
                         var scrollAmount = '-=20';
                          debounce(scroll(scrollAmount), 250)
                      }
                      return false
                  }
                  else {
                      return true
                  }
               },


            direction: vm.profileDragDirection,
            revertOnSpill: true
            // ,
            // copy:true


           });

        // Function checks to see if we SHOULD show overflow scrollTrigger areas
        $scope.checkOverflow = function() {
            var scrollH = $('#scroll-h'),
                target = scrollH[0];
               if (target.offsetHeight < target.scrollHeight ||
                      target.offsetWidth < target.scrollWidth) {
                      // your element have overflow
                  return true
                    } else {
                      // your element doesn't have overflow
                      return false
                    }
        };

        $scope.$on('drag-profile-panel.drag', function(){
            if($scope.checkOverflow()){
                $rootScope.draggingPanel = true;
            }

        });

        $scope.$on('drag-profile-panel.cancel', function(){
              $rootScope.draggingPanel = false;

        });
        $scope.$on('drag-profile-detail.drag', function(){
            if($scope.checkOverflow()){
                $rootScope.draggingDetail = true;
            }

        });

        $scope.$on('drag-profile-detail.cancel', function(){
              $rootScope.draggingDetail = false;

        });

        $scope.$on('drag-profile-panel.drop', function (event, item) {
          // $log.info(event);
          // $log.info(item);
          $timeout(function(){$rootScope.draggingPanel = false;},100);
          // heap.track('Profile Panel Moved');
          var droppedPanelID = item[0].attributes.panelid.nodeValue,
              clientID = item[0].attributes.client.nodeValue;
          // $log.info(droppedPanelID + 'dropped in client ' + clientID);
          // grab all of the panels directly from the DOM to ensure we have the correct sort order
          // make sure we don't accidentally pick up dragula's .gu-mirror copy that was used
          // and hidden during the drag process
          var sortedPanels = $('profile-panel:not(".gu-mirror")');

          // set our DB reference
          var panelsRef = firebase.database().ref('clients/' + clientID + '/panels');

          // Update each item in firebase by ID
          _.each(sortedPanels, function(panel, index){
            // If this isn't our undeletable Client Details panel, re-order it
              var newOrder = index+1,
                  panelID = panel.getAttribute('panelid');
                  // $log.info(panelID);
              // update JUST the order value on the detail
              panelsRef.child(panelID).child('order').set(newOrder);

            // $log.info(panel);

          })

      });// $on.drag-profile-panel.drop
    };// end clientProfileController





})();

(function () {
    'use strict';

    angular
            .module('clientManager')
            .config(moduleConfig);



    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {

        $stateProvider
                .state('triangular.client-manager-page', {
                    abstract: true,
                    views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/admin-client-manager/client-manager-toolbar.tmpl.html',
                            controller: 'clientManagerToolbarController',
                            controllerAs: 'vm'
                        }
                    },
                    url: '/clients/:clientID',
                    templateUrl: 'app/admin-client-manager/client-manager-page.tmpl.html',
                    // set the controller to load for this page
                    controller: 'clientManagerPageController',
                    controllerAs: 'vm',
                    resolve: {
                        'currentAuth': ['authFactory', function (authFactory) {
                                return authFactory.$requireSignIn()
                            }],
                        // resolve our _userData and pass it to the Controller for saving
                        '_userData': ['userDataService', function (userDataService) {
                                return userDataService.getLoggedInUser()
                                        .then(function (data) {
                                            return data
                                        })
                            }]
                    }
                })
                .state('triangular.manage-clients', {
                    url: '/manage-clients',
                    views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/layouts/toolbar/adminja-toolbar.tmpl.html',
                            controller: 'clientManagerToolbarController',
                            controllerAs: 'vm'
                        },
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-manager-clients.tmpl.html',
                            controller: 'manageClientsController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.client-manager-page.tasks', {
                    url: '',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-tasks.tmpl.html',
                            controller: 'clientTasksController',
                            controllerAs: 'vm'
                        }
                    }
                })

                .state('triangular.client-manager-page.information', {
                    url: '/information',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-profile.tmpl.html',
                            controller: 'clientProfileController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.client-manager-page.time', {
                    url: '/time',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-time.tmpl.html',
                            controller: 'clientTimeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        // // resolve our timeLog and pass it to the Controller for saving
                        // '_timeLogs': ['timeDataService', '$stateParams', function (timeDataService, $stateParams) {
                        //         var today = new Date();
                        //         var year = today.getFullYear()
                        //         return timeDataService.getClientTime($stateParams.clientID, year)
                        //                 .then(function (data) {
                        //                     return data
                        //                 })
                        //     }],
                        // '_retainerTimeLogs': ['timeDataService', '$stateParams', function (timeDataService, $stateParams) {
                        //         // var today = new Date('2017-02-10'); // mishu - not sure why this was hardcoded so I'm using Today
                        //         var today = new Date();
                        //         var year = today.getFullYear()
                        //         return timeDataService.getClientTime($stateParams.clientID, year)
                        //                 .then(function (data) {
                        //                     return data
                        //                 })
                        //     }]
                    }

                })


                .state('triangular.client-manager-page.task-templates', {
                    url: '/templates',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-task-templates.tmpl.html',
                            controller: 'clientTaskTemplatesController',
                            controllerAs: 'vm'
                        }
                    }
                })

                .state('triangular.client-manager-page.client-billing', {
                    url: '/billing',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-billing.tmpl.html',
                            controller: 'clientBillingController',
                            controllerAs: 'vm'
                        }
                    }
                });


    } // end moduleConfig



})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('clientManagerToolbarController', clientManagerToolbarController);

    /* @ngInject */
    function clientManagerToolbarController($log, $scope, gateService, $injector, $rootScope, $mdMedia, $state, teamDataService, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, userDataService, clientDataService, $stateParams, _userData) {
        // $log.info('clientManagerToolbarController');
        // For some reason, we absolutely don't have access to vm in our view. But Scope works just fine
        var vm = this;
            vm.user = _userData,
            vm.thisClient = $state.params.clientID;



        $scope.teamList = {};
        // In a timeout to make sure the view gets the info
        $scope.isOwner = false;
       $timeout(function(){
            $scope.teamList = teamDataService.clientTeams[vm.thisClient];
            $scope.teamDataService = teamDataService;
            $scope.hasRecurring = gateService.gateData.hasRecurring;
            $scope.hasBilling = gateService.gateData.hasBilling;
            $scope.canViewTime = gateService.gateData.canViewTime;
            $scope.client = clientDataService.easyClient($state.params.clientID);

            if($scope.client.owner == vm.user.uid){
                $scope.isOwner = true;
            }

       },2000);

       $scope.showTeamFilter = function(){
        if (_.size($scope.teamList) > 1){
            return true
        }
       }

        $scope.currentPage = function(){
            var page = undefined;
            if($state.includes('triangular.client-manager-page.information')){
                page = "Profile"
            }
            if($state.includes('triangular.client-manager-page.tasks')){
                page = "Tasks"
            }
            if($state.includes('triangular.client-manager-page.time')){
                page = "Time"
            }
            if($state.includes('triangular.client-manager-page.task-templates')){
                page = "Recurring"
            }
            if($state.includes('triangular.client-manager-page.client-billing')){
                page = "Billing"
            }
            // $log.info(page);
            return page
        }

        $scope.isActive = function(value){
            if($state.includes(value)){
                return true
            }
        }


        $scope.isTasks = function(){
            if($state.includes('tasks')){
                return true
            }
        }

        // $log.info($scope.hasRecurring);

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;

        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        // $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $rootScope.showToday = false;

       ///

       $scope.filterUser = function(user){
        if(user != 'all'){
            // alert('Will trigger filtering to user ' + userID);
            // alert the parent controller of the new filter
            teamDataService.filteredMember = user.uid;
            teamDataService.filteredMemberName = user.profile.firstName;
        } else {
            delete teamDataService.filteredMember;
            delete teamDataService.filteredMemberName;
        }
       }// filterUser

        function changeState(newState){
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientManagerPageController', clientManagerPageController);

    /* @ngInject */
    function clientManagerPageController($q, $log, panelDataService, $sanitize, $http, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, pageDimensionsService, templateDataService, profileDataService, $mdDialog, $mdMedia, _userData, _clientData) {
        // $log.info('clientManagerPageController');
        // var vm = this;


    }; // end clientManagerPageController


})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('manageClientsController', manageClientsController);
        // manageClientsController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */

    function manageClientsController($log, $window, $firebaseArray, $scope, dragulaService, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, currentAuth, _userData, _clientData) {
        // $log.info('manageClientsController');
        // not sure whay, but we can't use vm. here for our controller. Despite controllerAs.
        $scope.user = _userData;
        $scope.spacesView = 'active';
        $scope.clients = _clientData;
          $scope.clientLimit = 2;
        if (_.has($scope.user, 'limits.clients')){
            $scope.clientLimit = $scope.user.limits.clients;
        }

          $timeout(function(){
            var archivedRef = firebase.database().ref().child('/clients');
            $firebaseArray(archivedRef.orderByChild("access/archiveOwner/" + $scope.user.uid).equalTo(true))
            .$loaded(
                function(archivedClients) {
                    $scope.archivedClients = archivedClients;
                });

          },0);




        $scope.archiveFilter = function(item){
          if (item.status == 'archived' || item.status == 'deleting'){
            return true
          } else {
            return false
          }
        }
        $scope.restoreClient = function(client, event){
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: green; padding-bottom: 1em; margin:0;">You are requesting to restore the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- The restoration can take up to 5 minutes.</li><li>- You will need to manually re-set this space\'s Due Dates, Recurring Tasks and Billing Periods.</li><li>- A Space can only be restored from archive once every 15 days.</li><li>- If you need have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Restore')
                  .targetEvent(event)
                  .ok('Restore')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             return clientDataService.restoreClient(client)
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });

        }


        $scope.deleteClient = function (client) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                    .title('PERMANENTLY delete this client and all of their data?')
                    .textContent(client.profile.firstname + ' ' + client.profile.lastname)
                    .ariaLabel('Delete client? Y//N')
                    .targetEvent(client)
                    .ok('Yes, Delete')
                    .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                clientDataService.deleteClient(client);
                // Refresh Client Menu
                // $log.info('deleting - regenerating client menu');
                // triMenu.removeMenu('triangular.client-manager-page');
                // clientDataService.setupClientMenu();
                $mdDialog.cancel();
                //     $state.go('triangular.manage-clients');
                //     $mdToast.show(
                //             $mdToast.simple()
                //             .textContent('Removed Client')
                //             .position('top right')
                //             .hideDelay(2000)
                //             );
              });


        }// delete client


        // // load up the clients for this page in a synchronized array
        // return clientDataService.thisUsersClients($scope.user.uid)
        // .then(function(clients){
        //     $scope.clients = clients;
        //     // $log.info($scope.clients);
        // })

        // Dragula Setup
        dragulaService.options($scope, 'client-sort', {
             moves: function (el, container, handle) {
               return handle.classList.contains('drag-handle');
             },
             accepts: function(){
                return true
             },
             // allowNestedContainers: true,
             direction: 'vertical'

           });

            $scope.launchPrimer = function(){
                Appcues.show($rootScope.tutorials.manageClients);
            };

        $scope.$on('client-sort.drop', function (event, el, target, source, sibling) {
            var sortingPanel = $('.account-card-container');
            // $(sortingPanel).css('background-color', 'yellow');
            // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedClients = $(sortingPanel).find('.client-card');

            // set our DB reference
            var clientsRef = firebase.database().ref('clients/');

            // Update each item in firebase by ID
            _.each(sortedClients, function(client, index){
                var newOrder = parseInt(index) + 1,
                    clientID = client.getAttribute('uid');
                // update JUST the order value on the panel
                clientsRef.child(clientID).child('order').set(newOrder);
            });

            // Force (true) Refresh our client menu
            clientDataService.setupClientMenu(true);
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientBillingController', clientBillingController);
        // clientBillingController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function clientBillingController($mdToast, $log, hotkeys, taskDataService, $stateParams,  $window, $scope, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, clientBillingService, timeReportService, timeDataService, invoiceService, currentAuth, _userData, _clientData) {
        var vm = this;
        vm.clients = _clientData;
        vm.user = _userData;
        vm.newEntry = {};
        vm.newPayment = {};
        vm.newPayment.date = moment().toDate();
        vm.clientBillingService = clientBillingService;
        vm.invoiceService = invoiceService;
        vm.today = moment();
        vm.timeReportService = timeReportService;
        vm.now = moment().toISOString();

       // Watch for changes in which period is selected and reset our form
      $scope.$watch('vm.clientBillingService.selectedPeriod', function() {
            // Only do something IF we have a periodForm.
             if(_.has(vm, 'periodForm')){
                vm.periodForm.$setPristine();
            }
         });


        // Support for showing appcues on demand
        vm.showCue = function(cue, flag){
            // trigger our primer
            Appcues.show(cue);

            // mark step complete
            $timeout(function(){
                vm.changeOnboardingFlag(flag, true);
            }, 5000);

        }


        vm.isCurrentPeriod = function(client, period){
            var now = moment().toISOString();
            if (period.info.start <= now && period.info.end >= now){
                return true
            } else {
                return false
            }
        }

        vm.enableEditPeriod = function(ev){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                  .title('Edit Billing Period Range: Are you Sure?')
                  .htmlContent('<span style="color: red;"><b>ONLY</b> edit this range if you know what you are doing.</span> <ul><li>- Please make sure none of your billing period ranges overlap.</li><li>- Please make sure the MOST RECENT billing period ends the day before this client\'s next cycle date.</li><li>- If you need assistance. Please submit a help desk ticket.</li></ul>')                  .ariaLabel('Confirm Edit')
                  .targetEvent(ev)
                  .ok('I know what I\'m Doing')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
              vm.editPeriod = true;
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
            });

        }
        vm.cancelEditPeriod = function(){
            vm.editPeriod = false;
            // Clear the service's current selected period
            delete vm.clientBillingService.selectedPeriod;
        }

        vm.changeOnboardingFlag = function(flag, value){
            // $log.info('updateSettings');
            userDataService.changeOnboardingFlag(flag, value);

            // Tag it in Drip
            // if(value){
            //     _dcq.push(["identify", {
            //      email: userDataService.user.email,
            //      tags: ["onBoarding: " + flag]
            //    }]);
            // } else {
            //      _dcq.push(["identify", {
            //       email: userDataService.user.email,
            //       remove_tags: ["onBoarding: " + flag]
            //     }]);
            // }
            // Update our local data
            userDataService.getLoggedInUser();
        } // vm.updateSettings

        // Clear the service's current selected period
        delete vm.clientBillingService.selectedPeriod;

        // Clear the service's selected arrays
        delete vm.invoiceService.selectedInvoice;
        delete vm.invoiceService.selectedTime

        // set our currency if user has selected one
         vm.currency = "$";
        if (_.has(userDataService.user.profile, 'settings.currency')){
             vm.currency = userDataService.user.profile.settings.currency;
         }
         // currency set

        // Identify thisClient
        vm.thisClient = _.find(vm.clients, function (client) {
            return client.uid == $stateParams.clientID;
        });

        // init our invoice service
        vm.invoiceService.init(vm.thisClient);


        // Calculate total time logged in this period
        vm.used = function(){
            var hours = vm.clientBillingService.selectedPeriod.info.logged / 60;
            return hours

        }// vm.used

        // Calc hours remaining in current period
        vm.remain = function(){
            return vm.clientBillingService.selectedPeriod.info.allocated - vm.used()
        }

        // Calculates total cost of hourly time logged
        vm.timeTotal = function(){
            var total = vm.clientBillingService.selectedPeriod.info.rate * vm.used();
            total = total.toFixed(2);
            return total
        }

        // Update allocated field (via inline editing)
        vm.updateAllocated = function(data){
            vm.clientBillingService.selectedPeriod.info.allocated = data;
        }
        // Update allocated field (via inline editing)
        vm.updateRate = function(data){
            vm.clientBillingService.selectedPeriod.info.rate = data;
        }

        // Update the database with the local copy
        vm.updatePeriod = function(){
            vm.editPeriod = false;
            // $log.info('vm.updatePeriod');
            return clientBillingService.updateBillingPeriod(vm.clientBillingService.selectedPeriod.info)
            .then(function(){
                // so our view updates
                $timeout(function(){
                    vm.periodForm.$setPristine();
                }, 1000);

                // Trigger a total recalc for this period
                timeDataService.triggerReCalc(vm.clientBillingService.selectedPeriod);
                // deselect the billing period
                delete vm.clientBillingService.selectedPeriod

            })
            // send updated period to clientBillingService
        }


        // store small subset of properties globally so our toolbar  has easy info
        $rootScope.thisClient = vm.thisClient.profile;


        // Trigger appcues
        $timeout(function(){
                if ($window.Appcues) {
                    $window.Appcues.start();
                }
            }, 1000)


        //// Line Entry Management
        vm.newEntry.date = moment().toDate();

        vm.addNewEntry = function(newEntry){
            // $log.info('vm.addNewEntry:', newEntry);
            // make a copy so we aren't dealing with $ nodes
            var newEntryCopy = angular.copy(newEntry);
            // Convert date to ISOString
            newEntryCopy.date = moment(newEntryCopy.date).toISOString();
            // Set our Ref
            var entryRef = firebase.database().ref('billingPeriods/' + vm.clientBillingService.selectedPeriod.uid + '/lineItems/');
            // Get our new key
            var newKey = entryRef.push().key;
            // Save our key on our object
            newEntryCopy.uid = newKey;
            // Store the object
            entryRef.child(newKey).set(newEntryCopy);
            // Clear the form
            vm.newEntry = {};
            vm.newEntry.date = moment().toDate();
        } // vm.addNewEntry

        vm.addNewPayment = function(newPayment){
            // $log.info('vm.addNewPayment:', newPayment);
            // make a copy so we aren't dealing with $ nodes
            var newPaymentCopy = angular.copy(newPayment);
            // Convert date to ISOString
            newPaymentCopy.date = moment(newPaymentCopy.date).toISOString();
            // Set our Ref
            var paymentRef = firebase.database().ref('invoices/' + vm.invoiceService.selectedInvoice.uid + '/info/payments/');
            // Get our new key
            var newKey = paymentRef.push().key;
            // Save our key on our object
            newPaymentCopy.uid = newKey;

            // Store the object
            paymentRef.child(newKey).set(newPaymentCopy);
            // Clear the form
            vm.newPayment = {};
            vm.newPayment.date = moment().toDate();

            // heap.track('Payment Applied');
            //  _dcq.push(["identify", {
            //   email: userDataService.user.email,
            //   tags: ["Applied a Payment"]
            // }]);
            // Update our invoice to store new calculcation
            vm.updateInvoice();
        } // vm.addNewPayment

        vm.removePayment = function(payment){
            // $log.info(payment);
            // $log.info(vm.invoiceService.selectedInvoice.info.payments);
            var updatedPayments = [];
            _.each(vm.invoiceService.selectedInvoice.info.payments, function(item){
                // $log.info(item);
                if(item.uid != payment.uid){
                    updatedPayments.push(item);
                }
            });
            // var updatedPayments = _.remove(vm.invoiceService.selectedInvoice.info.payments, function(item) {
            //   $log.info(item);
            //   return item.uid != payment.uid;
            // });

            // $log.info(updatedPayments);
            vm.invoiceService.selectedInvoice.info.payments = updatedPayments;
            // heap.track('Payment Removed');
            // // ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
            vm.updateInvoice();
        }// vm.removePayment

        vm.invoiceDue = function(){
            var due = 0,
                paid = 0,
                amount = vm.invoiceTotal();
                if(_.has(vm.invoiceService.selectedInvoice, 'info.payments')){
                    _.each(vm.invoiceService.selectedInvoice.info.payments, function(payment){
                        paid = paid + Number(payment.amount);
                    });
                }

            due = amount - paid;
            // function may run after invoice removed.
            // make sure we aren't assigning to undefined
            if(_.has(vm.invoiceService, 'selectedInvoice.info')){
                vm.invoiceService.selectedInvoice.info.balance = due;
            }
            return due
        }

        vm.deleteEntry = function(entry){
            // $log.info(Object.keys(entry));
           //  $log.info(entryID);
            var entryRef = firebase.database().ref('billingPeriods/' + vm.clientBillingService.selectedPeriod.uid + '/lineItems/');
           entryRef.child(entry.uid).set(null);
        }

        // Toggling for line items
        vm.toggleAllEntries = function() {
            // $log.info('toggleAllEntries');
            var toggleStatus = !vm.isAllSelected;
            angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced){
                    item.selected = toggleStatus;
                }
            });

         }// vm.toggleAllEntries

         vm.optionToggled = function(){
            var isAllSelected = true;
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if (!item.selected){
                    isAllSelected = false;
                }
            });
           vm.isAllSelected = isAllSelected
         }// vm.optionToggled


         vm.markItemsPending = function(){
            angular.forEach(vm.timeReportService.report.data, function(item){
              if(!item.invoiced && item.selected){
                    item.selected = false;
                   item.pending = true;
              }
          });
              angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced && item.selected){
                    item.selected = false;
                     item.pending = true;
                }
            });
         }// markItemsPending

         vm.removeAllPending = function(){
            angular.forEach(vm.timeReportService.report.data, function(item){
              if(!item.invoiced){
                    item.selected = false;
                   item.pending = false;
              }
          });
              angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced){
                    item.selected = false;
                     item.pending = false;
                }
            });
         }// removeAllPending

         // Toggling for time entries
         vm.toggleAllTimeEntries = function() {
             // $log.info('toggleAllEntries');
             var toggleStatus = !vm.isAllTimeSelected;
             angular.forEach(vm.timeReportService.report.data, function(item){
               if(!item.invoiced){
                    item.selected = toggleStatus;
               }
            });
          }// vm.toggleAllTimeEntries

          vm.timeOptionToggled = function(){
             var isAllSelected = true;
             _.each(vm.timeReportService.report.data, function(item){
                 if (!item.selected){
                     isAllSelected = false;
                 }
             });
            vm.isAllTimeSelected = isAllSelected
          }// vm.timeOptionToggled

          vm.areInvoiceItemsSelected = function(){
            var areSelected = false;
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if (item.selected){
                    areSelected = true;
                }
            });

            // If this is an hourly billingPeriod, then we need to check to see if any time is
            // selected as well
            if(vm.clientBillingService.selectedPeriod.info.type =='hourly'){
                _.each(vm.timeReportService.report.data, function(entry){
                    if (entry.selected){
                        areSelected = true;
                    }
                });
            }
            return areSelected
          }// vm.areInvoiceItemsSelected

          vm.arePrintableItemsSelected = function(){
            var areSelected = false;
            _.each(vm.timeReportService.report.data, function(item){
                if (item.selected){
                    areSelected = true;
                }
            });
            return areSelected
          }// vm.areInvoiceItemsSelected

          ////////////
          // Invoice Handling
          vm.invoiceSelectedLineItems = function(){
            var sendItems = [],
                sendTime = [];

            // Gather our lineItems
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    sendItems.push(itemCopy);
                }
            });

            // Gather our time
            _.each(vm.timeReportService.report.data, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    ajUTILITIES.removePropertiesWith(itemCopy);
                    itemCopy.rate = vm.clientBillingService.selectedPeriod.info.rate;
                    sendTime.push(itemCopy);
                }
            });

            return vm.invoiceService.newInvoice(vm.user, vm.clientBillingService.selectedPeriod, sendItems, sendTime)
            .then(function(invoice){
                vm.invoiceService.selectedInvoice = invoice;
                // mark the passed items as pending so they aren't
                // re-added to the invoice again (duplicated)
                vm.markItemsPending();
                // heap.track('New Invoice Started');
                //  _dcq.push(["identify", {
                //   email: userDataService.user.email,
                //   tags: ["Started and Invoice"]
                // }]);
                // $log.info(vm.invoiceService.selectedInvoice);
            });

          }// invoiceSelectedLineItems

          // Add selected items to currently selected Invoice
          vm.addSelectedLineItems = function(){
            var sendItems = [],
                sendTime = [];

            // Gather our lineItems
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    if(_.has(vm.invoiceService.selectedInvoice, 'lineItems')){
                        vm.invoiceService.selectedInvoice.lineItems.push(itemCopy);
                    } else {
                        vm.invoiceService.selectedInvoice.lineItems = [];
                        vm.invoiceService.selectedInvoice.lineItems.push(itemCopy);
                    }

                }
            });

            // Gather our time
            _.each(vm.timeReportService.report.data, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    ajUTILITIES.removePropertiesWith(itemCopy);
                    itemCopy.rate = vm.clientBillingService.selectedPeriod.info.rate;
                    if(_.has(vm.invoiceService.selectedInvoice, 'time')){
                        vm.invoiceService.selectedInvoice.time.push(itemCopy);
                    } else {
                        vm.invoiceService.selectedInvoice.time = [];
                        vm.invoiceService.selectedInvoice.time.push(itemCopy);
                    }
                }// if item.selected
            });

            vm.markItemsPending();
            vm.invoiceDirty = true;
          }// invoiceSelectedLineItems

          vm.cancelInvoice = function(){
            vm.removeAllPending();
            delete vm.invoiceService.selectedInvoice
            delete vm.invoiceService.selectedTime
            delete vm.printReport
          }

          vm.saveInvoice = function(){
            var invoiceCopy = angular.copy(vm.invoiceService.selectedInvoice);
            if(!_.has(invoiceCopy, 'info.terms')){
                invoiceCopy.info.terms = "";
            }
            if(!_.has(invoiceCopy, 'info.notes')){
                invoiceCopy.info.notes = "";
            }
            // $log.info(invoiceCopy);
            // convert our date object to a string
            invoiceCopy.info.date = moment(invoiceCopy.info.date).toISOString();
            invoiceCopy.info.due = moment(invoiceCopy.info.due).toISOString();
            return vm.invoiceService.saveInvoice(invoiceCopy)
            .then(function(response){
                //
                // $log.info(response);
                // heap.track('Invoice Saved');
                //  _dcq.push(["identify", {
                //   email: userDataService.user.email,
                //   tags: ["Saved New Invoice"]
                // }]);
            });
          }// saveInvoice

          vm.updateInvoiceDate = function(){
            var invoiceDue = moment(vm.invoiceService.selectedInvoice.info.date).add(1, 'month');
            vm.invoiceService.selectedInvoice.info.due = invoiceDue;
            vm.updateInvoice();
          }

          vm.updateInvoice = function(){

            // The timeout is required here to ensure that we are passing the invoice AFTER it's
            // total has been updated.
            // if invoice is a draft, just update model,
            if(_.has(vm.invoiceService.selectedInvoice, 'uid')){
                // if invoice has a uid, update the db
                $timeout(function(){

                    return vm.invoiceService.updateInvoice(vm.invoiceService.selectedInvoice)
                    .then(function(response){
                        // $log.info('invoice updated');
                        vm.invoiceDirty = false;
                        // update our last Invoice in case our edit changed it
                        vm.invoiceService.getLastInvoice(vm.thisClient);
                        // heap.track('Invoice Updated');

                    });
                },0);
            } else {

            }

          }

          vm.showDeleteInvoice = function(invoice){
            vm.deleting = true;
          }
          vm.cancelDeleteInvoice = function(invoice){
            vm.deleting = false;
          }
          vm.deleteInvoice = function(invoice){
            return vm.invoiceService.deleteInvoice(invoice)
            .then(function(){
                vm.deleting = false;
                // heap.track('Invoice Deleted');
            });
          }

        vm.invoiceTotal = function(){
            var total = 0;
            _.each(vm.invoiceService.selectedInvoice.lineItems, function(lineItem){
                var updateAmount = 0;
                updateAmount = lineItem.cost * lineItem.quantity;
                total = total + updateAmount;
            });
            _.each(vm.invoiceService.selectedInvoice.time, function(entry){
                var updateAmount = 0;
                updateAmount = entry.rate * (entry.logged/60);
                total = total + updateAmount;
            });

            // This function might run after invoice removed.
            // let's double check before assigning to undefined
            if(_.has(vm.invoiceService, 'selectedInvoice.info')){
                vm.invoiceService.selectedInvoice.info.total = total;
            }

            return total
        }

        vm.removeInvoiceTimeEntry = function(thisEntry){
            // $log.info(thisEntry.uid);
            // First - determine if this is pending or already saved entry in our timereport data
            _.each(vm.timeReportService.report.data, function(entry){
                if(entry.uid == thisEntry.uid){
                    if(entry.pending){
                        // this entry has been added but not saved. no need to unlock or update invoice

                        // remove our pending flag
                        entry.pending = false;
                        // Find the item in our invoices time list and remove it
                        var updatedTimeArray = _.remove(vm.invoiceService.selectedInvoice.time, function(item) {
                          return item.uid != thisEntry.uid;
                        });
                        vm.invoiceDirty = true;
                        // assign our trimmed array to the invoice
                        vm.invoiceService.selectedInvoice.time = updatedTimeArray;

                    } else {
                        // This entry has already been saved. We need to unlock it and update the invoice

                        var entriesToUnlock = [
                            thisEntry
                        ];

                        vm.invoiceService.unlockTimeEntries(entriesToUnlock);

                        // Find the item in our time list and remove it
                        var updatedTimeArray = _.remove(vm.invoiceService.selectedInvoice.time, function(entry) {
                          return entry.uid != thisEntry.uid;
                        });
 //
                        vm.invoiceService.selectedInvoice.time = updatedTimeArray;
                        ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
                        // Save our changes if we have a invoice UID
                        if(vm.invoiceService.selectedInvoice.uid){
                            vm.updateInvoice();
                        }
                        vm.invoiceDirty = false;
                        // update our last Invoice in case our edit changed it
                        vm.invoiceService.getLastInvoice(vm.thisClient);
                    }
                }
            });

        }// removeInvoiceTimeEntry

        vm.removeInvoiceLineItem = function(thisItem){
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if (item.uid == thisItem.uid){

                    if(item.pending){
                        // it's pending which means it hasn't been saved to the invoice yet.
                        // just remove pending and remove from invoice
                        item.pending = false;
                        vm.invoiceDirty = true;
                        // Find the item in our time list and remove it
                        var updatedLineItemArray = _.remove(vm.invoiceService.selectedInvoice.lineItems, function(item) {
                          return item.uid != thisItem.uid;
                        });

                        vm.invoiceService.selectedInvoice.lineItems = updatedLineItemArray;
                    } else {
                        // item has been saved to invoice. Needs removed and invoice updated
                        // put it on an array and send the array to be unlocked
                        var itemsToUnlock = [
                            thisItem
                        ];

                        vm.invoiceService.unlockLineItems(itemsToUnlock);

                        // Find the item in our time list and remove it
                        var updatedLineItemArray = _.remove(vm.invoiceService.selectedInvoice.lineItems, function(item) {
                          return item.uid != thisItem.uid;
                        });

                        vm.invoiceService.selectedInvoice.lineItems = updatedLineItemArray;
                        ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
                        if(vm.invoiceService.selectedInvoice.uid){
                            vm.updateInvoice();
                            vm.invoiceDirty = false;
                        }
                    }
                }
            });
        }

        vm.selectInvoice = function(invoiceID){
            // Make sure an unsaved dirty form for one period
            // doesn't enable the "save" button when we select a different period
         return vm.invoiceService.selectInvoice(invoiceID);
        }

        vm.makeDirty = function(){
            vm.invoiceDirty = true;
        }


        vm.emailInvoice = function(invoice){
            $log.info('emailInvoice');
           return vm.invoiceService.mailInvoiceDialog(vm.invoiceService.selectedInvoice, vm.user, vm.thisClient);
        }


        vm.preparePDF = function(next, recipientEmail){
            vm.invoiceService.preparePDF(vm.invoiceService.selectedInvoice, vm.user, vm.thisClient)
            vm.invoiceService.createPDF(vm.invoiceService.selectedInvoice);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Woot!',
                        message: 'Your report is being prepared. We will notify you when it is ready.' ,
                        color: 'orange'
                    }
                }));// mdToast
        }

        vm.printTime = function(){
            // $log.info('printTime');
            vm.cancelInvoice();
            vm.printReport = {};
            vm.printReport.clientName = clientBillingService.selectedPeriod.info.clientName;
            vm.printReport.start = clientBillingService.selectedPeriod.info.start;
            vm.printReport.end = clientBillingService.selectedPeriod.info.end;
            vm.printReport.type = clientBillingService.selectedPeriod.info.type;
            vm.printReport.rate = clientBillingService.selectedPeriod.info.rate;
            vm.printReport.allocated = clientBillingService.selectedPeriod.info.allocated;
            vm.printReport.total = vm.logTotal(vm.timeReportService.report.data);
            vm.printReport.time = vm.timeReportService.report.data;
            vm.printReport.filename = 'time-report-'+ clientBillingService.selectedPeriod.info.clientName + '-' + moment(clientBillingService.selectedPeriod.info.start).format('MM-DD-YY') + '.pdf';
        }

        //live totals calculation for each group
        vm.logTotal = function (logs) {
            var total = 0;
            _.each(logs, function (entry) {
                total += entry.logged;
            })
            return total
        };

        vm.removeReportTimeEntry = function(entryToRemove){
            var updatedTimeArray = _.remove(vm.invoiceService.selectedTime, function(entry) {
              return entry.uid != entryToRemove.uid;
            });

            vm.invoiceService.selectedTime = updatedTimeArray;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adminDashboard', ['appServices']);
})();

(function () {
    'use strict';

    angular
            .module('adminDashboard')
            .controller('adminDashboardController', adminDashboardController);

    /* @ngInject */

    function adminDashboardController($log,  $state, $timeout, $window, $rootScope, userDataService, timerDataService, aggregateDataService, $scope, $firebaseArray, taskDataService, clientDataService, clientBillingService, gateService, _userData) {
        $log.info('dashboardController');
        // $log.info('userData is:');
        // $log.info(_userData);
        // $log.info('clientData is:');
        // $log.info(_clientData);


        var vm = this;
        vm.userData = _userData;
        // vm.clientData = _clientData;
        vm.showMigrationTool = false;
        vm.showProgressChart = false;

        vm.showToday = true;
        // Force appcues trigger after delay...to acommodate it's failure at fireing on locationchange success
        // $timeout(function(){
        //     Appcues.start();
        // }, 1000)
        //


        vm.done = false;
        var init = function(){
            // Make sure we don't think we are on an individual client


        }// init dashboard

        init();
        // Determine if we should show november's migration tool
        // If we've already migrated them


        vm.showDashboard = function(){
            if (_.size(vm.clientData)>0 ){
                return true
            } else {
                return false
            }
        }// vm.showDashboard

        if (vm.userData.totals) {
            vm.showProgressChart = true;
        }

        vm.currency = "$";
        if (_.has(vm.userData.profile, 'settings.currency')) {
            vm.currency = vm.userData.profile.settings.currency;
        }

        function setupWatchers(){

            // Setup watchers
            $rootScope.$on('taskUpdated', function(){
                // $log.info('task updated...reloading');
                setupAllTasks();
            });

            // Watch vm.clients and update allTasks if it changes
            var unwatch = vm.clientData.$watch(function() {
              // console.log("data changed!");
              $timeout(function(){
                setupAllTasks();
              },100);

            });

            $scope.$on('$destroy', function() {
                // $log.info('unwatching clients');
                unwatch();
            });
        }


        vm.changeOnboardingFlag = function(flag, value){
            // $log.info('updateSettings');
            userDataService.changeOnboardingFlag(flag, value);

            // Tag it in Drip
            // if(value){
            //     _dcq.push(["identify", {
            //      email: userDataService.user.email,
            //      tags: ["onBoarding: " + flag]
            //    }]);
            // } else {
            //      _dcq.push(["identify", {
            //       email: userDataService.user.email,
            //       remove_tags: ["onBoarding: " + flag]
            //     }]);
            // }
            // Update our local data
            // userDataService.getLoggedInUser();
        } // vm.updateSettings


        vm.runTotals = function () {
            vm.migrationStatus = 'updating';
            $timeout(function () {
                aggregateDataService.calcTotals(vm.userData, vm.clientData);
            }, 10000)
                    .then(function () {
                        vm.migrationStatus = 'complete'
                    });
        }

        vm.getColor = function(clientID){
            return clientDataService.clientColor(clientID)
        }

        vm.openClient = function(clientID){
            // $log.info('vm.openClient: ' + client);
            $state.go("triangular.client-manager-page.tasks", {"clientID": clientID});
            // return clientDataService.getClient(client)
            // .then(function(thisClient){
            //     // $log.info(thisClient);
            //     return clientDataService.clientDialog(thisClient);
            // })
        }



        vm.newSpace = function(){
             clientDataService.clientDialog(clientDataService.newClient(), 'New Client Workspace');
         }

        vm.refresh = function () {
            // force refresh the page here
            location.reload();
        }

        ////////////////////////////////////////////////////////////
        // Support Current Status Widgets
        ////////////////////////////////////////////////////////////
        //
        function setupStatusWidgets(){
            var thisWeek = parseInt(moment().week()),
                    thisYear = parseInt(moment().year());

            vm.thisWeek = {};
            var userTotalsPath = "totals." + thisYear + ".weekly." + thisWeek;

            // $log.info(userTotalsPath);

            if (_.has(vm.userData, userTotalsPath)) {
                // $log.info('we has data');
                //Get the minutes logged this period
                vm.thisWeek.tasks = vm.userData.totals[thisYear]['weekly'][thisWeek]['completed'];
                vm.thisWeek.hours = vm.userData.totals[thisYear]['weekly'][thisWeek]['minutes'];
                vm.thisWeek.hours = vm.thisWeek.hours / 60;

            } else {

                // set used to 0
                vm.thisWeek.tasks = 0;
                vm.thisWeek.hours = 0;
            }

            // $log.info(vm.allTasks);
            vm.due = 0;
            vm.new = 0;
            vm.later = 0;
            vm.today = 0;

            _.each(vm.allTasks, function (task) {

                if (task.status == 'open') {
                    if (task.duedate && moment(task.duedate).diff(moment()) < 0) {
                        // $log.info('this ones due!');
                        vm.due++
                    } else if (task.focus == 'today') {

                        vm.today++
                    } else {
                        vm.later++
                    }
                }


            });
        } // setup status widgets


        ////////////////////////////////////////////////////////////
        // Support Current Status Widgets
        ////////////////////////////////////////////////////////////
        //

        function setupAllTasks() {
            vm.allTasks = [];

            // concate all of our open client tasks into one array
            _.each(vm.clientData, function (client) {
                _.each(client.tasks, function (task) {
                    vm.allTasks.push(task);
                });
            });

        } // setupAllTasks


        // we need this filter to be able to show appropriate items in today and waiting panels.
        // vm.todayFilter = function (task) {
        //     var now = moment().toISOString();
        //     return task.panel === 'due' || task.panel === 'today' || task.duedate <= now | task.focus === 'today';
        // };


        // putting this on scope. FOR SOME REASON, if vm.showDashboard == false, vm isn't available.
        // We only need this single piece of functionality from that state
        $scope.showCue = function(cue, flag){
            // trigger our primer
            Appcues.show(cue);

            // mark step complete
            if(flag){
                $timeout(function(){
                    vm.changeOnboardingFlag(flag, true);
                }, 1000);
            }
        }// vm.showCue

        function setupClientStatus(){
            ////////////////////////////////////////////////////////////
            // Support Client Status Widgets
            ////////////////////////////////////////////////////////////
            //
            // * this is duped in the vm.progress function below. sloppy
            // figure out how many hours have been logged for this client this period
            // if we have totals for this client


            var now = moment(),
                    thisMonth = parseInt(now.month() + 1),
                    thisWeek = parseInt(now.week()),
                    thisYear = parseInt(moment().year()),
                    totalsPath = "totals." + thisYear + ".monthly." + thisMonth,
                    calendar_totalsPath = "calendar_totals." + thisYear + ".monthly." + thisMonth,
                    retainer_totalsPath = "retainer_totals." + thisYear + ".monthly." + thisMonth;

            vm.currentMonthRange = moment().startOf('month').format('MMM D') + ' - ' + moment().endOf('month').format('D, YYYY');

            // Way too much logic to determine the current month range
            // Should be redone to utilize current billing period's data
            vm.monthRange = function (thisClient) {

                // if this client has already been upgraded to use profile.plan.nextCycle,
                // we can simply calculate and return our range.
                // Otherwise, the old, long, complicated way

                var queryDate = moment().startOf('day').toISOString(),
                    thisBillingPeriod = undefined;

                _.each(thisClient.billing, function(billingPeriod){
                    if(moment(billingPeriod.start).startOf('day').toISOString() <= queryDate && moment(billingPeriod.end).endOf('day').toISOString() > queryDate){
                       thisBillingPeriod =  billingPeriod;
                    }
                });

                if(thisBillingPeriod){
                    var endDate = thisBillingPeriod.end,
                        startDate = thisBillingPeriod.start;
                    return moment(startDate).format('MMM D') + ' - ' + moment(endDate).format('MMM D, YYYY');
                } else {
                    return ""
                }

                // if(_.has(thisClient.profile, 'plan.nextCycle')){

                //     var endDate = moment(thisClient.profile.plan.nextCycle).subtract(1, 'day').endOf('day'),
                //         startDate = moment(thisClient.profile.plan.nextCycle).subtract(1, 'month').startOf('day');
                //     return moment(startDate).format('MMM D') + ' - ' + moment(endDate).format('MMM D, YYYY');
                // }
                // else
                // {

                //     // we don't have a cycle date. Don't show anything. Another alert will be present in the clientSummary Strip.
                //     return ""

                // } // else - if we are dealing with a client using retainerStart
            };// vm.monthRange

        } // setupClientStatus




            function setupWorkLoadChart(){
                ////////////////////////////////////////////////////////////
                // Support Workload Widget - 6 weeks of data
                ////////////////////////////////////////////////////////////
                //
                vm.charts.workload = [];
                vm.charts.workload.series = ['Tasks Completed', 'Hours Logged'];
                vm.charts.workload.options = {
                    // scaleOverride: true,
                    //  scaleSteps : 100,
                    //  scaleStepWidth : 1,
                    //  scaleStartValue : 0
                    //  ,
                    datasetFill: true,
                    scaleBeginAtZero: true,
                    pointDot: true,
                    // scaleOverride: true,
                    // scaleSteps: 4,
                    responsive: true,
                    maintainAspectRatio: false,
                    // the legends node doens't seem to do anything
                    // legends: {
                    //     labels:{
                    //         defaultFontSize: 12,
                    //         defaultFontColor: '#E82A29'
                    //     }
                    // },
                    // scaleStepWidth: 25,
                    // scaleStartValue: 0,
                    scaleLabel : function(label){
                        var thisLabel = label.value.toString();
                        if(label.value > 99){
                            thisLabel = thisLabel + '+'
                        }
                        return thisLabel
                    }
                };

                vm.charts.workload.labels = [];
                vm.charts.workload.tasks = [];
                vm.charts.workload.hours = [];
                vm.charts.workload.data = [];
                vm.charts.workload.range = moment().format('MMM D');

                // Set our range for the chart
                var endChart = moment(),
                    startChart = moment().subtract(12, 'weeks');

                vm.charts.workload.range = startChart.format('MMM D') + ' - ' + endChart.format('MMM D, YYYY');

                //Loop through startChart until endChart
                // Set range for our weekly loop
                var chartRange = moment.range(startChart, endChart);
                // Loop through our range by week
                chartRange.by('weeks', function (targetWeek) {
                    // Do something with `moment`
                    var dateLabel = moment(targetWeek).day("Sunday"),
                            weekHours,
                            weekTasks,
                            weekYear = targetWeek.format('YYYY'),
                            weekWeek = targetWeek.format('w'),
                            dataPath = 'totals.' + weekYear + '.weekly.' + weekWeek + '.minutes';

                    // Only proceed if user has data.
                    if (_.has(vm.userData, dataPath)) {
                        // $log.info(vm.userData.totals[thisYear]['weekly'][i]['minutes']);
                        weekHours = vm.userData.totals[weekYear]['weekly'][weekWeek]['minutes'] / 60;
                        weekTasks = vm.userData.totals[weekYear]['weekly'][weekWeek]['completed'];


                        // reduce weekTasks if > 100 and treat as "100+" so our scale doesn't go off the charts.
                        if (weekTasks > 100){
                            weekTasks = 100;
                        }
                        if (weekHours == undefined) {
                            weekHours = 0;
                        }
                        if (weekTasks == undefined) {
                            weekTasks = 0;
                        }

                    } else {
                        // if no data at this path, return zeroes
                        weekHours = 0;
                        weekTasks = 0;
                    } // if user has data

                    vm.charts.workload.labels.push(dateLabel.format('MMM D'));
                    vm.charts.workload.tasks.push(weekTasks);
                    vm.charts.workload.hours.push(weekHours.toFixed(2));

                });


                // Push our data array's into workload.data for display
                vm.charts.workload.data.push(vm.charts.workload.tasks);
                vm.charts.workload.data.push(vm.charts.workload.hours);
                vm.done=true;

                //
            } // setupWorkloadChart

            function setupRevenueChart(){
                // $log.info('setupRevenueChart');
                ////////////////////////////////////////////////////////////
                // Support Revenue Widget - 12 months of data
                ////////////////////////////////////////////////////////////
                //

                vm.charts.revenue = [];
                vm.charts.revenue.series = ['Invoiced', 'Received'];
                vm.charts.revenue.options = {

                    datasetFill: true,
                    scaleBeginAtZero: false,
                    scaleStepWidth: 100,
                    pointDot: true,
                    responsive: true,
                    maintainAspectRatio: false,
                    scaleLabel:
                        function(label){return  vm.currency + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},

                    };

                vm.charts.revenue.labels = [];
                vm.charts.revenue.invoiced = [];
                vm.charts.revenue.received = [];
                vm.charts.revenue.data = [];
                vm.charts.revenue.range = moment().format('MMM D');

                // Set our range for the chart
                var endChart = moment().add(1, 'month'),
                    startChart = moment().subtract(12, 'months');

                vm.charts.revenue.range = startChart.format('MMM YYYY') + ' - ' + endChart.format('MMM YYYY');

                // Loop through startChart until endChart to create our labels
                // Set range for our weekly loop
                var chartRange = moment.range(startChart, endChart);
                // $log.info(moment(endChart).toISOString());
                // Loop through our range by month
                chartRange.by('months', function (targetMonth) {
                    var dateLabel = moment(targetMonth).format("MMM"),
                        monthMoment = moment(targetMonth).startOf('month').startOf('day').toISOString();

                    // Set our label
                    vm.charts.revenue.labels.push(moment(targetMonth).format('MMM'));

                    // Get our billing periods for this month and add up the invoice totals
                    var monthData = getInvoiced(monthMoment);
                    // $log.info(monthData);
                    // Push our period totals to the array
                    vm.charts.revenue.invoiced.push(monthData.invoiced);
                    vm.charts.revenue.received.push(monthData.payments);

                });

                // vm.charts.revenue.labels.push('Now');
                // vm.charts.revenue.invoiced.push(0);
                // Push our data array's into revenue.data for display
                vm.charts.revenue.data.push(vm.charts.revenue.invoiced);
                // vm.charts.revenue.data.push(vm.charts.revenue.received);
                //
            } // setupRevenueChart

            function getInvoiced(monthMoment){
                // $log.info('getInvoiced for ' + monthMoment);
                var monthData = {};
                monthData.invoiced = 0;
                monthData.balance = 0;
                monthData.payments = 0;

                _.each(vm.clientData, function(client){
                    // $log.info('processing client: ' + client.profile.fullName);
                    _.each(client.billing, function(period){
                        if (monthMoment >= period.start && monthMoment <= period.end){
                            // $log.info('found appropriate period. adding');
                            if(_.has(period, 'total')){
                                monthData.invoiced = monthData.invoiced + period.total;
                            };

                            if(_.has(period, 'received')){
                                monthData.payments = monthData.payments + period.received;
                            };

                        }

                        // $log.info(monthData.invoiced + '/' + monthData.payments);
                    });
                });
                return monthData
            }

        //


    }// adminDashboardController
})();

(function() {
    'use strict';

    angular
        .module('adminDashboard')
        .config(moduleConfig)
        // .run(['$rootScope', '$state','$stateParams', function($rootScope, $state, $stateParams) {
        //     $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        //       // We can catch the error thrown when the $requireAuth promise is rejected
        //       // and redirect the user back to the home page
        //       // debugger;
        //       if (error === 'AUTH_REQUIRED') {
        //         $state.go('authentication.login');
        //       }
        //     });
        // }]);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-dashboard');

        $stateProvider
            .state('triangular.dashboard', {
                url: '/',
                templateUrl: 'app/admin-dashboard/dashboard.tmpl.html',
                // set the controller to load for this page
                controller: 'adminDashboardController',
                controllerAs: 'vm',
                resolve: {
                    'currentAuth': ['authFactory', function(authFactory) {
                        return authFactory.$requireSignIn()
                    }],
                    // resolve our _userData and pass it to the Controller for saving
                     '_userData': ['userDataService', function(userDataService) {
                       return userDataService.getLoggedInUser()
                       .then(function(data){
                            return data
                       })
                    }]
                }

            });

        // // send /dashboard requests to triangular.dashboard state
        // $urlRouterProvider.when(/dashboard/, ['$state','$match', function ($state, $match) {
        //   $state.go('triangular.dashboard');
        // }]);

        triMenuProvider.addMenu({
            name: 'Dashboard',
            icon: 'fa fa-dashboard',
            type: 'link',
            state: 'triangular.dashboard',
            priority: 1.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('diagnostics', []);
})();

(function() {
    'use strict';

    angular
        .module('diagnostics')
        .controller('diagnosticsController', diagnosticsController);

    /* @ngInject */
    function diagnosticsController($log, userDataService, localStorageService, $rootScope, clientDataService) {
   // $log.info('diagnosticsController');

   var vm = this;
   vm.localUserID = localStorageService.get('userID');
   vm.thisClient = $rootScope.thisClient;

  	}; // end diagnosticsController
})();

(function() {
    'use strict';

    angular
        .module('diagnostics')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-diagnostics');

        $stateProvider
            .state('triangular.diagnostics', {
                url: '/diagnostics/',
                templateUrl: 'app/admin-diagnostics/diagnostics.tmpl.html',
                // set the controller to load for this page
                controller: 'diagnosticsController',
                controllerAs: 'vm'
            });

    }
})();

(function() {
    'use strict';

    angular
        .module('account', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('account')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {


        $translatePartialLoaderProvider.addPart('app/admin-account');

        $stateProvider
            .state('triangular.account-page', {
                abstract: true,
                views: {
                    'toolbar@triangular': {
                        templateUrl: 'app/admin-account/account-toolbar.tmpl.html',
                        controller: 'accountToolbarController',
                        controllerAs: 'vm'
                    }
                },
                url: '/account',
                templateUrl: 'app/admin-account/account-page.tmpl.html',
                // set the controller to load for this page
                controller: 'accountPageController',
                controllerAs: 'vm'


            })
            .state('triangular.account-page.profile',{
                url: '/profile',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-profile.tmpl.html',
                        controller: 'accountPageController',
                        controllerAs: 'vm'
                    }
                  }
            })
            .state('triangular.account-page.team',{
                url: '/team',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-team.tmpl.html',
                        controller: 'accountTeamController',
                        controllerAs: 'vm'
                    }
                  }

            })
            .state('triangular.account-page.plan',{
                url: '/plan',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-plan.tmpl.html',
                        controller: 'accountPageController',
                        controllerAs: 'vm'
                    }
                  }
            })
            // .state('triangular.account-page.clients',{
            //           templateUrl: 'app/admin-account/account-clients.tmpl.html',
            //           controller: 'accountClientsController',
            //           controllerAs: 'vm',
            //           url: '/clients'
            //   });



            triMenuProvider.addMenu({
                name: 'Account',
                icon: 'fa fa-gears',
                state: 'triangular.account-page.profile',
                type: 'dropdown',
                priority: 24,
                children: [{
                               name: 'Profile',
                               icon: 'fa fa-user',
                               state: 'triangular.account-page.profile',
                               type: 'link',
                               priority: 1
                           }

                           ,
                           // {
                           //  type: 'divider',
                           //  priority: 1.1
                           // },
                           // {
                           //     name: 'Manage Clients',
                           //     state: 'triangular.account-page.clients',
                           //     icon: 'zmdi zmdi-accounts-list',
                           //     type: 'link',
                           //     priority: 2
                           // },
                           {
                            type: 'divider',
                            priority: 2.1
                           },
                           {
                               name: 'Team',
                               state: 'triangular.account-page.team',
                               icon: 'fa fa-users',
                               type: 'link',
                               priority: 3
                           },
                           {
                            type: 'divider',
                            priority: 3.1
                           },

                           {
                               name: 'Plan',
                               state: 'triangular.account-page.plan',
                               icon: 'fa fa-credit-card',
                               type: 'link',
                               priority: 4
                           }
                           ,
                           {
                            type: 'divider',
                            priority: 4.1
                           }
                           ]
            });






    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('accountToolbarController', accountToolbarController);

    /* @ngInject */
    function accountToolbarController($log, $scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;

        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        // $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $scope.logout =logout;

        // Added for Adminja
        function logout(){
            // clear out ghost User if we are logged in as one
            localStorageService.remove('ghostUser');
            firebase.auth().signOut().then(function() {
              // Sign-out successful.
              // $state.go('authentication.login')
            }, function(error) {
              // An error happened.
            });
        }
        ////////////////

        function changeState(newState){
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountTeamController', accountTeamController);
        // accountTeamController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountTeamController($scope, $rootScope, $mdDialog, clientDataService) {

        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountPlanController', accountPlanController);
        // accountPlanController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountPlanController($scope, $rootScope, $mdDialog, clientDataService) {

        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountPageController', accountPageController);
        // accountPageController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountPageController($log, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, _clientData, fbService) {
        var vm = this;
            vm.user = _userData;
            vm.user.dob = new Date(vm.user.dob);


        vm.updateUser = function(user){
            // $log.info(user);
            userDataService.updateUser(user);
        }

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);


            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){


                        // $log.info('Saving '+filename);
                        var filename = localStorageService.get('userID') + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             vm.user.avatar = uploadTask.snapshot.downloadURL;
                             vm.customDirty = true;
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar


    }
})();


(function() {
    'use strict';

    angular
        .module('app')
        .value('googleChartApiConfig', {
            version: '1.1',
            optionalSettings: {
                packages: ['line', 'bar', 'geochart', 'scatter'],
                language: 'en'
            }
        });
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .filter('triTranslate', triTranslateFilter);

    /* @ngInject */
    function triTranslateFilter($injector, $filter) {
        return function(input) {
            // if angular translate installed this will return true
            // so we can translate
            if($injector.has('translateFilter')) {
                return $filter('translate')(input);
            }
            else {
                // no translation active so just return the same input
                return input;
            }
        };
    }
})();

(function() {
    angular
        .module('app')
        .controller('ErrorPageController', ErrorPageController);

    /* @ngInject */
    function ErrorPageController($state) {
        var vm = this;

        vm.goHome = goHome;
        console.log('ErrorPageController');
        /////////

        function goHome() {
            $state.go('authentication.login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(themesConfig);

    /* @ngInject */
    function themesConfig ($mdThemingProvider, triThemingProvider, triSkinsProvider) {
        /**
         *  PALETTES
         */
        $mdThemingProvider.definePalette('white', {
            '50': 'ffffff',
            '100': 'ffffff',
            '200': 'ffffff',
            '300': 'ffffff',
            '400': 'ffffff',
            '500': 'ffffff',
            '600': 'ffffff',
            '700': 'ffffff',
            '800': 'ffffff',
            '900': 'ffffff',
            'A100': 'ffffff',
            'A200': 'ffffff',
            'A400': 'ffffff',
            'A700': 'ffffff',
            'contrastDefaultColor': 'dark'
        });

        $mdThemingProvider.definePalette('adminja-blue-green', {
            '50': '#000000',
            '100': '#000101',
            '200': '#00111b',
            '300': '#002134',
            '400': '#00314e',
            '500': '#004167',
            '600': '#00619a',
            '700': '#0071b4',
            '800': '#0081cd',
            '900': '#0091e7',
            'A100': '#00619a',
            'A200': '#005181',
            'A400': '#004167',
            'A700': '#01a1ff',
            'contrastDefaultColor' :'light'
        });

        $mdThemingProvider.definePalette('adminja-blue-grey', {
             '50': '#3c4f82',
                    '100': '#344471',
                    '200': '#2c3a5f',
                    '300': '#242f4e',
                    '400': '#1c253c',
                    '500': '#141a2b',
                    '600': '#0c0f1a',
                    '700': '#040508',
                    '800': '#000000',
                    '900': '#000000',
                    'A100': '#455993',
                    'A200': '#4d64a5',
                    'A400': '#5970b2',
                    'A700': '#000000',
                'contrastDefaultColor' :'light'
            });

        $mdThemingProvider.definePalette('black', {
            '50': 'e1e1e1',
            '100': 'b6b6b6',
            '200': '8c8c8c',
            '300': '646464',
            '400': '3a3a3a',
            '500': 'e1e1e1',
            '600': 'e1e1e1',
            '700': '232323',
            '800': '1a1a1a',
            '900': '121212',
            'A100': '3a3a3a',
            'A200': 'ffffff',
            'A400': 'ffffff',
            'A700': 'ffffff',
            'contrastDefaultColor': 'light'
        });

        var triCyanMap = $mdThemingProvider.extendPalette('cyan', {
            'contrastDefaultColor': 'light',
            'contrastLightColors': '500 700 800 900',
            'contrastStrongLightColors': '500 700 800 900'
        });

        // Register the new color palette map with the name triCyan
        $mdThemingProvider.definePalette('triCyan', triCyanMap);

        /**
         *  SKINS
         */

        // CYAN CLOUD SKIN
        triThemingProvider.theme('cyan')
        .primaryPalette('triCyan')
        .accentPalette('amber')
        .warnPalette('deep-orange');

        triThemingProvider.theme('cyan-white')
        .primaryPalette('white')
        .accentPalette('triCyan', {
            'default': '500'
        })
        .warnPalette('deep-orange');

        triSkinsProvider.skin('cyan-cloud', 'Cyan Cloud')
        .sidebarTheme('cyan')
        .toolbarTheme('cyan-white')
        .logoTheme('cyan')
        .contentTheme('cyan');


        // PLUMB PURPLE SKIN
        triThemingProvider.theme('purple')
        .primaryPalette('purple')
        .accentPalette('deep-orange')
        .warnPalette('amber');

        triThemingProvider.theme('white-purple')
        .primaryPalette('white')
        .accentPalette('purple', {
            'default': '400'
        })
        .warnPalette('deep-orange');

        triSkinsProvider.skin('plumb-purple', 'Plumb Purple')
        .sidebarTheme('purple')
        .toolbarTheme('white-purple')
        .logoTheme('purple')
        .contentTheme('purple');

        // DARK KNIGHT SKIN
        triThemingProvider.theme('dark')
        .primaryPalette('black', {
            'default': '300',
            'hue-1': '400'
        })
        .accentPalette('amber')
        .warnPalette('deep-orange')
        .backgroundPalette('black')
        .dark();

        triSkinsProvider.skin('dark-knight', 'Dark Knight')
        .sidebarTheme('dark')
        .toolbarTheme('dark')
        .logoTheme('dark')
        .contentTheme('dark');

        // BATTLESHIP GREY SKIN
        triThemingProvider.theme('blue-grey')
        .primaryPalette('blue-grey')
        .accentPalette('amber')
        .warnPalette('orange');

        triThemingProvider.theme('white-blue-grey')
        .primaryPalette('white')
        .accentPalette('blue-grey', {
            'default': '400'
        })
        .warnPalette('orange');

        triSkinsProvider.skin('battleship-grey', 'Battleship Grey')
        .sidebarTheme('blue-grey')
        .toolbarTheme('white-blue-grey')
        .logoTheme('blue-grey')
        .contentTheme('blue-grey');



        // ZESTY ORANGE SKIN
        triThemingProvider.theme('orange')
        .primaryPalette('orange' , {
            'default': '800'
        })
        .accentPalette('lime')
        .warnPalette('amber');

        triThemingProvider.theme('white-orange')
        .primaryPalette('white')
        .accentPalette('orange', {
            'default': '500'
        })
        .warnPalette('lime');

        triSkinsProvider.skin('zesty-orange', 'Zesty Orange')
        .sidebarTheme('orange')
        .toolbarTheme('white-orange')
        .logoTheme('orange')
        .contentTheme('orange');


        // INDIGO ISLAND SKIN
        triThemingProvider.theme('indigo')
        .primaryPalette('indigo' , {
            'default': '600'
        })
        .accentPalette('red')
        .warnPalette('lime');

        triThemingProvider.theme('indigo-light')
        .primaryPalette('indigo' , {
            'default': '400'
        })
        .accentPalette('red')
        .warnPalette('lime');

        triSkinsProvider.skin('indigo-island', 'Indigo Island')
        .sidebarTheme('indigo')
        .toolbarTheme('indigo')
        .logoTheme('indigo')
        .contentTheme('indigo');

        // KERMIT GREEN SKIN
        triThemingProvider.theme('light-green')
        .primaryPalette('light-green' , {
            'default': '400'
        })
        .accentPalette('amber')
        .warnPalette('deep-orange');



        triThemingProvider.theme('white-light-green')
        .primaryPalette('white')
        .accentPalette('light-green', {
            'default': '400'
        })
        .warnPalette('deep-orange');

        triSkinsProvider.skin('kermit-green', 'Kermit Green')
        .sidebarTheme('light-green')
        .toolbarTheme('white-light-green')
        .logoTheme('light-green')
        .contentTheme('light-green');


        // ADMINJA SKIN
        triThemingProvider.theme('adminja-shade')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('light-blue',{
            'default': 'A700',
            'hue-1': '300'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        // ADMINJA SKIN
        triThemingProvider.theme('adminja-status')
        .primaryPalette('green', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('orange',{
            'default': '400',
            'hue-1': '300'
        })
        .warnPalette('red', {
            'default': '400'
        });

        // triThemingProvider.theme('adminja-status')
        // .primaryPalette('light-green')
        // .accentPalette('deep-orange')
        // .warnPalette('red');

        triThemingProvider.theme('adminja-green')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('green',{
            'default': '500',
            'hue-1': '300'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        // triThemingProvider.theme('adminja-shade-copy')
        // .primaryPalette('blue-grey', {
        //     'default': 'A700',
        //     'hue-1': '900'
        // })
        // .accentPalette('cyan',{
        //     'default': '400'
        // })
        // .warnPalette('pink', {
        //     'default': 'A200'
        // });

        triThemingProvider.theme('adminja-neutral')
        .primaryPalette('light-blue',{
            'default': '400'
        })
        .accentPalette('light-blue', {
            'default': 'A700'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });


        triThemingProvider.theme('adminja-light')
        .primaryPalette('black',{
            'default': '300'
        })
        .accentPalette('light-blue', {
            'default': '400'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        triThemingProvider.theme('adminja-white')
        .primaryPalette('grey',{
            'default': '200'
        })
        .accentPalette('cyan', {
            'default': '400'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });


        triThemingProvider.theme('adminja-green')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('green',{
            'default': '500',
            'hue-1': '300'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        triThemingProvider.theme('grey-menu')
        .primaryPalette('grey', {
            'default': '800',
            'hue-1': '600'
        })
        .accentPalette('green', {
            'default': '500'
        })
        .warnPalette('amber');

/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

        triSkinsProvider.skin('adminja', 'Adminja')
        .sidebarTheme('grey-menu')
        .toolbarTheme('adminja-shade')
        .logoTheme('grey-menu')
        .contentTheme('adminja-green')
        .statusTheme('adminja-status');

        /**
         *  SET DEFAULT SKIN
         */
        triSkinsProvider.setSkin('adminja');
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig(triSettingsProvider, triRouteProvider) {
        var now = new Date();
        // set app name & logo (used in loader, sidemenu, footer, login pages, etc)
        triSettingsProvider.setName('Adminja');
        triSettingsProvider.setCopyright('&copy;' + now.getFullYear() + ' openmotive.com');
        triSettingsProvider.setLogo('assets/images/brand/adminja-bug.svg');
        // set current version of app (shown in footer)
        triSettingsProvider.setVersion('1.5');
        // set the document title that appears on the browser tab
        triRouteProvider.setTitle('Adminja');
        triRouteProvider.setSeparator('|');
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(config);

    /* @ngInject */
    function config(triLayoutProvider) {
       // set app templates (all in app/layouts folder so you can tailor them to your needs)

       // loader screen HTML & controller
       triLayoutProvider.setDefaultOption('loaderTemplateUrl', 'app/layouts/loader/loader.tmpl.html');
       triLayoutProvider.setDefaultOption('loaderController', 'LoaderController');

       // left sidemenu HTML and controller
       triLayoutProvider.setDefaultOption('sidebarLeftTemplateUrl','app/layouts/adminja-menu.tmpl.html');
       triLayoutProvider.setDefaultOption('sidebarLeftController', 'LeftSidenavController');

       // right sidemenu HTML and controller
       triLayoutProvider.setDefaultOption('sidebarRightTemplateUrl', 'app/layouts/rightsidenav/rightsidenav.tmpl.html');
       triLayoutProvider.setDefaultOption('sidebarRightController', 'RightSidenavController');

       // top toolbar HTML and controller
       triLayoutProvider.setDefaultOption('toolbarTemplateUrl', 'app/layouts/toolbar/adminja-toolbar.tmpl.html');
       triLayoutProvider.setDefaultOption('toolbarController', 'ToolbarController');

       // footer HTML
       triLayoutProvider.setDefaultOption('footerTemplateUrl', 'app/layouts/footer/footer.tmpl.html');


        triLayoutProvider.setDefaultOption('toolbarSize', 'small');

        triLayoutProvider.setDefaultOption('toolbarShrink', true);

        triLayoutProvider.setDefaultOption('toolbarClass', '');

        triLayoutProvider.setDefaultOption('contentClass', '');

        triLayoutProvider.setDefaultOption('sideMenuSize', 'icon');

        triLayoutProvider.setDefaultOption('showToolbar', true);

        triLayoutProvider.setDefaultOption('footer', false);

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, APP_LANGUAGES) {
        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a il8n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/il8n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        // setup available languages in translate
        var languageKeys = [];
        for (var lang = APP_LANGUAGES.length - 1; lang >= 0; lang--) {
            languageKeys.push(APP_LANGUAGES[lang].key);
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(languageKeys, {
            'en_US': 'en',
            'en_UK': 'en'
        })
        .use('en');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();
(function() {
    'use strict';

   ///////////////////////////////////////////////////////////
   /// textAngularSetup
           angular.module('textAngularSetup')
               .config(['$provide', function($provide){
                   // this demonstrates how to register a new tool and add it to the default toolbar
                   $provide.decorator('taOptions', ['$delegate', function(taOptions){
                       // $delegate is the taOptions we are decorating
                       // here we override the default toolbars and classes specified in taOptions.
                       taOptions.forceTextAngularSanitize = true; // set false to allow the textAngular-sanitize provider to be replaced
                       taOptions.keyMappings = []; // allow customizable keyMappings for specialized key boards or languages
                       // taOptions.toolbar = [

                       //     ['bold', 'italics', 'underline','justifyLeft','justifyCenter', 'insertLink']
                       // ];
                       taOptions.classes = {
                           focussed: 'focussed',
                           toolbar: 'btn-toolbar',
                           toolbarGroup: 'btn-group',
                           toolbarButton: 'btn btn-default',
                           toolbarButtonActive: 'active',
                           disabled: 'disabled',
                           textEditor: 'form-control',
                           htmlEditor: 'form-control'
                       };
                       return taOptions; // whatever you return will be the taOptions
                   }]);
                   // // this demonstrates changing the classes of the icons for the tools for font-awesome v3.x
                   // $provide.decorator('taTools', ['$delegate', function(taTools){
                   //     taTools.bold.iconclass = 'icon-bold';
                   //     taTools.italics.iconclass = 'icon-italic';
                   //     taTools.underline.iconclass = 'icon-underline';
                   //     taTools.ul.iconclass = 'icon-list-ul';
                   //     taTools.ol.iconclass = 'icon-list-ol';
                   //     taTools.undo.iconclass = 'icon-undo';
                   //     taTools.redo.iconclass = 'icon-repeat';
                   //     taTools.justifyLeft.iconclass = 'icon-align-left';
                   //     taTools.justifyRight.iconclass = 'icon-align-right';
                   //     taTools.justifyCenter.iconclass = 'icon-align-center';
                   //     taTools.clear.iconclass = 'icon-ban-circle';
                   //     taTools.insertLink.iconclass = 'icon-link';
                   //     taTools.insertImage.iconclass = 'icon-picture';
                   //     // there is no quote icon in old font-awesome so we change to text as follows
                   //     delete taTools.quote.iconclass;
                   //     taTools.quote.buttontext = 'quote';
                   //     return taTools;
                   // }]);
               }]);


})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routeConfig);

    /* @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {
        // disable strict so it doesn't matter if we have trailing slashes in our URLs or not
        $urlMatcherFactoryProvider.strictMode(false);
        // Setup the apps routes

        // 404 & 500 pages
        $stateProvider
        .state('404', {
            url: '/404',
            views: {
                'root': {
                    templateUrl: '404.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('401', {
            url: '/401',
            views: {
                'root': {
                    templateUrl: '401.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('500', {
            url: '/500',
            views: {
                'root': {
                    templateUrl: '500.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        });



        // set default routes when no path specified
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/', '/dashboard');

        // always goto 404 if route not found
        $urlRouterProvider.otherwise('/404');
        // $urlRouterProvider.otherwise('/login');

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(config);

    /* @ngInject */
    function config(ChartJsProvider) {
        // Configure all charts to use material design colors
        ChartJsProvider.setOptions({
            colours : [
            '#0F9D58', // green
            '#5C6BC0',
            '#FF7043',
            '#AB47BC'
            ],
            // colours: [

                // '#F4B400',    // blue
                // '#FF7043',    // red
                // '#FF7043',    // yellow
                // '#FF7043',    // green
                // '#FF7043',    // purple
                // '#FF7043',    // light blue
                // '#FF7043',    // orange
                // '#FF7043',    // browny yellow
                // '#FF7043'     // dark blue
            // ],
            responsive: true
        });
    }
})();

// colours: [

//     '#1A237E',    // blue
//     '#26C6DA',    // red
//     '#F4B400',    // yellow
//     '#0F9D58',    // green
//     '#AB47BC',    // purple
//     '#00ACC1',    // light blue
//     '#FF7043',    // orange
//     '#9E9D24',    // browny yellow
//     '#5C6BC0'     // dark blue
// ]

(function() {
    'use strict';

    angular
        .module('app')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $state, $log) {

        // default redirect if access is denied
        function redirectError() {
            $log.info('redirectError');
            $state.go('authentication.login');
        }

        // watches

        // redirect all errors to permissions to 500
        var errorHandle = $rootScope.$on('$stateChangeError', redirectError);

        // remove watch on destroy
        $rootScope.$on('$destroy', function() {
            errorHandle();
        });

        // window.onbeforeunload = function (e) {

        //     alert('Please Refresh your Adminja browser.')
        //     return;
        // }
    }
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin-account/account-page.tmpl.html","    <div class=\"full-height\" ui-view>\n\n    </div>\n\n\n");
$templateCache.put("app/admin-account/account-plan.tmpl.html","<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n<h1>plan</h1>\n</md-content>\n");
$templateCache.put("app/admin-account/account-profile.tmpl.html","\n<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n	<h3 class=\"center\" style=\"margin-bottom: 4em;\">Your Profile</h3>\n	<div layout-gt-md=\"row\" layout=\"column\">\n		<div flex=\"40\" >\n			<div class=\"center\">\n			<img ng-if=\"vm.user.avatar\" src=\"{{vm.user.avatar}}\" width=\"200\" height=\"200\"><br>\n	           <img ng-if=\"!vm.user.avatar\" src=\"/assets/images/avatars/generic-avatar.png\" width=\"200\" height=\"200\"><br>\n	           <md-button ng-hide=\"vm.user.avatar\" class=\"md-primary \" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\">\n	               <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Upload Photo\n	           </md-button>\n	           <md-button ng-show=\"vm.user.avatar\" class=\"md-primary \" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\">\n	               <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Change Photo\n	           </md-button>\n	           </div>\n		</div>\n		<div flex=\"60\">\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>First name</label>\n						<input name=\"firstname\" ng-model=\"vm.user.profile.firstname\" required>\n						<div ng-messages=\"vm.user.profile.firstname.$error\">\n						      <div ng-message=\"required\">Oops! Your name is required</div>\n						</div>\n					</md-input-container>\n				</div>\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Last name</label>\n						<input name=\"lastname\" ng-model=\"vm.user.profile.lastname\" required>\n						<div ng-messages=\"vm.user.profile.lastname.$error\">\n						      <div ng-message=\"required\">Oops! Your name is required</div>\n						</div>\n					</md-input-container>\n				</div>\n			</div>\n			<div  class=\"left\">\n				<md-input-container>\n					<label>E-mail Address</label>\n					<input disabled=\"disabled\" type=\"email\" name=\"email\" ng-model=\"vm.user.email\" required>\n					<div ng-messages=\"vm.user.email.$error\">\n					      <div ng-message=\"required\">Please provide a valid E-mail address!</div>\n					</div>\n				</md-input-container>\n			</div>\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Primary Phone</label>\n						<input name=\"phone\" ng-model=\"vm.user.profile.phone\">\n					</md-input-container>\n				</div>\n				<div class=\"center\" flex=\"50\">\n					<div style=\"display:block;\"> <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.dob\" md-placeholder=\"Date of Birth\"></md-datepicker></div>\n				</div>\n			</div>\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Business Info</label>\n						<input type=\"company\" name=\"company\" ng-model=\"vm.user.profile.company\" >\n					</md-input-container>\n				</div>\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Website</label>\n						<input type=\"website\" name=\"website\" ng-model=\"vm.user.profile.website\" >\n					</md-input-container>\n				</div>\n			</div>\n				<div  class=\"left\">\n					<md-input-container>\n						<label>Twitter</label>\n						<input type=\"twitter\" name=\"twitter\" ng-model=\"vm.user.profile.twitter\" >\n					</md-input-container>\n				</div>\n				<div class=\"right\">\n					<md-button type=\"submit\" ng-disabled=\"userform.$pristine\" class=\"md-indigo-theme md-primary md-raised\" ng-click=\"vm.updateUser(vm.user)\">\n						Save\n					</md-button>\n				</div>\n		</div>\n	</div>\n</md-content>\n\n\n\n\n");
$templateCache.put("app/admin-account/account-team.tmpl.html","<div layout-padding>\n<!-- <h3 class=\"center\">Manage Your Team</h3>\n -->	<div class=\"account-card-container\" layout=\"row\" layout-wrap>\n		<md-card flex=\"1\">\n		  <md-card-title>\n		    <md-card-title-text>\n			 <span class=\"md-headline\">Meagan Mena</span>\n			 <span class=\"md-subhead\">Your Conpmany USA<br><a href=\"http://www.yahoo.com\">www.yourcompany.usa</a></span>\n		    </md-card-title-text>\n		    <md-card-title-media>\n			 <div class=\"md-media-sm card-media\">\n			 	<img src=\"/assets/images/avatars/avatar-1.png\" width=\"100\"><br>\n			 </div>\n		    </md-card-title-media>\n		  </md-card-title>\n		  <md-card-actions layout=\"row\" layout-align=\"end center\">\n		    <md-button>\n				Remove\n			</md-button>\n		    <md-button>\n				Manage\n			</md-button>\n		  </md-card-actions>\n		</md-card>\n\n	</div>\n</div>\n");
$templateCache.put("app/admin-account/account-toolbar.tmpl.html","<!-- // Account Manager Toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" >\n  <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"side navigation\">\n      <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n  </md-button>\n\n  <div flex=\"nogrow\"  style=\"padding-right: 2em;\">\n    <h3>My Account</h3>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" class=\"md-button\"  ui-sref=\"triangular.account-page.profile\" ><md-icon md-font-icon=\"fa fa-user\"></md-icon> Profile</a>\n  </div>\n\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-users\"></md-icon> Team</a>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Plan</a>\n  </div>\n  <div flex></div>\n  <sidebar-controls></sidebar-controls>\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-billing.tmpl.html","<div id=\"scroll-h\" >\n\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    BILLING PERIOD LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div class=\"app-item-container hide-for-print\"\n	md-whiteframe=\"2\"\n	layout=\"column\"\n	layout-align=\"start\"\n	>\n	<div class=\"app-item-container-header\">\n		<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n			<div class=\"auto\">\n				<h3>Billing Periods</h3>\n			</div>\n\n		</div><!-- // end app-item-container-title-bar -->\n	</div><!-- // end app-item-container-header -->\n\n	<div class=\"app-item-container-items billing-container-items\"\n	layout=\"column\"\n	layout-align=\"start start\"\n	resize=\'false\'\n	style=\"padding-top:8px;\"\n	>\n	<p class=\"text-center md-subhead\" style=\"padding: 2em;\" ng-hide=\"vm.thisClient.billing\"><strong>No Billing Periods</strong><br>\n\n		<span ng-if=\"vm.thisClient.profile.plan.nextCycle\">This client\'s first billing period hasn\'t started yet.<br>It will start on {{vm.thisClient.profile.plan.nextCycle | amDateFormat: \'MMM DD YYYY\'}}.<br>\n			&nbsp;<br>If you recently setup this client, it may take a few minutes for their first period to appear.\n		</span>\n		<span ng-if=\"!vm.thisClient.profile.plan.nextCycle\">Please set this client\'s first cycle date to start billing.</span>\n	</p>\n	<billing-period-card ng-repeat=\"item in billing = (vm.thisClient.billing | toArray : false  | orderBy: [\'-start\']) track by item.uid\" period=\"item\" client=\"vm.thisClient\"></billing-period-card>\n</div>\n</div>\n<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n<!-- /////////////////////////////////    BILLING PERIOD VIEW  /////////////////////////////////////////////-->\n<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n<div class=\"app-item-container billing-period-panel hide-for-print\"\nmd-whiteframe=\"2\"\nlayout=\"column\"\nlayout-align=\"start\"\nng-if=\"vm.clientBillingService.selectedPeriod\"\nstyle=\"background-color: #fff;\"\n>\n<div class=\"app-item-container-header\">\n	<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n		<div class=\"auto\">\n			<h3>Billing Period Detail</h3>\n		</div>\n\n	</div><!-- // end app-item-container-title-bar -->\n</div><!-- // end app-item-container-header -->\n\n<div class=\"sub-panel-details\"\nlayout=\"column\"\nresize=\'false\'\nstyle=\"width: 700px;\"\n>\n<div class=\"sub-panel-details-header\" >\n	<form name=\"vm.periodForm\">\n		<div layout=\"row\">\n			<div flex=\'40\' layout=\'column\' layout-align=\"start start\">\n				<p class=\"md-display-1\" style=\"margin-top: 0;\">\n					{{vm.clientBillingService.selectedPeriod.info.start | amDateFormat:\'MMMM YYYY\'}}<br>\n					<span style=\"font-size: 12px;\">{{vm.clientBillingService.selectedPeriod.info.clientName}}</span>\n				</p>\n				<md-divider></md-divider>\n				<div class=\"billing-period-summary\" layout=\"row\" layout-align=\"end start\">\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Invoiced</h3>\n						<p>{{vm.currency}}{{vm.clientBillingService.selectedPeriod.info.total || 0 | number : 2}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Received</h3>\n						<p>{{vm.currency}}{{vm.clientBillingService.selectedPeriod.info.received || 0 | number: 2}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Balance</h3>\n						<p>{{vm.currency}}{{vm.clientBillingService.selectedPeriod.info.open || 0 | number: 2}}</p>\n					</div>\n				</div>\n			</div>\n			<div flex=\'60\' layout=\'column\' layout-align=\'start\'>\n				<div layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.editPeriod\">\n					{{vm.clientBillingService.selectedPeriod.info.start | amDateFormat:\'MMM Do, YYYY\'}} - {{vm.clientBillingService.selectedPeriod.info.end | amDateFormat:\'MMM Do, YYYY\'}}\n					<md-button style=\"margin-left: 1em;\" class=\"md-button-tiny\" ng-click=\"vm.enableEditPeriod()\"><md-icon md-font-icon=\"zmdi zmdi-lock\" style=\"font-size: 12px;\"></md-icon></md-button>\n				</div>\n				<div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.editPeriod\">\n					<md-datepicker  md-hide-icons=\"calendar\" ng-model=\"vm.clientBillingService.selectedPeriod.info.start\" md-placeholder=\"Start\"></md-datepicker>\n					<span style=\"font-size: 18px; padding:0 1em 0 1em;\">-</span>\n					<md-datepicker  md-hide-icons=\"calendar\" ng-model=\"vm.clientBillingService.selectedPeriod.info.end\" md-placeholder=\"End\"></md-datepicker>\n					<md-button class=\"md-button-tiny\" ng-click=\"vm.cancelEditPeriod()\">cancel</md-button>\n				</div>\n\n\n				<div class=\"billing-period-summary\" layout=\"row\" layout-align=\"end start\" style=\"padding-top: 1em;\">\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">\n						<h3 class=\"\">Allocated</h3>\n						<p class=\"\" style=\"margin-top: 0; margin-bottom: 10px;\">\n							<span class=\"inline-edit-field small\" inline-edit=\"vm.clientBillingService.selectedPeriod.info.allocated\" inline-edit-callback=\"vm.updateAllocated(newValue)\" inline-edit-on-click inline-edit-on-blur=\"vm.updateAllocated(newValue)\" inline-edit-btn-save=\" Done  \"></span>\n							hrs\n							</span>\n						</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\">\n						<h3 class=\"\">Rate</h3>\n						<p>\n							{{vm.currency}}<span class=\"inline-edit-field small\" inline-edit=\"vm.clientBillingService.selectedPeriod.info.rate\" inline-edit-callback=\"vm.updateRate(newValue)\" inline-edit-on-click inline-edit-on-blur=\"vm.updateRate(newValue)\" inline-edit-btn-save=\" Done  \"></span></span>\n						</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\">\n						<h3 class=\"\">Logged</h3>\n						<p>{{vm.used() | number: 2}}hrs</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\">\n						<h3 class=\"\">Remain</h3>\n						<p>{{vm.remain()| number: 2}}hrs</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\">\n						<h3 class=\"\">Total</h3>\n						<p>{{vm.currency}}{{vm.timeTotal() | number: 2}}</p>\n					</div>\n				</div>\n\n\n			</div>\n		</div>\n		<div layout=\"column\" layout-align=\"start start\">\n			<p class=\"md-subhead invoice-list\" style=\"font-size: 12px; width: 100%;\">\n				<strong>Invoices</strong><br>\n							<!-- <md-chips ng-model=\"vm.clientBillingService.selectedPeriod.invoices\" name=\"invoices\" readonly=\"true\" md-removable=\"false\">\n								<md-chip-template ng-click=\"vm.selectInvoice($chip.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == $chip.uid}\"  style=\"cursor: pointer;\">\n									 <span class=\"chip-content\"><md-icon ng-if=\"$chip.balance <= 0\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon> <md-icon md-font-icon=\"zmdi zmdi-receipt\" style=\"color: #fff;\"></md-icon> #{{$chip.number}}  - {{vm.currency}}{{$chip.total}} - {{$chip.due | amDateFormat: \'DD MMM\'}}</span >\n								</md-chip-template>\n							</md-chips> -->\n				<span ng-click=\"vm.selectInvoice(invoice.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == invoice.uid, \'due\': vm.now > invoice.due && invoice.balance > 0 }\"  style=\"cursor: pointer;\"  ng-repeat=\"invoice in vm.clientBillingService.selectedPeriod.invoices track by invoice.uid\">\n					<md-icon ng-if=\"invoice.balance <= 0\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon>\n					<md-icon ng-if=\"vm.now <= invoice.due && invoice.balance > 0 || !invoice.due && invoice.balance > 0\" md-font-icon=\"zmdi zmdi-receipt\"></md-icon>\n					<md-icon ng-if=\"vm.now > invoice.due && invoice.balance > 0\" md-font-icon=\"zmdi zmdi-receipt\" style=\"color: red;\"></md-icon>\n				#{{invoice.number}}  - {{vm.currency}}{{invoice.total}} <span ng-if=\"invoice.due\">- {{invoice.due | amDateFormat: \'DD MMM\'}}</span></span >\n				</span><br>\n			</p>\n		</div>\n		<div layout=\"column\" class=\"period-stats\" style=\"margin-top: 0\">\n\n			<md-input-container style=\"margin-bottom: 0; margin-top:0;\" class=\"billing-notes-container\">\n				<textarea ng-model=\"vm.clientBillingService.selectedPeriod.info.notes\"\n				rows=\"1\"\n				placeholder=\"Notes\"\n				style=\"overflow-y: scroll;\"\n				>\n				</textarea>\n			</md-input-container>\n			<div ng-if=\"!vm.periodForm.$pristine\" layout=\"row\" layout-align=\"end center\">\n				<md-button class=\"md-raised md-primary\" ng-click=\"vm.updatePeriod()\" ng-disabled=\"vm.periodForm.$pristine\"   aria-label=\"save changes\"> Save Changes</md-button>\n			</div>\n\n		</div>\n	</form>\n</div>\n\n<div class=\"sub-panel-content\" style=\"padding-bottom: 5em;\">\n	<form name=\"vm.addLineItemForm\" class=\"add-line-item-form\" ng-submit=\"vm.addNewEntry(vm.newEntry)\">\n		<div layout=\"column\" class=\"\" style=\"margin-top: 0; margin-bottom:0;\">\n			<h3 style=\"font-size: 16px; margin: 0 0 1em 0; padding:0;\" class=\"md-title center\">Add a Charge</h3>\n		</div>\n\n\n		<div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 0; padding-right: 1em;\">\n			<div flex=\"nogrow\">\n				<md-input-container style=\"margin-bottom: 0; margin-top: 0;\">\n					<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newEntry.date\" md-placeholder=\"Date\"></md-datepicker>\n				</md-input-container>\n			</div>\n			<div flex=\"grow\">\n				<md-input-container style=\"margin-bottom: 0; margin-top: 0;\">\n					<label>Description</label>\n					<input type=\"text\" ng-model=\"vm.newEntry.description\">\n				</md-input-container>\n			</div>\n			<div flex=\'20\' style=\"padding-right: 2em;\">\n				<md-input-container class=\"md-icon-float\" style=\"margin-bottom: 0; margin-top: 0;\">\n					<label>Cost</label>\n					<md-icon style=\"padding-left: 12px;\">{{vm.currency}}</md-icon>\n					<input type=\"text\" ng-model=\"vm.newEntry.cost\" >\n				</md-input-container>\n			</div>\n			<div flex=\'10\' style=\"padding-right: 2em;\">\n				<md-input-container style=\"margin-bottom: 0;margin-top: 0; \">\n					<label>Qty</label>\n					<input type=\"number\" ng-model=\"vm.newEntry.quantity\" ng-init=\"vm.newEntry.quantity = 1\">\n				</md-input-container>\n			</div>\n			<div flex=\'15\'>\n				<!-- <md-input-container style=\"margin-bottom: 0; margin-top: 0; padding-right: 1em;\" class=\"md-icon-float\"> -->\n					<md-icon style=\"padding-left: 12px;\">{{vm.currency}}</md-icon>\n					{{vm.newEntry.cost * vm.newEntry.quantity | number: 2}}\n					<!-- <input  ng-readonly=\"true\" type=\"text\" ng-value=\"vm.newEntry.cost * vm.newEntry.quantity | number: 2\"> -->\n				<!-- </md-input-container> -->\n			</div>\n		</div>\n		<div layout=\"row\" layout-align=\"end center\">\n			<div flex=\'nogrow\' layout-align=\"center center\">\n				<md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.addNewEntry(vm.newEntry);\" ng-disabled=\"!vm.newEntry.description || !vm.newEntry.cost || !vm.newEntry.quantity \" aria-label=\"Add Line Item\">\n					Add Charge\n				</md-button>\n			</div>\n		</div>\n	</form>\n	<div layout=\"row\">\n		<div flex>\n			<h3 style=\"margin-bottom: 0;\" class=\"md-title\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">Line Item Detail</h3>\n			<h3 style=\"margin-bottom: 0;\" class=\"md-title\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\">Time Logged</h3>\n			<p class=\"md-subhead\" style=\"margin-top:0; margin-bottom:0;\">Select items to add them to an invoice.</p>\n		</div>\n		<div flex class=\"text-right\">\n		<!-- 	<md-button ng-if=\"!vm.invoiceService.selectedInvoice && vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.invoiceSelectedLineItems()\" aria-label=\"Invoice Selected\">Invoice Selected Items</md-button>\n			<md-button ng-if=\"vm.invoiceService.selectedInvoice && vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.addSelectedLineItems()\" aria-label=\"Add Selected\">Add Selected Items</md-button> -->\n			<md-button class=\"md-button-small\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" ng-click=\"vm.printTime();\" >\n				<md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n			</md-button>\n\n		</div>\n	</div>\n\n	<!-- header used for both hourly and retainer views...only one difference in the cost/rate label -->\n	<div layout=\"row\" style=\"margin-top: 1em;\" class=\"billing-table-header\" layout-align=\"start start\">\n		<div flex=\"5\" >\n			<md-checkbox  ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllEntries()\" ng-model=\"vm.isAllSelected\" aria-label=\"select\"></md-checkbox>\n			<md-checkbox  ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllTimeEntries()\" ng-model=\"vm.isAllTimeSelected\" aria-label=\"select\"></md-checkbox>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\"><strong>Date</strong></span>\n		</div>\n		<div flex=\"45\">\n			<span class=\"md-subhead\"><strong>Description</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" class=\"md-subhead\"><strong>Rate</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Qty</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Total</strong></span>\n		</div>\n\n	</div>\n\n	<!-- TIME AS SELECTABLE LINE ITEMS////////////////////////////////////////////////////////////////////////////-->\n	<div ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" ng-repeat=\"entry in vm.timeReportService.report.data | orderBy: [\'-logDate\'] track by entry.uid\" layout=\'row\' layout-align=\"end start\">\n		<div flex=\"5\">\n			<!-- <md-checkbox style=\"margin-bottom: 0;\" ng-model=\"entry.selected\" ng-click=\"vm.timeOptionToggled()\" aria-label=\"select\"></md-checkbox> -->\n			<md-checkbox ng-if=\"!entry.invoiced && !entry.pending\" style=\"margin-bottom: 0;\" ng-model=\"entry.selected\" ng-click=\"vm.timeOptionToggled()\" aria-label=\"select\"></md-checkbox>\n			<md-icon  ng-if=\"entry.invoiced && !entry.pending\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n			<md-icon  ng-if=\"entry.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logDate | amDateFormat: \'MMM DD\'}}</span>\n		</div>\n		<div flex=\"45\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-if=\"entry.taskName\">({{entry.taskName}}) </span>{{entry.description}}</span>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{vm.clientBillingService.selectedPeriod.info.rate}}</span>\n		</div>\n		<div flex=\"10\" layout-align=\"center center\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logged |HandM}}</span>\n		</div>\n		<div flex=\"10\" layout-align=\"center center\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{(entry.logged/60) * vm.clientBillingService.selectedPeriod.info.rate | number: 2}}</span>\n		</div>\n		<div flex=\"10\">\n			&nbsp;\n		</div>\n\n	</div>\n				<!-- <div layout=\"row\" layout-align=\"end center\">\n					<md-button ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" flex=\"nogrow\" style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"Print Time Report\">Print Time Report</md-button>\n				</div> -->\n\n				<!-- Line item detail header : ***ONLY USED IN HOURLY VIEW** -->\n				<h3 ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" class=\"md-title\" style=\"margin-top: 1.5em; margin-bottom:0;\">Additional Charges</h3>\n				<p class=\"md-subhead\" style=\"margin-top:0; margin-bottom:0;\">Select items to add them to an invoice.</p>\n\n				<!-- <p ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" style=\"fontclass=\"md-subhead\">Additional Charges</p> -->\n\n				<div layout=\"row\" layout-align=\"end start\" style=\"margin-top: 1em;\" class=\"billing-table-header\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\">\n					<div flex=\"5\" >\n						<md-checkbox  style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllEntries()\" ng-model=\"vm.isAllSelected\" aria-label=\"select\"></md-checkbox>\n					</div>\n					<div flex=\"10\">\n						<span class=\"md-subhead\"><strong>Date</strong></span>\n					</div>\n					<div flex=\"45\">\n						<span class=\"md-subhead\"><strong>Description</strong></span>\n					</div>\n					<div flex=\'10\'>\n						<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n						<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n					</div>\n					<div flex=\'10\'>\n						<span class=\"md-subhead\"><strong>Qty</strong></span>\n					</div>\n					<div flex=\'10\'>\n						<span class=\"md-subhead\"><strong>Total</strong></span>\n					</div>\n					<div flex=\'10\'>\n					</div>\n				</div>\n				<!-- //Line item detail header : ***ONLY USED IN HOURLY VIEW** -->\n\n				<!-- LINE ITEM MANAGEMENT /////////////////////////////////////////////////////////////////////////////////////-->\n				<div ng-repeat=\"item in vm.clientBillingService.selectedPeriod.lineItems track by item.uid\" layout=\'row\' layout-align=\"end start\">\n					<div flex=\"5\">\n						<!-- <md-checkbox style=\"margin-bottom: 0;\" ng-model=\"item.selected\" ng-click=\"vm.optionToggled()\" aria-label=\"select\"></md-checkbox> -->\n						<md-checkbox ng-if=\"!item.invoiced && !item.pending\" style=\"margin-bottom: 0;\" ng-model=\"item.selected\" ng-click=\"vm.optionToggled()\" aria-label=\"select\"></md-checkbox>\n						<md-icon  ng-if=\"item.invoiced && !item.pending\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n\n\n						<md-icon  ng-if=\"item.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n					</div>\n					<div flex=\"10\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.date | amDateFormat: \'MMM DD\'}}</span>\n					</div>\n					<div flex=\"45\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.description | limitTo : 60 : begin}}</span>\n					</div>\n					<div flex=\"10\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{item.cost}}</span>\n					</div>\n					<div flex=\"10\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.quantity}}</span>\n					</div>\n					<div flex=\"10\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{item.cost * item.quantity}}</span>\n					</div>\n					<div flex=\"10\">\n						<md-button ng-if=\"!item.invoiced\" style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.deleteEntry(item)\" aria-label=\"Delete\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n					</div>\n				</div>\n\n				<div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 1em;\">\n					<md-button ng-if=\"!vm.invoiceService.selectedInvoice\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.invoiceSelectedLineItems()\" aria-label=\"Invoice Selected\">Invoice Selected Items</md-button>\n					<md-button ng-if=\"vm.invoiceService.selectedInvoice\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.addSelectedLineItems()\" aria-label=\"Add Selected\">Add Selected Items</md-button>\n				</div>\n\n				<!-- only show time detail for reference/printing if we are on a retainer plan -->\n				<div ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">\n					<md-divider style=\"margin-top: 1em;\"></md-divider>\n					<div layout=\"row\" layout-align=\"start center\">\n						<div flex>\n							<h3 class=\"md-title\">Time Logged</h3>\n						</div>\n						<div flex class=\"text-right\">\n							<md-button class=\"md-button-small\" ng-click=\"vm.printTime();\" >\n								<md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n							</md-button>\n						</div>\n\n\n					</div>\n					<div layout=\"row\" layout-align=\"end start\" style=\"margin-top: 1em;\" class=\"billing-table-header\">\n						<div flex=\"10\" style=\"padding-left: .5em;\">\n							<span class=\"md-subhead\"><strong>Date</strong></span>\n						</div>\n						<div flex>\n							<span class=\"md-subhead\"><strong>Description</strong></span>\n						</div>\n						<div flex=\'15\'>\n							<span class=\"md-subhead\"><strong>Logged</strong></span>\n						</div>\n					</div>\n\n					<div ng-repeat=\"entry in vm.timeReportService.report.data | orderBy: [\'-logDate\'] track by entry.uid\" layout=\'row\' layout-align=\"end start\">\n						<div flex=\"10\">\n							<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logDate | amDateFormat: \'MMM DD\'}}</span>\n						</div>\n						<div flex>\n							<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-if=\"entry.taskName\">({{entry.taskName}}) </span>{{entry.description}}</span>\n						</div>\n						<div flex=\"15\" layout-align=\"center center\">\n							<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logged |HandM}}</span>\n						</div>\n\n					</div>\n					<!-- <div layout=\"row\" layout-align=\"end center\">\n\n							<md-button style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"Print Time Report\">Print Time Report</md-button>\n\n						</div> -->\n					</div>\n				</div>\n			</div>\n		</div>\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<!-- /////////////////////////////////    INVOICE VIEW  /////////////////////////////////////////////-->\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<div class=\"app-item-container invoice-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-if=\"vm.invoiceService.selectedInvoice\"\n		style=\"background-color: #fff; margin-right: 80px;\"\n		hotkey=\"{esc: vm.cancelInvoice}\"\n		>\n		<div class=\"app-item-container-header\"  >\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.thisClient.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Invoice #{{vm.invoiceService.selectedInvoice.info.number}} - {{vm.thisClient.profile.fullName}} </h3>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"invoice-container\"\n		layout=\"column\"\n			>\n		<!-- ///// Invoice -->\n		<div class=\"invoice\" layout=\"column\" print-section>\n			<div>\n				<div class=\"invoice-header\" layout=\"row\" layout-align=\"start start\">\n					<div flex=\"60\">\n						<p class=\"md-title\"><span style=\"color: red; font-weight: bold;\" ng-if=\"!vm.invoiceService.selectedInvoice.uid\">Draft </span>Invoice #\n							<span class=\"inline-edit-field small\" inline-edit=\"vm.invoiceService.selectedInvoice.info.number\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span> <span ng-if=\"vm.invoiceService.selectedInvoice.info.due < vm.now && vm.invoiceDue() > 0\" style=\"color: red;\">Past Due</span>\n						</p>\n						<p class=\"md-subhead recipient-address\">\n							<strong>Bill to:</strong><br>\n							<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.name\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n							<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.address\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n							<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.city\" inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>,\n							<span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.state\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n							<span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.postal\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n							<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.country\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n						</p>\n					</div>\n					<div flex layout=\"column\" layout-align=\"none end\">\n\n						<img ng-if=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\">\n						<md-input-container class=\"hide-for-print\" style=\"margin-top: 1em; margin-bottom: 0;\">\n							<label>Invoice Date</label>\n							<md-datepicker class=\"md-indigo-theme md-primary\" ng-change=\"vm.updateInvoiceDate()\" ng-model=\"vm.invoiceService.selectedInvoice.info.date\" md-placeholder=\"\" md-current-view=\"month\"></md-datepicker>\n						</md-input-container>\n\n						<md-input-container class=\"hide-for-print\" style=\"margin-top: .5em; margin-bottom: 0;\">\n							<label>Due</label>\n							<md-datepicker class=\"hide-for-print md-indigo-theme md-primary\" ng-change=\"vm.updateInvoice()\" ng-model=\"vm.invoiceService.selectedInvoice.info.due\" md-placeholder=\"Due\" md-current-view=\"month\"></md-datepicker>\n						</md-input-container>\n\n						<p class=\"text-right\" print-only>Issued: {{vm.invoiceService.selectedInvoice.info.date | amDateFormat: \'MMM DD, YYYY\'}}<br>\n							Due: {{vm.invoiceService.selectedInvoice.info.due | amDateFormat: \'MMM DD, YYYY\'}}\n						</p>\n\n\n					</div>\n				</div><!-- // invoice-header -->\n			</div>\n			<div class=\"invoice-body\" style=\"padding-top: 1em;\">\n				<div layout=\'row\' layout-align=\"start start\" class=\"invoice-table-header\">\n					<div flex=\"15\">\n						Date\n					</div>\n					<div flex=\"35\">\n						Description\n					</div>\n					<div flex=\"15\">\n						Cost/Rate\n					</div>\n					<div flex=\"15\">\n						Qty\n					</div>\n					<div flex=\"10\" class=\"text-right\">\n						Total\n					</div>\n\n\n				</div>\n				<div ng-repeat=\"entry in vm.invoiceService.selectedInvoice.time | orderBy: [\'-logDate\'] track by entry.uid\" layout=\'row\' layout-align=\"start start\">\n\n					<div flex=\"15\" style=\"padding-left: 10px;\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logDate | amDateFormat: \'MMM DD\'}}</span>\n					</div>\n					<div flex=\"35\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">\n							<span ng-if=\"entry.taskName\"><span class=\"inline-edit-field\" inline-edit-on-blur=\"cancel\" inline-edit=\"entry.taskName\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span></span>\n							<span class=\"inline-edit-field large\" inline-edit-on-blur=\"cancel\" inline-edit=\"entry.description\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n						</span>\n					</div>\n					<div flex=\"15\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}\n							<span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"entry.rate\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n						</span>\n					</div>\n					<div flex=\"15\" layout-align=\"center center\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\"><span class=\"inline-edit-field xsmall\" inline-edit-on-blur=\"cancel\" inline-edit=\"entry.logged\" inline-edit-filter=\"HandM\" inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n					</span>\n				</div>\n				<div flex=\"10\" class=\"text-right\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{(entry.logged/60) * vm.clientBillingService.selectedPeriod.info.rate | number: 2}}</span>\n				</div>\n				<div flex=\"10\" class=\"hide-for-print\">\n					<md-button ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.removeInvoiceTimeEntry(entry)\" aria-label=\"Remove\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n				</div>\n\n\n			</div>\n			<div ng-repeat=\"item in vm.invoiceService.selectedInvoice.lineItems track by item.uid\" layout=\'row\' layout-align=\"start start\">\n				<div flex=\"15\" style=\"padding-left: 10px;\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.date | amDateFormat: \'MMM DD\'}}</span>\n				</div>\n				<div flex=\"35\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">\n						<span class=\"inline-edit-field large\" inline-edit-on-blur=\"cancel\" inline-edit=\"item.description\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n					</span>\n				</div>\n				<div flex=\"15\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}\n						<span class=\"inline-edit-field xsmall\" inline-edit-on-blur=\"cancel\" inline-edit=\"item.cost\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n					</span>\n				</div>\n				<div flex=\"15\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">\n						<span class=\"inline-edit-field xsmall\" inline-edit-on-blur=\"cancel\" inline-edit=\"item.quantity\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n					</span>\n				</div>\n				<div flex=\"10\" class=\"text-right\">\n					<span class=\"md-subhead\" style=\"font-size: 11px;\">{{vm.currency}}{{item.cost * item.quantity | number: 2}}</span>\n				</div>\n				<div flex=\"10\" class=\"hide-for-print\">\n					<md-button ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.removeInvoiceLineItem(item)\" aria-label=\"Remove\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n				</div>\n\n			</div>\n\n			<div layout=\'row\' style=\"margin-top: 2em;\">\n				<p flex class=\"text-right\" style=\"margin:0;\">\n					<strong>Invoice Amount:&nbsp;</strong><strong>{{vm.currency}}{{vm.invoiceTotal() |number: 2}}</strong>\n				</p>\n			</div>\n			<div ng-if=\"vm.invoiceService.selectedInvoice.info.payments\" >\n				<h3 class=\"md-subhead invoice-table-header\">Payments received</h3>\n				<div layout=\"row\" layout-align=\"start start\" ng-repeat=\"payment in vm.invoiceService.selectedInvoice.info.payments | toArray: false | orderBy: \'date\' track by payment.uid\">\n					<div flex=\"15\" style=\"padding-left: 10px;\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{payment.date | amDateFormat: \'MMM DD\'}}</span>\n					</div>\n					<div flex>\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">{{payment.notes}}</span>\n					</div>\n					<div flex=\"10\" class=\"text-right\">\n						<span class=\"md-subhead\" style=\"font-size: 11px;\">({{vm.currency}}{{payment.amount | number: 2}})</span>\n					</div>\n					<div flex=\"10\" >\n						<md-button style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small hide-for-print\" style=\"margin:0;\" ng-click=\"vm.removePayment(payment)\" aria-label=\"Remove\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n					</div>\n				</div>\n\n			</div>\n			<div layout=\'row\' style=\"margin-top: 1em;\">\n				<p flex class=\"text-right\" style=\"margin:0;\">\n					<strong>Balance Due:&nbsp;</strong><strong>{{vm.currency}}{{vm.invoiceDue() |number: 2}}</strong>\n				</p>\n			</div>\n			<!-- /// Payments -->\n			<form class=\"hide-for-print payment-form\" name=\"vm.paymentForm\" ng-submit=\"vm.addNewPayment(vm.newPayment)\">\n				<div class=\"payments md-padding\" ng-if=\"vm.invoiceService.selectedInvoice.uid\" style=\"margin-top: 1.5em; margin-bottom: 1em;\">\n					<div ng-if=\"vm.invoiceDirty\">\n						<p class=\"center\">Please commit your changes before applying payments.</p>\n					</div>\n\n					<div ng-if=\"!vm.invoiceDirty\">\n						<div layout=\"column\" class=\"\" >\n							<h3 style=\"margin-top: 0; font-size: 16px;\" class=\"md-title text-center\" >Record Payment</h3>\n						</div>\n\n						<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\" >\n							<div flex=\"nogrow\">\n								<md-input-container md-no-float  style=\"width:90px;\">\n									<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newPayment.date\" md-placeholder=\"Date\" style=\"width:90px;\"></md-datepicker>\n								</md-input-container>\n							</div>\n							<div flex=\"20\" style=\"min-width: 120px; max-width: 120px;\">\n								<md-input-container md-no-float class=\"md-icon-float\" >\n									<md-icon style=\"padding-left: 12px;\">{{vm.currency}}</md-icon>\n									<input type=\"number\" step=\"0.01\" ng-model=\"vm.newPayment.amount\" placeholder=\"Amount\">\n								</md-input-container>\n							</div>\n							<div flex=\"auto\">\n								<md-input-container md-no-float>\n									<input type=\"text\" ng-model=\"vm.newPayment.notes\" placeholder=\"Method &amp; Notes\">\n								</md-input-container>\n							</div>\n\n						</div>\n						<div layout=\"row\" layout-align=\"end center\">\n							<md-button flex=\"nogrow\" type=\"submit\" style=\"margin-top: 0;\" class=\"md-raised md-accent\" ng-click=\"vm.addNewPayment(vm.newPayment)\" ng-disabled=\"!vm.newPayment.notes || !vm.newPayment.amount || !vm.newPayment.date \" aria-label=\"Apply Payment\">\n								Apply Payment\n							</md-button>\n						</div>\n					</div>\n				</div><!-- // End Payments -->\n			</form>\n\n\n					<div layout=\"row\" style=\"padding-top: 3em; \">\n						<div flex style=\"padding-right: 3em;\">\n\n							<md-input-container>\n								<textarea style=\"border-bottom: none;\" rows=\"1\" max-rows=\"4\" ng-change=\"vm.makeDirty()\" ng-model=\'vm.invoiceService.selectedInvoice.info.terms\' placeholder=\"Terms\">\n								</textarea>\n							</md-input-container>\n						</div>\n						<div flex style=\"padding-right: 3em;\">\n							<md-input-container>\n								<textarea style=\"border-bottom: none;\" rows=\"1\" max-rows=\"4\" ng-change=\"vm.makeDirty()\" ng-model=\'vm.invoiceService.selectedInvoice.info.notes\' placeholder=\"Notes\">\n								</textarea>\n							</md-input-container>\n						</div>\n					</div>\n				</div><!-- // invoice-body -->\n\n				<!--<div print-only >\n\n					<div class=\"payment-stub\" style=\"page-break-before: always;\">\n					<md-divider></md-divider>\n						<div layout=\"row\">\n							<div flex=\"40\">\n								<h3 class=\"md-title\">PAYMENT STUB</h3>\n								<p class=\"remit-address\">\n									{{vm.invoiceService.selectedInvoice.remit.company}}<br>\n									{{vm.invoiceService.selectedInvoice.remit.street}}<br>\n									<span ng-if=\"vm.invoiceService.selectedInvoice.remit.street1\">{{vm.invoiceService.selectedInvoice.remit.street2}}<br></span>\n									{{vm.invoiceService.selectedInvoice.remit.city}},\n									{{vm.invoiceService.selectedInvoice.remit.state}}\n									{{vm.invoiceService.selectedInvoice.remit.zip}}<br>\n									<span ng-if=\"vm.invoiceService.selectedInvoice.remit.country\">{{vm.invoiceService.selectedInvoice.remit.country}}</span>\n								</p>\n							</div>\n							<div flex=\"60\">\n								<h3 class=\"md-title\">&nbsp;</h3>\n								<div layout=\"row\" style=\"padding-right: 5em;\">\n									<div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n\n										<p><strong>\n											Client<br>\n											INVOICE #<br>\n											INVOICE Date<br>\n											Balance Due<br>\n											Amount Enclosed\n										</strong></p>\n									</div>\n									<div flex=\"50\">\n										<p class=\"text-right\">\n											{{vm.thisClient.profile.fullName}}<br>\n											{{vm.invoiceService.selectedInvoice.info.number}}<br>\n											{{vm.invoiceService.selectedInvoice.date | amDateFormat : \"MMMM DD, YYYY\"}}<br>\n											{{vm.currency}}{{vm.invoiceDue() |number: 2}}<br>\n											________________________\n										</p>\n									</div>\n								</div>\n							</div>\n						</div>\n\n						<div layout=\"row\" layout-align=\"center center\">\n\n							<div flex=\"nogrow\">\n								<img flex=\"nogrow\" src=\"/assets/images/brand/adminja-bug.svg\" width=\"15px\" flex=\"nogrow\" style=\"margin:0; opacity: .5;\">\n								<span flex=\"nogrow\" style=\"font-size: 10px; color: #888; margin: 0; padding: 0 0 0 1em;\">\n									Powered by Adminja\n								</span>\n							</div>\n						</div>\n					</div><\n\n				</div>-->\n\n			</div>\n\n\n			<!-- ///// Invoice Controls -->\n			<div class=\"invoice-controls\" layout=\"row\" style=\"width: 100%; background-color: rgba(240,240,240,1);\" layout-align=\"center center\">\n\n				<md-button flex=\"nogrow\" ng-if=\"vm.invoiceDirty || !vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Cancel</md-button>\n				<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceDirty && vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n				<span flex=\"nogrow\" ng-if=\"vm.invoiceService.selectedInvoice.uid\">\n\n					<!-- <md-button class=\"\" ng-click=\"vm.downloadInvoice()\">Download</md-button>\n						<md-button class=\"\" ng-click=\"vm.sendInvoice()\">Send</md-button> -->\n						<md-button ng-if=\"!vm.deleting && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" class=\"md-button-small\" ng-click=\"vm.showDeleteInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete</md-button>\n						<md-button style=\"margin: 0; padding:0;\" ng-if=\"vm.deleting\" class=\"md-button-small\" ng-click=\"vm.deleting = false\">x</md-button>\n						<md-button ng-if=\"vm.deleting\" class=\"md-raised md-warn\" ng-click=\"vm.deleteInvoice(vm.invoiceService.selectedInvoice)\">Delete this Invoice?</md-button>\n					</span>\n					<!-- <md-button ng-href=\"https://console.firebase.google.com/u/0/project/adminja-staging/database/adminja-staging/data/invoices/{{vm.invoiceService.selectedInvoice.uid}}\">Invoice Data</md-button> -->\n\n					<div ng-if=\"vm.invoiceService.selectedInvoice.uid\">\n						<md-button flex=\"nogrow\" ng-if=\"vm.invoiceDirty\" class=\"md-raised md-accent\" ng-click=\"vm.updateInvoice()\" style=\"margin-right: 3em;\">Commit Changes</md-button>\n						<md-button ng-click=\"vm.preparePDF()\" ng-if=\"!vm.invoiceService.selectedInvoice.pdf.link && !vm.invoiceDirty\" flex=\"nogrow\"  class=\"\"><md-icon md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon>Request PDF</md-button>\n						<md-button ng-click=\"vm.preparePDF()\" ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" flex=\"nogrow\"  class=\"\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px;\"></md-icon>Requesting PDF</md-button>\n						<!-- <md-button ng-disabled=\"true\" ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" flex=\"nogrow\"  class=\"\" style=\"text-align: center;\">Preparing PDF. We will notify you when it is ready.</md-button> -->\n						<!-- <md-progress-linear ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" class=\"md-accent margin-bottom-10\" md-mode=\"indeterminate\"></md-progress-linear> -->\n						<md-button ng-if=\"vm.invoiceService.selectedInvoice.pdf.link && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" ng-href=\"{{vm.invoiceService.selectedInvoice.pdf.link}}\" download=\"{{vm.invoiceService.selectedInvoice.pdf.link}}\" target=\"_blank\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>Download PDF</md-button>\n						<md-button ng-if=\"vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" ng-click=\"vm.emailInvoice(vm.invoiceService.selectedInvoice)\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>Send by Email</md-button>\n					</div>\n					<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceService.selectedInvoice.uid\" class=\"md-raised md-accent\" ng-click=\"vm.saveInvoice()\" style=\"margin-right: 3em;\">Save</md-button>\n					<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceDirty && vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n\n				</div>\n			</div>\n		</div>\n		<!-- // End Invoice View -->\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<!-- /////////////////////////////////    Print Time VIEW  /////////////////////////////////////////////-->\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<div class=\"app-item-container timeentry-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-if=\"vm.printReport\"\n		style=\"background-color: #fff;\"\n		hotkey=\"{esc: vm.cancelInvoice}\"\n		>\n		<div class=\"app-item-container-header\"  >\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Time Detail</h3>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"time-period-details\"\n		layout=\"column\"\n		resize=\'false\'\n		>\n		<print-time-report report=\"vm.printReport\"></print-time-report>\n	</div><!-- // time period details -->\n</div>\n<!-- // End Print Time View -->\n<div ng-show=\"billing.length == 1 && !vm.user.profile.onboardingFlags.billing\" layout=\"column\" layout-align=\"start center\" style=\"padding-top: 3em;\" class=\"md-padding\">\n	<p class=\"center\">First time working with Billing Periods?</p>\n	<md-button style=\"width: 150px; color: #fff;\" ng-if=\"billing.length == 1\" ng-click=\"vm.showCue(\'-KppUp3ARikBnT5MfMXk\', \'billing\')\">Learn How it Works</md-button>\n</div>\n<!-- this is required so we can slide invoice mostly into view. It\'s a hack but the right margin on the app-item-container isn\'t being respected without it-->\n<div class=\"billing-spacer\" style=\"display:block; width:10px;\">\n	&nbsp;\n</div>\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-manager-clients.tmpl.html","<div layout-padding class=\"no-scrollbar\">\n	<div layout=\"row\" layout-align=\"end center\" class=\"spaces-view-toggle\">\n		<md-button ng-class=\"{\'active\' : spacesView ==\'active\'}\" no-ink ng-click=\"spacesView = \'active\'\" class=\"md-button-small\">Active</md-button>\n		<md-button  ng-class=\"{\'active\' : spacesView ==\'archived\'}\"no-ink ng-click=\"spacesView = \'archived\'\" class=\"md-button-small\">Archived</md-button>\n	</div>\n\n	<div ng-if=\"spacesView == \'active\'\" layout=\'column\' layout-align=\"start center\">\n		<div ng-if=\"clients.length\" class=\"row account-card-container\" layout-align=\"center center\" style=\"margin-top:-65px; margin-bottom: 0;\">\n			<new-client-button flex=\"nogrow\"></new-client-button>\n		</div>\n		<div ng-if=\"clients.length\" class=\"account-card-container\" layout=\"row\" layout-wrap layout-align=\"center space-between\" dragula=\"\'client-sort\'\" style=\"margin:0; padding:0 1em 1em 0;\">\n			<client-card ng-repeat=\"client in clients | orderBy: \'order\' | filter: { owner: user.uid } |filter : {status: \'!archived\'} | limitTo: clientLimit track by client.uid\" ></client-card>\n		</div>\n	</div>\n\n	<md-content ng-show=\"!clients.length && spacesView == \'active\'\" class=\"account-card-container\" style=\"background-color: transparent;\" layout-fill>\n		<div ng-show=\"!vm.showDashboard()\" flex=\"auto\" class=\"chart-all-clients-plan-summary\"  layout=\"row\" layout-align=\"center center\" style=\"margin-right: 5px;\">\n		        <div flex=\"100\" flex-gt-sm=\"50\" class=\"placeholder-message\">\n		            <p class=\"md-headline center margin-20\">Let\'s get started by creating <br> your first Workspace! <br></p>\n		            <p class=\"center\"><new-client-button flex=\"nogrow\" style=\"margin-top: 1em;\"></new-client-button></p>\n		        </div>\n		</div>\n	</md-content>\n\n	<div ng-if=\"spacesView == \'archived\'\">\n		<div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -65px;\"><h3 class=\"md-title center\" style=\"color: #fff;\">Archived Workspaces</h3></div>\n		<div ng-if=\"archivedClients.length\" layout=\"row\" layout-align=\"center start\" style=\"margin:0; padding:0 1em 1em 0;\">\n			<table class=\"table-archived-clients\" style=\"width: 100%; max-width: 600px; background-color: #fff; \" >\n				<thead>\n					<tr>\n						<th style=\"padding-left: 1em; padding-top: .5em;\">Workspace</th>\n						<th style=\"width: 150px; padding-top: .5em;\">Archived on</th>\n						<th style=\"width: 100px; padding-top: .5em;\"></th>\n						<th style=\"width: 100px; padding-top: .5em;\"></th>\n					</tr>\n				</thead>\n\n				<tr ng-repeat=\"client in archivedClients | orderBy: \'order\' | filter: { owner: user.uid } |filter : archiveFilter track by client.uid\" >\n						<td style=\"padding-left: 1em;\"><strong>{{client.profile.fullName}}</strong> </td>\n						<!-- <td ng-if=\"user.type == \'admin\'\" style=\"padding-left: 1em;\"><strong><a href=\"https://console.firebase.google.com/project/adminja-staging/database/data/clients/{{client.uid}}\" target=\"_blank\">{{client.profile.fullName}}</a></strong> </td> -->\n						<td>{{client.lastArchived | amDateFormat: \'MMMM Do, YYYY\' }}</td>\n						<td class=\"center\" ><md-button class=\"md-button-small md-accent\" ng-click=\"restoreClient(client, $event)\">Restore</md-button></td>\n						<td ng-if=\"client.status == \'archived\'\" class=\"center\" ><md-button  class=\"md-button-small md-warn\" ng-click=\"deleteClient(client, $event)\">Delete</md-button></td>\n						<td ng-if=\"client.status == \'deleting\'\" class=\"center\" ><md-button  class=\"md-button-small md-warn\" ng-disabled=\"true\">Deleting...</md-button></td>\n				</tr>\n			</table >\n		</div>\n	</div>\n</div>\n");
$templateCache.put("app/admin-client-manager/client-manager-page.tmpl.html","\n<div ui-view>\n\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-manager-toolbar.tmpl.html","<!-- // client manager toolbar -->\n<div class=\"md-toolbar-tools client-manager-toolbar\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.clientColor}};\">\n	<md-button md-no-ink class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n			<md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n	</md-button>\n	<!-- desktop client toolbar -->\n	<div show-sm show-md show-lg show-xl hide-xs flex=\"auto\" layout=\"row\" layout-align=\"start center\" class=\"scrollable-toolbar-container\">\n\n\n		<div flex=\"none\">\n\n			<h3 style=\"font-weight: 500; white-space: nowrap\" ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" ng-show=\"client.name\" class=\"toolbar-title\">{{client.name}}</h3>\n\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n\n				<md-button md-no-ink ng-class=\"{\'md-button-split-left\': teamList.length > 1}\" ui-sref-active=\"active\" ui-sref=\"triangular.client-manager-page.tasks\">\n					<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon>\n					<span ng-if=\"teamDataService.filteredMember\">{{teamDataService.filteredMemberName}}\'s </span><span class=\"\">Tasks</span>\n					<md-menu ng-if=\"showTeamFilter() && currentPage() == \'Tasks\'\" md-position-mode=\"target-right bottom\" class=\"md-menu-split\">\n							<!-- Trigger element is a md-button with an icon -->\n						<md-button md-no-ink ng-click=\"$mdMenu.open($event)\" aria-label=\"Filter Tasks\" class=\"md-icon-button md-button-split-right\">\n							<md-icon md-font-icon=\"fa fa-filter\">\n									<md-tooltip md-delay=\"1000\">Filter Tasks </md-tooltip>\n							</md-icon>\n						</md-button>\n						<md-menu-content style=\"padding: 0; width: 200px;\">\n							<md-menu-item layout=\"column\" layout-align=\"start center\">\n								<md-button md-no-ink ng-click=\"filterUser(\'all\')\" style=\"padding: 0; margin: 0;\">\n									<md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em; font-size: 18px;\"></md-icon>\n								    <span class=\"small\">Whole Team</span>\n								</md-button>\n							</md-menu-item>\n							<md-menu-item layout=\"column\" layout-align=\"start center\" ng-repeat=\"member in teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by member.uid\" value=\"{{member.uid}}\" style=\"border-left: 4px solid {{member.color}};\">\n								<md-button md-no-ink ng-click=\"filterUser(member)\" style=\"padding: 0; margin: 0;\">\n								    <img flex=\"nogrow\" src=\"{{member.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n								    <span class=\"small\">{{member.profile.firstName}}\'s Tasks</span>\n								</md-button>\n							  </md-menu-item>\n							</md-menu-item>\n						</md-menu-content>\n					</md-menu>\n				</md-button>\n\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\">\n				<md-button md-no-ink ui-sref-active=\"active\" ui-sref=\"triangular.client-manager-page.information\">\n					<md-icon md-font-icon=\"zmdi zmdi-info\"></md-icon>\n					<span class=\"\">Information</span>\n				</md-button>\n		</div>\n\n\n		<div flex=\"nogrow\" class=\"toolbar-button-container\">\n			<md-button md-no-ink ng-disabled=\"!hasRecurring\" ui-sref=\"triangular.client-manager-page.task-templates\"  ui-sref-active=\"active\" >\n\n						<md-icon md-font-icon=\"zmdi zmdi-refresh\">\n\n						</md-icon>\n						<span class=\"\">Recurring</span>\n			</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\">\n			<md-button md-no-ink  ui-sref-active=\"active\" ui-sref=\"triangular.client-manager-page.time\" >\n				<md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n				<span class=\"\">Time</span>\n			</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" ng-if=\"isOwner && client.status != \'personal\'\">\n			<md-button md-no-ink ng-show=\"hasBilling\"  ui-sref-active=\"active\" ui-sref=\"triangular.client-manager-page.client-billing\" >\n				<md-icon md-font-icon=\"fa fa-credit-card\"></md-icon>\n				<span class=\"\">Billing</span>\n			</md-button>\n		</div>\n\n		<!-- <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\" ng-show=\"$state.includes(\'triangular.client-manager-page.tasks\')\">\n			<label><md-icon md-font-icon=\"fa fa-exclamation\" style=\"color: orange; font-size: 12px;\"></md-icon></label>\n			<md-switch  ng-model=\"$rootScope.showToday\" aria-label=\"Show Today\" >\n			 </md-switch>\n		</div> -->\n		<div flex>\n		</div>\n	</div><!-- // scrollable-toolbar-container -->\n	<!-- mobile client toolbar -->\n	<div hide-sm hide-md hide-lg hide-xl show-xs flex=\"auto\" layout=\"row\"  class=\"scrollable-toolbar-container\" >\n			<h3 flex=\"nogrow\" style=\"font-weight: 500;\" ng-show=\"client.name\" class=\"toolbar-title\">\n				{{client.name}}\n			</h3>\n			<div flex=\"auto\">\n			<md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n					<!-- Trigger element is a md-button with an icon -->\n					<md-button md-no-ink ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-button-small\" style=\"margin-right: 0; margin-left: 0;\">\n							{{currentPage()}} <md-icon md-font-icon=\"zmdi zmdi-caret-down\">\n									<md-tooltip md-delay=\"1000\">Group Menu</md-tooltip>\n							</md-icon>\n					</md-button>\n					<md-menu-content>\n							<md-menu-item>\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.client-manager-page.information\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n											 Profile\n									</md-button>\n							</md-menu-item>\n							<md-menu-item>\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.client-manager-page.tasks\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n											 Tasks\n									</md-button>\n							</md-menu-item>\n							<md-menu-item>\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.client-manager-page.time\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon> Time\n									</md-button>\n							</md-menu-item>\n							<md-menu-item>\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.client-manager-page.tasks-templates\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-refresh\">\n\n											</md-icon>\n											 Recurring\n									</md-button>\n							</md-menu-item>\n							<md-menu-item ng-if=\"isOwner && client.status != \'personal\'\">\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.client-manager-page.client-billing\')\">\n											<md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Billing{{isOwner}}\n									</md-button>\n							</md-menu-item>\n\n					</md-menu-content>\n				</md-menu>\n\n		</div>\n\n	</div>\n	<sidebar-controls ></sidebar-controls>\n</div>\n");
$templateCache.put("app/admin-client-manager/client-profile.tmpl.html","\n<div id=\"scroll-h\" style=\"\">\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n    dragula=\"\'drag-profile-detail\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingDetail\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n    dragula=\"\'drag-profile-detail\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingDetail\">\n</div>\n\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n    dragula=\"\'drag-profile-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n    dragula=\"\'drag-profile-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n<!--     <profile-panel\n    	class=\"app-item-container\"\n    	client=\"{{panel.client}}\"\n    	panelid=\"{{panel.uid}}\"\n    	ng-cloak\n    	class=\"profile-panel\"\n    	layout=\"column\"\n    	layout-align=\"start\"\n    	ng-repeat=\"panel in client.panels | toArray : false| orderBy: \'order\' | limitTo:1  track by panel.uid\"/>\n\n    	</profile-panel> -->\n	<!-- <new-client-button ng-if=\"clients.length\"></new-client-button> -->\n\n	<div  dragula=\"\'drag-profile-panel\'\" layout=\"row\">\n		<profile-panel\n			class=\"app-item-container\"\n			client=\"{{panel.client}}\"\n			panelid=\"{{panel.uid}}\"\n			ng-cloak\n			class=\"profile-panel\"\n			layout=\"column\"\n			layout-align=\"start\"\n			ng-repeat=\"panel in client.panels | toArray : false| orderBy: \'order\'  track by panel.uid\"/></profile-panel>\n	</div>\n	<!-- <div ng-show=\"showPrimer()\" flex=\"20\" layout=\"column\" layout-align=\"start center\">\n		<div class=\"engraved-box\">\n\n			<h3 class=\"center\">This your first time?</h3>\n			<p class=\"center\"><md-button ng-click=\"launchPrimer()\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn about Client Profiles</md-button></p>\n		</div>\n\n		<new-profile-panel  client=\"client.uid\"></new-profile-panel>\n	</div> -->\n\n	<div ng-show=\"!showPrimer()\" layout=\"column\" layout-align=\"start center\">\n		<new-profile-panel  client=\"client.uid\"></new-profile-panel>\n	</div>\n		<md-content ng-show=\"showPrimer()\" class=\"account-card-container\" style=\"background-color: transparent;\">\n		<div class=\"engraved-box\"  style=\"width: 400px; margin: 0 auto 0 auto;\">\n			<h3 style=\"text-align: center;\">You don\'t have any information buckets yet.</h3>\n			<p style=\"text-align: center;\">Click <strong>New Bucket</strong> to add your first.</p>\n			<new-profile-panel  client=\"client.uid\" style=\"margin-top: 1em;\"></new-profile-panel>\n	<!-- 		<p class=\"center\"><md-button class=\"md-button-small\"><md-icon style=\"color: #fff; font-size: 12px;\" md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn more</md-button></p>\n	 -->		</div>\n		</md-content>\n</div>\n<!-- end scroll-h-->\n");
$templateCache.put("app/admin-client-manager/client-task-templates.tmpl.html","<div id=\"scroll-h\">\n	<div class=\"app-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\"\n		>\n		<div class=\"app-item-container-header\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Active Recurring Tasks</h3>\n					<div class=\"app-item-container-controls\" style=\"right: 10px;\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n					    <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"margin:0; width: 25px;\">\n					        <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n					            <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n					        </md-icon>\n					    </md-button>\n					</div>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"app-item-container-items drag-recurring-container\"\n\n			layout=\"column\"\n			layout-wrap\n			layout-align=\"start start\"\n			resize=\'false\'\n			>\n			<task-template-card\n			ng-repeat=\"item in vm.thisClient.taskTemplates| toArray : false  | filter: {isRecurring:true} | orderBy: [\'order\'] track by item.uid\" template=\"item\"/>\n		</div>\n	</div>\n\n<!-- ////////////////// -->\n	<div class=\"app-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\"\n		>\n		<div class=\"app-item-container-header\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Task Library</h3>\n					<div class=\"app-item-container-controls\" style=\"right: 10px;\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n					    <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"margin:0; width: 25px;\">\n					        <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n					            <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n					        </md-icon>\n					    </md-button>\n					</div>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"app-item-container-items drag-template-container\"\n			layout=\"column\"\n			layout-wrap\n			layout-align=\"start start\"\n			resize=\'false\'\n			>\n			<task-template-card\n				ng-repeat=\"item in vm.thisClient.taskTemplates| toArray  : false| filter: {isRecurring:false} | orderBy:[\'order\'] track by item.uid \"\n				template=\"item\"\n				/>\n		</div>\n	</div>\n	<!-- <div  layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px;\">\n	    <md-button class=\"\"  ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"width: 150px; color: #fff;\">\n	        + New Task\n	    </md-button>\n	</div> -->\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-tasks.tmpl.html","<div id=\"scroll-h\">\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n    dragula=\"\'drag-task\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingTask\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n    dragula=\"\'drag-task\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingTask\">\n</div>\n\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n    dragula=\"\'drag-task-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n    dragula=\"\'drag-task-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n\n    <today-panel  ng-if=\"vm.showToday\" ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\" client=\"client\" tasks=\"client.tasks\" days=\"0\"></today-panel>\n\n    <div class=\"app-item-container\"  md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n        <div class=\"app-item-container-header\" style=\"margin-bottom:6px;\">\n            <div layout=\"row\" layout-align=\"start center\" class=\"app-item-container-title\">\n                <div flex=\"nogrow\" style=\"padding-left: 1em;\">\n                    <md-icon ng-show=\"!vm.showToday\" ng-click=\"vm.toggleShowToday()\" md-font-icon=\"zmdi zmdi-sun\" style=\"color: #fff; font-size: 12px; cursor: pointer;  margin-right:0px;\">\n                        <md-tooltip>Reveal \"Today\" Group</md-tooltip>\n                    </md-icon>\n\n\n                    <md-icon ng-show=\"vm.showToday\" ng-click=\"vm.toggleShowToday()\" md-font-icon=\"zmdi zmdi-sun\" style=\"color: orange; font-size: 12px; cursor: pointer; margin-right:0px;\">\n                        <md-tooltip>Hide \"Today\" Group</md-tooltip>\n                    </md-icon>\n                </div>\n                <div flex=\"auto\">\n                    <h3 style=\"padding-left: 0;\">\n                        New Tasks\n                    </h3>\n                </div>\n                <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                    <md-button class=\"md-icon-button\" style=\"margin-right: 0;\" ng-click=\"vm.newTask(vm.clientID, \'Later\')\" style=\"margin:0; width: 25px;\">\n                        <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n                            <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n                        <!-- Trigger element is a md-button with an icon -->\n                        <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n                            <md-icon md-font-icon=\"zmdi zmdi-caret-down\">\n                                <md-tooltip md-delay=\"1000\">Group Menu</md-tooltip>\n                            </md-icon>\n                        </md-button>\n                        <md-menu-content>\n                            <md-menu-item>\n                                <md-button ng-click=\"vm.newTask(vm.clientID)\">\n                                    <md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n                                </md-button>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <md-button ng-click=\"vm.batchTasks(vm.clientID)\">\n                                    <md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n                                </md-button>\n                            </md-menu-item>\n\n\n                        </md-menu-content>\n                    </md-menu>\n                </div>\n            </div><!-- // end app-item-container-title-bar -->\n        </div><!-- // end app-item-container-header -->\n\n        <div class=\"app-item-container-items\"\n             dragula=\"\'drag-task\'\"\n             ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n             layout-align=\"start start\"\n             resize=\"{{vm.suppressResize}}\"\n             panelid=\"Later\"\n             dragula-scope=\"$scope\"\n             >\n            <app-item\n                class=\"task-app-item\"\n                taskid=\"{{item.refID}}\"\n                order=\"{{item.order}}\"\n                taskpanel=\"{{item.panel}}\"\n                client=\"{{item.client}}\"\n                ng-repeat=\"item in vm.thisClient.tasks| toArray  : false| filter: inboxFilter | filter: userFilter | orderBy:[\'order\'] track by item.refID \" >\n            </app-item>\n            <!-- <app-item ng-repeat=\"item in vm.thisClient.tasks | toArray |  filter: { \'panel\':\'Later\' || \'Backlog\' } | filter: {\'status\': \'open\'} | filter: laterFilter | orderBy: \'duedate\' track by item.refID \" /> -->\n        </div>\n    </div>\n    <!-- wrapper to constrain our drag/drop -->\n    <div flex=\"nogrow\" dragula=\"\'drag-task-panel\'\" layout=\"row\" layout-align=\"start\">\n        <!-- ################## -->\n        <!-- custom task panels -->\n        <div class=\"app-item-container task-panel custom-task-panel\"  md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\" client=\"{{panel.client}}\" panelid=\"{{panel.uid}}\" ng-repeat=\"panel in vm.thisClient.taskpanels| toArray : false | orderBy: \'order\' track by panel.uid\">\n            <div class=\"app-item-container-header \" style=\"margin-bottom: 6px;\">\n                <div class=\"app-item-container-title panel-drag-handle\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{panel.color}};\">\n\n\n                    <h3 style=\"cursor: move;\">\n                        <span class=\"panel-drag-handle\">{{panel.label}}</span>\n                    </h3>\n\n                    <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n                        <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.newTask(vm.clientID, panel.uid)\" style=\"margin:0; width: 25px;\">\n                            <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n                                <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                            </md-icon>\n                        </md-button>\n                        <md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n                            <!-- Trigger element is a md-button with an icon -->\n                            <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n                                <md-icon md-font-icon=\"zmdi zmdi-caret-down\">\n                                    <md-tooltip md-delay=\"1000\">Group Menu</md-tooltip>\n                                </md-icon>\n                            </md-button>\n                            <md-menu-content>\n                                <md-menu-item>\n                                    <md-button ng-click=\"vm.newTask(vm.clientID, panel.uid)\">\n                                        <md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n                                    </md-button>\n                                </md-menu-item>\n                                <md-menu-item>\n                                    <md-button ng-click=\"vm.batchTasks(vm.clientID, panel.uid)\">\n                                        <md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n                                    </md-button>\n                                </md-menu-item>\n                                <md-menu-item >\n                                    <md-button ng-click=\"vm.editTaskPanel(panel)\">\n                                        <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit Bucket\n                                    </md-button>\n                                </md-menu-item>\n                                <md-menu-item ng-if=\"admin == \'admin\'\">\n                                    <md-button ng-click=\"vm.exportPanel(panel)\">\n                                        <md-icon md-font-icon=\"fa fa-download\"></md-icon> Export Bucket\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <div class=\"app-item-container-items\"\n                 ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n                 layout-align=\"start start\"\n                 resize=\"{{vm.suppressResize}}\"\n                 dragula=\"\'drag-task\'\"\n                 dragula-scope=\"$scope\"\n                 panelid=\"{{panel.uid}}\"\n                 >\n\n                <!-- <app-item\n                        class=\"fade\"\n                        taskid=\"{{item.refID}}\"\n                        order=\"{{item.order}}\"\n                        taskpanel=\"{{item.panel}}\"\n                        client=\"{{item.client}}\"\n                        ng-repeat=\"item in vm.thisClient.tasks | toArray | filter: {\'status\' : \'open\'} | filter: {\'panel\' : panel.uid} | orderBy:[\'duedate\',\'order\'] track by item.refID\">\n\n                </app-item> -->\n\n                <app-item\n                    class=\"task-app-item\"\n                    taskid=\"{{item.refID}}\"\n                    order=\"{{item.order}}\"\n                    taskpanel=\"{{item.panel}}\"\n                    client=\"{{item.client}}\"\n                    ng-repeat=\"item in vm.thisClient.tasks| toArray  : false | filter: laterFilter | filter: userFilter |  filter: {\'panel\' : panel.uid} | orderBy:[\'order\'] track by item.refID\">\n\n                </app-item>\n            </div>\n        </div>\n\n        <!-- / custom task panels -->\n    </div><!-- / wrapper to constrain our drag/drop -->\n\n\n    <div ng-show=\"!vm.hideCompletedPanel\" class=\"app-item-container completed-item-container\"  md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n        <div class=\"app-item-container-header\" style=\"margin-bottom: 6px;\">\n            <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\">\n                <div flex=\"auto\">\n                    <h3 class=\"\" >\n                        <span>Recently Completed</span>\n                    </h3>\n                </div>\n            </div><!-- // end app-item-container-title-bar -->\n        </div><!-- // end app-item-container-header -->\n\n        <div class=\"app-item-container-items drag-container\"\n             ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n             layout-align=\"start start\"\n             resize=\"{{vm.suppressResize}}\"\n             >\n            <app-item  class=\"task-app-item\" ng-repeat=\"item in vm.thisClient.tasks| toArray  : false  | filter: userFilter | filter: {status:\'closed\'} | orderBy: \'closedDate\':true | limitTo: 5 track by item.refID\"/>\n        </div>\n    </div>\n\n        <md-content ng-show=\"!vm.thisClient.taskpanels\" class=\"account-card-container\" style=\"background-color: transparent;\">\n        <div class=\"engraved-box\"  style=\"width: 400px; margin: 0 auto 0 auto;\">\n            <h3 style=\"text-align: center;\">You don\'t have any Task Buckets yet.</h3>\n            <p style=\"text-align: center;\">Click <strong>New Bucket</strong> to add your first.</p>\n            <p style=\"text-align: center;\">\n            <md-button ng-click=\"vm.newTaskPanel(vm.thisClient)\" style=\"margin-top: 1em;\">\n                + New Bucket\n            </md-button>\n            </p>\n            </div>\n        </md-content>\n\n\n    <div ng-show=\"vm.thisClient.taskpanels\" layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px;\">\n        <md-button class=\"\"  ng-click=\"vm.newTaskPanel(vm.thisClient)\" style=\"\">\n            + New Bucket\n        </md-button>\n    </div>\n\n\n\n\n\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-time.tmpl.html","<div style=\"overflow-y: hidden;\">\n    <div class=\"time-report-controls\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" layout-align=\"start center\">\n        <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin-bottom: 0; margin-left: 21px; margin-top: 21px;\">\n            <label>From</label>\n            <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 0 0 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\"  md-placeholder=\"Start\" ng-change=\"vm.updateReport()\"></md-datepicker>\n        </md-input-container>\n        <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin: 21px 0 0 0;\">\n            <label>To</label>\n            <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 1em 0 1em;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\"  md-placeholder=\"End\"  ng-change=\"vm.updateReport()\"></md-datepicker>\n        </md-input-container>\n\n\n        <md-input-container ng-if=\"vm.retainerMode\" flex=\"nogrow\" style=\"margin-left: 21px; margin-right: 21px;\">\n            <label>From</label>\n            <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\" ng-change=\"vm.updateReport()\">\n                <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date}}\">\n                    {{month.label}}\n                </md-option>\n            </md-select>\n        </md-input-container>\n        <md-input-container ng-if=\"vm.retainerMode\" flex=\"nogrow\" style=\"margin-right: 21px;\">\n            <label>To</label>\n            <md-select style=\"margin: 0 1em 0 1em;\"  ng-model=\"vm.timeReportService.report.end\" ng-change=\"vm.updateReport()\">\n                <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date | amAdd : \'1\' : \'month\'| amSubtract: \'1\' : \'day\'}}\">\n                    {{month.label}}\n                </md-option>\n            </md-select>\n        </md-input-container>\n        <md-input-container ng-if=\"vm.showTeamFilter()\" flex=\"nogrow\" style=\"margin-right: 2em;\">\n            <label>Team Filter</label>\n            <md-select ng-model=\"vm.timeReportService.report.selectedMember\" style=\"width: 250px;\"   placeholder=\"Restrict to user...\">\n                <md-option value=\"all\">Everyone</md-option>\n                <md-option ng-repeat=\"member in vm.teamList | toArray : false | orderBy: \'profile.lastName\' track by member.uid\" value=\"{{member.uid}}\" style=\"border-left: 4px solid {{member.color}};\">\n                    <img src=\"{{member.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-right: 1em; position: relative; top: 5px;\">\n                    <span class=\"small\">{{member.profile.firstName}} {{member.profile.lastName}}</span></md-option>\n            </md-select>\n        </md-input-container>\n\n        </div>\n        <div flex layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\">\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'month\'}\" ng-click=\"vm.viewMonths()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-comfy\">\n                        <md-tooltip>\n                            Group by Month\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'week\'}\" ng-click=\"vm.viewWeeks()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-view-week\">\n                        <md-tooltip>\n                            Group by Week\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" ng-disabled=\"vm.timeReportService.report.selectedClient == \'user\'\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'retainer\'}\" ng-click=\"vm.viewRetainer()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-money\">\n                        <md-tooltip>\n                            Group by Billing Period\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.downloadCSV(vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end), vm.allTimeReportFilename())\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                        <md-tooltip>\n                            Download Spreadsheet\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.reportAllTime();\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-file-text\">\n                        <md-tooltip>\n                            View Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            </div>\n\n        </div>\n\n\n    </div>\n    <div id=\"scroll-h\">\n        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n        <!-- /////////////////////////////////    Print Time VIEW  /////////////////////////////////////////////-->\n        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n        <div class=\"app-item-container timeentry-item-container\"\n            md-whiteframe=\"2\"\n            layout=\"column\"\n            layout-align=\"start\"\n            ng-if=\"vm.printReport\"\n            style=\"background-color: #fff;\"\n            >\n            <div class=\"app-item-container-header\"  >\n                <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n                    <div class=\"auto\">\n                        <h3>Time Report</h3>\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <div class=\"time-period-details\"\n                layout=\"column\"\n                resize\n                >\n                <print-time-report report=\"vm.printReport\"></print-time-report>\n            </div><!-- // time period details -->\n        </div>\n        <!-- // End Print Time View -->\n        <div class=\"app-item-container time-container\" ng-repeat=\"group in vm.timeReportService.report.groups |orderBy:\'-start\' track by $index\" resize md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\" style=\"padding-top: .5em;\">\n            <div class=\"app-item-container-header\">\n                <div class=\"app-item-container-title-bar\" layout=\"row\">\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'week\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'month\'\" class=\"time-container-heading\" flex>\n                        {{group.name}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'retainer\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 class=\"time-container-heading right\" flex=\"nogrow\">\n                        {{vm.logTotal(timeEntries) | HandM}} logged\n                    </h3>\n                    <div class=\"time-container-controls\" flex=\"nogrow\">\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <div class=\"app-item-container-items\"\n                        layout=\"column\"\n                        layout-align=\"start start\"\n                        resize\n                        >\n                <div ng-if=\"vm.timeReportService.report.loading\" layout=\"row\" layout-align=\"center center\">\n                   <p style=\"padding-left: 150px;\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n                </div>\n                <p style=\"text-align: center; width: 100%; padding-top: 2em; color: #666;\"  ng-show=\"!timeEntries.length\">No time logged for this period.</p>\n                <md-list class=\"md-dense\" style=\"overflow-y: scroll;\">\n\n                    <time-entry ng-repeat=\"entry in timeEntries = (vm.groupEntries(group.start, group.end)) | orderBy: \'-logDate\' track by entry.uid\">\n                    </time-entry>\n\n                    <!-- <md-subheader class=\"md-no-sticky\">2 line item</md-subheader> -->\n                </md-list>\n            </div>\n            <div class=\"time-footer\" layout=\"row\" layout-align=\"end center\">\n\n                    <md-button flex=\"nogrow\" ng-click=\"vm.downloadCSV(timeEntries, vm.groupTimeReportFilename(group))\" class=\"md-button-small md-secondary\" ng-click=\"vm.viewWeeks()\">\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                            <md-tooltip>\n                                Download Spreadsheet\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button flex=\"nogrow\" ng-click=\"vm.reportTime(group, timeEntries)\" class=\"md-button-small md-secondary\" ng-click=\"vm.viewWeeks()\">\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-file-text\">\n                            <md-tooltip>\n                                View Report\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <div flex>\n                        <h3 class=\"time-container-heading right\">\n                            {{vm.logTotal(timeEntries) | HandM}} logged\n                        </h3>\n                    </div>\n\n            </div>\n           <!--  <div class=\"time-footer\" flex layout=\"row\">\n                <a class=\"md-button\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon></a>\n                <a class=\"md-button\"><md-icon md-font-icon=\"fa fa-share\"></md-icon></a>\n            </div> -->\n        </div>\n\n\n    </div>\n</div>\n");
$templateCache.put("app/admin-dashboard/dashboard.tmpl.html","<div class=\"no-scrollbar\" layout-padding >\n       <md-content style=\"background-color: transparent;\" layout-fill>\n           <h1>Dashboard</h1>\n\n       <!--        <p class=\"center\"><md-button class=\"md-button-small\"><md-icon style=\"color: #fff; font-size: 12px;\" md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn more</md-button></p>\n    -->\n       </md-content>\n</div>\n\n\n");
$templateCache.put("app/admin-diagnostics/diagnostics.tmpl.html","<div layout-padding>\n	<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n\n		<h3 class=\"center\">Adminja Diagnostics</h3>\n		<p>Please copy the information below and paste it in your e-mail to support.</p>\n\n		<p><strong>rootUserID</strong><br>{{userID}}</p>\n		<p><strong>localUserID</strong><br>{{vm.localUserID}}</p>\n		<p><strong>authData</strong><br>{{authData}}</p>\n		<p><strong>assignedClients</strong><br>\n		{{quickClients | json}}</p>\n		<p><strong>thisClient</strong><br>\n		{{thisClient | json}}\n		</p>\n		<p><strong>rootClientID</strong><br>\n		{{clientID}}\n		</p>\n	</md-content>\n</div>\n");
$templateCache.put("app/admin-tasks/tasks-page.tmpl.html","<div class=\"no-scrollbar\" layout-padding ng-if=\"vm.clientCount == 0\">\n       <md-content class=\"account-card-container\" style=\"background-color: transparent;\" layout-fill>\n           <div flex=\"auto\" class=\"chart-all-clients-plan-summary\"  layout=\"row\" layout-align=\"center center\" style=\"margin-right: 5px;\">\n                   <div flex=\"100\" flex-gt-sm=\"50\" class=\"placeholder-message\">\n                       <p class=\"md-headline center margin-20\">Let\'s get started by creating <br> your first Workspace! <br></p>\n                       <!-- <p class=\"center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.ifCue(\'-Kn6yFm3fpOEdovzoA7p\', \'addClients\')\">Learn more</md-button></p> -->\n                       <p class=\"center\"><new-client-button flex=\"nogrow\" style=\"margin-top: 1em;\"></new-client-button></p>\n                   </div>\n           </div>\n\n       <!--        <p class=\"center\"><md-button class=\"md-button-small\"><md-icon style=\"color: #fff; font-size: 12px;\" md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn more</md-button></p>\n    -->\n       </md-content>\n</div>\n\n<div id=\"scroll-h\" ng-if=\"vm.clientCount > 0\">\n\n    <all-today-panel days=\"0\" ng-if=\"vm.user.profile.settings.showTodayPanel\" tasks=\"vm.allTasks\"></all-today-panel>\n\n	<!-- ++ Client Panels -->\n	<div class=\"app-item-container task-item-container\" md-whiteframe=\"2\" ng-repeat=\"client in vm.clients | toArray:false | limitTo:vm.clientLimit | orderBy:\'order\' track by $index\" ng-show=\"client.profile\" layout=\"column\" layout-align=\"start\">\n		<div class=\"app-item-container-header\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>\n						<a href=\"/#/clients/{{client.uid}}\">\n						<md-tooltip md-direction=\"right\" md-delay=\"2000\">\n							View Client\n						</md-tooltip>\n						<span ng-if=\"!client.profile.fullName\">\n							<md-icon ng-if=\"client.profile.avatar\" class=\"heading-avatar\"><img src=\"{{client.profile.avatar}}\" ></md-icon>\n							<md-icon ng-if=\"!client.profile.avatar\" class=\"heading-avatar\"><img src=\"/assets/images/avatars/generic-avatar.png\"></md-icon>\n							{{client.profile.firstname}} {{client.profile.lastname}}\n						</span>\n						<span ng-if=\"client.profile.fullName\">\n							<md-icon ng-if=\"client.profile.avatar\" class=\"heading-avatar\"><img src=\"{{client.profile.avatar}}\"></md-icon>\n														<md-icon ng-if=\"!client.profile.avatar\" class=\"heading-avatar\"><img src=\"/assets/images/avatars/generic-avatar.png\"></md-icon>\n							{{client.profile.fullName}}\n						</span>\n					</a></h3>\n				</div>\n				<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n					<md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"newTask(client.uid, \'Later\')\" >\n						<md-icon aria-label=\"Create new task for {{client.profile.name}}\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n							<md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n						</md-icon>\n					</md-button>\n					</a>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n			<client-summary-strip this-client=\"client\"></client-summary-strip>\n		</div><!-- // end app-item-container-header -->\n		<div class=\"app-item-container-items \"\n			dragula=\"\'drag-task\'\"\n			ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n			layout-align=\"start start\"\n			dragula-scope=\"$scope\"\n			resize=\"{{vm.verticalTaskPanels}}\"\n\n			>\n			<div class=\"task-panel\" ng-repeat=\"panel in client.panels track by panel.uid\">\n\n\n            </div>\n\n            <app-item\n            	class=\"task-app-item\"\n                taskid=\"{{item.refID}}\"\n                order=\"{{item.order}}\"\n                taskpanel=\"{{item.panel}}\"\n                client=\"{{item.client}}\"\n                ng-repeat=\"item in client.tasks| toArray: false | filter: {\'client\' : client.uid}| filter: { \'status\':\'open\' }  | filter: userFilter | orderBy: \'allOrder\' track by item.refID\"\n                >\n            </app-item>\n\n        </div>\n\n    </div>\n    <!-- // Client Panels -->\n\n    <!-- ++ Recently Completed -->\n    <div ng-show=\"!vm.user.profile.settings.hideCompletedPanel\" class=\"app-item-container completed-item-container\"  md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n        <div class=\"app-item-container-header\" style=\"margin-bottom: 10px;\">\n            <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\">\n                <div class=\"auto\">\n                    <h3>\n                        Recently Completed\n                    </h3>\n                </div>\n            </div><!-- // end app-item-container-title-bar -->\n        </div><!-- // end app-item-container-header -->\n        <div class=\"app-item-container-items \"\n            ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n             layout-align=\"start start\"\n             resize=\"{{vm.suppressResize}}\"\n             >\n            <app-item  class=\"fade task-app-item\" ng-repeat=\"item in vm.allTasks| toArray: false | filter: {\'status\':\'closed\'}  | filter: userFilter | orderBy: \'closedDate\':true | limitTo:10 track by item.refID\" />\n        </div>\n    </div>\n    <!-- the following element simply removes the loader when it\'s rendered -->\n    <!--<div ng-init=\"removeLoader()\"></div>-->\n</div>\n\n");
$templateCache.put("app/admin-time-reports/time-reports.tmpl.html","<div style=\"overflow-y: hidden;\">\n    <div class=\"time-report-controls\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" layout-align=\"start center\">\n            <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin-bottom: 0; margin-left: 21px; margin-top: 21px;\">\n                <label>From</label>\n                <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 0 0 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\"  md-placeholder=\"Start\" ng-change=\"vm.updateReport()\"></md-datepicker>\n            </md-input-container>\n            <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin: 21px 0 0 0;\">\n                <label>To</label>\n                <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\"  md-placeholder=\"End\"  ng-change=\"vm.updateReport()\"></md-datepicker>\n            </md-input-container>\n\n            <md-input-container  ng-if=\"vm.retainerMode\" style=\"margin-left: 21px; margin-right: 21px;\">\n                <label>From</label>\n\n                <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\" ng-change=\"vm.updateReport()\">\n                    <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date}}\">\n                        {{month.label}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n            <md-input-container ng-if=\"vm.retainerMode\" style=\"margin-right: 21px;\">\n                <label>To</label>\n\n                <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\" ng-change=\"vm.updateReport()\">\n                    <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date | amAdd : \'1\' : \'month\'| amSubtract: \'1\' : \'day\'}}\">\n                        {{month.label}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n        <md-input-container flex=\"nogrow\" style=\"margin-right: 2em;\">\n            <label>Client Filter</label>\n            <md-select ng-model=\"vm.timeReportService.report.selectedClient\" style=\"width: 250px;\" ng-change=\"vm.switchSource(vm.timeReportService.report.selectedClient)\" placeholder=\"Restrict to client...\">\n                <md-option value=\"all\">All Clients</md-option>\n                <md-option ng-if=\"!client.disabled\" ng-repeat=\"client in vm.clients | orderBy: \'order\' track by client.uid\" ng-value=\"\'{{client.uid}}\'\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                    <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                    <span class=\"small\">{{client.name}}</span><span ng-if=\"client.clientType == \'delegated\'\"><md-icon style=\"font-size: 10px; margin-left: 2em;\" md-font-icon=\"fa fa-users\"></md-icon></span></md-option>\n            </md-select>\n        </md-input-container>\n        <md-input-container ng-if=\"vm.showTeamPicker\" flex=\"nogrow\" style=\"margin-right: 2em;\">\n            <label>Team Filter</label>\n            <md-select ng-model=\"vm.timeReportService.report.selectedMember\" style=\"width: 250px;\"   placeholder=\"Restrict to user...\">\n                <md-option value=\"all\">Everyone</md-option>\n                <md-option ng-repeat=\"member in vm.teamList | orderBy: \'profile.lastName\' track by member.uid\" value=\"{{member.uid}}\" style=\"border-left: 4px solid {{member.color}};\">\n                    <img src=\"{{member.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-right: 1em; position: relative; top: 5px;\">\n                    <span class=\"small\">{{member.profile.firstName}} {{member.profile.lastName}}</span></md-option>\n            </md-select>\n        </md-input-container>\n\n        </div>\n        <div flex layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\">\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'month\'}\" ng-click=\"vm.viewMonths()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-comfy\">\n                        <md-tooltip>\n                            Group by Month\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'week\'}\" ng-click=\"vm.viewWeeks()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-view-week\">\n                        <md-tooltip>\n                            Group by Week\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" ng-disabled=\"vm.timeReportService.report.selectedClient == \'user\'\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'retainer\'}\" ng-click=\"vm.viewRetainer()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-money\">\n                        <md-tooltip>\n                            Group by Billing Period\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.downloadCSV(vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end), vm.allTimeReportFilename())\">\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                        <md-tooltip>\n                            Download Spreadsheet\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.reportAllTime();\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-file-text\">\n                        <md-tooltip>\n                            View Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            </div>\n\n        </div>\n\n\n    </div>\n    <div id=\"scroll-h\" style=\"height: auto;\">\n        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n        <!-- /////////////////////////////////    Print Time VIEW  /////////////////////////////////////////////-->\n        <!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n        <div class=\"app-item-container timeentry-item-container\"\n            id=\"time-report\"\n            md-whiteframe=\"2\"\n            layout=\"column\"\n            layout-align=\"start\"\n            ng-if=\"vm.printReport\"\n            style=\"background-color: #fff;\"\n            >\n            <div class=\"app-item-container-header\"  >\n                <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.clientColor}};\">\n                    <div class=\"auto\">\n                        <h3>Time Report</h3>\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <div class=\"time-period-details\"\n                layout=\"column\"\n                resize=\'false\'\n                >\n                <print-time-report report=\"vm.printReport\"></print-time-report>\n            </div><!-- // time period details -->\n        </div>\n        <!-- // End Print Time View -->\n        <div class=\"app-item-container time-container\" ng-repeat=\"group in vm.timeReportService.report.groups |orderBy:\'-start\' track by $index\" resize md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\" style=\"padding-top: .5em;\">\n            <div class=\"app-item-container-header\">\n                <div class=\"app-item-container-title-bar\" layout=\"row\">\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'week\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'month\'\" class=\"time-container-heading\" flex>\n                        {{group.name}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'retainer\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 class=\"time-container-heading right\" flex=\"nogrow\">\n                        {{vm.logTotal(timeEntries) | HandM}} logged\n                    </h3>\n                    <div class=\"time-container-controls\" flex=\"nogrow\">\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <md-content class=\"app-item-container-items\"\n                        layout=\"column\"\n                        layout-align=\"start start\"\n                        resize\n                        >\n                <div ng-if=\"vm.timeReportService.report.loading\" layout=\"row\" layout-align=\"center center\">\n                   <p style=\"padding-left: 150px;\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n                </div>\n                <p style=\"text-align: center; width: 100%; padding-top: 2em; color: #666;\"  ng-show=\"!timeEntries.length\">No time logged for this period.</p>\n                <md-list class=\"md-dense\">\n                    <time-entry ng-repeat=\"entry in timeEntries = (vm.groupEntries(group.start, group.end)) | orderBy: \'-logDate\' track by entry.uid\">\n\n                    <!-- <md-subheader class=\"md-no-sticky\">2 line item</md-subheader> -->\n                </md-list>\n            </md-content>\n            <div class=\"time-footer\" layout=\"row\" layout-align=\"end center\">\n\n                    <md-button flex=\"nogrow\" ng-click=\"vm.downloadCSV(timeEntries, vm.groupTimeReportFilename(group))\" class=\"md-button-small md-secondary\" >\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                            <md-tooltip>\n                                Download Spreadsheet\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button flex=\"nogrow\" ng-click=\"vm.reportTime(group, timeEntries)\" class=\"md-button-small md-secondary\">\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-file-text\">\n                            <md-tooltip>\n                                View report\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <div flex>\n                        <h3 class=\"time-container-heading right\">\n                            {{vm.logTotal(timeEntries) | HandM}} logged\n                        </h3>\n                    </div>\n                    <!-- <md-button ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.viewWeeks()\">\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"fa fa-file-pdf-o\">\n                            <md-tooltip>\n                                Download PDF\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button> -->\n                    <!-- <md-menu md-position-mode=\"target-right target\">\n                        <md-button style=\"min-width: 40px; width: 40px;\" ng-click=\"$mdMenu.open($event)\"  flex=\"nogrow\" class=\"md-secondary\"  aria-label=\"Open Menu\">\n                            <md-icon md-font-icon=\"fa fa-share\"></md-icon>\n                        </md-button>\n                        <md-menu-content>\n                            <md-menu-item>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <md-button ng-disabled=\"true\" flex=\"nogrow\" class=\"md-secondary\"  aria-label=\"Share\">\n                                    <md-icon md-font-icon=\"fa fa-send-o\"></md-icon> Send Report\n                                </md-button>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <md-button ng-disabled=\"true\" flex=\"nogrow\" class=\"md-secondary\"  aria-label=\"Print\">\n                                    <md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon> Print Report\n                                </md-button>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <md-button ng-click=\"vm.downloadCSV(timeEntries,  \'time-report\' + \'.csv\')\" flex=\"nogrow\" class=\"md-secondary\"  aria-label=\"Share\">\n                                    <md-icon md-font-icon=\"fa fa-file-excel-o\"></md-icon> Download CSV\n                                </md-button>\n                            </md-menu-item>\n                        </md-menu-content>\n                    </md-menu> -->\n            </div>\n           <!--  <div class=\"time-footer\" flex layout=\"row\">\n                <a class=\"md-button\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon></a>\n                <a class=\"md-button\"><md-icon md-font-icon=\"fa fa-share\"></md-icon></a>\n            </div> -->\n        </div>\n\n\n    </div>\n</div>\n");
$templateCache.put("app/admin-team/admin-team.tmpl.html","<div class=\"no-scrollbar\" layout-padding ng-if=\"!vm.hasTeams\">\n       <md-content class=\"account-card-container\" style=\"background-color: transparent;\" layout-fill>\n           <div ng-show=\"!vm.showDashboard()\" flex=\"auto\" class=\"chart-all-clients-plan-summary\"  layout=\"row\" layout-align=\"center center\" style=\"margin-right: 5px;\">\n                   <div flex=\"100\" flex-gt-sm=\"50\" class=\"placeholder-message\">\n                       <p class=\"md-headline center margin-20\">Teams are only available for certain plans.<br></p>\n                       <p class=\"center\"><md-button class=\"md-raised md-primary md-accent\" ui-sref=\"authentication.profile({selectedTab: 2})\">Upgrade your Subscription</md-button>\n                   </div>\n           </div>\n       </md-content>\n</div>\n\n<div ng-cloak ng-if=\"vm.hasTeams && !vm.teamsSetup()\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 4em;\">\n	<div flex layout=\"column\" layout-align=\"start center\" class=\"md-whiteframe-8dp md-padding\" style=\"background-color: #fff; min-width: 500px; min-height: 300px;\">\n		<h3 class=\"center\">Before you can add Team Members, <br>\n		We need to Setup your Team</h3>\n		<md-input-container>\n			<label>Give your team a name</label>\n			<input type=\"text\" ng-model=\"vm.teamName\" placeholder=\"{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\">\n		</md-input-container>\n		<md-button ng-click=\"vm.setupTeam(vm.user, vm.teamName)\" class=\"md-raised md-accent\">Setup Team</md-button>\n	</div>\n</div>\n<div ng-if=\"vm.hasTeams && vm.teamsSetup()\" id=\"scroll-h\" style=\"margin-right: 2em;\">\n\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    MEMBER LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div class=\"app-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		tlayout-align=\"start\"\n		>\n		<div class=\"app-item-container-header\" style=\"margin-bottom: 1em;\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\' cursor: default;\'>\n				<div class=\"auto\">\n					<h3>Your Team</h3>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n		<!-- <p class=\"text-center md-subhead\" ng-hide=\"vm.teamDataService.team\"><strong>No Team Members Have Been Added</strong><br> Invite someone to get started.\n			</p> -->\n		<md-button ng-disabled=\"!vm.canAddMembers()\" style=\"\" class=\"md-raised md-accent\" ng-click=\"vm.inviteMember(vm.user, vm.numMembers() + 1);\">\n			<span ng-if=\"vm.canAddMembers()\">Invite a New Member</span>\n			<span ng-if=\"!vm.canAddMembers()\">Team Limit Reached</span>\n		</md-button>\n		<div class=\"app-item-container-items billing-container-items\"\n			layout=\"column\"\n			layout-align=\"start start\"\n			resize=\'false\'\n			>\n			<team-member-card ng-repeat=\"member in vm.thisTeam  | limitTo:vm.teamLimit | orderBy: [\'-becameMember\'] track by member.uid\" displaytype=\"card\" member=\"member\" team=\"{{vm.user.uid}}\"></team-member-card>\n		</div>\n	</div>\n	<team-member-detail ng-if=\"vm.teamDataService.selectedMember\" member=\"vm.teamDataService.selectedMember\" user=\"vm.teamDataService.selectedUser\"></team-member-detail>\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    TEAMS LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div ng-if=\"vm.showAllTeams\" class=\"app-item-container hide-for-print\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		>\n		<div class=\"app-item-container-header\" style=\"margin-bottom: 1em;\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" >\n				<div class=\"auto\">\n					<h3>Teams you are on</h3>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n		<p class=\"text-center md-subhead\" ng-hide=\"vm.teamDataService.team\"><strong>You haven\'t been invited to any teams.</strong>\n			</p>\n		<!-- <md-button style=\"\" class=\"md-raised md-accent\" ng-click=\"addMember();\">Invite a New Member</md-button> -->\n		<div class=\"app-item-container-items billing-container-items\"\n			layout=\"column\"\n			layout-align=\"start start\"\n			resize=\'false\'\n			style=\"padding-top:8px;\"\n			>\n\n				<md-card layout=\"column\" class=\"team-member-card\"  ng-repeat=\"team in teamsList = (vm.teamDataService.teams | toArray: false) track by $index\">\n					<div layout=\"column\" class=\"md-padding\">\n						<h3 style=\"margin-top: 0; margin-bottom: 0;\">{{team.name}}</h3>\n						<h4 style=\"margin-top: 0;\">{{team.ownerName}}</h4>\n						<p class=\"md-subhead\" style=\"margin-top: 0;\">\n							<a href=\"mailto: {{team.ownerEmail}}\">{{team.ownerEmail}}</a><br>\n							<span ng-if=\"team.ownerID != vm.user.uid\">\n							Member since {{team.members[userID].becameMember | amDateFormat : \'MMM DD, YYYY\'}}<br>\n							</span>\n							<span ng-if=\"team.ownerID == vm.user.uid\">\n								Your Team\n							</span>\n						</p>\n					</div>\n\n				</md-card>\n\n\n\n		</div>\n	</div>\n</div><!-- //scrollH -->\n");
$templateCache.put("app/admin-timer-prototype/timer-prototype.tmpl.html","<md-content class=\"timer-prototype\" flex layout-padding style=\"max-width: 700px; margin:0 auto;\">\n<!--    <h2>Timer Prototype</h2>\n    <p>The directives in the prototype do not need to have any real \"design\" or \"styling\" beyond making it functional. Do not feel obligated to utilize angular-material or any existing stylesheets. There is a stylesheet you can use for this page if you would like.<p>-->\n    <!--<timer></timer>-->\n    <timer-list></timer-list>\n</md-content>\n");
$templateCache.put("app/admin-today/today.tmpl.html","<div class=\"no-scrollbar\" layout-padding ng-if=\"vm.hasClients == 0\">\n       <md-content class=\"account-card-container\" style=\"background-color: transparent;\" layout-fill>\n           <div flex=\"auto\" class=\"chart-all-clients-plan-summary\"  layout=\"row\" layout-align=\"center center\" style=\"margin-right: 5px;\">\n                   <div flex=\"100\" flex-gt-sm=\"50\" class=\"placeholder-message\">\n                       <p class=\"md-headline center margin-20\">Let\'s get started by creating <br> your first Workspace! <br></p>\n                       <!-- <p class=\"center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.ifCue(\'-Kn6yFm3fpOEdovzoA7p\', \'addClients\')\">Learn more</md-button></p> -->\n                       <p class=\"center\"><new-client-button flex=\"nogrow\" style=\"margin-top: 1em;\"></new-client-button></p>\n                   </div>\n           </div>\n\n       <!--        <p class=\"center\"><md-button class=\"md-button-small\"><md-icon style=\"color: #fff; font-size: 12px;\" md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn more</md-button></p>\n    -->\n       </md-content>\n</div>\n<div id=\"scroll-h\" ng-if=\"vm.hasClients > 0\">\n	<all-today-panel days=\"0\" ng-if=\"!vm.groupTodayByClients\" tasks=\"vm.allTasks\"></all-today-panel>\n\n    <div ng-if=\"vm.groupTodayByClients\" ng-repeat=\"client in vm.clients | toArray:false | limitTo: vm.clientLimit | orderBy:\'order\' track by $index\" >\n        <today-panel days=\"0\" client=\"client\" tasks=\"client.tasks\" ng-show=\"client.profile\"></today-panel>\n\n    </div>\n</div>\n");
$templateCache.put("app/adminja-admin/cancel-dialog.tmpl.html","<md-dialog aria-label=\"Cancel\">\n  <form ng-cloak>\n    <md-toolbar>\n      <div class=\"md-toolbar-tools\">\n        <h2>Cancel Account?</h2>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content>\n      <div class=\"md-dialog-content\">\n        <p>Should this account be cancelled at the end of their current period, or immediately?</p>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\">\n      <md-button ng-click=\"cancel()\">\n        Cancel\n      </md-button>\n      <span flex></span>\n      <md-button ng-click=\"answer(false)\">\n       Immediately\n      </md-button>\n      <md-button ng-click=\"answer(true)\">\n        At end of Term\n      </md-button>\n    </md-dialog-actions>\n  </form>\n</md-dialog>\n");
$templateCache.put("app/adminja-admin/cleanup-users.tmpl.html","<p class=\"center\">Note: Before cleaning up user accounts, you must export our user auth file to Json, and import the file (unchanged) into the auth-users node. It will appear as \"users\".</p>\n<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\">\n	<div layout=\"column\" flex=\"25\">\n		<md-button ng-click=\"vm.cleanupNotifications()\">Delete all notifications</md-button>\n		<h3>Users without Auth Account</h3>\n		<div ng-repeat=\"user in vm.noAuthUser track by $index\" class=\"user-list-record\" layout=\"row\" layout-align=\"start center\">\n			<div flex=\"auto\">\n				<p style=\"margin:0;\" class=\"md-subhead\"><strong>{{user.email}}</strong> <br><a href=\"https://console.firebase.google.com/u/0/project/adminja-staging/database/adminja-staging/data/users/{{user.uid}}\" target=\"_blank\">{{user.uid}}</a></p>\n			</div>\n			<div flex=\"nogrow\" ng-if=\"!user.removed\">\n				<md-button ng-click=\"vm.retireUser(user)\">Remove</md-button>\n			</div>\n			<div flex=\"nogrow\" ng-if=\"user.removed\">\n				<md-icon md-font-icon=\"zmdi zmdi-check\" style=\"color: green;\"></md-icon>\n			</div>\n		</div>\n	</div>\n	<div layout=\"column\" flex=\"25\">\n		<h3>Bad AuthUsers</h3>\n		<div ng-repeat=\"user in vm.badAuthUsers track by $index\" class=\"user-list-record\" layout=\"row\" layout-align=\"start center\">\n			<div flex=\"auto\">\n				<p style=\"margin:0;\" class=\"md-subhead\"><strong>{{user.email}}</strong></p>\n			</div>\n			<div flex=\"nogrow\">\n				X\n			</div>\n		</div>\n	</div>\n	<div layout=\"column\" flex=\"25\">\n		<h3>Bad Users</h3>\n		<div ng-repeat=\"user in vm.badUsers track by $index\" class=\"user-list-record\" layout=\"row\" layout-align=\"start center\">\n			<div flex=\"auto\">\n				<p style=\"margin:0;\" class=\"md-subhead\"><strong>{{user.email}}</strong><br>{{user.uid}}</p>\n			</div>\n			<div flex=\"nogrow\">\n				X\n			</div>\n		</div>\n	</div>\n\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/clone-clients.tmpl.html","    <div class=\"full-height\" >\n	<md-content layout-padding>\n		<h2>Copy Client</h2>\n		<form name=\"copyClientForm\">\n		<div layout=\"row\">\n			<div flex layout=\"column\">\n				<md-input-container>\n				<label>Source User</label>\n				<md-select ng-model=\"vm.sourceUser\" placeholder=\"Select a User\" ng-change=\"vm.updateClients(vm.sourceUser)\" required>\n				  <md-option ng-value=\"user.uid\" ng-repeat=\"user in vm.users track by $index\">{{user.email}}</md-option>\n				</md-select>\n				</md-input-container>\n			</div>\n			<div flex layout=\"column\">\n				<md-input-container>\n					<label>Source Client</label>\n					<md-select ng-model=\"vm.sourceClient\" placeholder=\"Select a Client\" required>\n					  <md-option ng-value=\"client.uid\" ng-repeat=\"client in vm.clients | orderBy: \'order\' track by $index\">{{client.profile.fullName}} <span ng-if=\"!client.profile.fullName\">{{client.profile.firstname}} {{client.profile.lastname}}</span></md-option>\n					</md-select>\n				</md-input-container>\n\n			</div>\n			<div flex layout=\"column\">\n				<md-input-container>\n					<label>Target User</label>\n					<md-select ng-model=\"vm.targetUser\" placeholder=\"Select a User\" required>\n					  <md-option ng-value=\"user.uid\" ng-repeat=\"user in vm.users track by $index\">{{user.email}}<br>{{user.profile.firstName}}</md-option>\n					</md-select>\n				</md-input-container>\n			</div>\n			<div flex layout=\"column\">\n				<md-button ng-disabled=\"copyClientForm.$invalid\" class=\"md-accent md-raised\" ng-click=\"vm.cloneClient();\">Copy</md-button>\n			</div>\n		</div>\n		</form>\n		<md-button class=\"md-raised md-accent\" ng-click=\"vm.triggerToast(\'A Task is Past Due!\', \'This is the task name.\', \'pink\')\">Trigger Toast</md-button>\n	</md-content>\n    </div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-notifications.tmpl.html","<div layout=\"row\" layout-align=\"center start\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n\n\n			<md-card flex=\"100\" flex-gt-md=\"50\" layout=\"column\"class=\"changelog-item\" style=\"margin-top: 1em;\">\n				<h3 class=\"center\">Send Notifications</h3>\n				<form name=\"changeLogForm\">\n				<div layout=\"column\" layout-align=\"start fill\">\n					<md-input-container>\n						<label>Notification Type</label>\n						<md-select flex=\"nogrow\" placeholder=\"Notification Type\" ng-model=\"vm.editedLog.type\">\n						    <md-option value=\"general\">\n						        General\n						    </md-option>\n						    <md-option value=\"reminder\">\n						        Personal Reminder\n						    </md-option>\n						    <md-option value=\"lead-reminder\">\n						        Lead reminder\n						    </md-option>\n						    <md-option value=\"thanks\">\n						        Thanks\n						    </md-option>\n						    <md-option value=\"task\">\n						        Task Due\n						    </md-option>\n						    <md-option value=\"taskOverBudget\">\n						        Task Over Budget\n						    </md-option>\n						    <md-option value=\"billing-period\">\n						        Billing Period Over Budget\n						    </md-option>\n						    <md-option value=\"taskComplete\">\n						        Task Complete\n						    </md-option>\n						    <md-option value=\"taskReceived\">\n						        Task Received\n						    </md-option>\n						    <md-option value=\"noteRecieved\">\n						        Note Received\n						    </md-option>\n						    <md-option value=\"clientAssignment\">\n						        Client Assignment\n						    </md-option>\n						    <md-option value=\"recurring\">\n						        Recurring Task Created\n						    </md-option>\n						    <md-option value=\"retainer\">\n						        Retainer Renewed\n						    </md-option>\n						    <md-option value=\"date\">\n						        Date\n						    </md-option>\n\n						    <md-option value=\"pdf\">\n						        PDF Download Ready\n						    </md-option>\n						    <md-option value=\"comment\">\n						        Comment\n						    </md-option>\n						    <md-option value=\"tip\">\n						        Tip\n						    </md-option>\n						    <md-option value=\"email\">\n						        Email\n						    </md-option>\n						    <md-divider></md-divider>\n						    <md-option value=\"new\">\n						        New\n						    </md-option>\n						    <md-option value=\"improvement\">\n						        Improvement\n						    </md-option>\n						    <md-option value=\"fix\">\n						        Fix\n						    </md-option>\n						    <md-option value=\"alert\">\n						        Alert\n						    </md-option>\n						    <md-option value=\"flowTrigger\">\n						        Appcues flow trigger\n						    </md-option>\n\n						</md-select>\n					</md-input-container>\n					<div layout=\"row\" layout-align=\"center center\">\n						<md-button class=\"md-secondary\" ng-click=\"vm.sendToAll()\">Send to All</md-button>\n						<md-button class=\"md-primary md-raised\" ng-click=\"vm.sendToSelf()\">Send to Self</md-button>\n					</div>\n					<md-input-container>\n						<md-select placeholder=\"Select User\" style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.editedLog.user\">\n						    <md-option ng-repeat=\"user in vm.users | toArray:false | orderBy: \'profile.lastName\' track by $index\" value=\"{{user.uid}}\">\n						        {{user.email}} - {{user.profile.fullName}}\n						    </md-option>\n						</md-select>\n					</md-input-container>\n\n\n					<!-- <md-input-container >\n						<md-datepicker ng-model=\"vm.editedLog.date\" md-placeholder=\"Log Date\"></md-datepicker>\n					</md-input-container> -->\n\n							<md-input-container flex>\n								<label>Notification Title</label>\n								<input type=\"text\" ng-model=\"vm.editedLog.title\" placeholder=\"Notification Title\">\n							</md-input-container>\n							<md-input-container flex>\n								<label>Notification Meta</label>\n								<input type=\"text\" ng-model=\"vm.editedLog.meta\" placeholder=\"Notification Meta\">\n							</md-input-container>\n\n							<md-input-container flex>\n								<label>Notification Message</label>\n								<input type=\"text\" ng-model=\"vm.editedLog.message\" ng-required=\"true\">\n								<!-- <textarea rows=\"10\" ng-model=\"vm.editedLog.message\" placeholder=\"Log Message\"></textarea> -->\n							</md-input-container>\n							<md-input-container flex>\n								<label>Related ID</label>\n								<input type=\"text\" ng-model=\"vm.editedLog.related\">\n								<!-- <textarea rows=\"10\" ng-model=\"vm.editedLog.message\" placeholder=\"Log Message\"></textarea> -->\n							</md-input-container>\n\n					</div>\n					<!-- <md-input-container style=\"background-color: #fff; margin-top: 0; margin-bottom: 0;\">\n					  <lk-color-chooser style=\"width: 320px;\" colors=\"vm.clientColors\" selected-color=\"vm.editedLog.color\" ng-model=\"vm.editedLog.color\" ng-click=\"vm.colorChange(vm.changeLogForm);\"></lk-color-chooser>\n					</md-input-container> -->\n					<!-- <md-button ng-if=\"vm.editedLog.uid\" class=\"md-raised md-warn\" ng-click=\"vm.deleteLog(vm.editedLog)\">Delete</md-button> -->\n					<div layout=\"row\" layout-align=\"center center\">\n						<md-button class=\"md-raised\" ng-click=\"vm.init()\">Cancel</md-button>\n						<md-button ng-click=\"vm.saveLog(vm.editedLog)\" class=\"md-raised md-accent\">Send</md-button>\n						<!-- <md-button ng-if=\"vm.editedLog.uid\" ng-click=\"vm.updateLog(vm.editedLog)\" class=\"md-raised md-accent\">Update</md-button> -->\n						<!-- <md-button ng-click=\"vm.init()\" class=\"md-raised md-accent\">Reset</md-button> -->\n						<md-button ng-click=\"vm.triggerToast()\" class=\"md-raised md-primary\">Display as local Toast</md-button>\n\n					</div>\n\n\n				</div>\n				</form>\n				</md-card>\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-page.tmpl.html","");
$templateCache.put("app/adminja-admin/manage-plans.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<div flex=\"30\" layout=\"column\" style=\"max-width:285px;\" >\n			<md-content flex=\"100\">\n				<md-subheader class=\"md-sticky\">Plans by: <md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'planName\'\">Name</md-button> <md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'status\'\">Status</md-button><md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'-lastUpdated\'\">Date</md-button></md-subheader>\n\n				<md-card class=\"plan-card md-padding\" ng-class=\"{\'selected\': plan.uid === vm.selectedPlan.uid, \'active\': plan.status == \'active\', \'archived\': plan.status == \'archived\'} \" class=\"md-3-line\" ng-repeat=\"plan in vm.plans | orderBy: vm.sortField track by $index\" ng-click=\"vm.selectPlan(plan)\">\n				         <div class=\"md-list-item-text\" layout=\"column\">\n				           <h3>{{plan.planName}}</h3>\n				           <h4>{{plan.planID}}</h4>\n				           <p>${{plan.monthly}}</p>\n				           <p class=\"md-caption\">Last update: {{plan.lastUpdated | amDateFormat: \'MMMM Do YYYY\'}}</p>\n				         </div>\n				</md-card>\n			</md-content>\n		</div>\n		<div flex layout=\"column\">\n			<md-content flex=\"100\" layout-padding>\n			<md-card style=\"max-width: 1000px;\">\n				<h3 ng-if=\"vm.selectedPlan.lastUpdated\">Edit Plan</h3>\n				<h3 ng-if=\"!vm.selectedPlan.lastUpdated\">New Plan</h3>\n				<form name=\"planAdminForm\">\n				<div ng-if=\"bryanSays\" layout=\"row\" layout-align=\"start center\">\n					<div flex=\"50\" layout-align=\"center center\">\n						<h3>{{vm.selectedPlan.planName}}</h3>\n						<h4>{{vm.selectedPlan.planID}}</h4>\n						<p class=\"md-caption\">\n	 						<strong>Last updated:</strong> {{vm.selectedPlan.lastUpdated | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							<strong>Status:</strong> {{vm.selectedPlan.status}}\n						</p>\n					</div>\n					<div flex=\"50\" layout-align=\"center center\">\n						<h3>{{vm.selectedPlan.planName}}</h3>\n						<h4>{{vm.selectedPlan.planID}}</h4>\n						<p class=\"md-caption\">\n							<strong>Last updated:</strong> {{vm.selectedPlan.lastUpdated | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							<strong>Status:</strong> {{vm.selectedPlan.status}}\n						</p>\n					</div>\n				</div>\n				<div layout=\"row\" layout-align=\"start center\">\n					<md-input-container flex=\"nogrow\">\n					    <label>Visibility in Adminja</label>\n					    <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.selectedPlan.status\">\n					        <md-option value=\"active\">\n					            active\n					        </md-option>\n					        <md-option value=\"draft\">\n					            draft\n					        </md-option>\n					        <md-option value=\"archived\">\n					            archived\n					        </md-option>\n					    </md-select>\n					</md-input-container>\n					<md-input-container flex=\"nogrow\">\n					    <label>Chargebee Status</label>\n					    <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.selectedPlan.chargebeeStatus\">\n					        <md-option value=\"active\">\n					            active\n					        </md-option>\n					        <md-option value=\"archived\">\n					            archived\n					        </md-option>\n					    </md-select>\n					</md-input-container>\n				</div>\n\n					<div flex layout=\"column\">\n\n						<md-input-container >\n						    <label>PlanID</label>\n						    <input name=\"planid\" ng-model=\"vm.selectedPlan.planID\" type=\"text\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Plan Name</label>\n						    <input name=\"planname\" ng-model=\"vm.selectedPlan.planName\" type=\"text\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Monthly Cost</label>\n						    <input name=\"plancost\" ng-model=\"vm.selectedPlan.monthly\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Workspace limit</label>\n						    <input name=\"workspaces\" ng-model=\"vm.selectedPlan.workspaces\" type=\"number\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Team Member limit (including Owner)</label>\n						    <input name=\"team\" ng-model=\"vm.selectedPlan.team\" type=\"number\" min=\"1\" max=\"50\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Recurring Task limit (enter zero for no restrictions)</label>\n						    <input name=\"team\" ng-model=\"vm.selectedPlan.recurring\" type=\"number\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Can access billing tab?</label>\n						    <md-switch class=\"md-accent\" ng-model=\"vm.selectedPlan.billing\"></md-switch>\n						</md-input-container>\n						<div layout=\"row\" layout-align=\"start center\">\n							<md-button class=\"\" type=\"submit\" ng-click=\"vm.reset()\">Reset</md-button>\n							<md-button class=\"md-accent md-raised\" ng-if=\"!vm.selectedPlan.uid\" type=\"submit\" ng-click=\"vm.savePlan(vm.selectedPlan)\">Save</md-button>\n							<md-button class=\"md-accent md-raised\" ng-if=\"vm.selectedPlan.uid\" type=\"submit\" ng-click=\"vm.savePlan(vm.selectedPlan)\">Update</md-button>\n						</div>\n						<hr>\n						<h3>Plan Details</h3>\n						<div ng-repeat=\"detail in vm.selectedPlan.details | toArray: false | orderBy: [\'order\'] track by detail.uid\" layout=\'row\' layout-align=\"layout-fill center\">\n							<div flex=\"grow\" layout=\"row\" layout-align=\"layout-fill center\" ng-click=\"vm.selectDetail(detail)\">\n								<span flex=\"nogrow\" style=\"padding: 0 1em 0 0;\">{{detail.order}}</span>\n								<span flex=\'nogrow\'><md-icon ng-if=\"detail.featured\" md-font-icon=\"zmdi zmdi-star\"></md-icon></span>\n								<span flex=\"50\" ng-if=\"!detail.emphasis\">{{detail.label}}</span>\n								<span flex=\"50\" ng-if=\"detail.emphasis\"><strong>{{detail.label}}</strong></span>\n								<span flex=\"auto\"><span ng-if=\"detail.url\">{{detail.url}}</span></span>\n							</div>\n							<md-button flex=\"nogrow\" ng-click=\"vm.removeDetail(detail)\">X</md-button>\n						</div>\n						<div style=\"background-color: #efefef; padding: 1em;\">\n							<h3>Add a new detail</h3>\n							<div layout=\"row\" layout-align=\"layout-fill center\">\n								<md-input-container flex=\"nogrow\">\n								    <label>Order</label>\n								    <input name=\"detailorder\" ng-model=\"vm.newDetail.order\" type=\"text\">\n								</md-input-container>\n								<md-input-container flex=\"grow\">\n								    <label>Detail</label>\n								    <input name=\"detailhtml\" ng-model=\"vm.newDetail.label\" type=\"text\">\n								</md-input-container>\n								<md-input-container flex=\"grow\">\n								    <label>Optional URL</label>\n								    <input name=\"detailurl\" ng-model=\"vm.newDetail.url\" type=\"text\">\n								</md-input-container>\n							</div>\n							<div layout=\"row\" layout-align=\"end center\">\n								<md-input-container flex=\"auto\" style=\"min-width: 150px;\">\n								    <label>Emphasized?</label>\n								    <md-switch class=\"md-accent\" ng-model=\"vm.newDetail.emphasis\"></md-switch>\n								</md-input-container>\n								<md-input-container flex=\"auto\" style=\"min-width: 150px;\">\n								    <label>Featured?</label>\n								    <md-switch class=\"md-accent\" ng-model=\"vm.newDetail.featured\"></md-switch>\n								</md-input-container>\n								<div style=\"min-width: 200px; margin-top: 20px;\">\n									<md-button flex=\"nogrow\" ng-if=\"!vm.newDetail.uid\" ng-click=\"vm.addDetail(vm.newDetail)\" class=\"md-accent  md-raised\">Add</md-button>\n									<md-button flex=\"nogrow\" ng-if=\"vm.newDetail.uid\" ng-click=\"vm.deSelectDetail()\" class=\"\">Cancel</md-button>\n									<md-button flex=\"nogrow\" ng-if=\"vm.newDetail.uid\" ng-click=\"vm.updateDetail(vm.newDetail)\" class=\"md-accent  md-raised\">Update</md-button>\n								</div>\n							</div>\n						</div>\n\n					</div>\n\n				</form>\n				</md-card>\n			</md-content>\n		</div>\n\n\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-tasks.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<div flex=\"30\" layout=\"column\" style=\"min-width: 450px;\">\n			<md-content flex=\"100\" style=\"background-color: #fff; border-right: 1px solid #bbb;\">\n				<md-list>\n\n				       <md-subheader class=\"md-sticky\"><form class=\"form-inline\" style=\"margin:0;\">\n				       	<h3 class=\"center\" style=\"margin-top:0px; margin-bottom:25px;\">{{vm.tasks.length}} Tasks for {{vm.client.profile.fullName}}</h3>\n						<div layout=\"row\" layout-align=\"center center\">\n							<div flex style=\"position: relative;\" layout=\"row\" layout-align=\"start center\">\n					             <input ng-show=\"vm.tasks\" id=\"searchQuery\" class=\"search-field\" ng-model=\"searchQuery\" type=\"text\"\n					               placeholder=\"Refine search\" autofocus style=\"margin-right: .5em;\">\n					               <input ng-disabled=\"true\" ng-show=\"!vm.tasks\" id=\"searchQuery\" class=\"search-field\" ng-model=\"searchQuery\" type=\"text\"\n					                 placeholder=\"Please wait...\" style=\"margin-right: .5em;\">\n					                <md-icon md-font-icon=\"fa fa-close\" style=\"margin: 0 auto 0 auto; font-size: 11px; cursor:pointer;\" ng-click=\"vm.resetFilter()\"></md-icon>\n					          </div>\n\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Status</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.filterStatus\">\n									    <md-option value=\"all\">\n									        All\n									    </md-option>\n									    <md-option value=\"in_trial\">\n									        In Trial\n									    </md-option>\n									    <md-option value=\"active\">\n									        Active\n									    </md-option>\n									    <md-option value=\"cancelled\">\n									        Cancelled\n									    </md-option>\n									    <md-option value=\"exclude-cancelled\">\n									        Exclude Cancelled\n									    </md-option>\n									    <md-option value=\"exclude-zero-score\">\n									        Exclude No Score\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Plans</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.filterPlan\">\n									    <md-option value=\"all\">\n									        All\n									    </md-option>\n									    <md-option value=\"starter\">\n									        Starter\n									    </md-option>\n									    <md-option value=\"lite\">\n									        Lite (closed)\n									    </md-option>\n									    <md-option value=\"assistant\">\n									        Assistant\n									    </md-option>\n									    <md-option value=\"pro\">\n									        Pro\n									    </md-option>\n									    <md-option value=\"exclude-starter\">\n									        Exclude Starter\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Sort by</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.orderBy\">\n									    <md-option value=\"profile.lastName\">\n									        Last Name\n									    </md-option>\n									    <md-option value=\"-score\">\n									        Score\n									    </md-option>\n									    <md-option value=\"plan.content__subscription__plan_id\">\n									        Plan ID\n									    </md-option>\n									    <md-option value=\"plan.content__subscription__status\">\n									        Status\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n\n						</div>\n				           </form></md-subheader>\n					<p ng-if=\"!vm.tasks\" style=\"color: #bbb; font-size: 1em;\"  class=\"center\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon> Fetching Tasks</p>\n\n\n\n			      <app-item\n			          class=\"task-app-item\"\n			          taskid=\"{{item.refID}}\"\n			          order=\"{{item.order}}\"\n			          taskpanel=\"{{item.panel}}\"\n			          client=\"{{item.client}}\"\n			          ng-repeat=\"item in vm.tasks| toArray  : false| orderBy:[\'order\'] track by $index \" >\n			      </app-item>\n\n				</md-list>\n			</md-content>\n		</div>\n\n\n\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-toolbar.tmpl.html","<!-- // Account Manager Toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" >\n\n  <div flex=\"nogrow\"  style=\"padding-right: 2em;\">\n    <h3>Manage Adminja</h3>\n  </div>\n<!--   <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" class=\"md-button\"  ui-sref=\"triangular.account-page.profile\" ><md-icon md-font-icon=\"fa fa-user\"></md-icon> Profile</a>\n  </div>\n\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-users\"></md-icon> Team</a>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Plan</a>\n  </div>\n  <div flex></div>\n  <sidebar-controls></sidebar-controls> -->\n</div>\n\n");
$templateCache.put("app/adminja-admin/manage-tutorials.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<div flex=\"400\" layout=\"column\" style=\"min-width: 400px; max-width:400px;\" >\n			<md-content flex=\"100\">\n				<md-subheader class=\"md-sticky\">Sort by: <md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'order\'\">Order</md-button> <md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'label\'\">Nav Label</md-button> <md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'status\'\">Status</md-button><md-button class=\"md-button-small\" ng-click=\"vm.sortField = \'-lastUpdated\'\">Date</md-button></md-subheader>\n				<md-button class=\"md-raised md-accent\" ng-click=\"vm.reset()\">New Tutorial</md-button>\n				<md-card class=\"plan-card md-padding\" ng-class=\"{\'selected\': tutorial.uid === vm.selectedTutorial.uid, \'active\': tutorial.status == \'active\', \'draft\': tutorial.status == \'draft\'} \" class=\"md-3-line\" ng-repeat=\"tutorial in vm.tutorials | orderBy: vm.sortField track by $index\" ng-click=\"vm.selectTutorial(tutorial)\">\n				         <div class=\"md-list-item-text\" layout=\"column\">\n				           <h3>{{tutorial.label}}</h3>\n				           <h4>{{tutorial.title}}</h4>\n				           <p class=\"md-caption\">Last update: {{tutorial.lastUpdated | amDateFormat: \'MMMM Do YYYY\'}}</p>\n				         </div>\n				</md-card>\n\n			</md-content>\n		</div>\n		<div flex layout=\"column\">\n			<md-content flex=\"100\" layout-padding>\n			<md-card style=\"max-width: 600px;\">\n				<h3 ng-if=\"vm.selectedTutorial.lastUpdated\">Edit Tutorial</h3>\n				<h3 ng-if=\"!vm.selectedTutorial.lastUpdated\">New Tutorial</h3>\n				<form name=\"planAdminForm\">\n				<div ng-if=\"bryanSays\" layout=\"row\" layout-align=\"start center\">\n					<div flex=\"50\" layout-align=\"center center\">\n						<h3>{{vm.selectedTutorial.label}}</h3>\n						<h4>{{vm.selectedTutorial.title}}</h4>\n						<p class=\"md-caption\">\n							<strong>YoutubeID:</strong> {{vm.selectedTutorial.youtubeID}}<br>\n							<strong>Last updated:</strong> {{vm.selectedTutorial.lastUpdated | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							<strong>Status:</strong> {{vm.selectedTutorial.status}}\n						</p>\n					</div>\n					<div flex=\"50\" layout-align=\"center center\">\n						<h3>{{vm.selectedTutorial.planName}}</h3>\n						<h4>{{vm.selectedTutorial.planID}}</h4>\n						<p class=\"md-caption\">\n							<strong>Last updated:</strong> {{vm.selectedTutorial.lastUpdated | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							<strong>Status:</strong> {{vm.selectedTutorial.status}}\n						</p>\n					</div>\n				</div>\n				<div layout=\"row\" layout-align=\"start center\">\n					<md-input-container flex=\"nogrow\">\n					    <label>Status</label>\n					    <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.selectedTutorial.status\">\n					        <md-option value=\"active\">\n					            active\n					        </md-option>\n					        <md-option value=\"draft\">\n					            draft\n					        </md-option>\n\n					    </md-select>\n					</md-input-container>\n\n				</div>\n\n					<div flex layout=\"column\">\n\n\n						<md-input-container >\n						    <label>Navigation Label</label>\n						    <input name=\"navlabel\" ng-model=\"vm.selectedTutorial.label\" type=\"text\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Page Title</label>\n						    <input name=\"pagetitle\" ng-model=\"vm.selectedTutorial.title\" type=\"text\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Order</label>\n						    <input name=\"order\" ng-model=\"vm.selectedTutorial.order\" type=\"number\" required>\n						</md-input-container>\n						<md-input-container >\n						    <label>Youtube ID</label>\n						    <input name=\"youtubeid\" ng-model=\"vm.selectedTutorial.youtubeID\" type=\"text\"  required>\n						</md-input-container>\n						<md-input-container >\n						    <text-angular name=\"body\" ng-model=\"vm.selectedTutorial.body\"  ng-required=\"false\" ta-toolbar=\"[[\'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\', \'insertLink\']]\" ></text-angular>\n						</md-input-container>\n\n						<div layout=\"row\" layout-align=\"start center\">\n							<md-button class=\"\" type=\"submit\" ng-click=\"vm.reset()\">Reset</md-button>\n							<md-button class=\"\" ng-if=\"vm.selectedTutorial.uid\" type=\"submit\" ng-click=\"vm.delete(vm.selectedTutorial)\"><span style=\"color: red;\">Delete</span></md-button>\n							<md-button class=\"md-accent md-raised\" ng-if=\"!vm.selectedTutorial.uid\" type=\"submit\" ng-click=\"vm.saveTutorial(vm.selectedTutorial)\">Save</md-button>\n							<md-button class=\"md-accent md-raised\" ng-if=\"vm.selectedTutorial.uid\" type=\"submit\" ng-click=\"vm.saveTutorial(vm.selectedTutorial)\">Update</md-button>\n						</div>\n					</div>\n\n				</form>\n				</md-card>\n			</md-content>\n		</div>\n\n\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-users.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-align=\"layout-fill layout-fill\" layout-fill>\n		<div flex=\"30\" layout=\"column\" style=\"min-width: 450px;\">\n			<md-content flex=\"100\" style=\"background-color: #fff; border-right: 1px solid #bbb;\">\n				<md-list>\n				       <md-subheader class=\"md-sticky\"><form class=\"form-inline\" style=\"margin:0;\">\n				       	<h3 class=\"center\" style=\"margin-top:0px; margin-bottom:25px;\">{{filteredUsers.length}} Adminja Users</h3>\n						<div layout=\"row\" layout-align=\"start center\">\n							<div flex style=\"position: relative;\" layout=\"row\" layout-align=\"start center\">\n					             <input ng-show=\"vm.users\" id=\"searchQuery\" class=\"search-field\" ng-model=\"searchQuery\" type=\"text\"\n					               placeholder=\"Filter\" autofocus style=\"margin-right: .5em;\">\n					               <input ng-disabled=\"true\" ng-show=\"!vm.users\" id=\"searchQuery\" class=\"search-field\" ng-model=\"searchQuery\" type=\"text\"\n					                 placeholder=\"Please wait...\" style=\"margin-right: .5em;\">\n					                <md-icon style=\"margin:0;\" md-font-icon=\"fa fa-close\" style=\"margin: 0 auto 0 auto; font-size: 11px; cursor:pointer;\" ng-click=\"vm.resetFilter()\"></md-icon>\n					          </div>\n\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Status</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.filterStatus\">\n									    <md-option value=\"all\">\n									        All\n									    </md-option>\n									    <md-option value=\"in_trial\">\n									        In Trial\n									    </md-option>\n									    <md-option value=\"active\">\n									        Active\n									    </md-option>\n									    <md-option value=\"paused\">\n									        Paused\n									    </md-option>\n									    <md-option value=\"cancelled\">\n									        Cancelled\n									    </md-option>\n									    <md-option value=\"exclude-cancelled\">\n									        Exclude Cancelled\n									    </md-option>\n									    <md-option value=\"exclude-zero-score\">\n									        Exclude No Score\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Plans</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.filterPlan\">\n									    <md-option value=\"all\">\n									        All\n									    </md-option>\n									    <md-option ng-repeat=\"plan in vm.plans  track by uid + $index\" ng-value=\"plan.planID\">\n									    	{{plan.planName}}<br>{{plan.planID}}\n									    </md-option>\n									   <!--  <md-option value=\"starter\">\n									        Starter\n									    </md-option>\n									    <md-option value=\"lite\">\n									        Lite (closed)\n									    </md-option>\n									    <md-option value=\"assistant\">\n									        Assistant\n									    </md-option>\n									    <md-option value=\"pro\">\n									        Pro\n									    </md-option> -->\n									    <md-option value=\"client-access\">\n									        Client Users\n									    </md-option>\n									    <md-option value=\"exclude-starter\">\n									        Paid Subscriptions Only\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n\n							<div flex=\"nogrow\">\n								<md-input-container style=\"margin:0; padding:0;\">\n									<label>Sort by</label>\n									<md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.orderBy\">\n									    <md-option value=\"fullName\">\n									        First Name\n									    </md-option>\n									    <md-option value=\"email\">\n									        Email\n									    </md-option>\n									    <!-- <md-option value=\"-score\">\n									        Score\n									    </md-option> -->\n									    <md-option value=\"plan\">\n									        Plan ID\n									    </md-option>\n									    <md-option value=\"status\">\n									        Status\n									    </md-option>\n									    <md-option value=\"startDate\">\n									        Start Date\n									    </md-option>\n									    <md-option value=\"teams\">\n									        On Teams\n									    </md-option>\n									</md-select>\n								</md-input-container>\n							</div>\n\n						</div>\n				           </form></md-subheader>\n\n					<p ng-if=\"!vm.users\" style=\"color: #bbb; font-size: 1em;\"  class=\"center\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon> Fetching Users</p>\n				       <md-list-item style=\"border-bottom: 1px solid #bbb;\"\n				       	ng-class=\"{\'selected\': user.uid === vm.selectedUser.uid}\"\n				       	class=\"md-3-line\"\n				       	ng-if=\"user.email\"\n				       	ng-repeat=\"user in filteredUsers = (vm.users | toArray:false |  filter: vm.filterText | filter: vm.statusFilter | filter: vm.planFilter  | orderBy: vm.orderBy) track by $index\"\n				       	ng-click=\"vm.selectUser(user.uid)\">\n				         <img src=\"{{user.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" class=\"md-avatar\" alt=\"{{user.fullName}}\" width=\"50\"/>\n				         <div class=\"md-list-item-text\" layout=\"column\" style=\"padding: 1em;\" >\n				           <h3>{{user.fullName}} <span ng-if=\"!user.plan\" style=\"color: red;\">!!!</span></h3>\n\n				           <h4>{{user.email}}</h4>\n				           <p>ID: {{user.uid}}</p>\n				           <!-- <p>Type: {{user.type}}</p> -->\n				           <p>Plan: {{user.plan}}<br>\n				           Status: <span class=\"user-status-{{user.status}}\">{{user.status}}</span><br>\n				           Start Date: {{user.startDate | amDateFormat: \"MM/DD/YY\"}}<br>\n				           Last Session: {{user.lastSession | amDateFormat: \"MM/DD/YY\"}}<br>\n				           # of Sessions: {{user.sessionCount}}\n\n				      </p>\n\n				         </div>\n				       </md-list-item>\n\n				</md-list>\n			</md-content>\n		</div>\n		<div flex=\"70\" layout=\"column\" >\n			<md-content layout=\"column\" layout-padding ng-if=\"vm.selectedUser\" style=\"background-color: #ededed;\">\n				<h3>User Details</h3>\n				<md-card style=\"padding: 2em;\" layout=\"column\">\n					<div layout=\"row\" layout-align=\"start start\">\n						<img ng-src=\"{{vm.selectedUser.profile.avatar|| \'/assets/images/avatars/generic-avatar.png\'}}\" class=\"md-avatar\" alt=\"{{vm.selectedUser.profile.fullName}}\" style=\"width: 50px; border-radius: 50px;\"/>\n					</div>\n					<div layout=\"row\" layout-align=\"start start\">\n						<div flex=\"40\">\n							<h3>{{vm.selectedUser.profile.fullName}}</h3>\n							<h4>{{vm.selectedUser.email}}</h4>\n							<span class=\"md-subhead\">Is a member on {{vm.teamSize(vm.selectedUser)}} teams.</span>\n							<small><strong>UID:</strong> <a href=\"{{dataURL}}users/{{vm.selectedUser.uid}}\" target=\"_blank\">{{vm.selectedUser.uid}}</a></small><br>\n\n							<h4 ng-bind=\"vm.litmusTest(vm.selectedUser)\"></h4>\n						</div>\n						<div flex=\"30\">\n							<p>\n								<strong>Plan: </strong> {{vm.selectedUser.plan.content__subscription__plan_id}}<br>\n								<strong>Status: </strong> {{vm.selectedUser.plan.content__subscription__status}}<br>\n								<strong>Total sessions:</strong> {{vm.selectedUser.sessionCount}}<br>\n								<strong>Last Login:</strong> {{vm.selectedUser.lastLogin | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							</p>\n						</div>\n						<div flex=\"30\">\n							<p>\n								<strong>Started:</strong> {{vm.selectedUser.profile.startDate | amDateFormat: \'MMM Do, YYYY\'}}<br>\n								<strong>Trial End:</strong> {{vm.selectedUser.plan.content__subscription__trial_end | amDateFormat: \'MMM Do, YYYY\'}}<br>\n								<span ng-if=\"vm.selectedUser.plan.content__subscription__status == \'cancelled\'\">\n									<strong>Cancelled:</strong> {{vm.selectedUser.plan.cancelledAt| amDateFormat: \'MMM Do, YYYY\'}}<br>\n								</span>\n								<strong>Country:</strong> {{vm.selectedUser.profile.country || \'unspecified\'}}<br>\n								<strong>Source:</strong> {{vm.selectedUser.source}}<br>\n							</p>\n						</div>\n					</div>\n					<md-divider style=\"margin: 2em;\"></md-divider>\n					<div layout=\"row\" layout-align=\"layout-fill start\">\n						<div flex=\"30\">\n							<div ng-if=\"vm.teamSize(vm.selectedUser) > 0\">\n								<h4 style=\"margin-bottom: 0;\">Team Memberships</h4>\n								<small ng-repeat=\"(key, value) in vm.selectedUser.teams track by $index\">\n									<a target=\"_blank\" href=\"{{dataURL}}teams/{{key}}\">{{key}}</a>\n								</small>\n							</div>\n							<h4 style=\"margin-bottom:0;\">Service Records</h4>\n							<ul style=\"margin-top: 0;\">\n								<li>\n									<a href=\"{{dataURL}}users/{{vm.selectedUser.uid}}\" target=\"_blank\">Firebase Record</a>\n								</li>\n								<li>\n									<a href=\"{{dataURL}}userList/{{vm.selectedUser.uid}}\" target=\"_blank\">User Brief Record</a>\n								</li>\n								<li>\n									<a href=\"https://adminja.chargebee.com/admin-console/customers/{{vm.selectedUser.plan.content__customer__id}}\" target=\"_blank\">Chargebee Customer</a>\n								</li>\n								<li>\n									<a href=\"https://adminja.chargebee.com/admin-console/subscriptions/{{vm.selectedUser.plan.content__subscription__id}}\" target=\"_blank\">Chargebee Subscription</a>\n								</li>\n								<li>\n									<a href=\"https://adminja.groovehq.com/groove_client/search/{{vm.selectedUser.email | escape}}\" target=\"_blank\">Groove Helpdesk</a>\n								</li>\n							</ul>\n							<h4 style=\"margin-bottom: 0;\">Links</h4>\n							<ul style=\"margin-top:0;\">\n								<li ng-if=\"vm.selectedUser.profile.website\"><a href=\"{{vm.selectedUser.profile.website}}\" target=\"_blank\">Website</a></li>\n								<li ng-if=\"vm.selectedUser.profile.twitter\"><a href=\"https://www.twitter.com/{{vm.selectedUser.profile.twitter}}\" target=\"_blank\">Twitter</a></li>\n								<li ng-if=\"vm.selectedUser.profile.facebook\"><a href=\"https://www.facebook.com/{{vm.selectedUser.profile.facebook}}\" target=\"_blank\">Facebook</a></li>\n							</ul>\n						</div>\n						<div flex=\"40\" class=\"padding-right-20\">\n							<div class=\"user-management-form\" ng-if=\"!vm.selectedUser.plan.content__subscription__id\" style=\"border: 1px solid red; border-radius:8px; padding: .5em; margin-right:1em;\">\n								<h3 class=\"center md-subhead margin-top-0\">User has no plan!</h3>\n								<md-input-container style=\"margin-right: 1em;\">\n								<md-select style=\"margin: 0;\" ng-model=\"vm.targetPlan\" ng-change=\"\" placeholder=\"Select a plan\">\n								    <md-option  value=\"starter-2018c\">\n								        Starter<span style=\"font-size: .85em;\">(starter-2018c)</span>\n								    </md-option>\n								    <md-option ng-repeat=\"plan in vm.plans track by $index\" ng-if=\"plan.status == \'active\'\" value=\"{{plan.planID}}\">\n								        {{plan.planName}} <span style=\"font-size: .85em;\">({{plan.planID}})</span>\n								    </md-option>\n								</md-select>\n								</md-input-container>\n								<md-button ng-disabled=\"!vm.targetPlan\" ng-click=\"vm.subscribeUser(vm.selectedUser.uid, vm.targetPlan)\" class=\"md-raised md-accent\">Create Subscription</md-button><br>\n							</div>\n\n							<form ng-disabled=\"!vm.selectedUser.plan.content__subscription__plan_id\" class=\"user-management-form\" name=\"vm.forms.subscriptionForm\">\n								<small style=\"font-size: 12px; margin-bottom: 2em;\" ng-if=\"vm.teamSize(vm.selectedUser) > 0\" class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"font-size: 12px; margin:0; color: orange;\"></md-icon>Subscriber is on a team. Cannot be cancelled, paused or deleted.</small>\n\n								<div layout=\"row\" layout-align=\"start center\">\n									<p flex=\"20\" class=\"md-subhead margin-top-0 margin-bottom-0\" style=\"font-size: 12px; font-weight: bold;\">Teams: </p>\n									<md-button ng-disabled=\"vm.selectedUser.limits.team < 2\" ng-click=\"vm.dissolveTeam(vm.selectedUser.uid)\" style=\"margin:0;\" ><md-icon md-font-icon=\"fa fa-users\" style=\"font-size: 14px;\"></md-icon>  Dissolve Team</md-button>\n									<md-button ng-disabled=\"!vm.selectedUser.teams || vm.selectedUser.teams == 0\" ng-click=\"vm.leaveTeams(vm.selectedUser.uid)\" style=\"margin:0;\"><md-icon md-font-icon=\"fa fa-user\" style=\"font-size: 14px;\"></md-icon>  Leave Teams</md-button>\n								</div>\n								<md-divider style=\"margin-bottom: 1em;\"></md-divider>\n								<div layout=\"row\" layout-align=\"start center\" >\n									<p flex=\"20\" class=\"md-subhead margin-top-0 margin-bottom-0\" style=\"font-size: 12px; font-weight: bold;\">Subscription: </p>\n									<md-button ng-click=\"vm.pauseSubscription(vm.selectedUser)\" ng-disabled=\"vm.selectedUser.plan.content__subscription__status == \'paused\' || vm.selectedUser.plan.content__subscription__status == \'cancelled\' || vm.teamSize(vm.selectedUser) > 0\"><md-icon md-font-icon=\"zmdi zmdi-pause\" style=\"color: orange;\"></md-icon>  Pause</md-button>\n									<md-button ng-click=\"vm.cancelSubscription(vm.selectedUser)\" ng-disabled=\"vm.selectedUser.plan.content__subscription__status == \'cancelled\' || vm.teamSize(vm.selectedUser) > 0\"><md-icon md-font-icon=\"zmdi zmdi-stop\" style=\"color: red;\"></md-icon>  Cancel</md-button>\n								</div>\n\n\n\n								<md-divider style=\"margin-bottom: 1em;\"></md-divider>\n								<div layout=\"row\" layout-align=\"start center\">\n									<p flex=\"20\" class=\"md-subhead margin-top-0 margin-bottom-0\" style=\"font-size: 12px; font-weight: bold;\">User: </p>\n									<md-button ng-click=\"vm.exportUser(vm.selectedUser)\" ><md-icon md-font-icon=\"zmdi zmdi-download\"></md-icon>  Export</md-button><br>\n									<a id=\"downloadAnchorElem\" style=\"display:none\"></a>\n									<md-button ng-click=\"vm.deleteUser(vm.selectedUser)\" ng-disabled=\"vm.selectedUser.plan.content__subscription__status != \'cancelled\' || vm.teamSize(vm.selectedUser) > 0\" ><md-icon style=\"color: red;\" md-font-icon=\"zmdi zmdi-delete\"></md-icon>  Delete</md-button>\n								</div>\n\n							</form>\n							<div>\n								<p>Only bryan should use this.</p>\n								<md-button ng-click=\"vm.forceDeleteUser(vm.selectedUser)\">Force Delete User</md-button>\n							</div>\n\n						</div>\n						<div flex=\"30\" >\n							<form class=\"user-management-form\" name=\"vm.forms.userForm\" >\n								<h3 class=\"center md-subhead margin-top-0 margin-bottom-20\">Subscription Overrides</h3>\n								<md-input-container style=\"padding:0;\" label=\"Workspace Limit\">\n									<label for=\"limit\">Workspace Limit</label>\n									<input type=\"text\" name=\"limit\" ng-model=\"vm.selectedUser.limits.clients\">\n								</md-input-container>\n								<md-input-container style=\"margin:0; padding:0;\" label=\"Team Limit\">\n									<label for=\"teamLimit\">Member Limit</label>\n									<input type=\"text\" name=\"teamLimit\" ng-model=\"vm.selectedUser.limits.team\">\n								</md-input-container>\n								<md-input-container style=\"margin:0; padding:0;\" label=\"Team Limit\">\n									<label for=\"teamLimit\">Additional members</label>\n									<input type=\"text\" name=\"additionalTeamMembers\" ng-model=\"vm.selectedUser.limits.additionalTeamMembers\">\n								</md-input-container>\n								<md-input-container style=\"margin:0; padding:0;\" label=\"Account Type\">\n									<label for=\"type\">Account Type</label>\n									<input type=\"text\" name=\"type\" ng-model=\"vm.selectedUser.type\">\n								</md-input-container>\n								<md-input-container style=\"margin:0; padding:0;\" label=\"Subscription Status\">\n									<md-select name=\'status\' ng-model=\"vm.selectedUser.plan.content__subscription__status\">\n										<md-option value=\"active\">Active</md-option>\n										<md-option value=\"in_trial\">In Trial</md-option>\n										<md-option value=\"paused\">Paused</md-option>\n										<md-option value=\"cancelled\">Cancelled</md-option>\n									</md-select>\n								</md-input-container>\n								<div layout=\"row\" layout-align=\"end center\" style=\"padding-top:2em;\">\n									<md-button ng-disabled=\"vm.forms.userForm.$pristine\" ng-click=\"vm.updateUser(vm.selectedUser)\" class=\"md-raised md-accent\">Update</md-button><br>\n								</div>\n							</form>\n						</div>\n					</div>\n					<!-- <div layout=\"column\">\n						{{vm.userToDelete | json}}\n					</div> -->\n					<!-- <div style=\"background-color: yellow; width: auto; max-width: 100%; overflow-x: scroll;\">\n						<p>Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales. Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales.</p>\n						<p>Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales.</p>\n						<p>Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales.</p>\n						<p>Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales.</p>\n						<div style=\"background-color: red; width: 2000px;\">\n							<p>Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales. Lorem ipsum dolor sit amet consectetur adipiscing elit, himenaeos porttitor mus vulputate tempus tempor mauris, eros praesent interdum duis potenti sodales.</p>\n						</div>\n					</div> -->\n					<div layout=\"column\" class=\"margin-top-20\" style=\"max-width: 100%; width: auto;\">\n						<h3 class=\"center\">Activity</h3>\n						<div class=\"activity\" layout=\"row\" layout-align=\"start start\" style=\"overflow-x: scroll; max-width: 100%;  width: auto;\">\n							<div flex=\"20\" style=\"min-width: 150px;\" layout=\"column\" layout-align=\"start start\" ng-repeat=\"week in vm.selectedUserCounts | toArray: false |orderBy: [\'range\'] track by week.range\">\n								<strong flex=\"nogrow\" style=\"font-size: 12px;\">{{week.range}}</strong>\n								<span flex=\"nogrow\" ng-if=\"key != \'range\'\" ng-repeat=\"(key, value) in week\">\n									<strong>{{key}}:</strong>\n									<div>{{value}}</div>\n								</span>\n							</div>\n						</div>\n					</div>\n\n				</md-card>\n\n\n\n			</md-content>\n\n		</div>\n\n\n</div>\n\n\n<md-table-container ng-if=\"vm.bryanSays\">\n        <table md-table class=\"md-primary user-details-table\">\n            <thead md-head>\n                <tr md-row>\n                	<th nowrap md-column></th>\n                    <th md-column>All Time</th>\n                    <th md-column>Today</th>\n                    <th md-column>This Week</th>\n                    <th md-column>This Month</th>\n                    <!-- <th md-column>This Year</th> -->\n				<th md-column>Last change</th>\n                </tr>\n            </thead>\n            <tbody md-body>\n            	<tr md-row>\n            		<td nowrap md-cell><strong>Tasks Added</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.added.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.added.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.added.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.added.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.tasks.added.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.tasks.added.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td nowrap md-cell><strong>Tasks Completed</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.completed.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.completed.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.completed.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.tasks.completed.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.tasks.completed.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.tasks.completed.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>Time Logs</strong></td>\n            	    <td md-cell >{{vm.selectedUser.counts.timeLogs.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.timeLogs.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.timeLogs.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>Time totals</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.allTime||0}} logs</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.todayTotal ||0 | HandM}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.weekTotal ||0 | HandM}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timeLogs.monthTotal ||0 | HandM}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.timeLogs.yearTotal ||0 | HandM}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.timeLogs.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>Timers</strong></td>\n            	    <td md-cell ng-class=\"{\'over\': vm.selectedUser.counts.timeLogs.allTime > 5, \'close\': vm.selectedUser.counts.timeLogs.allTime > 1 }\">{{vm.selectedUser.counts.timers.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timers.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timers.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.timers.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.timers.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.timers.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>PDFS</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.pdfs.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.pdfs.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.pdfs.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.pdfs.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.pdfs.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.pdfs.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>Profile Cards</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.profileCards.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.profileCards.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.profileCards.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.profileCards.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.profileCards.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.profileCards.lastChange\"></span></td>\n            	</tr>\n            	<tr md-row>\n            		<td md-cell nowrap><strong>Task Buckets</strong></td>\n            	    <td md-cell>{{vm.selectedUser.counts.taskGroups.allTime||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.taskGroups.today||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.taskGroups.thisWeek||0}}</td>\n            	    <td md-cell>{{vm.selectedUser.counts.taskGroups.thisMonth||0}}</td>\n            	    <!-- <td md-cell>{{vm.selectedUser.counts.taskGroups.thisYear||0}}</td> -->\n            	    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.taskGroups.lastChange\"></span></td>\n            	</tr>\n                <tr md-row>\n                	<td md-cell nowrap><strong>Invoices</strong></td>\n                    <td md-cell>{{vm.selectedUser.counts.invoices.allTime||0}}</td>\n                    <td md-cell>{{vm.selectedUser.counts.invoices.today||0}}</td>\n                    <td md-cell>{{vm.selectedUser.counts.invoices.thisWeek||0}}</td>\n                    <td md-cell>{{vm.selectedUser.counts.invoices.thisMonth||0}}</td>\n                    <!-- <td md-cell>{{vm.selectedUser.counts.invoices.thisYear||0}}</td> -->\n                    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.invoices.lastChange\"></span></td>\n                </tr>\n                <tr md-row>\n                	<td md-cell nowrap><strong>Recurring Tasks</strong></td>\n                    <td md-cell>{{vm.selectedUser.counts.taskTemplates.recurringTasks||0}}</td>\n                    <td md-cell>N/A</td>\n                    <td md-cell>N/A</td>\n                    <td md-cell>N/A</td>\n                    <!-- <td md-cell>N/A</td> -->\n                    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.taskTemplates.lastChange\"></span></td>\n                </tr>\n                <tr md-row>\n                	<td md-cell nowrap><strong>Task Templates</strong></td>\n                    <td md-cell>{{vm.selectedUser.counts.taskTemplates.templateTasks||0}}</td>\n                    <td md-cell>N/A</td>\n                    <td md-cell>N/A</td>\n                    <td md-cell>N/A</td>\n                    <!-- <td md-cell>N/A</td> -->\n                    <td md-cell><span am-time-ago=\"vm.selectedUser.counts.taskTemplates.lastChange\"></span></td>\n                </tr>\n            </tbody>\n              <thead md-head>\n                  <tr md-row>\n                  	<th md-column></th>\n                      <th md-column>Sent</th>\n                      <th md-column>Accepted</th>\n                      <th md-column>Revoked</th>\n                      <th md-column></th>\n                      <!-- <th md-column></th> -->\n  				<th md-column></th>\n                  </tr>\n                  <tr md-row>\n                  	<td md-cell nowrap><strong>Team Invites</strong></td>\n                  	<td md-cell>{{vm.selectedUser.counts.invites.sent||0}}</td>\n                  	<td md-cell>{{vm.selectedUser.counts.invites.accepted||0}}</td>\n                  	<td md-cell>{{vm.selectedUser.counts.invites.revoked||0}}</td>\n                  	<td md-cell></td>\n                  	<!-- <td md-cell></td> -->\n                  	<td md-cell></td>\n                  </tr>\n              </thead>\n        </table>\n    </md-table-container>\n");
$templateCache.put("app/adminja-admin/manage-workspaces.tmpl.html","\n<div layout=\"column\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" >\n		<md-content flex layout=\"column\">\n				<h3 class=\"center\">Copy Workspace</h3>\n				<p class=\"center\">Enter the workspaceID and userID for copying.</p>\n				    <div layout=\"row\" layout-align=\"center center\">\n				        <md-input-container>\n				            <label>Workspace to Copy</label>\n				            <input ng-model=\"vm.sourceWorkspaceID\">\n				        </md-input-container>\n				        <md-input-container>\n				            <label>User to Receive Copy</label>\n				            <input ng-model=\"vm.targetUser\">\n				        </md-input-container>\n				        <md-button class=\"md-primary md-raised\" ng-disabled=\"!vm.targetUser || !vm.sourceWorkspaceID\" ng-click=\"vm.copyWorkspace(vm.sourceWorkspaceID, vm.targetUser)\">Copy</md-button>\n				    </div>\n				    <hr>\n				    <div style=\"background-color: #efefef;\" layout=\"column\">\n						<h3 class=\"center\">Copy All Demo Workspaces</h3>\n						<div layout=\"row\" layout-align=\"center center\">\n							<div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n							    <md-input-container>\n							        <label>User to Receive Copy</label>\n							        <input ng-model=\"vm.targetUser\">\n							    </md-input-container>\n							    <md-button class=\"md-primary md-raised\" ng-disabled=\"!vm.targetUser\" ng-click=\"vm.copyDemoWorkspaces(vm.targetUser)\">Copy</md-button>\n							</div>\n							<div flex=\"50\" layout=\"column\" layout-align=\"start center\">\n								<div style=\" padding: 2em; font-size: .85em;\">\n									<h3>Demo Account Workspaces</h3>\n									<p>-KVXwMsIzy9WIa8o9JO5<br>\n									-KVXxgGCgRYZER4YZzhV<br>\n									-KVXygO3cGcw2gB6xeG1<br>\n									-KVc3bpcb3RHGx1LwJQr<br>\n									-KVc4704WD_86nU0Pn2h<br>\n									-LQ4_4KrWma2THUAKqqh<br>\n									-LioI1HRYMrLt5JqSRX_</p>\n								</div>\n							</div>\n						</div>\n					</div>\n					<hr>\n\n					<div ng-repeat=\"tasks in vm.lindasTasks track by $index\">\n						{{task.info.description}}<br>\n						{{task.uid}}\n					</div>\n\n		</md-content>\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/update-changelog.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<div flex=\"25\" layout=\"column\">\n			<md-content flex=\"100\" class=\"md-padding\">\n				<div>\n				       <md-subheader class=\"md-sticky\">Logs</md-subheader>\n				       <div class=\"changelog-item\" ng-repeat=\"log in vm.logs | orderBy: \'-date\' track by $index\" ng-click=\"vm.selectLog(log.uid)\">\n				         <div layout=\"column\" class=\"log-item-{{log.type}}\">\n				         <p class=\"text-center changelog-{{log.type}}\" style=\"margin-bottom: 0;\">{{log.type}}</p>\n				           <h3 style=\"margin-bottom: 0;\">{{log.title}}</h3>\n				           <p style=\"margin-top: 0;\">{{log.date | amDateFormat: \"MMM DD\"}}</p>\n				           <div ng-bind-html=\"log.message\"></div>\n				         </div>\n				       </div>\n				       <md-divider ></md-divider>\n				</div>\n			</md-content>\n		</div>\n		<div flex layout=\"column\">\n			<md-content flex=\"100\" layout-padding>\n			<md-card class=\"changelog-item\">\n				<h3>Log Detail</h3>\n				<form name=\"changeLogForm\">\n				<div layout=\"column\">\n					<md-input-container >\n						<md-datepicker ng-model=\"vm.editedLog.date\" md-placeholder=\"Log Date\"></md-datepicker>\n					</md-input-container>\n					<md-input-container>\n						<md-select flex=\"nogrow\" placeholder=\"Log Type\" ng-model=\"vm.editedLog.type\">\n						    <md-option value=\"new\">\n						        New\n						    </md-option>\n						    <md-option value=\"improvement\">\n						        Improvement\n						    </md-option>\n						    <md-option value=\"fix\">\n						        Fix\n						    </md-option>\n						    <md-option value=\"alert\">\n						        Alert\n						    </md-option>\n						</md-select>\n					</md-input-container>\n					<md-input-container>\n						<label>Log Title</label>\n						<input type=\"text\" ng-model=\"vm.editedLog.title\" placeholder=\"Log Title\">\n					</md-input-container>\n					<md-input-container style=\"border: 4px solid #bbb;\">\n\n					<text-angular style=\"\" name=\"noteEditor\" ng-model=\"vm.editedLog.message\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'p\', \'bold\',\'italics\',\'underline\',\'strikethrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'justifyLeft\', \'justifyCenter\', \'insertLink\', \'insertImage\', \'html\']]\" ></text-angular>\n						<!-- <textarea rows=\"10\" ng-model=\"vm.editedLog.message\" placeholder=\"Log Message\"></textarea> -->\n					</md-input-container>\n					<md-input-container style=\"background-color: #fff; margin-top: 0; margin-bottom: 0;\">\n					  <lk-color-chooser style=\"width: 320px;\" colors=\"vm.clientColors\" selected-color=\"vm.editedLog.color\" ng-model=\"vm.editedLog.color\" ng-click=\"vm.colorChange(vm.changeLogForm);\"></lk-color-chooser>\n					</md-input-container>\n					<md-button ng-if=\"vm.editedLog.uid\" class=\"md-raised md-warn\" ng-click=\"vm.deleteLog(vm.editedLog.uid)\">Delete</md-button>\n					<md-button ng-if=\"vm.editedLog.uid\" class=\"md-raised\" ng-click=\"vm.newLog()\">Cancel</md-button>\n					<md-button ng-if=\"vm.editedLog.uid\" ng-click=\"vm.updateLog(vm.editedLog)\" class=\"md-raised md-accent\">Update</md-button>\n					<md-button ng-if=\"!vm.editedLog.uid\" ng-click=\"vm.saveLog(vm.editedLog)\" class=\"md-raised md-accent\">Save</md-button>\n\n				</div>\n				</form>\n				</md-card>\n			</md-content>\n		</div>\n</div>\n\n\n");
$templateCache.put("app/bry/bry-page.tmpl.html","<md-content class=\"padded-content-page\">\n    <div layout=\"row\" layout-align=\"center center\">\n        <h2 class=\"md-display-3\">BRY</h2>\n    </div>\n\n\n    <h3>Clients</h3>\n    <div style=\"background-color: yellow; padding: 2em;\">\n    [<div ng-repeat=\"client in clients\">{{client | json}}<span ng-if=\"!$last\">,</span></div>]\n    </div>\n    <h3>Tasks</h3>\n    <div style=\"background-color: pink; padding: 2em;\">\n    [<div ng-repeat=\"task in tasks\">{{task | json}}<span ng-if=\"!$last\">,</span></div>]\n    </div>\n  <h3>People</h3>\n  <div style=\"background-color: blue; padding: 2em;\">\n  [<div ng-repeat=\"person in peoples\">{{person | json}}<span ng-if=\"!$last\">,</span></div>]\n</div>\n  <h3>Templates</h3>\n  <div style=\"background-color: green; padding: 2em;\">\n  [<div ng-repeat=\"template in templates\">{{template | json}}<span ng-if=\"!$last\">,</span></div>]\n  </div>\n<!--\n    <div layout=\"column\" class=\"margin-100\" layout-align=\"center\">\n\n              <md-input-container>\n                <label>Title</label>\n                <input ng-model=\"user.title\">\n              </md-input-container>\n              <md-input-container>\n                <label>Email</label>\n                <input ng-model=\"user.email\" type=\"email\">\n              </md-input-container>\n            </div>\n          </md-content>\n          <md-content layout-padding>\n            <div layout=\"column\" class=\"margin-100\" layout-align=\"center\">\n              <form name=\"userForm\">\n                <div layout-gt-xs=\"row\">\n                  <md-input-container class=\"md-block\" flex-gt-xs>\n                    <label>Company (Disabled)</label>\n                    <input ng-model=\"user.company\" disabled>\n                  </md-input-container>\n                  <md-datepicker ng-model=\"user.submissionDate\" md-placeholder=\"Enter date\">\n                  </md-datepicker>\n                </div>\n                <div layout-gt-sm=\"row\">\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>First name</label>\n                    <input ng-model=\"user.firstName\">\n                  </md-input-container>\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Long Last Name That Will Be Truncated And 3 Dots (Ellipsis) Will Appear At The End</label>\n                    <input ng-model=\"theMax\">\n                  </md-input-container>\n                </div>\n                <md-input-container class=\"md-block\">\n                  <label>Address</label>\n                  <input ng-model=\"user.address\">\n                </md-input-container>\n                <md-input-container md-no-float class=\"md-block\">\n                  <input ng-model=\"user.address2\" placeholder=\"Address 2\">\n                </md-input-container>\n                <div layout-gt-sm=\"row\">\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>City</label>\n                    <input ng-model=\"user.city\">\n                  </md-input-container>\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>State</label>\n                    <md-select ng-model=\"user.state\">\n                      <md-option ng-repeat=\"state in states\" value=\"{{state.abbrev}}\">\n                        {{state.abbrev}}\n                      </md-option>\n                    </md-select>\n                  </md-input-container>\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Postal Code</label>\n                    <input name=\"postalCode\" ng-model=\"user.postalCode\" placeholder=\"12345\"\n                           required ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\">\n                    <div ng-messages=\"userForm.postalCode.$error\" role=\"alert\" multiple>\n                      <div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div>\n                      <div ng-message=\"pattern\" class=\"my-message\">That doesn\'t look like a valid postal\n                        code.\n                      </div>\n                      <div ng-message=\"md-maxlength\" class=\"my-message\">\n                        Don\'t use the long version silly...we don\'t need to be that specific...\n                      </div>\n                    </div>\n                  </md-input-container>\n                </div>\n                <md-input-container class=\"md-block\">\n                  <label>Biography</label>\n                  <textarea ng-model=\"user.biography\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus></textarea>\n                </md-input-container>\n              </form>\n            </div>\n\n -->\n</md-content>\n");
$templateCache.put("app/layouts/adminja-menu.tmpl.html","<md-toolbar class=\"sidebar-left-toolbar\" md-theme=\"{{::triSkin.elements.logo}}\">\n    <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" style=\"padding:0;\">\n        <div class=\"sidebar-left-icon\">\n            <img ng-src=\"assets/images/brand/adminja-bug.svg\" alt=\"{{::vm.sidebarInfo.appName}}\">\n        </div>\n\n        <div flex class=\"sidebar-left-title\" ><img class=\"app-logotype\" src=\"assets/images/brand/adminja-logotype-white.svg\"  alt=\"{{::vm.sidebarInfo.appName}}\"></div>\n\n        <md-button class=\"md-icon-button sidebar-left-icon hide-xs hide-sm \" style=\"margin-right: .5em;\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\">\n            <md-icon md-font-icon style=\"font-size: 18px;\" ng-class=\"{ \'zmdi zmdi-chevron-left\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-chevron-right\' : vm.layout.sideMenuSize == \'full\' }\">\n                <md-tooltip md-delay=\"1000\">\n                    Pin/UnPin Menu\n                </md-tooltip>\n            </md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button hide-md hide-lg hide-xl\" style=\"margin-right: .5em; color: #fff;\" ng-click=\"vm.closeSideNav(\'left\')\" aria-label=\"Close side menu\">\n            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 14px;\" >\n                <md-tooltip md-delay=\"1000\">\n                    Close Menu\n                </md-tooltip>\n            </md-icon>\n            Close\n        </md-button>\n\n    </div>\n\n</md-toolbar>\n<!-- <md-divider></md-divider> -->\n<tri-menu md-theme=\"{{triSkin.elements.sidebar}}\" flex layout=\"column\"></tri-menu>\n<!-- <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"end center\" style=\"padding:0;\">\n    <md-button class=\"md-icon-button sidebar-left-icon hide-xs hide-sm hide-md\" style=\"margin-right: .5em;\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\">\n        <md-icon md-font-icon style=\"font-size: 14px; color: #fff;\" ng-class=\"{ \'zmdi zmdi-lock-open\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-lock-outline\' : vm.layout.sideMenuSize == \'full\' }\">\n            <md-tooltip md-delay=\"1000\">\n                Pin/UnPin Menu\n            </md-tooltip>\n        </md-icon>\n    </md-button>\n</div> -->\n<!-- <div class=\"center adminja-mascot-container\" hide show-gt-sm>\n	<img class=\"adminja-mascot\" src=\"/assets/images/brand/adminja-bug-no-hover.svg\">\n    <img src=\"/assets/images/brand/adminja-hover-circle.svg\" width=\"50\" style=\"display:block; margin:0 auto 10px auto;\">\n\n</div> -->\n\n");
$templateCache.put("app/admin-setup/clients/setup-clients.tmpl.html","<div class=\"client-setup\" ng-show=\"vm.user\">\n    <div class=\"padding-20 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n        <!-- <md-button class=\"cancel-profile md-icon-button\" ng-click=\"vm.cancelProfile();\">\n        <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n        </md-button> -->\n        <div class=\"margin-right-20\">\n            <div>\n                <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"100\" style=\"margin-right: 1em;\"/>\n            </div>\n        </div>\n        <div class=\"text-light\">\n            <h1 class=\"md-display-1\" style=\"margin-top: 0;\">Welcome!</h1>\n            <h3 class=\"font-weight-600 margin-bottom-0 margin-top-0 text-light\" ng-show=\"vm.user.profile.firstName\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}} <small ng-show=\"vm.user.profile.position\">{{vm.user.profile.position}}</small></h3>\n            <p class=\"font-weight-400 margin-top-0 text-light\">{{vm.user.email}}</p>\n        </div>\n    </div>\n    <div layout=\"row\" layout-align=\"center start\" layout-fill>\n        <div flex-sm=\"100\" flex-md=\"100\" flex-gt-md=\"60\" layout=\"column\" class=\"md-whiteframe-4dp\">\n            <md-content layout-padding flex style=\"padding-bottom: 60px;\">\n                <div ng-show=\"!vm.hasClients()\">\n                    <p class=\"md-display-1 text-center\" style=\"line-height: 1.25em;\" style=\"font-size: 1.75em;\">Before we get started, <br>we need to setup your first Client</p>\n                    <p class=\"text-center\" style=\"font-size: 12px; line-height: 1em;\">(Hint: You can create a Client Space for yourself, too.)</p>\n                </div>\n                <div ng-show=\"vm.hasClients()\">\n                    <p ng-show=\"vm.canAddNew()\" class=\"md-display-1 text-center\" style=\"font-size: 1.75em;\">Great! Now we have something to work with!</p>\n                    <p ng-show=\"vm.canAddNew()\" class=\"md-display-1 text-center\" style=\"font-size: 1.75em;\"><strong>Want to add some more?</strong></p>\n                    <p ng-show=\"vm.canAddNew()\" class=\"text-center\" style=\"font-size: 12px; line-height: 1em;\"><a ui-sref=\"triangular.dashboard\">No thanks. I\'ll add the rest of my clients later.</a></p>\n                    <p ng-show=\"!vm.canAddNew()\" class=\"md-display-1 text-center\" \">Whoa! You\'ve reached the client limit for your plan.</p>\n                    <p ng-show=\"!vm.canAddNew()\" class=\"text-center\">\n                        <md-button  style=\" padding-left: .5em; padding-right: .5em;\" md-colors=\"\" flex=\"nogrow\" class=\"md-raised md-accent \" ng-click=\"vm.continue();\" aria-label=\"Continue to Adminja\">\n                            Continue to Adminja\n                        </md-button>\n                   </p>\n                </div>\n                <form name=\"vm.clientForm\" ng-show=\"vm.canAddNew()\">\n                    <div class=\"quick-client-form md-whiteframe-4dp\" layout=\"column\" layout-gt-sm=\"row\" style=\"position: relative; margin-left: 1em; margin-right: 1em; padding: 1em; \">\n\n                        <div  flex-gt-sm=\"40\" flex=\"100\" layout=\"column\">\n                            <!-- <p class=\"md-body-2\" style=\"margin-top: 0;\">Details</p> -->\n                            <div layout=\"row\">\n                                 <md-input-container flex=\"40\">\n                                    <label>First Name</label>\n                                    <input name=\"clientfirstname\" id=\"focusfield\" ng-model=\"vm.newClient.profile.firstname\" required>\n                                </md-input-container>\n                                 <md-input-container flex=\"40\">\n                                     <label>Last Name</label>\n                                     <input name=\"clientlastname\" ng-model=\"vm.newClient.profile.lastname\" required>\n                                 </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <md-input-container flex=\"80\">\n                                    <label>Client\'s Primary Email</label>\n                                    <input name=\"clientemail\" ng-model=\"vm.newClient.profile.email\" type=\"email\" required>\n                                </md-input-container>\n                            </div>\n                        </div>\n                        <div flex-gt-sm=\"60\" flex=\"100\" ng-show=\"!vm.showColors\">\n                            <!-- <p class=\"md-body-2\" style=\"margin-top: 0;\">Plan</p> -->\n                            <md-radio-group ng-model=\"vm.newClient.profile.plan.type\" layout=\"row\" style=\"margin-bottom: 1em;\">\n                                <md-radio-button flex=\"none\" value=\"retainer\" aria-label=\"Monthly Retainer\">\n                                  <span style=\"font-size: 12px;\">Monthly Retainer</span>\n                                </md-radio-button>\n                                <md-radio-button flex value=\"hourly\" aria-label=\"Hourly\">\n                                  <span style=\"font-size: 12px;\">Hourly</span>\n                                </md-radio-button>\n                            </md-radio-group>\n                            <div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"vm.newClient.profile.plan.type ==\'retainer\' \">\n                                <div flex=\"40\" layout=\"row\">\n                                    <md-input-container flex >\n                                        <label>Monthly Fee</label>\n                                        <md-icon md-font-icon=\"zmdi zmdi-money\" style=\"color: #666;\"></md-icon>\n                                        <input style=\"min-width: 150px;\" name=\"rate\" type=\"number\" step=\"any\"  maxlength=\"7\" ng-model=\"vm.newClient.profile.plan.cost\" placeholder=\"000.00\">\n                                    </md-input-container>\n                                    <md-input-container flex>\n                                       <label>Hours Allocated</label>\n                                       <input style=\"min-width: 150px;\" name=\"allocated\" type=\"number\" maxlength=\"3\" ng-model=\"vm.newClient.profile.plan.allocated\" placeholder=\"00\">\n                                   </md-input-container>\n                                </div>\n                                <div flex=\"100\">\n                                   <md-input-container flex>\n                                      <label>Cycle day:</label>\n                                      <input style=\"max-width: 100px;\" name=\"start\" type=\"number\" maxlength=\"2\" ng-model=\"vm.newClient.profile.plan.retainerStart\" placeholder=\"01\">\n                                  </md-input-container>\n                                </div>\n                            </div>\n                            <div layout=\"row\" ng-show=\"vm.newClient.profile.plan.type ==\'hourly\'\">\n                                <md-input-container flex=\"40\">\n                                   <label>Hourly Rate</label>\n                                   <md-icon md-font-icon=\"zmdi zmdi-money\" style=\"color: #666;\"></md-icon>\n                                   <input name=\"hourly-rate\" type=\"number\" maxlength=\"3\" ng-model=\"vm.newClient.profile.plan.rate\" placeholder=\"00\">\n                               </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <!-- toggle Colors -->\n                                <div flex=\"10\">\n                                    <div class=\"setupToggleColors\" ng-click=\"vm.toggleColors()\" style=\"border-radius: 30px; display: inline-block; position: relative; top: -7px; margin-right: 1em; background-color: {{vm.newClient.profile.clientColor || \'#aaa\'}}; width: 30px; height: 30px; border: 1px solid #333;\"></div>\n                                </div>\n                                <div flex=\"50\"><span style=\"font-size: 12px;\">Choose a color to identify this client</span></div>\n                                <p class=\"text-right\" flex=\"50\" style=\"margin-bottom:0;\">\n                                    <md-button flex=\"nogrow\" ng-disabled=\"vm.clientForm.$invalid || vm.clientForm.$pristine\"  class=\"md-raised md-primary\"  ng-if=\"vm.canAddNew()\" ng-click=\"vm.addClient(vm.newClient)\" aria-label=\"Add Client\">\n                                    <!-- <md-icon md-font-icon=\"zmdi zmdi-account-add\" style=\"font-size: 16px; color: #fff;\"></md-icon>  -->\n                                    New Space\n                                    </md-button>\n                                </p>\n                            </div>\n                        </div>\n\n                            <md-input-container style=\"background-color: #fff; margin-top: 0; margin-bottom: 0;\" ng-show=\"vm.showColors\">\n                              <lk-color-chooser style=\"width: 320px;\" colors=\"vm.clientColors\" selected-color=\"vm.newClient.profile.clientColor\" ng-model=\"vm.newClient.profile.clientColor\" ng-click=\"vm.colorChange(vm.clientForm);\"></lk-color-chooser>\n                            </md-input-container>\n\n                    </div><!-- // quick-client-form -->\n                </form>\n                <md-divider ng-show=\"vm.hasClients()\"></md-divider>\n            <!-- list of clients that have been added -->\n            <div class=\"clientList\">\n            <div ng-repeat=\"client in vm.clients track by $index\" class=\"\" layout=\"row\" layout-align=\"center center\" style=\"margin-left: .5em; margin-bottom: 2em; padding: 1em; \">\n                <div layout=\"column\" layout-gt-sm=\"row\" flex=\"90\">\n                    <div  flex-gt-sm=\"60\" flex=\"100\" >\n                        <div layout=\"row\">\n                            <div flex=\"20\">\n                                <div style=\"border-radius: 30px;  position: relative; top: 1em; display: inline-block;  background-color: {{client.profile.clientColor || \'#aaa\'}}; width: 30px; height: 30px; border: 1px solid #333;\"></div>\n                            </div>\n                            <div flex=\"80\">\n                                <strong>{{client.profile.firstname}} {{client.profile.lastname}}</strong><br>\n                                {{client.profile.email}}\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex-gt-sm=\"40\" flex=\"100\" layout=\"row\">\n\n                            <div flex=\"50\" flex-gt-sm=\"85\">\n                                    <p ng-show=\"client.profile.plan.type == \'retainer\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 12px;\">\n                                        {{client.profile.plan.allocated}}hr Retainer @ ${{client.profile.plan.cost}}/month<br>\n                                        Renews on the {{client.profile.plan.retainerStart|ordinal}} of every month.\n                                    </p>\n                                    <p ng-show=\"client.profile.plan.type == \'hourly\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 12px;\">\n                                        Hourly rate: ${{client.profile.plan.rate}}\n                                    </p>\n                            </div>\n                            <div flex=\"30\" flex-gt-sm=\"15\" layout-align=\"center center\">\n                                <md-button ng-click=\"vm.deleteClient(client);\">\n                                    <md-icon md-font-icon=\"zmdi zmdi-close\">\n                                    </md-icon>\n                                </md-button>\n                            </div>\n\n                    </div>\n                </div>\n            </div>\n            <md-divider ng-show=\"vm.hasClients()\"></md-divider>\n            </div><!-- end clientList scrolling wrapper -->\n            <!-- add new client form -->\n\n            <p class=\"text-center\" ng-show=\"vm.hasClients() && vm.canAddClients()\">\n                <md-button style=\" padding-left: .5em; padding-right: .5em;\" md-colors=\"\" flex=\"nogrow\" class=\"md-raised md-accent \" ng-click=\"vm.continue();\" aria-label=\"Continue to Adminja\">\n                Continue to Adminja\n                </md-button><br>\n                <span style=\"font-size: 12px;\">Don\'t worry, you can add more clients later.</span>\n            </p>\n\n            </md-content>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/admin-setup/layouts/setup.tmpl.html","<!-- Authentication.tmpl.html -->\n<div class=\"full-height full-image-background mg-bg-01\" ng-class=\"authBackground\" layout=\"row\" layout-fill  style=\"background-repeat: auto;\">\n    <div class=\"animate-wrapper\" flex layout=\"row\">\n        <div  ui-view flex layout=\"column\" style=\"overflow: scroll;\">\n        </div>\n    </div>\n</div>\n\n<!-- mb-bg-39 -->\n");
$templateCache.put("app/admin-setup/profile/setup-profile.tmpl.html","<h3>Profile</h3>\n");
$templateCache.put("app/app-authentication/change-email/change-email.tmpl.html","<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <!-- <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"150\" style=\"margin-top: 2em;\"> -->\n                    <h3>Change Login Email</h3>\n                    <md-divider></md-divider>\n                    <form name=\"change-email\">\n                        <md-input-container class=\"md-block\" md-no-float>\n                            <label for=\"email\" translate>Please enter your new login email address</label>\n                            <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.newEmail\" required/>\n                            <div ng-messages=\"forgot.email.$error\" ng-if=\"forgot.email.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your email address</span></div>\n                                <div ng-message when=\"email\"><span translate>Please enter a valid email address</span></div>\n                            </div>\n                        </md-input-container>\n\n                        <md-button class=\"md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ng-click=\"vm.changeEmail(vm.newEmail)\" ng-disabled=\"change-email.$invalid\" >Change</md-button>\n\n                        <md-button class=\"md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ui-sref=\"authentication.profile\" >Change your mind?</md-button>\n                    </form>\n                </div>\n\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.registration\" >Join Adminja for Free!</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/cancel/cancel.confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n\n                    <h3>Signup Complete!</h3>\n                    <p class=\"center\">\n                        Please look in your email for a request to confirm your email address.\n                        <md-button ui-sref=\"authentication.login\">Login Now</md-button>\n                    </p>\n                </div>\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/cancel/cancel.tmpl.html","\n<div class=\"cancel-whiteframe no-scrollbar\" layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\" style=\"padding-left: 20px; padding-right: 20px;\">\n    <div flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-gt-lg=\"40\" md-whiteframe=\"3\" style=\"background-color: #fff;\" layout=\"column\" layout-align=\"start stretch\">\n        <form name=\"vm.cancelRequestForm\">\n        <h1 ng-if=\"!vm.request.action\" class=\"md-headline center\" >Before you go, maybe we can help?</h1>\n        <div ng-if=\"!vm.request.action\" layout=\"column\" layout-gt-sm=\"row\">\n            <div flex class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'demo\');\" layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Request a Demo\n                </h3>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'support\');\" layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Get Support\n                </h3>\n                <p class=\"md-caption center\">A 1:1 Call</p>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'pause\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Pause Subscription\n                </h3>\n                <p class=\"md-caption center\">For 90 days</p>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-risk\" ng-click=\"vm.selectAction(\'discount\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Request a Discount\n                </h3>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-risk\" ng-click=\"vm.selectAction(\'extend\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Extend your Trial\n                </h3>\n                <p class=\"md-caption center\">For 14 days</p>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-delete\" ng-click=\"vm.selectAction(\'cancel\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Delete Your Account\n                </h3>\n                <p class=\"md-caption center\">But leave us feedback</p>\n            </div>\n        </div>\n        <div layout-fill layout=\"column\" layout-align=\"start stretch\">\n        <!--- forms and confirmations -->\n\n            <div ng-if=\"vm.isSelected(\'demo\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Demo</h2>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We\'d be more than happy to setup a 1:1 demo with you to go over Adminja\'s functionality.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>What area of your workflow would you like to focus on?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay! We got your request!</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Someone will be reaching out to you asap to coordinate a call.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'support\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request 1:1 Support</h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p>We are very sorry if you are having difficulty with Adminja. We’ll do everything we can to try to make things right.</p>\n                                <md-input-container style=\"margin-top: 3em;\">\n                                    <label>What seems to be the trouble?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                                </md-input-container>\n                            </div>\n                        </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay! We got your request for support!</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Someone will be reviewing your issue and reaching out to you ASAP to resolve it.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'pause\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Pause your subscription</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We completely understand if circumstances require you to take a break. Sometimes we can help without limiting your access to Adminja.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>Would you mind sharing your circumstances with us?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your pause request has been submitted. </h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">You should hear back from our team within 1 business day with confirmation.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'discount\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Discount</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We completely understand if finances can sometimes get tight and we will do everything we can to help. </p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>Care to share anything about your situation?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your discount request has been submitted. </h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">You should hear back from our team within 1 business day.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'extend\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Trial Extension</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>Sometimes it takes a little more time to get to know a piece of software well enough to make an investment decision. We’ll try to do everything we can to help.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>How much more time do you need?</label>\n                                <input ng-model=\"vm.request.length\" minlength=\"5\" required>\n                            </md-input-container>\n                            <md-input-container style=\"\">\n                                <label>Reason?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your trial extension request has been submitted. </h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p class=\"center\">You should hear back from our team within 1 business day.</p>\n                            </div>\n                        </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'cancel\')\" flex=\"grow\">\n                <div ng-if=\"!vm.showConfirm\">\n                    <div ng-if=\"!vm.continue\">\n                        <h1 class=\"md-headline center\">\n                            Thanks for giving Adminja a shot.<br>\n                            We’ll be sorry to see you go!\n                        </h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-sm=\"70\">\n                                <p>We really appreciate you taking the the time to give Adminja a try and we hope that we can serve you again sometime in the future.</p>\n                            </div>\n                        </div>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\"  flex-gt-md=\"70\">\n                                <p style=\"margin-bottom:0;\"><strong>After you confirm your cancellation:</strong></p>\n                                <ul style=\"list-style: disc; margin-left: 2em;\">\n                                    <li>Your account will be deleted at the end of your current billing period</li>\n                                    <li>You won’t be charged again</li>\n                                    <li>Any information in your account will be deleted from our backups after 30 days</li>\n                                    <li>This cannot be reversed</li>\n                                </ul>\n                                <p><strong>You are responsible for any charges already incurred.</strong> </p>\n                            </div>\n                        </div>\n                    </div><!-- !vm.continue -->\n\n                    <div ng-if=\"vm.continue\" layout=\"column\" layout-align=\"start stretch\">\n                        <h1 flex class=\"md-headline center\">Help us make Adminja better!</h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p style=\"margin:0 0 1em 0;\">In order to make Adminja better for future users, it really helps us to learn why it wasn\'t a good fit for you.</p>\n                            </div>\n                        </div>\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p><strong>Please indicate why you wish to delete your account:</strong></p>\n                                <md-radio-group flex ng-model=\"vm.request.reason\" required>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Cost\'\" value=\"Cost\">Cost</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Difficulty of use\'\" value=\"Difficulty of use\">Difficulty of use</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Missing functionality\'\" value=\"Missing functionality\">Missing functionality</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Using other product\'\" value=\"Using other product\">Using other product</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Not using it\'\" value=\"Not using it\">Not using it</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Something else\'\" value=\"Something else\">Something else</md-radio-button>\n                                </md-radio-group>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Cost\'\" style=\"margin-top: 3em;\">\n                                    <label>What, in your opinion, would be a fairer price for Adminja?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Difficulty of use\'\" style=\"margin-top: 3em;\">\n                                    <label>Could you shared the area of difficulty?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Missing functionality\'\" style=\"margin-top: 3em;\">\n                                    <label>What features are you looking for that Adminja doesn\'t have?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Using other product\'\" style=\"margin-top: 3em;\">\n                                    <label>What product</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Not using it\'\" style=\"margin-top: 3em;\">\n                                    <label>Would you mind sharing your circumstances with us?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Something else\'\" style=\"margin-top: 3em;\">\n                                    <label>Could you explain?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Thank you! <br>Your cancellation request has been received.</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Your account is scheduled to close at the end of the current billing period. You will receive additional notifications via email when your account cancellation is complete.</p>\n                            <p class=\"center\"><strong>Thank you again for trying Adminja!</strong></p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div><!-- layout-fill container -->\n\n        <p class=\"center\">\n            <md-button class=\"md-accent\" ui-sref=\"authentication.profile\" >\n                <span  ng-if=\"!vm.showConfirm\">Cancel</span>\n                <span ng-if=\"vm.showConfirm\">Continue</span>\n            </md-button>\n            <md-button class=\"md-accent\" ng-if=\"!vm.continue && vm.request.action == \'cancel\'\" ng-click=\"vm.continue = true\">I understand and wish to continue</md-button>\n            <md-button class=\"md-accent\" ng-if=\"vm.request.action && !vm.showConfirm && vm.request.action == \'cancel\' && vm.continue\" ng-click=\"vm.submitRequest()\" ng-disabled=\"vm.cancelRequestForm.$invalid || vm.processing\">Confirm Account Deletion</md-button>\n            <md-button class=\"md-accent\" ng-if=\"vm.request.action && !vm.showConfirm && vm.request.action != \'cancel\'\" ng-click=\"vm.submitRequest()\" ng-disabled=\"vm.cancelRequestForm.$invalid || vm.processing\">Submit Request</md-button>\n        </p>\n        <!-- dev reset for testing -->\n        <!-- <p class=\"right\" ng-if=\"vm.request.action\">\n            <md-button ng-click=\"vm.resetRequest()\">Reset</md-button>\n        </p> -->\n        </form>\n    </div>\n</div>\n\n\n");
$templateCache.put("app/app-authentication/legal/legal.tmpl.html","<div class=\"user-profile\">\n\n\n<div class=\"mb-bg-01 padding-20 padding-top-100 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"cancel-profile md-icon-button\" back-button>\n    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n</md-button>\n    <div class=\"text-light\">\n        <h3 class=\"font-weight-600 margin-bottom-0 text-light\">Terms &amp; Privacy</h3>\n     </div>\n</div>\n\n<div layout=\"row\" class=\"profile\" layout-wrap>\n    <div flex=\"100\" flex-gt-md=\"100\">\n        <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n            <md-tab label=\"Terms & Conditions\">\n                <md-content class=\"md-padding\" layout=\"column\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"90\" flex-lg=\"70\" flex-gt-lg=\"50\">\n                        <!-- <h1>Terms and Conditions</h1> -->\n                        <p>Last updated: December 08, 2016</p>\n                        <p>Please read these Terms and Conditions (\"Terms\", \"Terms and Conditions\") carefully before using the https://www.getadminja.com website and the https://www.adminja.co application (the \"Service\") operated by Openmotive, Inc. (\"us\", \"we\", or \"our\").</p>\n                        <p>Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service.</p>\n                        <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service.</p>\n                        <p class=\"md-headline\">Communications</p>\n                        <p>By creating an Account on our service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</p>\n                        <p class=\"md-headline\">Subscriptions</p>\n                        <p>Some parts of the Service are billed on a subscription basis (\"Subscription(s)\"). You will be billed in advance on a recurring and periodic basis (\"Billing Cycle\"). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.</p>\n                        <p>At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or Openmotive, Inc. cancels it. You may cancel your Subscription renewal either through your online account management page or by contacting Openmotive, Inc. customer support team.</p>\n                        <p>A valid payment method, including credit card, is required to process the payment for your Subscription. You shall provide Openmotive, Inc. with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information. By submitting such payment information, you automatically authorize Openmotive, Inc. to charge all Subscription fees incurred through your account to any such payment instruments.</p>\n                        <p>Should automatic billing fail to occur for any reason, Openmotive, Inc. will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.</p>\n                        <p class=\"md-headline\">Fee Changes</p>\n                        <p>Openmotive, Inc., in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then-current Billing Cycle.</p>\n                        <p>Openmotive, Inc. will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.</p>\n                        <p>Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.</p>\n                        <p class=\"md-headline\">Refunds</p>\n                        <p>Certain refund requests for Subscriptions may be considered by Openmotive, Inc. on a case-by-case basis and granted in sole discretion of Openmotive, Inc..</p>\n                        <p class=\"md-headline\">Content</p>\n                        <p>Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material (\"Content\"). You are responsible for the Content that you post on or through the Service, including its legality, reliability, and appropriateness.</p>\n                        <p>By posting Content on or through the Service, You represent and warrant that: (i) the Content is yours (you own it) and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms, and (ii) that the posting of your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity. We reserve the right to terminate the account of anyone found to be infringing on a copyright.</p>\n                        <p>You retain any and all of your rights to any Content you submit, post or display on or through the Service and you are responsible for protecting those rights. We take no responsibility and assume no liability for Content you or any third party posts on or through the Service. However, by posting Content using the Service you grant us the right and license to use, modify, perform, display, reproduce, and distribute such Content on and through the Service.</p>\n                        <p>Openmotive, Inc. has the right but not the obligation to monitor and edit all Content provided by users.</p>\n                        <p>In addition, Content found on or through this Service are the property of Openmotive, Inc. or used with permission. You may not distribute, modify, transmit, reuse, download, repost, copy, or use said Content, whether in whole or in part, for commercial purposes or for personal gain, without express advance written permission from us.</p>\n                        <p class=\"md-headline\">Accounts</p>\n                        <p>When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service.</p>\n                        <p>You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</p>\n                        <p>You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than you, without appropriate authorization. You may not use as a username any name that is offensive, vulgar or obscene.</p>\n                        <p class=\"md-headline\">Intellectual Property</p>\n                        The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of Openmotive, Inc. and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Openmotive, Inc..</p>\n                        <p class=\"md-headline\">Links To Other Web Sites</p>\n                        <p>Our Service may contain links to third party web sites or services that are not owned or controlled by Openmotive, Inc..</p>\n                        <p>Openmotive, Inc. has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites.</p>\n                        <p>You acknowledge and agree that Openmotive, Inc. shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services.</p>\n                        <p>We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit.</p>\n                        <p class=\"md-headline\">Termination</p>\n                        <p>We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>\n                        <p>If you wish to terminate your account, you may simply discontinue using the Service.</p>\n                        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>\n                        <p class=\"md-headline\">Indemnification</p>\n                        <p>You agree to defend, indemnify and hold harmless Openmotive, Inc. and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney\'s fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password; b) a breach of these Terms, or c) Content posted on the Service.</p>\n                        <p class=\"md-headline\">Limitation Of Liability</p>\n                        <p>In no event shall Openmotive, Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.</p>\n                        <p class=\"md-headline\">Disclaimer</p>\n                        <p>Your use of the Service is at your sole risk. The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.</p>\n                        <p>Openmotive, Inc. its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.</p>\n                        <p class=\"md-headline\">Exclusions</p>\n                        <p>Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you.</p>\n                        <p class=\"md-headline\">Governing Law</p>\n                        <p>These Terms shall be governed and construed in accordance with the laws of Illinois, United States, without regard to its conflict of law provisions.</p>\n                        <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.</p>\n                        <p class=\"md-headline\">Changes</p>\n                        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>\n                        <p>By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.</p>\n                        <p class=\"md-headline\">Contact Us</p>\n                        <p>If you have any questions about these Terms, please contact us.</p>\n\n                        </div>\n                    </div>\n                <div layout=\"row\" layout-align=\"center center\" md-padding>\n                    <md-button class=\"margin-left-0\" ng-click=\"vm.cancelLegal();\">Return</md-button>\n                </div>\n                </md-content>\n            </md-tab>\n         <!--    <md-tab label=\"Team\">\n                <md-content class=\"md-padding\">\n\n                </md-content>\n            </md-tab> -->\n            <md-tab label=\"Privacy Policy\">\n                <md-content class=\"md-padding\" layout=\"column\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"90\" flex-lg=\"70\" flex-gt-lg=\"50\">\n                            <!-- <h1>Privacy Policy</h1> -->\n                            <p>Last updated: December 08, 2016</p>\n                            <p>Openmotive, Inc. (&quot;us&quot;, &quot;we&quot;, or &quot;our&quot;) operates the https://www.getadminja.com website and the https://www.adminja.co application(the &quot;Service&quot;).</p>\n                            <p>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.</p>\n                            <p>We will not use or share your information with anyone except as described in this Privacy Policy.</p>\n                            <p>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible at https://www.getadminja.com</p>\n                            <p class=\"md-headline\">Information Collection And Use</p>\n                            <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address, name, phone number, postal address, other information (&quot;Personal Information&quot;).\n                            We collect this information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/inquiries, servicing your purchase orders, and improving our services.</p>\n                            <p class=\"md-headline\">Log Data</p>\n                            <p>We may also collect information that your browser sends whenever you visit our Service (&quot;Log Data&quot;). This Log Data may include information such as your computer\'s Internet Protocol (&quot;IP&quot;) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>\n                            <p>In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service\'s functionality. These third party service providers have their own privacy policies addressing how they use such information.</p>\n                            <p class=\"md-headline\">Cookies</p>\n                            <p>Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.</p>\n                            <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.</p>\n                            <p>If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.</p>\n                            <p class=\"md-headline\">Do Not Track Disclosure</p>\n                            <p>We support Do Not Track (&quot;DNT&quot;). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</p>\n                            <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>\n                            <p class=\"md-headline\">Service Providers</p>\n                            <p>We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.</p>\n                            <p>These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.</p>\n                            <p class=\"md-headline\">Communications</p>\n                            <p>We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</p>\n                            <p class=\"md-headline\">Compliance With Laws</p>\n                            <p>We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security or integrity of our Service.</p>\n                            <p class=\"md-headline\">Security</p>\n                            <p>The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.</p>\n                            <p>However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.</p>\n                            <p class=\"md-headline\">International Transfer</p>\n                            <p>Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.</p>\n                            <p>If you are located outside United States and choose to provide information to us, please note that we transfer the information, including Personal Information, to United States and process it there.</p>\n                            <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>\n                            <p class=\"md-headline\">Links To Other Sites</p>\n                            <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>\n                            <p>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>\n                            <p class=\"md-headline\">Children\'s Privacy</p>\n                            <p>Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age of 13 (&quot;Children&quot;).</p>\n                            <p>We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.</p>\n                            <p class=\"md-headline\">Changes To This Privacy Policy</p>\n                            <p>This Privacy Policy is effective as of December 08, 2016 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p>\n                            <p>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>\n                            <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</p>\n                            <p class=\"md-headline\">Contact Us</p>\n                            <p>If you have any questions about this Privacy Policy, please contact us.</p>\n\n                        </div>\n                    </div>\n                    <div layout=\"row\" layout-align=\"center center\" md-padding>\n                        <md-button class=\"margin-left-0\" ng-click=\"vm.cancelLegal();\">Return</md-button>\n                    </div>\n                </md-content>\n            </md-tab>\n            <!-- <md-tab label=\"Account\">\n                <md-content class=\"md-padding\">\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.settingsGroups\">\n                            <md-subheader class=\"md-accent\" translate=\"{{::group.name}}\"></md-subheader>\n                            <md-list-item ng-repeat=\"setting in ::group.settings\" layout=\"row\" layout-align=\"space-around center\">\n                                <md-icon md-font-icon=\"{{::setting.icon}}\"></md-icon>\n                                <p translate>{{::setting.title}}</p>\n                                <md-switch class=\"md-secondary\" ng-model=\"setting.enabled\"></md-switch>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                    <md-button class=\"md-raised md-primary margin-left-0\" ng-disabled=\"profile.$invalid\" translate=\"PROFILE.BUTTON\"></md-button>\n                </md-content>\n            </md-tab> -->\n        </md-tabs>\n\n    </div>\n\n</div>\n\n</div>\n");
$templateCache.put("app/app-authentication/layouts/authentication.tmpl.html","<!-- Authentication.tmpl.html -->\n<div class=\"full-image-background\" ng-class=\"authBackground\" layout=\"row\" layout-fill>\n    <div class=\"animate-wrapper\" flex layout=\"row\">\n        <div id=\"ui-login\" class=\"login-frame no-scrollbar\" ui-view flex layout=\"column\" style=\"overflow: scroll;\"></div>\n    </div>\n</div>\n\n<!-- mb-bg-39 -->\n");
$templateCache.put("app/app-authentication/lock/lock.tmpl.html","<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\">\n        <md-card>\n            <md-toolbar class=\"padding-20\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <img ng-src=\"/assets/images/icons/full-logo.svg\" alt=\"{{vm.triSettings.name}}\" style=\"width: 60%;\">\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <h1 class=\"md-headline\">\n                        <span translate>LOCK.TITLE</span> {{vm.user.name}}\n                    </h1>\n                </div>\n            </md-toolbar>\n\n            <md-content class=\"md-padding\">\n                <p class=\"margin-top-20 margin-bottom-20\" translate>LOCK.LOGGED_OUT</p>\n\n                <form name=\"lock\">\n                    <md-input-container class=\"md-block\">\n                        <label for=\"password\" translate>LOCK.PASSWORD.LABEL</label>\n                        <input label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" required/>\n                        <div ng-messages for=\"lock.password.$error\" ng-if=\"lock.password.$dirty\">\n                            <div ng-message when=\"required\"><span translate>LOCK.PASSWORD.PLEASE_ENTER</span></div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\">\n                        <md-button flex href=\"/login\" translate=\"LOCK.LOGOUT\"></md-button>\n                        <md-button flex class=\"md-primary\" ng-click=\"vm.loginClick()\" ng-disabled=\"lock.$invalid\" translate=\"LOCK.LOGIN\"></md-button>\n                    </div>\n                </form>\n            </md-content>\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/login/login.tmpl.html","<!-- login.tmpl.html-->\n<div layout=\"row\" layout-fill layout-align=\"center start\" ng-show=\"vm.showLogin\" style=\"margin-top: 50px;\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\" style=\"max-width: 450px;\">\n        <md-card class=\"md-whiteframe-12dp login-card\" style=\"background-color: #0091ea;\">\n            <md-content >\n                <div layout=\"column\">\n                    <md-button ng-disabled=\"true\" ng-if=\"adminjaEnv == \'staging\'\" class=\"hide-s hide-xs\">\n                        <md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: orange;\"></md-icon>\n                        <span style=\"color: orange;\">Test Server</span>\n                    </md-button>\n                    <div layout=\"column\" layout-align=\"start center\">\n                        <!-- <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" height=\"75\" style=\"margin-top: 30px;\"> -->\n                        <h3>Admin Login</h3>\n                    </div>\n                </div>\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"start center\">\n\n\n\n                    <form ng-if=\"!vm.loggingIn\" name=\"login\" style=\"width: 80%;\">\n                        <md-input-container class=\"md-block\">\n                            <label for=\"email\" translate>email</label>\n                            <input id=\"email\" md-no-asterisk label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required md-autofocus/>\n                            <div ng-messages=\"login.email.$error\" ng-if=\"login.email.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your email address.</span></div>\n                                <!-- <div ng-message when=\"email\"><span translate>Please enter a valid email address.</span></div> -->\n\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" style=\"margin-bottom: 0;\">\n                            <label for=\"password\" translate>password</label>\n                            <input  md-no-asterisk id=\"password\" label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" adminja-enter=\"vm.loginClick()\" required/>\n                            <div ng-messages for=\"login.password.$error\" ng-if=\"login.password.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your password</span></div>\n                            </div>\n                        </md-input-container>\n\n                        <div layout=\"column\" layout-align=\"center end\" style=\"margin-top: -1em;\">\n                                <p  style=\"margin:0; text-align: right;\">\n                                    <a flex style=\"font-size: 12px;\" ui-sref=\"authentication.forgot\" translate=\"Forgot your password?\" aria-label=\"Forgot your password?\">Forgot your Password?</a>\n                                </p>\n                        </div>\n                        <div class=\"message-box fade\" ng-if=\"vm.errorMessage\">\n                            <p class=\"center\" ><span ng-bind-html=\'vm.errorMessage\'></span></p>\n                        </div>\n                        <div layout=\"column\"  layout-gt-sm=\"row\" layout-align=\"center center\" style=\"padding-top: 2em; padding-bottom: 2em;\">\n                            <div flex=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\" style=\"padding-bottom: 1em;\">\n                                <!-- <md-input-container style=\"color: #666; margin: 0; \">\n                                    <md-checkbox style=\"margin-bottom: 0; border-color: #666;\" ng-model=\"rememberMe\" aria-label=\"Remember me\" style=\"width: 12px;\"></md-checkbox> Remember me\n                                    <md-tooltip>\n                                        Stay logged into this computer.\n                                    </md-tooltip>\n                                </md-input-container> -->\n                            </div>\n                            <div flex=\"50\"  flex-order=\"1\" flex-order-gt-sm=\"2\" layout=\'row\' layout-align=\"end center\" style=\"padding-bottom: 1em;\">\n                                <md-button  flex=\"nogrow\" style=\"margin:0 0 0 0; padding: 0 16px 0 16px;\" class=\"md-raised md-accent\"  ng-click=\"vm.loginClick()\" ng-disabled=\"login.$invalid\"  aria-label=\"Log in\">Log in</md-button>\n                            </div>\n                        </div>\n\n                    </form>\n                    <div layout=\"column\"  ng-if=\"vm.loggingIn\" style=\"padding-top: 2em; padding-bottom: 2em;\">\n                        <p class=\"md-subhead text-center\">Loading your dashboard...</p>\n                        <md-progress-linear class=\"md-accent margin-bottom-20\" md-mode=\"indeterminate\"></md-progress-linear>\n                    </div>\n                </div>\n\n            </md-content>\n            <!-- <p class=\"center\"><a style=\"color: #fff;\" href=\"https://www.getadminja.com/pricing\" >Need an account? Join for Free!</a></p> -->\n        </md-card>\n        <!-- <p  class=\"center\" style=\"padding-top:50px;\"><a style=\"color: #fff;\"   href=\"https://www.getadminja.com\" ><md-icon aria-label=\"updating\" md-font-icon=\"fa fa-info-circle\" style=\"padding-right: .5em; color: #fff;\"></md-icon> Learn more about Adminja</a></p> -->\n    </div>\n</div>\n<!-- Analytics for Chargebee Cross-domain tracking-->\n<script>\n  (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n  })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n\n  ga(\'create\', \'UA-78636602-1\', \'auto\');\n  // ga(\'send\', \'pageview\');\n\n</script>\n<script>\nvar _gaq;\nsetTimeout(function(){\n    _gaq = _gaq || [];\n    _gaq.push([\'_setAccount\', \'UA-78636602-1\']);\n    _gaq.push([\'_setDomainName\', \'adminja.co\']);\n    _gaq.push([\'_setAllowLinker\', true]);\n    _gaq.push([\'_trackPageview\']);\n}, 1000);\n\n</script>\n\n");
$templateCache.put("app/app-authentication/profile/profile.tmpl.html","\n<div class=\"user-profile no-scrollbar\" ng-if=\"vm.user\">\n\n<form name=\"vm.profileForm\">\n\n<div class=\"mb-bg-01 no-scrollbar padding-20 padding-top-50 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"cancel-profile md-icon-button\" ng-click=\"vm.cancelProfile();\">\n    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n</md-button>\n    <div class=\"margin-right-20\">\n        <div>\n            <img\n            ngf-select=\"vm.uploadAvatar($files)\"\n            ngf-multiple=\"false\"\n            aria-label=\"upload\"\n            ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"\n            ng-show=\"vm.user.profile.avatar\" src=\"{{vm.user.profile.avatar}}\" class=\"make-round avatar\"  width=\"100\"/>\n\n            <img\n            ngf-select=\"vm.uploadAvatar($files)\"\n            ngf-multiple=\"false\"\n            aria-label=\"upload\"\n            ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"\n            ng-hide=\"vm.user.profile.avatar\" src=\"/assets/images/avatars/generic-avatar.png\" class=\"make-round avatar\"  width=\"100\" />\n            <md-tooltip md-delay=\"50\">\n                Change Photo\n            </md-tooltip>\n        </div>\n    </div>\n    <div class=\"text-light\">\n        <h3 class=\"font-weight-600 margin-bottom-0 text-light\" ng-hide=\"vm.user.profile.firstName\">First name Last name</h3>\n        <h3 class=\"font-weight-600 margin-bottom-0 text-light\" ng-show=\"vm.user.profile.firstName\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}} <small ng-show=\"vm.user.profile.position\">{{vm.user.profile.position}}</small></h3>\n        <p class=\"font-weight-400 margin-top-0 text-light\">{{vm.user.email}}<span ng-if=\"!vm.emailVerified\" style=\"background-color: red; padding: 2px; margin-left: 10px; font-size: 10px;\">Not Verified</span><span ng-if=\"vm.emailVerified\" style=\"background-color: green; padding: 2px; margin-left: 10px; font-size: 10px;\">Verified</span><md-button class=\"md-secondary md-button-small\" ui-sref=\"authentication.change-email\"><md-icon md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 12px; color: #fff;\"></md-icon></md-button>\n</p>\n     </div>\n</div>\n\n<div layout=\"row\" class=\"profile\" layout-wrap>\n    <div flex=\"100\" flex-gt-md=\"100\">\n        <md-content>\n        <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\" md-selected=\"vm.selectedTab\">\n            <md-tab label=\"Basic Info\">\n                <md-content class=\"md-padding\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n                        <md-input-container class=\"md-block\">\n                            <label for=\"name\" >First Name</label>\n                            <input id=\"name\" label=\"name\" name=\"lastname\" type=\"text\" ng-model=\"vm.user.profile.firstName\" required/>\n                            <div ng-messages=\"profile.name.$error\">\n                                <div ng-message when=\"required\"><span >Sorry, but we need to know who you are.</span></div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label for=\"name\" >Last Name</label>\n                            <input id=\"name\" label=\"name\" name=\"firstname\" type=\"text\" ng-model=\"vm.user.profile.lastName\" required/>\n                            <div ng-messages=\"profile.name.$error\">\n                                <div ng-message when=\"required\"><span >Sorry, but we need to know who you are.</span></div>\n                            </div>\n                        </md-input-container>\n                          <md-input-container class=\"md-block\">\n                              <label translate>Country/Region</label>\n                              <md-select name=\"country\" ng-model=\"vm.user.profile.address.country\">\n                                  <md-option value=\"{{country.name}}\" ng-repeat=\"country in vm.countries\">{{country.name}}</md-option>\n                              </md-select>\n                         </md-input-container>\n\n                       <md-input-container class=\"md-block\">\n                            <label>Company</label>\n                            <input name=\"company\" ng-model=\"vm.user.profile.company\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Position</label>\n                            <input name=\"clientposition\" ng-model=\"vm.user.profile.position\">\n                        </md-input-container>\n                       <md-input-container class=\"md-block\">\n                           <label>Website</label>\n                           <input name=\"website\" ng-model=\"vm.user.profile.website\">\n                       </md-input-container>\n                       <md-input-container class=\"md-block\">\n                           <label>Twitter</label>\n                           <input name=\"twitter\" ng-model=\"vm.user.profile.twitter\">\n                       </md-input-container>\n\n                      <!--  <md-input-container>\n                        <md-datepicker  class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.profile.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n                        </md-input-container> -->\n                    </form>\n                    <div layout=\"row\" layout-align=\"center center\" md-padding>\n                        <md-button class=\"md-secondary\" ui-sref=\"authentication.forgot\">Reset Password</md-button>\n                        <md-button ng-show=\"!vm.profileForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Cancel</md-button>\n                        <md-button ng-show=\"vm.profileForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Done</md-button>\n                        <md-button ng-hide=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\" ng-disabled=\"vm.profileForm.$invalid || vm.profileForm.$pristine\" translate=\"Update Profile\">\n\n                        </md-button>\n                        <md-button ng-show=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\">\n                            <md-icon aria-label=\"updating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px; color: #fff;\"></md-icon> Saving\n                        </md-button>\n                    </div>\n                    </div>\n                    </div>\n                </md-content>\n            </md-tab>\n\n\n\n            <md-tab label=\"Business Info\">\n                <md-content class=\"md-padding\">\n                  <form name=\"vm.companyForm\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n\n                         <h3 class=\"md-title text-center\" style=\"font-size: 14px; margin-bottom: 2em;\">Mailing Address</h3>\n                          <md-input-container class=\"md-block\">\n                               <label>Company</label>\n                               <input ng-model=\"vm.user.profile.company\">\n                           </md-input-container>\n                         <md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Street</label>\n                            <input ng-model=\"vm.user.profile.address.street\" style=\"color: #000;\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                          <label>Street 2</label>\n                            <input ng-model=\"vm.user.profile.address.street2\" style=\"color: #000;\">\n                        </md-input-container>\n                       <md-input-container class=\"md-block\">\n                           <label>City or Town</label>\n                           <input ng-model=\"vm.user.profile.address.city\" style=\"color: #000;\">\n                       </md-input-container>\n                       <md-input-container class=\"md-block\">\n                           <label>State or Region</label>\n                           <input ng-model=\"vm.user.profile.address.state\" style=\"color: #000;\">\n                       </md-input-container>\n                       <md-input-container class=\"md-block\">\n                           <label>Postal Code/Zip</label>\n                           <input ng-model=\"vm.user.profile.address.zip\" style=\"color: #000;\">\n                       </md-input-container>\n                        <h3 class=\"md-title text-center\" style=\"font-size: 14px; margin-bottom: 2em; margin-top: 1em;\">Upload Your Logo</h3>\n                       <p class=\"text-center\">\n                        <img\n                        ngf-select=\"vm.uploadLogo($files)\"\n                        ngf-multiple=\"false\"\n                        aria-label=\"upload logo\"\n                        ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n                        ng-hide=\"vm.user.profile.logo\" src=\"http://fpoimg.com/250x100?text=Your%20Logo\" class=\"\"  width=\"250\" />\n\n                        <img\n                        ngf-select=\"vm.uploadLogo($files)\"\n                        ngf-multiple=\"false\"\n                        aria-label=\"upload logo\"\n                        ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n                        ng-show=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\" class=\"\"  width=\"250\"/>\n                        </p>\n                        <p class=\"md-subhead text-center\" style=\"font-size: 10px; margin-bottom: 3em;\">Your logo will be used on invoices and reports. (250 X 100 max) <a ng-if=\"vm.user.profile.logo\" style=\"cursor: pointer;\" ng-click=\"vm.removeLogo()\">Remove</a></p>\n\n                       <md-input-container class=\"md-block\">\n                           <label>Default Invoice Terms</label>\n                           <input ng-model=\"vm.user.profile.invoiceTerms\" style=\"color: #000;\">\n                       </md-input-container>\n                    </form>\n                      <!--  <md-input-container>\n                        <md-datepicker  class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.profile.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n                        </md-input-container> -->\n\n                    <div layout=\"row\" layout-align=\"center center\" md-padding>\n\n                        <md-button ng-show=\"!vm.companyForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Cancel</md-button>\n                        <md-button ng-show=\"vm.companyForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Done</md-button>\n                        <md-button ng-hide=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\" ng-disabled=\"vm.companyForm.$invalid || vm.companyForm.$pristine\" translate=\"Update Profile\">\n\n                        </md-button>\n                        <md-button ng-show=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\">\n                            <md-icon aria-label=\"updating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px; color: #fff;\"></md-icon> Saving\n                        </md-button>\n                    </div>\n                    </div>\n                    </div>\n                </md-content>\n            </md-tab>\n         <!--    <md-tab label=\"Team\">\n                <md-content class=\"md-padding\">\n\n                </md-content>\n            </md-tab> -->\n\n            <md-tab>\n                <md-tab-label>\n                    <span ng-if=\"vm.user.plan.content__subscription__status == \'cancelled\'\">\n                        <md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: red;\">\n                            <md-tooltip md-delay=\"1000\">Please check your subscription!</md-tooltip>\n                        </md-icon>\n                    </span> Account\n                </md-tab-label>\n                <md-tab-body>\n                <md-content class=\"md-padding\">\n                <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                    <div layout=\"column\" flex=\"100\" flex-md=\"100\" flex-lg=\"80\" flex-xl=\"70\" style=\"padding-bottom: 150px;\">\n                        <subscription-manager user=\"vm.user\"></subscription-manager>\n                    </div>\n                </div>\n\n                <p class=\"text-center\">\n                    <br>\n                    <span class=\"md-caption\"><strong>USER ID:</strong> {{vm.user.uid}}</span>\n                </p>\n\n                </md-content>\n            </md-tab-body>\n            </md-tab>\n            <!-- <md-tab label=\"Account\">\n                <md-content class=\"md-padding\">\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.settingsGroups\">\n                            <md-subheader class=\"md-accent\" translate=\"{{::group.name}}\"></md-subheader>\n                            <md-list-item ng-repeat=\"setting in ::group.settings\" layout=\"row\" layout-align=\"space-around center\">\n                                <md-icon md-font-icon=\"{{::setting.icon}}\"></md-icon>\n                                <p translate>{{::setting.title}}</p>\n                                <md-switch class=\"md-secondary\" ng-model=\"setting.enabled\"></md-switch>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                    <md-button class=\"md-raised md-primary margin-left-0\" ng-disabled=\"profile.$invalid\" translate=\"PROFILE.BUTTON\"></md-button>\n                </md-content>\n            </md-tab> -->\n        </md-tabs>\n        </md-content>\n    </div>\n</div>\n</form>\n</div>\n");
$templateCache.put("app/app-authentication/registration/registration.confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n\n                    <h3>Signup Complete!</h3>\n                    <p class=\"center\">\n                        For a smooth experience, please <strong>check your email and confirm your address</strong> before logging in.\n                    </p>\n                    <p class=\"center\">\n                        <md-button ui-sref=\"authentication.login\">Adminja Login</md-button>\n                    </p>\n                </div>\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/registration/registration.tmpl.html","\n<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"100\" flex-lg=\"70\" flex-xl=\"60\" style=\"max-width: 600px;\">\n        <md-card class=\"md-whiteframe-12dp\" >\n\n            <md-content style=\"margin-top: 0em; margin-bottom: 0em;\">\n                <div layout=\"column\" layout-align=\"start center\" style=\"background-color: #0091ea;\">\n                    <!-- <md-button ng-disabled=\"true\" ng-if=\"adminjaEnv == \'staging\'\" class=\"hide-s hide-xs\">\n                        <md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: orange;\"></md-icon>\n                        <span style=\"color: orange;\">Test Server</span>\n                    </md-button> -->\n                    <div flex  class=\"text-center\" style=\"margin-top: 2em; margin-bottom: 1em;\">\n                        <img src=\"/assets/images/brand/adminja-hlogo-white-white.svg\" width=\"300\" style=\"\">\n                        <div ng-if=\"!vm.isInvitationValid\">\n                            <h3 class=\"text-center\" style=\" color: #fff; \" ng-if=\"vm.planID && vm.planID != \'starter-2017b\' && vm.planID != \'starter-2018a\'\">Start your Trial &mdash; it\'s free for 30 days!</h3>\n                            <h3 class=\"text-center\" style=\" color: #fff; \" ng-if=\"!vm.planID || vm.planID == \'starter-2017b\' || vm.planID == \'starter-2018a\'\">Open a Free Starter account</h3>\n                            <!-- <p class=\"text-center\" style=\" color: #fff; margin-top: 0;\">Just fill out a few details to get started</p> -->\n                        </div>\n                        <div ng-if=\"vm.isInvitationValid\">\n                            <h3 class=\"text-center\" style=\" color: #fff;\">Accept Team invite from {{vm.invitation.ownerName}}</h3>\n                            <!-- <p class=\"text-center\" style=\" color: #fff; margin-top: 0;\">Just fill out a few details to get started</p> -->\n                        </div>\n                    </div>\n                </div>\n                <div layout=\"row\">\n                    <div layout=\"column\" flex=\"100\" flex-sm=\"100\" flex-md=\"60\">\n\n                                        <div layout=\"column\" class=\"md-padding\" layout-align=\"start center\">\n                        <!-- Begin Form -->\n                                            <form name=\"login\" flex=\"100\" style=\"width: 100%;\">\n                                                <md-input-container class=\"md-block\">\n                                                    <label>First name</label>\n                                                    <input name=\"firstname\" ng-model=\"vm.user.firstname\" required>\n                                                    <div ng-messages=\"vm.user.firstname.$error\">\n                                                          <div ng-message=\"required\">Oops! Your name is required</div>\n                                                    </div>\n                                                </md-input-container>\n\n                                                <md-input-container class=\"md-block\">\n                                                    <label>Last name</label>\n                                                    <input name=\"lastname\" ng-model=\"vm.user.lastname\" required>\n                                                    <div ng-messages=\"vm.user.lastname.$error\">\n                                                          <div ng-message=\"required\">Oops! Your name is required</div>\n                                                    </div>\n                                                </md-input-container>\n\n                                                <md-input-container ng-if=\"!vm.isInvitationValid\" class=\"md-block\">\n                                                    <label for=\"email\" translate>Email</label>\n                                                    <input  id=\"email\" ng-pattern=\"/^[^[\\]:;|=*?<>/\\\\,]+$/\" md-no-asterisk label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required/>\n                                                    <div ng-messages=\"login.email.$error\" ng-if=\"login.email.$dirty\">\n                                                        <div ng-message when=\"required\"><span translate>Please enter your email address.</span></div>\n                                                        <div ng-message when=\"email\"><span translate>Please enter a valid email address.</span></div>\n                                                        <div ng-message when=\"errorMessage\">{{errorMessage}}</div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container ng-if=\"vm.isInvitationValid\" class=\"md-block\">\n                                                    <label for=\"email\" translate>Email</label>\n                                                        <input ng-disabled=\"true\" type=\"email\" id=\"email\"  name=\"email\" ng-model=\"vm.user.email\"/>\n                                                </md-input-container>\n                                                <md-input-container flex>\n                                                    <label translate>Password</label>\n                                                    <input ng-change=\"vm.checkStrength(vm.user.password)\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" md-maxlength=\"15\" minlength=\"6\" required>\n\n                                                    <div ng-messages=\"accountForm.password.$error\" md-auto-hide=\"false\" ng-show=\"accountForm.password.$touched\">\n                                                        <div ng-message when=\"required\">\n                                                            <span translate>This field is required. Minimum 7 characters.</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container flex ng-if=\"!vm.isInvitationValid\">\n                                                    <label translate>How\'d you hear about Adminja?</label>\n                                                    <input name=\"howHeard\" ng-model=\"vm.user.source\" md-maxlength=\"100\" minlength=\"6\" required>\n                                                </md-input-container>\n                                                <input ng-if=\"vm.isInvitationValid\" type=\"hidden\" ng-model=\"vm.user.source\" value=\"Team invitation\">\n\n                                                <div layout=\"column\" layout-align=\"end center\" style=\"padding-bottom: 2em;\" ng-if=\"vm.planID && vm.planID != \'starter-2017b\'\">\n                                                    <md-button flex style=\"font-size: 1em; padding: .25em 2em .25em 2em;\" class=\"md-raised md-accent\" ng-click=\"vm.registerUser(vm.user)\" ng-disabled=\"login.$invalid\" aria-label=\"Create Account\">Sign Up</md-button>\n                                                    <p class=\"md-caption text-center\">By clicking Continue, you agree to our <a href=\"https://www.getadminja.com/privacy-policy\" target=\"_blank\">privacy policy</a> and <a href=\"https://www.getadminja.com/terms-and-conditions/\" target=\"_blank\">terms and conditions</a>.</p>\n                                                </div>\n                                                <div layout=\"column\" layout-align=\"end center\" style=\"padding-bottom: 2em;\" ng-if=\"!vm.planID || vm.planID == \'starter-2017b\'\">\n                                                    <md-button flex style=\"font-size: 1em; padding: .25em 2em .25em 2em;\" class=\"md-raised md-accent\" ng-click=\"vm.registerUser(vm.user)\" ng-disabled=\"login.$invalid\" aria-label=\"Sign Up!\">Sign Up</md-button>\n                                                    <p class=\"md-caption text-center\">By clicking Sign Up, you agree to our <a href=\"https://www.getadminja.com/privacy-policy\" target=\"_blank\">privacy policy</a> and <a href=\"https://www.getadminja.com/terms-and-conditions/\" target=\"_blank\">terms and conditions</a>.</p>\n                                                </div>\n                                            </form>\n                        <!-- End Form -->\n\n                                    </div>\n                    </div>\n                   <!--  <div ng-if=\"!vm.isInvitationValid\" layout=\"column\" flex=\"auto\" hide-xs hide-sm style=\"background-color: #2c3a5f;\" class=\"md-padding\">\n                        <h3 style=\"color: #fff; font-weight: bold; font-size: 17px; text-align: center;\">Why are so many Virtual Assistants <br>switching to Adminja?</h3>\n                        <ul class=\"check-bullets\">\n                            <li>They are saving time with their Client information, Tasks, Time and Billing safe and secure under <b>ONE LOGIN</b>.</li>\n                            <li>Many aspects of their businesses run on Auto-pilot with Adminja\'s <b>Recurring Tasks</b>.</li>\n                            <li>Real-time <b>Client Summaries</b> keep them on top of things at all times.</li>\n                            <li>Auto-renewing <b>Client Retainers</b> make their retainer and invoice management a cinch.</li>\n                            <li>Adminja\'s <b>Help Desk</b> is responsive to their issues and implements many of their feature requests.</li>\n                        </ul>\n\n                    </div> -->\n                </div>\n\n            </md-content>\n            <p  class=\"center\" ng-if=\"!vm.planID\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p>\n        </md-card>\n        <p  class=\"center\" style=\"padding-top:50px;\"><a style=\"color: #fff;\"  href=\"https://www.getadminja.com\" ><md-icon aria-label=\"updating\" md-font-icon=\"fa fa-info-circle\" style=\"padding-right: .5em; color: #fff;\"></md-icon> Learn more about Adminja</a></p>\n    </div>\n\n</div>\n\n\n");
$templateCache.put("app/app-authentication/subscription-confirmation/subscription-confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div class=\"cancel-whiteframe no-scrollbar\" layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\" style=\"padding-left: 20px; padding-right: 20px;\">\n    <div flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-gt-lg=\"40\" md-whiteframe=\"3\" style=\" background-color: #fff;\" layout=\"column\" layout-align=\"start stretch\">\n\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n\n                    <h3>Subscription Complete!</h3>\n                    <p class=\"center\">\n                        Thank you for updating your payment information!<br>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"vm.returnToAdminja()\">Return to Adminja</md-button>\n                    </p>\n                </div>\n\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/forgot/forgot.tmpl.html","<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <!-- <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"150\" style=\"margin-top: 2em;\"> -->\n                    <h3>Reset password</h3>\n                    <md-divider></md-divider>\n                    <form name=\"forgot\">\n                        <md-input-container class=\"md-block\" md-no-float>\n                            <label for=\"email\" translate>Please enter your email address</label>\n                            <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required/>\n                            <div ng-messages=\"forgot.email.$error\" ng-if=\"forgot.email.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your email address</span></div>\n                                <div ng-message when=\"email\"><span translate>Please enter a valid email address</span></div>\n                            </div>\n                        </md-input-container>\n\n                        <md-button class=\"md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ng-click=\"vm.resetClick()\" ng-disabled=\"forgot.$invalid\" >Reset</md-button>\n\n                        <md-button class=\"md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ui-sref=\"authentication.login\" >Remember it? Login here!</md-button>\n                    </form>\n                </div>\n\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.registration\" >Join Adminja for Free!</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/client-member-list-item/client-member-list-item.tmpl.html","<md-card ng-click=\"vm.selectTeamMember(vm.member)\" ng-class=\"{\'active\': vm.isMemberSelected(), \'md-whiteframe-20dp\' : vm.isMemberSelected()}\" class=\"team-member-card\" ng-style=\"vm.isMemberSelected() && {\'border-top\':\'8px solid {{vm.member.color}}\'} || {\'border-top\': \'8px solid #bcbcbc\'}\">\n    <div layout=\"row\">\n        <div flex=\"20\" layout=\"row\" layout-align=\"start start\">\n            <img src=\"{{vm.user.profile.avatar}}\" class=\"avatar\">\n        </div>\n        <div flex=\"80\" layout=\"column\">\n            <p class=\"md-headline\" style=\"margin-bottom: 0; margin-top: 8px;\">\n                {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n                <a href=\"mailto:{{vm.member.email}}\">{{vm.user.email}}</a>\n            </p>\n            <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Became a member on {{vm.becameMember}}\n            </p>\n            <p ng-if=\"vm.member.status == \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Invitated on {{vm.invited}}\n            </p>\n        </div>\n\n    </div>\n    <div layout=\"row\" layout-align=\"end center\">\n        <div flex=\"nogrow\">\n            <p class=\"md-subhead member-{{vm.member.status}}\" style=\"font-size: 12px;\">\n                {{vm.member.status}}\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/billing-period/billing-period-card.tmpl.html","<md-card ng-click=\"vm.selectPeriod(vm.period)\" ng-class=\"{\'active\': vm.isSelected(), \'md-whiteframe-20dp\' : vm.isSelected()}\" class=\"billing-period-card\" ng-style=\"vm.isSelected() && {\'border-top\':\'8px solid {{vm.clientColor()}}\'} || {\'border-top\': \'8px solid #bcbcbc\'}\"  style=\"\">\n    <div layout=\"row\">\n        <div flex=\"70\" layout=\"column\">\n            <p class=\"md-headline\" style=\"margin-bottom: 0;\">\n                {{vm.periodLabel()}}\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n                {{vm.period.start | amDateFormat:\'M/D/YY\'}} - {{vm.period.end | amDateFormat:\'M/D/YY\'}}\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                {{vm.period.type}}\n            </p>\n        </div>\n        <div flex=\"30\" layout-align=\"start end\">\n            <p class=\"md-subhead\" style=\"margin-bottom: 0; font-size: 10px;\">\n                Invoiced\n            </p>\n            <p class=\"md-title cost\" style=\"margin-top:0;\">{{vm.currency}}{{vm.period.total || 0 | number: 2 }}</p>\n\n        </div>\n\n    </div>\n    <div layout=\"row\">\n        <div flex=\"50\">\n            <p class=\"md-subhead\" style=\"font-size: 12px;\"  ng-if=\"vm.period.type ==\'hourly\'\">\n                <strong>Logged:</strong> {{vm.used() | number: 2}}hrs<br>\n                <strong>Rate:</strong> {{vm.currency}}{{vm.period.rate | number: 2}}<br>\n                <strong>Earned:</strong> {{vm.currency}}{{vm.used() * vm.period.rate | number: 2}}\n            </p>\n            <p class=\"md-subhead\" style=\"font-size: 12px;\" ng-if=\"vm.period.type ==\'retainer\'\">\n                <strong>Logged:</strong> <span class=\"{{vm.retainerStatusClass()}}\">{{vm.used()|number: 2}}hrs</span><br>\n                <strong>Allocated:</strong> {{vm.period.allocated}}hrs\n            </p>\n        </div>\n        <div flex=\"50\" layout=\"column\" layout-align=\"start end\">\n            <p class=\"md-subhead\" style=\"font-size: 12px;\">\n<!--                 <strong>Invoiced:</strong> {{vm.currency}}{{vm.period.total || 0  | number: 2}}<br>\n -->                <strong>Payments:</strong> {{vm.currency}}{{vm.period.received || 0  | number: 2}}<br>\n                <strong>Balance:</strong> {{vm.currency}}{{vm.period.open || 0 | number: 2}}\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/client-directives/client-card.tmpl.html","<md-card  class=\"client-card md-whiteframe-2dp drag-handle clicked-{{client.clicked}}\" flex=\"1\" uid=\"{{client.uid}}\" layout-align=\"start\" layout=\"column\" style=\" cursor: move; background-color: #fff; border-top: 16px solid {{client.profile.clientColor}};\">\n    <!-- <div class=\"drag-handle\">\n        <md-icon md-font-icon=\"fa fa-reorder\" class=\"drag-handle\">\n        </md-icon>\n    </div> -->\n    <md-menu class=\"client-controls\" md-position-mode=\"target-right target\">\n        <!-- Trigger element is a md-button with an icon -->\n        <md-icon ng-Click=\"$mdMenu.open($event)\" aria-label=\"{{detail.type}} Options\" md-font-icon=\"zmdi zmdi-caret-down\">\n            <md-tooltip md-delay=\"1000\">Client Options</md-tooltip></md-icon>\n        <md-menu-content>\n            <md-menu-item>\n                <md-button ng-click=\"editClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-client\">\n                    </md-icon>Edit {{client.profile.fullName}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"viewClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-collection-item\" class=\"button-view-client\">\n                    </md-icon>Go to this Workspace\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"archiveClient(client, $event)\" aria-label=\"Archive\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"fa fa-archive\" class=\"button-view-client\">\n                    </md-icon>Archive this Space\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"archiveAndDeleteClient(client, $event)\" aria-label=\"Archive\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"fa fa-archive\" class=\"button-view-client\">\n                    </md-icon>Archive and Delete\n                </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"user.type == \'admin\'\">\n                <a class=\"md-button\" ng-href=\"https://console.firebase.google.com/project/adminja-staging/database/data/clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                    View Data\n                </a>\n            </md-menu-item>\n\n        </md-menu-content>\n    </md-menu>\n    <md-card-title ng-click=\"editClient(client)\" flex=\"none\">\n\n        <md-card-title-text>\n            <!-- if we have fullName, then show it, otherwise, first and last. This lets us grandfather in existing clients without error -->\n            <span class=\"md-title\" ng-show=\"!client.profile.fullName\" >{{client.profile.firstname}} {{client.profile.lastname}}</span>\n            <!-- display the client\'s fullName -->\n            <span class=\"md-title\" ng-show=\"client.profile.fullName\">{{client.profile.fullName}}</span>\n            <!-- if this is a business, display the primary user\'s name -->\n            <span class=\"md-subhead\" ng-show=\"client.profile.isCompany\" >{{client.profile.firstname}} {{client.profile.lastname}}</span>\n\n            <span ng-if=\"client.profile.position\" class=\"md-subhead\">{{client.profile.position}} <br><a target=\"_blank\" href=\"{{client.profile.companyurl}}\">{{client.profile.company}}</a></span>\n\n        </md-card-title-text>\n        <md-card-title-media>\n            <div class=\"md-media-sm card-media\">\n                <div class=\"client-avatar\" ng-if=\"!client.profile.avatar\" style=\"background-color: {{client.profile.clientColor}}; display:inline-block; width: 75px; height: 75px;\"></div>\n                <img class=\"client-avatar\" ng-if=\"client.profile.avatar\" src=\"{{client.profile.avatar}}\" width=\"100\" height=\"100\" >\n            </div>\n        </md-card-title-media>\n    </md-card-title>\n    <md-card-content flex=\"auto\">\n\n        <p class=\"md-subhead\">\n            <span ng-if=\"client.profile.email\" style=\"border-bottom: 1px solid #bbb;\"><strong>Personal</strong></span><br>\n\n            <span ng-if=\"client.profile.phone\" class=\"md-subhead dont-break-out\"><a href=\"tel:{{client.profile.phone}}\" >{{client.profile.phone}}</a></span><br>\n            <span ng-if=\"client.profile.email\" class=\"md-subhead dont-break-out\"><a href=\"mailto: {{client.profile.email}}\">{{client.profile.email}}</a></span>\n        </p>\n        <p>\n            <span ng-if=\"client.profile.address.street\">{{client.profile.address.street}}</span><br>\n            <span ng-if=\"client.profile.address.city\">{{client.profile.address.city}}</span><span ng-if=\"client.profile.address.state\">, {{client.profile.address.state}}</span> <span ng-if=\"client.profile.address.zip\">{{client.profile.address.zip}}</span>\n        </p>\n        <p><span ng-if=\"client.profile.twitter\"><md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon> <a href=\"{{client.profile.twitter}}\">Twitter</a><br></span>\n            <span ng-if=\"client.profile.facebook\"><md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon> <a href=\"{{client.profile.facebook}}\">Facebook</a><br></span>\n            <span ng-if=\"client.profile.linkedin\"><md-icon md-font-icon=\"zmdi zmdi-linkedin\"></md-icon> <a href=\"{{client.profile.linkedin}}\">LinkedIn</a><br></span>\n            <span ng-if=\"client.profile.instagram\"><md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon> <a href=\"{{client.profile.instagram}}\">Instagram</a><br></span>\n        </p>\n\n\n        <p ng-if=\"client.profile.company && client.status != \'personal\'\">\n            <span class=\"md-subhead\" ng-show=\"client.profile.company || client.profile.companyemail || client.profile.companyphone\" style=\"border-bottom: 1px solid #bbb;\"><strong>Business</strong></span>\n            <br>\n            <span ng-if=\"client.profile.company\" class=\"md-subhead\">{{client.profile.company}}<br></span>\n            <span ng-if=\"client.profile.companyemail\" class=\"md-subhead\" ><a href=\"mailto:{{client.profile.companyemail}}\">{{client.profile.companyemail}}</a><br></span>\n            <span ng-if=\"client.profile.companyphone\" class=\"md-subhead\">p. <a href=\"tel:{{client.profile.companyphone}}\">{{client.profile.companyphone}}</a><br></span>\n            <span ng-if=\"client.profile.companyfax\" class=\"md-subhead\">f. {{client.profile.companyfax}}<br></span>\n            <span ng-if=\"client.profile.companyurl\" class=\"md-subhead\"><a class=\"dont-break-out\" href=\"{{client.profile.companyurl}}\" target=\"_blank\">{{client.profile.companyurl}}</a><br></span>\n\n                <span ng-if=\"client.profile.companyAddress.street\">{{client.profile.companyAddress.street}}</span><br>\n                <span ng-if=\"client.profile.companyAddress.city\">{{client.profile.companyAddress.city}}</span>, <span ng-if=\"client.profile.companyAddress.state\">{{client.profile.companyAddress.state}}</span> <span ng-if=\"client.profile.companyAddress.zip\">{{client.profile.companyAddress.zip}}</span>\n\n        </p>\n        <span ng-if=\"client.profile.address.country\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-globe-alt\" style=\"font-size: 1em;\"></md-icon>{{client.profile.address.country}}</span><br>\n        <span ng-if=\"client.profile.timezone\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 1em;\"></md-icon> {{client.profile.timezone}}</span><br>\n        <span ng-if=\"client.profile.birthday.month\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-cake\" style=\"font-size: 1em;\"></md-icon>{{displayBirthday(client)}}</span>\n        <span ng-if=\"client.profile.birthday.year\">(<small style=\"display:inline;\">{{client.profile.birthday.year}}</small>)</span>\n\n    </md-card-content>\n    <p style=\"padding:0 1em 0 1em; margin-bottom: 0;\" ng-if=\"client.profile.plan.type == \'retainer\'\" class=\"md-caption\"><md-icon md-font-icon=\"zmdi zmdi-refresh\" style=\"font-size: 1.25em; margin-right: 0\"></md-icon>Renews on {{nextRenewal(client) | amDateFormat:\'MMM Do\'}}</p>\n\n    <client-summary-strip  this-client=\"client\" style=\"background-color: {{client.profile.clientColor}}; color: #000;\"></client-summary-strip>\n    <!--   <md-card-actions layout=\"row\" layout-align=\"end center\">\n        <md-button ng-click=\"editClient(client)\">\n            Edit\n        </md-button>\n        <md-button data-ng-show=\"$state.includes(\'triangular.account-page.clients\')\" ng-click=\"viewClient(client)\">\n            View\n        </md-button>\n      </md-card-actions> -->\n\n</md-card>\n");
$templateCache.put("app/app-directives/client-directives/new-client-button.tmpl.html","<div flex class=\"center\">\n    <md-button class=\"md-accent md-raised\" ng-click=\"newClient()\" >\n        + New Workspace\n    </md-button>\n</div>\n\n");
$templateCache.put("app/app-directives/client-summary-strip/client-summary-strip.tmpl.html","<div class=\"app-item-container-client-summary-wrapper\" style=\"background-color: {{client.color}};\">\n<!-- If this is an hourly client -->\n<div ng-show=\"!isPersonalSpace() && vm.type !=\'retainer\' && showSummary()\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary\" >\n    <div flex=\"25\">\n        <div class=\"client-summary-element\" ng-show=\"vm.type != \'retainer\'\">\n            <p class=\"md-caption\">Rate</p>\n            <h3>{{vm.currency}}{{vm.rate}}/<small>hr</small></h3>\n        </div>\n    </div>\n    <div flex=\"25\">\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Logged</p>\n            <h3 ng-bind-html=\"vm.used | HandM\"></h3>\n        </div>\n    </div>\n    <div flex=\"25\">\n        <div class=\"client-summary-element\"  ng-show=\"vm.type != \'retainer\'\">\n            <p class=\"md-caption\">Total</p>\n            <h3>\n                {{vm.currency}}{{vm.total |number:0}}\n            </h3>\n        </div>\n    </div>\n</div>\n<!-- if this is a private space -->\n<div ng-show=\"isPersonalSpace()\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary\" >\n    <div flex=\"25\">\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">&nbsp;</p>\n            <h3>&nbsp;</h3>\n        </div>\n    </div>\n</div>\n<!-- If this is a retainer-based client -->\n<div ng-show=\"!isPersonalSpace() && vm.type ==\'retainer\' && showSummary()\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary\" >\n    <div flex ng-show=\"vm.type == \'retainer\'\">\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Renews</p>\n            <h3>{{vm.renewsIn}}<small>d</small></h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\" ng-show=\"vm.type == \'retainer\'\">\n            <p class=\"md-caption\">Allocated</p>\n            <h3>{{vm.plan * 60 | HandM}}</h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Logged</p>\n            <h3 ng-bind-html=\"vm.used|HandM\"></h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\"  ng-show=\"vm.type == \'retainer\'\">\n            <p class=\"md-caption\"><strong>Remain</strong></p>\n            <h3 ng-class=\"retainerStatus(vm.used, vm.plan*60)\" ng-bind-html=\"vm.remain | HandM\" style=\"font-weight: bold;\"></h3>\n        </div>\n    </div>\n\n</div>\n<div ng-if=\"vm.showProgress && showSummary()\">\n    <!-- <p flex=\"100\" class=\"md-subhead center\" ng-show=\"vm.thisClient.profile.plan.type === \'retainer\'\" style=\"margin-top: 0px; font-size: 12px; color: #666;\">{{vm.progress(vm.used || 0, vm.plan)}}% of plan used</p> -->\n    <md-progress-linear  ng-if=\"vm.thisClient.profile.plan.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'ok\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-primary\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n    <md-progress-linear  ng-if=\"vm.thisClient.profile.plan.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'close\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-accent\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n    <md-progress-linear  ng-if=\"vm.thisClient.profile.plan.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'over\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-warn\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n</div>\n\n</div>\n");
$templateCache.put("app/app-directives/client-team-member-access/client-team-member-access.tmpl.html","<div ng-if=\"vm.isClientOwner\" layout=\"row\" layout-align=\"start center\" style=\"padding-top: .5em; padding-bottom: .5em;\">\n    <div flex=\"10\" style=\"width: 50px; padding:10px 0 0 1em;\">\n        <a ui-sref=\"triangular.client-manager-page.information({clientID: vm.client.uid})\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n            <img class=\"avatar\" src=\"{{vm.client.avatar|| \'/assets/images/avatars/generic-avatar.png\'}}\" style=\"border: 2px solid {{vm.client.clientColor}}; width: 30px; height: 30px;\" >\n        </a>\n    </div>\n    <div flex layout=\"column\" layout-align=\"center start\">\n        <a ui-sref=\"triangular.client-manager-page.information({clientID: vm.client.uid})\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n        <p style=\"font-size: 1em; margin:0;\">{{vm.client.name}}</p>\n        </a>\n    </div>\n\n    <div flex=\"50\">\n        <md-radio-group ng-disabled=\"vm.userID == vm.member.uid || vm.member.status == \'disabled\'\" ng-model=\"vm.clientAccess\" ng-change=\"vm.setMemberAccess(vm.member, vm.clientAccess)\" layout=\"row\" layout-align=\"end center\" style=\"margin-right: 1em;\">\n             <md-radio-button flex value=\"none\" class=\"md-primary\">None </md-radio-button>\n             <md-radio-button flex value=\"member\" class=\"md-accent\"><md-tooltip>Members cannot override task assignments.</md-tooltip>Member </md-radio-button>\n             <md-radio-button flex value=\"admin\" class=\"md-warn\">Admin <md-tooltip>Admins can see client billing and reassign any task to any team member.</md-radio-button>\n         </md-radio-group>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/fab-button/fab-button.tmpl.html","<md-fab-speed-dial ng-cloak md-direction=\"{{vm.fabDirection}}\"  md-open=\"vm.fabStatus\"  ng-class=\"vm.fabAnimation\">\n    <md-fab-trigger >\n        <md-button palette-background=\"green:500\" aria-label=\"Shortcut Menu\" class=\"md-fab\">\n            <md-icon md-svg-src=\"/assets/images/icons/ninja-star.svg\"><md-tooltip md-delay=\"1000\">Ninja Menu</md-tooltip></md-icon>\n        </md-button>\n    </md-fab-trigger>\n    <md-fab-actions>\n        <md-button aria-label=\"New Task\" md-colors=\"{background: \'orange-900\'}\" class=\"md-fab md-accent md-hue-1 md-raised md-mini\" ng-click=\"vm.newTask()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-check-square-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">New Task</md-tooltip></md-icon>\n        </md-button>\n        <md-button aria-label=\"New Batch Tasks\" md-colors=\"{background: \'orange-800\'}\" class=\"md-fab md-accent md-hue-1 md-raised md-mini\" ng-click=\"vm.batchTasks()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-tasks\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">Batch enter tasks</md-tooltip></md-icon>\n        </md-button>\n        <md-button aria-label=\"New Time Entry\" md-colors=\"{background: \'orange-700\'}\"  class=\"md-fab md-accent md-hue-1  md-raised md-mini\" ng-click=\"vm.newTime()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-timer\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">Log Time</md-tooltip></md-icon>\n        </md-button>\n        <md-button aria-label=\"New Space\" md-colors=\"{background: \'orange-600\'}\" class=\"md-fab md-raised md-mini\" ng-click=\"vm.newFabSpace()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-collection-item\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">New Workspace</md-tooltip></md-icon>\n        </md-button>\n\n        <md-button aria-label=\"New Note\" md-colors=\"{background: \'orange-500\'}\" class=\"md-fab md-hue-2 md-raised md-mini\" ng-click=\"vm.newFabDetail(\'note\')\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-file-text-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">New Note</md-tooltip></md-icon>\n        </md-button>\n        <md-button aria-label=\"New Person\" md-colors=\"{background: \'orange-400\'}\" class=\"md-fab md-hue-2  md-raised md-mini\" ng-click=\"vm.newFabDetail(\'person\')\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-account-box-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">New Person</md-tooltip></md-icon>\n        </md-button>\n        <md-button aria-label=\"New Bookmark\" md-colors=\"{background: \'orange-300\'}\" class=\"md-fab md-hue-2  md-raised md-mini\" ng-click=\"vm.newFabDetail(\'url\')\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-bookmark\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"100\">New Bookmark</md-tooltip></md-icon>\n        </md-button>\n\n\n        <!-- <md-button aria-label=\"Send Diagnostics\"class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.launchDiagnostics()\">\n            <md-icon md-font-icon=\"fa fa-medkit\" style=\"color: #fff;\" ><md-tooltip md-direction=\"left\" md-delay=\"400\">Bug Medic</md-tooltip></md-icon>\n        </md-button> -->\n    </md-fab-actions>\n</md-fab-speed-dial>\n\n");
$templateCache.put("app/app-directives/global-timer/global-timer.tmpl.html","<div class=\"globaltimer\" layout=\"column\" layout-align=\"center none\" style=\"padding-left: 1em; padding-right: 1em;\">\n  <div flex=\"1\" class=\"timer-task-title\" style=\"font-size: 10px; padding: .5em 0 0 0; margin:0;\">\n    <md-icon md-font-icon=\"zmdi zmdi-check-circle\" style=\"font-size: 12px; color:#fff!important;\"></md-icon>&nbsp;\n      Coordinate Office Lunch for Next Friday\n  </div>\n  <div flex=\"2\" layout=\"row\" layout-align=\"start center\">\n    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\" padding-right: 1em;\">\n      <!-- Controls -->\n       <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Pause Global timer\"><md-icon md-font-icon=\"zmdi zmdi-pause\"></md-icon></md-button>\n        <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Start Global timer\"><md-icon md-font-icon=\"zmdi zmdi-play\"></md-icon></md-button>\n        <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Stop Global timer\"><md-icon md-font-icon=\"zmdi zmdi-stop\"></md-icon></md-button>\n    </div>\n      <div flex=\"nogrow\" style=\"padding-right: 1em;\">\n        <!-- Timer -->\n        <span class=\"timer-count\">15:32</span>\n      </div>\n      <!-- Task name and budget -->\n      <p flex=\"auto\" style=\"color: #fff; font-size: 10px;\" class=\"timer-task-info\">\n        <span class=\"timer-budget\">Budget: .75hr</span>\n      </p>\n\n      <div flex=\"nogrow\" style=\"padding-left: 2em;\">\n        <!-- Dropdown -->\n        <md-input-container>\n\n               <md-select placeholder=\"Choose client\" ng-model=\"ctrl.userState\">\n                   <md-option  ng-repeat=\"client in clients | orderBy: \'order\' track by client.uid\" value=\"{{client.uid}}\">\n                   {{client.firstname}} {{client.lastname}}\n                 </md-option>\n               </md-select>\n        </md-input-container>\n      </div>\n    </div>\n\n\n\n</div>\n\n");
$templateCache.put("app/app-directives/file-attachments/file-attachments.tmpl.html","<div class=\"attachment-list md-padding\" style=\"padding-top: 5px;\">\n    <div layout=\"row\" layout-align=\"start center\">\n        <p flex=\"50\" class=\"task-budget-label\" style=\"margin:0; padding:0;\">Attachments</p>\n        <div flex=\"50\"\n                        ngf-multiple=\"true\"\n                        ngf-max-files=\"3\"\n                        ngf-max-size=\"5mb\"\n                        ngf-drop=\"uploadFile($files)\"\n                        ngf-drag-over-class=\"\'dragover\'\"\n                        layout=\"row\" layout-align=\"end center\">\n\n                <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-disabled=\"!vm.status\" ng-show=\"!vm.isUploading && vm.counter < 10\"\n                        class=\"md-primary \"\n                        ngf-select=\"uploadFile($files)\"\n                        ngf-multiple=\"true\"\n                        ngf-max-files=\"3\"\n                        ngf-max-size=\"5mb\"\n                        aria-label=\"upload\">\n                    <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon>\n                </md-button>\n                <md-button  flex=\"nogrow\" ng-show=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n                     <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n                        Uploading\n                </md-button>\n\n                <a class=\"md-button md-icon-button\" flex=\"nogrow\" href=\"javascript:;\" lk-google-picker on-picked=\"vm.onPicked(docs)\" on-loaded=\"vm.onLoaded()\" on-cancel=\"vm.onCancel()\">\n                    <md-icon md-font-icon=\"zmdi zmdi-google-drive\"></md-icon>\n                </a>\n                <a class=\"md-button md-icon-button\" flex=\"nogrow\" href=\"javascript:;\" drop-box-picker dbpicker-files=\"vm.files\" counter=\"vm.count\" form=\"vm.form\">\n                    <md-icon md-font-icon=\"fa fa-dropbox\"></md-icon>\n                </a>\n                <div class=\"dropzone text-center\">\n                    <p class=\"center md-subhead\" style=\"margin:0; padding:0;\"><md-icon md-font-icon=\"zmdi zmdi-upload\"></md-icon></p>\n                </div>\n\n        </div>\n    </div>\n    <md-chips ng-model=\"vm.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n        <md-chip-template>\n             <strong>\n                <a ng-if=\"!$chip.source || $chip.source == \'firebaseStorage\'\" href=\"{{$chip.url}}\" download>{{$chip.fileName}}</a>\n                <a ng-if=\"$chip.source == \'googleDrive\'\" href=\"{{$chip.url}}\"  target=\"_blank\">{{$chip.fileName}}</a>\n                <a ng-if=\"$chip.source == \'dropbox\'\" href=\"{{$chip.url}}\" target=\"_blank\">{{$chip.fileName}}</a>\n            </strong>\n        </md-chip-template>\n    </md-chips>\n\n\n</div>\n");
$templateCache.put("app/app-directives/gravatar-image/gravatar-image.tmpl.html","");
$templateCache.put("app/app-directives/note-entry/note-entry.tmpl.html","<md-list-item class=\"md-3-line task-note-item\" ng-if=\"!vm.editMode\">\n    <div class=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\">\n\n        <div flex>\n            <p style=\"white-space: pre-wrap;\" class=\"speech-bubble\" >{{vm.note.body}}</p>\n        </div>\n        <div flex=\"nogrow\" style=\"width: 120px;\" layout=\"column\" layout-align=\"end stretch\">\n                <p flex class=\"md-caption\" style=\"width: 120px; text-align: center;\">\n                <img flex src=\"{{vm.thisMember.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"25\" style=\"border-radius: 50%; border: 2px solid {{vm.thisMember.color}}; margin-right: 1em; top: 5px;\"><br>\n                <span  style=\"font-weight: bold;\">{{vm.thisMember.profile.fullName}}</span><br>\n                <span flex class=\"notedate\" am-time-ago=\"vm.note.date\"></span>\n                <span  ng-if=\"vm.note.notifyClient\">\n                <br>\n                    Client CC\'d\n                </span>\n                </p>\n        </div>\n        <div class=\"card-controls\" class=\"right\" ng-if=\"vm.thisMember.uid == vm.userID\">\n            <md-button ng-click=\"editNote(vm.note)\" style=\"min-width: 50px; width: 50px;\">\n                <md-icon aria-label=\"Edit Note\" md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 12px;\"></md-icon>\n            </md-button>\n        </div>\n        </div>\n    </div>\n</md-list-item>\n<md-list-item class=\"md-3-line task-note-item inline-edit\" ng-if=\"vm.editMode\">\n    <div class=\"md-list-item-text\" layout=\"column\" layout-align=\"center stretch\">\n            <form name=\"noteEntryForm\" novalidate layout=\"column\">\n                <div flex layout=\"column\">\n                    <md-input-container >\n                        <textarea md-autofocus md-maxlength=\"2000\" name=\"editNotebody\" ng-model=\"vm.editNote.body\" placeholder=\"Edit note\"></textarea>\n                    </md-input-container>\n                </div>\n                <!-- normal controls -->\n                <div flex layout=\"row\" ng-show=\"vm.editStatus == \'editing\'\" layout-align=\"end center\" style=\"margin-top: 40px;\">\n                   <div flex=\"nogrow\" class=\"button-label-container\">\n                       <md-button  class=\"md-indigo-theme\" ng-click=\"startDelete(vm.editNote)\">\n                          Delete\n                       </md-button>\n                   </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button  class=\"md-indigo-theme\" ng-click=\"cancelEdit(vm.editNote)\">\n                            Cancel\n                        </md-button>\n                    </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button type=\"submit\" class=\"md-indigo-theme md-primary md-raised\" ng-click=\"updateNote(vm.editNote, vm.task, vm.client)\">\n                            Update\n                        </md-button>\n                    </div>\n                </div>\n                <!-- Delete controls -->\n                <div flex layout=\"row\" ng-show=\"vm.editStatus == \'startdelete\' || vm.editStatus == \'deleting\'\" layout-align=\"end center\" style=\"background-color: pink;\">\n                <p ng-show=\"vm.editStatus ==\'startdelete\'\" class=\'center\"\' style=\"margin:0 auto 0 auto;\">\n                    Permanently delete?\n                </p>\n\n                <md-button ng-show=\"vm.editStatus ==\'startdelete\'\" class=\"md-primary\" ng-click=\"cancelDelete()\">\n                    cancel\n                </md-button>\n\n                <md-button class=\"md-primary\" ng-click=\"deleteNote(vm.editNote, vm.task, vm.client)\">\n                    <span ng-show=\"vm.editStatus == \'startdelete\'\">\n                            Confirm\n                        </span>\n                    <span ng-show=\"vm.editStatus == \'deleting\'\">\n                            <md-icon aria-label=\"Deleting\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px; line-height: 25px;\">\n                            </md-icon>\n                            Please Wait\n                        </span>\n                    <span ng-show=\"vm.editStatus == \'deleted\'\">\n                            <md-icon  aria-label=\"Note Deleted\" md-font-icon=\"zmdi zmdi-check\" style=\"min-width: 12px; width:12px; font-size: 12px;\">\n                            </md-icon> Note Deleted\n                        </span>\n                </md-button>\n                </div>\n            </form>\n\n        <div class=\"card-controls\" flex=\"20\" class=\"right\">\n            <md-button ng-click=\"cancelEdit(note)\" style=\"min-width: 50px; width: 50px;\">\n                <md-icon aria-label=\"Cancel Edit\" md-font-icon=\"zmdi zmdi-caret-up\"></md-icon>\n            </md-button>\n        </div>\n    </div>\n</md-list-item>\n<md-divider></md-divider>\n");
$templateCache.put("app/app-directives/print-time-report/print-time-report.tmpl.html","<div class=\"invoice print-time-report\" style=\"padding:0;\">\n    <div style=\"padding: 1em;\">\n        <div class=\"invoice-header\" layout=\"row\" layout-align=\"start center\">\n            <div flex style=\"padding-right: 2em;\">\n                <img ng-show=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\"  width=\"150\">\n                <p ng-show=\"!vm.user.profile.logo\">\n                    {{vm.user.profile.fullName}}\n                </p>\n            </div>\n            <div flex>\n                <p class=\"md-subhead recipient-address\">\n                    <strong>Time Report for:</strong> {{vm.report.clientName}}<br>\n                    <strong>Period:</strong> {{vm.report.start | amDateFormat: \'MMM DD, YYYY\'}} - {{vm.report.end | amDateFormat: \'MMM DD, YYYY\'}}<br>\n                    <span ng-if=\"vm.report.type == \'hourly\'\">\n                        <strong>Logged:</strong> {{vm.used(vm.report.time) | HandM}}\n                    </span>\n                    <!-- <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.address\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n                    <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.city\" inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>,\n                    <span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.state\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n                    <span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.postal\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n                    <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.country\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span> -->\n                </p>\n                <p class=\"md-subhead\" ></p>\n            </div>\n            <div flex layout=\"column\">\n            <p class=\"md-subhead text-right\" style=\"margin-top: 0; padding-right: 2em;\">\n                {{vm.today | amDateFormat: \'MMM DD, YYYY\'}}<br>&nbsp;<br>\n                <span ng-if=\"vm.report.type == \'retainer\'\">\n                    <strong>Allocated:</strong> {{vm.report.allocated * 60 |HandM}}<br>\n                    <strong>Logged:</strong> {{vm.used() | HandM}}hrs<br>\n                    <strong>Remain:</strong> {{vm.remain() | HandM}}\n                </span>\n                <span ng-if=\"vm.report.type == \'time\'\">\n                    <strong>Logged:</strong> {{vm.used() | HandM}}hrs<br>\n                </span>\n\n                </p>\n            </div>\n        </div><!-- // invoice-header -->\n\n\n    <md-divider></md-divider>\n    <div layout=\'row\' layout-align=\"start start\">\n        <div flex=\"15\">\n            Date\n        </div>\n        <div flex=\"20\" ng-if=\"vm.report.type == \'time\'\">\n            Client\n        </div>\n        <div flex>\n            Member\n        </div>\n        <div flex>\n            Description\n        </div>\n        <div flex=\"15\">\n            Hrs\n        </div>\n        <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n            Rate\n        </div>\n        <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n            Total\n        </div>\n\n       <!--  <div flex=\"10\" hide-for-print>\n        &nbsp;\n        </div> -->\n\n    </div>\n    <md-divider></md-divider>\n    <div ng-repeat=\"entry in vm.report.time | orderBy: [\'logDate\'] track by entry.uid\" layout=\'row\' layout-align=\"start start\">\n\n        <div flex=\"15\">\n            <span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logDate | amDateFormat: \'MMM DD\'}}</span>\n        </div>\n        <div flex=\"20\" ng-if=\"vm.report.type == \'time\'\">\n            <span class=\"md-subhead\">{{entry.clientName}}</span>\n        </div>\n        <div flex>\n            <span class=\"md-subhead\">{{entry.creatorName}}</span>\n        </div>\n        <div flex>\n            <span class=\"md-subhead\" style=\"font-size: 11px;\">\n                <span ng-if=\"entry.taskName\">({{entry.taskName}})</span>\n                {{entry.description}}\n            </span>\n        </div>\n\n        <div flex=\"15\" layout-align=\"center center\">\n           <span class=\"md-subhead\"> {{entry.logged | HandM}}</span>\n\n        </div>\n        <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n            <span class=\"md-subhead\">{{vm.currency}}{{vm.report.rate}}/hr</span>\n        </div>\n        <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n            <span class=\"md-subhead\">{{vm.currency}}{{vm.lineItemTotal(entry) | number: 2}}</span>\n        </div>\n        <!-- <div flex=\"10\" class=\"hide-for-print\">\n            <md-button  style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.removeReportTimeEntry(entry)\" aria-label=\"Delete\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n        </div> -->\n\n\n    </div>\n\n    <div layout=\"row\" ng-if=\"vm.report.type==\'hourly\'\">\n        <md-divider>\n        </md-divider>\n        <div flex=\"85\">\n            &nbsp;\n        </div>\n        <div flex=\"15\">\n            <span class=\"md-subhead\">{{vm.currency}}{{vm.reportTotal() | number: 2}}</span>\n        </div>\n    </div>\n\n    </div>\n    <!-- ///// Invoice Controls -->\n    <div class=\"invoice-controls\" layout=\"row\" style=\"width: 100%; background-color: rgba(240,240,240,1);\" layout-align=\"center center\">\n        <!-- <md-button class=\"\" ng-click=\"vm.downloadInvoice()\">Download</md-button>\n        <md-button class=\"\" ng-click=\"vm.sendInvoice()\">Send</md-button> -->\n        <md-button flex=\"nogrow\" class=\"\" ng-click=\"vm.cancelReport()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n        <md-button ng-click=\"vm.printReport(vm.report)\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon> Request PDF</md-button>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/notification-card/notification-card.tmpl.html","<md-card class=\"notification-list-item\" ng-class=\"{\'viewed\': vm.item.read, \'old\' : isOld(vm.item)}\">\n    <div class=\"notification-header\" layout=\"row\" layout-align=\"start center\">\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'invite\'\" style=\"color: green;\" md-font-icon=\"fa fa-envelope-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'email\'\" style=\"color: green;\" md-font-icon=\"fa fa-envelope-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'thanks\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-favorite\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'tip\'\" style=\"color: blue;\" md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'fix\' || vm.item.type ==\'improvement\'\" style=\"color: orange;\" md-font-icon=\"zmdi zmdi-wrench\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'task\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'taskComplete\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-check-square\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'comment\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: grey;\" md-font-icon=\"zmdi zmdi-comments\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'assignment\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'clientAssignment\'\" ng-click=\"vm.gotoClient(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'recurring\'\" ng-click=\"vm.openTask(vm.item)\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'retainer\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'date\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'alert\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-alert-polygon\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'new\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'pdf\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'flowTrigger\'\"  style=\"color: blue;\" md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n        <img flex=\"nogrow\" ng-if=\"!vm.item.type || vm.item.type == \'general\'\" src=\"/assets/images/brand/adminja-bug.svg\" width=\"15\" style=\"margin-right: 10px;\">\n        <span flex=\"grow\" class=\"notification-meta\">{{vm.item.meta}}</span>\n\n        <md-icon ng-click=\"vm.discardNotification(vm.item)\" class=\"button-discard-notification\" aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-close-circle\" class=\"\">\n            <md-tooltip md-delay=\"1000\">Discard</md-tooltip>\n        </md-icon>\n\n\n    </div>\n    <div class=\"notification-body\">\n        <h3 class=\"notification-title\">{{vm.item.title}}</h3>\n        <p class=\"notification-message\" ng-bind-html=\"vm.sanitizeMe(vm.item.message | limitTo: 200) \"></p>\n        <p class=\"notification-timestamp\"  am-time-ago=\"vm.item.date\"></p>\n    </div>\n    <!-- flowTriger action buttons -->\n    <div class=\"notification-actions\" ng-if=\"vm.item.type == \'flowTrigger\'\" layout=\"row\" layout-align=\"end center\" >\n        <md-button class=\"md-primary\" ng-click=\"vm.showCue(vm.item.related)\">\n             <md-tooltip md-delay=\"1000\">Show Me</md-tooltip>\n                 Show Me\n         </md-button>\n     </div>\n    <!-- Task action buttons -->\n    <div class=\"notification-actions\" ng-if=\"vm.item.type == \'task\' || vm.item.type == \'recurring\' || vm.item.type ==\'assignment\' || vm.item.type ==\'taskComplete\'\" layout=\"row\" layout-align=\"end center\" >\n        <md-button class=\"md-primary\" ng-click=\"vm.openTask(vm.item)\">\n             <md-tooltip md-delay=\"1000\">Open Task</md-tooltip>\n                 Open\n         </md-button>\n     </div>\n      <div class=\"notification-actions\" ng-if=\"vm.item.type == \'comment\'\" layout=\"row\" layout-align=\"end center\">\n         <md-button ng-click=\"vm.openTask(item, 2)\">\n             <md-tooltip md-delay=\"1000\">View Comment</md-tooltip>\n                 View\n         </md-button>\n      </div>\n      <!-- Client assignment -->\n       <div class=\"notification-actions\" ng-if=\"vm.item.type == \'clientAssignment\'\" layout=\"row\" layout-align=\"start center\" >\n             <md-button class=\"\" ng-click=\"vm.refreshClients()\">\n                 Refresh my Client list\n             </md-button>\n\n       </div>\n      <!-- invitation action buttons -->\n       <div class=\"notification-actions\" ng-if=\"vm.item.type == \'invite\'\" layout=\"row\" layout-align=\"start center\" >\n             <md-button class=\"\" ng-click=\"vm.acceptInvite(vm.item)\">\n                 Accept\n             </md-button>\n             <md-button class=\"\" ng-click=\"vm.declineInvite(vm.item)\">\n                  Decline\n             </md-button>\n       </div>\n        <!-- email action buttons -->\n        <div class=\"notification-actions\" ng-if=\"vm.item.type == \'email\'\" layout=\"row\" layout-align=\"end center\" >\n             <md-button class=\"\" ng-click=\"vm.importTask(vm.item)\">\n                 <md-icon aria-label=\"Import task\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                     <md-tooltip md-delay=\"1000\">Import as Task</md-tooltip>\n                     </md-icon>\n                     Task\n             </md-button>\n             <md-button class=\"\" style=\"margin-right: 0;\" ng-click=\"vm.importNote(vm.item)\">\n                 <md-icon aria-label=\"Import note\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                     <md-tooltip md-delay=\"1000\">Import as Note</md-tooltip>\n                     </md-icon> Note\n             </md-button>\n        </div>\n        <!-- pdf action buttons -->\n         <div class=\"notification-actions\" ng-if=\"vm.item.type == \'pdf\'\" layout=\"row\" layout-align=\"end center\">\n                 <md-button ng-href=\"{{vm.item.related}}\" download=\"{{vm.item.related}}\" class=\"\" target=\"_blank\" >\n                     <md-icon aria-label=\"Download PDF\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                         <md-tooltip md-delay=\"1000\">Download PDF</md-tooltip>\n                    </md-icon>\n                    Download PDF\n                 </md-button>\n         </div>\n</md-card>\n");
$templateCache.put("app/app-directives/profile-detail-item/profile-detail-item.tmpl.html","<md-card class=\"app-item info-card info-card-{{::detail.type}}\" ng-style=\"applyBackground(detail)\" panel=\"{{::detail.panel}}\" order=\"{{::detail.order}}\" client=\"{{::detail.client}}\" uid=\"{{::detail.uid}}\">\n    <div class=\"detail-controls detail-handle\">\n    <md-menu  flex=\"nogrow\" md-position-mode=\"target-right target\">\n        <!-- Trigger element is a md-button with an icon -->\n        <md-icon ng-Click=\"$mdMenu.open($event)\" aria-label=\"{{::detail.type}} Options\" md-font-icon=\"zmdi zmdi-caret-down\">\n        <md-tooltip md-delay=\"1000\">{{::detail.type}} Options</md-tooltip></md-icon>\n        <md-menu-content>\n            <md-menu-item>\n                <md-button ng-click=\"editDetail(detail)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-detail\">\n                    </md-icon>Edit {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"copyDetail(detail)\" aria-label=\"Clone\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-detail\">\n                    </md-icon>Clone {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"removeDetail(detail)\" aria-label=\"Delete\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-delete\" class=\"button-edit-detail\">\n\n                    </md-icon>Delete {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <!-- <md-menu-item ng-if=\"detail.panel != panel.uid\" ng-repeat=\"panel in client.panels | toArray | orderBy: \'order\' track by panel.uid\">\n                <md-button ng-click=\"moveToPanel(detail, panel.uid)\" aria-label=\"Move to Panel {{::panel.label}}\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-forward\" class=\"button-move-detail\">\n                    </md-icon>Move to {{::panel.label}}\n                </md-button>\n            </md-menu-item> -->\n        </md-menu-content>\n    </md-menu>\n    </div>\n    <!-- <div class=\"drag-handle\">\n            <md-icon md-font-icon=\"fa fa-reorder\" class=\"detail-handle\">\n            </md-icon>\n    </div> -->\n    <div layout=\"column\" layout-align=\"start start\" class=\"detail-content md-padding\">\n        <!-- Address -->\n        <div flex ng-if=\"detail.type == \'address\'\" layout=\"column\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n            <p>\n                 {{::detail.address1}}\n                <br>\n                <span ng-if=\"detail.address2\">{{::detail.address2}}<br></span>\n                {{::detail.city}}, {{::detail.state}}, {{::detail.zip}}\n                <br> {{::detail.country}}\n            </p>\n            <p ng-if=\"detail.number\" class=\"detail-label\">\n\n                <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{::detail.number}}\">{{::detail.number}}</a>\n                </p>\n        </div>\n        <!-- RichURL -->\n        <div flex ng-if=\"detail.type == \'url\' && !detail.simpleEmbed\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n            <a class=\"embedly-card\" data-card-controls=\"0\" data-card-width=\"320px\" data-card-chrome=\"0\" data-card-branding=\"0\" data-card-type=\"article\" href=\"{{::detail.url}}\"></a>\n            <!-- <p><md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon> <a href=\"{{::detail.url}}\" target=\"_blank\">{{::detail.url}}</a></p> -->\n        </div>\n        <!-- PlainURL -->\n        <div flex ng-if=\"detail.type == \'url\' && detail.simpleEmbed\">\n            <p class=\"detail-label\" ng-click=\"editDetail(detail)\">\n              {{::detail.label}}\n            </p>\n            <p><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <a href=\"{{::detail.url}}\" target=\"_blank\">{{::detail.url}}</a></p>\n        </div>\n        <!-- Email -->\n        <div flex ng-if=\"detail.type == \'email\'\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n            <p><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"{{::detail.address}}\">{{::detail.address}}</a></p>\n        </div>\n        <!-- Phone -->\n        <div flex ng-if=\"detail.type == \'phone\'\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n                <p><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{::detail.number}}\">{{::detail.number}}</a></p>\n        </div>\n        <!-- Note -->\n        <div flex ng-if=\"detail.type == \'note\'\" layout=\"row\" style=\"\">\n            <div ng-bind-html=\"detail.note\" class=\"detail-label dont-break-out\"></div>\n        </div>\n        <!-- Files -->\n        <div flex ng-if=\"detail.type == \'files\'\" layout=\"row\" style=\"\">\n            <p ng-if=\"detail.label\" class=\"detail-label dont-break-out\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n        </div>\n        <!-- Question -->\n        <div ng-if=\"detail.type == \'question\'\" flex class >\n            <p ng-if=\"detail.label\" class=\"detail-label\" ng-click=\"editDetail(detail)\">\n                <strong>{{::detail.label}}</strong>\n            </p>\n            <div class=\"detail-answer\" ng-bind-html=\"detail.a\">\n\n            </div>\n        </div>\n        <!-- Person -->\n        <div ng-if=\"detail.type == \'person\'\" layout=\"column\">\n            <div flex=\"nogrow\">\n                <div style=\"padding-right: 10px;\" >\n                    <div class=\"detail-label\" ng-click=\"editDetail(detail)\" layout=\"row\">\n                        <div flex=\"nogrow\" style=\"padding-right: 1em;\">\n                            <img ng-hide=\"detail.avatar\" src=\"/assets/images/avatars/generic-avatar.png\" width=\"40\" height=\"40\"/>\n                            <img ng-show=\"detail.avatar\" src=\"{{::detail.avatar}}\" width=\"40\" height=\"40\" >\n                        </div>\n                        <div flex>\n\n                            <strong>{{::detail.firstname}} {{::detail.lastname}}</strong>\n                            <small ng-if=\"detail.label\" >\n                                <strong>{{::detail.label}} <span ng-if=\"detail.position\">,{{::detail.position}}</span></strong>\n                            </small>\n                        </div>\n                    </div>\n                    <small ng-if=\"detail.dob\"><br>Birthday: {{::detail.dob | amDateFormat:\'MMM Do YYYY\'}}</small></p>\n\n                    <md-divider ng-if=\"detail.email || detail.phone\"></md-divider>\n                    <span ng-if=\"detail.email\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"mailto:{{::detail.email}}\">{{::detail.email}}</a><br></span>\n                    <span ng-if=\"detail.phone\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"{{::detail.phone}}\">{{::detail.phone}}</a><br></span>\n                    <span ng-if=\"detail.twitter\"><md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon> <a href=\"http://www.twitter.com/{{::detail.twitter}}\">{{::detail.twitter}}</a><br/></span>\n                    <span ng-if=\"detail.facebook\"><md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon> <a href=\"{{::detail.facebook}}\">Facebook</a><br/></span>\n                    <span ng-if=\"detail.linkedin\"><md-icon md-font-icon=\"zmdi zmdi-linkedin\"></md-icon> <a href=\"{{::detail.linkedin}}\">LinkedIn</a><br/></span>\n                    <span ng-if=\"detail.instagram\"><md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon> <a href=\"{{::detail.instagram}}\">Instagram</a><br/></span>\n\n                    <md-divider ng-if=\"detail.company || detail.companyemail || detail.companyphone || detail.website\"></md-divider>\n\n                    <p ng-if=\"detail.company\"><md-icon md-font-icon=\"fa fa-building\" ></md-icon><strong>{{::detail.company}}</strong></p>\n                    <p ng-if=\"detail.position\" style=\"margin-top: 0;\">{{::detail.position}}</p>\n                    <span ng-if=\"detail.companyemail\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"mailto:{{::detail.companyemail}}\">{{::detail.companyemail}}</a><br></span>\n                    <span ng-if=\"detail.companyphone\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"{{::detail.companyphone}}\">{{::detail.companyphone}}</a><br></span>\n                    <span ng-if=\"detail.website\"><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <a href=\"{{::detail.website}}\">Company Website</a></span>\n\n                </div>\n\n\n            </div>\n        </div>\n        <!-- if this detail has a description, display it -->\n        <div flex ng-if=\"detail.description\">\n        	<md-divider></md-divider>\n        	<p ng-bind-html=\"detail.description\"></p>\n        </div>\n        <div ng-if=\"detail.files\" layout=\'column\' layout-align=\"start start\" style=\"margin-top:10px;\">\n            <div layout=\"row\" layout-align=\"start start\" ng-repeat=\"file in detail.files track by $index\" class=\"attachment-grid\" >\n                <div ng-if=\"isImage(file)\" flex=\"nogrow\" style=\"background-color: red;\" style=\"min-width: 50px!important;\">\n                    <a  href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"background-image: url(\'{{file.url}}\'\"></div></a>\n                </div>\n                <div flex=\"auto\" style=\"padding-left: 1em;\">\n                    <md-chips>\n                    <md-chip><div class=\"md-chip-content\"><a href=\"{{file.url}}\" target=\"_new\">{{shortenFilename(file.fileName)}}</a></div></md-chip>\n                    </md-chips>\n                </div>\n            </div>\n        </div>\n    </div>\n<!--         <div ng-if=\"detail.files\" layout=\"column\" layout-align=\"start center\" >\n            <md-chips ng-model=\"detail.files\" name=\"files\" readonly=\"true\" md-removable=\"false\">\n                <md-chip-template ng-if=\"!isImage($chip)\">\n                     <strong>\n                        <a ng-if=\"!$chip.source || $chip.source == \'firebaseStorage\'\" href=\"{{::$chip.url}}\" download>{{::$chip.fileName}}</a>\n                        <a ng-if=\"$chip.source == \'googleDrive\'\" href=\"{{::$chip.url}}\"  target=\"_blank\">{{::$chip.fileName}}</a>\n                        <a ng-if=\"$chip.source == \'dropbox\'\" href=\"{{::$chip.url}}\" target=\"_blank\">{{::$chip.fileName}}</a>\n                    </strong>\n                </md-chip-template>\n            </md-chips>\n            <div flex>\n                <md-icon md-font-icon=\"fa fa-paperclip\" ></md-icon>\n                <span class=\"num-files\">{{::detail.files.length}}</span>\n            </div>\n        </div> -->\n\n</md-card>\n");
$templateCache.put("app/app-directives/profile-panel/new-profile-panel.tmpl.html","<div layout=\"column\" layout-align=\"start center\">\n    <md-button  ng-click=\"newPanel()\" style=\"margin-top: 1em;\">\n        + New Bucket\n    </md-button>\n</div>\n");
$templateCache.put("app/app-directives/profile-panel/profile-panel.tmpl.html","\n    <div class=\"app-item-container-header\" style=\"margin-bottom: 10px;\">\n\n        <div class=\"app-item-container-title panel-drag-handle\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{panel.color}};\">\n                <h3 class=\"panel-drag-handle\">\n                    {{panel.label}}\n                </h3>\n\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n                <md-button class=\"md-icon-button\" ng-click=\"addDetail(\'note\', panel)\" flex=\"nogrow\" style=\"margin:0; width: 25px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff; margin-right: 0;\"\">\n                        <md-tooltip md-delay=\"1000\">New Note</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n                    <!-- Trigger element is a md-button with an icon -->\n                    <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n                        <md-icon md-font-icon=\"zmdi zmdi-caret-down\">\n                            <md-tooltip md-delay=\"1000\">Group Menu</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-menu-content>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'note\', panel)\">\n                                <md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> Note\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'url\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> Bookmark\n                            </md-button>\n                        </md-menu-item>\n                        <!-- <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'files\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-attachment-alt\"></md-icon> Files\n                            </md-button>\n                        </md-menu-item> -->\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'person\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> Person\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'email\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Email\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'phone\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> Phone\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'address\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon> Address\n                            </md-button>\n                        </md-menu-item>\n                        <!-- The following two menu items ONLY appear in custom panels -->\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'question\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-help\"></md-icon> Q&amp;A\n                            </md-button>\n                        </md-menu-item>\n                        <md-divider></md-divider>\n                        <md-menu-item>\n                            <md-button ng-click=\"editPanel(panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit Bucket\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item ng-if=\"panel.label != \'Client Details\'\">\n                            <md-button ng-click=\"deletePanel(panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete Bucket\n                            </md-button>\n                        </md-menu-item>\n                    </md-menu-content>\n                </md-menu>\n            </div>\n        </div>\n        <!-- // end app-item-container-title-bar -->\n    </div>\n    <!-- // end app-item-container-header -->\n\n    <div class=\"app-item-container-items\"\n        client=\"{{panel.client}}\"\n        panelid=\"{{panel.uid}}\"\n        ng-class=\"{\'layout-wrap\': !verticalProfilePanels , \'layout-column\': !verticalProfilePanels, \'vertical-scroll\': verticalProfilePanels}\"\n        layout-align=\"start start\"\n        resize=\"{{verticalProfilePanels}}\"\n        dragula=\'\"drag-profile-detail\"\'\n        dragula-scope=\"$scope\"\n        >\n        <!-- if this is the default/permanent \"Client Details\" panel, include our client\'s personal profile -->\n        <!-- For explanation of this syntax (we only want this function to bind once)\n             http://shuheikagawa.com/blog/2016/04/05/one-time-binding-for-ng-if/-->\n        <div ng-show=\"::!!(showClientCard(panel.label))\">\n            <client-card></client-card>\n        </div>\n        <profile-detail-item ng-repeat=\"detail in panel.details | toArray | orderBy: \'order\' track by detail.uid\" id=\"{{detail.uid}}\"></profile-detail-item>\n\n    </div>\n\n");
$templateCache.put("app/app-directives/sidebar-controls/sidebar-controls.tmpl.html","<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" style=\"height: 100%;\">\n    <md-button flex=\"nogrow\" ng-disabled=\"true\" ng-if=\"adminjaEnv == \'staging\'\" class=\"hide-s\">\n        <md-icon  md-font-icon=\'fa fa-gear\' style=\"color: orange;\"></md-icon> <span style=\"color: orange; text-transform: capitalize;\">{{adminjaEnv}} server</span>\n        <!-- <span style=\"color: orange;\">Test Server</span> -->\n    </md-button>\n    <md-button flex=\"nogrow\" ng-disabled=\"true\" ng-if=\"adminjaEnv != \'staging\'\" class=\"hide-s\">\n        <md-icon  md-font-icon=\'fa fa-gear\' style=\"color: #15A108;\"></md-icon> <span style=\"color: #15A108; text-transform: capitalize;\">{{adminjaEnv}} server</span>\n        <!-- <span style=\"color: orange;\">Test Server</span> -->\n    </md-button>\n\n    <!-- <div flex=\"nogrow\" layout=\"row\" style=\"position: relative;\">\n        <md-button hide-xs hide-sm  ng-if=\"canUseTimer\" ng-disabled=\"!vm.user.timers\" style=\"margin-right:0; \" class=\"md-icon-button\" ng-click=\"toggleNotificationsTab(0)\" aria-label=\"Timer\">\n            <md-icon md-font-icon=\"zmdi zmdi-timer\" ng-class=\"{\'hit-limit\': vm.numTimers() > 9}\">\n                <md-tooltip md-delay=\"2000\">\n                    View Open Timers\n                </md-tooltip>\n            </md-icon>\n        </md-button>\n        <span class=\"badge hide-sm hide-xs\" ng-class=\"{\'hit-limit\': vm.numTimers() > 9}\" ng-if=\"vm.numTimers() > 0 && canUseTimer\">{{vm.numTimers()}}</span>\n         <span class=\"badge hide-sm hide-xs\" ng-if=\"vm.numTimers() > 9\" >!!</span> -->\n    <!-- </div> -->\n    <!-- Inbox menu toggle-->\n    <!-- <div flex=\"nogrow\" class=\"notification-badge messsage-count-{{vm.inboxCount()}}\" style=\"position: relative;\" hide-sm hide-xs>\n        <md-button class=\"md-icon-button\" ng-click=\"toggleNotificationsTab(1); vm.markAllRead()\" aria-label=\"Incoming Tasks\" style=\"margin-right: 0;\">\n            <md-icon ng-if=\"vm.inboxCount() > 0\"  md-font-icon=\"fa fa-bell\"></md-icon>\n            <md-icon ng-if=\"vm.inboxCount() == 0\" md-font-icon=\"fa fa-bell-o\"></md-icon>\n        </md-button>\n        <span class=\"badge hide-sm hide-xs\" ng-if=\"vm.inboxCount() > 0\">{{vm.inboxCount()}}</span>\n\n    </div> -->\n\n    <div flex=\"nogrow\" style=\"margin-right: 0; margin-left: 10px;\">\n        <md-menu>\n            <md-button class=\"md-icon-button\" aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"User Menu\" style=\"margin-left: 0;\">\n                <!-- <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon> -->\n                <img class=\"toolbar-user-avatar\" src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\">\n                <!-- <span style=\"text-transform: none; padding-left: 1em;\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}</span> -->\n            </md-button>\n            <md-menu-content width=\"12\" style=\"padding:0;\">\n\n                <md-menu-item hide-gt-sm>\n                    <md-button ng-if=\"canUseTimer\" style=\"padding-top:0;\" ng-click=\"toggleNotificationsTab(0)\" aria-label=\"Timer\">\n                        <md-icon md-font-icon=\"zmdi zmdi-timer\" style=\"font-size: 15px;\">\n                            <md-tooltip md-delay=\"2000\">\n                                View Open Timers\n                            </md-tooltip>\n                        </md-icon>\n\n                        <span translate=\"Timers\"></span> ({{vm.numTimers()}})\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-gt-sm>\n                    <md-button ng-click=\"toggleNotificationsTab(1)\" aria-label=\"Incoming Tasks\" style=\"padding-top: 0;\">\n                        <md-icon md-font-icon=\"zmdi zmdi-inbox\"></md-icon>\n                        <span translate=\"Incoming Tasks\"></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button ui-sref=\"authentication.profile\" aria-label=\"Account\" style=\"padding-top:0;\">\n                        <img class=\"toolbar-user-avatar\" src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\">\n                        <span style=\"text-transform: none; padding-left: 1em;\">View Profile<!-- {{vm.user.profile.firstName}} {{vm.user.profile.lastName}} --></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button ng-click=\"toggleNotificationsTab(2)\" aria-label=\"Account\" style=\"padding-top:0;\">\n                        <md-icon md-font-icon=\"fa fa-gear\" style=\"font-size: 15px;\"></md-icon>\n                        <span translate=\"Settings\"></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-sm hide-xs>\n                    <md-button ng-click=\"vm.toggleFullScreen(\'right\')\" aria-label=\"Toggle Full Screen\" style=\"padding-top: 0;\">\n                            <md-icon ng-if=\"!vm.isFullScreen\" md-font-icon=\"zmdi zmdi-fullscreen\"></md-icon>\n                            <md-icon ng-if=\"vm.isFullScreen\"  md-font-icon=\"zmdi zmdi-fullscreen-exit\"></md-icon>\n                            <span translate=\"Toggle Fullscreen\">Toggle Fullscreen</span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button ng-click=\"vm.getHelp()\" aria-label=\"Help\">\n                        <md-icon md-font-icon=\"fa fa-life-ring\" style=\"font-size: 15px;\"></md-icon>\n                        <span translate=\"Help\"></span>\n                    </md-button>\n                </md-menu-item>\n                <!-- <md-menu-item>\n                    <md-button ui-sref=\"authentication.legal\" aria-label=\"Terms\" style=\"padding-top:0;\">\n                        <md-icon md-font-icon=\"fa fa-gavel\" style=\"font-size: 15px;\"></md-icon>\n                        <span translate=\"Terms & Privacy\"></span>\n                    </md-button>\n                </md-menu-item> -->\n                <md-menu-item>\n                    <md-button ng-click=\"vm.logout()\" aria-label=\"Log Out\">\n                        <md-icon md-font-icon=\"zmdi zmdi-lock-open\" style=\"font-size: 15px; margin-left: 5px;\"></md-icon>\n                        <span translate=\"Logout\"></span>\n                    </md-button>\n                </md-menu-item>\n                <!-- <md-menu-divider></md-menu-divider> -->\n                <md-menu-item ng-if=\"trial\" style=\"background-color: {{trial.color}}; color: #fff; height: auto!important; max-height: 150px;\">\n                    <md-button style=\"padding-top:0;\"  ng-click=\"vm.showTrialMessage()\" style=\"\">\n                       <!--  <md-icon md-font-icon=\"zmdi zmdi-alert-circle\" style=\"font-size: 15px; color: #fff; margin-right: 0;\">\n                        </md-icon> -->\n\n                        <div ng-if=\"trial.type == \'starter\'\" style=\"display:block; padding: 1em;\">\n                            <p ng-if=\"trial.status != \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your Premium features trial ends in {{trial.daysLeft}} days.</p>\n                            <p ng-if=\"trial.status == \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your Premium feature trial has ended. <br>You still have access to the limited <b>Starter</b> plan.</p>\n                            <p ng-if=\"trial.daysLeft < 10 \" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\"><span style=\"text-decoration: underline;\">Upgrade today</span> to keep all of your workspaces, teams, and billing.</p>\n                        </div>\n\n                        <div ng-if=\"trial.type == \'paid\'\" style=\"display:block; padding: 1em;\">\n                            <p ng-if=\"trial.status != \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your free trial ends in {{trial.daysLeft}} days.</p>\n                            <p ng-if=\"trial.status == \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your premium account has been suspended.<br>You still have access to free <b>Starter</b> plan features and limits.</p>\n                            <p ng-if=\"trial.status == \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\"><a style=\"color: #fff;\" ui-sref=\"authentication.profile\"><b>Visit your profile</b></a> to upgrade to a different plan.</p>\n                        </div>\n\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n\n    </div>\n\n\n</div>\n");
$templateCache.put("app/app-directives/task-item/app-item-task.tmpl.html","<md-card class=\"app-item-task status-{{item.status}} focus-{{item.focus}} clicked-{{item.clicked}}\" >\n    <div class=\"task-badge task-handle\"  style=\"background-color: {{getColor(item.client)}};\">\n\n    </div>\n    <md-card-title>\n        <div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\">\n            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\" ng-show=\"item.status == \'closed\' || item.showComplete\" ng-click=\"toggleCompleted(item)\" style=\"margin:0\">\n                <md-tooltip md-delay=\"1000\">Re-Open</md-tooltip>\n            </md-icon>\n            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\" ng-show=\"item.status != \'closed\' && !item.showComplete\" ng-click=\"toggleCompleted(item)\" style=\"margin:0\">\n                <md-tooltip md-delay=\"1000\">Mark Complete</md-tooltip>\n            </md-icon>\n\n            <md-icon ng-show=\"item.focus === \'today\' && canFocus(item)\"  ng-click=\"toggleToday(item)\" class=\"app-item-focused focused-on\" md-font-icon=\"zmdi zmdi-sun\" style=\"margin:0; font-size: 18px;\" >\n                <md-tooltip md-delay=\"1000\">Remove Today flag</md-tooltip>\n            </md-icon>\n\n\n            <md-icon ng-show=\"item.focus != \'today\' && canFocus(item)\" ng-click=\"toggleToday(item)\"  class=\"app-item-focused focused-off\" md-font-icon=\"zmdi zmdi-sun\" style=\"margin:0; font-size: 18px; color: #aaa;\"  >\n                <md-tooltip md-delay=\"1000\">Flag for Today</md-tooltip>\n            </md-icon>\n\n\n\n\n        </div>\n        <md-card-title-text flex ng-click=\"item.status == \'closed\' || editTask(item)\" md-no-ink=\"true\" class=\"app-item-description\" style=\"padding-right: 1em;\" md-ink-ripple=\"#bbb\">\n            <span class=\"task-title\" class=\"md-truncate\"> {{firstLine(item.description)}}</span>\n            <span class=\"md-caption task-client\">{{clientName(item.client)}}</span>\n            <!-- <span class=\"md-caption task-assignee\">taskID: {{item.refID}}</span> -->\n            <span class=\"md-subhead task-description\" style=\"color: #777\" md-no-ink=\"true\">{{restLines(item.description) | limitTo\n                        : 150 : begin}}</span>\n        </md-card-title-text>\n        <div class=\"card-controls\" flex=\"nogrow\" style=\"padding-right:0;\">\n            <md-menu md-position-mode=\"target-right target\">\n                <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-caret-down\" class=\"app-item-more\"></md-icon>\n                <md-menu-content>\n                    <md-menu-item ng-show=\"item.status != \'closed\'\">\n                        <md-button aria-label=\"Log Time\" ng-click=\"logTime(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> Enter Time\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-show=\"item.status != \'closed\' && vm.canUseTimer\">\n                        <md-button aria-label=\"Log Time\" ng-click=\"startTimer(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-play\"></md-icon> Start Timer\n                        </md-button>\n                    </md-menu-item>\n                    <!--   <md-menu-item ng-show=\"canThisWait(item)\">\n                          <md-button aria-label=\"Wait for ...\" ng-click=\"moveTask(item , \'waiting\')\">\n                              <md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon> Wait for ...\n                          </md-button>\n                      </md-menu-item>\n                      <md-menu-item ng-show=\"item.panel == \'waiting\' && item.status != \'closed\'\">\n                          <md-button aria-label=\"Stop waiting\" ng-click=\"moveTask(item, \'Later\')\">\n                              <md-icon md-font-icon=\"zmdi zmdi-alarm-off\"></md-icon> Stop waiting\n                          </md-button>\n                      </md-menu-item> -->\n                    <md-menu-item ng-show=\"item.panel != \'today\' && item.status != \'closed\'\">\n                        <md-button aria-label=\"Do Today\" ng-click=\"toggleToday(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon> Do Today\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-show=\"item.panel == \'today\' && item.status != \'closed\'\">\n                        <md-button aria-label=\"Do Later\" ng-click=\"toggleToday(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon> Do Later\n                        </md-button>\n                    </md-menu-item>\n\n                    <md-menu-item ng-show=\"item.status != \'closed\'\">\n                        <md-button aria-label=\"Mark Complete\" ng-click=\"toggleCompleted(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark Complete\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-show=\"item.status == \'closed\'\">\n                        <md-button aria-label=\"Re-Open\" ng-click=\"toggleCompleted(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Re-open\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button aria-label=\"Edit\" ng-click=\"editTask(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button aria-label=\"Clone\" ng-click=\"copyTask(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button aria-label=\"Save copy in Library\" ng-click=\"makeTemplate(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Save as a Template\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button aria-label=\"Delete\" ng-click=\"deleteTask(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </md-card-title>\n    <!-- <md-divider></md-divider> -->\n    <md-card-footer class=\"md-primary\">\n        <!-- <div layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\">\n                <md-icon ng-show=\"!vm.runningTimer\" md-font-icon=\"zmdi zmdi-time-interval\" ng-click=\"vm.startTimer(item.client, item.refID)\" style=\"max-width: 70px; width: 68px;\">\n                    <md-tooltip md-delay=\"500\">Start Timer</md-tooltip> Start Timer\n                </md-icon>\n            </div>\n        </div> -->\n        <div layout=\"row\" layout-align=\"end start\">\n            <!-- ALTERNATE NEXT LINE <div flex ng-if=\"item.assignee != vm.userDataService.user.uid\" style=\"padding-left: 10px;\"> -->\n            <div ng-if=\"item.assigneeName\" flex style=\"padding-left: 6px;\">\n                <img src=\"{{item.assigneeAvatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"14\" style=\"border-radius:50%; margin-right: .5em; position: relative; top: 3px; opacity: .7;\">\n                <span class=\"md-caption\" style=\"color: #999;\">{{item.assigneeName}}</span>\n            </div>\n            <div flex=\"nogrow\">\n                <span ng-if=\"item.duedate\">\n                    <label ng-click=\"editTask(item)\" ng-class=\"{ \'close\': isNear(item.duedate, item.status) , \'over\': isDue(item.duedate, item.status) }\">\n                        {{item.duedate| amDateFormat:\'MMM Do\'}}\n                    </label><br>\n                </span>\n                <label >\n                    <span  ng-class=\"{ \'close\': isClose(item.logged, item.budget) , \'over\': isOver(item.logged, item.budget) }\">\n                    {{item.logged| HandM}}\n                    </span>\n                    <span ng-if=\"item.budget\" style=\"color: #aaa;\">\n                     / {{item.budget| HandM}}\n                     </span>\n                    <!-- Budget Alert Icons -->\n                    <!--  <span ng-show=\"isOver(item.logged, item.budget)\">\n                         <md-icon  class=\"over\" md-font-icon=\"zmdi zmdi-alert-circle\">\n                         </md-icon>\n                     </span>\n                     <span ng-show=\"isClose(item.logged, item.budget) && !isOver(item.logged, item.budget)\">\n                         <md-icon  class=\"close\" md-font-icon=\"zmdi zmdi-alert-circle-o\">\n                         </md-icon>\n                     </span> -->\n                     <md-tooltip>\n                        Time Logged / Time Budgeted\n                     </md-tooltip>\n                </label>\n            </div>\n        </div>\n\n\n        <div layout=\"row\" layout-align=\"start center\" class=\"item-footer-controls\">\n            <div flex=\"nogrow\" ng-show=\"item.parentTemplate\">\n                <md-button class=\"md-icon-button\" style=\"margin:0 ; padding: 4px; width: 25px;\">\n                <md-icon class=\"md-icon-button\"  md-font-icon=\"zmdi zmdi-refresh\">\n                    <md-tooltip md-delay=\"1000\">Recurring task</md-tooltip>\n                </md-icon>\n            </md-button>\n            </div>\n            <div flex=\"nogrow\" ng-if=\"item.numChecklistItems > 0\">\n                <md-button  ng-click=\"editTask(item, 1);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-check-all\" >\n                        <md-tooltip md-delay=\"500\">Checklist items</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label ng-click=\"editTask(item, 1);\" class=\"icon-label\">{{item.numCompleteItems || 0}}/{{item.numChecklistItems}}</label>\n            </div>\n\n            <div flex=\"nogrow\" >\n                <md-button  ng-click=\"editTask(item, 2);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-comment-outline\" >\n                        <md-tooltip md-delay=\"500\">Comments</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label ng-show=\"item.numnotes > 0\" class=\"icon-label\">{{item.numnotes}}</label>\n            </div>\n\n            <div flex=\"nogrow\" ng-show=\"item.files\">\n                <md-button ng-click=\"editTask(item);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                <md-icon  md-font-icon=\"zmdi zmdi-attachment\">\n                    <md-tooltip md-delay=\"500\">Attachments</md-tooltip>\n                </md-icon>\n                </md-button>\n                <label class=\"icon-label\"> {{item.files.length}}</label>\n            </div>\n            <div flex  layout=\"row\" layout-align=\"end center\">\n\n                <md-button class=\"md-icon-button\" ng-click=\"editTask(item, 3)\" flex=\"nogrow\" ng-show=\"item.logged > 0\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"  >\n                        <md-tooltip md-delay=\"500\">View Time Logs</md-tooltip>\n                    </md-icon>\n                </div>\n                <div flex=\"nogrow\">\n                    <md-button ng-click=\"logTime(item)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                        <md-icon  md-font-icon=\"zmdi zmdi-plus\" >\n                            <md-tooltip md-delay=\"500\">Log Time Manually</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <!-- <md-icon md-font-icon=\"zmdi zmdi-play\" ng-click=\"startTimer(item)\" style=\"max-width: 16px; width: 16px;\">\n                        <md-tooltip md-delay=\"500\">Add Time Entry</md-tooltip>\n                    </md-icon> -->\n                </div>\n                <div flex=\"nogrow\" ng-if=\"vm.canUseTimer\">\n                    <md-button  ng-if=\"!vm.isTimerRunning(item) && !vm.hasOpenTimers(item)\" ng-click=\"startTimer(item)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                        <md-icon  md-font-icon=\"zmdi zmdi-play\">\n                            <md-tooltip md-delay=\"500\">Start Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button  ng-if=\"!vm.isTimerRunning(item) && vm.hasOpenTimers(item)\"  ng-click=\"resumeTimer(item)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                        <md-icon style=\"color: orange;\" class=\"rotate-90\" md-font-icon=\"zmdi zmdi-eject\" >\n                            <md-tooltip md-delay=\"500\">Resume Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button  ng-if=\"vm.isTimerRunning(item)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                        <md-icon  style=\"color: {{getColor(item.client)}};\" md-font-icon=\"zmdi zmdi-pause\"  ng-click=\"pauseTimer(item)\" >\n                            <md-tooltip md-delay=\"500\">Pause Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n\n                    <!-- <md-icon md-font-icon=\"zmdi zmdi-play\" ng-click=\"startTimer(item)\" style=\"max-width: 16px; width: 16px;\">\n                        <md-tooltip md-delay=\"500\">Add Time Entry</md-tooltip>\n                    </md-icon> -->\n                </div>\n\n\n            </div>\n\n        </div>\n\n    </md-card-footer>\n    <div layout=\"row\" layout-align=\"start start\" layout-wrap style=\"padding-left: 10px;\">\n        <div flex=\"25\" ng-repeat=\"file in item.files track by $index\" ng-if=\"isImage(file)\">\n            <a href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"background-image: url(\'{{file.url}}\');\" style=\"border: none;\"></div></a>\n        </div>\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/task-item/app-item-template.tmpl.html","<md-card class=\"app-item app-item-task app-item-task-template status-{{item.status}} md-whiteframe-4dp\"\n        ng-class=\"{ \'focused\' : item.focused }\"\n\n  >\n     <div layout=\"row\">\n        <div flex=\"80\" layout=\"row\" style=\"padding: .5em;\">\n            <div flex=\"15\">\n              <md-icon  class=\"app-item-checkbox\"\n                        md-font-icon=\"zmdi zmdi-check-square\"\n                        ng-show=\"item.completed\"\n                        ng-click=\"toggleCompleted()\"\n                >\n              </md-icon>\n              <md-icon  class=\"app-item-checkbox\"\n                        md-font-icon=\"zmdi zmdi-square-o\"\n                        ng-show=\"!item.completed\"\n                        ng-click=\"toggleCompleted()\"\n                >\n              </md-icon>\n            </div>\n            <div flex>\n              <h3 class=\"md-title\">{{item.name}}</h3>\n            </div>\n        </div>\n        <div class=\"card-controls\" flex>\n            <md-menu md-position-mode=\"target-right target\">\n                 <!-- Trigger element is a md-button with an icon -->\n                 <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n                 <md-menu-content >\n                   <md-menu-item><md-icon md-font-icon=\"fa fa-edit\">&nbsp; Edit</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"zmdi zmdi-plus\">&nbsp;New task from Template</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"zmdi zmdi-copy\">&nbsp; Duplicate</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"fa fa-trash\">&nbsp; Delete</md-icon></md-menu-item>\n                 </md-menu-content>\n            </md-menu>\n        </div>\n     </div>\n     <md-card-content ng-show=\"item.description\">\n        <p class=\"md-caption\">{{item.description}}<br>&nbsp;</p>\n      <!-- <md-button ng-click=\"toast(\'Hello Watson!\')\">Button</md-button> -->\n      </md-card-content>\n  <div ng-show=\"item.steps\" class=\"item-steps\">\n    <md-divider></md-divider>\n    <h3 class=\"md-caption\" style=\"padding-left: 1em;\">Task Steps</h3>\n    <md-content>\n    <div flex layout=\"row\" ng-repeat=\"step in item.steps\" ng-show=\"item.steps\" class=\"task-step\">\n      <div flex=\"15\"><p>\n              <md-icon  class=\"app-item-step-checkbox\"\n                        md-font-icon=\"zmdi zmdi-check-square\"\n                        ng-show=\"step.completed\"\n                        ng-click=\"toggleStepCompleted()\"\n                >\n              </md-icon>\n              <md-icon  class=\"app-item-step-checkbox\"\n                        md-font-icon=\"zmdi zmdi-square-o\"\n                        ng-show=\"!step.completed\"\n                        ng-click=\"toggleStepCompleted()\"\n                >\n              </md-icon></p>\n      </div>\n      <div flex><p>{{step.name}}<span ng-show=\"step.description\"><br><small>{{step.description}}</small></span></p></div>\n    </div>\n    </md-content>\n    </div>\n     <md-card-footer ng-show=\"item.schedule\" style=\"background-color: #fdd7e2;\">\n            <p class=\"text-center md-caption\">\n                <md-icon md-font-icon=\"fa fa-calendar-o\" style=\"font-size: 12px;\"></md-icon> {{item.schedule}}\n            </p>\n        </div>\n\n     </md-card-footer>\n\n</md-card>\n");
$templateCache.put("app/app-directives/task-item/app-item-time.tmpl.html","  <md-card class=\"app-item app-item-time md-whiteframe-2dp\" style=\"border-left: solid 2px {{item.clientcolor}}!important\">\n    <md-card-content>\n      <div layout=\"row\">\n        <div flex=\"80\">\n          <h3 class=\"md-title app-item-time-client\">{{item.client}}</h3>\n        </div>\n        <div class=\"card-controls\" flex>\n          <md-menu md-position-mode=\"target-right target\">\n             <!-- Trigger element is a md-button with an icon -->\n             <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n             <md-menu-content >\n               <md-menu-item><md-icon md-font-icon=\"fa fa-edit\">&nbsp; Edit</md-icon></md-menu-item>\n               <md-menu-item><md-icon md-font-icon=\"fa fa-trash\">&nbsp; Delete</md-icon></md-menu-item>\n             </md-menu-content>\n            </md-menu>\n          </div>\n      </div>\n      <div layout=\"row\">\n        <p flex class=\"md-caption\">\n          <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> {{item.logged}}\n        </p>\n        <p flex class=\"md-caption app-item-time-category\">\n          {{item.timetype}}\n        </p>\n        <p flex class=\"md-caption\">\n          <md-icon md-font-icon=\"fa fa-calendar-o\"></md-icon>\n          {{item.datelogged}}\n        </p>\n      </div>\n      <div layout=\"row\">\n        <div flex>\n          <p class=\"md-caption app-item-time-description\">{{item.description}}</p>\n        </div>\n      </div>\n     </md-card-content>\n  </md-card>\n");
$templateCache.put("app/app-directives/task-notes/task-notes.tmpl.html","<md-content palette-background=\"white:50\" id=\"noteList\" style=\"max-height: 400px;\">\n    <md-list class=\"md-dense\">\n        <!-- Updates view -->\n        <note-entry ng-repeat=\"note in vm.notes | orderBy: \'date\' track by note.uid\" note=\"{{note}}\" client=\"{{vm.client}}\" task=\"{{vm.task}}\"></note-entry>\n\n    </md-list>\n</md-content>\n<!-- Add Note Form -->\n<div style=\"margin-top: 1em;\">\n    <form name=\"vm.taskNoteForm\" novalidate>\n        <div layout=\"row\" style=\"padding-left: 1em;\">\n            <md-input-container flex=\"auto\" style=\"padding: 1em;\">\n                <textarea id=\"newNoteBody\" adminja-enter=\"addTaskNote(vm.newNote)\" md-autofocus md-maxlength=\"2000\"  name=\"newNotebody\" ng-model=\"vm.newNote.body\" placeholder=\"Comment\"></textarea>\n            </md-input-container>\n        </div>\n        <md-dialog-actions layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\" layout-align=\"start start\">\n            <div flex flex-gt-sm=\"30\" class=\"button-label-container\" ng-if=\"!vm.isSpace()\">\n                <md-button>\n                <md-checkbox ng-if=\"vm.canEmailClient\" ng-model=\"vm.newNote.notifyClient\" aria-label=\"Notify Client\">\n                            CC Client\n                  </md-checkbox>\n                  <md-checkbox ng-if=\"!vm.canEmailClient\" ng-disabled=\"true\" ng-model=\"vm.newNote.notifyClient\" aria-label=\"Notify Client\">\n                              CC Client\n                              <md-tooltip>\n                                Not available on Free plans\n                              </md-tooltip>\n                    </md-checkbox>\n\n                </md-button>\n\n            </div>\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                        Cancel\n                    </md-button>\n\n                </div>\n              <!--   <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button class=\"\" ng-click=\"clearNote()\">\n                        Clear\n                    </md-button>\n                </div> -->\n                <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button ng-disabled=\"!vm.newNote.body\" class=\"md-accent md-raised\" ng-click=\"addTaskNote(vm.newNote)\">\n                        Post\n                    </md-button>\n                    <!-- <label class=\"shortcut\">ctrl + enter</label> -->\n                </div>\n            </div>\n        </md-dialog-actions>\n       <!--  <div layout=\"row\" class=\"fade\" ng-if=\"vm.newNote.body\" style=\"position:relative; top: -2em;\">\n            <div flex=\"nogrow\">\n                <md-input-container>\n                    <md-checkbox ng-disabled=\'true\' ng-model=\"checkboxes.default\" aria-label=\"Default Checkbox\">\n                        CC Client\n                    </md-checkbox>\n                </md-input-container>\n            </div>\n            <div flex=\"nogrow\">\n                <md-input-container>\n                    <md-checkbox ng-disabled=\'true\' ng-model=\"checkboxes.default\" aria-label=\"Default Checkbox\">\n                        Include Full History\n                    </md-checkbox>\n                </md-input-container>\n            </div>\n\n        </div> -->\n    </form>\n</div>\n");
$templateCache.put("app/app-directives/subscription-manager/subscription-manager.tmpl.html","<div class=\"subscription-manager\" layout=\"column\" style=\"padding-top: 2em;\">\n\n    <div layout=\"row\" layout-align=\"center start\">\n        <div layout=\"row\" layout-wrap layout-align=\"center start\" flex=\"auto\" style=\"background-color: rgb(240,240,240); border-radius: 4px; max-width: 800px; padding: 1em 1em 2em 1em; margin-bottom :7em;\">\n            <div layout=\"column\" flex=\"100\">\n                <h3 ng-if=\"vm.currentStatus == \'active\'\" class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 2em;\">\n                    You are on the <strong>{{vm.currentPlan.planName}}</strong> plan\n                </h3>\n                <h3 ng-if=\"vm.currentStatus == \'in_trial\'\" class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 2em;\">\n                    You have signed up for the <strong>{{vm.currentPlan.planName}}</strong> plan\n                </h3>\n                <p class=\"md-subhead center\" style=\"margin-bottom: 2em;\" ng-if=\"vm.currentPlan.status == \'archived\'\"><strong>This plan is no longer offered.</strong></p>\n            </div>\n            <div flex=\"nogrow\" style=\"min-width: 300px;\">\n                <p class=\"md-subhead\" style=\"margin-bottom: 0;\"><strong>The {{vm.currentPlan.planName}} plan includes:</strong></p>\n                <p class=\"md-subhead\" style=\"padding-left: 1em;\">\n                    - {{vm.currentPlan.workspaces}} Workspaces<br>\n                    <span ng-if=\"vm.currentPlan.recurring == 0\">- No Recurring Task Limit<br></span>\n                    <span ng-if=\"vm.currentPlan.recurring != 0\">- {{vm.currentPlan.recurring}} Recurring Tasks/Workspace<br></span>\n                    - {{vm.currentPlan.team}} Team member<span ng-if=\"vm.currentPlan.team > 1\">s</span><br>\n\n                    <span ng-if=\"vm.currentPlan.billing\">- Client Billing</span>\n                    <span ng-if=\"!vm.currentPlan.billing\">- No Client Billing</span>\n                </p>\n\n            </div>\n            <div flex=\"100\" flex-gt-sm=\"30\" style=\"min-width: 300px;\" layout=\"column\" layout-align=\"center fill\">\n                <div class=\"plan-status-box\" ng-class=\"{\'in-trial\':  vm.currentStatus == \'in_trial\', \'active\': vm.currentStatus == \'active\', \'cancelled\': vm.currentStatus == \'cancelled\'}\">\n                    <p ng-if=\"vm.currentStatus == \'in_trial\'\">\n                        Your Subscription is in trial.<br>\n                        <span>Trial ends in {{vm.remainingTrial}} days</span>\n                    </p>\n                    <p ng-if=\"vm.currentStatus == \'active\'\">\n                        <md-icon md-font-icon=\"zmdi zmdi-check\" style=\"font-size: 24px; color: green;\"></md-icon> Your Subscription is active!<br>\n                        <span>Since {{vm.activeStart | amDateFormat: \"MMM DD, YYYY\"}}</span>\n                    </p>\n                    <div ng-if=\"vm.currentStatus == \'cancelled\'\">\n                        <p >\n                            Your premium subscription<br> has been cancelled<br>\n                            <span>Since {{vm.user.plan.content__subscription__cancelled_at | amDateFormat: \"MMM DD, YYYY\"}}</span>\n                        </p>\n                        <md-button ng-click=\"vm.reactivatePlan(vm.currentPlan.planID)\" ng-if=\"vm.currentStatus == \'cancelled\'\" style=\"width: 80%\" class=\"md-raised md-primary\">Reactivate Subscription</md-button>\n\n                    </div>\n                </div>\n                <!-- if in trial and no credit card -->\n                <div ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'no_card\'\">\n                    <p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"font-size: 24px; color: orange;\"></md-icon> Please provide payment information <br>before your Free trial ends!</p>\n                    <p class=\"center\"><md-button ng-href=\"{{vm.functionsURL}}/checkout?key={{vm.functionsKey}}&user={{vm.user.uid}}&plan={{vm.currentPlan.planID}}&method=checkout\" ng-click=\"vm.checkoutPlan(plan.planID)\" class=\"md-raised md-accent\">Complete Signup</md-button></p>\n\n                </div>\n                <!-- if in trial credit card -->\n                <div ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'valid\'\">\n                    <p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-check\" style=\"font-size: 24px; color: green;\"></md-icon>\n                    Your signup is complete.</p>\n                    <p class=\"md-subhead center\">Your Subscription will officially activate <br>at the end of your free trial.</p>\n                </div>\n                <!-- {{vm.user.plan.content__subscription__id}} -->\n            </div>\n        </div>\n    </div><!-- top row -->\n\n    <!-- <md-divider style=\"margin-top: 3em;\"></md-divider> -->\n    <div class=\"md-padding\" ng-if=\"(vm.currentStatus == \'in_trial\' && vm.cardStatus != \'valid\') || vm.currentStatus == \'active\'\">\n        <div layout=\"column\" style=\"margin-bottom: 2em;\">\n            <!-- <h3 ng-if=\"vm.currentStatus != \'in_trial\'\" class=\"center\">Change your plan</h3> -->\n            <!-- <h3 ng-if=\"vm.currentStatus == \'in_trial\'\" class=\"center\">Would a different plan fit better?</h3> -->\n\n            <p class=\"md-title center\" ng-if=\"vm.currentStatus != \'in_trial\'\">You can upgrade/downgrade at any time.</p>\n            <p class=\"md-title center\" ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'no_card\'\">Or you can complete your signup using a different plan:</p>\n        </div>\n        <div layout=\"row\" layout-align=\"center start\" layout-wrap >\n            <md-card flex-xs=\"100\" flex-sm=\"45\" flex-md=\"20\" flex-lg=\"20\" flex-xl=\"20\" class=\"adminja-plan md-padding\" ng-if=\"plan.status == \'active\'\" ng-repeat=\"plan in vm.plans | orderBy: \'monthly\' track by $index\" >\n                <h3 class=\"center\">{{plan.planName}}</h3>\n                <md-divider></md-divider>\n                <p class=\'md-subhead plan-detail\'><strong>{{plan.workspaces}}</strong> Workspaces<br>\n                    <span ng-if=\"plan.recurring == 0\"><strong>No</strong> Recurring Task Limit<br></span>\n                    <span ng-if=\"plan.recurring != 0\"><strong>{{plan.recurring}}</strong> Recurring Tasks/Workspace<br></span>\n                    <strong>{{plan.team}}</strong> Team member<span ng-if=\"plan.team > 1\">s</span><br>\n                    <span ng-if=\"plan.billing\">Client Billing</span>\n                    <span ng-if=\"!plan.billing\">No Client Billing</span>\n                </p>\n                <md-divider></md-divider>\n                <h3 class=\"center\">${{plan.monthly}}/mo</h3>\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.currentPlan.planID != plan.planID\">\n                    <md-button style=\"width: 80%\" ng-click=\"vm.confirmChange(plan.planID)\" ng-if=\"vm.currentStatus == \'active\'\" class=\"md-raised md-primary\">Switch to this Plan</md-button>\n                    <md-button style=\"width: 80%\" ng-href=\"{{vm.functionsURL}}/checkout?key={{vm.functionsKey}}&user={{vm.user.uid}}&plan={{plan.planID}}&method=checkout\" ng-if=\"vm.currentStatus == \'in_trial\'\" class=\"md-raised md-primary\">Complete signup with this Plan</md-button>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.currentPlan.planID == plan.planID\">\n                    <md-button ng-if=\"vm.currentStatus != \'cancelled\'\" style=\"width: 80%\" ng-disabled=\"true\" class=\"md-raised md-primary\">You are on this Plan</md-button>\n                    <md-button ng-click=\"vm.reactivatePlan(plan.planID)\" ng-if=\"vm.currentStatus == \'cancelled\'\" style=\"width: 80%\" class=\"md-raised md-primary\">Reactivate this Plan</md-button>\n                </div>\n            </md-card>\n        </div>\n        <div ng-if=\"vm.currentStatus == \'active\'\">\n            <p class=\"md-subhead center\" style=\"font-size: 11px;\">Note: If you change plans, you will be credited the unused portion from your current plan and a prorated charge for the new plan will be applied.</p>\n        </div>\n    </div>\n    <p ng-if=\"vm.currentStatus != \'cancelled\'\" class=\"text-center\">\n      <md-button ui-sref=\"authentication.cancel\"  class=\"md-warn\">Cancel Subscription</md-button>\n    </p>\n</div>\n");
$templateCache.put("app/app-directives/task-template-card/task-template-card.tmpl.html","\n<md-card class=\"app-item-task status-open focus-{{vm.template.info.focus}}\" >\n    <div class=\"task-badge task-handle\"  style=\"background-color: {{getColor(vm.template.info.client)}};\">\n\n    </div>\n    <md-card-title>\n\n        <md-card-title-text flex class=\"app-item-description\" style=\"padding-right: 1em;\" md-ink-ripple=\"#bbb\">\n            <span class=\"task-title\" ng-click=\"vm.editTemplate(vm.template)\">{{firstLine(vm.template.info.description) | limitTo\n                        : 40 : begin}} </span>\n            <!-- <span class=\"md-caption task-client\">{{clientName(vm.template.info.client)}}</span> -->\n            <span class=\"md-subhead\" ng-click=\"vm.editTemplate(vm.template)\" style=\"color: #777\">{{restLines(vm.template.info.description) | limitTo\n                        : 150 : begin}}</span>\n             <div ng-show=\"vm.template.isRecurring\">\n				<p class=\"md-caption\">Repeats: <span style=\"color: #888;\">{{vm.ruleInEnglish}}</span></p>\n				<p class=\"md-caption\">\n                    <span style=\"color: #888;\" ng-show=\"vm.template.schedule.limit\">Created {{vm.template.schedule.count}} of {{vm.template.schedule.limit}} times.</span>\n					<span style=\"color: #888;\" ng-show=\"!vm.template.schedule.limit\">Created {{vm.template.schedule.count}} times.</span>\n					<br>&nbsp;<br><span ng-show=\"!vm.template.schedule.complete\">Next <md-icon style=\"font-size: 12px; display:inline; margin-right: 3px;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon> <span style=\"color: #888;\">{{vm.displayNextDueDate}}</span></span>\n				</p>\n			</div>\n\n        </md-card-title-text>\n        <div class=\"card-controls\" flex=\"nogrow\" style=\"padding-right:0;\">\n            <md-menu md-position-mode=\"target-right target\">\n                <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-caret-down\" class=\"app-item-more\"></md-icon>\n                <md-menu-content>\n                    <md-menu-item>\n                        <md-button aria-label=\"Edit\" ng-click=\"vm.editTemplate(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit\n                        </md-button>\n                    </md-menu-item>\n                    <!-- <md-menu-item>\n                        <md-button aria-label=\"Clone\" ng-click=\"copyTask(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n                        </md-button>\n                    </md-menu-item> -->\n                    <md-menu-item>\n                        <md-button aria-label=\"New Task from this Template\" ng-click=\"clone(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> New Task from this Template\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button aria-label=\"Delete\" ng-click=\"deleteTemplate(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </md-card-title>\n    <!-- <md-divider></md-divider> -->\n    <md-card-footer class=\"md-primary\">\n\n        <div layout=\"row\" layout-align=\"start center\" class=\"item-footer-controls\" style=\"padding-left: 00px; padding-bottom: 0;\">\n            <div flex=\"nogrow\" ng-if=\"vm.template.info.numChecklistItems > 0\">\n                <md-button  ng-click=\"editTemplate(vm.template, 1);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon md-font-icon=\"fa fa-check-square-o\" >\n                        <md-tooltip md-delay=\"500\">Checklist items</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label class=\"icon-label\">{{vm.template.info.numChecklistItems}}</label>\n\n            </div>\n            <div flex=\"nogrow\" ng-show=\"vm.template.info.files\">\n                <md-button ng-click=\"vm.editTemplate(vm.template)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon  md-font-icon=\"zmdi zmdi-attachment\" >\n                        <md-tooltip md-delay=\"500\">Attachments</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label class=\"icon-label\"> {{vm.template.info.files.length}}</label>\n            </div>\n            <div flex=\"auto\" layout=\"row\" layout-align=\"end center\">\n                <label class=\"icon-label\">\n                    <span ng-if=\"vm.template.info.budget\">\n                     Budget: {{vm.template.info.budget| HandM}}\n                     </span>\n                </label>\n            </div>\n\n\n\n            </div>\n\n        </div>\n    </md-card-footer>\n</md-card>\n");
$templateCache.put("app/app-directives/team-member-detail/team-member-detail.tmpl.html","<div class=\"app-item-container team-member-detail hide-for-print\"\n    md-whiteframe=\"2\"\n    layout=\"column\"\n    layout-align=\"start\"\n    style=\"background-color: #fff;\"\n    >\n    <div class=\"app-item-container-header\" >\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.member.color}}; z-index: 100; cursor: default;\">\n            <div class=\"auto\">\n                <h3>Member Detail</h3>\n            </div>\n\n        </div><!-- // end app-item-container-title-bar -->\n    </div><!-- // end app-item-container-header -->\n\n    <div class=\"sub-panel-details app-item-container-items\"\n        layout=\"column\"\n        style=\"width: 700px;\"\n        resize\n        hotkey=\"{esc: vm.cancelMemberSelect}\"\n        >\n        <form name=\"vm.memberForm\" novalidate>\n        <div class=\"sub-panel-details-header\" >\n\n                <div layout=\"row\" style=\" padding-bottom: 1em; margin-bottom: 1em;\">\n                    <div flex=\"20\" style=\"min-width: 120px;\">\n                        <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" class=\"avatar\">\n                    </div>\n                    <div flex layout=\'column\' layout-align=\"start start\">\n                        <p ng-if=\"vm.user\" class=\"md-display-1\">\n                            {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}<br>\n                        </p>\n                        <p ng-if=\"vm.user\" class=\"md-subhead\" style=\"margin:0;\">\n                            <a href=\"mailto:{{vm.user.email}}\">{{vm.user.email}}</a><br>\n                        </p>\n                        <p ng-if=\"!vm.user\" class=\"md-subhead\" style=\"margin:0;\">\n                            <a href=\"mailto:{{vm.member.email}}\">{{vm.member.email}}</a><br>\n                        </p>\n                        <p class=\"md-caption\" style=\"margin:0;\" ng-if=\"vm.userID != vm.user.uid && vm.member.status != \'declined\'\">\n                            <span ng-if=\"vm.member.status != \'pending\'\">Member since {{vm.member.becameMember | amDateFormat: \'MMM DD, YYYY\'}}</span>\n                            <span ng-if=\"vm.member.status == \'pending\'\">Invited on {{vm.member.invited | amDateFormat: \'MMM DD, YYYY\'}}</span>\n                        </p>\n                        <p class=\"md-caption\" style=\"margin:0;\" ng-if=\"vm.userID == vm.user.uid\">\n                            Team Owner\n                        </p>\n\n                       <!--  <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"font-size: 12px; margin-top: 1em;\">\n                            <strong>Tags?</strong><br>\n                            <md-chips ng-model=\"vm.clientBillingService.selectedPeriod.invoices\" name=\"invoices\" readonly=\"true\" md-removable=\"false\">\n                                <md-chip-template ng-click=\"vm.selectInvoice($chip.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == $chip.uid}\"  style=\"cursor: pointer;\">\n                                     <span class=\"chip-content\"><md-icon ng-if=\"$chip.balance <= 0\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon> <md-icon md-font-icon=\"zmdi zmdi-receipt\" style=\"color: #fff;\"></md-icon> #{{$chip.number}}  - {{vm.currency}}{{$chip.total}}</span >\n                                </md-chip-template>\n                            </md-chips>\n\n                        </p> -->\n\n                    </div>\n\n                    <div flex=\'40\' layout=\'column\' layout-align=\'start end\' ng-if=\"vm.member.role != \'owner\'\">\n                        <div layout=\"column\" layout-align=\"start end\">\n                            <md-select ng-if=\"vm.member.status == \'declined\'\" ng-disabled=\"true\" placeholder=\"declined\" style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.member.status\"></md-select>\n                            <md-select ng-if=\"vm.member.status != \'declined\'\" ng-disabled=\"vm.member.status == \'pending\'\" placeholder=\"pending\" style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.member.status\" ng-change=\"vm.changeMemberStatus(vm.member)\">\n                                <md-option value=\"active\">\n                                    <span style=\"color: green;\">Active</span>\n                                </md-option>\n                                <md-option value=\"disabled\">\n                                    <span style=\"color: red;\">Disabled</span>\n                                </md-option>\n                            </md-select>\n                            <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.member.status != \'declined\'\" style=\"padding-top: 10px;\">\n                                <span class=\"md-subhead\" style=\"font-size: 11px; padding-right: 1em;\">Assign a color:</span>\n                                <div style=\"position: relative; top: 3px;\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\" flex=\"nogrow\" aria-label=\"Assign Member a Color\" md-no-ink=\"true\"  >\n                                    <div class=\"swatch\" style=\"background-color: {{vm.member.color || \'#999\'}}; width: 15px; height: 15px;\" >\n                                    </div>\n                                    <md-icon style=\"position: relative; top: -11px; right: -10px;\" flex=\"none\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon>\n                                </div class=\"toggleSwatch\">\n                            </div>\n                            <div class=\"colorPicker\" ng-if=\"vm.colorPicker\" style=\"background-color: rgba(255,255,255,0);\">\n                                <lk-color-chooser   ng-change=\"vm.togglePicker()\" style=\"margin:0; width:235px;\" colors=\"vm.memberColors\" selected-color=\"vm.member.color\" ng-model=\"vm.member.color\" ng-click=\"vm.colorChange(vm.memberForm);\"></lk-color-chooser>\n                            </div>\n                            <md-button ng-if=\"vm.member.status != \'declined\' && vm.member.status != \'pending\'\" ng-click=\"vm.removeMember(vm.member)\" style=\"font-weight: normal;\"> <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"font-size: 1.25rem;\"></md-icon>Remove Member</md-button>\n                        </div>\n                        <div layout=\"row\" layout-align=\"end start\" ng-if=\"vm.member.status == \'pending\'\">\n\n                                    <p style=\"text-align: right;\"><span style=\"color: orange;\">Invitation Pending</span></p>\n\n\n                        </div>\n\n                    </div>\n                </div>\n                <div layout=\"column\" class=\"period-stats\" style=\"margin-top: 0\" ng-if=\"vm.member.status != \'declined\'\">\n\n                            <md-input-container style=\"margin-bottom: 0;\">\n                                <textarea ng-model=\"vm.member.notes\"\n                                    rows=\"1\"\n                                    placeholder=\"Notes\"\n                                    style=\"overflow-y: scroll;\"\n                                    ng-change=\"vm.editMemberNote()\"\n                                >\n                                </textarea>\n                            </md-input-container>\n                            <div ng-if=\"!vm.memberForm.$pristine\" layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.cancelNote()\">cancel</md-button> <md-button class=\"md-raised md-primary\" ng-click=\"vm.updateMember(vm.member)\" ng-disabled=\"vm.memberForm.$pristine\"   aria-label=\"save changes\"> Save Changes</md-button>\n                            </div>\n\n\n                </div>\n\n        </div>\n             </form>\n            <div class=\"sub-panel-content\" style=\"padding-bottom: 5em;\" ng-if=\"vm.member.status == \'pending\' || vm.member.status == \'declined\'\">\n\n                <div ng-if=\"vm.member.status == \'pending\'\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 1em;\">\n                    <h3 class=\"center\">Invitation Pending</h3>\n                    <p class=\"center md-subhead\">You\'ll be able to assign clients once this member has accepted your invitation.</p>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.resendInvite(vm.member)\">\n                        <md-icon md-font-icon=\"fa fa-share\" style=\"margin-right: 1em;\"></md-icon>\n                    Re-send Invitation</md-button>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.revokeInvite(vm.member);\">\n                    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"margin-right: 1em;\"></md-icon> Revoke Invitation</md-button>\n\n                </div>\n                <div ng-if=\"vm.member.status == \'declined\'\" layout=\"column\" style=\"padding-top: 1em;\">\n                    <h3 class=\"center\">Invitation Declined</h3>\n                    <p class=\"center md-subhead\">The candidate declined your team invitation.</p>\n                    <md-button class=\"md-primary \" ng-click=\"vm.revokeInvite(vm.member);\">\n                    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"margin-right: 1em;\"></md-icon> Discard Invitation</md-button>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.resendInvite(vm.member)\">\n                        <md-icon md-font-icon=\"fa fa-share\" style=\"margin-right: 1em;\"></md-icon>\n                    Re-send Invitation</md-button>\n\n                </div>\n\n            </div>\n        <div ng-if=\"vm.member.status != \'pending\' && vm.member.status != \'declined\' && vm.member.status != \'archived\'\" class=\"sub-panel-content\" style=\"padding-bottom: 5em;\">\n\n           <md-tabs md-stretch-tabs=\"auto\" md-dynamic-height md-border-bottom>\n                <md-tab label=\"{{vm.user.profile.firstName}}\'s Permissions\">\n                  <md-content class=\"\" style=\"background-color: #fff;\">\n                    <div ng-if=\"!vm.membersClients.length\">\n                        <h3 class=\"md-headline text-center\" style=\"font-size: 18px; margin-top: 2em;\">This member has not been granted access to any clients.</h3>\n                        <p class=\"md-subhead text-center\">Visit the \"Team\" tab for any client to grant access. </p>\n                    </div>\n                    <client-team-member-access ng-if=\"client.owner == vm.userID\" client=\"client\" member=\"vm.member\" ng-repeat=\"client in vm.membersClients |filter : {status: \'!archived\'} track by client.uid\" style=\"border-bottom: 1px solid #bbb;\">\n                        <!-- <client-summary-strip this-client=\"client\" show-progress=\"false\" style=\"margin-bottom: 1em;\"></client-summary-strip> -->\n                    </client-team-member-access>\n                  </md-content>\n                </md-tab>\n                <!-- <md-tab label=\"History\">\n                  <md-content class=\"md-padding\">\n                    <h1 class=\"md-display-2\">Tab One</h1>\n                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue. Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus. In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec, feugiat ultricies mi.</p>\n                  </md-content>\n                </md-tab> -->\n            </md-tabs>\n                <!-- <div layout=\"row\" layout-align=\"end center\">\n\n                        <md-button style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"Print Time Report\">Print Time Report</md-button>\n\n                </div> -->\n\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/task-time/task-time.tmpl.html","<md-content style=\"height: 400px;\">\n    <md-list class=\"md-dense\">\n        <time-entry ng-repeat=\"entry in vm.timeLogs track by entry.uid\">\n         </time-entry>\n    </md-list>\n</md-content>\n<h4 class=\"right\" style=\"padding-right: 1em;\">Total: {{vm.totalLogged | HandM}}</h4>\n");
$templateCache.put("app/app-directives/team-member/team-member-card.tmpl.html","<md-card  ng-click=\"vm.selectTeamMember(vm.member)\" ng-class=\"{\'active\': vm.isMemberSelected(), \'owner\': vm.member.role == \'owner\', \'archived\': vm.member.status == \'archived\', \'md-whiteframe-20dp\' : vm.isMemberSelected()}\" class=\"team-member-card\" ng-style=\"{\'border-top\':\'8px solid {{vm.member.color}}\'}\">\n    <div layout=\"row\">\n        <div flex=\"20\" layout=\"row\" layout-align=\"start start\">\n            <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" class=\"avatar\">\n        </div>\n        <div flex=\"80\" layout=\"column\">\n            <p class=\"md-headline\" style=\"margin-bottom: 0; margin-top: 8px;\">\n                {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\n            </p>\n\n\n            <p ng-if=\"vm.member.status == \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Invitation sent on {{vm.member.invited| amDateFormat: \'MMM DD, YYYY\'}}<br>\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n                <a ng-if=\"vm.user.email\" href=\"mailto:{{vm.user.email}}\">{{vm.user.email}}</a>\n                <a ng-if=\"!vm.user.email\" href=\"mailto:{{vm.member.email}}\">{{vm.member.email}}</a>\n            </p>\n            <div ng-if=\"vm.member.uid != vm.userID\">\n                <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                    Became a member on {{vm.member.becameMember | amDateFormat: \'MMM DD, YYYY\'}}\n                </p>\n            </div>\n            <div ng-if=\"vm.member.role == \'owner\'\">\n                <p class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                    Team Owner<br>\n                </p>\n            </div>\n        </div>\n\n\n    </div>\n    <div layout=\"row\" layout-align=\"end center\">\n        <div flex=\"nogrow\">\n            <p class=\"md-subhead member-{{vm.member.status}}\" style=\"font-size: 12px;\">\n                {{vm.member.status}} <span ng-if=\"vm.member.status == \'pending\'\">invitation</span>\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/team-member/team-member-client-list-item.tmpl.html","<div layout=\"row\" layout-align=\"center center\" style=\"border-bottom: 1px solid #bbb; padding: 1em;\">\n       <div hide-xs flex=\"nogrow\" layout=\"row\" layout-align=\"start start\">\n           <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" class=\"avatar\" style=\"margin-right: 1em; border: 2px solid {{vm.member.color}}; border-radius: 50%;\">\n       </div>\n       <div flex=\"100\" flex-gt-xs=\"30\" layout=\"column\">\n           <p class=\"md-headline\" style=\"margin-bottom: 0; margin-top: 8px;\">\n               {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\n           </p>\n           <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n               <a href=\"mailto:{{vm.member.email}}\">{{vm.user.email}}</a>\n           </p>\n\n       </div>\n       <md-radio-group ng-disabled=\"vm.disableEdit\" ng-model=\"vm.clientAccess\" ng-change=\"vm.setMemberAccess(vm.member, vm.clientAccess)\">\n            <md-radio-button flex value=\"none\" class=\"md-primary\">None  </md-radio-button>\n            <md-radio-button flex value=\"member\" class=\"md-accent\">Member  </md-radio-button>\n            <md-radio-button flex value=\"admin\" class=\"md-warn\">Admin  </md-radio-button>\n        </md-radio-group>\n\n\n   </div>\n");
$templateCache.put("app/app-directives/time-entry/time-entry.tmpl.html","<md-list-item class=\"md-3-line time-entry-list-item\" ng-class=\"{\'editing\': vm.editMode}\" style=\"border-top: 5px solid {{vm.entry.clientColor}}; border-right: none; background-color: #fff; position: relative;\">\n    <div  class=\"card-controls\">\n        <md-button ng-disabled=\"entry.invoiced\" ng-click=\"openTime(entry)\">\n           <md-icon ng-if=\"entry.invoiced\" md-font-icon=\"zmdi zmdi-lock\">\n               <md-tooltip>\n                   This entry has been invoiced and cannot be modified.\n               </md-tooltip>\n           </md-icon>\n            <md-icon  ng-if=\"!entry.invoiced\" aria-label=\"Edit Entry\" md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 10px;\"></md-icon>\n        </md-button>\n\n    </div>\n<div ng-if=\"!vm.editMode\" class=\"entry-card\" flex layout=\"column\" layout-align=\"center stretch\">\n    <div flex layout=\"row\" layout-align=\"start start\" style=\"padding-top: 1em;\">\n        <div flex=\"80\">\n            <p class=\"entry-description\">{{vm.entry.description | limitTo : 50 : begin}}</p>\n        </div>\n        <div flex=\"20\" class=\"entry-digits\" style=\"padding-right: 1em;\">\n            <p class=\"entry-date\">{{vm.entry.logDate | amDateFormat:\'MM/DD/YY\'}}</p>\n            <p class=\"entry-logged\">{{vm.entry.logged | HandM}}</p>\n            <p class=\"entry-client\">{{ vm.entry.clientName }}</p>\n        </div>\n\n    </div>\n\n    <div flex layout=\"row\" layout-align=\"start end\">\n        <div flex=\"100\">\n            <p class=\"task-info\" ng-show=\"!vm.local\" ng-click=\"openTask(vm.entry.task)\">\n               <md-icon ng-show=\"vm.entry.task\" aria-label=\"View Related Task\" md-font-icon=\"fa fa-check-square\" style=\"min-width: 12px; width: 12px;\">\n                   <md-tooltip md-delay=\"1000\">View Related Task</md-tooltip>\n               </md-icon>\n               {{vm.entry.taskName| limitTo : 25 : begin}}\n            </p>\n            <p class=\"entry-creator\">\n                <img class=\"avatar\" src=\"{{vm.entry.creatorAvatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"14\">\n              {{vm.entry.creatorName}}\n            </p>\n        </div>\n    </div>\n</div>\n<!-- inline edit form -->\n<div ng-if=\"vm.editMode\" class=\"time-edit-inline\" flex layout=\"column\" layout-align=\"center stretch\">\n<form name=\"timeEntryForm\" novalidate=\"\">\n    <div layout=\"row\" layout-align=\"start start\">\n        <div flex=\"grow\">\n        </div>\n        <div flex=\"20\">\n            <div class=\"card-controls\">\n                <md-button ng-click=\"cancelEdit(entry)\">\n                    <md-icon  aria-label=\"Edit Entry\" md-font-icon=\"zmdi zmdi-close\" ></md-icon>\n                </md-button>\n            </div>\n        </div>\n    </div>\n\n    <!-- <h3 class=\"center\">Edit Time Entry</h3> -->\n\n        <div flex=\"100\" layout=\"row\" layout-align=\"center center\" class=\"duration-container\">\n            <div class=\"date-label-container\" flex=\"nogrow\" style=\"padding-right: 2em;\">\n                <md-datepicker ng-model=\"vm.editEntry.logDate\" md-max-date=\"vm.maxDate\"  md-placeholder=\"Date\" required=\"required\"></md-datepicker>\n                <div class=\"hint\" style=\"padding-left: 2em;\">Date</div>\n                <div ng-messages=\"vm.timeEntry.logDate.$error\">\n                    <div ng-message=\"required\">Please make sure you\'ve entered a valid date. (mm/dd/yyyy)</div>\n                </div>\n            </div>\n            <md-input-container flex=\"50\">\n                <input name=\"hours\" type=\"number\" min=\"0\" max=\"24\" ng-model=\"vm.editEntry.hours\">\n                <div class=\"hint\">Hours</div>\n            </md-input-container>\n            <md-input-container flex=\"50\">\n                <input name=\"minutes\" type=\"number\" min=\"0\" step=\"5\" max=\"480\" ng-model=\"vm.editEntry.minutes\">\n                <div class=\"hint\">Minutes</div>\n            </md-input-container>\n        </div>\n        <md-divider></md-divider>\n        <div flex=\"100\">\n            <md-input-container flex=\"100\" ng-if=\"!vm.requireWorkDescription\" class=\"time-description-container\">\n                <textarea name=\"description\" md-no-asterisk ng-model=\"vm.editEntry.description\"></textarea>\n                <div class=\"hint\">Entry Description</div>\n                <div ng-messages=\"vm.editEntry.description.$error\">\n                    <div ng-message=\"required\">Your time entry needs a description</div>\n                </div>\n            </md-input-container>\n            <md-input-container flex=\"100\" ng-if=\"vm.requireWorkDescription\" class=\"time-description-container\">\n                <textarea name=\"description\" md-no-asterisk ng-model=\"vm.editEntry.description\" required=\"required\"></textarea>\n                <div class=\"hint\">Entry Description</div>\n                <div ng-messages=\"vm.editEntry.description.$error\">\n                    <div ng-message=\"required\">Your time entry needs a description</div>\n                </div>\n            </md-input-container>\n\n        </div>\n        <div flex=\"100\" layout=\"row\">\n\n\n           <!--  <p class=\"right clientname\" flex=\"50\" >\n                <md-icon aria-label=\"client\" md-font-icon=\"zmdi zmdi-account-box-o\" style=\"min-width: 12px; width:12px; font-size: 12px;\">\n                </md-icon> {{vm.editEntry.clientName}}\n            </p> -->\n        </div>\n        <!-- <div flex=\"100\" >\n            <p class=\"left taskname\" ng-show=\"vm.editEntry.task\" style=\"font-size: 10px;\" ng-click=\"openTask(vm.entry.task)\"><md-icon  aria-label=\"Cancel Changes\" md-font-icon=\"fa fa-check-square\" style=\"min-width: 12px; width:12px; font-size: 12px;\">\n            </md-icon>{{vm.editEntry.taskName | limitTo : 35 : begin}}</p>\n        </div> -->\n\n\n\n\n        <!-- save -->\n        <div layout=\"row\" layout-align=\"end center\" flex  ng-show=\"vm.editStatus !=\'startdelete\' && vm.editStatus !=\'deleting\' && vm.editStatus !=\'deleted\'\" style=\"padding-top: 1em;\">\n\n                <md-button flex=\"nogrow\" ng-show=\"vm.editStatus != \'startdelete\' && vm.editStatus != \'deleting\' && vm.editStatus != \'deleted\'\"   aria-label=\"Delete Time Entry\" ng-click=\"startDelete(vm.editEntry);\">\n                    Delete\n                </md-button>\n\n            <md-button flex=\"nogrow\" ng-disabled=\"vm.editStatus == \'saving\'\" ng-click=\"cancelEdit(entry)\" >\n                 Cancel\n            </md-button>\n            <md-button flex=\"nogrow\" class=\"md-primary\" ng-click=\"updateTime(vm.editEntry)\" ng-disabled=\"timeEntryForm.$invalid || timeEntryForm.$pristine || vm.status==\'saving\'\">\n                <span ng-show=\"vm.editStatus == \'editing\'\">\n                        Save Changes\n                    </span>\n                <span ng-show=\"vm.editStatus == \'saving\'\">\n                    <md-icon aria-label=\"Saving\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px; line-height: 25px;\">\n                    </md-icon>\n                    Please Wait\n                </span>\n                <span ng-show=\"vm.editStatus == \'saved\'\">\n                    <md-icon  aria-label=\"Save Changes\" md-font-icon=\"zmdi zmdi-check\" style=\"min-width: 12px; width:12px; font-size: 12px; line-height: 25px;\">\n                    </md-icon> Changes Saved\n                </span>\n            </md-button>\n        </div><!-- // save -->\n\n    <!-- delete entry controls -->\n    <div flex=\"auto\" ng-show=\"vm.editStatus == \'startdelete\' || vm.editStatus == \'deleting\' || vm.editStatus ==\'deleted\'\" class=\"center\" style=\"background-color: pink;\">\n\n\n        <p ng-show=\"vm.editStatus ==\'startdelete\'\" class=\'center\"\' style=\"margin:0 auto 0 auto;\">\n            Permanently delete?\n        </p>\n\n        <md-button ng-show=\"vm.editStatus ==\'startdelete\'\" class=\"md-primary\" ng-click=\"cancelDelete()\">\n            cancel\n        </md-button>\n\n        <md-button class=\"md-primary\" ng-click=\"deleteEntry(vm.editEntry)\">\n            <span ng-show=\"vm.editStatus == \'startdelete\'\">\n                    Confirm\n                </span>\n            <span ng-show=\"vm.editStatus == \'deleting\'\">\n                    <md-icon aria-label=\"Deleting\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px;\">\n                    </md-icon>\n                    Please Wait\n                </span>\n            <span ng-show=\"vm.editStatus == \'deleted\'\">\n                    <md-icon  aria-label=\"Save Changes\" md-font-icon=\"zmdi zmdi-check\" style=\"min-width: 12px; width:12px; font-size: 12px;\">\n                    </md-icon> Entry Deleted\n                </span>\n        </md-button>\n    </div><!-- // delete entry controls -->\n    </form>\n</div>\n\n</md-list-item>\n<md-divider></md-divider>\n\n");
$templateCache.put("app/app-directives/timer-directives/timer-list.tmpl.html","<div>\n    <div ng-if=\"vm.userTimers.length > 0\">\n        <md-card\n            ng-repeat=\"userTimer in vm.userTimers| orderBy : \'-uid\'\"\n            ng-class=\"{ \'active-timer md-whiteframe-6dp\': vm.timerDataService.timerData.activeTimer.uid==userTimer.uid}\"\n            style=\"border-left: 6px solid {{userTimer.client.clientColor}}; margin-bottom: 8px;\"\n            layout=\"column\">\n\n            <div layout=\"row\">\n                <div flex=\"70\" class=\"md-padding\" style=\"padding-bottom: 0; padding-top: 0;\">\n                    <p style=\"font-size: 18px;\">{{userTimer.client.name}}</p>\n                    <p style=\"font-size: 12px;\" ng-if=\"userTimer.task\">\n                        <strong>Related Task: </strong>\n                        <span ng-click=\"vm.viewTask(userTimer.task.uid)\" style=\"cursor: pointer;\">{{vm.firstLine(userTimer.task.title)}}</span>\n                    </p>\n                </div>\n                <div flex>\n                    <p class=\"md-body-1 md-padding acrrued-time\" style=\"margin:0; padding-bottom: 0; font-size: 18px;\" ng-class=\"{ \'active-accrued\': vm.timerDataService.timerData.activeTimer.uid==userTimer.uid}\">\n                            <strong>{{userTimer.approxAccrued | hhmmss}}</strong><br>\n                    </p>\n                    <p class=\"md-padding\" style=\"font-size: 10px; margin: 0; padding-top: 0; padding-right: 25px; text-align:right;\">{{userTimer.events[0].when | amDateFormat: \'MMM DD\'}}</p>\n                </div>\n\n            </div>\n\n            <div layout=\"column\" style=\"padding: .5em 1em 0 1em;\">\n                <form name=\"timerDescriptionForm\" ng-submit=\"vm.updateDescription(userTimer)\">\n                <md-input-container style=\"margin: 0;position: relative;\" md-no-float >\n\n                    <input placeholder=\"What are you working on?\" name=\"description\" class=\"timer-description\" ng-model=\"userTimer.description\" ng-blur=\"vm.updateDescription(userTimer)\">\n                    <span style=\"position: absolute; right: 5px; top: 3px;\" ng-show=\"userTimer.saving\" class=\"\"><md-icon  aria-label=\"logging-ing\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"padding-right: .5em; font-size: 11px; line-height: 25px; \"></md-icon></span>\n                    <span style=\"position: absolute; right: 5px; top: 3px;\" ng-show=\"userTimer.saved\" class=\"disappear\"><md-icon  aria-label=\"logging-ing\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-right: .5em; min-width: 12px; width: 12px; font-size: 12px; color: green;\"></md-icon></span>\n                </md-input-container>\n                </form>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\" class=\"md-padding timerlist-controls\"  >\n\n                <!-- use resumeSavedTimer if this isn\'t the current active timer -->\n                <md-button\n                    style=\"margin-right:0px; margin-left: 0px;\"\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.uid != userTimer.uid\"\n                    ng-disabled=\"userTimer.on\"\n                    ng-click=\"vm.resumeSavedTimer(userTimer)\"\n                    class=\"  md-small \"\n                    flex=\"nogrow\"\n                    >\n                    <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\" >\n                        <md-tooltip>Resume Timer</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <!-- use resumeTimer if this is the current active timer -->\n                <md-button\n                    style=\"margin-right:0px; margin-left: 0px;\"\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.uid == userTimer.uid\"\n                    ng-disabled=\"userTimer.on\"\n                    ng-click=\"vm.resumeTimer(userTimer)\"\n                    class=\"  md-small \"\n                    flex=\"nogrow\"\n                    >\n                    <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\" >\n                        <md-tooltip>Resume Timer</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button\n                    style=\"margin-right:0px; margin-left: 0px;\"\n                    ng-disabled=\"!userTimer.on\"\n                    ng-click=\"vm.pauseTimer(userTimer)\"\n                    class=\"  md-small \"\n                    flex=\"nogrow\"\n                    >\n                    <md-icon md-font-icon=\"zmdi zmdi-pause\" ><md-tooltip>Pause Timer</md-tooltip></md-icon>\n\n                </md-button>\n                <md-button\n                    style=\"margin-right:0px; margin-left: 0px;\"\n                    ng-click=\"vm.stopTimer(userTimer)\"\n                    class=\"  md-small \"\n                    flex=\"nogrow\"\n                    >\n                    <md-icon md-font-icon=\"zmdi zmdi-stop\" ><md-tooltip>Close and Log Timer</md-tooltip></md-icon>\n\n                </md-button>\n                <md-button\n                    style=\"margin-right:0px; margin-left: 0px;\"\n                    ng-click=\"vm.discardTimer(userTimer)\"\n                    ng-confirm-click=\"Discard this timer?\"\n                    class=\" md-small\"\n                    flex=\"nogrow\"\n                    >\n                    <md-icon\n                        title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                        <md-tooltip>Discard Timer</md-tooltip>\n                    </md-icon>\n\n                </md-button>\n            </div>\n        </md-card>\n        <!-- end md-list-item-text -->\n    </div>\n\n    <div ng-if=\"vm.userTimers.length == 0\">\n        <p class=\"text-center md-heading\">You don\'t have any timers to switch to.<br>\n        Start one in your toolbar or click the \"play\" button on any task.</p>\n    </div>\n    <!-- <p ng-if=\"vm.userTimers.length > 0\" class=\"text-center\">Missing a timer? <br>\n        Please refresh your browser.\n    </p> -->\n</div>\n");
$templateCache.put("app/app-directives/timer-directives/timer.tmpl.html","<div class=\"timer-wrapper\" layout=\"row\" layout-align=\"start center\">\n<div class=\"timer-toggle\" ng-click=\"vm.toggleTimerGui()\"  flex=\"nogrow\" >\n        <md-icon ng-if=\"vm.timerDataService.showTimerGui\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n        <md-icon ng-if=\"!vm.timerDataService.showTimerGui\" md-font-icon=\"zmdi zmdi-caret-left\"></md-icon>\n        <md-tooltip md-delay=\"1000\">\n            Show/Hide Timer\n        </md-tooltip>\n</div>\n<div ng-if=\"vm.timerDataService.showTimerGui\" layout=\"row\" layout-align=\"start center\" style=\"position: relative;  padding:0 1em 0 2em; background-color: {{vm.timerDataService.timerData.activeTimer.displayColor}};\">\n    <!-- CLIENT -->\n        <div class=\"timer\" layout=\"row\" layout-align=\"start center\">\n\n                <!-- CLIENT -->\n                <div class=\"animate-width\" ng-if=\"!vm.timerDataService.timerData.activeTimer.on\" flex=\"nogrow\" layout=\"column\" layout-align=\"start start\">\n                  <md-input-container class=\"md-block\" style=\"padding:0;\">\n                    <!-- note ng-model-options is required for md-select to auto-select current client -->\n                     <md-select\n                        ng-disabled=\"vm.timerDataService.timerData.activeTimer.on\"\n                        class=\"timer-client-menu-container md-no-underline timer-client-select\"\n                        ng-model=\"vm.timerDataService.timerData.activeClient\"\n                        style=\"\"\n                        ng-model-options=\"{trackBy: \'$value.uid\'}\"\n                        md-no-underline\n                        placeholder=\"Choose Workspace\"\n                        ng-change=\"vm.newTimer(vm.timerDataService.timerData.activeClient)\"\n                       >\n                        <md-option\n                            ng-repeat=\"client in vm.clients | orderBy: \'order\' track by client.uid\"\n                            ng-value={{client}}\n                            style=\"border-left: 4px solid {{client.clientColor}};\"\n                            ng-if=\"!client.disabled\"\n                            >\n                            <img\n                                src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\"\n                                width=\"20\"\n                                style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: .5em; position: relative; top: 5px;\" />\n                            <span style=\"position: relative; top: -3px;\" class=\"small\">{{client.name}}</span>\n                        </md-option>\n\n                     </md-select>\n                     <div class=\"task-information\" ng-click=\"vm.viewTask(vm.timerDataService.timerData.activeTimer.task.uid)\" ng-show=\"vm.timerDataService.timerData.activeTimer.task\" style=\"font-size: 9px; padding-left: 32px;\">\n                         <!-- Link to parent task -->\n                         <p style=\"font-size: 8px; line-height: 10px; margin:0; padding:0;\"><!-- <md-icon\n                             ng-show=\"vm.timerDataService.timerData.activeTimer.task\"\n                             style=\"font-size: 8px; min-width: 10px; width: 10px;\"\n                             md-font-icon=\"zmdi zmdi-check-square\">\n                             <md-tooltip md-delay=\"500\">\n                                 <span >View Related Task</span>\n                             </md-tooltip>\n                         </md-icon> -->\n                         {{vm.shortTaskName(vm.timerDataService.timerData.activeTimer.task.title)}}\n                         </p>\n                     </div>\n                  </md-input-container>\n\n                </div>\n                <!-- <img\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.on\"\n                    src=\"{{vm.selectedClient.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\"\n                    width=\"20\"\n                    style=\"border-radius: 50%; border: 2px solid {{vm.selectedClient.clientColor}}; margin-right: 1em; position: relative;\" /> -->\n                <!-- time elapsed since timer started -->\n                <div class=\"timer-actual-background\" layout=\"row\" layout-align=\"start center\" style=\"margin:0; padding:0;\">\n                <span\n                    class=\"timer-actual {{vm.budgetStatus(vm.timerDataService.timerData.activeTimer)}}\"\n                    flex=\"nogrow\"\n                    style=\"margin-right: .5em; padding: 15px 0 15px 0;\"\n                    >\n                    {{vm.timerDataService.timerData.activeTimer.approxAccrued | hhmmss}}\n                </span>\n\n\n\n                <!-- START -->\n                <!-- only show if activeTimer has no events -- after that we\'ll use resume instead-->\n                <!-- only enabled if a client is selected -->\n                <md-button\n                    ng-show=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    ng-disabled=\"!vm.timerDataService.timerData.activeClient.uid || vm.timerDataService.timerData.timers.length > 9\"\n                    ng-click=\"vm.startTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"play timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\"\n                    md-no-ink>\n                    <md-icon md-font-icon=\"zmdi zmdi-play\">\n                        <md-tooltip md-delay=\"500\" >\n                            <span ng-if=\"vm.selectedClient && vm.timerDataService.timerData.timers.length < 10\">Start Timer {{vm.selectedClient.name}}</span>\n                            <span ng-if=\"!vm.selectedClient\">Choose a client first</span>\n                            <span ng-if=\"vm.selectedClient && vm.timerDataService.timerData.timers.length > 9\">You have reach the maximum allowed simultaneous timers.</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n\n                <!-- PAUSE -->\n                <!-- only show if timer is running. -->\n                <md-button\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.on\"\n                    ng-click=\"vm.pauseTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"pause timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\" >\n                    <md-icon md-font-icon=\"zmdi zmdi-pause\">\n                        <md-tooltip md-delay=\"500\">\n                            <span >Pause Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n                <!-- RESUME -->\n                <!-- only display if timer already has events  and if timer is not running-->\n                <md-button\n                    ng-if=\"!vm.timerDataService.timerData.activeTimer.on && vm.timerDataService.timerData.activeTimer.events.length\"\n                    ng-click=\"vm.resumeTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"play timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\">\n                    <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\">\n                        <md-tooltip md-delay=\"500\">\n                            <span >Resume Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n\n                <!-- STOP -->\n                <md-button\n                    ng-disabled=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    aria-label=\"stop timer\"\n                    flex=\"nogrow\"\n                    ng-click=\"vm.stopTimer(vm.timerDataService.timerData.activeTimer)\"\n                    class=\"cassette-control md-icon-button\" >\n                    <md-icon md-font-icon=\"zmdi zmdi-stop\">\n                        <md-tooltip md-delay=\"500\">\n                            <span>Stop &amp; Log Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n                <!-- Discard -->\n                <md-button\n                    ng-disabled=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    aria-label=\"discard timer\"\n                    flex=\"nogrow\"\n                    ng-click=\"vm.discardTimer(vm.timerDataService.timerData.activeTimer)\"\n                    class=\"cassette-control md-icon-button\">\n                    <md-icon md-font-icon=\"zmdi zmdi-close\">\n                        <md-tooltip md-delay=\"500\">\n                            <span>Discard Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            </div><!-- timer-actual-background -->\n        </div>\n\n\n\n</div>\n</div>\n");
$templateCache.put("app/app-directives/today-panel/all-today-panel.tmpl.html","<div class=\"app-item-container task-item-container focused-item-container\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n    <div class=\"app-item-container-header\" style=\"margin-bottom: 12px;\">\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" >\n            <div flex=\"auto\">\n                <h3 >\n                    Today\n                </h3>\n            </div>\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"newTask(null, \'today\')\">\n                    <md-icon aria-label=\"Create new task\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n                        <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                    </md-icon>\n                </md-button>\n                </a>\n            </div>\n        </div><!-- // end app-item-container-title-bar -->\n    </div><!-- // end app-item-container-header -->\n    <div class=\"app-item-container-items\"\n         dragula=\"\'drag-today-task\'\"\n         dragula-scope=\"$scope\"\n         ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n              layout-align=\"start start\"\n              resize=\"{{vm.suppressResize}}\"\n         layout-align=\"start start\"\n         panelid=\"today\"\n         >\n\n        <app-item\n            class=\"task-app-item\"\n            ng-repeat=\"item in filteredTasks =(vm.tasks |  filter: {\'status\' : \'open\'} | filter: todayFilter | orderBy:[\'todayorder\']) track by item.refID \"\n            taskid=\"{{item.refID}}\"\n            order=\"{{item.order}}\"\n            taskpanel=\"{{item.panel}}\"\n            client=\"{{item.client}}\"\n            >\n\n        </app-item>\n        <div layout=\"column\" ng-if=\"!filteredTasks.length\" flex=\"100\">\n            <p style=\"min-width: 258px; width: 100%; font-size:128px;\" class=\"center\"><md-icon md-font-icon=\"fa fa-smile-o\" style=\"font-size: 128px; color: rgba(200,200,200,.2);\"></md-icon></p>\n        </div>\n\n    </div>\n\n</div>\n");
$templateCache.put("app/app-directives/today-panel/today-panel.tmpl.html","<div class=\"app-item-container task-item-container focused-item-container\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n    <div class=\"app-item-container-header\">\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.client.profile.clientColor}};\">\n            <div flex=\"auto\">\n\n                <h3>\n                    <a href=\"/clients/{{vm.client.uid}}\" ng-if=\"showClientName\">\n                        <md-tooltip md-direction=\"right\" md-delay=\"2000\">\n                            View Client\n                        </md-tooltip>\n                        <span ng-if=\"!vm.client.profile.fullName\">\n                            <md-icon ng-if=\"vm.client.profile.avatar\" class=\"heading-avatar\"><img src=\"{{vm.client.profile.avatar}}\" ></md-icon>\n                            <md-icon ng-if=\"!vm.client.profile.avatar\" class=\"heading-avatar\"><img src=\"/assets/images/avatars/generic-avatar.png\"></md-icon>\n                            {{vm.client.profile.firstname}} {{vm.client.profile.lastname}}\n                        </span>\n                        <span ng-if=\"vm.client.profile.fullName\">\n                            <md-icon ng-if=\"vm.client.profile.avatar\" class=\"heading-avatar\"><img src=\"{{vm.client.profile.avatar}}\"></md-icon>\n                                                        <md-icon ng-if=\"!vm.client.profile.avatar\" class=\"heading-avatar\"><img src=\"/assets/images/avatars/generic-avatar.png\"></md-icon>\n                            {{vm.client.profile.fullName}}\n                        </span>\n                    </a>\n                    <span ng-if=\"!showClientName\">\n                        <md-icon ng-if=\"vm.client.profile.avatar\" class=\"side-menu-icon\" style=\"max-height:20px; margin-right: 0;\"><img class=\"client-panel-avatar\" src=\"{{vm.client.profile.avatar}}\"></md-icon>\n                         Today\n                    </span>\n                </h3>\n            </div>\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"newTask(vm.client.uid, \'today\')\">\n                    <md-icon aria-label=\"Create new task for {{vm.client.profile.name}}\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n                        <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                    </md-icon>\n                </md-button>\n                </a>\n            </div>\n        </div><!-- // end app-item-container-title-bar -->\n        <client-summary-strip this-client=\"vm.client\" ></client-summary-strip>\n    </div><!-- // end app-item-container-header -->\n    <div class=\"app-item-container-items\"\n        dragula=\"\'drag-today-task\'\"\n        dragula-scope=\"$scope\"\n        ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n        layout-align=\"start start\"\n        resize=\"{{vm.suppressResize}}\"\n        panelid=\"today\"\n        >\n        <app-item\n            class=\"task-app-item\"\n            taskid=\"{{item.refID}}\"\n            order=\"{{item.todayorder}}\"\n            taskpanel=\"{{item.panel}}\"\n            client=\"{{item.client}}\"\n            ng-repeat=\"item in filteredTasks = (vm.tasks | toArray  : false | filter: {\'status\' : \'open\'} | filter: todayFilter | orderBy:[\'todayorder\']) track by $index\"\n        >\n\n        </app-item>\n        <div layout=\"column\" ng-if=\"!filteredTasks.length\" flex=\"100\" style=\"width:100%;\">\n            <p style=\"min-width: 258px; width: 100%; font-size:128px;\" class=\"center\"><md-icon md-font-icon=\"fa fa-smile-o\" style=\"font-size: 128px; color: rgba(200,200,200,.2);\"></md-icon></p>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/app-services/clientDataService/dialog-client.tmpl.html","<md-dialog md-dynamic-height flex=\"100\" flex-sm=\"70\" flex-md=\"80\" flex-lg=\"60\" flex-xl=\"40\" style=\"max-width: 800px; max-height: 800px;\" md-theme=\"grey-menu\" class=\" item-dialog client-item-dialog md-inline-form\">\n    <md-dialog-content ng-if=\"!vm.canEditClient\" style=\"padding: 50px; background-color: #fff;\">\n        <p class=\"text-center\"><img src=\"/assets/images/brand/adminja-bug.svg\" width=\"85\"></p>\n        <h3 class=\"text-center\">We\'re glad see you want to add another Workspace!</h3>\n        <h3 class=\"text-center\">Unfortunately, your plan only supports {{vm.clientLimit}} Workspaces and you have already reached that limit.</h3>\n        <p class=\"text-center\">You can add more by <a href=\"https://www.getadminja.com/upgrading-adminja\">upgrading</a> to a bigger plan.</p>\n        <p class=\"text-center\"> Visit your <a ui-sref=\"authentication.profile\">Profile</a> to learn more about your Adminja subscription.</p>\n    </md-dialog-content>\n    <form name=\"forms.clientDialogForm\" novalidate ng-if=\"vm.canEditClient\">\n        <fieldset ng-disabled=\"!vm.isAdmin\">\n        <md-dialog-content ng-if=\"!vm.client.status\" layout=\"column\" layout-align=\"center center\" style=\"height: 200px;\">\n            <h3 class=\"md-title\">Who is this Workspace for?</h3>\n            <div layout=\"row\" layout-align=\"space-between center\">\n                <md-button flex=\"nogrow\" class=\"md-secondary md-raised\" ng-click=\"vm.setupAsPersonalSpace();\">\n                    For Me\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-accent md-raised\" ng-click=\"vm.client.status = \'active\'\">\n                    For a Client\n                </md-button>\n            </div>\n        </md-dialog-content>\n        <!--- personal space form -->\n        <md-dialog-content ng-if=\"vm.client.status == \'personal\'\">\n            <md-toolbar class=\"md-primary\" style=\"background-color: {{vm.client.profile.clientColor}}\">\n                <div class=\"md-toolbar-tools\" layout=\"column\" style=\"padding-top: .5em;\">\n                    <h2 flex=\"100\" ng-show=\"!vm.client.profile.firstname\" class=\"center\">New Personal Workspace</h2>\n                </div>\n            </md-toolbar>\n            <div layout=\"column\" class=\"md-padding\">\n                <div layout=\"row\"layout-align=\"center center\" style=\"padding-top: 1em;\">\n                    <div flex=\"nogrow\" style=\"padding-right: 2em;\">\n\n                            <img ng-if=\"vm.client.profile.avatar\" class=\"client-card-avatar\"  src=\"{{vm.client.profile.avatar}}\" width=\"50\" height=\"50\"\n                            ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\" ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"/>\n                            <img ng-if=\"!vm.client.profile.avatar\" class=\"client-card-avatar\"  src=\"/assets/images/avatars/generic-avatar.png\" width=\"50\" height=\"50\"\n                            ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\" ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"/>\n\n\n                        <md-tooltip md-delay=\"50\">\n                            Change Logo\n                        </md-tooltip>\n                    </div>\n                    <md-input-container style=\"margin-top: 0;\" md-no-float flex=\"50\" >\n                        <input name=\"clientcompany\" style=\"max-width: 400px;\" ng-model=\"vm.client.profile.company\"  placeholder=\"Give your Workspace a name\" required>\n                    </md-input-container>\n\n                </div>\n                <div layout=\"column\" class=\"md-padding\">\n                    <div flex=\"nogrow\" style=\"position: relative;\">\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <span class=\"md-subhead\" style=\" padding-right: 1em;\">Select a color label:</span>\n                            <div style=\"position: relative; top: 3px;\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\" flex=\"nogrow\" aria-label=\"Assign Client a Color\" md-no-ink=\"true\" >\n                                <div class=\"swatch\" style=\"background-color: {{vm.client.profile.clientColor || \'#999\'}};\" >\n                                </div>\n                                <md-icon style=\"position: relative; top: -11px;\" flex=\"none\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon>\n                            </div class=\"toggleSwatch\">\n                        </div>\n                        <div class=\"colorPicker\" ng-if=\"vm.colorPicker && vm.canEdit\">\n                            <lk-color-chooser  ng-change=\"vm.togglePicker()\"  colors=\"vm.clientColors\" selected-color=\"vm.client.profile.clientColor\" ng-model=\"vm.client.profile.clientColor\" ng-click=\"vm.colorChange(forms.clientDialogForm);\"></lk-color-chooser>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions ng-if=\"vm.client.status == \'personal\'\" style=\"border-top: none;\" class=\"md-padding\">\n            <div layout=\"row\" layout-align=\"center end\">\n                <!-- <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.client.uid && vm.isOwner\">\n                    <md-button type=\"button\" class=\"\" ng-click=\"vm.deleteClient(vm.client)\">Delete</md-button>\n                </div> -->\n\n                <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button type=\"button\" class=\"\" ng-click=\"vm.cancelDialog(vm.client)\">Cancel</md-button>\n                </div>\n                <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.client.uid\">\n                    <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveUpdatedClient(vm.client)\">Update</md-button>\n                    <label class=\"shortcut\">ctrl + enter</label>\n                </div>\n                <div ng-if=\"!vm.client.uid\" flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewClient(vm.client)\">Create</md-button>\n                    <label class=\"shortcut\">ctrl + enter</label>\n                </div>\n\n            </div>\n        </md-dialog-actions>\n        <!--- client space form -->\n        <md-dialog-content ng-if=\"vm.client.status == \'active\'\" >\n            <md-toolbar class=\"md-primary\" style=\"background-color: {{vm.client.profile.clientColor}}\">\n                <div class=\"md-toolbar-tools\" layout=\"column\" style=\"padding-top: .5em;\">\n                    <h2 flex=\"100\" ng-show=\"!vm.client.profile.firstname\" class=\"center\">{{vm.title}}</h2>\n                    <h2 flex=\"100\" ng-show=\"vm.client.profile.isCompany\" class=\"center\">{{vm.client.profile.company}}</h2>\n                    <h2 flex=\"100\" ng-show=\"!vm.client.profile.isCompany\" class=\"center\">{{vm.client.profile.firstname}} {{vm.client.profile.lastname}}</h2>\n\n                </div>\n            </md-toolbar>\n            <md-tabs md-dynamic-height class=\"md-primary\" md-selected=\"vm.selectedTabIndex\" md-stretch-tabs=\"always\">\n                <!-- General Task Details -->\n                <md-tab md-on-select=\"vm.onTabChanges(0)\">\n                    <md-tab-label>\n                        <md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-account\"></md-icon>\n                        <span class=\"hide-sm hide-xs\">Key Info</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\"  class=\"md-padding\">\n                                <!-- <div ng-if=\"!vm.client.uid\" style=\"background-color: #aaa; margin-bottom: 1em;\">\n                                    <p class=\"alert-success center\" style=\"color: #fff;\">\n                                        Go get started right away, just fill in the Client information below.<br>\n                                        You can come back later to flesh out their profile via the other tabs above.<br>\n                                        Don\'t forget to assign a color and set up their billing plan!\n                                    </p>\n                                </div> -->\n                                <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" style=\"padding-top: 1em;\">\n                                    <div flex=\"nogrow\" style=\"padding-right: 2em;\">\n                                        <span ng-show=\"vm.client.profile.avatar\">\n                                            <img class=\"client-card-avatar\"  src=\"{{vm.client.profile.avatar}}\" width=\"50\" height=\"50\"\n                                            ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\" ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"/>\n                                        </span>\n                                        <span ng-hide=\"vm.client.profile.avatar\">\n                                            <img class=\"client-card-avatar\" src=\"/assets/images/avatars/generic-avatar.png\" width=\"50\" height=\"50\" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\" ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"/>\n                                        </span>\n                                        <md-tooltip md-delay=\"50\">\n                                            Change Photo\n                                        </md-tooltip>\n                                    </div>\n                                    <div flex=\"auto\" layout=\"row\">\n                                        <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                            <input name=\"clientfirstname\" ng-model=\"vm.client.profile.firstname\" ng-model-options=\"vm.inputOptions\"  placeholder=\"First Name\" required>\n                                        </md-input-container>\n                                        <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                            <input name=\"clientlastname\" ng-model=\"vm.client.profile.lastname\" ng-model-options=\"vm.inputOptions\" placeholder=\"Last Name\" required>\n                                        </md-input-container>\n                                    </div>\n                                </div>\n                                <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center space-between\" style=\"padding-top: 1em;\">\n                                    <div flex flex-gt-sm=\"40\" style=\"padding-right: 2em;\">\n                                        <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                            <input placeholder=\"Primary Email\" name=\"clientemail\" ng-model=\"vm.client.profile.email\" type=\"email\" ng-model-options=\"vm.inputOptions\" required>\n                                        </md-input-container>\n                                    </div>\n                                    <div flex flex-gt-sm=\"40\" style=\"position: relative;\" layout=\"column\">\n                                        <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\">\n                                            <span flex=\"nogrow\" class=\"md-subhead\" style=\" padding-right: 1em;\">Select a color label:</span>\n                                            <div flex style=\"position: relative; top: 3px;\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\" flex=\"nogrow\" aria-label=\"Assign Client a Color\" md-no-ink=\"true\" >\n                                                <div class=\"swatch\" style=\"background-color: {{vm.client.profile.clientColor || \'#999\'}};\" >\n                                                </div>\n                                                <!-- <md-icon style=\"position: relative; top: -11px;\" flex=\"none\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon> -->\n                                            </div class=\"toggleSwatch\">\n                                        </div>\n                                        <div class=\"color-picker\" ng-if=\"vm.colorPicker && vm.canEdit\">\n                                            <lk-color-chooser   ng-change=\"vm.togglePicker()\" colors=\"vm.clientColors\" selected-color=\"vm.client.profile.clientColor\" ng-model=\"vm.client.profile.clientColor\" ng-click=\"vm.colorChange(forms.clientDialogForm);\"></lk-color-chooser>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- Plan -->\n                                <p ng-if=\"vm.isOwner\" class=\"center md-subhead\" style=\"margin: 1em 0 0 0;\">How do you track time for this client?</p>\n                                <div ng-if=\"vm.isOwner\" layout=\"row\" layout-align=\"center center\">\n                                    <md-radio-group ng-model=\"vm.client.profile.plan.type\" flex=\"nogrow\" ng-required=\"true\">\n                                        <md-radio-button value=\"retainer\" class=\"md-primary\" style=\"margin-right: 1em;\">Against a monthly retainer plan</md-radio-button>\n                                        <md-radio-button value=\"hourly\">Pay as they go</md-radio-button>\n                                    </md-radio-group>\n                                </div>\n                                <div layout=\"column\" ng-if=\"vm.isOwner && vm.client.profile.plan.type\" style=\"background-color: #efefef; border-radius: 4px; border: 1px solid rgba(100,100,100,.5); margin-top: 1em;\" class=\"md-padding\">\n                                    <!-- <p class=\"md-headline center\">Client Billing Plan</p> -->\n                                    <div ng-show=\"vm.client.profile.plan.type == \'retainer\'\" style=\"margin-top: 1em;\">\n                                        <div layout=\"row\" layout-align=\"center space-between\">\n                                            <md-input-container flex=\"nogrow\">\n                                                <label>Monthly Rate</label>\n                                                <md-icon>{{vm.currency}}</md-icon>\n                                                <input name=\"rate\" type=\"number\" step=\"any\" maxlength=\"7\" ng-model=\"vm.client.profile.plan.cost\" ng-change=\"vm.changeBilling()\"  placeholder=\"000.00\">\n                                            </md-input-container>\n                                            <md-input-container  flex=\"nogrow\">\n                                                <label>Hours Included</label>\n                                                <input name=\"allocated\" type=\"number\" step=\"any\"  maxlength=\"5\" ng-model=\"vm.client.profile.plan.allocated\" ng-change=\"vm.changeBilling()\" placeholder=\"00\">\n                                            </md-input-container>\n                                            <md-input-container flex=\"nogrow\">\n                                                <label ng-if=\"vm.client.uid\">Next Renewal:</label>\n                                                <label ng-if=\"!vm.client.uid\">Client Start Date:</label>\n                                                  <md-datepicker style=\"position: relative; top: -8px;required md-date-filter=\"vm.cycleDateLimit()\" ng-model=\"vm.client.profile.plan.nextCycle\" name=\"nextCycle\" ng-change=\"vm.showCycleWarning();\"></md-datepicker>\n                                            </md-input-container>\n                                        </div>\n                                        <div ng-if=\"!vm.client.profile.plan.nextCycle && vm.client.uid\" >\n                                            <p class=\"md-subhead text-center\" >\n                                                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: orange;\"></md-icon> <span style=\"color: orange;\">Please specify a start date for this client\'s billing cycles.<br></span>\n                                            </p>\n                                             <p class=\"md-subhead text-center\"><strong>Suggested start date<br> based on client history: </strong>{{vm.suggestedRenew(vm.client.profile.plan.retainerStart)}}</p>\n                                        </div>\n                                        <div layout=\"row\" layout-align=\"center center\">\n                                            <div flex=\"nogrow\">\n                                                <div ng-if=\"vm.showRetainerChangeWarning && vm.client.profile.plan.nextCycle && vm.client.uid\">\n                                                    <p style=\"color: orange;\" class=\"text-center\">Changes made to the client\'s billing only affect FUTURE billing periods. <br>Please visit this client\'s \"Billing\" tab to make changes to existing periods.</span></p>\n                                                </div>\n                                                <div ng-if=\"vm.showRetainerWarning\">\n                                                    <p style=\"color: orange;\" class=\"text-center\">This client\'s billing cycle will start on the date selected<br> and renew on the same day each month. <br></p>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div ng-show=\"vm.client.profile.plan.type == \'hourly\'\" style=\"margin-top: 1em;\">\n                                        <div layout=\"row\" layout-align=\"center space-between\">\n                                            <md-input-container flex=\"nogrow\">\n                                                <label>Hourly Rate</label>\n                                                <md-icon>{{vm.currency}}</md-icon>\n                                                <input name=\"hourlyrate\" type=\"number\" step=\"any\" ng-model=\"vm.client.profile.plan.rate\" placeholder=\"00.00\">\n                                            </md-input-container>\n                                                <md-input-container flex=\"nogrow\">\n                                                <label ng-if=\"vm.client.uid\">Next Cycle:</label>\n                                                <label ng-if=\"!vm.client.uid\">Client Start Date:</label>\n                                                <md-datepicker style=\"position: relative; top: -8px;\" required md-date-filter=\"vm.cycleDateLimit\" ng-model=\"vm.client.profile.plan.nextCycle\" name=\"nextCycle\" ng-change=\"vm.showCycleWarning();\"></md-datepicker>\n                                            </md-input-container>\n                                        </div>\n                                        <div ng-if=\"!vm.client.profile.plan.nextCycle && vm.client.uid\" >\n                                            <p class=\"md-subhead text-center\" >\n                                                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: orange;\"></md-icon> <span style=\"color: orange;\">Please specify this client\'s current cycle date.<br></span>\n                                            </p>\n                                            <p class=\"md-subhead text-center\"><strong>Suggested Cycle Date: </strong> e<br> based on client history: {{vm.suggestedRenew(vm.client.profile.plan.retainerStart)}}</p>\n                                        </div>\n                                        <div layout=\"row\" layout-align=\"center center\">\n                                            <div flex=\"nogrow\">\n\n                                            <div ng-if=\"vm.showRetainerWarning\">\n                                                <p style=\"color: orange;\" class=\"text-center\">This client\'s billing cycle will start on the date selected and renew every month thereafter. <br><span ng-if=\"vm.client.uid\">Your current billing period will be lengthened or shortened to accommodate.</span></p>\n                                            </div>\n                                        </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n                        <!-- <div layout=\"row\" class=\"md-padding\" layout-align=\"end center\"> -->\n                        <!-- The client start date was automatically set when they set their first cycle date. it is historical, not editable -->\n                        <div style=\"margin-top: 1em;\" flex=\"nogrow\" ng-if=\"vm.client.profile.startDate\">\n                         <md-input-container >\n                            <label>Start Date</label>\n                            <md-datepicker ng-disabled=\"true\" class=\"md-indigo-theme md-primary\" ng-model=\"vm.client.profile.startDate\" md-placeholder=\"\" md-current-view=\"month\"></md-datepicker>\n                            <md-tooltip>\n                                Reflects this client\'s initial cycle start date.\n                            </md-tooltip>\n                        </md-input-container>\n                        </div>\n\n                    </md-tab-body>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabChanges(1)\">\n                    <md-tab-label>\n                        <md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n                        <span class=\"hide-sm hide-xs\">Contact Info</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\"  class=\"layout-padding\">\n                            <div layout=\"column\" layout-gt-sm=\"row\" style=\"padding-top: 2em;\">\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                    <input placeholder=\"Primary Phone\" name=\"clientphone\" ng-model=\"vm.client.profile.phone\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                            </div>\n\n                            <div layout=\"column\">\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n\n                                    <input placeholder=\"Street Address\" name=\"clientaddress\" ng-model=\"vm.client.profile.address.street\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\" flex>\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n\n                                    <input placeholder=\"City or Town\" type=\"text\" name=\"clientcity\" ng-model=\"vm.client.profile.address.city\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex=\"30\">\n\n                                    <input placeholder=\"State/Province/Region\" type=\"text\" name=\"clientstate\" ng-model=\"vm.client.profile.address.state\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex=\"20\">\n\n                                    <input placeholder=\"ZIP/Postal Code\" type=\"text\" name=\"clientzip\" ng-model=\"vm.client.profile.address.zip\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n\n                            </div>\n                            <div layout=\"row\" layout-align=\"start center\" style=\"padding-bottom: 1em;\">\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                    <md-select ng-disabled=\"!vm.canEdit\" placeholder=\"Country\" ng-model=\"vm.client.profile.address.country\">\n                                        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n                                    </md-select>\n                                </md-input-container>\n                                <md-input-container style=\"margin-top: 0;\" md-no-float flex>\n                                    <md-select ng-disabled=\"!vm.canEdit\" placeholder=\"Client timezone\" ng-model=\"vm.client.profile.timezone\">\n                                        <md-optgroup label=\"US & Canada\">\n                                            <md-option value=\"America/Newfoundland - CNT\">America/Newfoundland - CNT</md-option>\n                                            <md-option value=\"America/New York - EST\">America/New York - EST</md-option>\n                                            <md-option value=\"America/Chicago - CST\">America/Chicago - CST</md-option>\n                                            <md-option value=\"America/Indiana Eastern Standard - IET\">America/Indiana Eastern Standard - IET</md-option>\n                                            <md-option value=\"America/Denver - MST\">America/Denver - MST</md-option>\n                                            <md-option value=\"America/Phoenix - PNT\">America/Phoenix - PNT</md-option>\n                                            <md-option value=\"America/Los Angeles-PST\">America/Los Angeles-PST</md-option>\n                                            <md-option value=\"America/Juneau - AST\">America/Juneau - AST</md-option>\n                                            <md-option value=\"America/Honolulu - HST\">America/Honolulu - HST</md-option>\n                                            <md-option value=\"Puerto Rico and US Virgin Islands - PRT\">Puerto Rico and US Virgin Islands - PRT</md-option>\n                                        </md-optgroup>\n                                        <md-optgroup label=\"Europe\">\n                                            <md-option value=\"Europe/London - WET\">Europe/London - WET</md-option>\n                                            <md-option value=\"Europe/Paris - CET\">Europe/Paris - CET</md-option>\n                                            <md-option value=\"Europe/Athens - EET\">Europe/Athens - EET</md-option>\n                                            <md-option value=\"Europe/Moscow - FET\">Europe/Moscow - FET</md-option>\n                                        </md-optgroup>\n                                        <md-optgroup label=\"Global\">\n                                            <md-option value=\"(Arabic) Egypt Standard   - ART\">(Arabic) Egypt Standard - ART</md-option>\n                                            <md-option value=\"Eastern African   - EAT\">Eastern African - EAT</md-option>\n                                            <md-option value=\"Middle East   - MET\">Middle East - MET</md-option>\n                                            <md-option value=\"Near East - NET\">Near East - NET</md-option>\n                                            <md-option value=\"Pakistan Lahore   - PLT\">Pakistan Lahore - PLT</md-option>\n                                            <md-option value=\"India Standard Time - IST\">India Standard Time - IST</md-option>\n                                            <md-option value=\"Bangladesh Standard   - BST\">Bangladesh Standard - BST</md-option>\n                                            <md-option value=\"Vietnam Standard  - VST\">Vietnam Standard - VST</md-option>\n                                            <md-option value=\"China Taiwan  - CTT\">China Taiwan - CTT</md-option>\n                                            <md-option value=\"Japan Standard Time - JST\">Japan Standard Time - JST</md-option>\n                                            <md-option value=\"Australia Western - AWT\">Australia Western - AWT</md-option>\n                                            <md-option value=\"Australia Central - ACT\">Australia Central - ACT</md-option>\n                                            <md-option value=\"Australia Eastern - AET\">Australia Eastern - AET</md-option>\n                                            <md-option value=\"Solomon Standard  - SST\">Solomon Standard - SST</md-option>\n                                            <md-option value=\"New Zealand Standard  - NST\">New Zealand Standard - NST</md-option>\n                                            <md-option value=\"Midway Islands - MIT\">Midway Islands - MIT</md-option>\n                                            <md-option value=\"Argentina Standard - AGT\">Argentina Standard - AGT</md-option>\n                                            <md-option value=\"Brazil Eastern - BET\">Brazil Eastern - BET</md-option>\n                                            <md-option value=\"Central African    - CAT\">Central African - CAT</md-option>\n                                        </md-optgroup>\n                                    </md-select>\n                                </md-input-container>\n\n                            </div>\n\n\n                            <div layout=\"row\" layout-align=\"start center\">\n                                <md-input-container style=\"margin-top: 0;\" flex=\"nogrow\">\n                                    <md-select ng-disabled=\"!vm.canEdit\" ng-model=\"vm.client.profile.birthday.month\" placeholder=\"Birthmonth\">\n                                        <md-option value=\"1\">January</md-option>\n                                        <md-option value=\"2\">February</md-option>\n                                        <md-option value=\"3\">March</md-option>\n                                        <md-option value=\"4\">April</md-option>\n                                        <md-option value=\"5\">May</md-option>\n                                        <md-option value=\"6\">June</md-option>\n                                        <md-option value=\"7\">July</md-option>\n                                        <md-option value=\"8\">August</md-option>\n                                        <md-option value=\"9\">September</md-option>\n                                        <md-option value=\"10\">October</md-option>\n                                        <md-option value=\"11\">November</md-option>\n                                        <md-option value=\"12\">December</md-option>\n                                    </md-select>\n                                </md-input-container>\n                                <md-input-container style=\"margin-top: 0;\" flex=\"nogrow\">\n                                    <md-select ng-disabled=\"!vm.canEdit\" ng-model=\"vm.client.profile.birthday.day\" placeholder=\"Birthday\">\n                                        <md-option value=\"1\">1</md-option>\n                                        <md-option value=\"2\">2</md-option>\n                                        <md-option value=\"3\">3</md-option>\n                                        <md-option value=\"4\">4</md-option>\n                                        <md-option value=\"5\">5</md-option>\n                                        <md-option value=\"6\">6</md-option>\n                                        <md-option value=\"7\">7</md-option>\n                                        <md-option value=\"8\">8</md-option>\n                                        <md-option value=\"9\">9</md-option>\n                                        <md-option value=\"10\">10</md-option>\n                                        <md-option value=\"11\">11</md-option>\n                                        <md-option value=\"12\">12</md-option>\n                                        <md-option value=\"13\">13</md-option>\n                                        <md-option value=\"14\">14</md-option>\n                                        <md-option value=\"15\">15</md-option>\n                                        <md-option value=\"16\">16</md-option>\n                                        <md-option value=\"17\">17</md-option>\n                                        <md-option value=\"18\">18</md-option>\n                                        <md-option value=\"19\">19</md-option>\n                                        <md-option value=\"20\">20</md-option>\n                                        <md-option value=\"21\">21</md-option>\n                                        <md-option value=\"22\">22</md-option>\n                                        <md-option value=\"23\">23</md-option>\n                                        <md-option value=\"24\">24</md-option>\n                                        <md-option value=\"25\">25</md-option>\n                                        <md-option value=\"26\">26</md-option>\n                                        <md-option value=\"27\">27</md-option>\n                                        <md-option value=\"28\">28</md-option>\n                                        <md-option value=\"29\">29</md-option>\n                                        <md-option value=\"30\">30</md-option>\n                                        <md-option value=\"31\">31</md-option>\n                                    </md-select>\n                                    <!-- <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.client.profile.dob\" md-placeholder=\"__/__\" md-current-view=\"year\"></md-datepicker> -->\n                                </md-input-container>\n                                <!-- <md-input-container>\n                                    <input type=\"number\" ng-model=\"vm.client.profile.birthday.year\" placeholder=\"Birth Year\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container> -->\n                            </div>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabChanges(2)\">\n                    <md-tab-label>\n                        <md-icon style=\"font-size: 14px!important;\" md-font-icon=\"fa fa-briefcase\"></md-icon>\n                        <span class=\"hide-sm hide-xs\">Business</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\" class=\"md-padding\">\n                            <div layout=\"column\" layout-gt-xs=\"row\">\n                                <md-input-container flex>\n                                    <label>Company</label>\n                                    <input name=\"clientcompany\" ng-model=\"vm.client.profile.company\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Position</label>\n                                    <input name=\"clientposition\" ng-model=\"vm.client.profile.position\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex style=\"margin-top: 0;\">\n                                    <md-checkbox ng-disabled=\"!vm.canEdit\" ng-model=\"vm.client.profile.isCompany\" aria-label=\"Show as company\" >\n                                        Treat this client as a company\n                                    </md-checkbox>\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\">\n\n                                <md-input-container flex>\n                                    <label>Street Address</label>\n                                    <input name=\"clientaddress\" ng-model=\"vm.client.profile.companyAddress.street\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\" flex>\n                                <md-input-container flex>\n                                    <label>City or Town</label>\n                                    <input type=\"text\" name=\"clientcity\" ng-model=\"vm.client.profile.companyAddress.city\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n\n                            </div>\n                            <div layout=\"row\" flex>\n                                <md-input-container flex>\n                                    <label>State/Province/Region</label>\n                                    <input type=\"text\" name=\"clientstate\" ng-model=\"vm.client.profile.companyAddress.state\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>ZIP/Postal Code</label>\n                                    <input type=\"text\" name=\"clientzip\" ng-model=\"vm.client.profile.companyAddress.zip\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Country</label>\n                                    <md-select ng-disabled=\"!vm.canEdit\" placeholder=\"Country\" ng-model=\"vm.client.profile.companyAddress.country\">\n                                        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n                                    </md-select>\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <md-input-container flex>\n                                    <label>Work Email</label>\n                                    <input name=\"clientcompanyemail\" ng-model=\"vm.client.profile.companyemail\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Work Phone #</label>\n                                    <input name=\"clientcompanyphone\" ng-model=\"vm.client.profile.companyphone\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <md-input-container flex>\n                                    <label>Work Fax</label>\n                                    <input name=\"clientcompanyfax\" ng-model=\"vm.client.profile.companyfax\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Company Website</label>\n                                    <input name=\"clientcompanyurl\" ng-model=\"vm.client.profile.companyurl\" ng-model-options=\"vm.inputOptions\" >\n                                </md-input-container>\n                            </div>\n\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabChanges(3)\">\n                    <md-tab-label>\n                        <md-icon style=\"font-size: 14px!important;\" md-font-icon=\"fa fa-comments-o\"></md-icon>\n                        <span class=\"hide-sm hide-xs\">Social</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\" layout-gt-md=\"column\" class=\"md-padding\">\n                            <md-input-container flex>\n                                <label>Twitter</label>\n                                <input name=\"clienttwitter\" ng-model=\"vm.client.profile.twitter\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Facebook</label>\n                                <input name=\"clientfacebook\" ng-model=\"vm.client.profile.facebook\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>LinkedIn</label>\n                                <input name=\"clientlinkedin\" ng-model=\"vm.client.profile.linkedin\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Instagram</label>\n                                <input name=\"clientinstagram\" ng-model=\"vm.client.profile.instagram\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n                            </md-input-container>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab ng-if=\"vm.client.uid\" md-on-select=\"vm.hideButtons = true; vm.onTabChanges(4)\" md-on-deselect=\"vm.hideButtons = false\">\n                    <md-tab-label>\n                        <md-icon style=\"font-size: 14px!important;\" md-font-icon=\"fa fa-users\"></md-icon>\n                        <span class=\"hide-sm hide-xs\">Team</span>\n                    </md-tab-label>\n                    <md-tab-body style=\"padding: 2em 1em 1em 1em;\">\n                        <p class=\"md-headline text-center\">Team Member Access</p>\n\n                        <div class=\"client-team-list\">\n                          <team-member-card ng-if=\"member.status == \'active\'\" ng-repeat=\"member in teamList = (vm.teamList | toArray : false  |orderBy: [\'-info.lastName\']) track by $index\" displaytype=\"client-list\" member=\"member\" team=\"{{vm.client.owner}}\" clientid=\"{{vm.client.uid}}\" editallowed=\"{{vm.isAdmin}}\"></team-member-card>\n                        </div>\n\n                    </md-tab-body>\n                </md-tab>\n\n            </md-tabs>\n            </fieldset>\n            <md-dialog-actions ng-if=\"!vm.hideButtons && vm.client.status == \'active\'\" style=\"border-top: none;\" class=\"md-padding\">\n                <div layout=\"row\" layout-align=\"end center\">\n                    <!-- <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.client.uid && vm.isOwner\">\n                        <md-button type=\"button\" class=\"\" ng-click=\"vm.deleteClient(vm.client)\">Delete</md-button>\n                    </div> -->\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button type=\"button\" class=\"\" ng-click=\"vm.cancelDialog(vm.client)\">Cancel</md-button>\n                    </div>\n                    <div ng-if=\"vm.isOwner || vm.canEdit\">\n                        <!-- the following buttons help guide user through the tabs when creating a new client -->\n                        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.client.uid\">\n                            <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveUpdatedClient(vm.client, vm.prevPlan.nextCycle)\">Save</md-button>\n                            <label class=\"shortcut\">ctrl + enter</label>\n                        </div>\n                        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid && vm.client.profile.plan.type\">\n                            <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewClient(vm.client)\">Save</md-button>\n                            <label class=\"shortcut\">ctrl + enter</label>\n                        </div>\n\n                        <!-- <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.profile.plan.type && vm.selectedTabIndex != 1\">\n                            <md-button type=\"button\" ng-disabled=\"!vm.client.profile.email\" class=\"md-adminja-shade-theme md-accent md-raised\">Select a billing plan</md-button>\n                        </div> -->\n                    </div>\n                    <md-button class=\"md-button-small\" ng-disabled=\"true\" flex=\"nogrow\" ng-if=\"!vm.client.uid && vm.client.profile.plan.type\">or</md-button>\n                    <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid && vm.client.profile.plan.type && vm.selectedTabIndex == \'0\'\">\n                        <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\"  class=\"md-adminja-shade-theme md-secondary\" ng-click=\"vm.changeTab(1)\">Enter Contact Info <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" style=\"font-size: 12px;\"></md-icon></md-button>\n                    </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid && vm.client.profile.plan.type && vm.selectedTabIndex == \'1\'\">\n                        <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\"  class=\"md-adminja-shade-theme md-secondary\" ng-click=\"vm.changeTab(2)\">Enter Business info <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" style=\"font-size: 12px;\"></md-icon></md-button>\n                    </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid && vm.client.profile.plan.type && vm.selectedTabIndex == \'2\'\">\n                        <md-button type=\"button\" ng-disabled=\"forms.clientDialogForm.$invalid || forms.clientDialogForm.$pristine\"  class=\"md-adminja-shade-theme md-secondary\" ng-click=\"vm.changeTab(3)\">Enter Social info <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" style=\"font-size: 12px;\"></md-icon></md-button>\n                    </div>\n                </div>\n            </md-dialog-actions>\n        </md-dialog-content>\n\n    </form>\n\n</md-dialog>\n");
$templateCache.put("app/app-services/invoiceService/emailInvoice.html","<md-dialog flex=\"100\" flex-gt-sm=\"40\">\n	<md-dialog-content class=\"md-padding\">\n		<h3 class=\"md-title\">Email Invoice</h3>\n\n		<md-input-container>\n			<label>Recipient\'s address</label>\n			<input ng-model=\"vm.recipientEmail\" required>\n		</md-input-container>\n		<p style=\"text-align:right;\"><md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-click=\"vm.sendPDF(vm.recipientEmail)\" class=\"md-accent md-raised\">Send Invoice</md-button></p>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/noteDataService/dialog-edit-note.tmpl.html"," <md-dialog flex=\"100\" flex-sm=\"90\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\" md-theme=\"grey-menu\" class=\"item-dialog md-inline-form\">\n    <md-dialog-content>\n        <md-tabs md-dynamic-height class=\"md-primary task-tabs\" md-selected=\"vm.selectedTab\" md-stretch-tabs=\"always\">\n            <!-- General Task Details -->\n            <md-tab md-on-select=\"showTaskControls();\" md-on-deselect=\"hideTaskControls();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n                    <span class=\"hide-for-medium\" ng-if=\"vm.editedItem.uid\">Task Details</span>\n                    <span class=\"hide-for-medium\" ng-if=\"!vm.editedItem.uid\">New Task Details</span>\n                </md-tab-label>\n                <md-tab-body layout=\"column\" layout-padding>\n                    <form name=\"taskDialogForm\" novalidate>\n                        <!-- checkbox and title -->\n\n\n                            <!-- description -->\n                            <!-- if we have ID, then we don\'t autofocus the field -->\n                            <div flex md-padding>\n                            <md-input-container class=\"task-description-container\">\n                                <textarea ng-disabled=\"vm.editedItem.info.status == \'closed\'\" name=\"description\" md-autofocus=\"!vm.editedItem.uid\" md-no-asterisk ng-model=\"vm.editedItem.info.description\" placeholder=\"Task description\" required=\"required\"></textarea>\n                            </md-input-container>\n                            </div>\n\n                        <div flex layout=\"row\" layout-align=\"start center\" style=\"padding-top: .5em;\">\n                            <div flex style=\"padding-right: 2em;\" class=\"date-label-container\">\n                                <label>Due Date</label>\n                                <md-datepicker ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"\" ng-model=\"vm.editedItem.info.duedate\" md-placeholder=\"Due\"></md-datepicker>\n                            </div>\n                            <div flex>\n\n                            <md-input-container >\n                                <label>Client</label>\n                                <md-select ng-disabled=\"vm.editedItem.uid\" md-no-asterisk placeholder=\"Please select a client\" ng-model=\"vm.editedItem.info.client\" required>\n                                    <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                    <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"30\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                    <span class=\"small\">{{client.name}}</span></md-option>\n                                </md-select>\n                            </md-input-container>\n                            </div>\n\n\n                        </div>\n                        <!-- autocomplete tags - not fully functional -->\n\n                        <!--<div layout=\"row\" layout-align=\"start center\" md-padding>\n                                <div flex=\"10\" class=\"center\">\n                                    <md-icon tabindex=\"-1\" md-font-icon=\"fa fa-tags\" >\n                                    </md-icon>\n                                </div>\n                                <div flex=\'80\'>\n                                    <md-chips ng-model=\"vm.editedItem.info.tags\" md-autocomplete-snap readOnly=false>\n                                          <md-autocomplete\n                                              md-items=\"item in queryTags(vm.searchText)\"\n                                              md-select-on-match = true\n                                              md-transform-chip= transformChip($chip)\n                                              md-no-cache = true\n                                              md-selected-item-change = tagSelected(vm.selectedItem)\n                                              md-selected-item=\"vm.selectedItem\"\n                                              md-search-text=\"vm.searchText\"\n                                              md-item-text=\"item.name\"\n                                              md-require-match\n                                              placeholder=\"Add tags\">\n                                            <span md-highlight-text=\"vm.searchText\">{{item.name}}</span>\n                                          </md-autocomplete>\n                                          <md-chip-template md-highlight-text=\"vm.searchText\">\n                                            {{$chip}}\n                                          </md-chip-template>\n                                        </md-chips>\n                                </div>\n                        </div>-->\n                            <!-- <md-divider class=\"md-padding\"></md-divider> -->\n                            <!-- Datepicker and Cilent -->\n\n                        <!-- budget -->\n\n\n                            <div flex style=\"padding-top: 1.5em;\">\n                                <p class=\"task-budget-label\" >\n                                    <span ng-show=\"!vm.editItem.info.budget\">Budget</span>\n                                </p>\n                             <md-slider ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"md-accent item-budget fade\" min=\"0\" max=\"240\" step=\"15\"  ng-model=\"vm.editedItem.info.budget\" ng-init=\"sliders.default=0\" aria-label=\"Task Budget\"></md-slider>\n                                <p class=\"task-budget-label right\" style=\"margin-top: -5px;\">\n                                    <span ng-show=\"vm.editedItem.info.budget\">{{vm.editedItem.info.budget /60}}hrs</span>\n                                    <span ng-show=\"vm.editedItem.info.logged\"> | Logged: {{vm.editedItem.info.logged / 60}}hrs</span>\n                                </p>\n                            </div>\n\n\n                        <div layout=\"column\"\n                        <!-- file management -->\n                        <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.isUploading && vm.numFiles < 5\"\n                                class=\"md-primary \"\n                                ngf-select=\"uploadFile($files)\"\n                                ngf-multiple=\"true\"\n                                ngf-max-files=\"3\"\n                                ngf-max-size=\"5mb\"\n                                ngf-drop=\"uploadFile($files)\"\n                                ngf-drag-over-class=\"\'dragover\'\"\n                                aria-label=\"upload\">\n                            <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Attach Files\n                            <div class=\"dropzone\">\n                                <p class=\"center\">Drop File to Upload</p>\n                            </div>\n                         </md-button>\n                        <md-button ng-if=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n                             <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n                                Uploading\n                        </md-button>\n\n                        <md-chips ng-model=\"vm.editedItem.info.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n                            <md-chip-template >\n                                 <strong><a href=\"{{$chip.url}}\" download>{{$chip.fileName}}</a></strong>\n                            </md-chip-template>\n                        </md-chips>\n\n                        </div>\n                    </form>\n                </md-tab-body>\n\n            </md-tab>\n\n            <!-- Task Notes -->\n            <md-tab ng-if=\"vm.editedItem.uid\" md-on-select=\"hideTaskControls(); setupNotes();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"fa fa-comment-o\"></md-icon> <span class=\"hide-for-medium\">Discussion</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                       <task-notes class=\"fade\" task=\"{{vm.editedItem.uid}}\" client=\"{{vm.editedItem.info.client}}\"></task-notes>\n                </md-tab-body>\n            </md-tab>\n            <!-- Time Log -->\n    <!--         <md-tab ng-if=\"vm.editedItem.uid\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> <span class=\"hide-for-medium\">Time</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <md-content style=\"height: 400px;\">\n                        <md-list class=\"md-dense\">\n                            <div class=\"time-entry-list-item\" ng-repeat=\"entry in vm.timeLogs track by $index\">\n                                <md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{entry.clientColor}};\">\n                                    <div class=\"md-list-item-text\" layout=\"column\">\n                                        <div flex layout=\"row\">\n                                            <h3 ng-show=\"!entry.task\">\n                                                        {{entry.description}}\n                                                    </h3>\n                                            <h3 ng-show=\"entry.task\">\n                                                        <md-icon aria-label=\"View Related Task\" md-font-icon=\"fa fa-check-square\">\n                                                            <md-tooltip md-delay=\"1000\">View Related Task</md-tooltip>\n                                                        </md-icon>\n                                                        {{entry.task}}\n                                                    </h3>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p><em>{{entry.date}}</em></p>\n                                            </div>\n                                            <div flex class=\"center\">\n                                            </div>\n                                            <div flex class=\"right\">\n                                                <h3><strong>{{entry.total}} min</strong></h3>\n                                            </div>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p class=\"right\"><em>{{entry.tag}}</em></p>\n                                            </div>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p class=\"left\">by {{entry.user}}</p>\n                                            </div>\n                                            <div flex>\n                                                <p class=\"right\">{{ entry.client }}</p>\n                                            </div>\n                                        </div>\n                                    </div> -->\n                                    <!-- end md-list-item-text -->\n                               <!--  </md-list-item>\n                                <md-divider></md-divider> -->\n                            <!-- </div> -->\n                            <!-- <md-subheader class=\"md-no-sticky\">2 line item</md-subheader> -->\n                       <!--  </md-list>\n                    </md-content>\n                    <h4 class=\"right\">Total: 3hrs 35min</h4>\n                </md-tab-body>\n            </md-tab> -->\n\n            <!-- Task Activity Log -->\n            <!--<md-tab ng-if=\"vm.editedItem.uid\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-receipt\"></md-icon> <span class=\"hide-for-medium\">Activity</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                <md-content style=\"max-height: 400px;\">\n                    <md-list class=\"md-dense\">\n                        <div class=\"activity-log-item\" ng-repeat=\"item in vm.editedItem.info.activity track by $index\">\n                            <md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{vm.clientColor}};\">\n                                <div class=\"md-list-item-text\" layout=\"column\">\n                                    <div flex layout=\"row\">\n                                        <h3 >\n                                                    {{item.event}}\n                                            </h3>\n                                    </div>\n                                    <div flex layout=\"row\">\n                                        <div flex>\n                                            <p><em am-time-ago=\"item.timestamp\"></em></p>\n                                        </div>\n                                        <div flex class=\"center\">\n                                        </div>\n                                        <div flex class=\"right\">\n                                            <h3><strong>{{item.actor}}</strong></h3>\n                                        </div>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                            <md-divider></md-divider>\n                        </div>\n                    </md-list>\n                    </md-content>\n                </md-tab-body>\n            </md-tab>-->\n        </md-tabs>\n\n    </md-dialog-content>\n    <md-dialog-actions ng-show=\"vm.taskControls\" layout=\"column\" layout-gt-sm=\"row\"  style=\"padding-bottom: 1em;\">\n        <div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n            <md-button flex=\"nogrow\"  ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.uid && vm.editedItem.info.panel == \'today\' && vm.editedItem.info.status != \'completed\'\">\n                <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-on\"  class=\"today-icon\">\n                </md-icon> Doing Today\n            </md-button>\n            <md-button flex=\"nogrow\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.uid && vm.editedItem.info.panel != \'today\' && vm.editedItem.info.status != \'completed\'\">\n                <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-off\"  class=\"today-icon\">\n                </md-icon> Doing later\n            </md-button>\n            <div flex=\"nogrow\"  ng-show=\"vm.editedItem.uid\">\n            <md-button ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'closed\'\" >\n                <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\" >\n                </md-icon>\n                Re-open\n            </md-button>\n            <md-button ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'open\'\">\n                <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\">\n                </md-icon>\n                Mark Complete\n            </md-button>\n            </div>\n        </div>\n        <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                    Cancel\n                </md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button ng-hide=\"vm.editedItem.uid\" ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" class=\"md-adminja-shade-theme md-primary\" ng-click=\"saveNewTask(vm.editedItem,\'andNew\')\">Add and New</md-button>\n                <label class=\"shortcut\">shift + ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid\">\n                <md-button   ng-disabled=\"taskDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                    Update Task\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid\">\n                <md-button  ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" type=\"submit\" class=\"md-adminja-shade-theme md-accent\" ng-click=\"saveNewTask(vm.editedItem)\">\n                    Add Task\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n        </div>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-services/panelDataService/dialog-profile-panel.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"md-inline-form dialog-panel\" style=\"min-height: 300px; width: 309px;\" >\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon> <span class=\"hide-for-medium\"><span ng-if=\"!vm.panel.uid\">New</span><span ng-if=\"vm.panel.uid\">Edit</span> Bucket</span>\n\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.panelDialogForm\">\n			<div layout=\"column\" class=\"md-padding\">\n				<md-input-container md-autofocus flex style=\"margin-bottom: 0;\">\n				       <label>Bucket Name</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.panel.label\" required>\n				 </md-input-container>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"!vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></md-button>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color <md-icon md-font-icon=\"zmdi zmdi-caret-up\"></md-icon></md-button>\n				 <div class=\"row\" layout-align=\"center center\">\n				 <div flex=\"nogrow\" ng-if=\"vm.showColors\" style=\"width: 235px;\">\n					 <lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.panel.color\" ng-model=\"vm.panel.color\" ng-change=\"toggleColors();\"></lk-color-chooser>\n				 </div>\n				</div>\n			</div>\n\n				<!-- <md-divider></md-divider> -->\n\n				<md-dialog-actions style=\"border-top: none;\" class=\"md-padding\">\n				    <div layout=\"row\" layout-align=\"center center\">\n				        <div flex=\"nogrow\" class=\"button-label-container\">\n				        	<md-button class=\"\" ng-click=\"cancelDialog(vm.panel)\">Cancel</md-button>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"updatePanel(vm.panel)\">Save</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button  ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid || !vm.panel.label\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"saveNewPanel(vm.panel)\">Add</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				    </div>\n				</md-dialog-actions>\n			</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/presenceService/dialog-presence.tmpl.html","<md-dialog flex-xs=\"100\" flex-sm=\"90\" flex-md=\"60\" flex-lg=\"50\" flex-gt-lg=\"40\" class=\"presence-dialog md-padding\">\n	<h3>{{vm.title}}</h3>\n	<p>{{vm.message}}</p>\n\n		<md-button ng-show=\"vm.showButton\" ng-click=\"vm.cancelDialog()\">Got it</md-button>\n\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-address.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-address md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Address</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\" novalidate>\n			<div layout=\"column\">\n			<div class=\"md-block text-center\" flex>\n				<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n				<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n			</div>\n				<md-input-container md-autofocus flex>\n				       <label>Who/What is this address for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Street Address</label>\n						<input name=\"detailaddress1\" ng-model=\"vm.detail.address1\" required>\n						<div ng-messages=\"vm.detail.address.$error\">\n						      <div ng-message=\"required\">Oops! It doesn\'t look like you put in an address!</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Address2</label>\n						<input name=\"detailaddress2\" ng-model=\"vm.detail.address2\">\n					</md-input-container>\n					<div layout=\"column\" layout-gt-md=\"row\">\n						<md-input-container flex class=\"md-block\">\n							<label>City or Town</label>\n							<input name=\"detailcity\" ng-model=\"vm.detail.city\">\n						</md-input-container>\n						<md-input-container flex=\"none\" class=\"md-block\">\n							<label>State/Province/Region</label>\n							<input name=\"detailstate\" ng-model=\"vm.detail.state\">\n						</md-input-container>\n					</div>\n					<div layout=\"column\" layout-gt-md=\"row\">\n						<md-input-container flex=\"none\" class=\"md-block\">\n							<label>Zip/Postal Code</label>\n							<input name=\"detailzip\" ng-model=\"vm.detail.zip\">\n						</md-input-container>\n						<md-input-container flex=\"none\" class=\"md-block\">\n						    <label>Country</label>\n						    <md-select placeholder=\"Country\" ng-model=\"vm.detail.country\">\n						        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<md-input-container flex=\"none\" class=\"md-block\">\n						<label>Related phone</label>\n						<input name=\"detailphone\" ng-model=\"vm.detail.number\">\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n				</form>\n\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n	<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n		<div flex=\"nogrow\" class=\"button-label-container\">\n			<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n			<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n				Save Changes\n			</md-button>\n			<label class=\"shortcut\">ctrl + enter</label>\n\n		</div>\n		<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n			<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n				Add Address\n			</md-button>\n			<label class=\"shortcut\">ctrl + enter</label>\n\n		</div>\n	</md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-email.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Email</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\" novalidate=\"\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>What is this address for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Email Address</label>\n						<input name=\"detailaddress\" ng-model=\"vm.detail.address\" type=\"email\" placeholder=\"address@domain.com\" required>\n\n						<div ng-messages=\"vm.detail.email.$error\">\n						      <div ng-message=\"required\">Oops! That doesn\'t look like a valid internet address.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Email\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-files.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"item-dialog edit-note md-inline-form\" flex-sm=\"100\" flex-md=\"40\" flex-lg=\"30\" flex-gt-lg=\"20\">\n<!-- note, above we are applying class of edit-note. That\'s because the files and note share same layout exactly. No need to duplicate CSS rules -->\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Web URL</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\">\n			<div layout=\"column\">\n				<div flex class=\"md-block text-center\">\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Title (optional)</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\">\n				 </md-input-container>\n			</div>\n			<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n			<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n				<!-- include our profile file upload snippet -->\n\n				<md-input-container flex class=\"md-block\">\n					<label>Description</label>\n					<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n				</md-input-container>\n			</div>\n\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Files\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-note.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"40\" md-theme=\"grey-menu\" class=\"edit-note md-inline-form\">\n	<md-dialog-content>\n\n	<md-tabs md-dynamic-height class=\"md-primary no-active\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab >\n			<md-tab-label>\n				<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> {{vm.title}} Note\n			</md-tab-label>\n			<md-tab-body >\n			<div layout=\"column\">\n				<div flex class=\"md-block text-center\">\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n			</div>\n			<form name=\"detailDialogForm\" novalidate >\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\" >\n					<div flex class=\"md-block\" >\n					<div style=\"background-color: {{vm.detail.notecolor}};\"\">\n					    <text-angular style=\"\" name=\"noteEditor\" ng-model=\"vm.detail.note\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\', \'insertLink\']]\" ></text-angular>\n					</div>\n							<div class=\"task-description-tooltip\">\n							    <md-icon md-font-icon=\"zmdi zmdi-help\">\n							        <md-tooltip md-delay=\"500\" class=\"help\" md-direction=\"top\">\n							            <p class=\"text-center\">\n							            	<strong>Paste as plain text</strong><br>\n							            	<strong>Mac:</strong> Shift + Option + Command + V<br>\n							            	<strong>PC:</strong> Control + Shift + V\n							            </p>\n							        </md-tooltip>\n							    </md-icon>\n							</div>\n\n					</div>\n				</div>\n\n			<!-- <div layout=\"column\">\n				<md-input-container md-autofocus flex>\n					  <label>Note Label (optional)</label>\n					  <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n\n\n			</div> -->\n\n\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"vm.filePath\"></file-attachments>\n				<!-- <div layout=\"column\" ng-include=\"\'app/app-services/profileDataService/include-profile-detail-files.tmpl.html\'\"></div> -->\n				<div layout=\"row\" ng-if=\"vm.showPicker\">\n					<div flex=\"50\">\n						<md-input-container class=\"md-block\" >\n						    <label>Workspace</label>\n						    <md-select required md-no-asterisk placeholder=\"Workspace\" ng-change=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.client\" required>\n						        <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n						        <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\"> <span class=\"small\">{{client.name}}</span></md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<div flex=\"50\">\n						<md-input-container class=\"md-block\">\n						    <label>Bucket</label>\n						    <md-select required md-no-asterisk placeholder=\"Bucket\" md-on-open=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.panel\" required>\n						        <md-option ng-repeat=\"panel in vm.panels track by $index\" value=\"{{panel.uid}}\">\n						        <span class=\"small\">{{panel.label}}</span></md-option>\n						    </md-select>\n\n						</md-input-container>\n					</div>\n				</div>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button  ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Note\n						</md-button>\n\n\n					</div>\n				</md-dialog-actions>\n\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-person.tmpl.html","<md-dialog flex=\"100\" flex-gt-md=\"50\" md-theme=\"grey-menu\" class=\"item-dialog edit-person md-inline-form\">\n    <form name=\"detailDialogForm\" novalidate>\n        <md-dialog-content>\n            <md-tabs md-dynamic-height class=\"md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n                <!-- General Task Details -->\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\">\n                        <div class=\"md-block text-center\" flex>\n                            <lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n                            <!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n                        </div>\n                            <md-input-container md-autofocus flex>\n                                   <label>Relationship</label>\n                                   <input name=\"detaillabel\" ng-model=\"vm.detail.label\">\n                             </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <md-input-container flex>\n                                <label>First Name</label>\n                                <input name=\"clientfirstname\" ng-model=\"vm.detail.firstname\" required>\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Last Name</label>\n                                <input name=\"clientlastname\" ng-model=\"vm.detail.lastname\" required>\n                            </md-input-container>\n                        </div>\n\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <div flex=\"50\" layout=\"column\" layout-align=\"center center\">\n                                <img ng-show=\"vm.detail.avatar\" src=\"{{vm.detail.avatar}}\" width=\"75\" height=\"75\"/><br>\n                                <img ng-hide=\"vm.detail.avatar\" src=\"/assets/images/avatars/generic-avatar.png\" width=\"75\" height=\"75\"/><br>\n                                <md-button type=\"button\"\n                                            ng-show=\"vm.detail.avatar\"\n                                            class=\"md-primary\"\n                                            ngf-select=\"uploadAvatar($files, vm.detail)\"\n                                            ngf-multiple=\"false\"\n                                            aria-label=\"upload\"\n                                            ngf-resize=\"{width: 75, height: 75, centerCrop: true}\"\n                                >\n                                    <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Change Photo\n                                </md-button>\n                                <md-button type=\"button\"\n                                            ng-hide=\"vm.detail.avatar\"\n                                            class=\"md-primary \"\n                                            ngf-select=\"uploadAvatar($files, vm.detail)\"\n                                            ngf-multiple=\"false\"\n                                            aria-label=\"upload\"\n                                            ngf-resize=\"{width: 75, height: 75, centerCrop: true}\"\n                                >\n                                    <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Upload Photo\n                                </md-button>\n                                <div flex>\n                                    <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.detail.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n                                </div>\n                            </div>\n                            <div flex=\"50\">\n                                <md-input-container flex>\n                                    <label>Primary Phone</label>\n                                    <input name=\"clientphone\" ng-model=\"vm.detail.phone\">\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Primary Email</label>\n                                    <input name=\"clientemail\" ng-model=\"vm.detail.email\" type=\"email\">\n                                </md-input-container>\n                            </div>\n                        </div>\n\n                        <!-- include our profile file upload snippet -->\n                        <file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n                        <div layout=\"row\" ng-if=\"vm.showPicker\">\n                            <div flex=\"50\">\n                                <md-input-container class=\"md-block\">\n                                    <label>Workspace</label>\n                                    <md-select required md-no-asterisk placeholder=\"Workspace\" ng-change=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.client\" required>\n                                        <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                        <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\"> <span class=\"small\">{{client.name}}</span></md-option>\n                                    </md-select>\n                                </md-input-container>\n                            </div>\n                            <div flex=\"50\">\n                                <md-input-container class=\"md-block\">\n                                    <label>Bucket</label>\n                                    <md-select required md-no-asterisk placeholder=\"Bucket\" md-on-open=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.panel\" required>\n                                        <md-option ng-repeat=\"panel in vm.panels track by $index\" value=\"{{panel.uid}}\">\n                                        <span class=\"small\">{{panel.label}}</span></md-option>\n                                    </md-select>\n\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">Company</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"row\"  layout-sm=\"column\">\n                            <md-input-container flex>\n                                <label>Company</label>\n                                <input name=\"clientcompany\" ng-model=\"vm.detail.company\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Position</label>\n                                <input name=\"clientposition\" ng-model=\"vm.detail.position\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <md-input-container flex>\n                                <label>Work Email</label>\n                                <input name=\"clientcompanyemail\" ng-model=\"vm.detail.companyemail\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Work Phone #</label>\n                                <input name=\"clientcompanyphone\" ng-model=\"vm.detail.companyphone\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <md-input-container flex>\n                                <label>Work Fax</label>\n                                <input name=\"clientcompanyfax\" ng-model=\"vm.detail.companyfax\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Company Website</label>\n                                <input name=\"clientcompanyurl\" ng-model=\"vm.detail.companyurl\">\n                            </md-input-container>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">Social</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                       <div layout=\"column\">\n                           <md-input-container flex>\n                               <label>Twitter</label>\n                               <input name=\"clienttwitter\" ng-model=\"vm.detail.twitter\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>Facebook</label>\n                               <input name=\"clientfacebook\" ng-model=\"vm.detail.facebook\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>linkedIn</label>\n                               <input name=\"clientlinkedin\" ng-model=\"vm.detail.linkedin\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>Instagram</label>\n                               <input name=\"clientinstagram\" ng-model=\"vm.detail.instagram\" type=\"text\">\n                           </md-input-container>\n                       </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> <span class=\"hide-for-medium\">Notes</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <md-input-container flex class=\"md-block\">\n                            <label>Notes</label>\n                            <textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n                        </md-input-container>\n                    </md-tab-body>\n                </md-tab>\n            </md-tabs>\n         <md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n                <md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n                    Save Changes\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n                <md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n                    Add Person\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n         </md-dialog-actions>\n        </md-dialog-content>\n    </form>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-phone.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Phone #</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Who/What is this phone # for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" required>\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Phone #</label>\n						<input name=\"detailphone\" ng-model=\"vm.detail.number\" required>\n\n						<div ng-messages=\"vm.detail.number.$error\">\n						      <div ng-message=\"required\">Oops! It doesn\'t look like you included a phone number.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Phone#\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-question.tmpl.html","<md-dialog md-theme=\"grey-menu\" flex=\"45\" class=\"item-dialog edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">{{ vm.title }} Question &amp; Answer</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\" novalidate>\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Question</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" required>\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<text-angular ng-model=\"vm.detail.a\" ta-toolbar=\"[[\'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\', \'insertLink\']]\" ></text-angular>\n\n					</md-input-container>\n				</div>\n				<md-divider></md-divider>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Q&amp;A\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-url.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"item-dialog edit-note md-inline-form\" flex=\"100\" flex-gt-sm=\"40\" >\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Bookmark</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Title (optional)</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\">\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>URL</label>\n						<input type=\"url\" name=\"detailurl\" ng-model=\"vm.detail.url\" placeholder=\"http://www.yoururl.com\" required>\n						{{vm.detail.url.$error}}\n						<div ng-messages=\"vm.detail.url.$error\">\n						      <div ng-message=\"required\">Oops! That doesn\'t look like a valid internet address.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<div layout=\"row\" layout-align=\"center center\">\n					<md-input-container flex>\n						<label style=\"margin-bottom: .5em;\" class=\"md-subhead\" ng-show=\"vm.detail.simpleEmbed\">Simple</label>\n						<label style=\"margin-bottom: .5em;\" class=\"md-subhead\" ng-show=\"!vm.detail.simpleEmbed\">Embedded</label>\n						<md-switch class=\"md-accent\" ng-model=\"vm.detail.simpleEmbed\" aria-label=\"Simple Embed\">\n					</md-switch>\n					<span ng-if=\"vm.detail.simpleEmbed\">Show a simple link</span>\n					<span ng-if=\"!vm.detail.simpleEmbed\">Show an embedded clip</span>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n				<div layout=\"row\" ng-if=\"vm.showPicker\">\n				    <div flex=\"50\">\n				        <md-input-container class=\"md-block\">\n				            <label>Workspace</label>\n				            <md-select required md-no-asterisk placeholder=\"Workspace\" ng-change=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.client\" required>\n				                <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n				                <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\"> <span class=\"small\">{{client.name}}</span></md-option>\n				            </md-select>\n				        </md-input-container>\n				    </div>\n				    <div flex=\"50\">\n				        <md-input-container class=\"md-block\">\n				            <label>Bucket</label>\n				            <md-select required md-no-asterisk placeholder=\"Bucket\" md-on-open=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.panel\" required>\n				                <md-option ng-repeat=\"panel in vm.panels track by $index\" value=\"{{panel.uid}}\">\n				                <span class=\"small\">{{panel.label}}</span></md-option>\n				            </md-select>\n\n				        </md-input-container>\n				    </div>\n				</div>\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add URL\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/include-profile-detail-files.tmpl.html","<md-button ng-if=\"!vm.isUploading && vm.numFiles < 5\"\n		class=\"md-primary \"\n		ngf-select=\"uploadFile($files)\"\n		ngf-multiple=\"true\"\n		ngf-max-files=\"3\"\n		ngf-max-size=\"5mb\"\n		ngf-drop=\"uploadFile($files)\"\n		ngf-drag-over-class=\"\'dragover\'\"\n		aria-label=\"upload\">\n	<md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Attach Files\n	<div class=\"dropzone\">\n		<p class=\"center\">Drop File to Upload</p>\n	</div>\n </md-button>\n<md-button ng-if=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n	 <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n		Uploading\n</md-button>\n\n<md-chips ng-model=\"vm.detail.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n	<md-chip-template >\n		 <strong><a href=\"{{$chip.url}}\" download>{{$chip.fileName}}</a></strong>\n	</md-chip-template>\n</md-chips>\n");
$templateCache.put("app/app-services/taskDataService/dialog-edit-batch.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"60\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\" class=\"item-dialog task-item-dialog md-inline-form\">\n    <md-dialog-content>\n        <md-toolbar class=\"md-primary\">\n            <div class=\"md-toolbar-tools\" layout=\"column\" style=\"padding-top: .5em;\">\n                <h2 flex=\"100\" class=\"center\">Add A List of Tasks</h2>\n            </div>\n        </md-toolbar>\n\n\n\n                    <form name=\"batchTasksForm\" novalidate style=\"padding: 1em;\">\n                        <md-input-container style=\"margin-bottom: 2em;\">\n                            <label>Enter multiple tasks. One per line.</label>\n                            <textarea id=\"focusfield\"  ng-model=\"vm.taskText\"></textarea>\n                        </md-input-container>\n\n\n\n                    </form>\n                    <div layout=\"row\" layout-align=\"end center\" layout-padding>\n                        <md-input-container flex=\"nogrow\" style=\"\">\n                            <label>Client</label>\n                            <md-select md-no-asterisk placeholder=\"Select a Workspace\" ng-model=\"vm.thisClient\" required>\n                                <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                    <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                    <span class=\"small\">{{client.name}}</span></md-option>\n                            </md-select>\n                        </md-input-container>\n                        <div flex layout=\"row\" layout-align=\"end center\">\n                            <md-button class=\"md-raised md-accent\" ng-disabled=\"!vm.taskText || !vm.thisClient\" ng-click=\"vm.saveTasks(vm.taskText)\">Save Tasks</md-button>\n                        </div>\n                    </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/taskDataService/dialog-edit-task.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"80\" flex-md=\"70\" flex-lg=\"50\" flex-xl=\"50\" md-theme=\"grey-menu\" class=\"item-dialog task-item-dialog md-inline-form\" style=\"max-width: 800px;\">\n    <md-dialog-content>\n        <md-tabs md-dynamic-height class=\"md-primary task-tabs\" md-selected=\"vm.selectedTab\" md-stretch-tabs=\"always\">\n            <!-- General Task Details -->\n            <md-tab class=\"task-details-tab\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n                    <span class=\"hide-xs\" ng-if=\"vm.editedItem.uid\">Details</span>\n                    <span class=\"hide-xs\" ng-if=\"!vm.editedItem.uid\">New Task</span>\n                </md-tab-label>\n                <md-tab-body  layout-padding>\n                    <form name=\"taskDialogForm\" novalidate >\n                        <div class=\"main-task-field-container\" >\n                            <div flex layout=\"row\" >\n                                <!-- toggles -->\n                                <div flex=\"nogrow\" layout=\"column\">\n                                    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'open\' && vm.editedItem.type !=\'template\'\">\n                                        <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\">\n                                        </md-icon>\n                                        <md-tooltip md-delay=\"1000\">\n                                            Toggle Complete\n                                        </md-tooltip>\n                                    </md-button>\n                                    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'closed\' && vm.editedItem.type !=\'template\'\">\n                                        <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\">\n                                        </md-icon>\n                                        <md-tooltip md-delay=\"1000\">\n                                            Toggle Complete\n                                        </md-tooltip>\n                                    </md-button>\n                                    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.info.focus == \'today\' && vm.editedItem.info.status != \'completed\' && vm.editedItem.type !=\'template\'\">\n                                        <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-on\" class=\"today-icon\">\n                                        </md-icon>\n                                        <md-tooltip md-delay=\"1000\">\n                                            Toggle Today\n                                        </md-tooltip>\n                                    </md-button>\n                                    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.info.focus != \'today\' && vm.editedItem.info.status != \'completed\' && vm.editedItem.type !=\'template\'\">\n                                        <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-off\" class=\"today-icon\">\n                                        </md-icon>\n                                        <md-tooltip md-delay=\"1000\">\n                                            Toggle Today\n                                        </md-tooltip>\n                                    </md-button>\n                                    <div style=\"width: 25px;\" ng-if=\"vm.editedItem.type ==\'template\'\">\n                                    </div>\n                                </div>\n                                <!-- main fields -->\n                                <div flex=\"grow\" layout=\"column\" >\n                                    <div style=\"display:block;\">\n                                    <md-input-container class=\"task-description-container\">\n                                        <textarea\n                                            ng-disabled=\"vm.editedItem.info.status == \'closed\'\"\n                                            rows=\"2\"\n                                            name=\"description\"\n                                            id=\"taskdescription\"\n                                            md-autofocus=\"!vm.editedItem.uid\"\n                                            md-no-asterisk\n                                            ng-model=\"vm.editedItem.info.description\"\n                                            placeholder=\"Task description\"\n                                            required=\"required\"\n                                            style=\"overflow-y: scroll; background-color: transparent; min-height: 100px; max-height: 100px; margin-bottom: 1em;\"\n                                            ng-model-options=\"{ updateOn: \'default blur\',\n                                                 debounce: {\n                                                   default: 300,\n                                                   blur: 0\n                                                 }\n                                            }\"\n                                            >\n                                            </textarea>\n                                        <!-- <div class=\"task-description-tooltip\">\n                                            <md-icon md-font-icon=\"zmdi zmdi-help\">\n                                                <md-tooltip md-delay=\"500\" class=\"help\" md-direction=\"top\">\n                                                    <p class=\"text-center\"><strong>Multi-line Task Description</strong></p>\n                                                    <p class=\"text-center\">The first sentence will be treated as the title.</p>\n                                                </md-tooltip>\n                                            </md-icon>\n                                        </div> -->\n                                    </md-input-container>\n                                    </div>\n                                    <div layout=\"row\">\n                                            <md-input-container style=\" padding-top: 0;\" class=\"md-padding\" flex md-no-float style=\"\">\n                                                <label>Workspace</label>\n                                                <md-select style=\"margin-left: -1em; width: 50%;\" ng-disabled=\"vm.editedItem.info.status == \'closed\' || vm.editedItem.info.logged > 0 || vm.editedItem.uid\" md-no-asterisk placeholder=\"Select a Workspace for this task\" ng-model=\"vm.editedItem.info.client\" ng-change=\"vm.clientChange(vm.editedItem.info.client)\" required>\n                                                    <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                                        <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                                        <span class=\"small\">{{client.name}}</span></md-option>\n                                                </md-select>\n                                            </md-input-container>\n                                            <div ng-if=\"vm.showAssignmentField\">\n                                            <md-input-container ng-if=\"!vm.teamListLoading && vm.teamListSize > 1\" style=\"padding-left: 0; padding-top: 0;\" class=\"md-padding\" flex style=\"margin-top\">\n                                                <label>Assigned to</label>\n                                                <md-select ng-disabled=\"!vm.editedItem.info.client || !vm.isAdmin\" style=\"margin: 0 1em 0 0; width: 100%;\" ng-model=\"vm.editedItem.info.assignee\"   placeholder=\"Assign to User\">\n                                                    <md-option ng-repeat=\"member in vm.teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by $index\" ng-value=\"\'{{member.uid}}\'\"  style=\"border-left: 4px solid {{member.color}};\">\n                                                        <img src=\"{{member.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" height=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-right: 1em; position: relative; top: 5px;\">\n                                                        <span class=\"small\">{{member.profile.firstName}} {{member.profile.lastName}}</span>\n                                                    </md-option>\n                                                </md-select>\n                                            </md-input-container>\n                                            <p class=\"text-center\" ng-if=\"vm.editedItem.info.client && vm.teamListLoading\">\n                                               <md-icon md-font-icon=\'fa fa-circle-o-notch fa-spin\'></md-icon>\n                                            </p>\n                                            </div><!-- if vm.showAssignmentField\" -->\n\n                                    </div>\n                                    <div flex layout=\"row\" layout-gt-sm=\"row\" style=\"margin-top: 0\">\n                                        <div flex=\"50\">\n                                            <md-input-container style=\" padding-top: 0;\" class=\"md-padding\" flex style=\"margin-top\">\n                                                <label>Workflow group</label>\n                                                 <md-select style=\"margin-left: -1em; width:50%;\" md-no-asterisk placeholder=\"Select a group\" ng-model=\"vm.editedItem.info.panel\" required>\n                                                    <md-option ng-value=\"\'Later\'\" ng-selected=\"!vm.editedItem.info.panel || vm.editedItem.info.panel == \'Later\'\">\n                                                        <span class=\"small\">New Tasks</span>\n                                                    </md-option>\n                                                    <md-option ng-repeat=\"panel in vm.panelCandidates | toArray | orderBy: \'order\' track by $index\" ng-value=\"\'{{panel.uid}}\'\">\n                                                        <span class=\"small\">{{panel.label}}</span>\n                                                    </md-option>\n                                                </md-select>\n                                            </md-input-container>\n                                        </div>\n                                        <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n\n                                                <div flex=\"nogrow\" class=\"button-label-container\">\n                                                    <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                                                        Cancel\n                                                    </md-button>\n                                                </div>\n\n                                            <!--<div flex=\"nogrow\" class=\"button-label-container\">\n																<md-button ng-hide=\"vm.editedItem.uid\" ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" class=\"md-adminja-shade-theme md-primary\" ng-click=\"saveNewTask(vm.editedItem,\'andNew\')\">Add and New</md-button>\n																<label class=\"shortcut\">shift + ctrl + enter</label>\n						                      </div>-->\n                                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid\">\n                                                <md-button ng-disabled=\"taskDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                                    Update\n                                                </md-button>\n                                                <label class=\"shortcut\">ctrl + enter</label>\n                                            </div>\n                                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid\">\n                                                <md-button ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client || !vm.editedItem.info.description\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewTask(vm.editedItem)\">\n                                                    Save\n                                                </md-button>\n                                                <label class=\"shortcut\">ctrl + enter</label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <!--// main-task-field-container -->\n                        <file-attachments files=\'vm.editedItem.info.files\' form=\"taskDialogForm\" counter=\"vm.numFiles\" status=\"vm.editedItem.info.status\" client=\"vm.editedItem.info.client\" path=\"vm.filePath\"></file-attachments>\n\n                        <!-- // Un-focused controls -->\n                        <div class=\"unfocused-task-controls\">\n                            <div flex layout=\"column\">\n                                <p class=\"task-budget-label\" flex>\n                                    <span>Budget</span>\n                                </p>\n                                <div flex layout=\"row\" class=\"tick-row\" style=\"margin: 0 0 -17px 5px!important;\">\n                                    <div flex=\"25\" class=\"text-right tick-quarter\">\n                                        <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                <span class=\"tick-number tick-number-space\">&nbsp;</span>\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">1</span>\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                <span class=\"tick-number\">2</span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div flex=\"25\" class=\"text-right tick-quarter\">\n                                        <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">3</span>\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">4</span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div flex=\"25\" class=\"text-right tick-quarter\">\n                                        <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">5</span>\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">6</span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div flex=\"25\" class=\"text-right tick-quarter\">\n                                        <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                <span class=\"tick-number\">7</span>\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right tick-mark\">\n                                                &nbsp;\n                                            </div>\n                                            <div flex=\"25\" class=\"text-right \">\n                                                &nbsp;\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <md-slider ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"md-accent item-budget fade\" min=\"0\" max=\"480\" step=\"5\" ng-model=\"vm.editedItem.info.budget\" ng-init=\"sliders.default=0\" aria-label=\"Task Budget\" ng-model-options=\"{debounce: 0}\"></md-slider>\n                                <p class=\"task-budget-label right\" style=\"margin-top: -5px;\">\n                                    <span ng-show=\"vm.editedItem.info.budget\">Budget: {{vm.editedItem.info.budget | HandM}}hrs</span>\n                                    <span ng-show=\"vm.editedItem.info.logged\"> | Logged:\n				                	   <span  ng-class=\"{ \'close\': isClose(vm.editedItem.info) , \'over\': isOver(vm.editedItem.info) }\">{{vm.editedItem.info.logged | HandM}}hrs</span>\n                                    </span>\n                                </p>\n                            </div>\n\n\n                        </div>\n                    </form>\n                    <div flex layout=\"row\" layout-align=\"center center\" ng-if=\"vm.editedItem.type !=\'template\'\" style=\"background-color: rgb(240,240,240); padding: 1em 2em 1em 2em;\">\n                        <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin:0 1em 0 0;\">\n                            <strong>Due:</strong>\n                            </p>\n                        <md-input-container flex=\"nogrow\" style=\"margin-top:0; position:relative; top:-6px;\">\n                            <md-datepicker ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"\" ng-change=\"vm.setDirty()\" ng-model=\"vm.editedItem.info.duedate\" md-placeholder=\"Select date\" ></md-datepicker>\n                            <div flex ng-show=\"vm.editedItem.info.closedDate\">\n                                <p style=\"font-size: 12px; margin: 0 0 0 1.5em; color: #777;\">Completed: {{vm.editedItem.info.closedDate|date: \'short\'}} </p>\n                            </div>\n                        </md-input-container>\n                        <div flex layout=\"row\" layout-align=\"left center\" class=\"duedate-shortcuts\" style=\"padding-left: 2em;\">\n                            <md-button class=\"md-button-small\" ng-click=\"vm.setDueWith(vm.duedates.today)\">Today</md-button>\n                            <md-button class=\"md-button-small\" ng-click=\"vm.setDueWith(vm.duedates.tomorrow)\">Tomorrow</md-button>\n                            <md-button class=\"md-button-small\" ng-click=\"vm.setDueWith(vm.duedates.days3)\">3 days</md-button>\n                            <md-button class=\"md-button-small\" ng-click=\"vm.setDueWith(vm.duedates.days7)\">7 days</md-button>\n\n                        </div>\n                    </div>\n                </md-tab-body>\n            </md-tab>\n            <md-tab ng-if=\"vm.showChecklists(vm.editedItem)\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-check-all\"></md-icon> <span class=\"hide-xs\">Checklist <span ng-show=\"vm.editedItem.type != \'template\'\">{{vm.editedItem.info.numCompleteItems || 0}}/{{vm.editedItem.info.numChecklistItems || 0}}</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body class=\"\" >\n                    <div layout=\"column\" class=\"task-checklist\"\n                        dragula=\"\'drag-checklist\'\"\n                        dragula-scope=\"$scope\">\n                        <div class=\"checklist-item\" uid=\"{{item.uid}}\" ng-repeat=\"item in vm.editedItem.checklist | toArray : false | orderBy: [\'+order\'] track by $index\" layout=\"row\" layout-align=\"start start\">\n                            <div flex=\"nogrow\">\n                                <md-checkbox ng-disabled=\"!vm.editedItem.uid\" flex=\"nogrow\" ng-model=\"item.complete\" aria-label=\"Mark complete\" ng-click=\"vm.updateChecklistItem(item, vm.editedItem)\" style=\"margin:0;\">\n                                  </md-checkbox>\n                            </div>\n                            <div flex=\"auto\" ng-click=\"vm.editChecklistItem(item, vm.editedItem)\">\n                                {{item.body}}\n                            </div>\n                            <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\">\n                                 <md-button ng-disabled=\"!vm.editedItem.uid\" style=\"padding:0;\" class=\"md-icon-button\" ng-click=\"vm.deleteChecklistItem(item, vm.editedItem)\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n                            </div>\n                            <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\">\n                                 <md-button ng-disabled=\"!vm.editedItem.uid\" style=\"padding:0;\" class=\"md-icon-button handle\"><md-icon md-font-icon=\"fa fa-reorder\"></md-icon></md-button>\n                            </div>\n\n                        </div>\n                    </div>\n                    <div layout=\"column\" class=\"task-checklist-controls md-padding\" style=\"margin-top: 0;\" >\n                        <div ng-show=\"!vm.editedItem.uid\">\n                            <p style=\"text-align:center;\">\n                                This checklist can be modified after the task is saved.\n                            </p>\n                        </div>\n                         <div class=\"add-checklist-item\" ng-show=\"vm.editedItem.uid\">\n                             <form name=\"forms.addCheckListItemForm\" ng-if=\"vm.shouldShowForm\">\n                                 <md-input-container >\n                                     <label>Add an item...</label>\n                                     <input adminja-enter=\"vm.addChecklistItem(vm.newChecklistItem, vm.editedItem)\" id=\"focusfield\" type=\"text\" ng-model=\"vm.newChecklistItem.body\">\n                                 </md-input-container>\n\n                                 <md-button ng-click=\"vm.addChecklistItem(vm.newChecklistItem, vm.editedItem)\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newChecklistItem.body\" aria-label=\"Add\" md-no-ink=\"true\" >\n                                 <span ng-if=\"!vm.newChecklistItem.uid\">Add</span>\n                                 <span ng-if=\"vm.newChecklistItem.uid\">Update</span>\n                                 </md-button>\n                                 <md-button ng-click=\"vm.closeChecklistForm()\" class=\"md-button-small\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n                             </form>\n                             <md-button class=\"md-raised\" ng-click=\"vm.showChecklistForm()\" ng-if=\"!vm.shouldShowForm\">+ Add items</md-button>\n                         </div>\n                    </div>\n                </md-tab-body>\n            </md-tab>\n            <!-- Task Notes -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.editedItem.type !=\'template\'\" md-on-select=\"setupNotes();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"fa fa-comment-o\"></md-icon> <span class=\"hide-xs\">Comments</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <task-notes class=\"fade\" task=\"{{vm.editedItem.uid}}\" client=\"{{vm.editedItem.info.client}}\"></task-notes>\n                </md-tab-body>\n            </md-tab>\n            <!-- Time Log -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.canLogTime && vm.editedItem.type !=\'template\'\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> <span class=\"hide-xs\">Time</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <task-time class=\"fade\" local=\"true\" task=\"{{vm.editedItem.uid}}\" client=\"{{vm.editedItem.info.client}}\"></task-time>\n                </md-tab-body>\n            </md-tab>\n\n            <!-- Recurrence Settings Log -->\n            <md-tab ng-if=\"vm.editedItem.type==\'template\'\">\n\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> <span class=\"hide-xs\">Recurring Schedule</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                <form name=\"recurringForm\">\n                    <div layout=\"row\" layout-padding>\n                        <md-switch style=\"margin:0;\" flex=\"nogrow\" class=\"md-secondary\" ng-model=\"vm.editedItem.isRecurring\" ng-change=\"vm.setDirty()\"></md-switch>\n                        <p flex=\"nogrow\" style=\"margin:0;\">Make this a recurring task.</p>\n\n                    </div>\n                    <div layout-fill layout-padding ng-if=\"vm.editedItem.isRecurring\" layout=\"column\">\n\n                        <div layout=\"row\" layout-align=\"start center\">\n                            <div flex>\n                                <md-input-container>\n                                    <label>When should this task repeat?</label>\n                                    <input type=\"text\" class=\"ruletext\" name=\"ruletext\" ng-model=\"vm.editedItem.schedule.ruleText\"  placeholder=\"e.g. Every 2 weeks on Monday\"  ng-change=\"vm.resetValidity()\">\n                                    <div class=\"task-repeating-tooltip\">\n                                        <md-icon md-font-icon=\"zmdi zmdi-help\">\n                                            <p style=\"margin:0; display:inline; font-size: 10px;\">Examples</p>\n                                            <md-tooltip md-delay=\"500\" class=\"help\" md-direction=\"top\">\n                                                <p class=\"text-center\"><strong>Examples</strong></p>\n                                                <p class=\"text-center\">Every 2 weeks on Tuesday<br>\n                                                        Every week on Monday, Wednesday<br>\n                                                        Every month on the 2nd last Friday for 7 times<br>\n                                                        Every 6 months<br>\n                                                        Every 2 years</p>\n                                            </md-tooltip>\n                                        </md-icon>\n                                    </div>\n                                </md-input-container>\n\n                            </div>\n\n                        </div>\n                        <div layout=\"row\" layout-align=\"start center\">\n\n                            <div flex=\"nogrow\">\n                                <md-input-container>\n                                    <md-datepicker ng-model=\"vm.startOn\" md-placeholder=\"Start on\" ng-change=\"vm.resetValidity()\" md-min-date=\"vm.minDate\" placeholder=\"Start on\"></md-datepicker>\n                                </md-input-container>\n                            </div>\n                        </div>\n                        <div layout=\"row\">\n                            <div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-md=\"40\">\n                                <md-button class=\"md-raised md-accent\" ng-if=\"!vm.validRule\" ng-disabled=\"!vm.editedItem.schedule.ruleText\" aria-label=\"Repeating rule\" ng-click=\"vm.calcRule(vm.editedItem.schedule.ruleText)\">Test</md-button>\n\n                                <ul>\n                                    <li ng-if=\"vm.validRule\"><strong>Schedule Preview</strong></li>\n                                    <li style=\"font-size: 11px;\" ng-repeat=\"(key, value) in vm.rulePreview\">\n                                        {{value}}\n                                    </li>\n                                </ul>\n                                <md-button ng-if=\"vm.validRule\" ng-disabled=\"!vm.editedItem.description || !vm.validRule\" aria-label=\"Repeating rule\" style=\"color:green;\"><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Valid Schedule!</md-button>\n\n                            </div>\n                        </div>\n                        <div layout=\"row\">\n                           <!--  <div flex>\n                                <md-checkbox flex=\"nogrow\" ng-model=\"vm.editedItem.schedule.hasDue\" aria-label=\"Copies have due dates\">\n                                        Copies have a due date.\n                                  </md-checkbox>\n                            </div> -->\n                            <div flex >\n                                <p>Create <input type=\"text\" ng-model=\"vm.editedItem.schedule.dueDays\" style=\"width: 25px;\" ng-change=\"vm.calcRule(vm.editedItem.schedule.ruleText)\"> days before they are due.</p>\n                            </div>\n\n                        </div>\n\n\n                    </div>\n                    <div layout=\"row\" layout-align=\"end center\">\n                        <div flex=\"40\" layout=\"row\" layout-align=\"end center\">\n                            <div flex=\"nogrow\" class=\"button-label-container\">\n                                <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                                    Cancel\n                                </md-button>\n                            </div>\n                            <!--<div flex=\"nogrow\" class=\"button-label-container\">\n                                                <md-button ng-hide=\"vm.editedItem.uid\" ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" class=\"md-adminja-shade-theme md-primary\" ng-click=\"saveNewTask(vm.editedItem,\'andNew\')\">Add and New</md-button>\n                                                <label class=\"shortcut\">shift + ctrl + enter</label>\n                              </div>-->\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid && vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                    Schedule\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid && !vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                    Save Changes\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid && vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client || !vm.editedItem.info.description || !vm.validRule\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewTask(vm.editedItem)\">\n                                    Save &amp; Schedule\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                </md-tab-body>\n            </md-tab>\n            <!-- Task Activity Log -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.isAdmin\">\n	<md-tab-label>\n	<md-icon md-font-icon=\"zmdi zmdi-receipt\"></md-icon> <span class=\"hide-xs\">Activity</span></md-tab-label>\n	</md-tab-label>\n	<md-tab-body>\n	<md-content style=\"max-height: 400px;\">\n	<md-list class=\"md-dense\">\n	<div class=\"activity-log-item\" ng-repeat=\"item in vm.editedItem.activity | toArray: false | orderBy: [\'-timestamp\'] track by $index\">\n					<md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{vm.clientColor}};\">\n					<div class=\"md-list-item-text\" layout=\"column\">\n									<div flex layout=\"row\">\n													<h3 >\n													{{item.event}}\n													</h3>\n									</div>\n									<div flex layout=\"row\">\n													<div flex>\n																	<p><em am-time-ago=\"item.timestamp\"></em></p>\n													</div>\n													<div flex class=\"center\">\n													</div>\n													<div flex class=\"right\">\n																	<h3><strong>{{item.actor}}</strong></h3>\n													</div>\n									</div>\n					</div>\n					</md-list-item>\n					<md-divider></md-divider>\n	</div>\n	</md-list>\n	</md-content>\n	</md-tab-body>\n</md-tab>\n        </md-tabs>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"md-inline-form dialog-panel\" style=\"width:309px; min-height: 300px;\" >\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon> <span class=\"hide-for-medium\"><span ng-if=\"!vm.panel.uid\">New</span><span ng-if=\"vm.panel.uid\">Edit</span> Bucket</span>\n\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.panelDialogForm\">\n			<div layout=\"column\" class=\"md-padding\">\n				<md-input-container md-autofocus flex style=\"margin-bottom: 0;\">\n				       <label>Task Bucket Name</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.panel.label\" required>\n				 </md-input-container>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"!vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></md-button>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color <md-icon md-font-icon=\"zmdi zmdi-caret-up\"></md-icon></md-button>\n				 <div class=\"row\" layout-align=\"center center\">\n				 <div flex=\"nogrow\" ng-if=\"vm.showColors\" style=\"width: 235px;\">\n					 <lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.panel.color\" ng-model=\"vm.panel.color\" ng-change=\"toggleColors();\"></lk-color-chooser>\n				 </div>\n				</div>\n			</div>\n\n				<!-- <md-divider></md-divider> -->\n\n				<md-dialog-actions style=\"border-top: none;\" class=\"md-padding\">\n				    <div layout=\"row\" layout-align=\"center center\">\n					    <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.hasCards && vm.panel.uid\">\n					    	 <md-button class=\"\" ng-click=\"removePanel(vm.panel)\">Delete </md-button>\n					    </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\">\n				        	<md-button class=\"\" ng-click=\"cancelDialog(vm.panel)\">Cancel</md-button>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"updatePanel(vm.panel)\">Save</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button  ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid || !vm.panel.label\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"saveNewPanel(vm.panel)\">Add</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				    </div>\n				</md-dialog-actions>\n			</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/teamDataService/dialog-invite-team-member.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"60\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\" class=\"md-inline-form\" >\n    <md-dialog-content >\n        <md-tabs class=\"md-primary no-active\" md-stretch-tabs=\"always\">\n            <md-tab >\n                <md-tab-label>\n                    <span>Inviting member #{{vm.numMembers}} of {{vm.teamLimit}}</span>\n                </md-tab-label>\n                <md-tab-body >\n\n                    <form name=\"inviteTeamMemberForm\" novalidate style=\"padding: 1em;\">\n                        <p class=\"md-subhead\">Enter an email address and we\'ll send that person a link to join your team.</p>\n\n                        <md-input-container style=\"margin-bottom: .5em;\">\n                            <label>Enter an Email Address</label>\n                            <input id=\"focusfield\" ng-model=\"vm.inviteEmail\" required type=\"email\"  minlength=\"10\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\"></textarea>\n                        </md-input-container>\n                            <div flex layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.cancelDialog()\">cancel</md-button>\n                                <md-button class=\"md-raised md-accent\" ng-disabled=\"!vm.inviteEmail\" ng-click=\"vm.saveInvite(vm.inviteEmail)\">Send Invitation</md-button>\n                            </div>\n\n                        </div>\n\n                    </form>\n\n                </md-tab-body>\n            </md-tab>\n        </md-tabs>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/timeDataService/dialog-edit-time-entry.tmpl.html","<md-dialog flex=\"80\" flex-sm=\"50\" flex-md=\"35\" flex-lg=\"25\" flex-xl=\"20\" md-theme=\"grey-menu\" class=\"edit-time md-inline-form\">\n    <md-dialog-content ng-if=\"vm.canLogTime\">\n        <md-tabs md-dynamic-height class=\"no-active md-primary\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n            <!-- General Task Details -->\n            <md-tab>\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon> <span class=\"hide-for-medium\"><span ng-if=\"!vm.timeEntry.uid\">New</span><span ng-if=\"vm.timeEntry.uid\">Edit</span> Time Entry</span>\n                </md-tab-label>\n                <md-tab-body>\n                    <form name=\"forms.timeDialogForm\" novalidate=\"\">\n                    <div flex md-padding layout=\"column\">\n                        <md-input-container flex style=\"margin-bottom: 2em;\">\n                            <label>Workspace</label>\n                            <md-select ng-disabled=\"vm.timeEntry.task || vm.timeEntry.uid\" md-no-asterisk placeholder=\"Space\" ng-change=\"setClient(vm.timeEntry.client)\" ng-model=\"vm.timeEntry.client\" required>\n                                <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                <img src=\"{{client.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"30\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\"> <span class=\"small\">{{client.name}}</span></md-option>\n                            </md-select>\n                        </md-input-container>\n                        <div fkex layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\">\n                            <md-input-container flex=\"100\" flex-gt-sm=\"45\">\n                                <label>Hours</label>\n                                <input name=\"hours\" type=\"number\" min=\"0\" max=\"24\" ng-model=\"vm.timeEntry.hours\" ng-model-options=\"vm.inputOptions\">\n                            </md-input-container>\n                            <md-input-container flex=\"100\" flex-gt-sm=\"45\">\n                                <label>Minutes</label>\n                                <input name=\"minutes\" type=\"number\" min=\"0\" step=\"5\" max=\"480\" ng-model=\"vm.timeEntry.minutes\" style=\"min-width:175px;\" ng-model-options=\"vm.inputOptions\">\n                            </md-input-container>\n                        </div>\n                        <md-input-container flex class=\"time-description-container\" ng-if=\"!vm.requireWorkDescription\" >\n                            <textarea class=\"time-description\" name=\"description\" ng-model=\"vm.timeEntry.description\" placeholder=\"What were you working on?\" ng-model-options=\"vm.inputOptions\"></textarea>\n                        </md-input-container>\n                        <md-input-container flex class=\"time-description-container\" ng-if=\"vm.requireWorkDescription\" required>\n                            <textarea class=\"time-description\" name=\"description\" md-no-asterisk ng-model=\"vm.timeEntry.description\" placeholder=\"What were you working on?\" ng-required=\"true\"  ng-model-options=\"vm.inputOptions\"></textarea>\n                            <div ng-messages=\"vm.timeEntry.description.$error\">\n                                <div ng-message=\"required\">Your time entry needs a description</div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container flex style=\"margin-bottom: 2em;\">\n                            <label>Apply time to a task:</label>\n                            <!-- note how we are dealing with the compressed tags\n                                from our initially resolved clientData,\n                                thus we use the refID, not uid -->\n                            <md-select ng-disabled=\"!vm.taskCandidates\" md-no-asterisk placeholder=\"Optional - select a related task\"  ng-change=\"setTask(vm.timeEntry)\" ng-model=\"vm.timeEntry.task\">\n                                <md-option md-option-empty></md-option>\n                                <md-option\n                                    ng-repeat=\"task in vm.taskCandidates | filter: {\'status\' : \'open\'} track by $index\"\n                                    value=\"{{task.refID}}\"\n                                    ng-selected=\"vm.timeEntry.task == task.refID\"\n                                    >\n                                    <span class=\"small\">{{task.description | limitTo : 50 : begin}}</span></md-option>\n                            </md-select>\n                        </md-input-container>\n                        <md-input-container  style=\"margin: 1em 0 0 0;\">\n                            <label>Date</label>\n                            <md-datepicker ng-model=\"vm.timeEntry.logDate\" md-max-date=\"vm.maxDate\"  required=\"required\"></md-datepicker>\n                            <div ng-messages=\"vm.timeEntry.logDate.$error\">\n                                <div ng-message=\"required\">Please make sure you\'ve entered a valid date. (mm/dd/yyyy)</div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                    </form>\n                </md-tab-body>\n            </md-tab>\n    </md-dialog-content>\n    <md-dialog-actions ng-if=\"vm.canLogTime && !vm.confirmDelete\" style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n        <div flex=\"nogrow\" class=\"button-label-container\">\n            <md-button  aria-label=\"Delete Time Entry\" ng-if=\"vm.timeEntry.uid\" ng-click=\"startDelete(vm.editEntry);\">\n                Delete\n            </md-button>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\">\n            <md-button class=\"\" ng-click=\"cancelDialog(vm.timeEntry)\">Cancel</md-button>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.timeEntry.uid\">\n            <md-button ng-disabled=\"vm.timeDialogForm.$invalid || vm.timeDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateEntry(vm.timeEntry)\">\n                Update\n            </md-button>\n            <label class=\"shortcut\">ctrl + enter</label>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.timeEntry.uid\">\n            <md-button ng-disabled=\"vm.timeDialogForm.$invalid || !vm.timeEntry.client || (!vm.timeEntry.minutes && !vm.timeEntry.hours)\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveEntry(vm.timeEntry)\">\n                Save\n            </md-button>\n            <label class=\"shortcut\">ctrl + enter</label>\n        </div>\n    </md-dialog-actions>\n    <md-dialog-actions ng-if=\"vm.confirmDelete\" style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n        <p class=\'center\"\' style=\"margin:0 auto 0 auto;\">\n            Permanently delete?\n        </p>\n\n        <md-button class=\"md-primary\" ng-click=\"cancelDelete()\">\n            cancel\n        </md-button>\n\n        <md-button class=\"md-primary\" ng-click=\"deleteTime(vm.timeEntry)\">\n            <span >\n                    Confirm\n                </span>\n        </md-button>\n    </md-dialog-actions>\n    <md-content ng-if=\"!vm.canLogTime\">\n        <h3 class=\"text-center\">Your subscription plan does not include Time logging.</h3>\n    </md-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/userDataService/dialog-user-profile.tmpl.html"," <md-dialog flex-xs=\"100\" flex-sm=\"90\" flex-md=\"60\" flex-lg=\"50\" flex-gt-lg=\"40\" class=\"item-dialog edit-user md-inline-form\">\n     <form name=\"userDialogForm\" novalidate>\n     <md-toolbar class=\"md-primary\">\n           <div class=\"md-toolbar-tools\">\n             <h2 ng-show=\"!vm.user.profile.firstName\" class=\"center\">{{vm.title}}</h2>\n             <h2 ng-show=\"vm.user.profile.firstName\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}</h2>\n             <span flex></span>\n\n           </div>\n         </md-toolbar>\n     <md-dialog-content>\n\n\n\n                     <div layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"row\">\n                         <div md-padding flex-gt-md=\"40\" flex-sm=\"100\" layout=\"column\" layout-align=\"start center\">\n                                <md-input-container>\n                                     <img  ng-show=\"vm.user.profile.avatar\" src=\"{{vm.user.profile.avatar}}\" width=\"150\" height=\"150\"/><br>\n                                     <img  ng-hide=\"vm.user.profile.avatar\" src=\"/assets/images/avatars/generic-avatar.png\" width=\"150\" height=\"150\"/><br>\n                                 </md-input-container>\n                                 <md-button  type=\"button\"\n                                            ng-show=\"vm.user.profile.avatar\"\n                                            class=\"md-primary \"\n                                            ngf-select=\"vm.uploadAvatar($files, vm.user)\"\n                                            ngf-multiple=\"false\"\n                                            aria-label=\"upload\"\n                                            ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"\n                                            >\n                                     <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Change Photo\n                                 </md-button>\n                                 <md-button  type=\"button\"\n                                            ng-hide=\"vm.user.profile.avatar\"\n                                            class=\"md-primary \"\n                                            ngf-select=\"vm.uploadAvatar($files, vm.user)\"\n                                            ngf-multiple=\"false\"\n                                            aria-label=\"upload\"\n                                            ngf-resize=\"{width: 150, height: 150, centerCrop: true}\"\n                                            >\n                                     <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Upload Photo\n                                 </md-button>\n                             <md-datepicker  class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.profile.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n                         </div>\n                         <div flex md-padding>\n                             <div flex class=\"right\">\n                                 <md-input-container>\n                                     <!-- <timezone-selector width=\"250px\" show-local=\"true\" display-utc=\"true\" ng-model=\"vm.user.profile.timezone\" style=\"margin-bottom: 1em;\"> </timezone-selector> -->\n                                 </md-input-container>\n                             </div>\n                             <md-input-container flex>\n                                 <label>First Name</label>\n                                 <input name=\"firstname\" ng-model=\"vm.user.profile.firstName\"  required>\n                             </md-input-container>\n                             <md-input-container flex>\n                                 <label>Last Name</label>\n                                 <input name=\"lastname\" ng-model=\"vm.user.profile.lastName\" required>\n                             </md-input-container>\n\n                             <md-input-container flex>\n                                 <label>Email</label>\n                                 <input disabled=\"disabled\" name=\"email\" ng-model=\"vm.user.email\" type=\"email\" required>\n                             </md-input-container>\n                            <!--  <md-input-container flex>\n                                 <label>Primary Phone</label>\n                                 <input name=\"phone\" ng-model=\"vm.user.profile.phone\">\n                             </md-input-container> -->\n\n                             <md-input-container flex>\n                                 <label>Company</label>\n                                 <input name=\"company\" ng-model=\"vm.user.profile.company\">\n                             </md-input-container>\n                             <md-input-container flex>\n                                 <label>Position</label>\n                                 <input name=\"clientposition\" ng-model=\"vm.user.profile.position\">\n                             </md-input-container>\n                            <md-input-container flex>\n                                <label>Website</label>\n                                <input name=\"website\" ng-model=\"vm.user.profile.website\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Twitter</label>\n                                <input name=\"twitter\" ng-model=\"vm.user.profile.twitter\">\n                            </md-input-container>\n                             <md-input-container flex>\n                                 <label translate>Country/Region</label>\n                                 <md-select name=\"country\" ng-model=\"vm.user.profile.address.country\" required>\n                                     <md-option value=\"{{country.name}}\" ng-repeat=\"country in vm.countries\">{{country.name}}</md-option>\n                                 </md-select>\n                            </md-input-container>\n\n                         </div>\n\n                     </div>\n\n     </md-dialog-content>\n     <md-dialog-actions style=\"border-top: none;\" class=\"md-padding\">\n         <div layout=\"row\" layout-align=\"center end\">\n\n             <div flex=\"nogrow\" class=\"button-label-container\">\n                 <md-button type=\"button\" class=\"\" ng-click=\"vm.cancelDialog(vm.user)\">Cancel</md-button>\n             </div>\n             <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.user.uid\">\n                 <md-button type=\"button\" ng-disabled=\"userDialogForm.$invalid || userDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateUser(vm.user)\">Update Profile</md-button>\n                 <label class=\"shortcut\">ctrl + enter</label>\n             </div>\n             <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.user.uid\">\n                 <md-button type=\"button\" ng-disabled=\"userDialogForm.$invalid || userDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewUser(vm.user)\">Complete Your Registration</md-button>\n                 <label class=\"shortcut\">ctrl + enter</label>\n             </div>\n         </div>\n     </md-dialog-actions>\n\n     </form>\n </md-dialog>\n");
$templateCache.put("app/permission/pages/permission-define.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Defining Roles & Permissions</h2>\n\n    <p>To get started we recommend looking at the example app and how the roles and permissions are defined there.</p>\n\n    <p>Take a look at the file <code>permission/permission.run.js</code> to see how the apps roles & permissions.</p>\n    <p>For example</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>permission/permission.run.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    // create roles for app\n    RoleStore\n    .defineRole(\'SUPERADMIN\', [\'viewEmail\', \'viewGitHub\', \'viewCalendar\', \'viewLayouts\', \'viewTodo\', \'viewElements\', \'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'ADMIN\', [\'viewLayouts\', \'viewTodo\', \'viewElements\', \'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'USER\', [\'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'ANONYMOUS\', [], checkRole);\n\n    // function that calls user service to check if permission is allowed\n    function checkRole(permission, transitionProperties) {\n        return UserService.hasPermission(permission, transitionProperties);\n    }\n        </div>\n    </div>\n\n    <p>In the first lines we define the roles SUPERADMIN, ADMIN, USER, and ANONYMOUS.  These roles each have their own permissions except for ANONYMOUS which doesn\'t have any permissions set.</p>\n\n    <p>We also tell angular permission to use a function called checkRole to verify that the current user has a permission.</p>\n\n    <p>This function calls the main UserService to check the users permissions.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission-routes.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Route Permissions</h2>\n\n    <h3 class=\"md-subheading\">Blocking Routes</h3>\n    <p>In order to block routes from being accessed when a usre doesn\'t have permission just add the following code to your <code>$stateProvider</code> declaration inside your config file.</p>\n\n    <p>For example</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-module.config.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    $stateProvider\n    .state(\'triangular.my-page\', {\n        url: \'/mypage\',\n        templateUrl: \'app/my-module/my-page.tmpl.html\',\n        data: {\n            permissions: {\n                only: [\'viewMyPage\']\n            }\n        }\n    });\n        </div>\n    </div>\n\n    <p>So now if any user that doesn\'t have the permission <code>viewMyPage</code> tries to access <code>/mypage</code> in the browser they will be redirected to the <a href=\"/401\">401 Page</a></p>\n\n    <h3 class=\"md-subheading\">Hiding menus</h3>\n    <p>As well as blocking the route you will also want to hide the menu item.  This is also easy, just add a permission to the menu item when you add it in your config file.</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-module.config.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    triMenuProvider.addMenu({\n        name: \'My Page\',\n        type: \'link\',\n        permission: \'viewMyPage\',\n    });\n        </div>\n    </div>\n\n    <p>Now unless the user has the <code>viewMyPage</code> permission they will not see the menu item in the left sidebar.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission-views.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">View Permissions</h2>\n\n    <h3 class=\"md-subheading\">Hiding view elements</h3>\n\n    <p>You can also use angular permission to hide elements on the page.</p>\n\n    <p>For example to a button on your app unless the user has a <code>canDelete</code> permission you would do the following.</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-page.tmpl.html</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"html\">\n<md-button permission permission-only=\"\'canDelete\'\">Delete</md-button></div>\n    </div>\n\n    <p>So now if any user that doesn\'t have the permission <code>canDelete</code> they wont see this button.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Permissions</h2>\n\n    <p>Many people have requested a way to restrict access to pages inside triangular.</p>\n\n    <p>So for that reason we have added an optional module that works with the <a href=\"https://github.com/Narzerus/angular-permission\">Angular Permission Module</a></p>\n\n    <p>To show how this works we have created some mock users, roles and permissions for triangular.</p>\n\n    <p>This will show you how they can be used to restrict user access to routes / pages and HTML elements in your app.</p>\n\n    <p>In the demo app we have 4 users with different roles assigned to each.  Each role has a set of permissions that we will use to show and hide menu items on the left as well as disable the routes to those pages.</p>\n\n    <div layout=\"row\" layout-xs=\"column\" layout-margin layout-align=\"space-between stretch\">\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Users</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item class=\"md-primary\" ng-repeat=\"user in vm.userList\" ng-click=\"vm.selectUser(user)\">\n                        <img ng-src=\"{{user.avatar}}\" class=\"md-avatar\" alt=\"{{user.displayName}}\" />\n                        <p>{{user.displayName}}</p>\n                        <md-icon md-font-icon=\"zmdi zmdi-circle\" ng-show=\"vm.selectedUser == user\"></md-icon>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Roles</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item ng-repeat=\"role in vm.roleList\">\n                        <p>{{role.roleName}}</p>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Permissions</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item ng-repeat=\"permission in vm.permissionList\">\n                        <p>{{permission}}</p>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n    </div>\n\n    <md-button class=\"md-primary md-raised\" ng-click=\"vm.loginClick()\">Login as {{vm.selectedUser.displayName}}</md-button>\n\n    <p>Go ahead and log in as one of the users to see it\'s effect on the side menu items and routes</p>\n\n    <p>For more details on how to set this up read about permissions for routes and permissions for views.</p>\n</div>\n");
$templateCache.put("app/layouts/footer/footer.tmpl.html","<div flex=\"noshrink\" layout=\"column\" layout-align=\"end none\">\n    <md-toolbar ng-controller=\"AppFooterController as footer\" md-theme=\"{{triSkin.elements.toolbar}}\">\n        <div class=\"md-toolbar-tools md-body-1\" layout=\"row\" layout-align=\"space-between center\">\n            <h2>{{footer.settings.name}}</h2>\n            <h2 hide-xs ng-bind-html=\"footer.settings.copyright\"></h2>\n            <h2>v{{footer.settings.version}}</h2>\n        </div>\n    </md-toolbar>\n</div>\n");
$templateCache.put("app/layouts/leftsidenav/leftsidenav.tmpl.html","<md-toolbar class=\"sidebar-left-toolbar\" md-theme=\"{{::triSkin.elements.logo}}\">\n    <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\">\n\n        <div class=\"sidebar-left-logo\">\n            <img ng-src=\"{{::vm.sidebarInfo.appLogo}}\" alt=\"{{::vm.sidebarInfo.appName}}\">\n        </div>\n\n        <h2 flex class=\"sidebar-left-title\">{{::vm.sidebarInfo.appName}}</h2>\n\n        <md-button class=\"md-icon-button sidebar-left-icon\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\">\n            <md-icon md-font-icon ng-class=\"{ \'zmdi zmdi-chevron-right\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-chevron-left\' : vm.layout.sideMenuSize == \'full\' }\"></md-icon>\n        </md-button>\n\n    </div>\n</md-toolbar>\n\n<tri-menu md-theme=\"{{triSkin.elements.sidebar}}\" flex layout=\"column\"></tri-menu>\n");
$templateCache.put("app/layouts/loader/loader.tmpl.html","<div class=\"app-loader\" flex layout=\"column\" layout-align=\"center center\">\n    <div flex=\"auto\" layout=\"column\" layout-align=\"center center\" style=\"min-width: 80%;\">\n	    	<p style=\"margin:0;  text-align: center;  font-size: 36px; font-weight: 400;\">{{loaderMessage}}\n	    	</p>\n	    	<md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" style=\"margin-top: 36px; width: 100%;\"></md-progress-linear>\n    </div>\n</div>\n");
$templateCache.put("app/layouts/rightsidenav/rightsidenav.tmpl.html","<md-content flex layout class=\"admin-notifications\">\n		<md-button style=\"position: absolute; top: -10px; left: -10px; z-index: 1000;\"\" class=\"md-button-small\" ng-click=\"close()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n		<md-tabs class=\"md-secondary\" flex md-stretch-tabs=\"always\" md-selected=\"currentTab\">\n			<md-tab class=\"sidebar-timers-tab\">\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"fa fa-clock-o\"></md-icon>\n					</md-tab-label>\n					<md-tab-body layout=\"column\">\n					<md-content>\n\n							<div class=\"timer-container\" hide-gt-sm ng-show=\"canUseTimer\" layout=\"column\" layout-align=\"start center\">\n									<timer></timer>\n									<!-- <div layout=\"row\" flex=\"100\" style=\"padding:0; margin:0;\" layout-align=\"start center\"> <timer ></timer></div> -->\n							 </div>\n							<h3 class=\"text-center\">Open Timers</h3>\n\n						 <timer-list ng-if=\"canUseTimer\"></timer-list>\n						 <div ng-if=\"!canUseTimer\">\n						 <img src=\"/assets/images/screenshots/timer.png\" style=\"margin: 1em;\">\n							<h2 class=\"center\">Timers are a Premium feature.</h3>\n							<h3 class=\"center\">Please review your <a ui-sref=\"authentication.profile\">Subscription</a> plan for upgrade options. </p>\n\n						 </div>\n\n\n					</md-content>\n									<!-- <md-toolbar class=\"footer-toolbar\" layout=\"row\" style=\"background-color:#fff; position: absolute; bottom: 50px;\">\n												<div class=\"md-toolbar-tools\" flex=\"nogrow\" layout-align=\"center center\">\n													<md-button aria-label=\"New Time Entry\" ng-click=\"logManualTime()\" class=\"\">\n														<md-icon md-font-icon=\"zmdi zmdi-plus\" style=\"color: #bbb;\"></md-icon><span style=\"color: rgba(0,0,0,.3);\"> Manual Time Entry</span>\n														<md-tooltip md-direction=\"top\" md-delay=\"1000\">Add Manual Time Entry</md-tooltip>\n													</md-button>\n\n												</div>\n									</md-toolbar> -->\n\n					</md-tab-body>\n\n			</md-tab>\n			<!-- notifications tab -->\n			<md-tab >\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"fa fa-bell-o\"></md-icon>\n					</md-tab-label>\n					<md-tab-body>\n							<md-content>\n								<div layout=\"row\" layout-align=\"end center\">\n									<span flex=\"nogrow\" style=\"margin-right: 2em; color: #bbb; font-size: 12px;\">\n										<md-icon ng-click=\"discardAllNotifications()\" aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-close-circle\" class=\"\" style=\"font-size: 1.5rem; color: #bbb; cursor: pointer; min-width: 15px;\"></md-icon>\n										 All\n									</span>\n								</div>\n									<div class=\"notification-list\">\n										<notification-card class=\"fade\" ng-repeat=\"item in user.notifications | toArray |  orderBy: \'-date\' track by item.uid\" item=\"item\"></notification-card>\n									</div>\n							</md-content>\n\n					</md-tab-body>\n			</md-tab>\n			<md-tab>\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n					</md-tab-label>\n					<md-tab-body>\n							<md-content>\n									<h3 class=\"text-center\">Settings</h3>\n									<md-list>\n											<div>\n													<md-subheader class=\"md-primary\"><span translate>Units</span></md-subheader>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"fa fa-dollar\"></md-icon>\n															<p translate>Currency</p>\n															<md-input-container>\n																	<md-select md-no-asterisk placeholder=\"Select a currency\" ng-model=\"user.profile.settings.currency\" ng-change=\"updateSettings(\'currency\',user.profile.settings.currency)\">\n																			<md-option value=\"$\">$</md-option>\n																			<md-option value=\"&pound;\">&pound;</md-option>\n																			<md-option value=\"&euro;\">&euro;</md-option>\n																			<md-option value=\"&#x20B9;\">&#x20B9;</md-option><!-- rupee -->\n																			<md-option value=\"&#x20a3;\">&#x20a3;</md-option><!-- franc -->\n																			<md-option value=\"CHF\">CHF</md-option><!-- Swedish franc -->\n																	</md-select>\n															</md-input-container>\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n															<p translate>Date Format</p>\n															<md-input-container style=\"\">\n																	<md-select md-no-asterisk placeholder=\"Select a date format\" ng-model=\"user.profile.settings.dateFormat\"  ng-change=\"updateSettings(\'dateFormat\',user.profile.settings.dateFormat)\">\n																			<md-option value=\"us\">mm/dd/yyyy</md-option>\n																			<md-option value=\"eu\">dd/mm/yyyy</md-option>\n																	</md-select>\n															</md-input-container>\n\n															<!-- <md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.dateFormat\"></md-switch> -->\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n															<p translate>Start of week</p>\n															<md-input-container style=\"\">\n																	<md-select md-no-asterisk placeholder=\"Select a day\" ng-model=\"user.profile.settings.startOfWeek\"  ng-change=\"updateSettings(\'startOfWeek\',user.profile.settings.startOfWeek)\">\n																			<md-option value=\"0\">Sunday</md-option>\n																			<md-option value=\"1\">Monday</md-option>\n																			<md-option value=\"2\">Tuesday</md-option>\n																			<md-option value=\"3\">Wednesday</md-option>\n																			<md-option value=\"4\">Thursday</md-option>\n																			<md-option value=\"5\">Friday</md-option>\n																			<md-option value=\"6\">Saturday</md-option>\n																	</md-select>\n															</md-input-container>\n\n															<!-- <md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.dateFormat\"></md-switch> -->\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n															<p translate>Round timers up to nearest...</p>\n															<md-input-container>\n																	<md-select md-no-asterisk placeholder=\"Select a unit\" ng-model=\"user.profile.settings.roundUpTo\" ng-change=\"updateSettings(\'roundUpTo\',user.profile.settings.roundUpTo)\">\n																			<md-option value=\"1\">minute</md-option>\n																			<md-option value=\"5\">5 minutes</md-option>\n																			<md-option value=\"10\">10 minutes</md-option>\n																			<md-option value=\"15\">15 minutes</md-option><!-- rupee -->\n																			<md-option value=\"30\">half hour</md-option><!-- franc -->\n																			<md-option value=\"60\">hour</md-option><!-- Swedish franc -->\n																	</md-select>\n															</md-input-container>\n													</md-list-item>\n											</div>\n\n											<div>\n													<md-subheader class=\"md-primary\"><span translate>Behavior</span></md-subheader>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"fa fa-thumb-tack\"></md-icon>\n															<p translate>Pin Left Menu Open</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.pinMenu\" ng-change=\"updateSettings(\'pinMenu\',user.profile.settings.pinMenu)\"></md-switch>\n\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n															<p translate>Require work description for time entries</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.requireWorkDescription\" ng-change=\"updateSettings(\'requireWorkDescription\',user.profile.settings.requireWorkDescription)\"></md-switch>\n\n													</md-list-item>\n											</div>\n											<div>\n													<md-subheader class=\"md-primary\"><span translate>Layout</span></md-subheader>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n															<p translate>Vertical Information Buckets</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.verticalProfilePanels\" ng-change=\"updateSettings(\'verticalProfilePanels\',user.profile.settings.verticalProfilePanels)\"></md-switch>\n\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n															<p translate>Vertical Task Buckets</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.verticalTaskPanels\" ng-change=\"updateSettings(\'verticalTaskPanels\',user.profile.settings.verticalTaskPanels)\"></md-switch>\n\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n															<p translate>Group <strong>Today</strong> view by Workspace</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.groupToday\" ng-change=\"updateSettings(\'groupToday\',user.profile.settings.groupToday)\"></md-switch>\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n															<p translate>Show <strong>Today</strong> in <Strong>All Tasks</Strong></p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.showTodayPanel\" ng-change=\"updateSettings(\'showTodayPanel\',user.profile.settings.showTodayPanel)\"></md-switch>\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n															<p translate>Show <strong>Today</strong> in Workspaces by default</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.showClientTodayPanel\" ng-change=\"updateSettings(\'showClientTodayPanel\',user.profile.settings.showClientTodayPanel)\"></md-switch>\n													</md-list-item>\n													<md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"fa fa-check\"></md-icon>\n															<p translate>Show <strong>Recently Completed</strong> tasks</p>\n															<md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"user.profile.settings.hideCompletedPanel\" ng-change=\"updateSettings(\'hideCompletedPanel\',user.profile.settings.hideCompletedPanel)\"></md-switch>\n													</md-list-item>\n													<!-- <md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"fa fa-check\"></md-icon>\n															<p translate>Show <strong>Onboarding Guide</strong></p>\n															<md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"user.profile.onboardingFlags.complete\" ng-change=\"changeOnboardingFlag(\'complete\',user.profile.onboardingFlags.complete)\"></md-switch>\n													</md-list-item> -->\n													<!-- <md-list-item layout=\"row\" layout-align=\"space-around center\">\n															<md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n															<p translate>Show Timer in Right Sidebar instead</p>\n															<md-switch class=\"md-secondary\" ng-model=\"user.profile.settings.showTimerInSidebar\" ng-change=\"updateSettings(\'showTimerInSidebar\',user.profile.settings.showTimerInSidebar)\"></md-switch>\n													</md-list-item> -->\n											</div>\n											<md-list-item layout=\"column\" layout-align=\"center center\" ng-if=\"noGhostUser()\">\n													<md-button class=\"\" ng-click=\"requestNotificationPermission()\"> <md-icon md-font-icon=\"zmdi zmdi-notifications\"></md-icon> Enable Notifications on this Browser</md-button>\n											</md-list-item>\n											<!-- <md-list-item layout=\"column\" layout-align=\"center center\">\n													<md-button class=\"\" ng-click=\"resetOnboarding()\">Reset Onboarding Checklist</md-button>\n											</md-list-item> -->\n											<!-- <div ng-repeat=\"group in ::statisticsGroups\"> -->\n													<!-- <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader> -->\n													<!-- <md-list-item ng-repeat=\"stat in ::group.stats\" layout=\"column\" layout-align=\"space-around start\"> -->\n													 <!--   <md-progress-linear class=\"margin-top-20 ng-class=\"::stat.mdClass\" md-mode=\"determinate\" ng-value=\"::stat.value\"></md-progress-linear>-->\n															<!-- <p translate>{{::stat.title}}</p> -->\n													<!-- </md-list-item> -->\n											<!-- </div> -->\n									</md-list>\n							</md-content>\n							<p class=\"text-center\" style=\"padding: 2em 2em 2em 2em;\"><small>NOTE: Some settings may require a refresh for the change to take effect.</small></p>\n					</md-tab-body>\n			</md-tab>\n		</md-tabs>\n</md-content>\n");
$templateCache.put("app/layouts/toolbar/adminja-tasks-toolbar.tmpl.html","<!-- // default toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\">\n\n    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n    <div flex=\"auto\" layout=\"row\" layout-align=\"start start\" class=\"scrollable-toolbar-container\">\n        <div ng-if=\"teamList.length > 1\" flex=\"none\">\n            <md-menu md-position-mode=\"target-right bottom\" class=\"md-menu-split\">\n                    <!-- Trigger element is a md-button with an icon -->\n                    <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Filter Tasks\" class=\"md-icon-button md-button-split-right\" md-no-ink>\n                            <md-icon md-font-icon=\"fa fa-filter\">\n                                    <md-tooltip md-delay=\"1000\">Filter Tasks </md-tooltip>\n                            </md-icon>\n                    </md-button>\n                    <md-menu-content style=\"padding: 0; width: 200px;\">\n                            <md-menu-item layout=\"column\" layout-align=\"start center\">\n                                        <md-button ng-click=\"filterUser(\'all\')\" style=\"padding: 0; margin: 0;\">\n                                            <md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em; font-size: 18px;\"></md-icon>\n                                            <span class=\"small\">Whole Team</span>\n                                        </md-button>\n                            </md-menu-item>\n                            <md-menu-item layout=\"column\" layout-align=\"start center\"\n                                        ng-repeat=\"member in teamList | orderBy: \'profile.lastName\' track by $index\"\n                                        value=\"{{member.uid}}\"\n                                        style=\"border-left: 4px solid {{member.color}};\">\n                                    <md-button ng-click=\"filterUser(member)\" style=\"padding: 0; margin: 0;\">\n                                        <img flex=\"nogrow\" src=\"{{member.profile.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n                                        <span class=\"small\">{{member.profile.firstName}}\'s Tasks</span>\n                                </md-button>\n                              </md-menu-item>\n                            </md-menu-item>\n                        </md-menu-content>\n            </md-menu>\n        </div>\n        <div flex=\"none\">\n            <h3 ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" style=\"padding-right: .5em!important;\">\n                <span ng-repeat=\"crumb in breadcrumbs.crumbs\">\n                    <span ng-if=\"teamDataService.filteredMember\">{{teamDataService.filteredMemberName}}\'s Tasks</span><span ng-if=\"!teamDataService.filteredMember\" translate>{{crumb.name}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n            </h3>\n        </div>\n\n        <div flex></div>\n    </div><!-- // scrollable-toolbar-container -->\n    <sidebar-controls></sidebar-controls>\n</div>\n");
$templateCache.put("app/layouts/toolbar/adminja-toolbar.tmpl.html","<!-- // default toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\">\n\n    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n    <div flex=\"auto\" layout=\"row\" layout-align=\"start start\" class=\"scrollable-toolbar-container\">\n        <div flex=\"none\">\n            <h3 ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" style=\"padding-right: .5em!important;\">\n                <span ng-if=\"!overRideBreadcrumb\" ng-repeat=\"crumb in breadcrumbs.crumbs\">\n                    <span translate>{{crumb.name}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n                <span ng-if=\"overRideBreadcrumb\" ng-repeat=\"crumb in breadcrumbs.crumbs\">\n                    <span translate>{{overRideBreadcrumb}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n            </h3>\n        </div>\n        <div flex></div>\n    </div><!-- // scrollable-toolbar-container -->\n    <sidebar-controls></sidebar-controls>\n</div>\n");
$templateCache.put("app/layouts/toolbar/toolbar.tmpl.html","<div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" ng-if=\"!vm.hideMenuButton()\" ng-click=\"vm.openSideNav(\'left\')\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n\n    <h2 hide-xs flex>\n        <span ng-repeat=\"crumb in vm.breadcrumbs.crumbs\">\n            <span translate>{{crumb.name}}</span>\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n        </span>\n    </h2>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleFullScreen()\" aria-label=\"toggle fullscreen\">\n        <md-icon md-font-icon ng-class=\"vm.fullScreenIcon\"></md-icon>\n    </md-button>\n\n    <md-menu ng-show=\"vm.languages.length > 0\">\n        <md-button class=\"md-icon-button\" aria-label=\"language\" ng-click=\"$mdMenu.open()\" aria-label=\"change language\">\n            <md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"3\">\n            <md-menu-item ng-repeat=\"language in ::vm.languages\">\n                <md-button ng-click=\"vm.switchLanguage(language.key)\" translate=\"{{::language.name}}\" aria-label=\"{{::language.name}}\"></md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n\n    <md-button class=\"md-icon-button toolbar-button animated\" ng-click=\"vm.toggleNotificationsTab(0)\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n        <span class=\"toolbar-button-badge animated\" theme-background=\"accent\" ng-class=\"{ \'toolbar-button-badge-new\' : vm.emailNew }\">5</span>\n    </md-button>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleNotificationsTab(1)\">\n        <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n        <span class=\"toolbar-button-badge\" theme-background=\"accent\">2</span>\n    </md-button>\n\n    <md-menu>\n        <md-button aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"side navigation\">\n            <img class=\"toolbar-user-avatar\" ng-src=\"{{vm.currentUser.avatar}}\">\n            {{vm.currentUser.displayName}}\n        </md-button>\n        <md-menu-content width=\"4\">\n            <md-menu-item>\n                <md-button ng-click=\"vm.toggleNotificationsTab(2)\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n                    <span translate=\"Settings\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button href=\"/profile\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n                    <span translate=\"Profile\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n            <md-menu-item>\n                <md-button href=\"/login\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-sign-in\"></md-icon>\n                    <span translate=\"Logout\"></span>\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n");
$templateCache.put("app/triangular/components/footer/footer.tmpl.html","<md-toolbar id=\"footer\" md-theme=\"{{triSkin.elements.toolbar}}\" ng-controller=\"FooterController as vm\" ng-show=\"vm.layout.footer\">\n    <div class=\"md-toolbar-tools md-body-1\" layout=\"row\" layout-align=\"space-between center\">\n        <h2>{{vm.name}}</h2>\n        <h2 hide-xs ng-bind-html=\"vm.copyright\"></h2>\n        <h2>v{{vm.version}}</h2>\n    </div>\n</md-toolbar>\n");
$templateCache.put("app/triangular/components/notifications-panel/notifications-panel.tmpl.html","<md-content flex layout class=\"admin-notifications\">\n    <md-tabs flex md-stretch-tabs=\"always\" md-selected=\"vm.currentTab\">\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list class=\"md-dense\">\n                        <md-list-item class=\"md-2-line\" ng-repeat=\"email in ::vm.emails\" ng-click=\"vm.openMail(email)\">\n                            <img class=\"md-avatar\" ng-src=\"{{::email.from.image}}\" alt=\"{{::email.from.name}}\">\n                            <div class=\"md-list-item-text\">\n                                <h3>{{::email.from.name}}</h3>\n                                <h4>{{::email.subject}}</h4>\n                                <p class=\"md-caption\" am-time-ago=\"::email.date\"></p>\n                            </div>\n                            <md-divider ng-hide=\"$last\"></md-divider>\n                        </md-list-item>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.notificationGroups\">\n                            <md-subheader class=\"md-primary\">{{::group.name}}</md-subheader>\n                            <md-list-item ng-repeat=\"notification in ::group.notifications\" layout=\"row\" layout-align=\"space-between center\">\n                                <md-icon md-font-icon=\"{{::notification.icon}}\" ng-style=\"{ color: notification.iconColor }\"></md-icon>\n                                <p>{{::notification.title}}</p>\n                                <span class=\"md-caption\" am-time-ago=\"::notification.date\"></span>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.settingsGroups\">\n                            <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader>\n                            <md-list-item ng-repeat=\"setting in ::group.settings\" layout=\"row\" layout-align=\"space-around center\">\n                                <md-icon md-font-icon=\"{{::setting.icon}}\"></md-icon>\n                                <p translate>{{::setting.title}}</p>\n                                <md-switch class=\"md-secondary\" ng-model=\"setting.enabled\"></md-switch>\n                            </md-list-item>\n                        </div>\n                        <div ng-repeat=\"group in ::vm.statisticsGroups\">\n                            <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader>\n                            <md-list-item ng-repeat=\"stat in ::group.stats\" layout=\"column\" layout-align=\"space-around start\">\n                                <md-progress-linear class=\"margin-top-20 ng-class=\"::stat.mdClass\" md-mode=\"determinate\" ng-value=\"::stat.value\"></md-progress-linear>\n                                <p translate>{{::stat.title}}</p>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n    </md-tabs>\n</md-content>\n");
$templateCache.put("app/triangular/components/menu/menu-item-client.tmpl.html","<md-button ng-if=\"::triMenuItem.item.status != \'archived\'\" md-no-ink ng-disabled=\"{{::triMenuItem.item.disabled}}\"  permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\" >\n    <img ng-if=\"::triMenuItem.item.icon != \'none\'\" style=\"border-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\" src=\"{{::triMenuItem.item.icon}}\">\n    <div ng-if=\"::triMenuItem.item.icon == \'none\'\" style=\"background-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\"></div>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    	<small ng-if=\"::triMenuItem.item.clientType == \'delegated\'\" class=\"side-menu-badge\" style=\"padding-top: 0; position: relative; left: 10px;\"><md-icon style=\"font-size: 12px; color: #FFF;\" md-font-icon=\"zmdi zmdi-account-box\"></md-icon></small>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"warn\" class=\"side-menu-badge\">{{::triMenuItem.item.badge}}</small>\n   <!-- <a class=\"clientlink\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon>Edit</a> -->\n\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-divider.tmpl.html","<md-divider></md-divider>");
$templateCache.put("app/triangular/components/menu/menu-item-dropdown.tmpl.html","<md-button ng-click=\"triMenuItem.toggleDropdownMenu()\" class=\"md-raised md-primary side-menu-link\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\"  class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <md-icon class=\"menu-toggle-icon\" md-font-icon=\"zmdi zmdi-chevron-right\" ng-class=\"{ open: triMenuItem.item.open }\"></md-icon>\n</md-button>\n<ul class=\"drop-down-list\" ng-show=\"triMenuItem.item.open\">\n    <li ng-repeat=\"child in triMenuItem.item.children\">\n        <tri-menu-item item=\"::child\"></tri-menu-item>\n    </li>\n</ul>\n");
$templateCache.put("app/triangular/components/menu/menu-item-link-w-no-params.tmpl.html","<md-button permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"accent\" class=\"side-menu-badge\">{{::triMenuItem.item.badge}}</small>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-link.tmpl.html","<md-button md-no-ink permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"accent\" class=\"side-menu-badge\">{{triMenuItem.item.badge}}</small>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-logout.tmpl.html","<md-button permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\" >\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n\n    <span translate>{{::triMenuItem.item.name}}</span>\n</md-button>\n\n");
$templateCache.put("app/triangular/components/menu/menu-item-timer.tmpl.html","<global-timer></global-timer>\n");
$templateCache.put("app/triangular/components/table/table-directive.tmpl.html","<table class=\"md-table\">\n    <thead>\n        <tr>\n            <th ng-repeat=\"column in columns\" ng-click=\"sortClick(column.field)\" ng-class=\"headerClass(column.field)\">\n                <md-icon ng-show=\"showSortOrder(column.field, true)\" class=\"zmdi-hc-rotate-90\" md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n                <md-icon ng-show=\"showSortOrder(column.field, false)\" class=\"zmdi-hc-rotate-270\" md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n                <span>\n                    {{column.title | triTranslate}}\n                </span>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"content in contents | filter:filters | startFrom:page * pageSize | limitTo: pageSize\">\n            <td ng-repeat=\"column in columns\" ng-bind-html=\"cellContents(column, content)\" ng-class=\"column.field + \'-cell\'\"></td>\n        </tr>\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan=\"{{columns.length}}\">\n                <div class=\"md-table-footer\" layout=\"row\" layout-align=\"end center\">\n                    <div class=\"md-table-page-select\" layout=\"row\" layout-align=\"center center\">\n                        <span translate>Rows per page:</span>\n                        <md-select ng-model=\"pageSize\" ng-change=\"refresh(true)\">\n                            <md-option value=\"5\">5</md-option>\n                            <md-option value=\"10\">10</md-option>\n                            <md-option value=\"25\">25</md-option>\n                            <md-option value=\"50\">50</md-option>\n                            <md-option value=\"100\">100</md-option>\n                        </md-select>\n                    </div>\n                    <span class=\"md-table-info\">\n                        {{pageStart()}}\n                        -\n                        {{pageEnd()}}\n                        <span translate>of</span>\n                        {{totalItems()}}\n                    </span>\n                    <div class=\"md-table-page-nav\">\n                        <md-button ng-disabled=\"page == 0\" ng-click=\"page = page - 1\" aria-label=\"{{\'Previous Page\' | triTranslate}}\" class=\"md-primary md-icon-button\">\n                            <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n                        </md-button>\n                        <md-button ng-disabled=\"page == numberOfPages() - 1\" ng-click=\"page = page + 1\" aria-label=\"{{\'Next Page\' | triTranslate}}\" class=\"md-primary md-icon-button\">\n                            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n                        </md-button>\n                    </div>\n                </div>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n");
$templateCache.put("app/triangular/components/toolbars/toolbar.tmpl.html","<div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" ng-if=\"!vm.hideMenuButton()\" ng-click=\"vm.openSideNav(\'left\')\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n\n    <h2 hide-xs flex>\n        <span ng-repeat=\"crumb in vm.breadcrumbs.crumbs\">\n            <span translate>{{crumb.name}}</span>\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n        </span>\n    </h2>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleFullScreen()\" aria-label=\"toggle fullscreen\">\n        <md-icon md-font-icon ng-class=\"vm.fullScreenIcon\"></md-icon>\n    </md-button>\n\n    <md-menu ng-show=\"vm.languages.length > 0\">\n        <md-button class=\"md-icon-button\" aria-label=\"language\" ng-click=\"$mdMenu.open()\" aria-label=\"change language\">\n            <md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"3\">\n            <md-menu-item ng-repeat=\"language in ::vm.languages\">\n                <md-button ng-click=\"vm.switchLanguage(language.key)\" translate=\"{{::language.name}}\" aria-label=\"{{::language.name}}\"></md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n\n    <md-button class=\"md-icon-button toolbar-button animated\" ng-click=\"vm.toggleNotificationsTab(0)\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n        <span class=\"toolbar-button-badge animated\" theme-background=\"accent\" ng-class=\"{ \'toolbar-button-badge-new\' : vm.emailNew }\">5</span>\n    </md-button>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleNotificationsTab(1)\">\n        <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n        <span class=\"toolbar-button-badge\" theme-background=\"accent\">2</span>\n    </md-button>\n\n    <md-menu>\n        <md-button aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"side navigation\">\n            <img class=\"toolbar-user-avatar\" src=\"assets/images/avatars/avatar-5.png\">\n            Christos\n        </md-button>\n        <md-menu-content width=\"4\">\n            <md-menu-item>\n                <md-button ng-click=\"vm.toggleNotificationsTab(2)\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n                    <span translate=\"Settings\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button href=\"/profile\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n                    <span translate=\"Profile\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n            <md-menu-item>\n                <md-button href=\"/login\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-sign-in\"></md-icon>\n                    <span translate=\"Logout\"></span>\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n");
$templateCache.put("app/triangular/components/widget/widget.tmpl.html","<div class=\"widget md-whiteframe-z2\" ng-class=\"::{\'widget-overlay-title\': vm.overlayTitle}\" flex layout=\"{{vm.widgetLayout}}\">\n\n    <div class=\"widget-title\" ng-if=\"::(vm.title || vm.subtitle)\" layout=\"row\" layout-padding layout-align=\"start center\" flex-order=\"{{vm.titleOrder}}\">\n        <div ng-if=\"::vm.avatar\">\n            <img ng-src=\"{{::vm.avatar}}\" class=\"widget-avatar\"/>\n        </div>\n        <div flex layout=\"column\">\n            <h3 class=\"md-subhead\" ng-if=\"::vm.title\" translate>{{::vm.title}}</h3>\n            <p class=\"md-body-1\" ng-if=\"::vm.subtitle\" translate>{{::vm.subtitle}}</p>\n        </div>\n        <md-menu ng-if=\"::vm.menu\">\n            <md-button class=\"widget-button md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"open menu\">\n                <md-icon md-font-icon=\"{{::vm.menu.icon}}\"></md-icon>\n            </md-button>\n            <md-menu-content>\n                <md-menu-item ng-repeat=\"item in ::vm.menu.items\">\n                    <md-button ng-click=\"item.click($event)\">\n                        <md-icon ng-if=\"::item.icon\" md-font-icon=\"{{::item.icon}}\"></md-icon>\n                        <span translate>{{::item.title}}</span>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n    </div>\n\n    <div class=\"widget-content\" layout=\"{{vm.contentLayout}}\" layout-align=\"{{vm.contentLayoutAlign}}\" ng-class=\"{\'layout-padding\': vm.contentPadding}\" ng-transclude flex-order=\"{{vm.contentOrder}}\"></div>\n\n    <div class=\"widget-loading ng-hide\" ng-show=\"vm.loading\" layout layout-fill layout-align=\"center center\">\n        <div class=\"widget-loading-inner\" ng-show=\"vm.loading\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/triangular/layouts/default/default-content.tmpl.html","<div id=\"admin-panel-content-view\" class=\"{{layout.innerContentClass}}\" flex ui-view></div>\n");
$templateCache.put("app/triangular/layouts/default/default-no-scroll.tmpl.html","<div layout=\"row\" class=\"full-height\">\n    <!-- left sidebar -->\n\n    <md-sidenav class=\"admin-sidebar-left md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"layoutController.activateHover()\" ng-mouseleave=\"layoutController.removeHover()\"></md-sidenav>\n\n    <!-- main content -->\n    <div id=\"admin-panel\" layout=\"column\" flex>\n        <!-- loading animation -->\n        <tri-loader></tri-loader>\n\n        <!-- top toolbar -->\n        <md-toolbar class=\"admin-toolbar\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\"></md-toolbar>\n\n        <!-- scrollable content -->\n        <div ui-view=\"content\" layout=\"column\" flex class=\"overflow-hidden\"></div>\n\n        <div ui-view=\"belowContent\"></div>\n    </div>\n\n    <!-- right sidebar -->\n    <md-sidenav layout layout-fill class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"notifications\" ui-view=\"sidebarRight\"></md-sidenav>\n\n</div>\n");
$templateCache.put("app/triangular/layouts/default/default.tmpl.html","<div layout=\"row\" class=\"full-height\">\n    <!-- left sidebar -->\n\n    <md-sidenav class=\"admin-sidebar-left md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"layoutController.activateHover()\" ng-mouseleave=\"layoutController.removeHover()\"></md-sidenav>\n\n    <!-- main content -->\n    <div id=\"admin-panel\" layout=\"column\" flex>\n        <!-- loading animation -->\n        <tri-loader></tri-loader>\n\n        <!-- top toolbar -->\n        <md-toolbar class=\"admin-toolbar\" ng-if=\"layout.showToolbar\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\"></md-toolbar>\n\n        <!-- scrollable content -->\n        <md-content ng-class=\"layout.contentClass\" flex tri-default-content ui-view=\"content\"></md-content>\n\n        <div ui-view=\"belowContent\"></div>\n    </div>\n\n    <!-- right sidebar -->\n    <md-sidenav layout layout-fill class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"notifications\" ui-view=\"sidebarRight\"></md-sidenav>\n</div>\n");
$templateCache.put("app/triangular/layouts/states/triangular/triangular.tmpl.html","<!-- left sidebar -->\n<md-sidenav md-colors=\"{ background: \'primary\' }\" class=\"triangular-sidenav-left md-sidenav-left md-whiteframe-z2\" ng-if=\"layout.sideMenuSize !== \'off\'\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"stateController.activateHover()\" ng-mouseleave=\"stateController.removeHover()\"></md-sidenav>\n\n<!-- main content -->\n<div class=\"triangular-toolbar-and-content\" layout=\"column\" flex>\n    <!-- loading animation -->\n    <!-- <tri-loader></tri-loader> -->\n\n    <!-- top toolbar -->\n    <md-toolbar class=\"triangular-toolbar md-whiteframe-z1\" ng-if=\"layout.showToolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\"></md-toolbar>\n\n    <!-- scrollable content -->\n    <md-content class=\"triangular-content\" ng-class=\"layout.contentClass\" flex ui-view ></md-content>\n\n    <div ui-view=\"belowContent\"></div>\n\n    <div class=\"triangular-loader\" ng-show=\"stateController.showLoader\" layout=\"column\" ui-view=\"loader\"></div>\n</div>\n\n<!-- right sidebar -->\n<md-sidenav layout layout-fill class=\"triangular-sidenav-right md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\" ui-view=\"sidebarRight\"></md-sidenav>\n<!-- <fab-button ng-if=\"showNinjaMenu\"></fab-button> -->\n");}]);